!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("ramda"), require("react-dom"));else if ("function" === typeof define && define.amd) define(["react", "ramda", "react-dom"], t);else {
    var n = "object" === typeof exports ? t(require("react"), require("ramda"), require("react-dom")) : t(e.react, e.ramda, e["react-dom"]);

    for (var r in n) {
      ("object" === typeof exports ? exports : e)[r] = n[r];
    }
  }
}(window, function (__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__9__, __WEBPACK_EXTERNAL_MODULE__19__) {
  return function (e) {
    var t = {};

    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        __webpack_require__.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 142);
  }([function (e, t) {
    e.exports = __WEBPACK_EXTERNAL_MODULE__0__;
  }, function (e, t, n) {
    var r;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var i = typeof r;
            if ("string" === i || "number" === i) e.push(r);else if (Array.isArray(r) && r.length) {
              var a = classNames.apply(null, r);
              a && e.push(a);
            } else if ("object" === i) for (var o in r) {
              n.call(r, o) && r[o] && e.push(o);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (r = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t, n) {
    e.exports = n(231)();
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var n = function cssWithMappingToString(e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" === typeof btoa) {
              var i = function toComment(e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(r),
                  a = r.sources.map(function (e) {
                return "/*# sourceURL=" + r.sourceRoot + e + " */";
              });

              return [n].concat(a).concat([i]).join("\n");
            }

            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var r = {}, i = 0; i < this.length; i++) {
          var a = this[i][0];
          "number" === typeof a && (r[a] = !0);
        }

        for (i = 0; i < e.length; i++) {
          var o = e[i];
          "number" === typeof o[0] && r[o[0]] || (n && !o[2] ? o[2] = n : n && (o[2] = "(" + o[2] + ") and (" + n + ")"), t.push(o));
        }
      }, t;
    };
  }, function (e, t, n) {
    var r = {},
        i = function (e) {
      var t;
      return function () {
        return "undefined" === typeof t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        a = function (e) {
      var t = {};
      return function (e, n) {
        if ("function" === typeof e) return e();

        if ("undefined" === typeof t[e]) {
          var r = function (e, t) {
            return t ? t.querySelector(e) : document.querySelector(e);
          }.call(this, e, n);

          if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
            r = r.contentDocument.head;
          } catch (i) {
            r = null;
          }
          t[e] = r;
        }

        return t[e];
      };
    }(),
        o = null,
        s = 0,
        l = [],
        c = n(145);

    function addStylesToDom(e, t) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n],
            a = r[i.id];

        if (a) {
          a.refs++;

          for (var o = 0; o < a.parts.length; o++) {
            a.parts[o](i.parts[o]);
          }

          for (; o < i.parts.length; o++) {
            a.parts.push(addStyle(i.parts[o], t));
          }
        } else {
          var s = [];

          for (o = 0; o < i.parts.length; o++) {
            s.push(addStyle(i.parts[o], t));
          }

          r[i.id] = {
            id: i.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function listToStyles(e, t) {
      for (var n = [], r = {}, i = 0; i < e.length; i++) {
        var a = e[i],
            o = t.base ? a[0] + t.base : a[0],
            s = {
          css: a[1],
          media: a[2],
          sourceMap: a[3]
        };
        r[o] ? r[o].parts.push(s) : n.push(r[o] = {
          id: o,
          parts: [s]
        });
      }

      return n;
    }

    function insertStyleElement(e, t) {
      var n = a(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = l[l.length - 1];
      if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), l.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" !== typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var i = a(e.insertAt.before, n);
        n.insertBefore(t, i);
      }
    }

    function removeStyleElement(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = l.indexOf(e);
      t >= 0 && l.splice(t, 1);
    }

    function createStyleElement(e) {
      var t = document.createElement("style");

      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var r = function getNonce() {
          0;
          return n.nc;
        }();

        r && (e.attrs.nonce = r);
      }

      return addAttrs(t, e.attrs), insertStyleElement(e, t), t;
    }

    function addAttrs(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }

    function addStyle(e, t) {
      var n, r, i, a;

      if (t.transform && e.css) {
        if (!(a = t.transform(e.css))) return function () {};
        e.css = a;
      }

      if (t.singleton) {
        var l = s++;
        n = o || (o = createStyleElement(t)), r = applyToSingletonTag.bind(null, n, l, !1), i = applyToSingletonTag.bind(null, n, l, !0);
      } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (n = function createLinkElement(e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", addAttrs(t, e.attrs), insertStyleElement(e, t), t;
      }(t), r = function updateLink(e, t, n) {
        var r = n.css,
            i = n.sourceMap,
            a = void 0 === t.convertToAbsoluteUrls && i;
        (t.convertToAbsoluteUrls || a) && (r = c(r));
        i && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
        var o = new Blob([r], {
          type: "text/css"
        }),
            s = e.href;
        e.href = URL.createObjectURL(o), s && URL.revokeObjectURL(s);
      }.bind(null, n, t), i = function i() {
        removeStyleElement(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = createStyleElement(t), r = function applyToTag(e, t) {
        var n = t.css,
            r = t.media;
        r && e.setAttribute("media", r);
        if (e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), i = function i() {
        removeStyleElement(n);
      });

      return r(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else i();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" === typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = i()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = listToStyles(e, t);
      return addStylesToDom(n, t), function update(e) {
        for (var i = [], a = 0; a < n.length; a++) {
          var o = n[a];
          (s = r[o.id]).refs--, i.push(s);
        }

        e && addStylesToDom(listToStyles(e, t), t);

        for (a = 0; a < i.length; a++) {
          var s;

          if (0 === (s = i[a]).refs) {
            for (var l = 0; l < s.parts.length; l++) {
              s.parts[l]();
            }

            delete r[s.id];
          }
        }
      };
    };

    var p = function () {
      var e = [];
      return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(e, t, n, r) {
      var i = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = p(t, i);else {
        var a = document.createTextNode(i),
            o = e.childNodes;
        o[t] && e.removeChild(o[t]), o.length ? e.insertBefore(a, o[t]) : e.appendChild(a);
      }
    }
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ReactCSS = t.loop = t.handleActive = t.handleHover = t.hover = void 0;

    var r = _interopRequireDefault(n(279)),
        i = _interopRequireDefault(n(355)),
        a = _interopRequireDefault(n(381)),
        o = _interopRequireDefault(n(382)),
        s = _interopRequireDefault(n(383)),
        l = _interopRequireDefault(n(384));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    t.hover = o.default, t.handleHover = o.default, t.handleActive = s.default, t.loop = l.default;

    var c = t.ReactCSS = function ReactCSS(e) {
      for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) {
        n[o - 1] = arguments[o];
      }

      var s = (0, r.default)(n),
          l = (0, i.default)(e, s);
      return (0, a.default)(l);
    };

    t.default = c;
  }, function (e, t) {
    e.exports = function _assertThisInitialized(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(385);
    Object.defineProperty(t, "Alpha", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(r).default;
      }
    });
    var i = n(67);
    Object.defineProperty(t, "Checkboard", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(i).default;
      }
    });
    var a = n(388);
    Object.defineProperty(t, "EditableInput", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(a).default;
      }
    });
    var o = n(389);
    Object.defineProperty(t, "Hue", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(o).default;
      }
    });
    var s = n(391);
    Object.defineProperty(t, "Raised", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(s).default;
      }
    });
    var l = n(453);
    Object.defineProperty(t, "Saturation", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(l).default;
      }
    });
    var c = n(125);
    Object.defineProperty(t, "ColorWrap", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(c).default;
      }
    });
    var p = n(467);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "Swatch", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(p).default;
      }
    });
  }, function (e, t) {
    e.exports = function _defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    };
  }, function (e, t) {
    e.exports = __WEBPACK_EXTERNAL_MODULE__9__;
  }, function (e, t, n) {
    e.exports = n(392)();
  }, function (e, t, n) {
    var r = n(394),
        i = n(444)(function (e, t, n) {
      r(e, t, n);
    });
    e.exports = i;
  }, function (e, t) {
    var n = Array.isArray;
    e.exports = n;
  }, function (e, t, n) {
    var r = n(113),
        i = "object" == typeof self && self && self.Object === Object && self,
        a = r || i || Function("return this")();
    e.exports = a;
  }, function (e, t) {
    e.exports = function isObject(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t) {
    var n = Array.isArray;
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.red = t.getContrastingColor = t.isValidHex = t.toState = t.simpleCheckForValidColor = void 0;

    var r = _interopRequireDefault(n(458)),
        i = _interopRequireDefault(n(466));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    t.simpleCheckForValidColor = function simpleCheckForValidColor(e) {
      var t = 0,
          n = 0;
      return (0, r.default)(["r", "g", "b", "a", "h", "s", "l", "v"], function (r) {
        if (e[r] && (t += 1, isNaN(e[r]) || (n += 1), "s" === r || "l" === r)) {
          /^\d+%$/.test(e[r]) && (n += 1);
        }
      }), t === n && e;
    };

    var a = t.toState = function toState(e, t) {
      var n = e.hex ? (0, i.default)(e.hex) : (0, i.default)(e),
          r = n.toHsl(),
          a = n.toHsv(),
          o = n.toRgb(),
          s = n.toHex();
      return 0 === r.s && (r.h = t || 0, a.h = t || 0), {
        hsl: r,
        hex: "000000" === s && 0 === o.a ? "transparent" : "#" + s,
        rgb: o,
        hsv: a,
        oldHue: e.h || t || r.h,
        source: e.source
      };
    };

    t.isValidHex = function isValidHex(e) {
      var t = "#" === String(e).charAt(0) ? 1 : 0;
      return e.length !== 4 + t && e.length < 7 + t && (0, i.default)(e).isValid();
    }, t.getContrastingColor = function getContrastingColor(e) {
      if (!e) return "#fff";
      var t = a(e);
      return "transparent" === t.hex ? "rgba(0,0,0,0.4)" : (299 * t.rgb.r + 587 * t.rgb.g + 114 * t.rgb.b) / 1e3 >= 128 ? "#000" : "#fff";
    }, t.red = {
      hsl: {
        a: 1,
        h: 0,
        l: .5,
        s: 1
      },
      hex: "#ff0000",
      rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
      },
      hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
      }
    };
    t.default = t;
  }, function (e, t, n) {
    var r = n(87),
        i = "object" == typeof self && self && self.Object === Object && self,
        a = r || i || Function("return this")();
    e.exports = a;
  }, function (e, t) {
    e.exports = function isObjectLike(e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t) {
    e.exports = __WEBPACK_EXTERNAL_MODULE__19__;
  }, function (e, t) {
    function _extends() {
      return e.exports = _extends = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }, _extends.apply(this, arguments);
    }

    e.exports = _extends;
  }, function (e, t, n) {
    e.exports = n(225);
  }, function (e, t, n) {
    var r = n(33),
        i = n(281),
        a = n(282),
        o = "[object Null]",
        s = "[object Undefined]",
        l = r ? r.toStringTag : void 0;

    e.exports = function baseGetTag(e) {
      return null == e ? void 0 === e ? s : o : l && l in Object(e) ? i(e) : a(e);
    };
  }, function (e, t, n) {
    var r = n(307),
        i = n(310);

    e.exports = function getNative(e, t) {
      var n = i(e, t);
      return r(n) ? n : void 0;
    };
  }, function (e, t, n) {
    var r = n(405),
        i = n(410);

    e.exports = function getNative(e, t) {
      var n = i(e, t);
      return r(n) ? n : void 0;
    };
  }, function (e, t) {
    e.exports = function isObjectLike(e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, n) {
    var r = n(127),
        i = n(472),
        a = n(510),
        o = n(15);

    e.exports = function map(e, t) {
      return (o(e) ? r : a)(e, i(t, 3));
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t) {
    e.exports = function isObject(e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t, n) {
    var r = n(46),
        i = n(406),
        a = n(407),
        o = "[object Null]",
        s = "[object Undefined]",
        l = r ? r.toStringTag : void 0;

    e.exports = function baseGetTag(e) {
      return null == e ? void 0 === e ? s : o : l && l in Object(e) ? i(e) : a(e);
    };
  }, function (e, t, n) {
    var r = n(70),
        i = n(75);

    e.exports = function isArrayLike(e) {
      return null != e && i(e.length) && !r(e);
    };
  }, function (e, t) {
    e.exports = function _inheritsLoose(e, t) {
      e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
    };
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (r) {
      "object" === typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    var r = n(17).Symbol;
    e.exports = r;
  }, function (e, t, n) {
    var r = n(89),
        i = n(289),
        a = n(36);

    e.exports = function keys(e) {
      return a(e) ? r(e) : i(e);
    };
  }, function (e, t) {
    e.exports = function eq(e, t) {
      return e === t || e !== e && t !== t;
    };
  }, function (e, t, n) {
    var r = n(94),
        i = n(54);

    e.exports = function isArrayLike(e) {
      return null != e && i(e.length) && !r(e);
    };
  }, function (e, t, n) {
    var r = n(297),
        i = n(298),
        a = n(299),
        o = n(300),
        s = n(301);

    function ListCache(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    ListCache.prototype.clear = r, ListCache.prototype.delete = i, ListCache.prototype.get = a, ListCache.prototype.has = o, ListCache.prototype.set = s, e.exports = ListCache;
  }, function (e, t, n) {
    var r = n(60);

    e.exports = function assocIndexOf(e, t) {
      for (var n = e.length; n--;) {
        if (r(e[n][0], t)) return n;
      }

      return -1;
    };
  }, function (e, t, n) {
    var r = n(23)(Object, "create");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(319);

    e.exports = function getMapData(e, t) {
      var n = e.__data__;
      return r(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
    };
  }, function (e, t, n) {
    var r = n(334),
        i = n(61),
        a = n(335),
        o = n(336),
        s = n(337),
        l = n(22),
        c = n(97),
        p = c(r),
        d = c(i),
        h = c(a),
        u = c(o),
        f = c(s),
        m = l;
    (r && "[object DataView]" != m(new r(new ArrayBuffer(1))) || i && "[object Map]" != m(new i()) || a && "[object Promise]" != m(a.resolve()) || o && "[object Set]" != m(new o()) || s && "[object WeakMap]" != m(new s())) && (m = function getTag(e) {
      var t = l(e),
          n = "[object Object]" == t ? e.constructor : void 0,
          r = n ? c(n) : "";
      if (r) switch (r) {
        case p:
          return "[object DataView]";

        case d:
          return "[object Map]";

        case h:
          return "[object Promise]";

        case u:
          return "[object Set]";

        case f:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = m;
  }, function (e, t, n) {
    var r = n(65),
        i = 1 / 0;

    e.exports = function toKey(e) {
      if ("string" == typeof e || r(e)) return e;
      var t = e + "";
      return "0" == t && 1 / e == -i ? "-0" : t;
    };
  }, function (e, t, n) {
    var r = n(109),
        i = n(110);

    e.exports = function copyObject(e, t, n, a) {
      var o = !n;
      n || (n = {});

      for (var s = -1, l = t.length; ++s < l;) {
        var c = t[s],
            p = a ? a(n[c], e[c], c, n, e) : void 0;
        void 0 === p && (p = e[c]), o ? i(n, c, p) : r(n, c, p);
      }

      return n;
    };
  }, function (e, t, n) {
    var r = n(395),
        i = n(396),
        a = n(397),
        o = n(398),
        s = n(399);

    function ListCache(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    ListCache.prototype.clear = r, ListCache.prototype.delete = i, ListCache.prototype.get = a, ListCache.prototype.has = o, ListCache.prototype.set = s, e.exports = ListCache;
  }, function (e, t, n) {
    var r = n(35);

    e.exports = function assocIndexOf(e, t) {
      for (var n = e.length; n--;) {
        if (r(e[n][0], t)) return n;
      }

      return -1;
    };
  }, function (e, t, n) {
    var r = n(13).Symbol;
    e.exports = r;
  }, function (e, t, n) {
    var r = n(24)(Object, "create");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(419);

    e.exports = function getMapData(e, t) {
      var n = e.__data__;
      return r(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
    };
  }, function (e, t) {
    e.exports = function identity(e) {
      return e;
    };
  }, function (e, t, n) {
    var r = n(29),
        i = n(25),
        a = "[object Symbol]";

    e.exports = function isSymbol(e) {
      return "symbol" == typeof e || i(e) && r(e) == a;
    };
  }, function (e, t, n) {
    var r = n(50),
        i = 1 / 0;

    e.exports = function toKey(e) {
      if ("string" == typeof e || r(e)) return e;
      var t = e + "";
      return "0" == t && 1 / e == -i ? "-0" : t;
    };
  }, function (e, t, n) {
    var r = n(88),
        i = n(291);

    e.exports = function forOwn(e, t) {
      return e && r(e, i(t));
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(17),
          i = n(287),
          a = t && !t.nodeType && t,
          o = a && "object" == typeof e && e && !e.nodeType && e,
          s = o && o.exports === a ? r.Buffer : void 0,
          l = (s ? s.isBuffer : void 0) || i;
      e.exports = l;
    }).call(this, n(27)(e));
  }, function (e, t) {
    var n = 9007199254740991;

    e.exports = function isLength(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= n;
    };
  }, function (e, t) {
    e.exports = function baseUnary(e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(87),
          i = t && !t.nodeType && t,
          a = i && "object" == typeof e && e && !e.nodeType && e,
          o = a && a.exports === i && r.process,
          s = function () {
        try {
          var e = a && a.require && a.require("util").types;

          return e || o && o.binding && o.binding("util");
        } catch (t) {}
      }();

      e.exports = s;
    }).call(this, n(27)(e));
  }, function (e, t) {
    var n = Object.prototype;

    e.exports = function isPrototype(e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || n);
    };
  }, function (e, t, n) {
    var r = n(93)(Object.getPrototypeOf, Object);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(37),
        i = n(302),
        a = n(303),
        o = n(304),
        s = n(305),
        l = n(306);

    function Stack(e) {
      var t = this.__data__ = new r(e);
      this.size = t.size;
    }

    Stack.prototype.clear = i, Stack.prototype.delete = a, Stack.prototype.get = o, Stack.prototype.has = s, Stack.prototype.set = l, e.exports = Stack;
  }, function (e, t) {
    e.exports = function eq(e, t) {
      return e === t || e !== e && t !== t;
    };
  }, function (e, t, n) {
    var r = n(23)(n(17), "Map");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(311),
        i = n(318),
        a = n(320),
        o = n(321),
        s = n(322);

    function MapCache(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    MapCache.prototype.clear = r, MapCache.prototype.delete = i, MapCache.prototype.get = a, MapCache.prototype.has = o, MapCache.prototype.set = s, e.exports = MapCache;
  }, function (e, t, n) {
    var r = n(333),
        i = n(104),
        a = Object.prototype.propertyIsEnumerable,
        o = Object.getOwnPropertySymbols,
        s = o ? function (e) {
      return null == e ? [] : (e = Object(e), r(o(e), function (t) {
        return a.call(e, t);
      }));
    } : i;
    e.exports = s;
  }, function (e, t, n) {
    var r = n(12),
        i = n(65),
        a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        o = /^\w*$/;

    e.exports = function isKey(e, t) {
      if (r(e)) return !1;
      var n = typeof e;
      return !("number" != n && "symbol" != n && "boolean" != n && null != e && !i(e)) || o.test(e) || !a.test(e) || null != t && e in Object(t);
    };
  }, function (e, t, n) {
    var r = n(22),
        i = n(18),
        a = "[object Symbol]";

    e.exports = function isSymbol(e) {
      return "symbol" == typeof e || i(e) && r(e) == a;
    };
  }, function (e, t, n) {
    var r = n(100);

    e.exports = function cloneArrayBuffer(e) {
      var t = new e.constructor(e.byteLength);
      return new r(t).set(new r(e)), t;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Checkboard = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = function _interopRequireWildcard(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }(n(387));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var o = t.Checkboard = function Checkboard(e) {
      var t = e.white,
          n = e.grey,
          o = e.size,
          s = e.renderers,
          l = e.borderRadius,
          c = e.boxShadow,
          p = (0, i.default)({
        default: {
          grid: {
            borderRadius: l,
            boxShadow: c,
            absolute: "0px 0px 0px 0px",
            background: "url(" + a.get(t, n, o, s.canvas) + ") center left"
          }
        }
      });
      return r.default.createElement("div", {
        style: p.grid
      });
    };

    o.defaultProps = {
      size: 8,
      white: "transparent",
      grey: "rgba(0,0,0,.08)",
      renderers: {}
    }, t.default = o;
  }, function (e, t, n) {
    var r = n(44),
        i = n(400),
        a = n(401),
        o = n(402),
        s = n(403),
        l = n(404);

    function Stack(e) {
      var t = this.__data__ = new r(e);
      this.size = t.size;
    }

    Stack.prototype.clear = i, Stack.prototype.delete = a, Stack.prototype.get = o, Stack.prototype.has = s, Stack.prototype.set = l, e.exports = Stack;
  }, function (e, t, n) {
    var r = n(24)(n(13), "Map");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(29),
        i = n(14),
        a = "[object AsyncFunction]",
        o = "[object Function]",
        s = "[object GeneratorFunction]",
        l = "[object Proxy]";

    e.exports = function isFunction(e) {
      if (!i(e)) return !1;
      var t = r(e);
      return t == o || t == s || t == a || t == l;
    };
  }, function (e, t, n) {
    var r = n(411),
        i = n(418),
        a = n(420),
        o = n(421),
        s = n(422);

    function MapCache(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    MapCache.prototype.clear = r, MapCache.prototype.delete = i, MapCache.prototype.get = a, MapCache.prototype.has = o, MapCache.prototype.set = s, e.exports = MapCache;
  }, function (e, t, n) {
    var r = n(116);

    e.exports = function baseAssignValue(e, t, n) {
      "__proto__" == t && r ? r(e, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : e[t] = n;
    };
  }, function (e, t) {
    var n = Object.prototype;

    e.exports = function isPrototype(e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || n);
    };
  }, function (e, t, n) {
    var r = n(431),
        i = n(25),
        a = Object.prototype,
        o = a.hasOwnProperty,
        s = a.propertyIsEnumerable,
        l = r(function () {
      return arguments;
    }()) ? r : function (e) {
      return i(e) && o.call(e, "callee") && !s.call(e, "callee");
    };
    e.exports = l;
  }, function (e, t) {
    var n = 9007199254740991;

    e.exports = function isLength(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= n;
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(13),
          i = n(433),
          a = t && !t.nodeType && t,
          o = a && "object" == typeof e && e && !e.nodeType && e,
          s = o && o.exports === a ? r.Buffer : void 0,
          l = (s ? s.isBuffer : void 0) || i;
      e.exports = l;
    }).call(this, n(27)(e));
  }, function (e, t, n) {
    var r = n(435),
        i = n(436),
        a = n(437),
        o = a && a.isTypedArray,
        s = o ? i(o) : r;
    e.exports = s;
  }, function (e, t) {
    var n = 9007199254740991,
        r = /^(?:0|[1-9]\d*)$/;

    e.exports = function isIndex(e, t) {
      var i = typeof e;
      return !!(t = null == t ? n : t) && ("number" == i || "symbol" != i && r.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
  }, function (e, t, n) {
    var r = n(123),
        i = n(462),
        a = n(30);

    e.exports = function keys(e) {
      return a(e) ? r(e) : i(e);
    };
  }, function (e, t, n) {
    var r = n(15),
        i = n(50),
        a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        o = /^\w*$/;

    e.exports = function isKey(e, t) {
      if (r(e)) return !1;
      var n = typeof e;
      return !("number" != n && "symbol" != n && "boolean" != n && null != e && !i(e)) || o.test(e) || !a.test(e) || null != t && e in Object(t);
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      for (var n = "undefined" !== typeof window && "undefined" !== typeof document, r = ["Edge", "Trident", "Firefox"], i = 0, a = 0; a < r.length; a += 1) {
        if (n && navigator.userAgent.indexOf(r[a]) >= 0) {
          i = 1;
          break;
        }
      }

      var o = n && window.Promise ? function microtaskDebounce(e) {
        var t = !1;
        return function () {
          t || (t = !0, window.Promise.resolve().then(function () {
            t = !1, e();
          }));
        };
      } : function taskDebounce(e) {
        var t = !1;
        return function () {
          t || (t = !0, setTimeout(function () {
            t = !1, e();
          }, i));
        };
      };

      function isFunction(e) {
        return e && "[object Function]" === {}.toString.call(e);
      }

      function getStyleComputedProperty(e, t) {
        if (1 !== e.nodeType) return [];
        var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
        return t ? n[t] : n;
      }

      function getParentNode(e) {
        return "HTML" === e.nodeName ? e : e.parentNode || e.host;
      }

      function getScrollParent(e) {
        if (!e) return document.body;

        switch (e.nodeName) {
          case "HTML":
          case "BODY":
            return e.ownerDocument.body;

          case "#document":
            return e.body;
        }

        var t = getStyleComputedProperty(e),
            n = t.overflow,
            r = t.overflowX,
            i = t.overflowY;
        return /(auto|scroll|overlay)/.test(n + i + r) ? e : getScrollParent(getParentNode(e));
      }

      var s = n && !(!window.MSInputMethodContext || !document.documentMode),
          l = n && /MSIE 10/.test(navigator.userAgent);

      function isIE(e) {
        return 11 === e ? s : 10 === e ? l : s || l;
      }

      function getOffsetParent(e) {
        if (!e) return document.documentElement;

        for (var t = isIE(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling;) {
          n = (e = e.nextElementSibling).offsetParent;
        }

        var r = n && n.nodeName;
        return r && "BODY" !== r && "HTML" !== r ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) && "static" === getStyleComputedProperty(n, "position") ? getOffsetParent(n) : n : e ? e.ownerDocument.documentElement : document.documentElement;
      }

      function getRoot(e) {
        return null !== e.parentNode ? getRoot(e.parentNode) : e;
      }

      function findCommonOffsetParent(e, t) {
        if (!e || !e.nodeType || !t || !t.nodeType) return document.documentElement;
        var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
            r = n ? e : t,
            i = n ? t : e,
            a = document.createRange();
        a.setStart(r, 0), a.setEnd(i, 0);
        var o = a.commonAncestorContainer;
        if (e !== o && t !== o || r.contains(i)) return function isOffsetContainer(e) {
          var t = e.nodeName;
          return "BODY" !== t && ("HTML" === t || getOffsetParent(e.firstElementChild) === e);
        }(o) ? o : getOffsetParent(o);
        var s = getRoot(e);
        return s.host ? findCommonOffsetParent(s.host, t) : findCommonOffsetParent(e, getRoot(t).host);
      }

      function getScroll(e) {
        var t = "top" === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft",
            n = e.nodeName;

        if ("BODY" === n || "HTML" === n) {
          var r = e.ownerDocument.documentElement;
          return (e.ownerDocument.scrollingElement || r)[t];
        }

        return e[t];
      }

      function getBordersSize(e, t) {
        var n = "x" === t ? "Left" : "Top",
            r = "Left" === n ? "Right" : "Bottom";
        return parseFloat(e["border" + n + "Width"], 10) + parseFloat(e["border" + r + "Width"], 10);
      }

      function getSize(e, t, n, r) {
        return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], isIE(10) ? parseInt(n["offset" + e]) + parseInt(r["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0);
      }

      function getWindowSizes(e) {
        var t = e.body,
            n = e.documentElement,
            r = isIE(10) && getComputedStyle(n);
        return {
          height: getSize("Height", t, n, r),
          width: getSize("Width", t, n, r)
        };
      }

      var c = function classCallCheck(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      },
          p = function () {
        function defineProperties(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        return function (e, t, n) {
          return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
        };
      }(),
          d = function defineProperty(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      },
          h = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      };

      function getClientRect(e) {
        return h({}, e, {
          right: e.left + e.width,
          bottom: e.top + e.height
        });
      }

      function getBoundingClientRect(e) {
        var t = {};

        try {
          if (isIE(10)) {
            t = e.getBoundingClientRect();
            var n = getScroll(e, "top"),
                r = getScroll(e, "left");
            t.top += n, t.left += r, t.bottom += n, t.right += r;
          } else t = e.getBoundingClientRect();
        } catch (d) {}

        var i = {
          left: t.left,
          top: t.top,
          width: t.right - t.left,
          height: t.bottom - t.top
        },
            a = "HTML" === e.nodeName ? getWindowSizes(e.ownerDocument) : {},
            o = a.width || e.clientWidth || i.right - i.left,
            s = a.height || e.clientHeight || i.bottom - i.top,
            l = e.offsetWidth - o,
            c = e.offsetHeight - s;

        if (l || c) {
          var p = getStyleComputedProperty(e);
          l -= getBordersSize(p, "x"), c -= getBordersSize(p, "y"), i.width -= l, i.height -= c;
        }

        return getClientRect(i);
      }

      function getOffsetRectRelativeToArbitraryNode(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = isIE(10),
            i = "HTML" === t.nodeName,
            a = getBoundingClientRect(e),
            o = getBoundingClientRect(t),
            s = getScrollParent(e),
            l = getStyleComputedProperty(t),
            c = parseFloat(l.borderTopWidth, 10),
            p = parseFloat(l.borderLeftWidth, 10);
        n && i && (o.top = Math.max(o.top, 0), o.left = Math.max(o.left, 0));
        var d = getClientRect({
          top: a.top - o.top - c,
          left: a.left - o.left - p,
          width: a.width,
          height: a.height
        });

        if (d.marginTop = 0, d.marginLeft = 0, !r && i) {
          var h = parseFloat(l.marginTop, 10),
              u = parseFloat(l.marginLeft, 10);
          d.top -= c - h, d.bottom -= c - h, d.left -= p - u, d.right -= p - u, d.marginTop = h, d.marginLeft = u;
        }

        return (r && !n ? t.contains(s) : t === s && "BODY" !== s.nodeName) && (d = function includeScroll(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
              r = getScroll(t, "top"),
              i = getScroll(t, "left"),
              a = n ? -1 : 1;
          return e.top += r * a, e.bottom += r * a, e.left += i * a, e.right += i * a, e;
        }(d, t)), d;
      }

      function getFixedPositionOffsetParent(e) {
        if (!e || !e.parentElement || isIE()) return document.documentElement;

        for (var t = e.parentElement; t && "none" === getStyleComputedProperty(t, "transform");) {
          t = t.parentElement;
        }

        return t || document.documentElement;
      }

      function getBoundaries(e, t, n, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
            a = {
          top: 0,
          left: 0
        },
            o = i ? getFixedPositionOffsetParent(e) : findCommonOffsetParent(e, t);
        if ("viewport" === r) a = function getViewportOffsetRectRelativeToArtbitraryNode(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = e.ownerDocument.documentElement,
              r = getOffsetRectRelativeToArbitraryNode(e, n),
              i = Math.max(n.clientWidth, window.innerWidth || 0),
              a = Math.max(n.clientHeight, window.innerHeight || 0),
              o = t ? 0 : getScroll(n),
              s = t ? 0 : getScroll(n, "left");
          return getClientRect({
            top: o - r.top + r.marginTop,
            left: s - r.left + r.marginLeft,
            width: i,
            height: a
          });
        }(o, i);else {
          var s = void 0;
          "scrollParent" === r ? "BODY" === (s = getScrollParent(getParentNode(t))).nodeName && (s = e.ownerDocument.documentElement) : s = "window" === r ? e.ownerDocument.documentElement : r;
          var l = getOffsetRectRelativeToArbitraryNode(s, o, i);
          if ("HTML" !== s.nodeName || function isFixed(e) {
            var t = e.nodeName;
            if ("BODY" === t || "HTML" === t) return !1;
            if ("fixed" === getStyleComputedProperty(e, "position")) return !0;
            var n = getParentNode(e);
            return !!n && isFixed(n);
          }(o)) a = l;else {
            var c = getWindowSizes(e.ownerDocument),
                p = c.height,
                d = c.width;
            a.top += l.top - l.marginTop, a.bottom = p + l.top, a.left += l.left - l.marginLeft, a.right = d + l.left;
          }
        }
        var h = "number" === typeof (n = n || 0);
        return a.left += h ? n : n.left || 0, a.top += h ? n : n.top || 0, a.right -= h ? n : n.right || 0, a.bottom -= h ? n : n.bottom || 0, a;
      }

      function computeAutoPlacement(e, t, n, r, i) {
        var a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === e.indexOf("auto")) return e;
        var o = getBoundaries(n, r, a, i),
            s = {
          top: {
            width: o.width,
            height: t.top - o.top
          },
          right: {
            width: o.right - t.right,
            height: o.height
          },
          bottom: {
            width: o.width,
            height: o.bottom - t.bottom
          },
          left: {
            width: t.left - o.left,
            height: o.height
          }
        },
            l = Object.keys(s).map(function (e) {
          return h({
            key: e
          }, s[e], {
            area: (t = s[e], t.width * t.height)
          });
          var t;
        }).sort(function (e, t) {
          return t.area - e.area;
        }),
            c = l.filter(function (e) {
          var t = e.width,
              r = e.height;
          return t >= n.clientWidth && r >= n.clientHeight;
        }),
            p = c.length > 0 ? c[0].key : l[0].key,
            d = e.split("-")[1];
        return p + (d ? "-" + d : "");
      }

      function getReferenceOffsets(e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
        return getOffsetRectRelativeToArbitraryNode(n, r ? getFixedPositionOffsetParent(t) : findCommonOffsetParent(t, n), r);
      }

      function getOuterSizes(e) {
        var t = e.ownerDocument.defaultView.getComputedStyle(e),
            n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0),
            r = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
        return {
          width: e.offsetWidth + r,
          height: e.offsetHeight + n
        };
      }

      function getOppositePlacement(e) {
        var t = {
          left: "right",
          right: "left",
          bottom: "top",
          top: "bottom"
        };
        return e.replace(/left|right|bottom|top/g, function (e) {
          return t[e];
        });
      }

      function getPopperOffsets(e, t, n) {
        n = n.split("-")[0];
        var r = getOuterSizes(e),
            i = {
          width: r.width,
          height: r.height
        },
            a = -1 !== ["right", "left"].indexOf(n),
            o = a ? "top" : "left",
            s = a ? "left" : "top",
            l = a ? "height" : "width",
            c = a ? "width" : "height";
        return i[o] = t[o] + t[l] / 2 - r[l] / 2, i[s] = n === s ? t[s] - r[c] : t[getOppositePlacement(s)], i;
      }

      function find(e, t) {
        return Array.prototype.find ? e.find(t) : e.filter(t)[0];
      }

      function runModifiers(e, t, n) {
        return (void 0 === n ? e : e.slice(0, function findIndex(e, t, n) {
          if (Array.prototype.findIndex) return e.findIndex(function (e) {
            return e[t] === n;
          });
          var r = find(e, function (e) {
            return e[t] === n;
          });
          return e.indexOf(r);
        }(e, "name", n))).forEach(function (e) {
          e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
          var n = e.function || e.fn;
          e.enabled && isFunction(n) && (t.offsets.popper = getClientRect(t.offsets.popper), t.offsets.reference = getClientRect(t.offsets.reference), t = n(t, e));
        }), t;
      }

      function isModifierEnabled(e, t) {
        return e.some(function (e) {
          var n = e.name;
          return e.enabled && n === t;
        });
      }

      function getSupportedPropertyName(e) {
        for (var t = [!1, "ms", "Webkit", "Moz", "O"], n = e.charAt(0).toUpperCase() + e.slice(1), r = 0; r < t.length; r++) {
          var i = t[r],
              a = i ? "" + i + n : e;
          if ("undefined" !== typeof document.body.style[a]) return a;
        }

        return null;
      }

      function getWindow(e) {
        var t = e.ownerDocument;
        return t ? t.defaultView : window;
      }

      function setupEventListeners(e, t, n, r) {
        n.updateBound = r, getWindow(e).addEventListener("resize", n.updateBound, {
          passive: !0
        });
        var i = getScrollParent(e);
        return function attachToScrollParents(e, t, n, r) {
          var i = "BODY" === e.nodeName,
              a = i ? e.ownerDocument.defaultView : e;
          a.addEventListener(t, n, {
            passive: !0
          }), i || attachToScrollParents(getScrollParent(a.parentNode), t, n, r), r.push(a);
        }(i, "scroll", n.updateBound, n.scrollParents), n.scrollElement = i, n.eventsEnabled = !0, n;
      }

      function disableEventListeners() {
        this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = function removeEventListeners(e, t) {
          return getWindow(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function (e) {
            e.removeEventListener("scroll", t.updateBound);
          }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t;
        }(this.reference, this.state));
      }

      function isNumeric(e) {
        return "" !== e && !isNaN(parseFloat(e)) && isFinite(e);
      }

      function setStyles(e, t) {
        Object.keys(t).forEach(function (n) {
          var r = "";
          -1 !== ["width", "height", "top", "right", "bottom", "left"].indexOf(n) && isNumeric(t[n]) && (r = "px"), e.style[n] = t[n] + r;
        });
      }

      var u = n && /Firefox/i.test(navigator.userAgent);

      function isModifierRequired(e, t, n) {
        var r = find(e, function (e) {
          return e.name === t;
        }),
            i = !!r && e.some(function (e) {
          return e.name === n && e.enabled && e.order < r.order;
        });

        if (!i) {
          var a = "`" + t + "`",
              o = "`" + n + "`";
          console.warn(o + " modifier is required by " + a + " modifier in order to work, be sure to include it before " + a + "!");
        }

        return i;
      }

      var f = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"],
          m = f.slice(3);

      function clockwise(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = m.indexOf(e),
            r = m.slice(n + 1).concat(m.slice(0, n));
        return t ? r.reverse() : r;
      }

      var g = {
        FLIP: "flip",
        CLOCKWISE: "clockwise",
        COUNTERCLOCKWISE: "counterclockwise"
      };

      function parseOffset(e, t, n, r) {
        var i = [0, 0],
            a = -1 !== ["right", "left"].indexOf(r),
            o = e.split(/(\+|\-)/).map(function (e) {
          return e.trim();
        }),
            s = o.indexOf(find(o, function (e) {
          return -1 !== e.search(/,|\s/);
        }));
        o[s] && -1 === o[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
        var l = /\s*,\s*|\s+/,
            c = -1 !== s ? [o.slice(0, s).concat([o[s].split(l)[0]]), [o[s].split(l)[1]].concat(o.slice(s + 1))] : [o];
        return (c = c.map(function (e, r) {
          var i = (1 === r ? !a : a) ? "height" : "width",
              o = !1;
          return e.reduce(function (e, t) {
            return "" === e[e.length - 1] && -1 !== ["+", "-"].indexOf(t) ? (e[e.length - 1] = t, o = !0, e) : o ? (e[e.length - 1] += t, o = !1, e) : e.concat(t);
          }, []).map(function (e) {
            return function toValue(e, t, n, r) {
              var i = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                  a = +i[1],
                  o = i[2];
              if (!a) return e;

              if (0 === o.indexOf("%")) {
                var s = void 0;

                switch (o) {
                  case "%p":
                    s = n;
                    break;

                  case "%":
                  case "%r":
                  default:
                    s = r;
                }

                return getClientRect(s)[t] / 100 * a;
              }

              if ("vh" === o || "vw" === o) return ("vh" === o ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * a;
              return a;
            }(e, i, t, n);
          });
        })).forEach(function (e, t) {
          e.forEach(function (n, r) {
            isNumeric(n) && (i[t] += n * ("-" === e[r - 1] ? -1 : 1));
          });
        }), i;
      }

      var v = {
        placement: "bottom",
        positionFixed: !1,
        eventsEnabled: !0,
        removeOnDestroy: !1,
        onCreate: function onCreate() {},
        onUpdate: function onUpdate() {},
        modifiers: {
          shift: {
            order: 100,
            enabled: !0,
            fn: function shift(e) {
              var t = e.placement,
                  n = t.split("-")[0],
                  r = t.split("-")[1];

              if (r) {
                var i = e.offsets,
                    a = i.reference,
                    o = i.popper,
                    s = -1 !== ["bottom", "top"].indexOf(n),
                    l = s ? "left" : "top",
                    c = s ? "width" : "height",
                    p = {
                  start: d({}, l, a[l]),
                  end: d({}, l, a[l] + a[c] - o[c])
                };
                e.offsets.popper = h({}, o, p[r]);
              }

              return e;
            }
          },
          offset: {
            order: 200,
            enabled: !0,
            fn: function offset(e, t) {
              var n = t.offset,
                  r = e.placement,
                  i = e.offsets,
                  a = i.popper,
                  o = i.reference,
                  s = r.split("-")[0],
                  l = void 0;
              return l = isNumeric(+n) ? [+n, 0] : parseOffset(n, a, o, s), "left" === s ? (a.top += l[0], a.left -= l[1]) : "right" === s ? (a.top += l[0], a.left += l[1]) : "top" === s ? (a.left += l[0], a.top -= l[1]) : "bottom" === s && (a.left += l[0], a.top += l[1]), e.popper = a, e;
            },
            offset: 0
          },
          preventOverflow: {
            order: 300,
            enabled: !0,
            fn: function preventOverflow(e, t) {
              var n = t.boundariesElement || getOffsetParent(e.instance.popper);
              e.instance.reference === n && (n = getOffsetParent(n));
              var r = getSupportedPropertyName("transform"),
                  i = e.instance.popper.style,
                  a = i.top,
                  o = i.left,
                  s = i[r];
              i.top = "", i.left = "", i[r] = "";
              var l = getBoundaries(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
              i.top = a, i.left = o, i[r] = s, t.boundaries = l;
              var c = t.priority,
                  p = e.offsets.popper,
                  u = {
                primary: function primary(e) {
                  var n = p[e];
                  return p[e] < l[e] && !t.escapeWithReference && (n = Math.max(p[e], l[e])), d({}, e, n);
                },
                secondary: function secondary(e) {
                  var n = "right" === e ? "left" : "top",
                      r = p[n];
                  return p[e] > l[e] && !t.escapeWithReference && (r = Math.min(p[n], l[e] - ("right" === e ? p.width : p.height))), d({}, n, r);
                }
              };
              return c.forEach(function (e) {
                var t = -1 !== ["left", "top"].indexOf(e) ? "primary" : "secondary";
                p = h({}, p, u[t](e));
              }), e.offsets.popper = p, e;
            },
            priority: ["left", "right", "top", "bottom"],
            padding: 5,
            boundariesElement: "scrollParent"
          },
          keepTogether: {
            order: 400,
            enabled: !0,
            fn: function keepTogether(e) {
              var t = e.offsets,
                  n = t.popper,
                  r = t.reference,
                  i = e.placement.split("-")[0],
                  a = Math.floor,
                  o = -1 !== ["top", "bottom"].indexOf(i),
                  s = o ? "right" : "bottom",
                  l = o ? "left" : "top",
                  c = o ? "width" : "height";
              return n[s] < a(r[l]) && (e.offsets.popper[l] = a(r[l]) - n[c]), n[l] > a(r[s]) && (e.offsets.popper[l] = a(r[s])), e;
            }
          },
          arrow: {
            order: 500,
            enabled: !0,
            fn: function arrow(e, t) {
              var n;
              if (!isModifierRequired(e.instance.modifiers, "arrow", "keepTogether")) return e;
              var r = t.element;

              if ("string" === typeof r) {
                if (!(r = e.instance.popper.querySelector(r))) return e;
              } else if (!e.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;

              var i = e.placement.split("-")[0],
                  a = e.offsets,
                  o = a.popper,
                  s = a.reference,
                  l = -1 !== ["left", "right"].indexOf(i),
                  c = l ? "height" : "width",
                  p = l ? "Top" : "Left",
                  h = p.toLowerCase(),
                  u = l ? "left" : "top",
                  f = l ? "bottom" : "right",
                  m = getOuterSizes(r)[c];
              s[f] - m < o[h] && (e.offsets.popper[h] -= o[h] - (s[f] - m)), s[h] + m > o[f] && (e.offsets.popper[h] += s[h] + m - o[f]), e.offsets.popper = getClientRect(e.offsets.popper);
              var g = s[h] + s[c] / 2 - m / 2,
                  v = getStyleComputedProperty(e.instance.popper),
                  b = parseFloat(v["margin" + p], 10),
                  y = parseFloat(v["border" + p + "Width"], 10),
                  x = g - e.offsets.popper[h] - b - y;
              return x = Math.max(Math.min(o[c] - m, x), 0), e.arrowElement = r, e.offsets.arrow = (d(n = {}, h, Math.round(x)), d(n, u, ""), n), e;
            },
            element: "[x-arrow]"
          },
          flip: {
            order: 600,
            enabled: !0,
            fn: function flip(e, t) {
              if (isModifierEnabled(e.instance.modifiers, "inner")) return e;
              if (e.flipped && e.placement === e.originalPlacement) return e;
              var n = getBoundaries(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed),
                  r = e.placement.split("-")[0],
                  i = getOppositePlacement(r),
                  a = e.placement.split("-")[1] || "",
                  o = [];

              switch (t.behavior) {
                case g.FLIP:
                  o = [r, i];
                  break;

                case g.CLOCKWISE:
                  o = clockwise(r);
                  break;

                case g.COUNTERCLOCKWISE:
                  o = clockwise(r, !0);
                  break;

                default:
                  o = t.behavior;
              }

              return o.forEach(function (s, l) {
                if (r !== s || o.length === l + 1) return e;
                r = e.placement.split("-")[0], i = getOppositePlacement(r);
                var c = e.offsets.popper,
                    p = e.offsets.reference,
                    d = Math.floor,
                    u = "left" === r && d(c.right) > d(p.left) || "right" === r && d(c.left) < d(p.right) || "top" === r && d(c.bottom) > d(p.top) || "bottom" === r && d(c.top) < d(p.bottom),
                    f = d(c.left) < d(n.left),
                    m = d(c.right) > d(n.right),
                    g = d(c.top) < d(n.top),
                    v = d(c.bottom) > d(n.bottom),
                    b = "left" === r && f || "right" === r && m || "top" === r && g || "bottom" === r && v,
                    y = -1 !== ["top", "bottom"].indexOf(r),
                    x = !!t.flipVariations && (y && "start" === a && f || y && "end" === a && m || !y && "start" === a && g || !y && "end" === a && v),
                    w = !!t.flipVariationsByContent && (y && "start" === a && m || y && "end" === a && f || !y && "start" === a && v || !y && "end" === a && g),
                    E = x || w;
                (u || b || E) && (e.flipped = !0, (u || b) && (r = o[l + 1]), E && (a = function getOppositeVariation(e) {
                  return "end" === e ? "start" : "start" === e ? "end" : e;
                }(a)), e.placement = r + (a ? "-" + a : ""), e.offsets.popper = h({}, e.offsets.popper, getPopperOffsets(e.instance.popper, e.offsets.reference, e.placement)), e = runModifiers(e.instance.modifiers, e, "flip"));
              }), e;
            },
            behavior: "flip",
            padding: 5,
            boundariesElement: "viewport",
            flipVariations: !1,
            flipVariationsByContent: !1
          },
          inner: {
            order: 700,
            enabled: !1,
            fn: function inner(e) {
              var t = e.placement,
                  n = t.split("-")[0],
                  r = e.offsets,
                  i = r.popper,
                  a = r.reference,
                  o = -1 !== ["left", "right"].indexOf(n),
                  s = -1 === ["top", "left"].indexOf(n);
              return i[o ? "left" : "top"] = a[n] - (s ? i[o ? "width" : "height"] : 0), e.placement = getOppositePlacement(t), e.offsets.popper = getClientRect(i), e;
            }
          },
          hide: {
            order: 800,
            enabled: !0,
            fn: function hide(e) {
              if (!isModifierRequired(e.instance.modifiers, "hide", "preventOverflow")) return e;
              var t = e.offsets.reference,
                  n = find(e.instance.modifiers, function (e) {
                return "preventOverflow" === e.name;
              }).boundaries;

              if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
                if (!0 === e.hide) return e;
                e.hide = !0, e.attributes["x-out-of-boundaries"] = "";
              } else {
                if (!1 === e.hide) return e;
                e.hide = !1, e.attributes["x-out-of-boundaries"] = !1;
              }

              return e;
            }
          },
          computeStyle: {
            order: 850,
            enabled: !0,
            fn: function computeStyle(e, t) {
              var n = t.x,
                  r = t.y,
                  i = e.offsets.popper,
                  a = find(e.instance.modifiers, function (e) {
                return "applyStyle" === e.name;
              }).gpuAcceleration;
              void 0 !== a && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");

              var o = void 0 !== a ? a : t.gpuAcceleration,
                  s = getOffsetParent(e.instance.popper),
                  l = getBoundingClientRect(s),
                  c = {
                position: i.position
              },
                  p = function getRoundedOffsets(e, t) {
                var n = e.offsets,
                    r = n.popper,
                    i = n.reference,
                    a = Math.round,
                    o = Math.floor,
                    s = function noRound(e) {
                  return e;
                },
                    l = a(i.width),
                    c = a(r.width),
                    p = -1 !== ["left", "right"].indexOf(e.placement),
                    d = -1 !== e.placement.indexOf("-"),
                    h = t ? p || d || l % 2 === c % 2 ? a : o : s,
                    u = t ? a : s;

                return {
                  left: h(l % 2 === 1 && c % 2 === 1 && !d && t ? r.left - 1 : r.left),
                  top: u(r.top),
                  bottom: u(r.bottom),
                  right: h(r.right)
                };
              }(e, window.devicePixelRatio < 2 || !u),
                  d = "bottom" === n ? "top" : "bottom",
                  f = "right" === r ? "left" : "right",
                  m = getSupportedPropertyName("transform"),
                  g = void 0,
                  v = void 0;

              if (v = "bottom" === d ? "HTML" === s.nodeName ? -s.clientHeight + p.bottom : -l.height + p.bottom : p.top, g = "right" === f ? "HTML" === s.nodeName ? -s.clientWidth + p.right : -l.width + p.right : p.left, o && m) c[m] = "translate3d(" + g + "px, " + v + "px, 0)", c[d] = 0, c[f] = 0, c.willChange = "transform";else {
                var b = "bottom" === d ? -1 : 1,
                    y = "right" === f ? -1 : 1;
                c[d] = v * b, c[f] = g * y, c.willChange = d + ", " + f;
              }
              var x = {
                "x-placement": e.placement
              };
              return e.attributes = h({}, x, e.attributes), e.styles = h({}, c, e.styles), e.arrowStyles = h({}, e.offsets.arrow, e.arrowStyles), e;
            },
            gpuAcceleration: !0,
            x: "bottom",
            y: "right"
          },
          applyStyle: {
            order: 900,
            enabled: !0,
            fn: function applyStyle(e) {
              return setStyles(e.instance.popper, e.styles), function setAttributes(e, t) {
                Object.keys(t).forEach(function (n) {
                  !1 !== t[n] ? e.setAttribute(n, t[n]) : e.removeAttribute(n);
                });
              }(e.instance.popper, e.attributes), e.arrowElement && Object.keys(e.arrowStyles).length && setStyles(e.arrowElement, e.arrowStyles), e;
            },
            onLoad: function applyStyleOnLoad(e, t, n, r, i) {
              var a = getReferenceOffsets(i, t, e, n.positionFixed),
                  o = computeAutoPlacement(n.placement, a, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
              return t.setAttribute("x-placement", o), setStyles(t, {
                position: n.positionFixed ? "fixed" : "absolute"
              }), n;
            },
            gpuAcceleration: void 0
          }
        }
      },
          b = function () {
        function Popper(e, t) {
          var n = this,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          c(this, Popper), this.scheduleUpdate = function () {
            return requestAnimationFrame(n.update);
          }, this.update = o(this.update.bind(this)), this.options = h({}, Popper.Defaults, r), this.state = {
            isDestroyed: !1,
            isCreated: !1,
            scrollParents: []
          }, this.reference = e && e.jquery ? e[0] : e, this.popper = t && t.jquery ? t[0] : t, this.options.modifiers = {}, Object.keys(h({}, Popper.Defaults.modifiers, r.modifiers)).forEach(function (e) {
            n.options.modifiers[e] = h({}, Popper.Defaults.modifiers[e] || {}, r.modifiers ? r.modifiers[e] : {});
          }), this.modifiers = Object.keys(this.options.modifiers).map(function (e) {
            return h({
              name: e
            }, n.options.modifiers[e]);
          }).sort(function (e, t) {
            return e.order - t.order;
          }), this.modifiers.forEach(function (e) {
            e.enabled && isFunction(e.onLoad) && e.onLoad(n.reference, n.popper, n.options, e, n.state);
          }), this.update();
          var i = this.options.eventsEnabled;
          i && this.enableEventListeners(), this.state.eventsEnabled = i;
        }

        return p(Popper, [{
          key: "update",
          value: function update$$1() {
            return function update() {
              if (!this.state.isDestroyed) {
                var e = {
                  instance: this,
                  styles: {},
                  arrowStyles: {},
                  attributes: {},
                  flipped: !1,
                  offsets: {}
                };
                e.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = computeAutoPlacement(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = getPopperOffsets(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = runModifiers(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e));
              }
            }.call(this);
          }
        }, {
          key: "destroy",
          value: function destroy$$1() {
            return function destroy() {
              return this.state.isDestroyed = !0, isModifierEnabled(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[getSupportedPropertyName("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
            }.call(this);
          }
        }, {
          key: "enableEventListeners",
          value: function enableEventListeners$$1() {
            return function enableEventListeners() {
              this.state.eventsEnabled || (this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate));
            }.call(this);
          }
        }, {
          key: "disableEventListeners",
          value: function disableEventListeners$$1() {
            return disableEventListeners.call(this);
          }
        }]), Popper;
      }();

      b.Utils = ("undefined" !== typeof window ? window : e).PopperUtils, b.placements = f, b.Defaults = v, t.a = b;
    }).call(this, n(32));
  }, function (e, t, n) {
    (function (t) {
      var n = "undefined" !== typeof window ? window : "undefined" !== typeof WorkerGlobalScope && self instanceof WorkerGlobalScope ? self : {},
          r = function () {
        var e = /\blang(?:uage)?-([\w-]+)\b/i,
            t = 0,
            r = n.Prism = {
          manual: n.Prism && n.Prism.manual,
          disableWorkerMessageHandler: n.Prism && n.Prism.disableWorkerMessageHandler,
          util: {
            encode: function encode(e) {
              return e instanceof i ? new i(e.type, r.util.encode(e.content), e.alias) : "Array" === r.util.type(e) ? e.map(r.util.encode) : e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            type: function type(e) {
              return Object.prototype.toString.call(e).match(/\[object (\w+)\]/)[1];
            },
            objId: function objId(e) {
              return e.__id || Object.defineProperty(e, "__id", {
                value: ++t
              }), e.__id;
            },
            clone: function clone(e, t) {
              var n = r.util.type(e);

              switch (t = t || {}, n) {
                case "Object":
                  if (t[r.util.objId(e)]) return t[r.util.objId(e)];
                  clone = {};

                  for (var i in t[r.util.objId(e)] = clone, e) {
                    e.hasOwnProperty(i) && (clone[i] = r.util.clone(e[i], t));
                  }

                  return clone;

                case "Array":
                  if (t[r.util.objId(e)]) return t[r.util.objId(e)];
                  var clone = [];
                  return t[r.util.objId(e)] = clone, e.forEach(function (e, n) {
                    clone[n] = r.util.clone(e, t);
                  }), clone;
              }

              return e;
            }
          },
          languages: {
            extend: function extend(e, t) {
              var n = r.util.clone(r.languages[e]);

              for (var i in t) {
                n[i] = t[i];
              }

              return n;
            },
            insertBefore: function insertBefore(e, t, n, i) {
              var a = (i = i || r.languages)[e];

              if (2 == arguments.length) {
                for (var o in n = arguments[1]) {
                  n.hasOwnProperty(o) && (a[o] = n[o]);
                }

                return a;
              }

              var s = {};

              for (var l in a) {
                if (a.hasOwnProperty(l)) {
                  if (l == t) for (var o in n) {
                    n.hasOwnProperty(o) && (s[o] = n[o]);
                  }
                  s[l] = a[l];
                }
              }

              return r.languages.DFS(r.languages, function (t, n) {
                n === i[e] && t != e && (this[t] = s);
              }), i[e] = s;
            },
            DFS: function DFS(e, t, n, i) {
              for (var a in i = i || {}, e) {
                e.hasOwnProperty(a) && (t.call(e, a, e[a], n || a), "Object" !== r.util.type(e[a]) || i[r.util.objId(e[a])] ? "Array" !== r.util.type(e[a]) || i[r.util.objId(e[a])] || (i[r.util.objId(e[a])] = !0, r.languages.DFS(e[a], t, a, i)) : (i[r.util.objId(e[a])] = !0, r.languages.DFS(e[a], t, null, i)));
              }
            }
          },
          plugins: {},
          highlightAll: function highlightAll(e, t) {
            r.highlightAllUnder(document, e, t);
          },
          highlightAllUnder: function highlightAllUnder(e, t, n) {
            var i = {
              callback: n,
              selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            r.hooks.run("before-highlightall", i);

            for (var a, o = i.elements || e.querySelectorAll(i.selector), s = 0; a = o[s++];) {
              r.highlightElement(a, !0 === t, i.callback);
            }
          },
          highlightElement: function highlightElement(t, i, a) {
            for (var o, s, l = t; l && !e.test(l.className);) {
              l = l.parentNode;
            }

            l && (o = (l.className.match(e) || [, ""])[1].toLowerCase(), s = r.languages[o]), t.className = t.className.replace(e, "").replace(/\s+/g, " ") + " language-" + o, t.parentNode && (l = t.parentNode, /pre/i.test(l.nodeName) && (l.className = l.className.replace(e, "").replace(/\s+/g, " ") + " language-" + o));
            var c = {
              element: t,
              language: o,
              grammar: s,
              code: t.textContent
            };
            if (r.hooks.run("before-sanity-check", c), !c.code || !c.grammar) return c.code && (r.hooks.run("before-highlight", c), c.element.textContent = c.code, r.hooks.run("after-highlight", c)), void r.hooks.run("complete", c);

            if (r.hooks.run("before-highlight", c), i && n.Worker) {
              var p = new Worker(r.filename);
              p.onmessage = function (e) {
                c.highlightedCode = e.data, r.hooks.run("before-insert", c), c.element.innerHTML = c.highlightedCode, a && a.call(c.element), r.hooks.run("after-highlight", c), r.hooks.run("complete", c);
              }, p.postMessage(JSON.stringify({
                language: c.language,
                code: c.code,
                immediateClose: !0
              }));
            } else c.highlightedCode = r.highlight(c.code, c.grammar, c.language), r.hooks.run("before-insert", c), c.element.innerHTML = c.highlightedCode, a && a.call(t), r.hooks.run("after-highlight", c), r.hooks.run("complete", c);
          },
          highlight: function highlight(e, t, n) {
            var a = {
              code: e,
              grammar: t,
              language: n
            };
            return r.hooks.run("before-tokenize", a), a.tokens = r.tokenize(a.code, a.grammar), r.hooks.run("after-tokenize", a), i.stringify(r.util.encode(a.tokens), a.language);
          },
          matchGrammar: function matchGrammar(e, t, n, i, a, o, s) {
            var l = r.Token;

            for (var c in n) {
              if (n.hasOwnProperty(c) && n[c]) {
                if (c == s) return;
                var p = n[c];
                p = "Array" === r.util.type(p) ? p : [p];

                for (var d = 0; d < p.length; ++d) {
                  var h = p[d],
                      u = h.inside,
                      f = !!h.lookbehind,
                      m = !!h.greedy,
                      g = 0,
                      v = h.alias;

                  if (m && !h.pattern.global) {
                    var b = h.pattern.toString().match(/[imuy]*$/)[0];
                    h.pattern = RegExp(h.pattern.source, b + "g");
                  }

                  h = h.pattern || h;

                  for (var y = i, x = a; y < t.length; x += t[y].length, ++y) {
                    var w = t[y];
                    if (t.length > e.length) return;

                    if (!(w instanceof l)) {
                      if (m && y != t.length - 1) {
                        if (h.lastIndex = x, !(M = h.exec(e))) break;

                        for (var E = M.index + (f ? M[1].length : 0), C = M.index + M[0].length, k = y, S = x, _ = t.length; k < _ && (S < C || !t[k].type && !t[k - 1].greedy); ++k) {
                          E >= (S += t[k].length) && (++y, x = S);
                        }

                        if (t[y] instanceof l) continue;
                        L = k - y, w = e.slice(x, S), M.index -= x;
                      } else {
                        h.lastIndex = 0;
                        var M = h.exec(w),
                            L = 1;
                      }

                      if (M) {
                        f && (g = M[1] ? M[1].length : 0);
                        C = (E = M.index + g) + (M = M[0].slice(g)).length;
                        var P = w.slice(0, E),
                            F = w.slice(C),
                            A = [y, L];
                        P && (++y, x += P.length, A.push(P));
                        var D = new l(c, u ? r.tokenize(M, u) : M, v, M, m);
                        if (A.push(D), F && A.push(F), Array.prototype.splice.apply(t, A), 1 != L && r.matchGrammar(e, t, n, y, x, !0, c), o) break;
                      } else if (o) break;
                    }
                  }
                }
              }
            }
          },
          tokenize: function tokenize(e, t, n) {
            var i = [e],
                a = t.rest;

            if (a) {
              for (var o in a) {
                t[o] = a[o];
              }

              delete t.rest;
            }

            return r.matchGrammar(e, i, t, 0, 0, !1), i;
          },
          hooks: {
            all: {},
            add: function add(e, t) {
              var n = r.hooks.all;
              n[e] = n[e] || [], n[e].push(t);
            },
            run: function run(e, t) {
              var n = r.hooks.all[e];
              if (n && n.length) for (var i, a = 0; i = n[a++];) {
                i(t);
              }
            }
          }
        },
            i = r.Token = function (e, t, n, r, i) {
          this.type = e, this.content = t, this.alias = n, this.length = 0 | (r || "").length, this.greedy = !!i;
        };

        if (i.stringify = function (e, t, n) {
          if ("string" == typeof e) return e;
          if ("Array" === r.util.type(e)) return e.map(function (n) {
            return i.stringify(n, t, e);
          }).join("");
          var a = {
            type: e.type,
            content: i.stringify(e.content, t, n),
            tag: "span",
            classes: ["token", e.type],
            attributes: {},
            language: t,
            parent: n
          };

          if (e.alias) {
            var o = "Array" === r.util.type(e.alias) ? e.alias : [e.alias];
            Array.prototype.push.apply(a.classes, o);
          }

          r.hooks.run("wrap", a);
          var s = Object.keys(a.attributes).map(function (e) {
            return e + '="' + (a.attributes[e] || "").replace(/"/g, "&quot;") + '"';
          }).join(" ");
          return "<" + a.tag + ' class="' + a.classes.join(" ") + '"' + (s ? " " + s : "") + ">" + a.content + "</" + a.tag + ">";
        }, !n.document) return n.addEventListener ? (r.disableWorkerMessageHandler || n.addEventListener("message", function (e) {
          var t = JSON.parse(e.data),
              i = t.language,
              a = t.code,
              o = t.immediateClose;
          n.postMessage(r.highlight(a, r.languages[i], i)), o && n.close();
        }, !1), n.Prism) : n.Prism;
        var a = document.currentScript || [].slice.call(document.getElementsByTagName("script")).pop();
        return a && (r.filename = a.src, r.manual || a.hasAttribute("data-manual") || ("loading" !== document.readyState ? window.requestAnimationFrame ? window.requestAnimationFrame(r.highlightAll) : window.setTimeout(r.highlightAll, 16) : document.addEventListener("DOMContentLoaded", r.highlightAll))), n.Prism;
      }();

      e.exports && (e.exports = r), "undefined" !== typeof t && (t.Prism = r), r.languages.markup = {
        comment: /<!--[\s\S]*?-->/,
        prolog: /<\?[\s\S]+?\?>/,
        doctype: /<!DOCTYPE[\s\S]+?>/i,
        cdata: /<!\[CDATA\[[\s\S]*?]]>/i,
        tag: {
          pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i,
          greedy: !0,
          inside: {
            tag: {
              pattern: /^<\/?[^\s>\/]+/i,
              inside: {
                punctuation: /^<\/?/,
                namespace: /^[^\s>\/:]+:/
              }
            },
            "attr-value": {
              pattern: /=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+)/i,
              inside: {
                punctuation: [/^=/, {
                  pattern: /(^|[^\\])["']/,
                  lookbehind: !0
                }]
              }
            },
            punctuation: /\/?>/,
            "attr-name": {
              pattern: /[^\s>\/]+/,
              inside: {
                namespace: /^[^\s>\/:]+:/
              }
            }
          }
        },
        entity: /&#?[\da-z]{1,8};/i
      }, r.languages.markup.tag.inside["attr-value"].inside.entity = r.languages.markup.entity, r.hooks.add("wrap", function (e) {
        "entity" === e.type && (e.attributes.title = e.content.replace(/&amp;/, "&"));
      }), r.languages.xml = r.languages.markup, r.languages.html = r.languages.markup, r.languages.mathml = r.languages.markup, r.languages.svg = r.languages.markup, r.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
          pattern: /@[\w-]+?.*?(?:;|(?=\s*\{))/i,
          inside: {
            rule: /@[\w-]+/
          }
        },
        url: /url\((?:(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1|.*?)\)/i,
        selector: /[^{}\s][^{};]*?(?=\s*\{)/,
        string: {
          pattern: /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        },
        property: /[-_a-z\xA0-\uFFFF][-\w\xA0-\uFFFF]*(?=\s*:)/i,
        important: /\B!important\b/i,
        function: /[-a-z0-9]+(?=\()/i,
        punctuation: /[(){};:]/
      }, r.languages.css.atrule.inside.rest = r.languages.css, r.languages.markup && (r.languages.insertBefore("markup", "tag", {
        style: {
          pattern: /(<style[\s\S]*?>)[\s\S]*?(?=<\/style>)/i,
          lookbehind: !0,
          inside: r.languages.css,
          alias: "language-css",
          greedy: !0
        }
      }), r.languages.insertBefore("inside", "attr-value", {
        "style-attr": {
          pattern: /\s*style=("|')(?:\\[\s\S]|(?!\1)[^\\])*\1/i,
          inside: {
            "attr-name": {
              pattern: /^\s*style/i,
              inside: r.languages.markup.tag.inside
            },
            punctuation: /^\s*=\s*['"]|['"]\s*$/,
            "attr-value": {
              pattern: /.+/i,
              inside: r.languages.css
            }
          },
          alias: "language-css"
        }
      }, r.languages.markup.tag)), r.languages.clike = {
        comment: [{
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0
        }, {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }],
        string: {
          pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        },
        "class-name": {
          pattern: /((?:\b(?:class|interface|extends|implements|trait|instanceof|new)\s+)|(?:catch\s+\())[\w.\\]+/i,
          lookbehind: !0,
          inside: {
            punctuation: /[.\\]/
          }
        },
        keyword: /\b(?:if|else|while|do|for|return|in|instanceof|function|new|try|throw|catch|finally|null|break|continue)\b/,
        boolean: /\b(?:true|false)\b/,
        function: /[a-z0-9_]+(?=\()/i,
        number: /\b0x[\da-f]+\b|(?:\b\d+\.?\d*|\B\.\d+)(?:e[+-]?\d+)?/i,
        operator: /--?|\+\+?|!=?=?|<=?|>=?|==?=?|&&?|\|\|?|\?|\*|\/|~|\^|%/,
        punctuation: /[{}[\];(),.:]/
      }, r.languages.javascript = r.languages.extend("clike", {
        keyword: /\b(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|var|void|while|with|yield)\b/,
        number: /\b(?:0[xX][\dA-Fa-f]+|0[bB][01]+|0[oO][0-7]+|NaN|Infinity)\b|(?:\b\d+\.?\d*|\B\.\d+)(?:[Ee][+-]?\d+)?/,
        function: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*\()/i,
        operator: /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
      }), r.languages.insertBefore("javascript", "keyword", {
        regex: {
          pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s])\s*)\/(\[[^\]\r\n]+]|\\.|[^/\\\[\r\n])+\/[gimyu]{0,5}(?=\s*($|[\r\n,.;})\]]))/,
          lookbehind: !0,
          greedy: !0
        },
        "function-variable": {
          pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=\s*(?:function\b|(?:\([^()]*\)|[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/i,
          alias: "function"
        },
        constant: /\b[A-Z][A-Z\d_]*\b/
      }), r.languages.insertBefore("javascript", "string", {
        "template-string": {
          pattern: /`(?:\\[\s\S]|\${[^}]+}|[^\\`])*`/,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /\${[^}]+}/,
              inside: {
                "interpolation-punctuation": {
                  pattern: /^\${|}$/,
                  alias: "punctuation"
                },
                rest: null
              }
            },
            string: /[\s\S]+/
          }
        }
      }), r.languages.javascript["template-string"].inside.interpolation.inside.rest = r.languages.javascript, r.languages.markup && r.languages.insertBefore("markup", "tag", {
        script: {
          pattern: /(<script[\s\S]*?>)[\s\S]*?(?=<\/script>)/i,
          lookbehind: !0,
          inside: r.languages.javascript,
          alias: "language-javascript",
          greedy: !0
        }
      }), r.languages.js = r.languages.javascript, "undefined" !== typeof self && self.Prism && self.document && document.querySelector && (self.Prism.fileHighlight = function () {
        var e = {
          js: "javascript",
          py: "python",
          rb: "ruby",
          ps1: "powershell",
          psm1: "powershell",
          sh: "bash",
          bat: "batch",
          h: "c",
          tex: "latex"
        };
        Array.prototype.slice.call(document.querySelectorAll("pre[data-src]")).forEach(function (t) {
          for (var n, i = t.getAttribute("data-src"), a = t, o = /\blang(?:uage)?-([\w-]+)\b/i; a && !o.test(a.className);) {
            a = a.parentNode;
          }

          if (a && (n = (t.className.match(o) || [, ""])[1]), !n) {
            var s = (i.match(/\.(\w+)$/) || [, ""])[1];
            n = e[s] || s;
          }

          var l = document.createElement("code");
          l.className = "language-" + n, t.textContent = "", l.textContent = "Loading\u2026", t.appendChild(l);
          var c = new XMLHttpRequest();
          c.open("GET", i, !0), c.onreadystatechange = function () {
            4 == c.readyState && (c.status < 400 && c.responseText ? (l.textContent = c.responseText, r.highlightElement(l)) : c.status >= 400 ? l.textContent = "\u2716 Error " + c.status + " while fetching file: " + c.statusText : l.textContent = "\u2716 Error: File does not exist or is empty");
          }, c.send(null);
        }), r.plugins.toolbar && r.plugins.toolbar.registerButton("download-file", function (e) {
          var t = e.element.parentNode;

          if (t && /pre/i.test(t.nodeName) && t.hasAttribute("data-src") && t.hasAttribute("data-download-link")) {
            var n = t.getAttribute("data-src"),
                r = document.createElement("a");
            return r.textContent = t.getAttribute("data-download-link-label") || "Download", r.setAttribute("download", ""), r.href = n, r;
          }
        });
      }, document.addEventListener("DOMContentLoaded", self.Prism.fileHighlight));
    }).call(this, n(32));
  }, function (e, t, n) {
    var r = n(159);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    var r = n(233);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    "use strict";

    (e.exports = {}).forEach = function (e, t) {
      for (var n = 0; n < e.length; n++) {
        var r = t(e[n]);
        if (r) return r;
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = e.exports = {};
    r.isIE = function (e) {
      return !!function isAnyIeVersion() {
        var e = navigator.userAgent.toLowerCase();
        return -1 !== e.indexOf("msie") || -1 !== e.indexOf("trident") || -1 !== e.indexOf(" edge/");
      }() && (!e || e === function () {
        var e = 3,
            t = document.createElement("div"),
            n = t.getElementsByTagName("i");

        do {
          t.innerHTML = "\x3c!--[if gt IE " + ++e + "]><i></i><![endif]--\x3e";
        } while (n[0]);

        return e > 4 ? e : void 0;
      }());
    }, r.isLegacyOpera = function () {
      return !!window.opera;
    };
  }, function (e, t, n) {
    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.exports = n;
    }).call(this, n(32));
  }, function (e, t, n) {
    var r = n(283),
        i = n(34);

    e.exports = function baseForOwn(e, t) {
      return e && r(e, t, i);
    };
  }, function (e, t, n) {
    var r = n(285),
        i = n(90),
        a = n(12),
        o = n(53),
        s = n(91),
        l = n(92),
        c = Object.prototype.hasOwnProperty;

    e.exports = function arrayLikeKeys(e, t) {
      var n = a(e),
          p = !n && i(e),
          d = !n && !p && o(e),
          h = !n && !p && !d && l(e),
          u = n || p || d || h,
          f = u ? r(e.length, String) : [],
          m = f.length;

      for (var g in e) {
        !t && !c.call(e, g) || u && ("length" == g || d && ("offset" == g || "parent" == g) || h && ("buffer" == g || "byteLength" == g || "byteOffset" == g) || s(g, m)) || f.push(g);
      }

      return f;
    };
  }, function (e, t, n) {
    var r = n(286),
        i = n(18),
        a = Object.prototype,
        o = a.hasOwnProperty,
        s = a.propertyIsEnumerable,
        l = r(function () {
      return arguments;
    }()) ? r : function (e) {
      return i(e) && o.call(e, "callee") && !s.call(e, "callee");
    };
    e.exports = l;
  }, function (e, t) {
    var n = 9007199254740991,
        r = /^(?:0|[1-9]\d*)$/;

    e.exports = function isIndex(e, t) {
      var i = typeof e;
      return !!(t = null == t ? n : t) && ("number" == i || "symbol" != i && r.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
  }, function (e, t, n) {
    var r = n(288),
        i = n(55),
        a = n(56),
        o = a && a.isTypedArray,
        s = o ? i(o) : r;
    e.exports = s;
  }, function (e, t) {
    e.exports = function overArg(e, t) {
      return function (n) {
        return e(t(n));
      };
    };
  }, function (e, t, n) {
    var r = n(22),
        i = n(28),
        a = "[object AsyncFunction]",
        o = "[object Function]",
        s = "[object GeneratorFunction]",
        l = "[object Proxy]";

    e.exports = function isFunction(e) {
      if (!i(e)) return !1;
      var t = r(e);
      return t == o || t == s || t == a || t == l;
    };
  }, function (e, t) {
    e.exports = function identity(e) {
      return e;
    };
  }, function (e, t) {
    e.exports = function arrayMap(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r;) {
        i[n] = t(e[n], n, e);
      }

      return i;
    };
  }, function (e, t) {
    var n = Function.prototype.toString;

    e.exports = function toSource(e) {
      if (null != e) {
        try {
          return n.call(e);
        } catch (t) {}

        try {
          return e + "";
        } catch (t) {}
      }

      return "";
    };
  }, function (e, t, n) {
    var r = n(323),
        i = n(18);

    e.exports = function baseIsEqual(e, t, n, a, o) {
      return e === t || (null == e || null == t || !i(e) && !i(t) ? e !== e && t !== t : r(e, t, n, a, baseIsEqual, o));
    };
  }, function (e, t, n) {
    var r = n(324),
        i = n(327),
        a = n(328),
        o = 1,
        s = 2;

    e.exports = function equalArrays(e, t, n, l, c, p) {
      var d = n & o,
          h = e.length,
          u = t.length;
      if (h != u && !(d && u > h)) return !1;
      var f = p.get(e);
      if (f && p.get(t)) return f == t;
      var m = -1,
          g = !0,
          v = n & s ? new r() : void 0;

      for (p.set(e, t), p.set(t, e); ++m < h;) {
        var b = e[m],
            y = t[m];
        if (l) var x = d ? l(y, b, m, t, e, p) : l(b, y, m, e, t, p);

        if (void 0 !== x) {
          if (x) continue;
          g = !1;
          break;
        }

        if (v) {
          if (!i(t, function (e, t) {
            if (!a(v, t) && (b === e || c(b, e, n, l, p))) return v.push(t);
          })) {
            g = !1;
            break;
          }
        } else if (b !== y && !c(b, y, n, l, p)) {
          g = !1;
          break;
        }
      }

      return p.delete(e), p.delete(t), g;
    };
  }, function (e, t, n) {
    var r = n(17).Uint8Array;
    e.exports = r;
  }, function (e, t, n) {
    var r = n(102),
        i = n(63),
        a = n(34);

    e.exports = function getAllKeys(e) {
      return r(e, a, i);
    };
  }, function (e, t, n) {
    var r = n(103),
        i = n(12);

    e.exports = function baseGetAllKeys(e, t, n) {
      var a = t(e);
      return i(e) ? a : r(a, n(e));
    };
  }, function (e, t) {
    e.exports = function arrayPush(e, t) {
      for (var n = -1, r = t.length, i = e.length; ++n < r;) {
        e[i + n] = t[n];
      }

      return e;
    };
  }, function (e, t) {
    e.exports = function stubArray() {
      return [];
    };
  }, function (e, t, n) {
    var r = n(28);

    e.exports = function isStrictComparable(e) {
      return e === e && !r(e);
    };
  }, function (e, t) {
    e.exports = function matchesStrictComparable(e, t) {
      return function (n) {
        return null != n && n[e] === t && (void 0 !== t || e in Object(n));
      };
    };
  }, function (e, t, n) {
    var r = n(108),
        i = n(42);

    e.exports = function baseGet(e, t) {
      for (var n = 0, a = (t = r(t, e)).length; null != e && n < a;) {
        e = e[i(t[n++])];
      }

      return n && n == a ? e : void 0;
    };
  }, function (e, t, n) {
    var r = n(12),
        i = n(64),
        a = n(341),
        o = n(344);

    e.exports = function castPath(e, t) {
      return r(e) ? e : i(e, t) ? [e] : a(o(e));
    };
  }, function (e, t, n) {
    var r = n(110),
        i = n(60),
        a = Object.prototype.hasOwnProperty;

    e.exports = function assignValue(e, t, n) {
      var o = e[t];
      a.call(e, t) && i(o, n) && (void 0 !== n || t in e) || r(e, t, n);
    };
  }, function (e, t, n) {
    var r = n(359);

    e.exports = function baseAssignValue(e, t, n) {
      "__proto__" == t && r ? r(e, t, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : e[t] = n;
    };
  }, function (e, t, n) {
    var r = n(89),
        i = n(362),
        a = n(36);

    e.exports = function keysIn(e) {
      return a(e) ? r(e, !0) : i(e);
    };
  }, function (e, t, n) {
    var r = n(103),
        i = n(58),
        a = n(63),
        o = n(104),
        s = Object.getOwnPropertySymbols ? function (e) {
      for (var t = []; e;) {
        r(t, a(e)), e = i(e);
      }

      return t;
    } : o;
    e.exports = s;
  }, function (e, t, n) {
    (function (t) {
      var n = "object" == typeof t && t && t.Object === Object && t;
      e.exports = n;
    }).call(this, n(32));
  }, function (e, t) {
    var n = Function.prototype.toString;

    e.exports = function toSource(e) {
      if (null != e) {
        try {
          return n.call(e);
        } catch (t) {}

        try {
          return e + "";
        } catch (t) {}
      }

      return "";
    };
  }, function (e, t, n) {
    var r = n(72),
        i = n(35);

    e.exports = function assignMergeValue(e, t, n) {
      (void 0 === n || i(e[t], n)) && (void 0 !== n || t in e) || r(e, t, n);
    };
  }, function (e, t, n) {
    var r = n(24),
        i = function () {
      try {
        var e = r(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (t) {}
    }();

    e.exports = i;
  }, function (e, t, n) {
    var r = n(423)();
    e.exports = r;
  }, function (e, t, n) {
    var r = n(13).Uint8Array;
    e.exports = r;
  }, function (e, t, n) {
    var r = n(120)(Object.getPrototypeOf, Object);
    e.exports = r;
  }, function (e, t) {
    e.exports = function overArg(e, t) {
      return function (n) {
        return e(t(n));
      };
    };
  }, function (e, t) {
    e.exports = function safeGet(e, t) {
      if (("constructor" !== t || "function" !== typeof e[t]) && "__proto__" != t) return e[t];
    };
  }, function (e, t, n) {
    var r = n(123),
        i = n(442),
        a = n(30);

    e.exports = function keysIn(e) {
      return a(e) ? r(e, !0) : i(e);
    };
  }, function (e, t, n) {
    var r = n(441),
        i = n(74),
        a = n(15),
        o = n(76),
        s = n(78),
        l = n(77),
        c = Object.prototype.hasOwnProperty;

    e.exports = function arrayLikeKeys(e, t) {
      var n = a(e),
          p = !n && i(e),
          d = !n && !p && o(e),
          h = !n && !p && !d && l(e),
          u = n || p || d || h,
          f = u ? r(e.length, String) : [],
          m = f.length;

      for (var g in e) {
        !t && !c.call(e, g) || u && ("length" == g || d && ("offset" == g || "parent" == g) || h && ("buffer" == g || "byteLength" == g || "byteOffset" == g) || s(g, m)) || f.push(g);
      }

      return f;
    };
  }, function (e, t, n) {
    var r = n(14),
        i = n(455),
        a = n(456),
        o = "Expected a function",
        s = Math.max,
        l = Math.min;

    e.exports = function debounce(e, t, n) {
      var c,
          p,
          d,
          h,
          u,
          f,
          m = 0,
          g = !1,
          v = !1,
          b = !0;
      if ("function" != typeof e) throw new TypeError(o);

      function invokeFunc(t) {
        var n = c,
            r = p;
        return c = p = void 0, m = t, h = e.apply(r, n);
      }

      function shouldInvoke(e) {
        var n = e - f;
        return void 0 === f || n >= t || n < 0 || v && e - m >= d;
      }

      function timerExpired() {
        var e = i();
        if (shouldInvoke(e)) return trailingEdge(e);
        u = setTimeout(timerExpired, function remainingWait(e) {
          var n = t - (e - f);
          return v ? l(n, d - (e - m)) : n;
        }(e));
      }

      function trailingEdge(e) {
        return u = void 0, b && c ? invokeFunc(e) : (c = p = void 0, h);
      }

      function debounced() {
        var e = i(),
            n = shouldInvoke(e);

        if (c = arguments, p = this, f = e, n) {
          if (void 0 === u) return function leadingEdge(e) {
            return m = e, u = setTimeout(timerExpired, t), g ? invokeFunc(e) : h;
          }(f);
          if (v) return clearTimeout(u), u = setTimeout(timerExpired, t), invokeFunc(f);
        }

        return void 0 === u && (u = setTimeout(timerExpired, t)), h;
      }

      return t = a(t) || 0, r(n) && (g = !!n.leading, d = (v = "maxWait" in n) ? s(a(n.maxWait) || 0, t) : d, b = "trailing" in n ? !!n.trailing : b), debounced.cancel = function cancel() {
        void 0 !== u && clearTimeout(u), m = 0, c = f = p = u = void 0;
      }, debounced.flush = function flush() {
        return void 0 === u ? h : trailingEdge(i());
      }, debounced;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ColorWrap = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        a = n(0),
        o = _interopRequireDefault(a),
        s = _interopRequireDefault(n(124)),
        l = _interopRequireDefault(n(16));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var c = t.ColorWrap = function ColorWrap(e) {
      var t = function (t) {
        function ColorPicker(e) {
          !function _classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, ColorPicker);

          var t = function _possibleConstructorReturn(e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
          }(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

          return t.handleChange = function (e, n) {
            if (l.default.simpleCheckForValidColor(e)) {
              var r = l.default.toState(e, e.h || t.state.oldHue);
              t.setState(r), t.props.onChangeComplete && t.debounce(t.props.onChangeComplete, r, n), t.props.onChange && t.props.onChange(r, n);
            }
          }, t.handleSwatchHover = function (e, n) {
            if (l.default.simpleCheckForValidColor(e)) {
              var r = l.default.toState(e, e.h || t.state.oldHue);
              t.props.onSwatchHover && t.props.onSwatchHover(r, n);
            }
          }, t.state = r({}, l.default.toState(e.color, 0)), t.debounce = (0, s.default)(function (e, t, n) {
            e(t, n);
          }, 100), t;
        }

        return function _inherits(e, t) {
          if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(ColorPicker, a.PureComponent || a.Component), i(ColorPicker, [{
          key: "componentWillReceiveProps",
          value: function componentWillReceiveProps(e) {
            this.setState(r({}, l.default.toState(e.color, this.state.oldHue)));
          }
        }, {
          key: "render",
          value: function render() {
            var t = {};
            return this.props.onSwatchHover && (t.onSwatchHover = this.handleSwatchHover), o.default.createElement(e, r({}, this.props, this.state, {
              onChange: this.handleChange
            }, t));
          }
        }]), ColorPicker;
      }();

      return t.propTypes = r({}, e.propTypes), t.defaultProps = r({}, e.defaultProps, {
        color: {
          h: 250,
          s: .5,
          l: .2,
          a: 1
        }
      }), t;
    };

    t.default = c;
  }, function (e, t, n) {
    var r = n(461),
        i = n(464)(r);
    e.exports = i;
  }, function (e, t) {
    e.exports = function arrayMap(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, i = Array(r); ++n < r;) {
        i[n] = t(e[n], n, e);
      }

      return i;
    };
  }, function (e, t, n) {
    var r = n(475),
        i = n(25);

    e.exports = function baseIsEqual(e, t, n, a, o) {
      return e === t || (null == e || null == t || !i(e) && !i(t) ? e !== e && t !== t : r(e, t, n, a, baseIsEqual, o));
    };
  }, function (e, t, n) {
    var r = n(476),
        i = n(479),
        a = n(480),
        o = 1,
        s = 2;

    e.exports = function equalArrays(e, t, n, l, c, p) {
      var d = n & o,
          h = e.length,
          u = t.length;
      if (h != u && !(d && u > h)) return !1;
      var f = p.get(e);
      if (f && p.get(t)) return f == t;
      var m = -1,
          g = !0,
          v = n & s ? new r() : void 0;

      for (p.set(e, t), p.set(t, e); ++m < h;) {
        var b = e[m],
            y = t[m];
        if (l) var x = d ? l(y, b, m, t, e, p) : l(b, y, m, e, t, p);

        if (void 0 !== x) {
          if (x) continue;
          g = !1;
          break;
        }

        if (v) {
          if (!i(t, function (e, t) {
            if (!a(v, t) && (b === e || c(b, e, n, l, p))) return v.push(t);
          })) {
            g = !1;
            break;
          }
        } else if (b !== y && !c(b, y, n, l, p)) {
          g = !1;
          break;
        }
      }

      return p.delete(e), p.delete(t), g;
    };
  }, function (e, t, n) {
    var r = n(14);

    e.exports = function isStrictComparable(e) {
      return e === e && !r(e);
    };
  }, function (e, t) {
    e.exports = function matchesStrictComparable(e, t) {
      return function (n) {
        return null != n && n[e] === t && (void 0 !== t || e in Object(n));
      };
    };
  }, function (e, t, n) {
    var r = n(133),
        i = n(51);

    e.exports = function baseGet(e, t) {
      for (var n = 0, a = (t = r(t, e)).length; null != e && n < a;) {
        e = e[i(t[n++])];
      }

      return n && n == a ? e : void 0;
    };
  }, function (e, t, n) {
    var r = n(15),
        i = n(80),
        a = n(499),
        o = n(502);

    e.exports = function castPath(e, t) {
      return r(e) ? e : i(e, t) ? [e] : a(o(e));
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t), n.d(t, "red", function () {
      return r;
    }), n.d(t, "pink", function () {
      return i;
    }), n.d(t, "purple", function () {
      return a;
    }), n.d(t, "deepPurple", function () {
      return o;
    }), n.d(t, "indigo", function () {
      return s;
    }), n.d(t, "blue", function () {
      return l;
    }), n.d(t, "lightBlue", function () {
      return c;
    }), n.d(t, "cyan", function () {
      return p;
    }), n.d(t, "teal", function () {
      return d;
    }), n.d(t, "green", function () {
      return h;
    }), n.d(t, "lightGreen", function () {
      return u;
    }), n.d(t, "lime", function () {
      return f;
    }), n.d(t, "yellow", function () {
      return m;
    }), n.d(t, "amber", function () {
      return g;
    }), n.d(t, "orange", function () {
      return v;
    }), n.d(t, "deepOrange", function () {
      return b;
    }), n.d(t, "brown", function () {
      return y;
    }), n.d(t, "grey", function () {
      return x;
    }), n.d(t, "blueGrey", function () {
      return w;
    }), n.d(t, "darkText", function () {
      return E;
    }), n.d(t, "lightText", function () {
      return C;
    }), n.d(t, "darkIcons", function () {
      return k;
    }), n.d(t, "lightIcons", function () {
      return S;
    }), n.d(t, "white", function () {
      return _;
    }), n.d(t, "black", function () {
      return M;
    });
    var r = {
      50: "#ffebee",
      100: "#ffcdd2",
      200: "#ef9a9a",
      300: "#e57373",
      400: "#ef5350",
      500: "#f44336",
      600: "#e53935",
      700: "#d32f2f",
      800: "#c62828",
      900: "#b71c1c",
      a100: "#ff8a80",
      a200: "#ff5252",
      a400: "#ff1744",
      a700: "#d50000"
    },
        i = {
      50: "#fce4ec",
      100: "#f8bbd0",
      200: "#f48fb1",
      300: "#f06292",
      400: "#ec407a",
      500: "#e91e63",
      600: "#d81b60",
      700: "#c2185b",
      800: "#ad1457",
      900: "#880e4f",
      a100: "#ff80ab",
      a200: "#ff4081",
      a400: "#f50057",
      a700: "#c51162"
    },
        a = {
      50: "#f3e5f5",
      100: "#e1bee7",
      200: "#ce93d8",
      300: "#ba68c8",
      400: "#ab47bc",
      500: "#9c27b0",
      600: "#8e24aa",
      700: "#7b1fa2",
      800: "#6a1b9a",
      900: "#4a148c",
      a100: "#ea80fc",
      a200: "#e040fb",
      a400: "#d500f9",
      a700: "#aa00ff"
    },
        o = {
      50: "#ede7f6",
      100: "#d1c4e9",
      200: "#b39ddb",
      300: "#9575cd",
      400: "#7e57c2",
      500: "#673ab7",
      600: "#5e35b1",
      700: "#512da8",
      800: "#4527a0",
      900: "#311b92",
      a100: "#b388ff",
      a200: "#7c4dff",
      a400: "#651fff",
      a700: "#6200ea"
    },
        s = {
      50: "#e8eaf6",
      100: "#c5cae9",
      200: "#9fa8da",
      300: "#7986cb",
      400: "#5c6bc0",
      500: "#3f51b5",
      600: "#3949ab",
      700: "#303f9f",
      800: "#283593",
      900: "#1a237e",
      a100: "#8c9eff",
      a200: "#536dfe",
      a400: "#3d5afe",
      a700: "#304ffe"
    },
        l = {
      50: "#e3f2fd",
      100: "#bbdefb",
      200: "#90caf9",
      300: "#64b5f6",
      400: "#42a5f5",
      500: "#2196f3",
      600: "#1e88e5",
      700: "#1976d2",
      800: "#1565c0",
      900: "#0d47a1",
      a100: "#82b1ff",
      a200: "#448aff",
      a400: "#2979ff",
      a700: "#2962ff"
    },
        c = {
      50: "#e1f5fe",
      100: "#b3e5fc",
      200: "#81d4fa",
      300: "#4fc3f7",
      400: "#29b6f6",
      500: "#03a9f4",
      600: "#039be5",
      700: "#0288d1",
      800: "#0277bd",
      900: "#01579b",
      a100: "#80d8ff",
      a200: "#40c4ff",
      a400: "#00b0ff",
      a700: "#0091ea"
    },
        p = {
      50: "#e0f7fa",
      100: "#b2ebf2",
      200: "#80deea",
      300: "#4dd0e1",
      400: "#26c6da",
      500: "#00bcd4",
      600: "#00acc1",
      700: "#0097a7",
      800: "#00838f",
      900: "#006064",
      a100: "#84ffff",
      a200: "#18ffff",
      a400: "#00e5ff",
      a700: "#00b8d4"
    },
        d = {
      50: "#e0f2f1",
      100: "#b2dfdb",
      200: "#80cbc4",
      300: "#4db6ac",
      400: "#26a69a",
      500: "#009688",
      600: "#00897b",
      700: "#00796b",
      800: "#00695c",
      900: "#004d40",
      a100: "#a7ffeb",
      a200: "#64ffda",
      a400: "#1de9b6",
      a700: "#00bfa5"
    },
        h = {
      50: "#e8f5e9",
      100: "#c8e6c9",
      200: "#a5d6a7",
      300: "#81c784",
      400: "#66bb6a",
      500: "#4caf50",
      600: "#43a047",
      700: "#388e3c",
      800: "#2e7d32",
      900: "#1b5e20",
      a100: "#b9f6ca",
      a200: "#69f0ae",
      a400: "#00e676",
      a700: "#00c853"
    },
        u = {
      50: "#f1f8e9",
      100: "#dcedc8",
      200: "#c5e1a5",
      300: "#aed581",
      400: "#9ccc65",
      500: "#8bc34a",
      600: "#7cb342",
      700: "#689f38",
      800: "#558b2f",
      900: "#33691e",
      a100: "#ccff90",
      a200: "#b2ff59",
      a400: "#76ff03",
      a700: "#64dd17"
    },
        f = {
      50: "#f9fbe7",
      100: "#f0f4c3",
      200: "#e6ee9c",
      300: "#dce775",
      400: "#d4e157",
      500: "#cddc39",
      600: "#c0ca33",
      700: "#afb42b",
      800: "#9e9d24",
      900: "#827717",
      a100: "#f4ff81",
      a200: "#eeff41",
      a400: "#c6ff00",
      a700: "#aeea00"
    },
        m = {
      50: "#fffde7",
      100: "#fff9c4",
      200: "#fff59d",
      300: "#fff176",
      400: "#ffee58",
      500: "#ffeb3b",
      600: "#fdd835",
      700: "#fbc02d",
      800: "#f9a825",
      900: "#f57f17",
      a100: "#ffff8d",
      a200: "#ffff00",
      a400: "#ffea00",
      a700: "#ffd600"
    },
        g = {
      50: "#fff8e1",
      100: "#ffecb3",
      200: "#ffe082",
      300: "#ffd54f",
      400: "#ffca28",
      500: "#ffc107",
      600: "#ffb300",
      700: "#ffa000",
      800: "#ff8f00",
      900: "#ff6f00",
      a100: "#ffe57f",
      a200: "#ffd740",
      a400: "#ffc400",
      a700: "#ffab00"
    },
        v = {
      50: "#fff3e0",
      100: "#ffe0b2",
      200: "#ffcc80",
      300: "#ffb74d",
      400: "#ffa726",
      500: "#ff9800",
      600: "#fb8c00",
      700: "#f57c00",
      800: "#ef6c00",
      900: "#e65100",
      a100: "#ffd180",
      a200: "#ffab40",
      a400: "#ff9100",
      a700: "#ff6d00"
    },
        b = {
      50: "#fbe9e7",
      100: "#ffccbc",
      200: "#ffab91",
      300: "#ff8a65",
      400: "#ff7043",
      500: "#ff5722",
      600: "#f4511e",
      700: "#e64a19",
      800: "#d84315",
      900: "#bf360c",
      a100: "#ff9e80",
      a200: "#ff6e40",
      a400: "#ff3d00",
      a700: "#dd2c00"
    },
        y = {
      50: "#efebe9",
      100: "#d7ccc8",
      200: "#bcaaa4",
      300: "#a1887f",
      400: "#8d6e63",
      500: "#795548",
      600: "#6d4c41",
      700: "#5d4037",
      800: "#4e342e",
      900: "#3e2723"
    },
        x = {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#eeeeee",
      300: "#e0e0e0",
      400: "#bdbdbd",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121"
    },
        w = {
      50: "#eceff1",
      100: "#cfd8dc",
      200: "#b0bec5",
      300: "#90a4ae",
      400: "#78909c",
      500: "#607d8b",
      600: "#546e7a",
      700: "#455a64",
      800: "#37474f",
      900: "#263238"
    },
        E = {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)",
      dividers: "rgba(0, 0, 0, 0.12)"
    },
        C = {
      primary: "rgba(255, 255, 255, 1)",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      dividers: "rgba(255, 255, 255, 0.12)"
    },
        k = {
      active: "rgba(0, 0, 0, 0.54)",
      inactive: "rgba(0, 0, 0, 0.38)"
    },
        S = {
      active: "rgba(255, 255, 255, 1)",
      inactive: "rgba(255, 255, 255, 0.5)"
    },
        _ = "#ffffff",
        M = "#000000";
    t.default = {
      red: r,
      pink: i,
      purple: a,
      deepPurple: o,
      indigo: s,
      blue: l,
      lightBlue: c,
      cyan: p,
      teal: d,
      green: h,
      lightGreen: u,
      lime: f,
      yellow: m,
      amber: g,
      orange: v,
      deepOrange: b,
      brown: y,
      grey: x,
      blueGrey: w,
      darkText: E,
      lightText: C,
      darkIcons: k,
      lightIcons: S,
      white: _,
      black: M
    };
  }, function (e, t) {
    e.exports = function _objectWithoutPropertiesLoose(e, t) {
      if (null == e) return {};
      var n,
          r,
          i = {},
          a = Object.keys(e);

      for (r = 0; r < a.length; r++) {
        n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
      }

      return i;
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(152));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    t.default = r.default.createContext || i.default, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r = function warning() {};

    e.exports = r;
  }, function (module, exports, __webpack_require__) {
    var __WEBPACK_AMD_DEFINE_RESULT__, root, factory;

    root = window || {}, factory = function factory(window) {
      var svgNS = "http://www.w3.org/2000/svg",
          locationHref = "",
          subframeEnabled = !0,
          expressionsPlugin,
          isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
          cachedColors = {},
          bm_rounder = Math.round,
          bm_rnd,
          bm_pow = Math.pow,
          bm_sqrt = Math.sqrt,
          bm_abs = Math.abs,
          bm_floor = Math.floor,
          bm_max = Math.max,
          bm_min = Math.min,
          blitter = 10,
          BMMath = {};

      function ProjectInterface() {
        return {};
      }

      !function () {
        var e,
            t = Object.getOwnPropertyNames(Math),
            n = t.length;

        for (e = 0; e < n; e += 1) {
          BMMath[t[e]] = Math[t[e]];
        }
      }(), BMMath.random = Math.random, BMMath.abs = function (e) {
        if ("object" === typeof e && e.length) {
          var t,
              n = Array.apply(null, {
            length: e.length
          }),
              r = e.length;

          for (t = 0; t < r; t += 1) {
            n[t] = Math.abs(e[t]);
          }

          return n;
        }

        return Math.abs(e);
      };
      var defaultCurveSegments = 150,
          degToRads = Math.PI / 180,
          roundCorner = .5519;

      function roundValues(e) {
        bm_rnd = e ? Math.round : function bm_rnd(e) {
          return e;
        };
      }

      function roundTo2Decimals(e) {
        return Math.round(1e4 * e) / 1e4;
      }

      function roundTo3Decimals(e) {
        return Math.round(100 * e) / 100;
      }

      function styleDiv(e) {
        e.style.position = "absolute", e.style.top = 0, e.style.left = 0, e.style.display = "block", e.style.transformOrigin = e.style.webkitTransformOrigin = "0 0", e.style.backfaceVisibility = e.style.webkitBackfaceVisibility = "visible", e.style.transformStyle = e.style.webkitTransformStyle = e.style.mozTransformStyle = "preserve-3d";
      }

      function styleUnselectableDiv(e) {
        e.style.userSelect = "none", e.style.MozUserSelect = "none", e.style.webkitUserSelect = "none", e.style.oUserSelect = "none";
      }

      function BMEnterFrameEvent(e, t, n, r) {
        this.type = e, this.currentTime = t, this.totalTime = n, this.direction = r < 0 ? -1 : 1;
      }

      function BMCompleteEvent(e, t) {
        this.type = e, this.direction = t < 0 ? -1 : 1;
      }

      function BMCompleteLoopEvent(e, t, n, r) {
        this.type = e, this.currentLoop = t, this.totalLoops = n, this.direction = r < 0 ? -1 : 1;
      }

      function BMSegmentStartEvent(e, t, n) {
        this.type = e, this.firstFrame = t, this.totalFrames = n;
      }

      function BMDestroyEvent(e, t) {
        this.type = e, this.target = t;
      }

      function _addEventListener(e, t) {
        return this._cbs[e] || (this._cbs[e] = []), this._cbs[e].push(t), function () {
          this.removeEventListener(e, t);
        }.bind(this);
      }

      function _removeEventListener(e, t) {
        if (t) {
          if (this._cbs[e]) {
            for (var n = 0, r = this._cbs[e].length; n < r;) {
              this._cbs[e][n] === t && (this._cbs[e].splice(n, 1), n -= 1, r -= 1), n += 1;
            }

            this._cbs[e].length || (this._cbs[e] = null);
          }
        } else this._cbs[e] = null;
      }

      function _triggerEvent(e, t) {
        if (this._cbs[e]) for (var n = this._cbs[e].length, r = 0; r < n; r++) {
          this._cbs[e][r](t);
        }
      }

      function randomString(e, t) {
        var n;
        void 0 === t && (t = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890");
        var r = "";

        for (n = e; n > 0; --n) {
          r += t[Math.round(Math.random() * (t.length - 1))];
        }

        return r;
      }

      function HSVtoRGB(e, t, n) {
        var r, i, a, o, s, l, c, p;

        switch (1 === arguments.length && (t = e.s, n = e.v, e = e.h), l = n * (1 - t), c = n * (1 - (s = 6 * e - (o = Math.floor(6 * e))) * t), p = n * (1 - (1 - s) * t), o % 6) {
          case 0:
            r = n, i = p, a = l;
            break;

          case 1:
            r = c, i = n, a = l;
            break;

          case 2:
            r = l, i = n, a = p;
            break;

          case 3:
            r = l, i = c, a = n;
            break;

          case 4:
            r = p, i = l, a = n;
            break;

          case 5:
            r = n, i = l, a = c;
        }

        return [r, i, a];
      }

      function RGBtoHSV(e, t, n) {
        1 === arguments.length && (t = e.g, n = e.b, e = e.r);
        var r,
            i = Math.max(e, t, n),
            a = Math.min(e, t, n),
            o = i - a,
            s = 0 === i ? 0 : o / i,
            l = i / 255;

        switch (i) {
          case a:
            r = 0;
            break;

          case e:
            r = t - n + o * (t < n ? 6 : 0), r /= 6 * o;
            break;

          case t:
            r = n - e + 2 * o, r /= 6 * o;
            break;

          case n:
            r = e - t + 4 * o, r /= 6 * o;
        }

        return [r, s, l];
      }

      function addSaturationToRGB(e, t) {
        var n = RGBtoHSV(255 * e[0], 255 * e[1], 255 * e[2]);
        return n[1] += t, n[1] > 1 ? n[1] = 1 : n[1] <= 0 && (n[1] = 0), HSVtoRGB(n[0], n[1], n[2]);
      }

      function addBrightnessToRGB(e, t) {
        var n = RGBtoHSV(255 * e[0], 255 * e[1], 255 * e[2]);
        return n[2] += t, n[2] > 1 ? n[2] = 1 : n[2] < 0 && (n[2] = 0), HSVtoRGB(n[0], n[1], n[2]);
      }

      function addHueToRGB(e, t) {
        var n = RGBtoHSV(255 * e[0], 255 * e[1], 255 * e[2]);
        return n[0] += t / 360, n[0] > 1 ? n[0] -= 1 : n[0] < 0 && (n[0] += 1), HSVtoRGB(n[0], n[1], n[2]);
      }

      function componentToHex(e) {
        var t = e.toString(16);
        return 1 == t.length ? "0" + t : t;
      }

      roundValues(!1);

      var rgbToHex = function () {
        var e,
            t,
            n = [];

        for (e = 0; e < 256; e += 1) {
          t = e.toString(16), n[e] = 1 == t.length ? "0" + t : t;
        }

        return function (e, t, r) {
          return e < 0 && (e = 0), t < 0 && (t = 0), r < 0 && (r = 0), "#" + n[e] + n[t] + n[r];
        };
      }();

      function fillToRgba(e, t) {
        if (!cachedColors[e]) {
          var n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
          cachedColors[e] = parseInt(n[1], 16) + "," + parseInt(n[2], 16) + "," + parseInt(n[3], 16);
        }

        return "rgba(" + cachedColors[e] + "," + t + ")";
      }

      var fillColorToString = function () {
        var e = [];
        return function (t, n) {
          return void 0 !== n && (t[3] = n), e[t[0]] || (e[t[0]] = {}), e[t[0]][t[1]] || (e[t[0]][t[1]] = {}), e[t[0]][t[1]][t[2]] || (e[t[0]][t[1]][t[2]] = {}), e[t[0]][t[1]][t[2]][t[3]] || (e[t[0]][t[1]][t[2]][t[3]] = "rgba(" + t.join(",") + ")"), e[t[0]][t[1]][t[2]][t[3]];
        };
      }();

      function RenderedFrame(e, t) {
        this.tr = e, this.o = t;
      }

      function iterateDynamicProperties(e) {
        var t,
            n = this.dynamicProperties;

        for (t = 0; t < n; t += 1) {
          this.dynamicProperties[t].getValue(e);
        }
      }

      function reversePath(e) {
        var t,
            n,
            r = [],
            i = [],
            a = [],
            o = {},
            s = 0;
        e.c && (r[0] = e.o[0], i[0] = e.i[0], a[0] = e.v[0], s = 1);
        var l = (n = e.i.length) - 1;

        for (t = s; t < n; t += 1) {
          r.push(e.o[l]), i.push(e.i[l]), a.push(e.v[l]), l -= 1;
        }

        return o.i = r, o.o = i, o.v = a, o;
      }

      var Matrix = function () {
        function reset() {
          return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
        }

        function rotate(e) {
          if (0 === e) return this;
          var t = Math.cos(e),
              n = Math.sin(e);
          return this._t(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        function rotateX(e) {
          if (0 === e) return this;
          var t = Math.cos(e),
              n = Math.sin(e);
          return this._t(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1);
        }

        function rotateY(e) {
          if (0 === e) return this;
          var t = Math.cos(e),
              n = Math.sin(e);
          return this._t(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1);
        }

        function rotateZ(e) {
          if (0 === e) return this;
          var t = Math.cos(e),
              n = Math.sin(e);
          return this._t(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        function shear(e, t) {
          return this._t(1, t, e, 1, 0, 0);
        }

        function skew(e, t) {
          return this.shear(Math.tan(e), Math.tan(t));
        }

        function skewFromAxis(e, t) {
          var n = Math.cos(t),
              r = Math.sin(t);
          return this._t(n, r, 0, 0, -r, n, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, Math.tan(e), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(n, -r, 0, 0, r, n, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }

        function scale(e, t, n) {
          return n = isNaN(n) ? 1 : n, 1 == e && 1 == t && 1 == n ? this : this._t(e, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1);
        }

        function setTransform(e, t, n, r, i, a, o, s, l, c, p, d, h, u, f, m) {
          return this.props[0] = e, this.props[1] = t, this.props[2] = n, this.props[3] = r, this.props[4] = i, this.props[5] = a, this.props[6] = o, this.props[7] = s, this.props[8] = l, this.props[9] = c, this.props[10] = p, this.props[11] = d, this.props[12] = h, this.props[13] = u, this.props[14] = f, this.props[15] = m, this;
        }

        function translate(e, t, n) {
          return n = n || 0, 0 !== e || 0 !== t || 0 !== n ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, e, t, n, 1) : this;
        }

        function transform(e, t, n, r, i, a, o, s, l, c, p, d, h, u, f, m) {
          if (1 === e && 0 === t && 0 === n && 0 === r && 0 === i && 1 === a && 0 === o && 0 === s && 0 === l && 0 === c && 1 === p && 0 === d) return 0 === h && 0 === u && 0 === f || (this.props[12] = this.props[12] * e + this.props[13] * i + this.props[14] * l + this.props[15] * h, this.props[13] = this.props[12] * t + this.props[13] * a + this.props[14] * c + this.props[15] * u, this.props[14] = this.props[12] * n + this.props[13] * o + this.props[14] * p + this.props[15] * f, this.props[15] = this.props[12] * r + this.props[13] * s + this.props[14] * d + this.props[15] * m), this._identityCalculated = !1, this;
          var g = this.props[0],
              v = this.props[1],
              b = this.props[2],
              y = this.props[3],
              x = this.props[4],
              w = this.props[5],
              E = this.props[6],
              C = this.props[7],
              k = this.props[8],
              S = this.props[9],
              _ = this.props[10],
              M = this.props[11],
              L = this.props[12],
              P = this.props[13],
              F = this.props[14],
              A = this.props[15];
          return this.props[0] = g * e + v * i + b * l + y * h, this.props[1] = g * t + v * a + b * c + y * u, this.props[2] = g * n + v * o + b * p + y * f, this.props[3] = g * r + v * s + b * d + y * m, this.props[4] = x * e + w * i + E * l + C * h, this.props[5] = x * t + w * a + E * c + C * u, this.props[6] = x * n + w * o + E * p + C * f, this.props[7] = x * r + w * s + E * d + C * m, this.props[8] = k * e + S * i + _ * l + M * h, this.props[9] = k * t + S * a + _ * c + M * u, this.props[10] = k * n + S * o + _ * p + M * f, this.props[11] = k * r + S * s + _ * d + M * m, this.props[12] = L * e + P * i + F * l + A * h, this.props[13] = L * t + P * a + F * c + A * u, this.props[14] = L * n + P * o + F * p + A * f, this.props[15] = L * r + P * s + F * d + A * m, this._identityCalculated = !1, this;
        }

        function isIdentity() {
          return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
        }

        function clone(e) {
          var t;

          for (t = 0; t < 16; t += 1) {
            e.props[t] = this.props[t];
          }
        }

        function cloneFromProps(e) {
          var t;

          for (t = 0; t < 16; t += 1) {
            this.props[t] = e[t];
          }
        }

        function applyToPoint(e, t, n) {
          return {
            x: e * this.props[0] + t * this.props[4] + n * this.props[8] + this.props[12],
            y: e * this.props[1] + t * this.props[5] + n * this.props[9] + this.props[13],
            z: e * this.props[2] + t * this.props[6] + n * this.props[10] + this.props[14]
          };
        }

        function applyToX(e, t, n) {
          return e * this.props[0] + t * this.props[4] + n * this.props[8] + this.props[12];
        }

        function applyToY(e, t, n) {
          return e * this.props[1] + t * this.props[5] + n * this.props[9] + this.props[13];
        }

        function applyToZ(e, t, n) {
          return e * this.props[2] + t * this.props[6] + n * this.props[10] + this.props[14];
        }

        function inversePoint(e) {
          var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
              n = this.props[5] / t,
              r = -this.props[1] / t,
              i = -this.props[4] / t,
              a = this.props[0] / t,
              o = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t,
              s = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t;
          return [e[0] * n + e[1] * i + o, e[0] * r + e[1] * a + s, 0];
        }

        function inversePoints(e) {
          var t,
              n = e.length,
              r = [];

          for (t = 0; t < n; t += 1) {
            r[t] = inversePoint(e[t]);
          }

          return r;
        }

        function applyToPointArray(e, t, n, r) {
          if (r && 2 === r) {
            var i = point_pool.newPoint();
            return i[0] = e * this.props[0] + t * this.props[4] + n * this.props[8] + this.props[12], i[1] = e * this.props[1] + t * this.props[5] + n * this.props[9] + this.props[13], i;
          }

          return [e * this.props[0] + t * this.props[4] + n * this.props[8] + this.props[12], e * this.props[1] + t * this.props[5] + n * this.props[9] + this.props[13], e * this.props[2] + t * this.props[6] + n * this.props[10] + this.props[14]];
        }

        function applyToPointStringified(e, t) {
          return this.isIdentity() ? e + "," + t : bm_rnd(e * this.props[0] + t * this.props[4] + this.props[12]) + "," + bm_rnd(e * this.props[1] + t * this.props[5] + this.props[13]);
        }

        function toArray() {
          return [this.props[0], this.props[1], this.props[2], this.props[3], this.props[4], this.props[5], this.props[6], this.props[7], this.props[8], this.props[9], this.props[10], this.props[11], this.props[12], this.props[13], this.props[14], this.props[15]];
        }

        function toCSS() {
          return isSafari ? "matrix3d(" + roundTo2Decimals(this.props[0]) + "," + roundTo2Decimals(this.props[1]) + "," + roundTo2Decimals(this.props[2]) + "," + roundTo2Decimals(this.props[3]) + "," + roundTo2Decimals(this.props[4]) + "," + roundTo2Decimals(this.props[5]) + "," + roundTo2Decimals(this.props[6]) + "," + roundTo2Decimals(this.props[7]) + "," + roundTo2Decimals(this.props[8]) + "," + roundTo2Decimals(this.props[9]) + "," + roundTo2Decimals(this.props[10]) + "," + roundTo2Decimals(this.props[11]) + "," + roundTo2Decimals(this.props[12]) + "," + roundTo2Decimals(this.props[13]) + "," + roundTo2Decimals(this.props[14]) + "," + roundTo2Decimals(this.props[15]) + ")" : (this.cssParts[1] = this.props.join(","), this.cssParts.join(""));
        }

        function to2dCSS() {
          return "matrix(" + roundTo2Decimals(this.props[0]) + "," + roundTo2Decimals(this.props[1]) + "," + roundTo2Decimals(this.props[4]) + "," + roundTo2Decimals(this.props[5]) + "," + roundTo2Decimals(this.props[12]) + "," + roundTo2Decimals(this.props[13]) + ")";
        }

        function toString() {
          return "" + this.toArray();
        }

        return function () {
          this.reset = reset, this.rotate = rotate, this.rotateX = rotateX, this.rotateY = rotateY, this.rotateZ = rotateZ, this.skew = skew, this.skewFromAxis = skewFromAxis, this.shear = shear, this.scale = scale, this.setTransform = setTransform, this.translate = translate, this.transform = transform, this.applyToPoint = applyToPoint, this.applyToX = applyToX, this.applyToY = applyToY, this.applyToZ = applyToZ, this.applyToPointArray = applyToPointArray, this.applyToPointStringified = applyToPointStringified, this.toArray = toArray, this.toCSS = toCSS, this.to2dCSS = to2dCSS, this.toString = toString, this.clone = clone, this.cloneFromProps = cloneFromProps, this.inversePoints = inversePoints, this.inversePoint = inversePoint, this._t = this.transform, this.isIdentity = isIdentity, this._identity = !0, this._identityCalculated = !1, this.props = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], this.cssParts = ["matrix3d(", "", ")"];
        };
      }();

      function Matrix() {}

      !function (e, t) {
        var n,
            r = this,
            i = 256,
            a = 6,
            o = "random",
            s = t.pow(i, a),
            l = t.pow(2, 52),
            c = 2 * l,
            p = i - 1;

        function ARC4(e) {
          var t,
              n = e.length,
              r = this,
              a = 0,
              o = r.i = r.j = 0,
              s = r.S = [];

          for (n || (e = [n++]); a < i;) {
            s[a] = a++;
          }

          for (a = 0; a < i; a++) {
            s[a] = s[o = p & o + e[a % n] + (t = s[a])], s[o] = t;
          }

          (r.g = function (e) {
            for (var t, n = 0, a = r.i, o = r.j, s = r.S; e--;) {
              t = s[a = p & a + 1], n = n * i + s[p & (s[a] = s[o = p & o + t]) + (s[o] = t)];
            }

            return r.i = a, r.j = o, n;
          })(i);
        }

        function copy(e, t) {
          return t.i = e.i, t.j = e.j, t.S = e.S.slice(), t;
        }

        function mixkey(e, t) {
          for (var n, r = e + "", i = 0; i < r.length;) {
            t[p & i] = p & (n ^= 19 * t[p & i]) + r.charCodeAt(i++);
          }

          return tostring(t);
        }

        function tostring(e) {
          return String.fromCharCode.apply(0, e);
        }

        t["seed" + o] = function seedrandom(p, d, h) {
          var u = [],
              f = mixkey(function flatten(e, t) {
            var n,
                r = [],
                i = typeof e;
            if (t && "object" == i) for (n in e) {
              try {
                r.push(flatten(e[n], t - 1));
              } catch (a) {}
            }
            return r.length ? r : "string" == i ? e : e + "\0";
          }((d = 1 == d ? {
            entropy: !0
          } : d || {}).entropy ? [p, tostring(e)] : null == p ? function autoseed() {
            try {
              if (n) return tostring(n.randomBytes(i));
              var t = new Uint8Array(i);
              return (r.crypto || r.msCrypto).getRandomValues(t), tostring(t);
            } catch (s) {
              var a = r.navigator,
                  o = a && a.plugins;
              return [+new Date(), r, o, r.screen, tostring(e)];
            }
          }() : p, 3), u),
              m = new ARC4(u),
              g = function prng() {
            for (var e = m.g(a), t = s, n = 0; e < l;) {
              e = (e + n) * i, t *= i, n = m.g(1);
            }

            for (; e >= c;) {
              e /= 2, t /= 2, n >>>= 1;
            }

            return (e + n) / t;
          };

          return g.int32 = function () {
            return 0 | m.g(4);
          }, g.quick = function () {
            return m.g(4) / 4294967296;
          }, g.double = g, mixkey(tostring(m.S), e), (d.pass || h || function (e, n, r, i) {
            return i && (i.S && copy(i, m), e.state = function () {
              return copy(m, {});
            }), r ? (t[o] = e, n) : e;
          })(g, f, "global" in d ? d.global : this == t, d.state);
        }, mixkey(t.random(), e);
      }([], BMMath);

      var BezierFactory = function () {
        var e = {
          getBezierEasing: function getBezierEasing(e, n, r, i, a) {
            var o = a || ("bez_" + e + "_" + n + "_" + r + "_" + i).replace(/\./g, "p");
            if (t[o]) return t[o];
            var s = new BezierEasing([e, n, r, i]);
            return t[o] = s, s;
          }
        },
            t = {};
        var n = 4,
            r = 1e-7,
            i = 10,
            a = 11,
            o = 1 / (a - 1),
            s = "function" === typeof Float32Array;

        function A(e, t) {
          return 1 - 3 * t + 3 * e;
        }

        function B(e, t) {
          return 3 * t - 6 * e;
        }

        function C(e) {
          return 3 * e;
        }

        function calcBezier(e, t, n) {
          return ((A(t, n) * e + B(t, n)) * e + C(t)) * e;
        }

        function getSlope(e, t, n) {
          return 3 * A(t, n) * e * e + 2 * B(t, n) * e + C(t);
        }

        function BezierEasing(e) {
          this._p = e, this._mSampleValues = s ? new Float32Array(a) : new Array(a), this._precomputed = !1, this.get = this.get.bind(this);
        }

        return BezierEasing.prototype = {
          get: function get(e) {
            var t = this._p[0],
                n = this._p[1],
                r = this._p[2],
                i = this._p[3];
            return this._precomputed || this._precompute(), t === n && r === i ? e : 0 === e ? 0 : 1 === e ? 1 : calcBezier(this._getTForX(e), n, i);
          },
          _precompute: function _precompute() {
            var e = this._p[0],
                t = this._p[1],
                n = this._p[2],
                r = this._p[3];
            this._precomputed = !0, e === t && n === r || this._calcSampleValues();
          },
          _calcSampleValues: function _calcSampleValues() {
            for (var e = this._p[0], t = this._p[2], n = 0; n < a; ++n) {
              this._mSampleValues[n] = calcBezier(n * o, e, t);
            }
          },
          _getTForX: function _getTForX(e) {
            for (var t = this._p[0], s = this._p[2], l = this._mSampleValues, c = 0, p = 1, d = a - 1; p !== d && l[p] <= e; ++p) {
              c += o;
            }

            var h = c + (e - l[--p]) / (l[p + 1] - l[p]) * o,
                u = getSlope(h, t, s);
            return u >= .001 ? function newtonRaphsonIterate(e, t, r, i) {
              for (var a = 0; a < n; ++a) {
                var o = getSlope(t, r, i);
                if (0 === o) return t;
                t -= (calcBezier(t, r, i) - e) / o;
              }

              return t;
            }(e, h, t, s) : 0 === u ? h : function binarySubdivide(e, t, n, a, o) {
              var s,
                  l,
                  c = 0;

              do {
                (s = calcBezier(l = t + (n - t) / 2, a, o) - e) > 0 ? n = l : t = l;
              } while (Math.abs(s) > r && ++c < i);

              return l;
            }(e, c, c + o, t, s);
          }
        }, e;
      }();

      function createElement(e, t, n) {
        if (!t) {
          var r = Object.create(e.prototype, n);
          return r && "[object Function]" === {}.toString.call(r.init) && r.init(), r;
        }

        t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.prototype._parent = e.prototype;
      }

      function extendPrototype(e, t) {
        for (var n in e.prototype) {
          e.prototype.hasOwnProperty(n) && (t.prototype[n] = e.prototype[n]);
        }
      }

      function bezFunction() {
        Math;

        function pointOnLine2D(e, t, n, r, i, a) {
          var o = e * r + t * i + n * a - i * r - a * e - n * t;
          return o > -1e-4 && o < 1e-4;
        }

        var e = function () {
          function Segment(e, t) {
            this.l = e, this.p = t;
          }

          return function (e, t, n, r) {
            var i,
                a,
                o,
                s,
                l,
                c,
                p = defaultCurveSegments,
                d = 0,
                h = [],
                u = [],
                f = {
              addedLength: 0,
              segments: []
            };

            for (o = n.length, i = 0; i < p; i += 1) {
              for (l = i / (p - 1), c = 0, a = 0; a < o; a += 1) {
                s = bm_pow(1 - l, 3) * e[a] + 3 * bm_pow(1 - l, 2) * l * n[a] + 3 * (1 - l) * bm_pow(l, 2) * r[a] + bm_pow(l, 3) * t[a], h[a] = s, null !== u[a] && (c += bm_pow(h[a] - u[a], 2)), u[a] = h[a];
              }

              c && (d += c = bm_sqrt(c)), f.segments.push(new Segment(d, l));
            }

            return f.addedLength = d, f;
          };
        }();

        function BezierData(e) {
          this.segmentLength = 0, this.points = new Array(e);
        }

        function PointData(e, t) {
          this.partialLength = e, this.point = t;
        }

        var t = function () {
          var e = {};
          return function (t) {
            var n = t.s,
                r = t.e,
                i = t.to,
                a = t.ti,
                o = (n.join("_") + "_" + r.join("_") + "_" + i.join("_") + "_" + a.join("_")).replace(/\./g, "p");
            if (e[o]) t.bezierData = e[o];else {
              var s,
                  l,
                  c,
                  p,
                  d,
                  h,
                  u,
                  f = defaultCurveSegments,
                  m = 0,
                  g = null;
              2 === n.length && (n[0] != r[0] || n[1] != r[1]) && pointOnLine2D(n[0], n[1], r[0], r[1], n[0] + i[0], n[1] + i[1]) && pointOnLine2D(n[0], n[1], r[0], r[1], r[0] + a[0], r[1] + a[1]) && (f = 2);
              var v = new BezierData(f);

              for (c = i.length, s = 0; s < f; s += 1) {
                for (u = new Array(c), d = s / (f - 1), h = 0, l = 0; l < c; l += 1) {
                  p = bm_pow(1 - d, 3) * n[l] + 3 * bm_pow(1 - d, 2) * d * (n[l] + i[l]) + 3 * (1 - d) * bm_pow(d, 2) * (r[l] + a[l]) + bm_pow(d, 3) * r[l], u[l] = p, null !== g && (h += bm_pow(u[l] - g[l], 2));
                }

                m += h = bm_sqrt(h), v.points[s] = new PointData(h, u), g = u;
              }

              v.segmentLength = m, t.bezierData = v, e[o] = v;
            }
          };
        }();

        function getDistancePerc(e, t) {
          var n = t.segments,
              r = n.length,
              i = bm_floor((r - 1) * e),
              a = e * t.addedLength,
              o = 0;
          if (a == n[i].l) return n[i].p;

          for (var s = n[i].l > a ? -1 : 1, l = !0; l;) {
            n[i].l <= a && n[i + 1].l > a ? (o = (a - n[i].l) / (n[i + 1].l - n[i].l), l = !1) : i += s, (i < 0 || i >= r - 1) && (l = !1);
          }

          return n[i].p + (n[i + 1].p - n[i].p) * o;
        }

        function SegmentPoints() {
          this.pt1 = new Array(2), this.pt2 = new Array(2), this.pt3 = new Array(2), this.pt4 = new Array(2);
        }

        return {
          getBezierLength: e,
          getSegmentsLength: function getSegmentsLength(t) {
            var n,
                r = t.c,
                i = t.v,
                a = t.o,
                o = t.i,
                s = t._length,
                l = [],
                c = 0;

            for (n = 0; n < s - 1; n += 1) {
              l[n] = e(i[n], i[n + 1], a[n], o[n + 1]), c += l[n].addedLength;
            }

            return r && (l[n] = e(i[n], i[0], a[n], o[0]), c += l[n].addedLength), {
              lengths: l,
              totalLength: c
            };
          },
          getNewSegment: function getNewSegment(e, t, n, r, i, a, o) {
            var s,
                l = new SegmentPoints(),
                c = getDistancePerc(i = i < 0 ? 0 : i > 1 ? 1 : i, o),
                p = getDistancePerc(a = a > 1 ? 1 : a, o),
                d = e.length,
                h = 1 - c,
                u = 1 - p;

            for (s = 0; s < d; s += 1) {
              l.pt1[s] = Math.round(1e3 * (h * h * h * e[s] + (c * h * h + h * c * h + h * h * c) * n[s] + (c * c * h + h * c * c + c * h * c) * r[s] + c * c * c * t[s])) / 1e3, l.pt3[s] = Math.round(1e3 * (h * h * u * e[s] + (c * h * u + h * c * u + h * h * p) * n[s] + (c * c * u + h * c * p + c * h * p) * r[s] + c * c * p * t[s])) / 1e3, l.pt4[s] = Math.round(1e3 * (h * u * u * e[s] + (c * u * u + h * p * u + h * u * p) * n[s] + (c * p * u + h * p * p + c * u * p) * r[s] + c * p * p * t[s])) / 1e3, l.pt2[s] = Math.round(1e3 * (u * u * u * e[s] + (p * u * u + u * p * u + u * u * p) * n[s] + (p * p * u + u * p * p + p * u * p) * r[s] + p * p * p * t[s])) / 1e3;
            }

            return l;
          },
          getPointInSegment: function getPointInSegment(e, t, n, r, i, a) {
            var o = getDistancePerc(i, a),
                s = 1 - o;
            return [Math.round(1e3 * (s * s * s * e[0] + (o * s * s + s * o * s + s * s * o) * n[0] + (o * o * s + s * o * o + o * s * o) * r[0] + o * o * o * t[0])) / 1e3, Math.round(1e3 * (s * s * s * e[1] + (o * s * s + s * o * s + s * s * o) * n[1] + (o * o * s + s * o * o + o * s * o) * r[1] + o * o * o * t[1])) / 1e3];
          },
          buildBezierData: t,
          pointOnLine2D: pointOnLine2D,
          pointOnLine3D: function pointOnLine3D(e, t, n, r, i, a, o, s, l) {
            if (0 === n && 0 === a && 0 === l) return pointOnLine2D(e, t, r, i, o, s);
            var c,
                p = Math.sqrt(Math.pow(r - e, 2) + Math.pow(i - t, 2) + Math.pow(a - n, 2)),
                d = Math.sqrt(Math.pow(o - e, 2) + Math.pow(s - t, 2) + Math.pow(l - n, 2)),
                h = Math.sqrt(Math.pow(o - r, 2) + Math.pow(s - i, 2) + Math.pow(l - a, 2));
            return (c = p > d ? p > h ? p - d - h : h - d - p : h > d ? h - d - p : d - p - h) > -1e-4 && c < 1e-4;
          }
        };
      }

      !function () {
        for (var e = 0, t = ["ms", "moz", "webkit", "o"], n = 0; n < t.length && !window.requestAnimationFrame; ++n) {
          window.requestAnimationFrame = window[t[n] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[t[n] + "CancelAnimationFrame"] || window[t[n] + "CancelRequestAnimationFrame"];
        }

        window.requestAnimationFrame || (window.requestAnimationFrame = function (t, n) {
          var r = new Date().getTime(),
              i = Math.max(0, 16 - (r - e)),
              a = setTimeout(function () {
            t(r + i);
          }, i);
          return e = r + i, a;
        }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function (e) {
          clearTimeout(e);
        });
      }();
      var bez = bezFunction();

      function dataFunctionManager() {
        function findCompLayers(e, t) {
          for (var n = 0, r = t.length; n < r;) {
            if (t[n].id === e) return t[n].layers.__used ? JSON.parse(JSON.stringify(t[n].layers)) : (t[n].layers.__used = !0, t[n].layers);
            n += 1;
          }
        }

        function completeShapes(e) {
          var t, n, r;

          for (t = e.length - 1; t >= 0; t -= 1) {
            if ("sh" == e[t].ty) {
              if (e[t].ks.k.i) convertPathsToAbsoluteValues(e[t].ks.k);else for (r = e[t].ks.k.length, n = 0; n < r; n += 1) {
                e[t].ks.k[n].s && convertPathsToAbsoluteValues(e[t].ks.k[n].s[0]), e[t].ks.k[n].e && convertPathsToAbsoluteValues(e[t].ks.k[n].e[0]);
              }
              !0;
            } else "gr" == e[t].ty && completeShapes(e[t].it);
          }
        }

        function convertPathsToAbsoluteValues(e) {
          var t,
              n = e.i.length;

          for (t = 0; t < n; t += 1) {
            e.i[t][0] += e.v[t][0], e.i[t][1] += e.v[t][1], e.o[t][0] += e.v[t][0], e.o[t][1] += e.v[t][1];
          }
        }

        function checkVersion(e, t) {
          var n = t ? t.split(".") : [100, 100, 100];
          return e[0] > n[0] || !(n[0] > e[0]) && (e[1] > n[1] || !(n[1] > e[1]) && (e[2] > n[2] || !(n[2] > e[2]) && void 0));
        }

        var e = function () {
          var e = [4, 4, 14];

          function updateTextLayer(e) {
            var t = e.t.d;
            e.t.d = {
              k: [{
                s: t,
                t: 0
              }]
            };
          }

          function iterateLayers(e) {
            var t,
                n = e.length;

            for (t = 0; t < n; t += 1) {
              5 === e[t].ty && updateTextLayer(e[t]);
            }
          }

          return function (t) {
            if (checkVersion(e, t.v) && (iterateLayers(t.layers), t.assets)) {
              var n,
                  r = t.assets.length;

              for (n = 0; n < r; n += 1) {
                t.assets[n].layers && iterateLayers(t.assets[n].layers);
              }
            }
          };
        }(),
            t = function () {
          var e = [4, 7, 99];
          return function (t) {
            if (t.chars && !checkVersion(e, t.v)) {
              var n,
                  r,
                  i,
                  a,
                  o,
                  s = t.chars.length;

              for (n = 0; n < s; n += 1) {
                if (t.chars[n].data && t.chars[n].data.shapes) for (i = (o = t.chars[n].data.shapes[0].it).length, r = 0; r < i; r += 1) {
                  (a = o[r].ks.k).__converted || (convertPathsToAbsoluteValues(o[r].ks.k), a.__converted = !0);
                }
              }
            }
          };
        }(),
            n = function () {
          var e = [4, 1, 9];

          function iterateShapes(e) {
            var t,
                n,
                r,
                i = e.length;

            for (t = 0; t < i; t += 1) {
              if ("gr" === e[t].ty) iterateShapes(e[t].it);else if ("fl" === e[t].ty || "st" === e[t].ty) if (e[t].c.k && e[t].c.k[0].i) for (r = e[t].c.k.length, n = 0; n < r; n += 1) {
                e[t].c.k[n].s && (e[t].c.k[n].s[0] /= 255, e[t].c.k[n].s[1] /= 255, e[t].c.k[n].s[2] /= 255, e[t].c.k[n].s[3] /= 255), e[t].c.k[n].e && (e[t].c.k[n].e[0] /= 255, e[t].c.k[n].e[1] /= 255, e[t].c.k[n].e[2] /= 255, e[t].c.k[n].e[3] /= 255);
              } else e[t].c.k[0] /= 255, e[t].c.k[1] /= 255, e[t].c.k[2] /= 255, e[t].c.k[3] /= 255;
            }
          }

          function iterateLayers(e) {
            var t,
                n = e.length;

            for (t = 0; t < n; t += 1) {
              4 === e[t].ty && iterateShapes(e[t].shapes);
            }
          }

          return function (t) {
            if (checkVersion(e, t.v) && (iterateLayers(t.layers), t.assets)) {
              var n,
                  r = t.assets.length;

              for (n = 0; n < r; n += 1) {
                t.assets[n].layers && iterateLayers(t.assets[n].layers);
              }
            }
          };
        }(),
            r = function () {
          var e = [4, 4, 18];

          function completeShapes(e) {
            var t, n, r;

            for (t = e.length - 1; t >= 0; t -= 1) {
              if ("sh" == e[t].ty) {
                if (e[t].ks.k.i) e[t].ks.k.c = e[t].closed;else for (r = e[t].ks.k.length, n = 0; n < r; n += 1) {
                  e[t].ks.k[n].s && (e[t].ks.k[n].s[0].c = e[t].closed), e[t].ks.k[n].e && (e[t].ks.k[n].e[0].c = e[t].closed);
                }
                !0;
              } else "gr" == e[t].ty && completeShapes(e[t].it);
            }
          }

          function iterateLayers(e) {
            var t,
                n,
                r,
                i,
                a,
                o,
                s = e.length;

            for (n = 0; n < s; n += 1) {
              if ((t = e[n]).hasMask) {
                var l = t.masksProperties;

                for (i = l.length, r = 0; r < i; r += 1) {
                  if (l[r].pt.k.i) l[r].pt.k.c = l[r].cl;else for (o = l[r].pt.k.length, a = 0; a < o; a += 1) {
                    l[r].pt.k[a].s && (l[r].pt.k[a].s[0].c = l[r].cl), l[r].pt.k[a].e && (l[r].pt.k[a].e[0].c = l[r].cl);
                  }
                }
              }

              4 === t.ty && completeShapes(t.shapes);
            }
          }

          return function (t) {
            if (checkVersion(e, t.v) && (iterateLayers(t.layers), t.assets)) {
              var n,
                  r = t.assets.length;

              for (n = 0; n < r; n += 1) {
                t.assets[n].layers && iterateLayers(t.assets[n].layers);
              }
            }
          };
        }();

        var i = {};
        return i.completeData = function completeData(i, a) {
          i.__complete || (n(i), e(i), t(i), r(i), function completeLayers(e, t, n) {
            var r,
                i,
                a,
                o,
                s,
                l,
                c,
                p = e.length;

            for (i = 0; i < p; i += 1) {
              if ("ks" in (r = e[i]) && !r.completed) {
                if (r.completed = !0, r.tt && (e[i - 1].td = r.tt), r.hasMask) {
                  var d = r.masksProperties;

                  for (o = d.length, a = 0; a < o; a += 1) {
                    if (d[a].pt.k.i) convertPathsToAbsoluteValues(d[a].pt.k);else for (l = d[a].pt.k.length, s = 0; s < l; s += 1) {
                      d[a].pt.k[s].s && convertPathsToAbsoluteValues(d[a].pt.k[s].s[0]), d[a].pt.k[s].e && convertPathsToAbsoluteValues(d[a].pt.k[s].e[0]);
                    }
                  }
                }

                0 === r.ty ? (r.layers = findCompLayers(r.refId, t), completeLayers(r.layers, t, n)) : 4 === r.ty ? completeShapes(r.shapes) : 5 == r.ty && (0 !== (c = r).t.a.length || "m" in c.t.p || (c.singleShape = !0));
              }
            }
          }(i.layers, i.assets, a), i.__complete = !0);
        }, i;
      }

      var dataManager = dataFunctionManager(),
          FontManager = function () {
        var e = 5e3;

        function setUpNode(e, t) {
          var n = document.createElement("span");
          n.style.fontFamily = t;
          var r = document.createElement("span");
          r.innerHTML = "giItT1WQy@!-/#", n.style.position = "absolute", n.style.left = "-10000px", n.style.top = "-10000px", n.style.fontSize = "300px", n.style.fontVariant = "normal", n.style.fontStyle = "normal", n.style.fontWeight = "normal", n.style.letterSpacing = "0", n.appendChild(r), document.body.appendChild(n);
          var i = r.offsetWidth;
          return r.style.fontFamily = e + ", " + t, {
            node: r,
            w: i,
            parent: n
          };
        }

        function createHelper(e, t) {
          var n = document.createElementNS(svgNS, "text");
          n.style.fontSize = "100px", n.style.fontFamily = t.fFamily, n.textContent = "1", t.fClass ? (n.style.fontFamily = "inherit", n.className = t.fClass) : n.style.fontFamily = t.fFamily, e.appendChild(n);
          var r = document.createElement("canvas").getContext("2d");
          return r.font = "100px " + t.fFamily, r;
        }

        var t = function Font() {
          this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.loaded = !1, this.initTime = Date.now();
        };

        return t.prototype.addChars = function addChars(e) {
          if (e) {
            this.chars || (this.chars = []);
            var t,
                n,
                r,
                i = e.length,
                a = this.chars.length;

            for (t = 0; t < i; t += 1) {
              for (n = 0, r = !1; n < a;) {
                this.chars[n].style === e[t].style && this.chars[n].fFamily === e[t].fFamily && this.chars[n].ch === e[t].ch && (r = !0), n += 1;
              }

              r || (this.chars.push(e[t]), a += 1);
            }
          }
        }, t.prototype.addFonts = function addFonts(t, n) {
          if (t) {
            if (this.chars) return this.loaded = !0, void (this.fonts = t.list);
            var r,
                i = t.list,
                a = i.length;

            for (r = 0; r < a; r += 1) {
              if (i[r].loaded = !1, i[r].monoCase = setUpNode(i[r].fFamily, "monospace"), i[r].sansCase = setUpNode(i[r].fFamily, "sans-serif"), i[r].fPath) {
                if ("p" === i[r].fOrigin || 3 === i[r].origin) {
                  var o = document.createElement("style");
                  o.type = "text/css", o.innerHTML = "@font-face {font-family: " + i[r].fFamily + "; font-style: normal; src: url('" + i[r].fPath + "');}", n.appendChild(o);
                } else if ("g" === i[r].fOrigin || 1 === i[r].origin) {
                  var s = document.createElement("link");
                  s.type = "text/css", s.rel = "stylesheet", s.href = i[r].fPath, n.appendChild(s);
                } else if ("t" === i[r].fOrigin || 2 === i[r].origin) {
                  var l = document.createElement("script");
                  l.setAttribute("src", i[r].fPath), n.appendChild(l);
                }
              } else i[r].loaded = !0;

              i[r].helper = createHelper(n, i[r]), this.fonts.push(i[r]);
            }

            (function checkLoadedFonts() {
              var t,
                  n,
                  r,
                  i = this.fonts.length,
                  a = i;

              for (t = 0; t < i; t += 1) {
                if (this.fonts[t].loaded) a -= 1;else if ("t" === this.fonts[t].fOrigin || 2 === this.fonts[t].origin) {
                  if (window.Typekit && window.Typekit.load && 0 === this.typekitLoaded) {
                    this.typekitLoaded = 1;

                    try {
                      window.Typekit.load({
                        async: !0,
                        active: function () {
                          this.typekitLoaded = 2;
                        }.bind(this)
                      });
                    } catch (o) {}
                  }

                  2 === this.typekitLoaded && (this.fonts[t].loaded = !0);
                } else "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin ? this.fonts[t].loaded = !0 : (n = this.fonts[t].monoCase.node, r = this.fonts[t].monoCase.w, n.offsetWidth !== r ? (a -= 1, this.fonts[t].loaded = !0) : (n = this.fonts[t].sansCase.node, r = this.fonts[t].sansCase.w, n.offsetWidth !== r && (a -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
              }

              0 !== a && Date.now() - this.initTime < e ? setTimeout(checkLoadedFonts.bind(this), 20) : setTimeout(function () {
                this.loaded = !0;
              }.bind(this), 0);
            }).bind(this)();
          } else this.loaded = !0;
        }, t.prototype.getCharData = function getCharData(e, t, n) {
          for (var r = 0, i = this.chars.length; r < i;) {
            if (this.chars[r].ch === e && this.chars[r].style === t && this.chars[r].fFamily === n) return this.chars[r];
            r += 1;
          }
        }, t.prototype.getFontByName = function getFontByName(e) {
          for (var t = 0, n = this.fonts.length; t < n;) {
            if (this.fonts[t].fName === e) return this.fonts[t];
            t += 1;
          }

          return "sans-serif";
        }, t.prototype.measureText = function measureText(e, t, n) {
          return this.getFontByName(t).helper.measureText(e).width * n / 100;
        }, t;
      }(),
          PropertyFactory = function () {
        var e = -999999;

        function interpolateValue(e, t, n, r) {
          var i,
              a = this.offsetTime;
          n.constructor === Array && (i = Array.apply(null, {
            length: n.length
          }));

          for (var o, s, l, c, p, d, h, u, f = t, m = this.keyframes.length - 1, g = !0; g;) {
            if (o = this.keyframes[f], s = this.keyframes[f + 1], f == m - 1 && e >= s.t - a) {
              o.h && (o = s), t = 0;
              break;
            }

            if (s.t - a > e) {
              t = f;
              break;
            }

            f < m - 1 ? f += 1 : (t = 0, g = !1);
          }

          if (o.to) {
            o.bezierData || bez.buildBezierData(o);
            var v = o.bezierData;

            if (e >= s.t - a || e < o.t - a) {
              var b = e >= s.t - a ? v.points.length - 1 : 0;

              for (c = v.points[b].point.length, l = 0; l < c; l += 1) {
                i[l] = v.points[b].point[l];
              }

              r._lastBezierData = null;
            } else {
              o.__fnct ? u = o.__fnct : (u = BezierFactory.getBezierEasing(o.o.x, o.o.y, o.i.x, o.i.y, o.n).get, o.__fnct = u), p = u((e - (o.t - a)) / (s.t - a - (o.t - a)));
              var y,
                  x = v.segmentLength * p,
                  w = r.lastFrame < e && r._lastBezierData === v ? r._lastAddedLength : 0;

              for (h = r.lastFrame < e && r._lastBezierData === v ? r._lastPoint : 0, g = !0, d = v.points.length; g;) {
                if (w += v.points[h].partialLength, 0 === x || 0 === p || h == v.points.length - 1) {
                  for (c = v.points[h].point.length, l = 0; l < c; l += 1) {
                    i[l] = v.points[h].point[l];
                  }

                  break;
                }

                if (x >= w && x < w + v.points[h + 1].partialLength) {
                  for (y = (x - w) / v.points[h + 1].partialLength, c = v.points[h].point.length, l = 0; l < c; l += 1) {
                    i[l] = v.points[h].point[l] + (v.points[h + 1].point[l] - v.points[h].point[l]) * y;
                  }

                  break;
                }

                h < d - 1 ? h += 1 : g = !1;
              }

              r._lastPoint = h, r._lastAddedLength = w - v.points[h].partialLength, r._lastBezierData = v;
            }
          } else {
            var E, C, k, S, _;

            for (m = o.s.length, f = 0; f < m; f += 1) {
              if (1 !== o.h && (e >= s.t - a ? p = 1 : e < o.t - a ? p = 0 : (o.o.x.constructor === Array ? (o.__fnct || (o.__fnct = []), o.__fnct[f] ? u = o.__fnct[f] : (E = o.o.x[f] || o.o.x[0], C = o.o.y[f] || o.o.y[0], k = o.i.x[f] || o.i.x[0], S = o.i.y[f] || o.i.y[0], u = BezierFactory.getBezierEasing(E, C, k, S).get, o.__fnct[f] = u)) : o.__fnct ? u = o.__fnct : (E = o.o.x, C = o.o.y, k = o.i.x, S = o.i.y, u = BezierFactory.getBezierEasing(E, C, k, S).get, o.__fnct = u), p = u((e - (o.t - a)) / (s.t - a - (o.t - a))))), this.sh && 1 !== o.h) {
                var M = o.s[f],
                    L = o.e[f];
                M - L < -180 ? M += 360 : M - L > 180 && (M -= 360), _ = M + (L - M) * p;
              } else _ = 1 === o.h ? o.s[f] : o.s[f] + (o.e[f] - o.s[f]) * p;

              1 === m ? i = _ : i[f] = _;
            }
          }

          return {
            value: i,
            iterationIndex: t
          };
        }

        function getValueAtCurrentTime() {
          if (this.elem.globalData.frameId !== this.frameId) {
            this.mdf = !1;
            var t = this.comp.renderedFrame - this.offsetTime,
                n = this.keyframes[0].t - this.offsetTime,
                r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;

            if (!(t === this._caching.lastFrame || this._caching.lastFrame !== e && (this._caching.lastFrame >= r && t >= r || this._caching.lastFrame < n && t < n))) {
              var i = this._caching.lastFrame < t ? this._caching.lastIndex : 0,
                  a = this.interpolateValue(t, i, this.pv, this._caching);
              if (this._caching.lastIndex = a.iterationIndex, this.pv.constructor === Array) for (i = 0; i < this.v.length;) {
                this.pv[i] = a.value[i], this.v[i] = this.mult ? this.pv[i] * this.mult : this.pv[i], this.lastPValue[i] !== this.pv[i] && (this.mdf = !0, this.lastPValue[i] = this.pv[i]), i += 1;
              } else this.pv = a.value, this.v = this.mult ? this.pv * this.mult : this.pv, this.lastPValue != this.pv && (this.mdf = !0, this.lastPValue = this.pv);
            }

            this._caching.lastFrame = t, this.frameId = this.elem.globalData.frameId;
          }
        }

        function getNoValue() {}

        function ValueProperty(e, t, n) {
          this.mult = n, this.v = n ? t.k * n : t.k, this.pv = t.k, this.mdf = !1, this.comp = e.comp, this.k = !1, this.kf = !1, this.vel = 0, this.getValue = getNoValue;
        }

        function MultiDimensionalProperty(e, t, n) {
          this.mult = n, this.data = t, this.mdf = !1, this.comp = e.comp, this.k = !1, this.kf = !1, this.frameId = -1, this.v = Array.apply(null, {
            length: t.k.length
          }), this.pv = Array.apply(null, {
            length: t.k.length
          }), this.lastValue = Array.apply(null, {
            length: t.k.length
          });
          var r = Array.apply(null, {
            length: t.k.length
          });
          this.vel = r.map(function () {
            return 0;
          });
          var i,
              a = t.k.length;

          for (i = 0; i < a; i += 1) {
            this.v[i] = n ? t.k[i] * n : t.k[i], this.pv[i] = t.k[i];
          }

          this.getValue = getNoValue;
        }

        function KeyframedValueProperty(t, n, r) {
          this.keyframes = n.k, this.offsetTime = t.data.st, this.lastValue = -99999, this.lastPValue = -99999, this.frameId = -1, this._caching = {
            lastFrame: e,
            lastIndex: 0
          }, this.k = !0, this.kf = !0, this.data = n, this.mult = r, this.elem = t, this.comp = t.comp, this.v = r ? n.k[0].s[0] * r : n.k[0].s[0], this.pv = n.k[0].s[0], this.getValue = getValueAtCurrentTime, this.interpolateValue = interpolateValue;
        }

        function KeyframedMultidimensionalProperty(t, n, r) {
          var i,
              a,
              o,
              s,
              l,
              c = n.k.length;

          for (i = 0; i < c - 1; i += 1) {
            n.k[i].to && n.k[i].s && n.k[i].e && (a = n.k[i].s, o = n.k[i].e, s = n.k[i].to, l = n.k[i].ti, (2 === a.length && (a[0] !== o[0] || a[1] !== o[1]) && bez.pointOnLine2D(a[0], a[1], o[0], o[1], a[0] + s[0], a[1] + s[1]) && bez.pointOnLine2D(a[0], a[1], o[0], o[1], o[0] + l[0], o[1] + l[1]) || 3 === a.length && (a[0] !== o[0] || a[1] !== o[1] || a[2] !== o[2]) && bez.pointOnLine3D(a[0], a[1], a[2], o[0], o[1], o[2], a[0] + s[0], a[1] + s[1], a[2] + s[2]) && bez.pointOnLine3D(a[0], a[1], a[2], o[0], o[1], o[2], o[0] + l[0], o[1] + l[1], o[2] + l[2])) && (n.k[i].to = null, n.k[i].ti = null));
          }

          this.keyframes = n.k, this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this.mult = r, this.elem = t, this.comp = t.comp, this._caching = {
            lastFrame: e,
            lastIndex: 0
          }, this.getValue = getValueAtCurrentTime, this.interpolateValue = interpolateValue, this.frameId = -1, this.v = Array.apply(null, {
            length: n.k[0].s.length
          }), this.pv = Array.apply(null, {
            length: n.k[0].s.length
          }), this.lastValue = Array.apply(null, {
            length: n.k[0].s.length
          }), this.lastPValue = Array.apply(null, {
            length: n.k[0].s.length
          });
        }

        var t = function () {
          function positionGetter() {
            return this.p ? ExpressionValue(this.p) : [this.px.v, this.py.v, this.pz ? this.pz.v : 0];
          }

          function xPositionGetter() {
            return ExpressionValue(this.px);
          }

          function yPositionGetter() {
            return ExpressionValue(this.py);
          }

          function anchorGetter() {
            return ExpressionValue(this.a);
          }

          function orientationGetter() {
            return ExpressionValue(this.or);
          }

          function rotationGetter() {
            return this.r ? ExpressionValue(this.r, 1 / degToRads) : ExpressionValue(this.rz, 1 / degToRads);
          }

          function scaleGetter() {
            return ExpressionValue(this.s, 100);
          }

          function opacityGetter() {
            return ExpressionValue(this.o, 100);
          }

          function skewGetter() {
            return ExpressionValue(this.sk);
          }

          function skewAxisGetter() {
            return ExpressionValue(this.sa);
          }

          function applyToMatrix(e) {
            var t,
                n = this.dynamicProperties.length;

            for (t = 0; t < n; t += 1) {
              this.dynamicProperties[t].getValue(), this.dynamicProperties[t].mdf && (this.mdf = !0);
            }

            this.a && e.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && e.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.r ? e.rotate(-this.r.v) : e.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? e.translate(this.px.v, this.py.v, -this.pz.v) : e.translate(this.px.v, this.py.v, 0) : e.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }

          function processKeys() {
            if (this.elem.globalData.frameId !== this.frameId) {
              this.mdf = !1;
              var e,
                  t = this.dynamicProperties.length;

              for (e = 0; e < t; e += 1) {
                this.dynamicProperties[e].getValue(), this.dynamicProperties[e].mdf && (this.mdf = !0);
              }

              if (this.mdf) {
                var n, r;
                if (this.v.reset(), this.a && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r ? this.v.rotate(-this.r.v) : this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (n = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / this.elem.globalData.frameRate, 0), r = this.p.getValueAtTime(this.p.keyframes[0].t / this.elem.globalData.frameRate, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (n = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / this.elem.globalData.frameRate, 0), r = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .01) / this.elem.globalData.frameRate, 0)) : (n = this.p.pv, r = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / this.elem.globalData.frameRate, this.p.offsetTime)), this.v.rotate(-Math.atan2(n[1] - r[1], n[0] - r[0]));
                this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
              }

              this.frameId = this.elem.globalData.frameId;
            }
          }

          function setInverted() {
            this.inverted = !0, this.iv = new Matrix(), this.k || (this.data.p.s ? this.iv.translate(this.px.v, this.py.v, -this.pz.v) : this.iv.translate(this.p.v[0], this.p.v[1], -this.p.v[2]), this.r ? this.iv.rotate(-this.r.v) : this.iv.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.s && this.iv.scale(this.s.v[0], this.s.v[1], 1), this.a && this.iv.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]));
          }

          function autoOrient() {}

          return function TransformProperty(e, t, n) {
            this.elem = e, this.frameId = -1, this.type = "transform", this.dynamicProperties = [], this.mdf = !1, this.data = t, this.getValue = processKeys, this.applyToMatrix = applyToMatrix, this.setInverted = setInverted, this.autoOrient = autoOrient, this.v = new Matrix(), t.p.s ? (this.px = PropertyFactory.getProp(e, t.p.x, 0, 0, this.dynamicProperties), this.py = PropertyFactory.getProp(e, t.p.y, 0, 0, this.dynamicProperties), t.p.z && (this.pz = PropertyFactory.getProp(e, t.p.z, 0, 0, this.dynamicProperties))) : this.p = PropertyFactory.getProp(e, t.p, 1, 0, this.dynamicProperties), t.r ? this.r = PropertyFactory.getProp(e, t.r, 0, degToRads, this.dynamicProperties) : t.rx && (this.rx = PropertyFactory.getProp(e, t.rx, 0, degToRads, this.dynamicProperties), this.ry = PropertyFactory.getProp(e, t.ry, 0, degToRads, this.dynamicProperties), this.rz = PropertyFactory.getProp(e, t.rz, 0, degToRads, this.dynamicProperties), this.or = PropertyFactory.getProp(e, t.or, 1, degToRads, this.dynamicProperties), this.or.sh = !0), t.sk && (this.sk = PropertyFactory.getProp(e, t.sk, 0, degToRads, this.dynamicProperties), this.sa = PropertyFactory.getProp(e, t.sa, 0, degToRads, this.dynamicProperties)), t.a && (this.a = PropertyFactory.getProp(e, t.a, 1, 0, this.dynamicProperties)), t.s && (this.s = PropertyFactory.getProp(e, t.s, 1, .01, this.dynamicProperties)), t.o ? this.o = PropertyFactory.getProp(e, t.o, 0, .01, this.dynamicProperties) : this.o = {
              mdf: !1,
              v: 1
            }, this.dynamicProperties.length ? n.push(this) : (this.a && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r ? this.v.rotate(-this.r.v) : this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? t.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2])), Object.defineProperty(this, "position", {
              get: positionGetter
            }), Object.defineProperty(this, "xPosition", {
              get: xPositionGetter
            }), Object.defineProperty(this, "yPosition", {
              get: yPositionGetter
            }), Object.defineProperty(this, "orientation", {
              get: orientationGetter
            }), Object.defineProperty(this, "anchorPoint", {
              get: anchorGetter
            }), Object.defineProperty(this, "rotation", {
              get: rotationGetter
            }), Object.defineProperty(this, "scale", {
              get: scaleGetter
            }), Object.defineProperty(this, "opacity", {
              get: opacityGetter
            }), Object.defineProperty(this, "skew", {
              get: skewGetter
            }), Object.defineProperty(this, "skewAxis", {
              get: skewAxisGetter
            });
          };
        }();

        function getProp(e, n, r, i, a) {
          var o;
          if (2 === r) o = new t(e, n, a);else if (0 === n.a) o = 0 === r ? new ValueProperty(e, n, i) : new MultiDimensionalProperty(e, n, i);else if (1 === n.a) o = 0 === r ? new KeyframedValueProperty(e, n, i) : new KeyframedMultidimensionalProperty(e, n, i);else if (n.k.length) {
            if ("number" === typeof n.k[0]) o = new MultiDimensionalProperty(e, n, i);else switch (r) {
              case 0:
                o = new KeyframedValueProperty(e, n, i);
                break;

              case 1:
                o = new KeyframedMultidimensionalProperty(e, n, i);
            }
          } else o = new ValueProperty(e, n, i);
          return o.k && a.push(o), o;
        }

        var n = function () {
          function getValue(e) {
            if (this.prop.getValue(), this.cmdf = !1, this.omdf = !1, this.prop.mdf || e) {
              var t,
                  n,
                  r,
                  i = 4 * this.data.p;

              for (t = 0; t < i; t += 1) {
                n = t % 4 === 0 ? 100 : 255, r = Math.round(this.prop.v[t] * n), this.c[t] !== r && (this.c[t] = r, this.cmdf = !0);
              }

              if (this.o.length) for (i = this.prop.v.length, t = 4 * this.data.p; t < i; t += 1) {
                n = t % 2 === 0 ? 100 : 1, r = t % 2 === 0 ? Math.round(100 * this.prop.v[t]) : this.prop.v[t], this.o[t - 4 * this.data.p] !== r && (this.o[t - 4 * this.data.p] = r, this.omdf = !0);
              }
            }
          }

          function gradientProp(e, t, n) {
            this.prop = getProp(e, t.k, 1, null, []), this.data = t, this.k = this.prop.k, this.c = Array.apply(null, {
              length: 4 * t.p
            });
            var r = t.k.k[0].s ? t.k.k[0].s.length - 4 * t.p : t.k.k.length - 4 * t.p;
            this.o = Array.apply(null, {
              length: r
            }), this.cmdf = !1, this.omdf = !1, this.getValue = getValue, this.prop.k && n.push(this), this.getValue(!0);
          }

          return function getGradientProp(e, t, n) {
            return new gradientProp(e, t, n);
          };
        }(),
            r = function () {
          function processKeys(e) {
            var t = 0,
                n = this.dataProps.length;

            if (this.elem.globalData.frameId !== this.frameId || e) {
              for (this.mdf = !1, this.frameId = this.elem.globalData.frameId; t < n;) {
                if (this.dataProps[t].p.mdf) {
                  this.mdf = !0;
                  break;
                }

                t += 1;
              }

              if (this.mdf || e) for ("svg" === this.renderer && (this.dasharray = ""), t = 0; t < n; t += 1) {
                "o" != this.dataProps[t].n ? "svg" === this.renderer ? this.dasharray += " " + this.dataProps[t].p.v : this.dasharray[t] = this.dataProps[t].p.v : this.dashoffset = this.dataProps[t].p.v;
              }
            }
          }

          return function (e, t, n, r) {
            this.elem = e, this.frameId = -1, this.dataProps = new Array(t.length), this.renderer = n, this.mdf = !1, this.k = !1, "svg" === this.renderer ? this.dasharray = "" : this.dasharray = new Array(t.length - 1), this.dashoffset = 0;
            var i,
                a,
                o = t.length;

            for (i = 0; i < o; i += 1) {
              a = PropertyFactory.getProp(e, t[i].v, 0, 0, r), this.k = !!a.k || this.k, this.dataProps[i] = {
                n: t[i].n,
                p: a
              };
            }

            this.getValue = processKeys, this.k ? r.push(this) : this.getValue(!0);
          };
        }();

        var i = function () {
          var e = Math.max,
              t = Math.min,
              n = Math.floor;

          function updateRange(e) {
            if (this.mdf = e || !1, this.dynamicProperties.length) {
              var t,
                  n = this.dynamicProperties.length;

              for (t = 0; t < n; t += 1) {
                this.dynamicProperties[t].getValue(), this.dynamicProperties[t].mdf && (this.mdf = !0);
              }
            }

            var r = this.elem.textProperty.currentData ? this.elem.textProperty.currentData.l.length : 0;
            e && 2 === this.data.r && (this.e.v = r);
            var i = 2 === this.data.r ? 1 : 100 / r,
                a = this.o.v / i,
                o = this.s.v / i + a,
                s = this.e.v / i + a;

            if (o > s) {
              var l = o;
              o = s, s = l;
            }

            this.finalS = o, this.finalE = s;
          }

          function getMult(r) {
            var i = BezierFactory.getBezierEasing(this.ne.v / 100, 0, 1 - this.xe.v / 100, 1).get,
                a = 0,
                o = this.finalS,
                s = this.finalE,
                l = this.data.sh;
            if (2 == l) a = i(a = s === o ? r >= s ? 1 : 0 : e(0, t(.5 / (s - o) + (r - o) / (s - o), 1)));else if (3 == l) a = i(a = s === o ? r >= s ? 0 : 1 : 1 - e(0, t(.5 / (s - o) + (r - o) / (s - o), 1)));else if (4 == l) s === o ? a = 0 : (a = e(0, t(.5 / (s - o) + (r - o) / (s - o), 1))) < .5 ? a *= 2 : a = 1 - 2 * (a - .5), a = i(a);else if (5 == l) {
              if (s === o) a = 0;else {
                var c = s - o,
                    p = -c / 2 + (r = t(e(0, r + .5 - o), s - o)),
                    d = c / 2;
                a = Math.sqrt(1 - p * p / (d * d));
              }
              a = i(a);
            } else 6 == l ? (s === o ? a = 0 : (r = t(e(0, r + .5 - o), s - o), a = (1 + Math.cos(Math.PI + 2 * Math.PI * r / (s - o))) / 2), a = i(a)) : (r >= n(o) && (a = r - o < 0 ? 1 - (o - r) : e(0, t(s - r, 1))), a = i(a));
            return a * this.a.v;
          }

          return function TextSelectorProp(e, t, n) {
            this.mdf = !1, this.k = !1, this.data = t, this.dynamicProperties = [], this.getValue = updateRange, this.getMult = getMult, this.elem = e, this.comp = e.comp, this.finalS = 0, this.finalE = 0, this.s = PropertyFactory.getProp(e, t.s || {
              k: 0
            }, 0, 0, this.dynamicProperties), this.e = "e" in t ? PropertyFactory.getProp(e, t.e, 0, 0, this.dynamicProperties) : {
              v: 100
            }, this.o = PropertyFactory.getProp(e, t.o || {
              k: 0
            }, 0, 0, this.dynamicProperties), this.xe = PropertyFactory.getProp(e, t.xe || {
              k: 0
            }, 0, 0, this.dynamicProperties), this.ne = PropertyFactory.getProp(e, t.ne || {
              k: 0
            }, 0, 0, this.dynamicProperties), this.a = PropertyFactory.getProp(e, t.a, 0, .01, this.dynamicProperties), this.dynamicProperties.length ? n.push(this) : this.getValue();
          };
        }();

        return {
          getProp: getProp,
          getDashProp: function getDashProp(e, t, n, i) {
            return new r(e, t, n, i);
          },
          getTextSelectorProp: function getTextSelectorProp(e, t, n) {
            return new i(e, t, n);
          },
          getGradientProp: n
        };
      }();

      function ShapePath() {
        this.c = !1, this._length = 0, this._maxLength = 8, this.v = Array.apply(null, {
          length: this._maxLength
        }), this.o = Array.apply(null, {
          length: this._maxLength
        }), this.i = Array.apply(null, {
          length: this._maxLength
        });
      }

      ShapePath.prototype.setPathData = function (e, t) {
        this.c = e, this.setLength(t);

        for (var n = 0; n < t;) {
          this.v[n] = point_pool.newPoint(), this.o[n] = point_pool.newPoint(), this.i[n] = point_pool.newPoint(), n += 1;
        }
      }, ShapePath.prototype.setLength = function (e) {
        for (; this._maxLength < e;) {
          this.doubleArrayLength();
        }

        this._length = e;
      }, ShapePath.prototype.doubleArrayLength = function () {
        this.v = this.v.concat(Array.apply(null, {
          length: this._maxLength
        })), this.i = this.i.concat(Array.apply(null, {
          length: this._maxLength
        })), this.o = this.o.concat(Array.apply(null, {
          length: this._maxLength
        })), this._maxLength *= 2;
      }, ShapePath.prototype.setXYAt = function (e, t, n, r, i) {
        var a;

        switch (this._length = Math.max(this._length, r + 1), this._length >= this._maxLength && this.doubleArrayLength(), n) {
          case "v":
            a = this.v;
            break;

          case "i":
            a = this.i;
            break;

          case "o":
            a = this.o;
        }

        (!a[r] || a[r] && !i) && (a[r] = point_pool.newPoint()), a[r][0] = e, a[r][1] = t;
      }, ShapePath.prototype.setTripleAt = function (e, t, n, r, i, a, o, s) {
        this.setXYAt(e, t, "v", o, s), this.setXYAt(n, r, "o", o, s), this.setXYAt(i, a, "i", o, s);
      };

      var ShapePropertyFactory = function () {
        var e = -999999;

        function interpolateShape(e, t, n, r) {
          var i, a, o;
          if (e < this.keyframes[0].t - this.offsetTime) i = this.keyframes[0].s[0], o = !0, t = 0;else if (e >= this.keyframes[this.keyframes.length - 1].t - this.offsetTime) i = 1 === this.keyframes[this.keyframes.length - 2].h ? this.keyframes[this.keyframes.length - 1].s[0] : this.keyframes[this.keyframes.length - 2].e[0], o = !0;else {
            for (var s, l, c, p, d, h, u, f = t, m = this.keyframes.length - 1, g = !0; g && (s = this.keyframes[f], !((l = this.keyframes[f + 1]).t - this.offsetTime > e));) {
              f < m - 1 ? f += 1 : g = !1;
            }

            if (t = f, !(o = 1 === s.h)) {
              if (e >= l.t - this.offsetTime) u = 1;else if (e < s.t - this.offsetTime) u = 0;else {
                var v;
                s.__fnct ? v = s.__fnct : (v = BezierFactory.getBezierEasing(s.o.x, s.o.y, s.i.x, s.i.y).get, s.__fnct = v), u = v((e - (s.t - this.offsetTime)) / (l.t - this.offsetTime - (s.t - this.offsetTime)));
              }
              a = s.e[0];
            }

            i = s.s[0];
          }
          p = n._length, h = i.i[0].length;
          var b,
              y = !1;

          for (c = 0; c < p; c += 1) {
            for (d = 0; d < h; d += 1) {
              o ? (b = i.i[c][d], n.i[c][d] !== b && (n.i[c][d] = b, r && (this.pv.i[c][d] = b), y = !0), b = i.o[c][d], n.o[c][d] !== b && (n.o[c][d] = b, r && (this.pv.o[c][d] = b), y = !0), b = i.v[c][d], n.v[c][d] !== b && (n.v[c][d] = b, r && (this.pv.v[c][d] = b), y = !0)) : (b = i.i[c][d] + (a.i[c][d] - i.i[c][d]) * u, n.i[c][d] !== b && (n.i[c][d] = b, r && (this.pv.i[c][d] = b), y = !0), b = i.o[c][d] + (a.o[c][d] - i.o[c][d]) * u, n.o[c][d] !== b && (n.o[c][d] = b, r && (this.pv.o[c][d] = b), y = !0), b = i.v[c][d] + (a.v[c][d] - i.v[c][d]) * u, n.v[c][d] !== b && (n.v[c][d] = b, r && (this.pv.v[c][d] = b), y = !0));
            }
          }

          return y && (n.c = i.c), {
            iterationIndex: t,
            hasModified: y
          };
        }

        function resetShape() {
          this.paths = this.localShapeCollection, this.k || (this.mdf = !1);
        }

        function ShapeProperty(e, t, n) {
          this.__shapeObject = 1, this.comp = e.comp, this.k = !1, this.mdf = !1;
          var r = 3 === n ? t.pt.k : t.ks.k;
          this.v = shape_pool.clone(r), this.pv = shape_pool.clone(this.v), this.localShapeCollection = shapeCollection_pool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = resetShape;
        }

        function KeyframedShapeProperty(t, n, r) {
          this.__shapeObject = 1, this.comp = t.comp, this.elem = t, this.offsetTime = t.data.st, this._lastIndex = 0, this.keyframes = 3 === r ? n.pt.k : n.ks.k, this.k = !0, this.kf = !0;
          var i = this.keyframes[0].s[0].i.length;
          this.keyframes[0].s[0].i[0].length;
          this.v = shape_pool.newShape(), this.v.setPathData(this.keyframes[0].s[0].c, i), this.pv = shape_pool.clone(this.v), this.localShapeCollection = shapeCollection_pool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = e, this.reset = resetShape;
        }

        ShapeProperty.prototype.interpolateShape = interpolateShape, ShapeProperty.prototype.getValue = function getShapeValue() {
          return this.v;
        }, KeyframedShapeProperty.prototype.getValue = function interpolateShapeCurrentTime() {
          if (this.elem.globalData.frameId !== this.frameId) {
            this.mdf = !1;
            var t = this.comp.renderedFrame - this.offsetTime,
                n = this.keyframes[0].t - this.offsetTime,
                r = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;

            if (this.lastFrame === e || !(this.lastFrame < n && t < n || this.lastFrame > r && t > r)) {
              var i = this.lastFrame < t ? this._lastIndex : 0,
                  a = this.interpolateShape(t, i, this.v, !0);
              this._lastIndex = a.iterationIndex, this.mdf = a.hasModified, a.hasModified && (this.paths = this.localShapeCollection);
            }

            this.lastFrame = t, this.frameId = this.elem.globalData.frameId;
          }
        }, KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;

        var t = function () {
          var e = roundCorner;

          function convertEllToPath() {
            var t = this.p.v[0],
                n = this.p.v[1],
                r = this.s.v[0] / 2,
                i = this.s.v[1] / 2;
            3 !== this.d ? (this.v.v[0][0] = t, this.v.v[0][1] = n - i, this.v.v[1][0] = t + r, this.v.v[1][1] = n, this.v.v[2][0] = t, this.v.v[2][1] = n + i, this.v.v[3][0] = t - r, this.v.v[3][1] = n, this.v.i[0][0] = t - r * e, this.v.i[0][1] = n - i, this.v.i[1][0] = t + r, this.v.i[1][1] = n - i * e, this.v.i[2][0] = t + r * e, this.v.i[2][1] = n + i, this.v.i[3][0] = t - r, this.v.i[3][1] = n + i * e, this.v.o[0][0] = t + r * e, this.v.o[0][1] = n - i, this.v.o[1][0] = t + r, this.v.o[1][1] = n + i * e, this.v.o[2][0] = t - r * e, this.v.o[2][1] = n + i, this.v.o[3][0] = t - r, this.v.o[3][1] = n - i * e) : (this.v.v[0][0] = t, this.v.v[0][1] = n - i, this.v.v[1][0] = t - r, this.v.v[1][1] = n, this.v.v[2][0] = t, this.v.v[2][1] = n + i, this.v.v[3][0] = t + r, this.v.v[3][1] = n, this.v.i[0][0] = t + r * e, this.v.i[0][1] = n - i, this.v.i[1][0] = t - r, this.v.i[1][1] = n - i * e, this.v.i[2][0] = t - r * e, this.v.i[2][1] = n + i, this.v.i[3][0] = t + r, this.v.i[3][1] = n + i * e, this.v.o[0][0] = t - r * e, this.v.o[0][1] = n - i, this.v.o[1][0] = t - r, this.v.o[1][1] = n + i * e, this.v.o[2][0] = t + r * e, this.v.o[2][1] = n + i, this.v.o[3][0] = t + r, this.v.o[3][1] = n - i * e);
          }

          function processKeys(e) {
            var t,
                n = this.dynamicProperties.length;

            if (this.elem.globalData.frameId !== this.frameId) {
              for (this.mdf = !1, this.frameId = this.elem.globalData.frameId, t = 0; t < n; t += 1) {
                this.dynamicProperties[t].getValue(e), this.dynamicProperties[t].mdf && (this.mdf = !0);
              }

              this.mdf && this.convertEllToPath();
            }
          }

          return function EllShapeProperty(e, t) {
            this.v = shape_pool.newShape(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollection_pool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = t.d, this.dynamicProperties = [], this.elem = e, this.comp = e.comp, this.frameId = -1, this.mdf = !1, this.getValue = processKeys, this.convertEllToPath = convertEllToPath, this.reset = resetShape, this.p = PropertyFactory.getProp(e, t.p, 1, 0, this.dynamicProperties), this.s = PropertyFactory.getProp(e, t.s, 1, 0, this.dynamicProperties), this.dynamicProperties.length ? this.k = !0 : this.convertEllToPath();
          };
        }(),
            n = function () {
          function convertPolygonToPath() {
            var e,
                t = Math.floor(this.pt.v),
                n = 2 * Math.PI / t,
                r = this.or.v,
                i = this.os.v,
                a = 2 * Math.PI * r / (4 * t),
                o = -Math.PI / 2,
                s = 3 === this.data.d ? -1 : 1;

            for (o += this.r.v, this.v._length = 0, e = 0; e < t; e += 1) {
              var l = r * Math.cos(o),
                  c = r * Math.sin(o),
                  p = 0 === l && 0 === c ? 0 : c / Math.sqrt(l * l + c * c),
                  d = 0 === l && 0 === c ? 0 : -l / Math.sqrt(l * l + c * c);
              l += +this.p.v[0], c += +this.p.v[1], this.v.setTripleAt(l, c, l - p * a * i * s, c - d * a * i * s, l + p * a * i * s, c + d * a * i * s, e, !0), o += n * s;
            }

            this.paths.length = 0, this.paths[0] = this.v;
          }

          function convertStarToPath() {
            var e,
                t,
                n,
                r,
                i = 2 * Math.floor(this.pt.v),
                a = 2 * Math.PI / i,
                o = !0,
                s = this.or.v,
                l = this.ir.v,
                c = this.os.v,
                p = this.is.v,
                d = 2 * Math.PI * s / (2 * i),
                h = 2 * Math.PI * l / (2 * i),
                u = -Math.PI / 2;
            u += this.r.v;
            var f = 3 === this.data.d ? -1 : 1;

            for (this.v._length = 0, e = 0; e < i; e += 1) {
              n = o ? c : p, r = o ? d : h;
              var m = (t = o ? s : l) * Math.cos(u),
                  g = t * Math.sin(u),
                  v = 0 === m && 0 === g ? 0 : g / Math.sqrt(m * m + g * g),
                  b = 0 === m && 0 === g ? 0 : -m / Math.sqrt(m * m + g * g);
              m += +this.p.v[0], g += +this.p.v[1], this.v.setTripleAt(m, g, m - v * r * n * f, g - b * r * n * f, m + v * r * n * f, g + b * r * n * f, e, !0), o = !o, u += a * f;
            }
          }

          function processKeys() {
            if (this.elem.globalData.frameId !== this.frameId) {
              this.mdf = !1, this.frameId = this.elem.globalData.frameId;
              var e,
                  t = this.dynamicProperties.length;

              for (e = 0; e < t; e += 1) {
                this.dynamicProperties[e].getValue(), this.dynamicProperties[e].mdf && (this.mdf = !0);
              }

              this.mdf && this.convertToPath();
            }
          }

          return function StarShapeProperty(e, t) {
            this.v = shape_pool.newShape(), this.v.setPathData(!0, 0), this.elem = e, this.comp = e.comp, this.data = t, this.frameId = -1, this.d = t.d, this.dynamicProperties = [], this.mdf = !1, this.getValue = processKeys, this.reset = resetShape, 1 === t.sy ? (this.ir = PropertyFactory.getProp(e, t.ir, 0, 0, this.dynamicProperties), this.is = PropertyFactory.getProp(e, t.is, 0, .01, this.dynamicProperties), this.convertToPath = convertStarToPath) : this.convertToPath = convertPolygonToPath, this.pt = PropertyFactory.getProp(e, t.pt, 0, 0, this.dynamicProperties), this.p = PropertyFactory.getProp(e, t.p, 1, 0, this.dynamicProperties), this.r = PropertyFactory.getProp(e, t.r, 0, degToRads, this.dynamicProperties), this.or = PropertyFactory.getProp(e, t.or, 0, 0, this.dynamicProperties), this.os = PropertyFactory.getProp(e, t.os, 0, .01, this.dynamicProperties), this.localShapeCollection = shapeCollection_pool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : this.convertToPath();
          };
        }(),
            r = function () {
          function processKeys(e) {
            if (this.elem.globalData.frameId !== this.frameId) {
              this.mdf = !1, this.frameId = this.elem.globalData.frameId;
              var t,
                  n = this.dynamicProperties.length;

              for (t = 0; t < n; t += 1) {
                this.dynamicProperties[t].getValue(e), this.dynamicProperties[t].mdf && (this.mdf = !0);
              }

              this.mdf && this.convertRectToPath();
            }
          }

          function convertRectToPath() {
            var e = this.p.v[0],
                t = this.p.v[1],
                n = this.s.v[0] / 2,
                r = this.s.v[1] / 2,
                i = bm_min(n, r, this.r.v),
                a = i * (1 - roundCorner);
            this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(e + n, t - r + i, e + n, t - r + i, e + n, t - r + a, 0, !0), this.v.setTripleAt(e + n, t + r - i, e + n, t + r - a, e + n, t + r - i, 1, !0), 0 !== i ? (this.v.setTripleAt(e + n - i, t + r, e + n - i, t + r, e + n - a, t + r, 2, !0), this.v.setTripleAt(e - n + i, t + r, e - n + a, t + r, e - n + i, t + r, 3, !0), this.v.setTripleAt(e - n, t + r - i, e - n, t + r - i, e - n, t + r - a, 4, !0), this.v.setTripleAt(e - n, t - r + i, e - n, t - r + a, e - n, t - r + i, 5, !0), this.v.setTripleAt(e - n + i, t - r, e - n + i, t - r, e - n + a, t - r, 6, !0), this.v.setTripleAt(e + n - i, t - r, e + n - a, t - r, e + n - i, t - r, 7, !0)) : (this.v.setTripleAt(e - n, t + r, e - n + a, t + r, e - n, t + r, 2), this.v.setTripleAt(e - n, t - r, e - n, t - r + a, e - n, t - r, 3))) : (this.v.setTripleAt(e + n, t - r + i, e + n, t - r + a, e + n, t - r + i, 0, !0), 0 !== i ? (this.v.setTripleAt(e + n - i, t - r, e + n - i, t - r, e + n - a, t - r, 1, !0), this.v.setTripleAt(e - n + i, t - r, e - n + a, t - r, e - n + i, t - r, 2, !0), this.v.setTripleAt(e - n, t - r + i, e - n, t - r + i, e - n, t - r + a, 3, !0), this.v.setTripleAt(e - n, t + r - i, e - n, t + r - a, e - n, t + r - i, 4, !0), this.v.setTripleAt(e - n + i, t + r, e - n + i, t + r, e - n + a, t + r, 5, !0), this.v.setTripleAt(e + n - i, t + r, e + n - a, t + r, e + n - i, t + r, 6, !0), this.v.setTripleAt(e + n, t + r - i, e + n, t + r - i, e + n, t + r - a, 7, !0)) : (this.v.setTripleAt(e - n, t - r, e - n + a, t - r, e - n, t - r, 1, !0), this.v.setTripleAt(e - n, t + r, e - n, t + r - a, e - n, t + r, 2, !0), this.v.setTripleAt(e + n, t + r, e + n - a, t + r, e + n, t + r, 3, !0)));
          }

          return function RectShapeProperty(e, t) {
            this.v = shape_pool.newShape(), this.v.c = !0, this.localShapeCollection = shapeCollection_pool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = e, this.comp = e.comp, this.frameId = -1, this.d = t.d, this.dynamicProperties = [], this.mdf = !1, this.getValue = processKeys, this.convertRectToPath = convertRectToPath, this.reset = resetShape, this.p = PropertyFactory.getProp(e, t.p, 1, 0, this.dynamicProperties), this.s = PropertyFactory.getProp(e, t.s, 1, 0, this.dynamicProperties), this.r = PropertyFactory.getProp(e, t.r, 0, 0, this.dynamicProperties), this.dynamicProperties.length ? this.k = !0 : this.convertRectToPath();
          };
        }();

        var i = {
          getShapeProp: function getShapeProp(e, i, a, o) {
            var s;

            if (3 === a || 4 === a) {
              var l = 3 === a ? i.pt : i.ks,
                  c = l.k;
              s = 1 === l.a || c.length ? new KeyframedShapeProperty(e, i, a) : new ShapeProperty(e, i, a);
            } else 5 === a ? s = new r(e, i) : 6 === a ? s = new t(e, i) : 7 === a && (s = new n(e, i));

            return s.k && o.push(s), s;
          },
          getConstructorFunction: function getConstructorFunction() {
            return ShapeProperty;
          },
          getKeyframedConstructorFunction: function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
          }
        };
        return i;
      }(),
          ShapeModifiers = function () {
        var e = {},
            t = {};
        return e.registerModifier = function registerModifier(e, n) {
          t[e] || (t[e] = n);
        }, e.getModifier = function getModifier(e, n, r, i) {
          return new t[e](n, r, i);
        }, e;
      }();

      function ShapeModifier() {}

      function TrimModifier() {}

      function RoundCornersModifier() {}

      function RepeaterModifier() {}

      function ShapeCollection() {
        this._length = 0, this._maxLength = 4, this.shapes = Array.apply(null, {
          length: this._maxLength
        });
      }

      ShapeModifier.prototype.initModifierProperties = function () {}, ShapeModifier.prototype.addShapeToModifier = function () {}, ShapeModifier.prototype.addShape = function (e) {
        this.closed || (this.shapes.push({
          shape: e.sh,
          data: e,
          localShapeCollection: shapeCollection_pool.newShapeCollection()
        }), this.addShapeToModifier(e.sh));
      }, ShapeModifier.prototype.init = function (e, t, n) {
        this.elem = e, this.frameId = -1, this.shapes = [], this.dynamicProperties = [], this.mdf = !1, this.closed = !1, this.k = !1, this.comp = e.comp, this.initModifierProperties(e, t), this.dynamicProperties.length ? (this.k = !0, n.push(this)) : this.getValue(!0);
      }, extendPrototype(ShapeModifier, TrimModifier), TrimModifier.prototype.processKeys = function (e) {
        if (this.elem.globalData.frameId !== this.frameId || e) {
          this.mdf = !!e, this.frameId = this.elem.globalData.frameId;
          var t,
              n = this.dynamicProperties.length;

          for (t = 0; t < n; t += 1) {
            this.dynamicProperties[t].getValue(), this.dynamicProperties[t].mdf && (this.mdf = !0);
          }

          if (this.mdf || e) {
            var r = this.o.v % 360 / 360;
            r < 0 && (r += 1);
            var i = this.s.v + r,
                a = this.e.v + r;

            if (i > a) {
              var o = i;
              i = a, a = o;
            }

            this.sValue = i, this.eValue = a, this.oValue = r;
          }
        }
      }, TrimModifier.prototype.initModifierProperties = function (e, t) {
        this.sValue = 0, this.eValue = 0, this.oValue = 0, this.getValue = this.processKeys, this.s = PropertyFactory.getProp(e, t.s, 0, .01, this.dynamicProperties), this.e = PropertyFactory.getProp(e, t.e, 0, .01, this.dynamicProperties), this.o = PropertyFactory.getProp(e, t.o, 0, 0, this.dynamicProperties), this.m = t.m, this.dynamicProperties.length || this.getValue(!0);
      }, TrimModifier.prototype.calculateShapeEdges = function (e, t, n, r, i) {
        var a = [];
        t <= 1 ? a.push({
          s: e,
          e: t
        }) : e >= 1 ? a.push({
          s: e - 1,
          e: t - 1
        }) : (a.push({
          s: e,
          e: 1
        }), a.push({
          s: 0,
          e: t - 1
        }));
        var o,
            s,
            l = [],
            c = a.length;

        for (o = 0; o < c; o += 1) {
          var p, d;
          if ((s = a[o]).e * i < r || s.s * i > r + n) ;else p = s.s * i <= r ? 0 : (s.s * i - r) / n, d = s.e * i >= r + n ? 1 : (s.e * i - r) / n, l.push([p, d]);
        }

        return l.length || l.push([0, 0]), l;
      }, TrimModifier.prototype.processShapes = function (e) {
        var t,
            n,
            r,
            i,
            a,
            o = this.shapes.length,
            s = this.sValue,
            l = this.eValue,
            c = 0;
        if (l === s) for (n = 0; n < o; n += 1) {
          this.shapes[n].localShapeCollection.releaseShapes(), this.shapes[n].shape.mdf = !0, this.shapes[n].shape.paths = this.shapes[n].localShapeCollection;
        } else if (1 === l && 0 === s || 0 === l && 1 === s) {
          if (this.mdf) for (n = 0; n < o; n += 1) {
            this.shapes[n].shape.mdf = !0;
          }
        } else {
          var p,
              d,
              h = [];

          for (n = 0; n < o; n += 1) {
            if ((p = this.shapes[n]).shape.mdf || this.mdf || e || 2 === this.m) {
              if (f = (t = p.shape.paths)._length, a = 0, !p.shape.mdf && p.pathsData) a = p.totalShapeLength;else {
                for (r = [], u = 0; u < f; u += 1) {
                  i = bez.getSegmentsLength(t.shapes[u]), r.push(i), a += i.totalLength;
                }

                p.totalShapeLength = a, p.pathsData = r;
              }
              c += a, p.shape.mdf = !0;
            } else p.shape.paths = p.localShapeCollection;
          }

          var u,
              f,
              m = s,
              g = l,
              v = 0;

          for (n = o - 1; n >= 0; n -= 1) {
            if ((p = this.shapes[n]).shape.mdf) {
              if ((d = p.localShapeCollection).releaseShapes(), 2 === this.m && o > 1) {
                var b = this.calculateShapeEdges(s, l, p.totalShapeLength, v, c);
                v += p.totalShapeLength;
              } else b = [[m, g]];

              for (f = b.length, u = 0; u < f; u += 1) {
                m = b[u][0], g = b[u][1], h.length = 0, g <= 1 ? h.push({
                  s: p.totalShapeLength * m,
                  e: p.totalShapeLength * g
                }) : m >= 1 ? h.push({
                  s: p.totalShapeLength * (m - 1),
                  e: p.totalShapeLength * (g - 1)
                }) : (h.push({
                  s: p.totalShapeLength * m,
                  e: p.totalShapeLength
                }), h.push({
                  s: 0,
                  e: p.totalShapeLength * (g - 1)
                }));
                var y = this.addShapes(p, h[0]);

                if (h[0].s !== h[0].e) {
                  if (h.length > 1) if (p.shape.v.c) {
                    var x = y.pop();
                    this.addPaths(y, d), y = this.addShapes(p, h[1], x);
                  } else this.addPaths(y, d), y = this.addShapes(p, h[1]);
                  this.addPaths(y, d);
                }
              }

              p.shape.paths = d;
            }
          }
        }
        this.dynamicProperties.length || (this.mdf = !1);
      }, TrimModifier.prototype.addPaths = function (e, t) {
        var n,
            r = e.length;

        for (n = 0; n < r; n += 1) {
          t.addShape(e[n]);
        }
      }, TrimModifier.prototype.addSegment = function (e, t, n, r, i, a, o) {
        i.setXYAt(t[0], t[1], "o", a), i.setXYAt(n[0], n[1], "i", a + 1), o && i.setXYAt(e[0], e[1], "v", a), i.setXYAt(r[0], r[1], "v", a + 1);
      }, TrimModifier.prototype.addShapes = function (e, t, n) {
        var r,
            i,
            a,
            o,
            s,
            l,
            c,
            p,
            d = e.pathsData,
            h = e.shape.paths.shapes,
            u = e.shape.paths._length,
            f = 0,
            m = [],
            g = !0;

        for (n ? (s = n._length, p = n._length) : (n = shape_pool.newShape(), s = 0, p = 0), m.push(n), r = 0; r < u; r += 1) {
          for (l = d[r].lengths, n.c = h[r].c, a = h[r].c ? l.length : l.length + 1, i = 1; i < a; i += 1) {
            if (f + (o = l[i - 1]).addedLength < t.s) f += o.addedLength, n.c = !1;else {
              if (f > t.e) {
                n.c = !1;
                break;
              }

              t.s <= f && t.e >= f + o.addedLength ? (this.addSegment(h[r].v[i - 1], h[r].o[i - 1], h[r].i[i], h[r].v[i], n, s, g), g = !1) : (c = bez.getNewSegment(h[r].v[i - 1], h[r].v[i], h[r].o[i - 1], h[r].i[i], (t.s - f) / o.addedLength, (t.e - f) / o.addedLength, l[i - 1]), this.addSegment(c.pt1, c.pt3, c.pt4, c.pt2, n, s, g), g = !1, n.c = !1), f += o.addedLength, s += 1;
            }
          }

          if (h[r].c) {
            if (o = l[i - 1], f <= t.e) {
              var v = l[i - 1].addedLength;
              t.s <= f && t.e >= f + v ? (this.addSegment(h[r].v[i - 1], h[r].o[i - 1], h[r].i[0], h[r].v[0], n, s, g), g = !1) : (c = bez.getNewSegment(h[r].v[i - 1], h[r].v[0], h[r].o[i - 1], h[r].i[0], (t.s - f) / v, (t.e - f) / v, l[i - 1]), this.addSegment(c.pt1, c.pt3, c.pt4, c.pt2, n, s, g), g = !1, n.c = !1);
            } else n.c = !1;

            f += o.addedLength, s += 1;
          }

          if (n._length && (n.setXYAt(n.v[p][0], n.v[p][1], "i", p), n.setXYAt(n.v[n._length - 1][0], n.v[n._length - 1][1], "o", n._length - 1)), f > t.e) break;
          r < u - 1 && (n = shape_pool.newShape(), g = !0, m.push(n), s = 0);
        }

        return m;
      }, ShapeModifiers.registerModifier("tm", TrimModifier), extendPrototype(ShapeModifier, RoundCornersModifier), RoundCornersModifier.prototype.processKeys = function (e) {
        if (this.elem.globalData.frameId !== this.frameId || e) {
          this.mdf = !!e, this.frameId = this.elem.globalData.frameId;
          var t,
              n = this.dynamicProperties.length;

          for (t = 0; t < n; t += 1) {
            this.dynamicProperties[t].getValue(), this.dynamicProperties[t].mdf && (this.mdf = !0);
          }
        }
      }, RoundCornersModifier.prototype.initModifierProperties = function (e, t) {
        this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(e, t.r, 0, null, this.dynamicProperties), this.dynamicProperties.length || this.getValue(!0);
      }, RoundCornersModifier.prototype.processPath = function (e, t) {
        var n = shape_pool.newShape();
        n.c = e.c;
        var r,
            i,
            a,
            o,
            s,
            l,
            c,
            p,
            d,
            h,
            u,
            f,
            m,
            g = e._length,
            v = 0;

        for (r = 0; r < g; r += 1) {
          i = e.v[r], o = e.o[r], a = e.i[r], i[0] === o[0] && i[1] === o[1] && i[0] === a[0] && i[1] === a[1] ? 0 !== r && r !== g - 1 || e.c ? (s = 0 === r ? e.v[g - 1] : e.v[r - 1], c = (l = Math.sqrt(Math.pow(i[0] - s[0], 2) + Math.pow(i[1] - s[1], 2))) ? Math.min(l / 2, t) / l : 0, p = f = i[0] + (s[0] - i[0]) * c, d = m = i[1] - (i[1] - s[1]) * c, h = p - (p - i[0]) * roundCorner, u = d - (d - i[1]) * roundCorner, n.setTripleAt(p, d, h, u, f, m, v), v += 1, s = r === g - 1 ? e.v[0] : e.v[r + 1], c = (l = Math.sqrt(Math.pow(i[0] - s[0], 2) + Math.pow(i[1] - s[1], 2))) ? Math.min(l / 2, t) / l : 0, p = h = i[0] + (s[0] - i[0]) * c, d = u = i[1] + (s[1] - i[1]) * c, f = p - (p - i[0]) * roundCorner, m = d - (d - i[1]) * roundCorner, n.setTripleAt(p, d, h, u, f, m, v), v += 1) : (n.setTripleAt(i[0], i[1], o[0], o[1], a[0], a[1], v), v += 1) : (n.setTripleAt(e.v[r][0], e.v[r][1], e.o[r][0], e.o[r][1], e.i[r][0], e.i[r][1], v), v += 1);
        }

        return n;
      }, RoundCornersModifier.prototype.processShapes = function (e) {
        var t,
            n,
            r,
            i,
            a,
            o,
            s = this.shapes.length,
            l = this.rd.v;
        if (0 !== l) for (n = 0; n < s; n += 1) {
          if ((a = this.shapes[n]).shape.paths, o = a.localShapeCollection, a.shape.mdf || this.mdf || e) for (o.releaseShapes(), a.shape.mdf = !0, t = a.shape.paths.shapes, i = a.shape.paths._length, r = 0; r < i; r += 1) {
            o.addShape(this.processPath(t[r], l));
          }
          a.shape.paths = a.localShapeCollection;
        }
        this.dynamicProperties.length || (this.mdf = !1);
      }, ShapeModifiers.registerModifier("rd", RoundCornersModifier), RepeaterModifier.prototype.processKeys = function (e) {
        if (this.elem.globalData.frameId !== this.frameId || e) {
          this.mdf = !!e;
          var t,
              n = this.dynamicProperties.length;

          for (t = 0; t < n; t += 1) {
            this.dynamicProperties[t].getValue(), this.dynamicProperties[t].mdf && (this.mdf = !0);
          }
        }
      }, RepeaterModifier.prototype.initModifierProperties = function (e, t) {
        this.getValue = this.processKeys, this.c = PropertyFactory.getProp(e, t.c, 0, null, this.dynamicProperties), this.o = PropertyFactory.getProp(e, t.o, 0, null, this.dynamicProperties), this.tr = PropertyFactory.getProp(e, t.tr, 2, null, this.dynamicProperties), this.data = t, this.dynamicProperties.length || this.getValue(!0), this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
      }, RepeaterModifier.prototype.applyTransforms = function (e, t, n, r, i, a) {
        var o = a ? -1 : 1,
            s = r.s.v[0] + (1 - r.s.v[0]) * (1 - i),
            l = r.s.v[1] + (1 - r.s.v[1]) * (1 - i);
        e.translate(r.p.v[0] * o * i, r.p.v[1] * o * i, r.p.v[2]), t.translate(-r.a.v[0], -r.a.v[1], r.a.v[2]), t.rotate(-r.r.v * o * i), t.translate(r.a.v[0], r.a.v[1], r.a.v[2]), n.translate(-r.a.v[0], -r.a.v[1], r.a.v[2]), n.scale(a ? 1 / s : s, a ? 1 / l : l), n.translate(r.a.v[0], r.a.v[1], r.a.v[2]);
      }, RepeaterModifier.prototype.init = function (e, t, n, r, i) {
        this.elem = e, this.arr = t, this.pos = n, this.elemsData = r, this._currentCopies = 0, this._elements = [], this._groups = [], this.dynamicProperties = [], this.frameId = -1, this.initModifierProperties(e, t[n]);

        for (; n > 0;) {
          n -= 1, this._elements.unshift(t[n]), 1;
        }

        this.dynamicProperties.length ? (this.k = !0, i.push(this)) : this.getValue(!0);
      }, RepeaterModifier.prototype.resetElements = function (e) {
        var t,
            n = e.length;

        for (t = 0; t < n; t += 1) {
          e[t]._processed = !1, "gr" === e[t].ty && this.resetElements(e[t].it);
        }
      }, RepeaterModifier.prototype.cloneElements = function (e) {
        e.length;
        var t = JSON.parse(JSON.stringify(e));
        return this.resetElements(t), t;
      }, RepeaterModifier.prototype.changeGroupRender = function (e, t) {
        var n,
            r = e.length;

        for (n = 0; n < r; n += 1) {
          e[n]._render = t, "gr" === e[n].ty && this.changeGroupRender(e[n].it, t);
        }
      }, RepeaterModifier.prototype.processShapes = function (e) {
        if (this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.dynamicProperties.length || e || (this.mdf = !1), this.mdf)) {
          var t = Math.ceil(this.c.v);

          if (this._groups.length < t) {
            for (; this._groups.length < t;) {
              var n = {
                it: this.cloneElements(this._elements),
                ty: "gr"
              };
              n.it.push({
                a: {
                  a: 0,
                  ix: 1,
                  k: [0, 0]
                },
                nm: "Transform",
                o: {
                  a: 0,
                  ix: 7,
                  k: 100
                },
                p: {
                  a: 0,
                  ix: 2,
                  k: [0, 0]
                },
                r: {
                  a: 0,
                  ix: 6,
                  k: 0
                },
                s: {
                  a: 0,
                  ix: 3,
                  k: [100, 100]
                },
                sa: {
                  a: 0,
                  ix: 5,
                  k: 0
                },
                sk: {
                  a: 0,
                  ix: 4,
                  k: 0
                },
                ty: "tr"
              }), this.arr.splice(0, 0, n), this._groups.splice(0, 0, n), this._currentCopies += 1;
            }

            this.elem.reloadShapes();
          }

          var r,
              i,
              a = 0;

          for (r = 0; r <= this._groups.length - 1; r += 1) {
            i = a < t, this._groups[r]._render = i, this.changeGroupRender(this._groups[r].it, i), a += 1;
          }

          this._currentCopies = t, this.elem.firstFrame = !0;
          var o = this.o.v,
              s = o % 1,
              l = o > 0 ? Math.floor(o) : Math.ceil(o),
              c = (this.tr.v.props, this.pMatrix.props),
              p = this.rMatrix.props,
              d = this.sMatrix.props;
          this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
          var h = 0;

          if (o > 0) {
            for (; h < l;) {
              this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), h += 1;
            }

            s && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, s, !1), h += s);
          } else if (o < 0) {
            for (; h > l;) {
              this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), h -= 1;
            }

            s && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -s, !0), h -= s);
          }

          r = 1 === this.data.m ? 0 : this._currentCopies - 1;
          var u = 1 === this.data.m ? 1 : -1;

          for (a = this._currentCopies; a;) {
            if (0 !== h) {
              (0 !== r && 1 === u || r !== this._currentCopies - 1 && -1 === u) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(p[0], p[1], p[2], p[3], p[4], p[5], p[6], p[7], p[8], p[9], p[10], p[11], p[12], p[13], p[14], p[15]), this.matrix.transform(d[0], d[1], d[2], d[3], d[4], d[5], d[6], d[7], d[8], d[9], d[10], d[11], d[12], d[13], d[14], d[15]), this.matrix.transform(c[0], c[1], c[2], c[3], c[4], c[5], c[6], c[7], c[8], c[9], c[10], c[11], c[12], c[13], c[14], c[15]);
              var f = (g = (m = this.elemsData[r].it)[m.length - 1].transform.mProps.v.props).length;

              for (v = 0; v < f; v += 1) {
                g[v] = this.matrix.props[v];
              }

              this.matrix.reset();
            } else {
              this.matrix.reset();
              var m, g, v;
              f = (g = (m = this.elemsData[r].it)[m.length - 1].transform.mProps.v.props).length;

              for (v = 0; v < f; v += 1) {
                g[v] = this.matrix.props[v];
              }
            }

            h += 1, a -= 1, r += u;
          }
        }
      }, RepeaterModifier.prototype.addShape = function () {}, ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeCollection.prototype.addShape = function (e) {
        this._length === this._maxLength && (this.shapes = this.shapes.concat(Array.apply(null, {
          length: this._maxLength
        })), this._maxLength *= 2), this.shapes[this._length] = e, this._length += 1;
      }, ShapeCollection.prototype.releaseShapes = function () {
        var e;

        for (e = 0; e < this._length; e += 1) {
          shape_pool.release(this.shapes[e]);
        }

        this._length = 0;
      };

      var ImagePreloader = function () {
        var e;

        function imageLoaded() {
          this.loadedAssets += 1, this.loadedAssets === this.totalImages && e && e(null);
        }

        function getAssetsPath(e) {
          var t = "";

          if (this.assetsPath) {
            var n = e.p;
            -1 !== n.indexOf("images/") && (n = n.split("/")[1]), t = this.assetsPath + n;
          } else t = this.path, t += e.u ? e.u : "", t += e.p;

          return t;
        }

        function loadImage(e) {
          var t = document.createElement("img");
          t.addEventListener("load", imageLoaded.bind(this), !1), t.addEventListener("error", imageLoaded.bind(this), !1), t.src = e;
        }

        function loadAssets(t, n) {
          var r;

          for (e = n, this.totalAssets = t.length, r = 0; r < this.totalAssets; r += 1) {
            t[r].layers || (loadImage.bind(this)(getAssetsPath.bind(this)(t[r])), this.totalImages += 1);
          }
        }

        function setPath(e) {
          this.path = e || "";
        }

        function setAssetsPath(e) {
          this.assetsPath = e || "";
        }

        return function ImagePreloader() {
          this.loadAssets = loadAssets, this.setAssetsPath = setAssetsPath, this.setPath = setPath, this.assetsPath = "", this.path = "", this.totalAssets = 0, this.totalImages = 0, this.loadedAssets = 0;
        };
      }(),
          featureSupport = function () {
        var e = {
          maskType: !0
        };
        return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (e.maskType = !1), e;
      }(),
          filtersFactory = function () {
        var e = {};
        return e.createFilter = function createFilter(e) {
          var t = document.createElementNS(svgNS, "filter");
          return t.setAttribute("id", e), t.setAttribute("filterUnits", "objectBoundingBox"), t.setAttribute("x", "0%"), t.setAttribute("y", "0%"), t.setAttribute("width", "100%"), t.setAttribute("height", "100%"), t;
        }, e.createAlphaToLuminanceFilter = function createAlphaToLuminanceFilter() {
          var e = document.createElementNS(svgNS, "feColorMatrix");
          return e.setAttribute("type", "matrix"), e.setAttribute("color-interpolation-filters", "sRGB"), e.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), e;
        }, e;
      }();

      function TextAnimatorProperty(e, t, n) {
        this.mdf = !1, this._firstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._dynamicProperties = [], this._textData = e, this._renderType = t, this._elem = n, this._animatorsData = Array.apply(null, {
          length: this._textData.a.length
        }), this._pathData = {}, this._moreOptions = {
          alignment: {}
        }, this.renderedLetters = [], this.lettersChangedFlag = !1;
      }

      function LetterProps(e, t, n, r, i, a) {
        this.o = e, this.sw = t, this.sc = n, this.fc = r, this.m = i, this.p = a, this.mdf = {
          o: !0,
          sw: !!t,
          sc: !!n,
          fc: !!r,
          m: !0,
          p: !0
        };
      }

      function TextProperty(e, t, n) {
        this._frameId = -99999, this.pv = "", this.v = "", this.kf = !1, this.firstFrame = !0, this.mdf = !0, this.data = t, this.elem = e, this.keysIndex = -1, this.currentData = {
          ascent: 0,
          boxWidth: [0, 0],
          f: "",
          fStyle: "",
          fWeight: "",
          fc: "",
          j: "",
          justifyOffset: "",
          l: [],
          lh: 0,
          lineWidths: [],
          ls: "",
          of: "",
          s: "",
          sc: "",
          sw: 0,
          t: 0,
          tr: 0,
          fillColorAnim: !1,
          strokeColorAnim: !1,
          strokeWidthAnim: !1,
          yOffset: 0,
          __complete: !1
        }, this.searchProperty() ? n.push(this) : this.getValue(!0);
      }

      TextAnimatorProperty.prototype.searchProperties = function (e) {
        var t,
            n,
            r,
            i = this._textData.a.length,
            a = PropertyFactory.getProp;

        for (t = 0; t < i; t += 1) {
          n = {
            a: {},
            s: {}
          }, "r" in (r = this._textData.a[t]).a && (n.a.r = a(this._elem, r.a.r, 0, degToRads, this._dynamicProperties)), "rx" in r.a && (n.a.rx = a(this._elem, r.a.rx, 0, degToRads, this._dynamicProperties)), "ry" in r.a && (n.a.ry = a(this._elem, r.a.ry, 0, degToRads, this._dynamicProperties)), "sk" in r.a && (n.a.sk = a(this._elem, r.a.sk, 0, degToRads, this._dynamicProperties)), "sa" in r.a && (n.a.sa = a(this._elem, r.a.sa, 0, degToRads, this._dynamicProperties)), "s" in r.a && (n.a.s = a(this._elem, r.a.s, 1, .01, this._dynamicProperties)), "a" in r.a && (n.a.a = a(this._elem, r.a.a, 1, 0, this._dynamicProperties)), "o" in r.a && (n.a.o = a(this._elem, r.a.o, 0, .01, this._dynamicProperties)), "p" in r.a && (n.a.p = a(this._elem, r.a.p, 1, 0, this._dynamicProperties)), "sw" in r.a && (n.a.sw = a(this._elem, r.a.sw, 0, 0, this._dynamicProperties)), "sc" in r.a && (n.a.sc = a(this._elem, r.a.sc, 1, 0, this._dynamicProperties)), "fc" in r.a && (n.a.fc = a(this._elem, r.a.fc, 1, 0, this._dynamicProperties)), "fh" in r.a && (n.a.fh = a(this._elem, r.a.fh, 0, 0, this._dynamicProperties)), "fs" in r.a && (n.a.fs = a(this._elem, r.a.fs, 0, .01, this._dynamicProperties)), "fb" in r.a && (n.a.fb = a(this._elem, r.a.fb, 0, .01, this._dynamicProperties)), "t" in r.a && (n.a.t = a(this._elem, r.a.t, 0, 0, this._dynamicProperties)), n.s = PropertyFactory.getTextSelectorProp(this._elem, r.s, this._dynamicProperties), n.s.t = r.s.t, this._animatorsData[t] = n;
        }

        this._textData.p && "m" in this._textData.p ? (this._pathData = {
          f: a(this._elem, this._textData.p.f, 0, 0, this._dynamicProperties),
          l: a(this._elem, this._textData.p.l, 0, 0, this._dynamicProperties),
          r: this._textData.p.r,
          m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
        }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = a(this._elem, this._textData.m.a, 1, 0, this._dynamicProperties), this._dynamicProperties.length && e.push(this);
      }, TextAnimatorProperty.prototype.getMeasures = function (e, t) {
        if (this.lettersChangedFlag = t, this.mdf || this._firstFrame || t || this._hasMaskedPath && this._pathData.m.mdf) {
          this._firstFrame = !1;
          var n,
              r,
              i,
              a,
              o = this._moreOptions.alignment.v,
              s = this._animatorsData,
              l = this._textData,
              c = this.mHelper,
              p = this._renderType,
              d = this.renderedLetters.length,
              h = (this.data, e.l);

          if (this._hasMaskedPath) {
            var u = this._pathData.m;

            if (!this._pathData.n || this._pathData.mdf) {
              var f = u.v;
              this._pathData.r && (f = reversePath(f));
              var m,
                  g = {
                tLength: 0,
                segments: []
              };
              a = f._length - 1;
              var v = 0;

              for (i = 0; i < a; i += 1) {
                m = {
                  s: f.v[i],
                  e: f.v[i + 1],
                  to: [f.o[i][0] - f.v[i][0], f.o[i][1] - f.v[i][1]],
                  ti: [f.i[i + 1][0] - f.v[i + 1][0], f.i[i + 1][1] - f.v[i + 1][1]]
                }, bez.buildBezierData(m), g.tLength += m.bezierData.segmentLength, g.segments.push(m), v += m.bezierData.segmentLength;
              }

              i = a, u.v.c && (m = {
                s: f.v[i],
                e: f.v[0],
                to: [f.o[i][0] - f.v[i][0], f.o[i][1] - f.v[i][1]],
                ti: [f.i[0][0] - f.v[0][0], f.i[0][1] - f.v[0][1]]
              }, bez.buildBezierData(m), g.tLength += m.bezierData.segmentLength, g.segments.push(m), v += m.bezierData.segmentLength), this._pathData.pi = g;
            }

            g = this._pathData.pi;
            var b,
                y,
                x,
                w = this._pathData.f.v,
                E = 0,
                C = 1,
                k = 0,
                S = !0,
                _ = g.segments;
            if (w < 0 && u.v.c) for (g.tLength < Math.abs(w) && (w = -Math.abs(w) % g.tLength), C = (x = _[E = _.length - 1].bezierData.points).length - 1; w < 0;) {
              w += x[C].partialLength, (C -= 1) < 0 && (C = (x = _[E -= 1].bezierData.points).length - 1);
            }
            y = (x = _[E].bezierData.points)[C - 1];
            var M,
                L,
                P = (b = x[C]).partialLength;
          }

          a = h.length, n = 0, r = 0;
          var F,
              A,
              D,
              N,
              O = 1.2 * e.s * .714,
              z = !0;
          if (D = s.length, t) for (A = 0; A < D; A += 1) {
            s[A].s.getValue(!0);
          }
          var T,
              I,
              R,
              j,
              B,
              V,
              H,
              W,
              G,
              Z,
              q,
              U,
              K,
              X = -1,
              Y = w,
              $ = E,
              J = C,
              Q = -1,
              ee = "",
              te = this.defaultPropsArray;

          for (i = 0; i < a; i += 1) {
            if (c.reset(), B = 1, h[i].n) n = 0, r += e.yOffset, r += z ? 1 : 0, w = Y, z = !1, 0, this._hasMaskedPath && (C = J, y = (x = _[E = $].bezierData.points)[C - 1], P = (b = x[C]).partialLength, k = 0), K = Z = U = ee = "", te = this.defaultPropsArray;else {
              if (this._hasMaskedPath) {
                if (Q !== h[i].line) {
                  switch (e.j) {
                    case 1:
                      w += v - e.lineWidths[h[i].line];
                      break;

                    case 2:
                      w += (v - e.lineWidths[h[i].line]) / 2;
                  }

                  Q = h[i].line;
                }

                X !== h[i].ind && (h[X] && (w += h[X].extra), w += h[i].an / 2, X = h[i].ind), w += o[0] * h[i].an / 200;
                var ne = 0;

                for (A = 0; A < D; A += 1) {
                  "p" in (F = s[A].a) && ((T = s[A].s.getMult(h[i].anIndexes[A], l.a[A].s.totalChars)).length ? ne += F.p.v[0] * T[0] : ne += F.p.v[0] * T), "a" in F && ((T = s[A].s.getMult(h[i].anIndexes[A], l.a[A].s.totalChars)).length ? ne += F.a.v[0] * T[0] : ne += F.a.v[0] * T);
                }

                for (S = !0; S;) {
                  k + P >= w + ne || !x ? (M = (w + ne - k) / b.partialLength, R = y.point[0] + (b.point[0] - y.point[0]) * M, j = y.point[1] + (b.point[1] - y.point[1]) * M, c.translate(-o[0] * h[i].an / 200, -o[1] * O / 100), S = !1) : x && (k += b.partialLength, (C += 1) >= x.length && (C = 0, _[E += 1] ? x = _[E].bezierData.points : u.v.c ? (C = 0, x = _[E = 0].bezierData.points) : (k -= b.partialLength, x = null)), x && (y = b, P = (b = x[C]).partialLength));
                }

                I = h[i].an / 2 - h[i].add, c.translate(-I, 0, 0);
              } else I = h[i].an / 2 - h[i].add, c.translate(-I, 0, 0), c.translate(-o[0] * h[i].an / 200, -o[1] * O / 100, 0);

              for (h[i].l / 2, A = 0; A < D; A += 1) {
                "t" in (F = s[A].a) && (T = s[A].s.getMult(h[i].anIndexes[A], l.a[A].s.totalChars), this._hasMaskedPath ? T.length ? w += F.t * T[0] : w += F.t * T : T.length ? n += F.t.v * T[0] : n += F.t.v * T);
              }

              for (h[i].l / 2, e.strokeWidthAnim && (H = e.sw || 0), e.strokeColorAnim && (V = e.sc ? [e.sc[0], e.sc[1], e.sc[2]] : [0, 0, 0]), e.fillColorAnim && e.fc && (W = [e.fc[0], e.fc[1], e.fc[2]]), A = 0; A < D; A += 1) {
                "a" in (F = s[A].a) && ((T = s[A].s.getMult(h[i].anIndexes[A], l.a[A].s.totalChars)).length ? c.translate(-F.a.v[0] * T[0], -F.a.v[1] * T[1], F.a.v[2] * T[2]) : c.translate(-F.a.v[0] * T, -F.a.v[1] * T, F.a.v[2] * T));
              }

              for (A = 0; A < D; A += 1) {
                "s" in (F = s[A].a) && ((T = s[A].s.getMult(h[i].anIndexes[A], l.a[A].s.totalChars)).length ? c.scale(1 + (F.s.v[0] - 1) * T[0], 1 + (F.s.v[1] - 1) * T[1], 1) : c.scale(1 + (F.s.v[0] - 1) * T, 1 + (F.s.v[1] - 1) * T, 1));
              }

              for (A = 0; A < D; A += 1) {
                if (F = s[A].a, T = s[A].s.getMult(h[i].anIndexes[A], l.a[A].s.totalChars), "sk" in F && (T.length ? c.skewFromAxis(-F.sk.v * T[0], F.sa.v * T[1]) : c.skewFromAxis(-F.sk.v * T, F.sa.v * T)), "r" in F && (T.length ? c.rotateZ(-F.r.v * T[2]) : c.rotateZ(-F.r.v * T)), "ry" in F && (T.length ? c.rotateY(F.ry.v * T[1]) : c.rotateY(F.ry.v * T)), "rx" in F && (T.length ? c.rotateX(F.rx.v * T[0]) : c.rotateX(F.rx.v * T)), "o" in F && (T.length ? B += (F.o.v * T[0] - B) * T[0] : B += (F.o.v * T - B) * T), e.strokeWidthAnim && "sw" in F && (T.length ? H += F.sw.v * T[0] : H += F.sw.v * T), e.strokeColorAnim && "sc" in F) for (G = 0; G < 3; G += 1) {
                  T.length ? V[G] = V[G] + (F.sc.v[G] - V[G]) * T[0] : V[G] = V[G] + (F.sc.v[G] - V[G]) * T;
                }

                if (e.fillColorAnim && e.fc) {
                  if ("fc" in F) for (G = 0; G < 3; G += 1) {
                    T.length ? W[G] = W[G] + (F.fc.v[G] - W[G]) * T[0] : W[G] = W[G] + (F.fc.v[G] - W[G]) * T;
                  }
                  "fh" in F && (W = T.length ? addHueToRGB(W, F.fh.v * T[0]) : addHueToRGB(W, F.fh.v * T)), "fs" in F && (W = T.length ? addSaturationToRGB(W, F.fs.v * T[0]) : addSaturationToRGB(W, F.fs.v * T)), "fb" in F && (W = T.length ? addBrightnessToRGB(W, F.fb.v * T[0]) : addBrightnessToRGB(W, F.fb.v * T));
                }
              }

              for (A = 0; A < D; A += 1) {
                "p" in (F = s[A].a) && (T = s[A].s.getMult(h[i].anIndexes[A], l.a[A].s.totalChars), this._hasMaskedPath ? T.length ? c.translate(0, F.p.v[1] * T[0], -F.p.v[2] * T[1]) : c.translate(0, F.p.v[1] * T, -F.p.v[2] * T) : T.length ? c.translate(F.p.v[0] * T[0], F.p.v[1] * T[1], -F.p.v[2] * T[2]) : c.translate(F.p.v[0] * T, F.p.v[1] * T, -F.p.v[2] * T));
              }

              if (e.strokeWidthAnim && (Z = H < 0 ? 0 : H), e.strokeColorAnim && (q = "rgb(" + Math.round(255 * V[0]) + "," + Math.round(255 * V[1]) + "," + Math.round(255 * V[2]) + ")"), e.fillColorAnim && e.fc && (U = "rgb(" + Math.round(255 * W[0]) + "," + Math.round(255 * W[1]) + "," + Math.round(255 * W[2]) + ")"), this._hasMaskedPath) {
                if (c.translate(0, -e.ls), c.translate(0, o[1] * O / 100 + r, 0), l.p.p) {
                  L = (b.point[1] - y.point[1]) / (b.point[0] - y.point[0]);
                  var re = 180 * Math.atan(L) / Math.PI;
                  b.point[0] < y.point[0] && (re += 180), c.rotate(-re * Math.PI / 180);
                }

                c.translate(R, j, 0), w -= o[0] * h[i].an / 200, h[i + 1] && X !== h[i + 1].ind && (w += h[i].an / 2, w += e.tr / 1e3 * e.s);
              } else {
                switch (c.translate(n, r, 0), e.ps && c.translate(e.ps[0], e.ps[1] + e.ascent, 0), e.j) {
                  case 1:
                    c.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[h[i].line]), 0, 0);
                    break;

                  case 2:
                    c.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[h[i].line]) / 2, 0, 0);
                }

                c.translate(0, -e.ls), c.translate(I, 0, 0), c.translate(o[0] * h[i].an / 200, o[1] * O / 100, 0), n += h[i].l + e.tr / 1e3 * e.s;
              }

              "html" === p ? ee = c.toCSS() : "svg" === p ? ee = c.to2dCSS() : te = [c.props[0], c.props[1], c.props[2], c.props[3], c.props[4], c.props[5], c.props[6], c.props[7], c.props[8], c.props[9], c.props[10], c.props[11], c.props[12], c.props[13], c.props[14], c.props[15]], K = B;
            }
            d <= i ? (N = new LetterProps(K, Z, q, U, ee, te), this.renderedLetters.push(N), d += 1, this.lettersChangedFlag = !0) : (N = this.renderedLetters[i], this.lettersChangedFlag = N.update(K, Z, q, U, ee, te) || this.lettersChangedFlag);
          }
        }
      }, TextAnimatorProperty.prototype.getValue = function () {
        if (this._elem.globalData.frameId !== this._frameId) {
          this._frameId = this._elem.globalData.frameId;
          var e,
              t = this._dynamicProperties.length;

          for (this.mdf = !1, e = 0; e < t; e += 1) {
            this._dynamicProperties[e].getValue(), this.mdf = this._dynamicProperties[e].mdf || this.mdf;
          }
        }
      }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], LetterProps.prototype.update = function (e, t, n, r, i, a) {
        this.mdf.o = !1, this.mdf.sw = !1, this.mdf.sc = !1, this.mdf.fc = !1, this.mdf.m = !1, this.mdf.p = !1;
        var o = !1;
        return this.o !== e && (this.o = e, this.mdf.o = !0, o = !0), this.sw !== t && (this.sw = t, this.mdf.sw = !0, o = !0), this.sc !== n && (this.sc = n, this.mdf.sc = !0, o = !0), this.fc !== r && (this.fc = r, this.mdf.fc = !0, o = !0), this.m !== i && (this.m = i, this.mdf.m = !0, o = !0), !a.length || this.p[0] === a[0] && this.p[1] === a[1] && this.p[4] === a[4] && this.p[5] === a[5] && this.p[12] === a[12] && this.p[13] === a[13] || (this.p = a, this.mdf.p = !0, o = !0), o;
      }, TextProperty.prototype.setCurrentData = function (e) {
        var t = this.currentData;
        t.ascent = e.ascent, t.boxWidth = e.boxWidth ? e.boxWidth : t.boxWidth, t.f = e.f, t.fStyle = e.fStyle, t.fWeight = e.fWeight, t.fc = e.fc, t.j = e.j, t.justifyOffset = e.justifyOffset, t.l = e.l, t.lh = e.lh, t.lineWidths = e.lineWidths, t.ls = e.ls, t.of = e.of, t.s = e.s, t.sc = e.sc, t.sw = e.sw, t.t = e.t, t.tr = e.tr, t.fillColorAnim = e.fillColorAnim || t.fillColorAnim, t.strokeColorAnim = e.strokeColorAnim || t.strokeColorAnim, t.strokeWidthAnim = e.strokeWidthAnim || t.strokeWidthAnim, t.yOffset = e.yOffset, t.__complete = !1;
      }, TextProperty.prototype.searchProperty = function () {
        return this.kf = this.data.d.k.length > 1, this.kf;
      }, TextProperty.prototype.getValue = function () {
        this.mdf = !1;
        var e = this.elem.globalData.frameId;

        if (e !== this._frameId && this.kf || this.firstFrame) {
          for (var t, n = this.data.d.k, r = 0, i = n.length; r <= i - 1 && (t = n[r].s, !(r === i - 1 || n[r + 1].t > e));) {
            r += 1;
          }

          this.keysIndex !== r && (t.__complete || this.completeTextData(t), this.setCurrentData(t), this.mdf = !this.firstFrame, this.pv = this.v = this.currentData.t, this.keysIndex = r), this._frameId = e;
        }
      }, TextProperty.prototype.completeTextData = function (e) {
        e.__complete = !0;
        var t,
            n,
            r,
            i,
            a,
            o,
            s,
            l = this.elem.globalData.fontManager,
            c = this.data,
            p = [],
            d = 0,
            h = c.m.g,
            u = 0,
            f = 0,
            m = 0,
            g = [],
            v = 0,
            b = 0,
            y = l.getFontByName(e.f),
            x = 0,
            w = y.fStyle.split(" "),
            E = "normal",
            C = "normal";

        for (n = w.length, t = 0; t < n; t += 1) {
          switch (w[t].toLowerCase()) {
            case "italic":
              C = "italic";
              break;

            case "bold":
              E = "700";
              break;

            case "black":
              E = "900";
              break;

            case "medium":
              E = "500";
              break;

            case "regular":
            case "normal":
              E = "400";

            case "light":
            case "thin":
              E = "200";
          }
        }

        e.fWeight = E, e.fStyle = C, n = e.t.length;
        var k = e.tr / 1e3 * e.s;

        if (e.sz) {
          var S = e.sz[0],
              _ = -1;

          for (t = 0; t < n; t += 1) {
            r = !1, " " === e.t.charAt(t) ? _ = t : 13 === e.t.charCodeAt(t) && (v = 0, r = !0), l.chars ? (s = l.getCharData(e.t.charAt(t), y.fStyle, y.fFamily), x = r ? 0 : s.w * e.s / 100) : x = l.measureText(e.t.charAt(t), e.f, e.s), v + x > S && " " !== e.t.charAt(t) ? (-1 === _ ? n += 1 : t = _, e.t = e.t.substr(0, t) + "\r" + e.t.substr(t === _ ? t + 1 : t), _ = -1, v = 0) : (v += x, v += k);
          }

          n = e.t.length;
        }

        v = -k, x = 0;
        var M,
            L = 0;

        for (t = 0; t < n; t += 1) {
          if (r = !1, " " === (M = e.t.charAt(t)) ? i = "\xa0" : 13 === M.charCodeAt(0) ? (L = 0, g.push(v), b = v > b ? v : b, v = -2 * k, i = "", r = !0, m += 1) : i = e.t.charAt(t), l.chars ? (s = l.getCharData(M, y.fStyle, l.getFontByName(e.f).fFamily), x = r ? 0 : s.w * e.s / 100) : x = l.measureText(i, e.f, e.s), " " === M ? L += x + k : (v += x + k + L, L = 0), p.push({
            l: x,
            an: x,
            add: u,
            n: r,
            anIndexes: [],
            val: i,
            line: m
          }), 2 == h) {
            if (u += x, "" == i || "\xa0" == i || t == n - 1) {
              for ("" != i && "\xa0" != i || (u -= x); f <= t;) {
                p[f].an = u, p[f].ind = d, p[f].extra = x, f += 1;
              }

              d += 1, u = 0;
            }
          } else if (3 == h) {
            if (u += x, "" == i || t == n - 1) {
              for ("" == i && (u -= x); f <= t;) {
                p[f].an = u, p[f].ind = d, p[f].extra = x, f += 1;
              }

              u = 0, d += 1;
            }
          } else p[d].ind = d, p[d].extra = 0, d += 1;
        }

        if (e.l = p, b = v > b ? v : b, g.push(v), e.sz) e.boxWidth = e.sz[0], e.justifyOffset = 0;else switch (e.boxWidth = b, e.j) {
          case 1:
            e.justifyOffset = -e.boxWidth;
            break;

          case 2:
            e.justifyOffset = -e.boxWidth / 2;
            break;

          default:
            e.justifyOffset = 0;
        }
        e.lineWidths = g;
        var P,
            F,
            A = c.a;
        o = A.length;
        var D,
            N,
            O = [];

        for (a = 0; a < o; a += 1) {
          for ((P = A[a]).a.sc && (e.strokeColorAnim = !0), P.a.sw && (e.strokeWidthAnim = !0), (P.a.fc || P.a.fh || P.a.fs || P.a.fb) && (e.fillColorAnim = !0), N = 0, D = P.s.b, t = 0; t < n; t += 1) {
            (F = p[t]).anIndexes[a] = N, (1 == D && "" != F.val || 2 == D && "" != F.val && "\xa0" != F.val || 3 == D && (F.n || "\xa0" == F.val || t == n - 1) || 4 == D && (F.n || t == n - 1)) && (1 === P.s.rn && O.push(N), N += 1);
          }

          c.a[a].s.totalChars = N;
          var z,
              T = -1;
          if (1 === P.s.rn) for (t = 0; t < n; t += 1) {
            T != (F = p[t]).anIndexes[a] && (T = F.anIndexes[a], z = O.splice(Math.floor(Math.random() * O.length), 1)[0]), F.anIndexes[a] = z;
          }
        }

        e.yOffset = e.lh || 1.2 * e.s, e.ls = e.ls || 0, e.ascent = y.ascent * e.s / 100;
      }, TextProperty.prototype.updateDocumentData = function (e, t) {
        t = void 0 === t ? this.keysIndex : t;
        var n = this.data.d.k[t].s;
        n.__complete = !1, n.t = e.t, this.keysIndex = -1, this.firstFrame = !0, this.getValue();
      };

      var pooling = function () {
        return {
          double: function double(e) {
            return e.concat(Array.apply(null, {
              length: e.length
            }));
          }
        };
      }(),
          point_pool = function () {
        var e = {
          newPoint: function newPoint() {
            var e;
            e = t ? r[t -= 1] : [.1, .1];
            return e;
          },
          release: function release(e) {
            t === n && (r = pooling.double(r), n *= 2);
            r[t] = e, t += 1;
          }
        },
            t = 0,
            n = 8,
            r = Array.apply(null, {
          length: n
        });
        return e;
      }(),
          shape_pool = function () {
        var e = {
          clone: function clone(e, t) {
            var n,
                r,
                i = void 0 === e._length ? e.v.length : e._length,
                a = newShape();

            for (a.setLength(i), a.c = e.c, n = 0; n < i; n += 1) {
              t ? (r = t.applyToPointArray(e.v[n][0], e.v[n][1], 0, 2), a.setXYAt(r[0], r[1], "v", n), point_pool.release(r), r = t.applyToPointArray(e.o[n][0], e.o[n][1], 0, 2), a.setXYAt(r[0], r[1], "o", n), point_pool.release(r), r = t.applyToPointArray(e.i[n][0], e.i[n][1], 0, 2), a.setXYAt(r[0], r[1], "i", n), point_pool.release(r)) : a.setTripleAt(e.v[n][0], e.v[n][1], e.o[n][0], e.o[n][1], e.i[n][0], e.i[n][1], n);
            }

            return a;
          },
          newShape: newShape,
          release: release,
          releaseArray: function releaseArray(e, t) {
            for (; t--;) {
              release(e[t]);
            }
          }
        },
            t = 0,
            n = 4,
            r = Array.apply(null, {
          length: n
        });

        function newShape() {
          return t ? r[t -= 1] : new ShapePath();
        }

        function release(e) {
          t === n && (r = pooling.double(r), n *= 2);
          var i,
              a = e._length;

          for (i = 0; i < a; i += 1) {
            point_pool.release(e.v[i]), point_pool.release(e.i[i]), point_pool.release(e.o[i]), e.v[i] = null, e.i[i] = null, e.o[i] = null;
          }

          e._length = 0, e.c = !1, r[t] = e, t += 1;
        }

        return e;
      }(),
          shapeCollection_pool = function () {
        var e = {
          newShapeCollection: function newShapeCollection() {
            var e;
            e = t ? r[t -= 1] : new ShapeCollection();
            return e;
          },
          release: release,
          clone: function clone(e, i) {
            release(e), t === n && (r = pooling.double(r), n *= 2);
            r[t] = e, t += 1;
          }
        },
            t = 0,
            n = 4,
            r = Array.apply(null, {
          length: n
        });

        function release(e) {
          var i,
              a = e._length;

          for (i = 0; i < a; i += 1) {
            shape_pool.release(e.shapes[i]);
          }

          e._length = 0, t === n && (r = pooling.double(r), n *= 2), r[t] = e, t += 1;
        }

        return e;
      }();

      function BaseRenderer() {}

      function SVGRenderer(e, t) {
        this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.globalData = {
          frameNum: -1
        }, this.renderConfig = {
          preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
          progressiveLoad: t && t.progressiveLoad || !1,
          hideOnTransparent: !t || !1 !== t.hideOnTransparent,
          viewBoxOnly: t && t.viewBoxOnly || !1,
          className: t && t.className || ""
        }, this.globalData.renderConfig = this.renderConfig, this.elements = [], this.pendingElements = [], this.destroyed = !1;
      }

      function MaskElement(e, t, n) {
        this.dynamicProperties = [], this.data = e, this.element = t, this.globalData = n, this.storedData = [], this.masksProperties = this.data.masksProperties, this.viewData = Array.apply(null, {
          length: this.masksProperties.length
        }), this.maskElement = null, this.firstFrame = !0;
        var r,
            i,
            a,
            o,
            s,
            l,
            c,
            p,
            d = this.globalData.defs,
            h = this.masksProperties.length,
            u = this.masksProperties,
            f = 0,
            m = [],
            g = randomString(10),
            v = "clipPath",
            b = "clip-path";

        for (r = 0; r < h; r++) {
          if (("a" !== u[r].mode && "n" !== u[r].mode || u[r].inv || 100 !== u[r].o.k) && (v = "mask", b = "mask"), "s" != u[r].mode && "i" != u[r].mode || 0 != f ? s = null : ((s = document.createElementNS(svgNS, "rect")).setAttribute("fill", "#ffffff"), s.setAttribute("width", this.element.comp.data.w), s.setAttribute("height", this.element.comp.data.h), m.push(s)), i = document.createElementNS(svgNS, "path"), "n" != u[r].mode) {
            if (f += 1, "s" == u[r].mode ? i.setAttribute("fill", "#000000") : i.setAttribute("fill", "#ffffff"), i.setAttribute("clip-rule", "nonzero"), 0 !== u[r].x.k) {
              v = "mask", b = "mask", p = PropertyFactory.getProp(this.element, u[r].x, 0, null, this.dynamicProperties);
              var y = "fi_" + randomString(10);
              (l = document.createElementNS(svgNS, "filter")).setAttribute("id", y), (c = document.createElementNS(svgNS, "feMorphology")).setAttribute("operator", "dilate"), c.setAttribute("in", "SourceGraphic"), c.setAttribute("radius", "0"), l.appendChild(c), d.appendChild(l), "s" == u[r].mode ? i.setAttribute("stroke", "#000000") : i.setAttribute("stroke", "#ffffff");
            } else c = null, p = null;

            if (this.storedData[r] = {
              elem: i,
              x: p,
              expan: c,
              lastPath: "",
              lastOperator: "",
              filterId: y,
              lastRadius: 0
            }, "i" == u[r].mode) {
              o = m.length;
              var x = document.createElementNS(svgNS, "g");

              for (a = 0; a < o; a += 1) {
                x.appendChild(m[a]);
              }

              var w = document.createElementNS(svgNS, "mask");
              w.setAttribute("mask-type", "alpha"), w.setAttribute("id", g + "_" + f), w.appendChild(i), d.appendChild(w), x.setAttribute("mask", "url(" + locationHref + "#" + g + "_" + f + ")"), m.length = 0, m.push(x);
            } else m.push(i);

            u[r].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[r] = {
              elem: i,
              lastPath: "",
              op: PropertyFactory.getProp(this.element, u[r].o, 0, .01, this.dynamicProperties),
              prop: ShapePropertyFactory.getShapeProp(this.element, u[r], 3, this.dynamicProperties, null)
            }, s && (this.viewData[r].invRect = s), this.viewData[r].prop.k || this.drawPath(u[r], this.viewData[r].prop.v, this.viewData[r]);
          } else this.viewData[r] = {
            op: PropertyFactory.getProp(this.element, u[r].o, 0, .01, this.dynamicProperties),
            prop: ShapePropertyFactory.getShapeProp(this.element, u[r], 3, this.dynamicProperties, null),
            elem: i
          }, d.appendChild(i);
        }

        for (this.maskElement = document.createElementNS(svgNS, v), h = m.length, r = 0; r < h; r += 1) {
          this.maskElement.appendChild(m[r]);
        }

        this.maskElement.setAttribute("id", g), f > 0 && this.element.maskedElement.setAttribute(b, "url(" + locationHref + "#" + g + ")"), d.appendChild(this.maskElement);
      }

      function BaseElement() {}

      function SVGBaseElement(e, t, n, r, i) {
        this.globalData = n, this.comp = r, this.data = e, this.matteElement = null, this.transformedElement = null, this.isTransparent = !1, this.parentContainer = t, this.layerId = i ? i.layerId : "ly_" + randomString(10), this.placeholder = i, this._sizeChanged = !1, this.init();
      }

      function IShapeElement(e, t, n, r, i) {
        this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this._parent.constructor.call(this, e, t, n, r, i);
      }

      BaseRenderer.prototype.checkLayers = function (e) {
        var t,
            n,
            r = this.layers.length;

        for (this.completeLayers = !0, t = r - 1; t >= 0; t--) {
          this.elements[t] || (n = this.layers[t]).ip - n.st <= e - this.layers[t].st && n.op - n.st > e - this.layers[t].st && this.buildItem(t), this.completeLayers = !!this.elements[t] && this.completeLayers;
        }

        this.checkPendingElements();
      }, BaseRenderer.prototype.createItem = function (e) {
        switch (e.ty) {
          case 2:
            return this.createImage(e);

          case 0:
            return this.createComp(e);

          case 1:
            return this.createSolid(e);

          case 4:
            return this.createShape(e);

          case 5:
            return this.createText(e);

          case 13:
            return this.createCamera(e);

          case 99:
            return null;
        }

        return this.createBase(e);
      }, BaseRenderer.prototype.createCamera = function () {
        throw new Error("You're using a 3d camera. Try the html renderer.");
      }, BaseRenderer.prototype.buildAllItems = function () {
        var e,
            t = this.layers.length;

        for (e = 0; e < t; e += 1) {
          this.buildItem(e);
        }

        this.checkPendingElements();
      }, BaseRenderer.prototype.includeLayers = function (e) {
        this.completeLayers = !1;
        var t,
            n,
            r = e.length,
            i = this.layers.length;

        for (t = 0; t < r; t += 1) {
          for (n = 0; n < i;) {
            if (this.layers[n].id == e[t].id) {
              this.layers[n] = e[t];
              break;
            }

            n += 1;
          }
        }
      }, BaseRenderer.prototype.setProjectInterface = function (e) {
        this.globalData.projectInterface = e;
      }, BaseRenderer.prototype.initItems = function () {
        this.globalData.progressiveLoad || this.buildAllItems();
      }, BaseRenderer.prototype.buildElementParenting = function (e, t, n) {
        n = n || [];

        for (var r = this.elements, i = this.layers, a = 0, o = i.length; a < o;) {
          i[a].ind == t && (r[a] && !0 !== r[a] ? void 0 !== i[a].parent ? (n.push(r[a]), r[a]._isParent = !0, this.buildElementParenting(e, i[a].parent, n)) : (n.push(r[a]), r[a]._isParent = !0, e.setHierarchy(n)) : (this.buildItem(a), this.addPendingElement(e))), a += 1;
        }
      }, BaseRenderer.prototype.addPendingElement = function (e) {
        this.pendingElements.push(e);
      }, extendPrototype(BaseRenderer, SVGRenderer), SVGRenderer.prototype.createBase = function (e) {
        return new SVGBaseElement(e, this.layerElement, this.globalData, this);
      }, SVGRenderer.prototype.createShape = function (e) {
        return new IShapeElement(e, this.layerElement, this.globalData, this);
      }, SVGRenderer.prototype.createText = function (e) {
        return new SVGTextElement(e, this.layerElement, this.globalData, this);
      }, SVGRenderer.prototype.createImage = function (e) {
        return new IImageElement(e, this.layerElement, this.globalData, this);
      }, SVGRenderer.prototype.createComp = function (e) {
        return new ICompElement(e, this.layerElement, this.globalData, this);
      }, SVGRenderer.prototype.createSolid = function (e) {
        return new ISolidElement(e, this.layerElement, this.globalData, this);
      }, SVGRenderer.prototype.configAnimation = function (e) {
        this.layerElement = document.createElementNS(svgNS, "svg"), this.layerElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.layerElement.setAttribute("viewBox", "0 0 " + e.w + " " + e.h), this.renderConfig.viewBoxOnly || (this.layerElement.setAttribute("width", e.w), this.layerElement.setAttribute("height", e.h), this.layerElement.style.width = "100%", this.layerElement.style.height = "100%"), this.renderConfig.className && this.layerElement.setAttribute("class", this.renderConfig.className), this.layerElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.layerElement);
        var t = document.createElementNS(svgNS, "defs");
        this.globalData.defs = t, this.layerElement.appendChild(t), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.frameId = 0, this.globalData.nm = e.nm, this.globalData.compSize = {
          w: e.w,
          h: e.h
        }, this.data = e, this.globalData.frameRate = e.fr;
        var n = document.createElementNS(svgNS, "clipPath"),
            r = document.createElementNS(svgNS, "rect");
        r.setAttribute("width", e.w), r.setAttribute("height", e.h), r.setAttribute("x", 0), r.setAttribute("y", 0);
        var i = "animationMask_" + randomString(10);
        n.setAttribute("id", i), n.appendChild(r);
        var a = document.createElementNS(svgNS, "g");
        a.setAttribute("clip-path", "url(" + locationHref + "#" + i + ")"), this.layerElement.appendChild(a), t.appendChild(n), this.layerElement = a, this.layers = e.layers, this.globalData.fontManager = new FontManager(), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, t), this.elements = Array.apply(null, {
          length: e.layers.length
        });
      }, SVGRenderer.prototype.destroy = function () {
        this.animationItem.wrapper.innerHTML = "", this.layerElement = null, this.globalData.defs = null;
        var e,
            t = this.layers ? this.layers.length : 0;

        for (e = 0; e < t; e++) {
          this.elements[e] && this.elements[e].destroy();
        }

        this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
      }, SVGRenderer.prototype.updateContainerSize = function () {}, SVGRenderer.prototype.buildItem = function (e) {
        var t = this.elements;

        if (!t[e] && 99 != this.layers[e].ty) {
          t[e] = !0;
          var n = this.createItem(this.layers[e]);
          t[e] = n, expressionsPlugin && (0 === this.layers[e].ty && this.globalData.projectInterface.registerComposition(n), n.initExpressions()), this.appendElementInPos(n, e), this.layers[e].tt && (this.elements[e - 1] && !0 !== this.elements[e - 1] ? n.setMatte(t[e - 1].layerId) : (this.buildItem(e - 1), this.addPendingElement(n)));
        }
      }, SVGRenderer.prototype.checkPendingElements = function () {
        for (; this.pendingElements.length;) {
          var e = this.pendingElements.pop();
          if (e.checkParenting(), e.data.tt) for (var t = 0, n = this.elements.length; t < n;) {
            if (this.elements[t] === e) {
              e.setMatte(this.elements[t - 1].layerId);
              break;
            }

            t += 1;
          }
        }
      }, SVGRenderer.prototype.renderFrame = function (e) {
        if (this.renderedFrame != e && !this.destroyed) {
          null === e ? e = this.renderedFrame : this.renderedFrame = e, this.globalData.frameNum = e, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = e;
          var t,
              n = this.layers.length;

          for (this.completeLayers || this.checkLayers(e), t = n - 1; t >= 0; t--) {
            (this.completeLayers || this.elements[t]) && this.elements[t].prepareFrame(e - this.layers[t].st);
          }

          for (t = n - 1; t >= 0; t--) {
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
          }
        }
      }, SVGRenderer.prototype.appendElementInPos = function (e, t) {
        var n = e.getBaseElement();

        if (n) {
          for (var r, i = 0; i < t;) {
            this.elements[i] && !0 !== this.elements[i] && this.elements[i].getBaseElement() && (r = this.elements[i].getBaseElement()), i += 1;
          }

          r ? this.layerElement.insertBefore(n, r) : this.layerElement.appendChild(n);
        }
      }, SVGRenderer.prototype.hide = function () {
        this.layerElement.style.display = "none";
      }, SVGRenderer.prototype.show = function () {
        this.layerElement.style.display = "block";
      }, SVGRenderer.prototype.searchExtraCompositions = function (e) {
        var t,
            n = e.length,
            r = document.createElementNS(svgNS, "g");

        for (t = 0; t < n; t += 1) {
          if (e[t].xt) {
            var i = this.createComp(e[t], r, this.globalData.comp, null);
            i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
          }
        }
      }, MaskElement.prototype.getMaskProperty = function (e) {
        return this.viewData[e].prop;
      }, MaskElement.prototype.prepareFrame = function () {
        var e,
            t = this.dynamicProperties.length;

        for (e = 0; e < t; e += 1) {
          this.dynamicProperties[e].getValue();
        }
      }, MaskElement.prototype.renderFrame = function (e) {
        var t,
            n = this.masksProperties.length;

        for (t = 0; t < n; t++) {
          if ((this.viewData[t].prop.mdf || this.firstFrame) && this.drawPath(this.masksProperties[t], this.viewData[t].prop.v, this.viewData[t]), (this.viewData[t].op.mdf || this.firstFrame) && this.viewData[t].elem.setAttribute("fill-opacity", this.viewData[t].op.v), "n" !== this.masksProperties[t].mode && (this.viewData[t].invRect && (this.element.finalTransform.mProp.mdf || this.firstFrame) && (this.viewData[t].invRect.setAttribute("x", -e.props[12]), this.viewData[t].invRect.setAttribute("y", -e.props[13])), this.storedData[t].x && (this.storedData[t].x.mdf || this.firstFrame))) {
            var r = this.storedData[t].expan;
            this.storedData[t].x.v < 0 ? ("erode" !== this.storedData[t].lastOperator && (this.storedData[t].lastOperator = "erode", this.storedData[t].elem.setAttribute("filter", "url(" + locationHref + "#" + this.storedData[t].filterId + ")")), r.setAttribute("radius", -this.storedData[t].x.v)) : ("dilate" !== this.storedData[t].lastOperator && (this.storedData[t].lastOperator = "dilate", this.storedData[t].elem.setAttribute("filter", null)), this.storedData[t].elem.setAttribute("stroke-width", 2 * this.storedData[t].x.v));
          }
        }

        this.firstFrame = !1;
      }, MaskElement.prototype.getMaskelement = function () {
        return this.maskElement;
      }, MaskElement.prototype.createLayerSolidPath = function () {
        var e = "M0,0 ";
        return e += " h" + this.globalData.compSize.w, e += " v" + this.globalData.compSize.h, e += " h-" + this.globalData.compSize.w, e += " v-" + this.globalData.compSize.h + " ";
      }, MaskElement.prototype.drawPath = function (e, t, n) {
        var r,
            i,
            a = " M" + t.v[0][0] + "," + t.v[0][1];

        for (i = t._length, r = 1; r < i; r += 1) {
          a += " C" + bm_rnd(t.o[r - 1][0]) + "," + bm_rnd(t.o[r - 1][1]) + " " + bm_rnd(t.i[r][0]) + "," + bm_rnd(t.i[r][1]) + " " + bm_rnd(t.v[r][0]) + "," + bm_rnd(t.v[r][1]);
        }

        t.c && i > 1 && (a += " C" + bm_rnd(t.o[r - 1][0]) + "," + bm_rnd(t.o[r - 1][1]) + " " + bm_rnd(t.i[0][0]) + "," + bm_rnd(t.i[0][1]) + " " + bm_rnd(t.v[0][0]) + "," + bm_rnd(t.v[0][1])), n.lastPath !== a && (n.elem && (t.c ? e.inv ? n.elem.setAttribute("d", this.solidPath + a) : n.elem.setAttribute("d", a) : n.elem.setAttribute("d", "")), n.lastPath = a);
      }, MaskElement.prototype.destroy = function () {
        this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
      }, BaseElement.prototype.checkMasks = function () {
        if (!this.data.hasMask) return !1;

        for (var e = 0, t = this.data.masksProperties.length; e < t;) {
          if ("n" !== this.data.masksProperties[e].mode && !1 !== this.data.masksProperties[e].cl) return !0;
          e += 1;
        }

        return !1;
      }, BaseElement.prototype.checkParenting = function () {
        void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent);
      }, BaseElement.prototype.prepareFrame = function (e) {
        this.data.ip - this.data.st <= e && this.data.op - this.data.st > e ? !0 !== this.isVisible && (this.elemMdf = !0, this.globalData.mdf = !0, this.isVisible = !0, this.firstFrame = !0, this.data.hasMask && (this.maskManager.firstFrame = !0)) : !1 !== this.isVisible && (this.elemMdf = !0, this.globalData.mdf = !0, this.isVisible = !1);
        var t,
            n = this.dynamicProperties.length;

        for (t = 0; t < n; t += 1) {
          (this.isVisible || this._isParent && "transform" === this.dynamicProperties[t].type) && (this.dynamicProperties[t].getValue(), this.dynamicProperties[t].mdf && (this.elemMdf = !0, this.globalData.mdf = !0));
        }

        return this.data.hasMask && this.isVisible && this.maskManager.prepareFrame(e * this.data.sr), this.currentFrameNum = e * this.data.sr, this.isVisible;
      }, BaseElement.prototype.globalToLocal = function (e) {
        var t = [];
        t.push(this.finalTransform);

        for (var n = !0, r = this.comp; n;) {
          r.finalTransform ? (r.data.hasMask && t.splice(0, 0, r.finalTransform), r = r.comp) : n = !1;
        }

        var i,
            a,
            o = t.length;

        for (i = 0; i < o; i += 1) {
          a = t[i].mat.applyToPointArray(0, 0, 0), e = [e[0] - a[0], e[1] - a[1], 0];
        }

        return e;
      }, BaseElement.prototype.initExpressions = function () {
        this.layerInterface = LayerExpressionInterface(this), this.data.hasMask && this.layerInterface.registerMaskInterface(this.maskManager);
        var e = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
        this.layerInterface.registerEffectsInterface(e), 0 === this.data.ty || this.data.xt ? this.compInterface = CompExpressionInterface(this) : 4 === this.data.ty ? this.layerInterface.shapeInterface = ShapeExpressionInterface.createShapeInterface(this.shapesData, this.itemsData, this.layerInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = TextExpressionInterface(this));
      }, BaseElement.prototype.setBlendMode = function () {
        var e = "";

        switch (this.data.bm) {
          case 1:
            e = "multiply";
            break;

          case 2:
            e = "screen";
            break;

          case 3:
            e = "overlay";
            break;

          case 4:
            e = "darken";
            break;

          case 5:
            e = "lighten";
            break;

          case 6:
            e = "color-dodge";
            break;

          case 7:
            e = "color-burn";
            break;

          case 8:
            e = "hard-light";
            break;

          case 9:
            e = "soft-light";
            break;

          case 10:
            e = "difference";
            break;

          case 11:
            e = "exclusion";
            break;

          case 12:
            e = "hue";
            break;

          case 13:
            e = "saturation";
            break;

          case 14:
            e = "color";
            break;

          case 15:
            e = "luminosity";
        }

        (this.baseElement || this.layerElement).style["mix-blend-mode"] = e;
      }, BaseElement.prototype.init = function () {
        this.data.sr || (this.data.sr = 1), this.dynamicProperties = this.dynamicProperties || [], this.data.ef && (this.effects = new EffectsManager(this.data, this, this.dynamicProperties)), this.hidden = !1, this.firstFrame = !0, this.isVisible = !1, this._isParent = !1, this.currentFrameNum = -99999, this.lastNum = -99999, this.data.ks && (this.finalTransform = {
          mProp: PropertyFactory.getProp(this, this.data.ks, 2, null, this.dynamicProperties),
          matMdf: !1,
          opMdf: !1,
          mat: new Matrix(),
          opacity: 1
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.finalTransform.op = this.finalTransform.mProp.o, this.transform = this.finalTransform.mProp, 11 !== this.data.ty && this.createElements(), this.data.hasMask && this.addMasks(this.data)), this.elemMdf = !1;
      }, BaseElement.prototype.getType = function () {
        return this.type;
      }, BaseElement.prototype.resetHierarchy = function () {
        this.hierarchy ? this.hierarchy.length = 0 : this.hierarchy = [];
      }, BaseElement.prototype.getHierarchy = function () {
        return this.hierarchy || (this.hierarchy = []), this.hierarchy;
      }, BaseElement.prototype.setHierarchy = function (e) {
        this.hierarchy = e;
      }, BaseElement.prototype.getLayerSize = function () {
        return 5 === this.data.ty ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }, BaseElement.prototype.hide = function () {}, BaseElement.prototype.sourceRectAtTime = function () {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      }, BaseElement.prototype.mHelper = new Matrix(), createElement(BaseElement, SVGBaseElement), SVGBaseElement.prototype.createElements = function () {
        this.layerElement = document.createElementNS(svgNS, "g"), this.transformedElement = this.layerElement, this.data.hasMask && (this.maskedElement = this.layerElement);
        var e = null;

        if (this.data.td) {
          if (3 == this.data.td || 1 == this.data.td) {
            var t = document.createElementNS(svgNS, "mask");

            if (t.setAttribute("id", this.layerId), t.setAttribute("mask-type", 3 == this.data.td ? "luminance" : "alpha"), t.appendChild(this.layerElement), e = t, this.globalData.defs.appendChild(t), !featureSupport.maskType && 1 == this.data.td) {
              t.setAttribute("mask-type", "luminance");
              var n = randomString(10),
                  r = filtersFactory.createFilter(n);
              this.globalData.defs.appendChild(r), r.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (l = document.createElementNS(svgNS, "g")).appendChild(this.layerElement), e = l, t.appendChild(l), l.setAttribute("filter", "url(" + locationHref + "#" + n + ")");
            }
          } else if (2 == this.data.td) {
            var i = document.createElementNS(svgNS, "mask");
            i.setAttribute("id", this.layerId), i.setAttribute("mask-type", "alpha");
            var a = document.createElementNS(svgNS, "g");
            i.appendChild(a);
            n = randomString(10), r = filtersFactory.createFilter(n);
            var o = document.createElementNS(svgNS, "feColorMatrix");
            o.setAttribute("type", "matrix"), o.setAttribute("color-interpolation-filters", "sRGB"), o.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1"), r.appendChild(o), this.globalData.defs.appendChild(r);
            var s = document.createElementNS(svgNS, "rect");

            if (s.setAttribute("width", this.comp.data.w), s.setAttribute("height", this.comp.data.h), s.setAttribute("x", "0"), s.setAttribute("y", "0"), s.setAttribute("fill", "#ffffff"), s.setAttribute("opacity", "0"), a.setAttribute("filter", "url(" + locationHref + "#" + n + ")"), a.appendChild(s), a.appendChild(this.layerElement), e = a, !featureSupport.maskType) {
              i.setAttribute("mask-type", "luminance"), r.appendChild(filtersFactory.createAlphaToLuminanceFilter());
              var l = document.createElementNS(svgNS, "g");
              a.appendChild(s), l.appendChild(this.layerElement), e = l, a.appendChild(l);
            }

            this.globalData.defs.appendChild(i);
          }
        } else (this.data.hasMask || this.data.tt) && this.data.tt ? (this.matteElement = document.createElementNS(svgNS, "g"), this.matteElement.appendChild(this.layerElement), e = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;

        if (!this.data.ln && !this.data.cl || 4 !== this.data.ty && 0 !== this.data.ty || (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl)), 0 === this.data.ty) {
          var c = document.createElementNS(svgNS, "clipPath"),
              p = document.createElementNS(svgNS, "path");
          p.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var d = "cp_" + randomString(8);

          if (c.setAttribute("id", d), c.appendChild(p), this.globalData.defs.appendChild(c), this.checkMasks()) {
            var h = document.createElementNS(svgNS, "g");
            h.setAttribute("clip-path", "url(" + locationHref + "#" + d + ")"), h.appendChild(this.layerElement), this.transformedElement = h, e ? e.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else this.layerElement.setAttribute("clip-path", "url(" + locationHref + "#" + d + ")");
        }

        0 !== this.data.bm && this.setBlendMode(), this.layerElement !== this.parentContainer && (this.placeholder = null), this.data.ef && (this.effectsManager = new SVGEffects(this)), this.checkParenting();
      }, SVGBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode, SVGBaseElement.prototype.renderFrame = function (e) {
        if (3 === this.data.ty || this.data.hd || !this.isVisible) return !1;
        var t;
        this.lastNum = this.currentFrameNum, this.finalTransform.opMdf = this.firstFrame || this.finalTransform.op.mdf, this.finalTransform.matMdf = this.firstFrame || this.finalTransform.mProp.mdf, this.finalTransform.opacity = this.finalTransform.op.v;
        var n = this.finalTransform.mat;

        if (this.hierarchy) {
          var r = 0,
              i = this.hierarchy.length;
          if (!this.finalTransform.matMdf) for (; r < i;) {
            if (this.hierarchy[r].finalTransform.mProp.mdf) {
              this.finalTransform.matMdf = !0;
              break;
            }

            r += 1;
          }
          if (this.finalTransform.matMdf) for (t = this.finalTransform.mProp.v.props, n.cloneFromProps(t), r = 0; r < i; r += 1) {
            t = this.hierarchy[r].finalTransform.mProp.v.props, n.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
          }
        } else this.isVisible && (n = this.finalTransform.mProp.v);

        return this.finalTransform.matMdf && this.layerElement && this.transformedElement.setAttribute("transform", n.to2dCSS()), this.finalTransform.opMdf && this.layerElement && (this.finalTransform.op.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.hidden && this.isTransparent && (this.isTransparent = !1, this.show()), this.transformedElement.setAttribute("opacity", this.finalTransform.op.v)), this.data.hasMask && this.maskManager.renderFrame(n), this.effectsManager && this.effectsManager.renderFrame(this.firstFrame), this.isVisible;
      }, SVGBaseElement.prototype.destroy = function () {
        this.layerElement = null, this.parentContainer = null, this.matteElement && (this.matteElement = null), this.maskManager && this.maskManager.destroy();
      }, SVGBaseElement.prototype.getBaseElement = function () {
        return this.baseElement;
      }, SVGBaseElement.prototype.addMasks = function (e) {
        this.maskManager = new MaskElement(e, this, this.globalData);
      }, SVGBaseElement.prototype.setMatte = function (e) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + locationHref + "#" + e + ")");
      }, SVGBaseElement.prototype.hide = function () {
        this.hidden || (this.layerElement.style.display = "none", this.hidden = !0);
      }, SVGBaseElement.prototype.show = function () {
        this.isVisible && !this.isTransparent && (this.hidden = !1, this.layerElement.style.display = "block");
      }, createElement(SVGBaseElement, IShapeElement), IShapeElement.prototype.identityMatrix = new Matrix(), IShapeElement.prototype.lcEnum = {
        1: "butt",
        2: "round",
        3: "square"
      }, IShapeElement.prototype.ljEnum = {
        1: "miter",
        2: "round",
        3: "butt"
      }, IShapeElement.prototype.searchProcessedElement = function (e) {
        for (var t = this.processedElements.length; t;) {
          if (t -= 1, this.processedElements[t].elem === e) return this.processedElements[t].pos;
        }

        return 0;
      }, IShapeElement.prototype.addProcessedElement = function (e, t) {
        for (var n = this.processedElements.length; n;) {
          if (n -= 1, this.processedElements[n].elem === e) {
            this.processedElements[n].pos = t;
            break;
          }
        }

        0 === n && this.processedElements.push({
          elem: e,
          pos: t
        });
      }, IShapeElement.prototype.buildExpressionInterface = function () {}, IShapeElement.prototype.createElements = function () {
        this._parent.createElements.call(this), this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, this.dynamicProperties, 0, [], !0), this.data.hd && !this.data.td || styleUnselectableDiv(this.layerElement);
      }, IShapeElement.prototype.setGradientData = function (e, t, n) {
        var r,
            i = "gr_" + randomString(10);
        (r = 1 === t.t ? document.createElementNS(svgNS, "linearGradient") : document.createElementNS(svgNS, "radialGradient")).setAttribute("id", i), r.setAttribute("spreadMethod", "pad"), r.setAttribute("gradientUnits", "userSpaceOnUse");
        var a,
            o,
            s,
            l = [];

        for (s = 4 * t.g.p, o = 0; o < s; o += 4) {
          a = document.createElementNS(svgNS, "stop"), r.appendChild(a), l.push(a);
        }

        e.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(#" + i + ")"), this.globalData.defs.appendChild(r), n.gf = r, n.cst = l;
      }, IShapeElement.prototype.setGradientOpacity = function (e, t, n) {
        if (e.g.k.k[0].s && e.g.k.k[0].s.length > 4 * e.g.p || e.g.k.k.length > 4 * e.g.p) {
          var r,
              i,
              a,
              o,
              s = document.createElementNS(svgNS, "mask"),
              l = document.createElementNS(svgNS, "path");
          s.appendChild(l);
          var c = "op_" + randomString(10),
              p = "mk_" + randomString(10);
          s.setAttribute("id", p), (r = 1 === e.t ? document.createElementNS(svgNS, "linearGradient") : document.createElementNS(svgNS, "radialGradient")).setAttribute("id", c), r.setAttribute("spreadMethod", "pad"), r.setAttribute("gradientUnits", "userSpaceOnUse"), o = e.g.k.k[0].s ? e.g.k.k[0].s.length : e.g.k.k.length;
          var d = [];

          for (a = 4 * e.g.p; a < o; a += 2) {
            (i = document.createElementNS(svgNS, "stop")).setAttribute("stop-color", "rgb(255,255,255)"), r.appendChild(i), d.push(i);
          }

          return l.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(#" + c + ")"), this.globalData.defs.appendChild(r), this.globalData.defs.appendChild(s), t.of = r, t.ost = d, n.msElem = l, p;
        }
      }, IShapeElement.prototype.createStyleElement = function (e, t, n) {
        var r = {},
            i = {
          data: e,
          type: e.ty,
          d: "",
          ld: "",
          lvl: t,
          mdf: !1,
          closed: !1
        },
            a = document.createElementNS(svgNS, "path");

        if (r.o = PropertyFactory.getProp(this, e.o, 0, .01, n), ("st" == e.ty || "gs" == e.ty) && (a.setAttribute("stroke-linecap", this.lcEnum[e.lc] || "round"), a.setAttribute("stroke-linejoin", this.ljEnum[e.lj] || "round"), a.setAttribute("fill-opacity", "0"), 1 == e.lj && a.setAttribute("stroke-miterlimit", e.ml), r.w = PropertyFactory.getProp(this, e.w, 0, null, n), e.d)) {
          var o = PropertyFactory.getDashProp(this, e.d, "svg", n);
          o.k || (a.setAttribute("stroke-dasharray", o.dasharray), a.setAttribute("stroke-dashoffset", o.dashoffset)), r.d = o;
        }

        if ("fl" == e.ty || "st" == e.ty) r.c = PropertyFactory.getProp(this, e.c, 1, 255, n);else {
          r.g = PropertyFactory.getGradientProp(this, e.g, n), 2 == e.t && (r.h = PropertyFactory.getProp(this, e.h, 0, .01, n), r.a = PropertyFactory.getProp(this, e.a, 0, degToRads, n)), r.s = PropertyFactory.getProp(this, e.s, 1, null, n), r.e = PropertyFactory.getProp(this, e.e, 1, null, n), this.setGradientData(a, e, r, i);
          var s = this.setGradientOpacity(e, r, i);
          s && a.setAttribute("mask", "url(#" + s + ")");
        }
        return r.elem = a, 2 === e.r && a.setAttribute("fill-rule", "evenodd"), e.ln && a.setAttribute("id", e.ln), e.cl && a.setAttribute("class", e.cl), i.pElem = a, this.stylesList.push(i), r.style = i, r;
      }, IShapeElement.prototype.createGroupElement = function (e) {
        var t = {
          it: [],
          prevViewData: []
        },
            n = document.createElementNS(svgNS, "g");
        return t.gr = n, e.ln && t.gr.setAttribute("id", e.ln), t;
      }, IShapeElement.prototype.createTransformElement = function (e, t) {
        return {
          transform: {
            op: PropertyFactory.getProp(this, e.o, 0, .01, t),
            mProps: PropertyFactory.getProp(this, e, 2, null, t)
          },
          elements: []
        };
      }, IShapeElement.prototype.createShapeElement = function (e, t, n, r) {
        var i = {
          elements: [],
          caches: [],
          styles: [],
          transformers: t,
          lStr: ""
        },
            a = 4;
        return "rc" == e.ty ? a = 5 : "el" == e.ty ? a = 6 : "sr" == e.ty && (a = 7), i.sh = ShapePropertyFactory.getShapeProp(this, e, a, r), i.lvl = n, this.shapes.push(i.sh), this.addShapeToModifiers(i), i;
      };
      var cont = 0;

      function ITextElement(e, t, n, r) {}

      function SVGTextElement(e, t, n, r, i) {
        this.textSpans = [], this.renderType = "svg", this._parent.constructor.call(this, e, t, n, r, i);
      }

      function SVGTintFilter(e, t) {
        this.filterManager = t;
        var n = document.createElementNS(svgNS, "feColorMatrix");

        if (n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "linearRGB"), n.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), n.setAttribute("result", "f1"), e.appendChild(n), (n = document.createElementNS(svgNS, "feColorMatrix")).setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), n.setAttribute("result", "f2"), e.appendChild(n), this.matrixFilter = n, 100 !== t.effectElements[2].p.v || t.effectElements[2].p.k) {
          var r,
              i = document.createElementNS(svgNS, "feMerge");
          e.appendChild(i), (r = document.createElementNS(svgNS, "feMergeNode")).setAttribute("in", "SourceGraphic"), i.appendChild(r), (r = document.createElementNS(svgNS, "feMergeNode")).setAttribute("in", "f2"), i.appendChild(r);
        }
      }

      function SVGFillFilter(e, t) {
        this.filterManager = t;
        var n = document.createElementNS(svgNS, "feColorMatrix");
        n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), e.appendChild(n), this.matrixFilter = n;
      }

      function SVGStrokeEffect(e, t) {
        this.initialized = !1, this.filterManager = t, this.elem = e, this.paths = [];
      }

      function SVGTritoneFilter(e, t) {
        this.filterManager = t;
        var n = document.createElementNS(svgNS, "feColorMatrix");
        n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "linearRGB"), n.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), n.setAttribute("result", "f1"), e.appendChild(n);
        var r = document.createElementNS(svgNS, "feComponentTransfer");
        r.setAttribute("color-interpolation-filters", "sRGB"), e.appendChild(r), this.matrixFilter = r;
        var i = document.createElementNS(svgNS, "feFuncR");
        i.setAttribute("type", "table"), r.appendChild(i), this.feFuncR = i;
        var a = document.createElementNS(svgNS, "feFuncG");
        a.setAttribute("type", "table"), r.appendChild(a), this.feFuncG = a;
        var o = document.createElementNS(svgNS, "feFuncB");
        o.setAttribute("type", "table"), r.appendChild(o), this.feFuncB = o;
      }

      function SVGProLevelsFilter(e, t) {
        this.filterManager = t;
        var n = this.filterManager.effectElements,
            r = document.createElementNS(svgNS, "feComponentTransfer");
        (n[9].p.k || 0 !== n[9].p.v || n[10].p.k || 1 !== n[10].p.v || n[11].p.k || 1 !== n[11].p.v || n[12].p.k || 0 !== n[12].p.v || n[13].p.k || 1 !== n[13].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", r)), (n[16].p.k || 0 !== n[16].p.v || n[17].p.k || 1 !== n[17].p.v || n[18].p.k || 1 !== n[18].p.v || n[19].p.k || 0 !== n[19].p.v || n[20].p.k || 1 !== n[20].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", r)), (n[23].p.k || 0 !== n[23].p.v || n[24].p.k || 1 !== n[24].p.v || n[25].p.k || 1 !== n[25].p.v || n[26].p.k || 0 !== n[26].p.v || n[27].p.k || 1 !== n[27].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", r)), (n[30].p.k || 0 !== n[30].p.v || n[31].p.k || 1 !== n[31].p.v || n[32].p.k || 1 !== n[32].p.v || n[33].p.k || 0 !== n[33].p.v || n[34].p.k || 1 !== n[34].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", r)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (r.setAttribute("color-interpolation-filters", "sRGB"), e.appendChild(r), r = document.createElementNS(svgNS, "feComponentTransfer")), (n[2].p.k || 0 !== n[2].p.v || n[3].p.k || 1 !== n[3].p.v || n[4].p.k || 1 !== n[4].p.v || n[5].p.k || 0 !== n[5].p.v || n[6].p.k || 1 !== n[6].p.v) && (r.setAttribute("color-interpolation-filters", "sRGB"), e.appendChild(r), this.feFuncRComposed = this.createFeFunc("feFuncR", r), this.feFuncGComposed = this.createFeFunc("feFuncG", r), this.feFuncBComposed = this.createFeFunc("feFuncB", r));
      }

      function SVGDropShadowEffect(e, t) {
        e.setAttribute("x", "-100%"), e.setAttribute("y", "-100%"), e.setAttribute("width", "400%"), e.setAttribute("height", "400%"), this.filterManager = t;
        var n = document.createElementNS(svgNS, "feGaussianBlur");
        n.setAttribute("in", "SourceAlpha"), n.setAttribute("result", "drop_shadow_1"), n.setAttribute("stdDeviation", "0"), this.feGaussianBlur = n, e.appendChild(n);
        var r = document.createElementNS(svgNS, "feOffset");
        r.setAttribute("dx", "25"), r.setAttribute("dy", "0"), r.setAttribute("in", "drop_shadow_1"), r.setAttribute("result", "drop_shadow_2"), this.feOffset = r, e.appendChild(r);
        var i = document.createElementNS(svgNS, "feFlood");
        i.setAttribute("flood-color", "#00ff00"), i.setAttribute("flood-opacity", "1"), i.setAttribute("result", "drop_shadow_3"), this.feFlood = i, e.appendChild(i);
        var a = document.createElementNS(svgNS, "feComposite");
        a.setAttribute("in", "drop_shadow_3"), a.setAttribute("in2", "drop_shadow_2"), a.setAttribute("operator", "in"), a.setAttribute("result", "drop_shadow_4"), e.appendChild(a);
        var o,
            s = document.createElementNS(svgNS, "feMerge");
        e.appendChild(s), o = document.createElementNS(svgNS, "feMergeNode"), s.appendChild(o), (o = document.createElementNS(svgNS, "feMergeNode")).setAttribute("in", "SourceGraphic"), this.feMergeNode = o, this.feMerge = s, this.originalNodeAdded = !1, s.appendChild(o);
      }

      function SVGMatte3Effect(e, t, n) {
        this.initialized = !1, this.filterManager = t, this.filterElem = e, this.elem = n, n.matteElement = document.createElementNS(svgNS, "g"), n.matteElement.appendChild(n.layerElement), n.matteElement.appendChild(n.transformedElement), n.baseElement = n.matteElement;
      }

      function SVGEffects(e) {
        var t,
            n,
            r = e.data.ef.length,
            i = randomString(10),
            a = filtersFactory.createFilter(i),
            o = 0;

        for (this.filters = [], t = 0; t < r; t += 1) {
          20 === e.data.ef[t].ty ? (o += 1, n = new SVGTintFilter(a, e.effects.effectElements[t]), this.filters.push(n)) : 21 === e.data.ef[t].ty ? (o += 1, n = new SVGFillFilter(a, e.effects.effectElements[t]), this.filters.push(n)) : 22 === e.data.ef[t].ty ? (n = new SVGStrokeEffect(e, e.effects.effectElements[t]), this.filters.push(n)) : 23 === e.data.ef[t].ty ? (o += 1, n = new SVGTritoneFilter(a, e.effects.effectElements[t]), this.filters.push(n)) : 24 === e.data.ef[t].ty ? (o += 1, n = new SVGProLevelsFilter(a, e.effects.effectElements[t]), this.filters.push(n)) : 25 === e.data.ef[t].ty ? (o += 1, n = new SVGDropShadowEffect(a, e.effects.effectElements[t]), this.filters.push(n)) : 28 === e.data.ef[t].ty && (n = new SVGMatte3Effect(a, e.effects.effectElements[t], e), this.filters.push(n));
        }

        o && (e.globalData.defs.appendChild(a), e.layerElement.setAttribute("filter", "url(" + locationHref + "#" + i + ")"));
      }

      function ICompElement(e, t, n, r, i) {
        this._parent.constructor.call(this, e, t, n, r, i), this.layers = e.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? Array.apply(null, {
          length: this.layers.length
        }) : [], this.data.tm && (this.tm = PropertyFactory.getProp(this, this.data.tm, 0, n.frameRate, this.dynamicProperties)), this.data.xt ? (this.layerElement = document.createElementNS(svgNS, "g"), this.buildAllItems()) : n.progressiveLoad || this.buildAllItems();
      }

      function IImageElement(e, t, n, r, i) {
        this.assetData = n.getAssetData(e.refId), this._parent.constructor.call(this, e, t, n, r, i);
      }

      function ISolidElement(e, t, n, r, i) {
        this._parent.constructor.call(this, e, t, n, r, i);
      }

      IShapeElement.prototype.setElementStyles = function () {
        var e,
            t = this.stylesList.length,
            n = [];

        for (e = 0; e < t; e += 1) {
          this.stylesList[e].closed || n.push(this.stylesList[e]);
        }

        return n;
      }, IShapeElement.prototype.reloadShapes = function () {
        this.firstFrame = !0;
        var e = this.itemsData.length;

        for (t = 0; t < e; t += 1) {
          this.prevViewData[t] = this.itemsData[t];
        }

        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, this.dynamicProperties, 0, [], !0);
        var t;
        e = this.dynamicProperties.length;

        for (t = 0; t < e; t += 1) {
          this.dynamicProperties[t].getValue();
        }

        this.renderModifiers();
      }, IShapeElement.prototype.searchShapes = function (e, t, n, r, i, a, o, s) {
        var l,
            c,
            p,
            d,
            h,
            u,
            f = [].concat(o),
            m = e.length - 1,
            g = [],
            v = [];

        for (l = m; l >= 0; l -= 1) {
          if ((u = this.searchProcessedElement(e[l])) ? t[l] = n[u - 1] : e[l]._render = s, "fl" == e[l].ty || "st" == e[l].ty || "gf" == e[l].ty || "gs" == e[l].ty) u ? t[l].style.closed = !1 : t[l] = this.createStyleElement(e[l], a, i), e[l]._render && r.appendChild(t[l].elem), g.push(t[l].style);else if ("gr" == e[l].ty) {
            if (u) for (p = t[l].it.length, c = 0; c < p; c += 1) {
              t[l].prevViewData[c] = t[l].it[c];
            } else t[l] = this.createGroupElement(e[l]);
            this.searchShapes(e[l].it, t[l].it, t[l].prevViewData, t[l].gr, i, a + 1, f, s), e[l]._render && r.appendChild(t[l].gr);
          } else "tr" == e[l].ty ? (u || (t[l] = this.createTransformElement(e[l], i)), d = t[l].transform, f.push(d)) : "sh" == e[l].ty || "rc" == e[l].ty || "el" == e[l].ty || "sr" == e[l].ty ? (u || (t[l] = this.createShapeElement(e[l], f, a, i)), t[l].elements = this.setElementStyles()) : "tm" == e[l].ty || "rd" == e[l].ty || "ms" == e[l].ty ? (u ? (h = t[l]).closed = !1 : ((h = ShapeModifiers.getModifier(e[l].ty)).init(this, e[l], i), t[l] = h, this.shapeModifiers.push(h)), v.push(h)) : "rp" == e[l].ty && (u ? (h = t[l]).closed = !0 : (h = ShapeModifiers.getModifier(e[l].ty), t[l] = h, h.init(this, e, l, t, i), this.shapeModifiers.push(h), s = !1), v.push(h));
          this.addProcessedElement(e[l], l + 1);
        }

        for (m = g.length, l = 0; l < m; l += 1) {
          g[l].closed = !0;
        }

        for (m = v.length, l = 0; l < m; l += 1) {
          v[l].closed = !0;
        }
      }, IShapeElement.prototype.addShapeToModifiers = function (e) {
        var t,
            n = this.shapeModifiers.length;

        for (t = 0; t < n; t += 1) {
          this.shapeModifiers[t].addShape(e);
        }
      }, IShapeElement.prototype.renderModifiers = function () {
        if (this.shapeModifiers.length) {
          var e,
              t = this.shapes.length;

          for (e = 0; e < t; e += 1) {
            this.shapes[e].reset();
          }

          for (e = (t = this.shapeModifiers.length) - 1; e >= 0; e -= 1) {
            this.shapeModifiers[e].processShapes(this.firstFrame);
          }
        }
      }, IShapeElement.prototype.renderFrame = function (e) {
        if (!1 !== this._parent.renderFrame.call(this, e)) {
          this.hidden && (this.layerElement.style.display = "block", this.hidden = !1), this.renderModifiers();
          var t,
              n = this.stylesList.length;

          for (t = 0; t < n; t += 1) {
            this.stylesList[t].d = "", this.stylesList[t].mdf = !1;
          }

          for (this.renderShape(this.shapesData, this.itemsData, null), t = 0; t < n; t += 1) {
            "0" === this.stylesList[t].ld && (this.stylesList[t].ld = "1", this.stylesList[t].pElem.style.display = "block"), (this.stylesList[t].mdf || this.firstFrame) && (this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].msElem && this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d));
          }

          this.firstFrame && (this.firstFrame = !1);
        } else this.hide();
      }, IShapeElement.prototype.hide = function () {
        if (!this.hidden) {
          var e;

          for (this.layerElement.style.display = "none", e = this.stylesList.length - 1; e >= 0; e -= 1) {
            "0" !== this.stylesList[e].ld && (this.stylesList[e].ld = "0", this.stylesList[e].pElem.style.display = "none", this.stylesList[e].pElem.parentNode && (this.stylesList[e].parent = this.stylesList[e].pElem.parentNode));
          }

          this.hidden = !0;
        }
      }, IShapeElement.prototype.renderShape = function (e, t, n) {
        var r, i;

        for (r = e.length - 1; r >= 0; r -= 1) {
          "tr" == (i = e[r].ty) ? ((this.firstFrame || t[r].transform.op.mdf && n) && n.setAttribute("opacity", t[r].transform.op.v), (this.firstFrame || t[r].transform.mProps.mdf && n) && n.setAttribute("transform", t[r].transform.mProps.v.to2dCSS())) : "sh" == i || "el" == i || "rc" == i || "sr" == i ? this.renderPath(e[r], t[r]) : "fl" == i ? this.renderFill(e[r], t[r]) : "gf" == i ? this.renderGradient(e[r], t[r]) : "gs" == i ? (this.renderGradient(e[r], t[r]), this.renderStroke(e[r], t[r])) : "st" == i ? this.renderStroke(e[r], t[r]) : "gr" == i && this.renderShape(e[r].it, t[r].it, t[r].gr);
        }
      }, IShapeElement.prototype.buildShapeString = function (e, t, n, r) {
        var i,
            a = "";

        for (i = 1; i < t; i += 1) {
          1 === i && (a += " M" + r.applyToPointStringified(e.v[0][0], e.v[0][1])), a += " C" + r.applyToPointStringified(e.o[i - 1][0], e.o[i - 1][1]) + " " + r.applyToPointStringified(e.i[i][0], e.i[i][1]) + " " + r.applyToPointStringified(e.v[i][0], e.v[i][1]);
        }

        return 1 === t && (a += " M" + r.applyToPointStringified(e.v[0][0], e.v[0][1])), n && t && (a += " C" + r.applyToPointStringified(e.o[i - 1][0], e.o[i - 1][1]) + " " + r.applyToPointStringified(e.i[0][0], e.i[0][1]) + " " + r.applyToPointStringified(e.v[0][0], e.v[0][1]), a += "z"), a;
      }, IShapeElement.prototype.renderPath = function (e, t) {
        var n,
            r,
            i,
            a,
            o,
            s,
            l = t.elements.length,
            c = t.lvl;
        if (e._render) for (s = 0; s < l; s += 1) {
          if (t.elements[s].data._render) {
            a = t.sh.mdf || this.firstFrame, i = "M0 0";
            var p = t.sh.paths;

            if (r = p._length, t.elements[s].lvl < c) {
              for (var d, h = this.mHelper.reset(), u = c - t.elements[s].lvl, f = t.transformers.length - 1; u > 0;) {
                a = t.transformers[f].mProps.mdf || a, d = t.transformers[f].mProps.v.props, h.transform(d[0], d[1], d[2], d[3], d[4], d[5], d[6], d[7], d[8], d[9], d[10], d[11], d[12], d[13], d[14], d[15]), u--, f--;
              }

              if (a) {
                for (n = 0; n < r; n += 1) {
                  (o = p.shapes[n]) && o._length && (i += this.buildShapeString(o, o._length, o.c, h));
                }

                t.caches[s] = i;
              } else i = t.caches[s];
            } else if (a) {
              for (n = 0; n < r; n += 1) {
                (o = p.shapes[n]) && o._length && (i += this.buildShapeString(o, o._length, o.c, this.identityMatrix));
              }

              t.caches[s] = i;
            } else i = t.caches[s];

            t.elements[s].d += i, t.elements[s].mdf = a || t.elements[s].mdf;
          } else t.elements[s].mdf = !0;
        }
      }, IShapeElement.prototype.renderFill = function (e, t) {
        var n = t.style;
        (t.c.mdf || this.firstFrame) && n.pElem.setAttribute("fill", "rgb(" + bm_floor(t.c.v[0]) + "," + bm_floor(t.c.v[1]) + "," + bm_floor(t.c.v[2]) + ")"), (t.o.mdf || this.firstFrame) && n.pElem.setAttribute("fill-opacity", t.o.v);
      }, IShapeElement.prototype.renderGradient = function (e, t) {
        var n,
            r,
            i,
            a,
            o,
            s = t.gf,
            l = t.of,
            c = t.s.v,
            p = t.e.v;

        if (t.o.mdf || this.firstFrame) {
          var d = "gf" === e.ty ? "fill-opacity" : "stroke-opacity";
          t.elem.setAttribute(d, t.o.v);
        }

        if (t.s.mdf || this.firstFrame) {
          var h = 1 === e.t ? "x1" : "cx",
              u = "x1" === h ? "y1" : "cy";
          s.setAttribute(h, c[0]), s.setAttribute(u, c[1]), l && (l.setAttribute(h, c[0]), l.setAttribute(u, c[1]));
        }

        if (t.g.cmdf || this.firstFrame) {
          n = t.cst;
          var f = t.g.c;

          for (i = n.length, r = 0; r < i; r += 1) {
            (a = n[r]).setAttribute("offset", f[4 * r] + "%"), a.setAttribute("stop-color", "rgb(" + f[4 * r + 1] + "," + f[4 * r + 2] + "," + f[4 * r + 3] + ")");
          }
        }

        if (l && (t.g.omdf || this.firstFrame)) {
          n = t.ost;
          var m = t.g.o;

          for (i = n.length, r = 0; r < i; r += 1) {
            (a = n[r]).setAttribute("offset", m[2 * r] + "%"), a.setAttribute("stop-opacity", m[2 * r + 1]);
          }
        }

        if (1 === e.t) (t.e.mdf || this.firstFrame) && (s.setAttribute("x2", p[0]), s.setAttribute("y2", p[1]), l && (l.setAttribute("x2", p[0]), l.setAttribute("y2", p[1])));else if ((t.s.mdf || t.e.mdf || this.firstFrame) && (o = Math.sqrt(Math.pow(c[0] - p[0], 2) + Math.pow(c[1] - p[1], 2)), s.setAttribute("r", o), l && l.setAttribute("r", o)), t.e.mdf || t.h.mdf || t.a.mdf || this.firstFrame) {
          o || (o = Math.sqrt(Math.pow(c[0] - p[0], 2) + Math.pow(c[1] - p[1], 2)));
          var g = Math.atan2(p[1] - c[1], p[0] - c[0]),
              v = o * (t.h.v >= 1 ? .99 : t.h.v <= -1 ? -.99 : t.h.v),
              b = Math.cos(g + t.a.v) * v + c[0],
              y = Math.sin(g + t.a.v) * v + c[1];
          s.setAttribute("fx", b), s.setAttribute("fy", y), l && (l.setAttribute("fx", b), l.setAttribute("fy", y));
        }
      }, IShapeElement.prototype.renderStroke = function (e, t) {
        var n = t.style,
            r = t.d;
        r && r.k && (r.mdf || this.firstFrame) && (n.pElem.setAttribute("stroke-dasharray", r.dasharray), n.pElem.setAttribute("stroke-dashoffset", r.dashoffset)), t.c && (t.c.mdf || this.firstFrame) && n.pElem.setAttribute("stroke", "rgb(" + bm_floor(t.c.v[0]) + "," + bm_floor(t.c.v[1]) + "," + bm_floor(t.c.v[2]) + ")"), (t.o.mdf || this.firstFrame) && n.pElem.setAttribute("stroke-opacity", t.o.v), (t.w.mdf || this.firstFrame) && (n.pElem.setAttribute("stroke-width", t.w.v), n.msElem && n.msElem.setAttribute("stroke-width", t.w.v));
      }, IShapeElement.prototype.destroy = function () {
        this._parent.destroy.call(this._parent), this.shapeData = null, this.itemsData = null, this.parentContainer = null, this.placeholder = null;
      }, ITextElement.prototype.init = function () {
        this.lettersChangedFlag = !0, this.dynamicProperties = this.dynamicProperties || [], this.textAnimator = new TextAnimatorProperty(this.data.t, this.renderType, this), this.textProperty = new TextProperty(this, this.data.t, this.dynamicProperties), this._parent.init.call(this), this.textAnimator.searchProperties(this.dynamicProperties);
      }, ITextElement.prototype.prepareFrame = function (e) {
        this._parent.prepareFrame.call(this, e), (this.textProperty.mdf || this.textProperty.firstFrame) && (this.buildNewText(), this.textProperty.firstFrame = !1);
      }, ITextElement.prototype.createPathShape = function (e, t) {
        var n,
            r,
            i = t.length,
            a = "";

        for (n = 0; n < i; n += 1) {
          r = t[n].ks.k, a += this.buildShapeString(r, r.i.length, !0, e);
        }

        return a;
      }, ITextElement.prototype.updateDocumentData = function (e, t) {
        this.textProperty.updateDocumentData(e, t);
      }, ITextElement.prototype.applyTextPropertiesToMatrix = function (e, t, n, r, i) {
        switch (e.ps && t.translate(e.ps[0], e.ps[1] + e.ascent, 0), t.translate(0, -e.ls, 0), e.j) {
          case 1:
            t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[n]), 0, 0);
            break;

          case 2:
            t.translate(e.justifyOffset + (e.boxWidth - e.lineWidths[n]) / 2, 0, 0);
        }

        t.translate(r, i, 0);
      }, ITextElement.prototype.buildColor = function (e) {
        return "rgb(" + Math.round(255 * e[0]) + "," + Math.round(255 * e[1]) + "," + Math.round(255 * e[2]) + ")";
      }, ITextElement.prototype.buildShapeString = IShapeElement.prototype.buildShapeString, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function () {
        this._parent.destroy.call(this._parent);
      }, createElement(SVGBaseElement, SVGTextElement), extendPrototype(ITextElement, SVGTextElement), SVGTextElement.prototype.createElements = function () {
        this._parent.createElements.call(this), this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = document.createElementNS(svgNS, "text"));
      }, SVGTextElement.prototype.buildNewText = function () {
        var e,
            t,
            n = this.textProperty.currentData;
        this.renderedLetters = Array.apply(null, {
          length: n ? n.l.length : 0
        }), n.fc ? this.layerElement.setAttribute("fill", this.buildColor(n.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), n.sc && (this.layerElement.setAttribute("stroke", this.buildColor(n.sc)), this.layerElement.setAttribute("stroke-width", n.sw)), this.layerElement.setAttribute("font-size", n.s);
        var r = this.globalData.fontManager.getFontByName(n.f);
        if (r.fClass) this.layerElement.setAttribute("class", r.fClass);else {
          this.layerElement.setAttribute("font-family", r.fFamily);
          var i = n.fWeight,
              a = n.fStyle;
          this.layerElement.setAttribute("font-style", a), this.layerElement.setAttribute("font-weight", i);
        }
        var o = n.l || [],
            s = this.globalData.fontManager.chars;

        if (t = o.length) {
          var l,
              c,
              p = this.mHelper,
              d = "",
              h = this.data.singleShape,
              u = 0,
              f = 0,
              m = !0,
              g = n.tr / 1e3 * n.s;

          if (h && !s) {
            var v = this.textContainer,
                b = "";

            switch (n.j) {
              case 1:
                b = "end";
                break;

              case 2:
                b = "middle";
                break;

              case 2:
                b = "start";
            }

            v.setAttribute("text-anchor", b), v.setAttribute("letter-spacing", g);
            var y = n.t.split(String.fromCharCode(13));
            t = y.length;
            f = n.ps ? n.ps[1] + n.ascent : 0;

            for (e = 0; e < t; e += 1) {
              (l = this.textSpans[e] || document.createElementNS(svgNS, "tspan")).textContent = y[e], l.setAttribute("x", 0), l.setAttribute("y", f), l.style.display = "inherit", v.appendChild(l), this.textSpans[e] = l, f += n.lh;
            }

            this.layerElement.appendChild(v);
          } else {
            var x,
                w,
                E = this.textSpans.length;

            for (e = 0; e < t; e += 1) {
              s && h && 0 !== e || (l = E > e ? this.textSpans[e] : document.createElementNS(svgNS, s ? "path" : "text"), E <= e && (l.setAttribute("stroke-linecap", "butt"), l.setAttribute("stroke-linejoin", "round"), l.setAttribute("stroke-miterlimit", "4"), this.textSpans[e] = l, this.layerElement.appendChild(l)), l.style.display = "inherit"), p.reset(), s ? (p.scale(n.s / 100, n.s / 100), h && (o[e].n && (u = -g, f += n.yOffset, f += m ? 1 : 0, m = !1), this.applyTextPropertiesToMatrix(n, p, o[e].line, u, f), u += o[e].l || 0, u += g), c = (x = (w = this.globalData.fontManager.getCharData(n.t.charAt(e), r.fStyle, this.globalData.fontManager.getFontByName(n.f).fFamily)) && w.data || {}).shapes ? x.shapes[0].it : [], h ? d += this.createPathShape(p, c) : l.setAttribute("d", this.createPathShape(p, c))) : (l.textContent = o[e].val, l.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"));
            }

            h && l.setAttribute("d", d);
          }

          for (; e < this.textSpans.length;) {
            this.textSpans[e].style.display = "none", e += 1;
          }

          this._sizeChanged = !0;
        }
      }, SVGTextElement.prototype.sourceRectAtTime = function (e) {
        if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderLetters(), this._sizeChanged) {
          this._sizeChanged = !1;
          var t = this.layerElement.getBBox();
          this.bbox = {
            top: t.y,
            left: t.x,
            width: t.width,
            height: t.height
          };
        }

        return this.bbox;
      }, SVGTextElement.prototype.renderLetters = function () {
        if (!this.data.singleShape && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
          var e, t;
          this._sizeChanged = !0;
          var n,
              r,
              i = this.textAnimator.renderedLetters,
              a = this.textProperty.currentData.l;

          for (t = a.length, e = 0; e < t; e += 1) {
            a[e].n || (n = i[e], r = this.textSpans[e], n.mdf.m && r.setAttribute("transform", n.m), n.mdf.o && r.setAttribute("opacity", n.o), n.mdf.sw && r.setAttribute("stroke-width", n.sw), n.mdf.sc && r.setAttribute("stroke", n.sc), n.mdf.fc && r.setAttribute("fill", n.fc));
          }
        }
      }, SVGTextElement.prototype.renderFrame = function (e) {
        !1 !== this._parent.renderFrame.call(this, e) ? (this.hidden && this.show(), this.firstFrame && (this.firstFrame = !1), this.renderLetters()) : this.hide();
      }, SVGTintFilter.prototype.renderFrame = function (e) {
        if (e || this.filterManager.mdf) {
          var t = this.filterManager.effectElements[0].p.v,
              n = this.filterManager.effectElements[1].p.v,
              r = this.filterManager.effectElements[2].p.v / 100;
          this.matrixFilter.setAttribute("values", n[0] - t[0] + " 0 0 0 " + t[0] + " " + (n[1] - t[1]) + " 0 0 0 " + t[1] + " " + (n[2] - t[2]) + " 0 0 0 " + t[2] + " 0 0 0 " + r + " 0");
        }
      }, SVGFillFilter.prototype.renderFrame = function (e) {
        if (e || this.filterManager.mdf) {
          var t = this.filterManager.effectElements[2].p.v,
              n = this.filterManager.effectElements[6].p.v;
          this.matrixFilter.setAttribute("values", "0 0 0 0 " + t[0] + " 0 0 0 0 " + t[1] + " 0 0 0 0 " + t[2] + " 0 0 0 " + n + " 0");
        }
      }, SVGStrokeEffect.prototype.initialize = function () {
        var e,
            t,
            n,
            r,
            i = this.elem.layerElement.children || this.elem.layerElement.childNodes;

        for (1 === this.filterManager.effectElements[1].p.v ? (r = this.elem.maskManager.masksProperties.length, n = 0) : r = (n = this.filterManager.effectElements[0].p.v - 1) + 1, (t = document.createElementNS(svgNS, "g")).setAttribute("fill", "none"), t.setAttribute("stroke-linecap", "round"), t.setAttribute("stroke-dashoffset", 1); n < r; n += 1) {
          e = document.createElementNS(svgNS, "path"), t.appendChild(e), this.paths.push({
            p: e,
            m: n
          });
        }

        if (3 === this.filterManager.effectElements[10].p.v) {
          var a = document.createElementNS(svgNS, "mask"),
              o = "stms_" + randomString(10);
          a.setAttribute("id", o), a.setAttribute("mask-type", "alpha"), a.appendChild(t), this.elem.globalData.defs.appendChild(a);
          var s = document.createElementNS(svgNS, "g");
          s.setAttribute("mask", "url(" + locationHref + "#" + o + ")"), i[0] && s.appendChild(i[0]), this.elem.layerElement.appendChild(s), this.masker = a, t.setAttribute("stroke", "#fff");
        } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
          if (2 === this.filterManager.effectElements[10].p.v) for (i = this.elem.layerElement.children || this.elem.layerElement.childNodes; i.length;) {
            this.elem.layerElement.removeChild(i[0]);
          }
          this.elem.layerElement.appendChild(t), this.elem.layerElement.removeAttribute("mask"), t.setAttribute("stroke", "#fff");
        }

        this.initialized = !0, this.pathMasker = t;
      }, SVGStrokeEffect.prototype.renderFrame = function (e) {
        this.initialized || this.initialize();
        var t,
            n,
            r,
            i = this.paths.length;

        for (t = 0; t < i; t += 1) {
          if (n = this.elem.maskManager.viewData[this.paths[t].m], r = this.paths[t].p, (e || this.filterManager.mdf || n.prop.mdf) && r.setAttribute("d", n.lastPath), e || this.filterManager.effectElements[9].p.mdf || this.filterManager.effectElements[4].p.mdf || this.filterManager.effectElements[7].p.mdf || this.filterManager.effectElements[8].p.mdf || n.prop.mdf) {
            var a;

            if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
              var o = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) / 100,
                  s = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) / 100,
                  l = r.getTotalLength();
              a = "0 0 0 " + l * o + " ";
              var c,
                  p = l * (s - o),
                  d = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v / 100,
                  h = Math.floor(p / d);

              for (c = 0; c < h; c += 1) {
                a += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v / 100 + " ";
              }

              a += "0 " + 10 * l + " 0 0";
            } else a = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v / 100;

            r.setAttribute("stroke-dasharray", a);
          }
        }

        if ((e || this.filterManager.effectElements[4].p.mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (e || this.filterManager.effectElements[6].p.mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (e || this.filterManager.effectElements[3].p.mdf)) {
          var u = this.filterManager.effectElements[3].p.v;
          this.pathMasker.setAttribute("stroke", "rgb(" + bm_floor(255 * u[0]) + "," + bm_floor(255 * u[1]) + "," + bm_floor(255 * u[2]) + ")");
        }
      }, SVGTritoneFilter.prototype.renderFrame = function (e) {
        if (e || this.filterManager.mdf) {
          var t = this.filterManager.effectElements[0].p.v,
              n = this.filterManager.effectElements[1].p.v,
              r = this.filterManager.effectElements[2].p.v,
              i = r[0] + " " + n[0] + " " + t[0],
              a = r[1] + " " + n[1] + " " + t[1],
              o = r[2] + " " + n[2] + " " + t[2];
          this.feFuncR.setAttribute("tableValues", i), this.feFuncG.setAttribute("tableValues", a), this.feFuncB.setAttribute("tableValues", o);
        }
      }, SVGProLevelsFilter.prototype.createFeFunc = function (e, t) {
        var n = document.createElementNS(svgNS, e);
        return n.setAttribute("type", "table"), t.appendChild(n), n;
      }, SVGProLevelsFilter.prototype.getTableValue = function (e, t, n, r, i) {
        for (var a, o, s = 0, l = Math.min(e, t), c = Math.max(e, t), p = Array.call(null, {
          length: 256
        }), d = 0, h = i - r, u = t - e; s <= 256;) {
          o = (a = s / 256) <= l ? u < 0 ? i : r : a >= c ? u < 0 ? r : i : r + h * Math.pow((a - e) / u, 1 / n), p[d++] = o, s += 256 / 255;
        }

        return p.join(" ");
      }, SVGProLevelsFilter.prototype.renderFrame = function (e) {
        if (e || this.filterManager.mdf) {
          var t,
              n = this.filterManager.effectElements;
          this.feFuncRComposed && (e || n[2].p.mdf || n[3].p.mdf || n[4].p.mdf || n[5].p.mdf || n[6].p.mdf) && (t = this.getTableValue(n[2].p.v, n[3].p.v, n[4].p.v, n[5].p.v, n[6].p.v), this.feFuncRComposed.setAttribute("tableValues", t), this.feFuncGComposed.setAttribute("tableValues", t), this.feFuncBComposed.setAttribute("tableValues", t)), this.feFuncR && (e || n[9].p.mdf || n[10].p.mdf || n[11].p.mdf || n[12].p.mdf || n[13].p.mdf) && (t = this.getTableValue(n[9].p.v, n[10].p.v, n[11].p.v, n[12].p.v, n[13].p.v), this.feFuncR.setAttribute("tableValues", t)), this.feFuncG && (e || n[16].p.mdf || n[17].p.mdf || n[18].p.mdf || n[19].p.mdf || n[20].p.mdf) && (t = this.getTableValue(n[16].p.v, n[17].p.v, n[18].p.v, n[19].p.v, n[20].p.v), this.feFuncG.setAttribute("tableValues", t)), this.feFuncB && (e || n[23].p.mdf || n[24].p.mdf || n[25].p.mdf || n[26].p.mdf || n[27].p.mdf) && (t = this.getTableValue(n[23].p.v, n[24].p.v, n[25].p.v, n[26].p.v, n[27].p.v), this.feFuncB.setAttribute("tableValues", t)), this.feFuncA && (e || n[30].p.mdf || n[31].p.mdf || n[32].p.mdf || n[33].p.mdf || n[34].p.mdf) && (t = this.getTableValue(n[30].p.v, n[31].p.v, n[32].p.v, n[33].p.v, n[34].p.v), this.feFuncA.setAttribute("tableValues", t));
        }
      }, SVGDropShadowEffect.prototype.renderFrame = function (e) {
        if (e || this.filterManager.mdf) {
          if ((e || this.filterManager.effectElements[4].p.mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), e || this.filterManager.effectElements[0].p.mdf) {
            var t = this.filterManager.effectElements[0].p.v;
            this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * t[0]), Math.round(255 * t[1]), Math.round(255 * t[2])));
          }

          if ((e || this.filterManager.effectElements[1].p.mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), e || this.filterManager.effectElements[2].p.mdf || this.filterManager.effectElements[3].p.mdf) {
            var n = this.filterManager.effectElements[3].p.v,
                r = (this.filterManager.effectElements[2].p.v - 90) * degToRads,
                i = n * Math.cos(r),
                a = n * Math.sin(r);
            this.feOffset.setAttribute("dx", i), this.feOffset.setAttribute("dy", a);
          }
        }
      }, SVGMatte3Effect.prototype.setElementAsMask = function (e, t) {
        var n = document.createElementNS(svgNS, "mask");
        n.setAttribute("id", t.layerId), n.setAttribute("mask-type", "alpha"), n.appendChild(t.layerElement), e.setMatte(t.layerId), t.data.hd = !1, e.globalData.defs.appendChild(n);
      }, SVGMatte3Effect.prototype.initialize = function () {
        for (var e = this.filterManager.effectElements[0].p.v, t = 0, n = this.elem.comp.elements.length; t < n;) {
          this.elem.comp.elements[t].data.ind === e && this.setElementAsMask(this.elem, this.elem.comp.elements[t]), t += 1;
        }

        this.initialized = !0;
      }, SVGMatte3Effect.prototype.renderFrame = function () {
        this.initialized || this.initialize();
      }, SVGEffects.prototype.renderFrame = function (e) {
        var t,
            n = this.filters.length;

        for (t = 0; t < n; t += 1) {
          this.filters[t].renderFrame(e);
        }
      }, createElement(SVGBaseElement, ICompElement), ICompElement.prototype.hide = function () {
        if (!this.hidden) {
          this._parent.hide.call(this);

          var e,
              t = this.elements.length;

          for (e = 0; e < t; e += 1) {
            this.elements[e] && this.elements[e].hide();
          }
        }
      }, ICompElement.prototype.prepareFrame = function (e) {
        if (this._parent.prepareFrame.call(this, e), !1 !== this.isVisible || this.data.xt) {
          if (this.tm) {
            var t = this.tm.v;
            t === this.data.op && (t = this.data.op - 1), this.renderedFrame = t;
          } else this.renderedFrame = e / this.data.sr;

          var n,
              r = this.elements.length;

          for (this.completeLayers || this.checkLayers(this.renderedFrame), n = 0; n < r; n += 1) {
            (this.completeLayers || this.elements[n]) && this.elements[n].prepareFrame(this.renderedFrame - this.layers[n].st);
          }
        }
      }, ICompElement.prototype.renderFrame = function (e) {
        var t,
            n = this._parent.renderFrame.call(this, e),
            r = this.layers.length;

        if (!1 !== n) {
          for (this.hidden && this.show(), t = 0; t < r; t += 1) {
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
          }

          this.firstFrame && (this.firstFrame = !1);
        } else this.hide();
      }, ICompElement.prototype.setElements = function (e) {
        this.elements = e;
      }, ICompElement.prototype.getElements = function () {
        return this.elements;
      }, ICompElement.prototype.destroy = function () {
        this._parent.destroy.call(this._parent);

        var e,
            t = this.layers.length;

        for (e = 0; e < t; e += 1) {
          this.elements[e] && this.elements[e].destroy();
        }
      }, ICompElement.prototype.checkLayers = SVGRenderer.prototype.checkLayers, ICompElement.prototype.buildItem = SVGRenderer.prototype.buildItem, ICompElement.prototype.buildAllItems = SVGRenderer.prototype.buildAllItems, ICompElement.prototype.buildElementParenting = SVGRenderer.prototype.buildElementParenting, ICompElement.prototype.createItem = SVGRenderer.prototype.createItem, ICompElement.prototype.createImage = SVGRenderer.prototype.createImage, ICompElement.prototype.createComp = SVGRenderer.prototype.createComp, ICompElement.prototype.createSolid = SVGRenderer.prototype.createSolid, ICompElement.prototype.createShape = SVGRenderer.prototype.createShape, ICompElement.prototype.createText = SVGRenderer.prototype.createText, ICompElement.prototype.createBase = SVGRenderer.prototype.createBase, ICompElement.prototype.appendElementInPos = SVGRenderer.prototype.appendElementInPos, ICompElement.prototype.checkPendingElements = SVGRenderer.prototype.checkPendingElements, ICompElement.prototype.addPendingElement = SVGRenderer.prototype.addPendingElement, createElement(SVGBaseElement, IImageElement), IImageElement.prototype.createElements = function () {
        var e = this.globalData.getAssetsPath(this.assetData);
        this._parent.createElements.call(this), this.innerElem = document.createElementNS(svgNS, "image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", "xMidYMid slice"), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), this.maskedElement = this.innerElem, this.layerElement.appendChild(this.innerElem), this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl);
      }, IImageElement.prototype.renderFrame = function (e) {
        !1 !== this._parent.renderFrame.call(this, e) ? (this.hidden && this.show(), this.firstFrame && (this.firstFrame = !1)) : this.hide();
      }, IImageElement.prototype.destroy = function () {
        this._parent.destroy.call(this._parent), this.innerElem = null;
      }, createElement(SVGBaseElement, ISolidElement), ISolidElement.prototype.createElements = function () {
        this._parent.createElements.call(this);

        var e = document.createElementNS(svgNS, "rect");
        e.setAttribute("width", this.data.sw), e.setAttribute("height", this.data.sh), e.setAttribute("fill", this.data.sc), this.layerElement.appendChild(e), this.innerElem = e, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl);
      }, ISolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame, ISolidElement.prototype.destroy = IImageElement.prototype.destroy;

      var animationManager = function () {
        var e = {},
            t = [],
            n = 0,
            r = 0,
            i = !0,
            a = 0;

        function removeElement(e) {
          for (var n = 0, i = e.target; n < r;) {
            t[n].animation === i && (t.splice(n, 1), n -= 1, r -= 1, i.isPaused || subtractPlayingCount()), n += 1;
          }
        }

        function registerAnimation(e, n) {
          if (!e) return null;

          for (var i = 0; i < r;) {
            if (t[i].elem == e && null !== t[i].elem) return t[i].animation;
            i += 1;
          }

          var a = new AnimationItem();
          return setupAnimation(a, e), a.setData(e, n), a;
        }

        function addPlayingCount() {
          a += 1, function activate() {
            i && (i = !1, window.requestAnimationFrame(first));
          }();
        }

        function subtractPlayingCount() {
          0 === (a -= 1) && (i = !0);
        }

        function setupAnimation(e, n) {
          e.addEventListener("destroy", removeElement), e.addEventListener("_active", addPlayingCount), e.addEventListener("_idle", subtractPlayingCount), t.push({
            elem: n,
            animation: e
          }), r += 1;
        }

        function resume(e) {
          var a,
              o = e - n;

          for (a = 0; a < r; a += 1) {
            t[a].animation.advanceTime(o);
          }

          n = e, i || window.requestAnimationFrame(resume);
        }

        function first(e) {
          n = e, window.requestAnimationFrame(resume);
        }

        function start() {
          window.requestAnimationFrame(first);
        }

        return setTimeout(start, 0), e.registerAnimation = registerAnimation, e.loadAnimation = function loadAnimation(e) {
          var t = new AnimationItem();
          return setupAnimation(t, null), t.setParams(e), t;
        }, e.setSpeed = function setSpeed(e, n) {
          var i;

          for (i = 0; i < r; i += 1) {
            t[i].animation.setSpeed(e, n);
          }
        }, e.setDirection = function setDirection(e, n) {
          var i;

          for (i = 0; i < r; i += 1) {
            t[i].animation.setDirection(e, n);
          }
        }, e.play = function play(e) {
          var n;

          for (n = 0; n < r; n += 1) {
            t[n].animation.play(e);
          }
        }, e.moveFrame = function moveFrame(e, i) {
          var a;

          for (n = Date.now(), a = 0; a < r; a += 1) {
            t[a].animation.moveFrame(e, i);
          }
        }, e.pause = function pause(e) {
          var n;

          for (n = 0; n < r; n += 1) {
            t[n].animation.pause(e);
          }
        }, e.stop = function stop(e) {
          var n;

          for (n = 0; n < r; n += 1) {
            t[n].animation.stop(e);
          }
        }, e.togglePause = function togglePause(e) {
          var n;

          for (n = 0; n < r; n += 1) {
            t[n].animation.togglePause(e);
          }
        }, e.searchAnimations = function searchAnimations(e, t, n) {
          var r,
              i = document.getElementsByClassName("bodymovin"),
              a = i.length;

          for (r = 0; r < a; r += 1) {
            n && i[r].setAttribute("data-bm-type", n), registerAnimation(i[r], e);
          }

          if (t && 0 === a) {
            n || (n = "svg");
            var o = document.getElementsByTagName("body")[0];
            o.innerHTML = "";
            var s = document.createElement("div");
            s.style.width = "100%", s.style.height = "100%", s.setAttribute("data-bm-type", n), o.appendChild(s), registerAnimation(s, e);
          }
        }, e.resize = function resize() {
          var e;

          for (e = 0; e < r; e += 1) {
            t[e].animation.resize();
          }
        }, e.start = start, e.goToAndStop = function goToAndStop(e, n, i) {
          var a;

          for (a = 0; a < r; a += 1) {
            t[a].animation.goToAndStop(e, n, i);
          }
        }, e.destroy = function destroy(e) {
          var n;

          for (n = r - 1; n >= 0; n -= 1) {
            t[n].animation.destroy(e);
          }
        }, e;
      }(),
          AnimationItem = function AnimationItem() {
        this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.pendingElements = 0, this.playCount = 0, this.prerenderFramesFlag = !0, this.animationData = {}, this.layers = [], this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = randomString(10), this.scaleMode = "fit", this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.subframeEnabled = subframeEnabled, this.segments = [], this.pendingSegment = !1, this._idle = !0, this.projectInterface = ProjectInterface();
      };

      function CanvasRenderer(e, t) {
        this.animationItem = e, this.renderConfig = {
          clearCanvas: !t || void 0 === t.clearCanvas || t.clearCanvas,
          context: t && t.context || null,
          progressiveLoad: t && t.progressiveLoad || !1,
          preserveAspectRatio: t && t.preserveAspectRatio || "xMidYMid meet",
          className: t && t.className || ""
        }, this.renderConfig.dpr = t && t.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = t && t.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
          frameNum: -1
        }, this.contextData = {
          saved: Array.apply(null, {
            length: 15
          }),
          savedOp: Array.apply(null, {
            length: 15
          }),
          cArrPos: 0,
          cTr: new Matrix(),
          cO: 1
        };
        var n;

        for (n = 0; n < 15; n += 1) {
          this.contextData.saved[n] = Array.apply(null, {
            length: 16
          });
        }

        this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1;
      }

      function HybridRenderer(e, t) {
        this.animationItem = e, this.layers = null, this.renderedFrame = -1, this.globalData = {
          frameNum: -1
        }, this.renderConfig = {
          className: t && t.className || ""
        }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0;
      }

      function CVBaseElement(e, t, n) {
        this.globalData = n, this.data = e, this.comp = t, this.canvasContext = n.canvasContext, this.init();
      }

      function CVCompElement(e, t, n) {
        this._parent.constructor.call(this, e, t, n);

        var r = {};

        for (var i in n) {
          n.hasOwnProperty(i) && (r[i] = n[i]);
        }

        r.renderer = this, r.compHeight = this.data.h, r.compWidth = this.data.w, this.renderConfig = {
          clearCanvas: !0
        }, this.contextData = {
          saved: Array.apply(null, {
            length: 15
          }),
          savedOp: Array.apply(null, {
            length: 15
          }),
          cArrPos: 0,
          cTr: new Matrix(),
          cO: 1
        }, this.completeLayers = !1;
        var a;

        for (a = 0; a < 15; a += 1) {
          this.contextData.saved[a] = Array.apply(null, {
            length: 16
          });
        }

        this.transformMat = new Matrix(), this.parentGlobalData = this.globalData;
        var o = document.createElement("canvas");
        r.canvasContext = o.getContext("2d"), this.canvasContext = r.canvasContext, o.width = this.data.w, o.height = this.data.h, this.canvas = o, this.globalData = r, this.layers = e.layers, this.pendingElements = [], this.elements = Array.apply(null, {
          length: this.layers.length
        }), this.data.tm && (this.tm = PropertyFactory.getProp(this, this.data.tm, 0, n.frameRate, this.dynamicProperties)), !this.data.xt && n.progressiveLoad || this.buildAllItems();
      }

      function CVImageElement(e, t, n) {
        this.assetData = n.getAssetData(e.refId), this._parent.constructor.call(this, e, t, n), this.globalData.addPendingElement();
      }

      function CVMaskElement(e, t) {
        this.data = e, this.element = t, this.dynamicProperties = [], this.masksProperties = this.data.masksProperties, this.viewData = Array.apply(null, {
          length: this.masksProperties.length
        });
        var n,
            r = this.masksProperties.length;

        for (n = 0; n < r; n++) {
          this.viewData[n] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[n], 3, this.dynamicProperties, null);
        }
      }

      function CVShapeElement(e, t, n) {
        this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this._parent.constructor.call(this, e, t, n);
      }

      function CVSolidElement(e, t, n) {
        this._parent.constructor.call(this, e, t, n);
      }

      function CVTextElement(e, t, n) {
        this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
          fill: "rgba(0,0,0,0)",
          stroke: "rgba(0,0,0,0)",
          sWidth: 0,
          fValue: ""
        }, this._parent.constructor.call(this, e, t, n);
      }

      function HBaseElement(e, t, n, r, i) {
        this.globalData = n, this.comp = r, this.data = e, this.matteElement = null, this.parentContainer = t, this.layerId = i ? i.layerId : "ly_" + randomString(10), this.placeholder = i, this.init();
      }

      function HSolidElement(e, t, n, r, i) {
        this._parent.constructor.call(this, e, t, n, r, i);
      }

      function HCompElement(e, t, n, r, i) {
        this._parent.constructor.call(this, e, t, n, r, i), this.layers = e.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = Array.apply(null, {
          length: this.layers.length
        }), this.data.tm && (this.tm = PropertyFactory.getProp(this, this.data.tm, 0, n.frameRate, this.dynamicProperties)), this.data.hasMask && (this.supports3d = !1), this.data.xt && (this.layerElement = document.createElement("div")), this.buildAllItems();
      }

      function HShapeElement(e, t, n, r, i) {
        this.shapes = [], this.shapesData = e.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this._parent.constructor.call(this, e, t, n, r, i), this.currentBBox = {
          x: 999999,
          y: -999999,
          h: 0,
          w: 0
        };
      }

      AnimationItem.prototype.setParams = function (e) {
        var t = this;
        e.context && (this.context = e.context), (e.wrapper || e.container) && (this.wrapper = e.wrapper || e.container);
        var n = e.animType ? e.animType : e.renderer ? e.renderer : "svg";

        switch (n) {
          case "canvas":
            this.renderer = new CanvasRenderer(this, e.rendererSettings);
            break;

          case "svg":
            this.renderer = new SVGRenderer(this, e.rendererSettings);
            break;

          case "hybrid":
          case "html":
          default:
            this.renderer = new HybridRenderer(this, e.rendererSettings);
        }

        if (this.renderer.setProjectInterface(this.projectInterface), this.animType = n, "" === e.loop || null === e.loop || (!1 === e.loop ? this.loop = !1 : !0 === e.loop ? this.loop = !0 : this.loop = parseInt(e.loop)), this.autoplay = !("autoplay" in e) || e.autoplay, this.name = e.name ? e.name : "", this.prerenderFramesFlag = !("prerender" in e) || e.prerender, this.autoloadSegments = !e.hasOwnProperty("autoloadSegments") || e.autoloadSegments, e.animationData) t.configAnimation(e.animationData);else if (e.path) {
          "json" != e.path.substr(-4) && ("/" != e.path.substr(-1, 1) && (e.path += "/"), e.path += "data.json");
          var r = new XMLHttpRequest();
          -1 != e.path.lastIndexOf("\\") ? this.path = e.path.substr(0, e.path.lastIndexOf("\\") + 1) : this.path = e.path.substr(0, e.path.lastIndexOf("/") + 1), this.assetsPath = e.assetsPath, this.fileName = e.path.substr(e.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), r.open("GET", e.path, !0), r.send(), r.onreadystatechange = function () {
            if (4 == r.readyState) if (200 == r.status) t.configAnimation(JSON.parse(r.responseText));else try {
              var e = JSON.parse(r.responseText);
              t.configAnimation(e);
            } catch (n) {}
          };
        }
      }, AnimationItem.prototype.setData = function (e, t) {
        var n = {
          wrapper: e,
          animationData: t ? "object" === typeof t ? t : JSON.parse(t) : null
        },
            r = e.attributes;
        n.path = r.getNamedItem("data-animation-path") ? r.getNamedItem("data-animation-path").value : r.getNamedItem("data-bm-path") ? r.getNamedItem("data-bm-path").value : r.getNamedItem("bm-path") ? r.getNamedItem("bm-path").value : "", n.animType = r.getNamedItem("data-anim-type") ? r.getNamedItem("data-anim-type").value : r.getNamedItem("data-bm-type") ? r.getNamedItem("data-bm-type").value : r.getNamedItem("bm-type") ? r.getNamedItem("bm-type").value : r.getNamedItem("data-bm-renderer") ? r.getNamedItem("data-bm-renderer").value : r.getNamedItem("bm-renderer") ? r.getNamedItem("bm-renderer").value : "canvas";
        var i = r.getNamedItem("data-anim-loop") ? r.getNamedItem("data-anim-loop").value : r.getNamedItem("data-bm-loop") ? r.getNamedItem("data-bm-loop").value : r.getNamedItem("bm-loop") ? r.getNamedItem("bm-loop").value : "";
        "" === i || (n.loop = "false" !== i && ("true" === i || parseInt(i)));
        var a = r.getNamedItem("data-anim-autoplay") ? r.getNamedItem("data-anim-autoplay").value : r.getNamedItem("data-bm-autoplay") ? r.getNamedItem("data-bm-autoplay").value : !r.getNamedItem("bm-autoplay") || r.getNamedItem("bm-autoplay").value;
        n.autoplay = "false" !== a, n.name = r.getNamedItem("data-name") ? r.getNamedItem("data-name").value : r.getNamedItem("data-bm-name") ? r.getNamedItem("data-bm-name").value : r.getNamedItem("bm-name") ? r.getNamedItem("bm-name").value : "", "false" === (r.getNamedItem("data-anim-prerender") ? r.getNamedItem("data-anim-prerender").value : r.getNamedItem("data-bm-prerender") ? r.getNamedItem("data-bm-prerender").value : r.getNamedItem("bm-prerender") ? r.getNamedItem("bm-prerender").value : "") && (n.prerender = !1), this.setParams(n);
      }, AnimationItem.prototype.includeLayers = function (e) {
        e.op > this.animationData.op && (this.animationData.op = e.op, this.totalFrames = Math.floor(e.op - this.animationData.ip), this.animationData.tf = this.totalFrames);
        var t,
            n,
            r = this.animationData.layers,
            i = r.length,
            a = e.layers,
            o = a.length;

        for (n = 0; n < o; n += 1) {
          for (t = 0; t < i;) {
            if (r[t].id == a[n].id) {
              r[t] = a[n];
              break;
            }

            t += 1;
          }
        }

        if ((e.chars || e.fonts) && (this.renderer.globalData.fontManager.addChars(e.chars), this.renderer.globalData.fontManager.addFonts(e.fonts, this.renderer.globalData.defs)), e.assets) for (i = e.assets.length, t = 0; t < i; t += 1) {
          this.animationData.assets.push(e.assets[t]);
        }
        this.animationData.__complete = !1, dataManager.completeData(this.animationData, this.renderer.globalData.fontManager), this.renderer.includeLayers(e.layers), expressionsPlugin && expressionsPlugin.initExpressions(this), this.renderer.renderFrame(null), this.loadNextSegment();
      }, AnimationItem.prototype.loadNextSegment = function () {
        var e = this.animationData.segments;
        if (!e || 0 === e.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.animationData.tf);
        var t = e.shift();
        this.timeCompleted = t.time * this.frameRate;
        var n = new XMLHttpRequest(),
            r = this,
            i = this.path + this.fileName + "_" + this.segmentPos + ".json";
        this.segmentPos += 1, n.open("GET", i, !0), n.send(), n.onreadystatechange = function () {
          if (4 == n.readyState) if (200 == n.status) r.includeLayers(JSON.parse(n.responseText));else try {
            var e = JSON.parse(n.responseText);
            r.includeLayers(e);
          } catch (t) {}
        };
      }, AnimationItem.prototype.loadSegments = function () {
        this.animationData.segments || (this.timeCompleted = this.animationData.tf), this.loadNextSegment();
      }, AnimationItem.prototype.configAnimation = function (e) {
        var t = this;
        this.renderer && this.renderer.destroyed || (this.animationData = e, this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.animationData.tf = this.totalFrames, this.renderer.configAnimation(e), e.assets || (e.assets = []), e.comps && (e.assets = e.assets.concat(e.comps), e.comps = null), this.renderer.searchExtraCompositions(e.assets), this.layers = this.animationData.layers, this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.firstFrame = Math.round(this.animationData.ip), this.frameMult = this.animationData.fr / 1e3, this.trigger("config_ready"), this.imagePreloader = new ImagePreloader(), this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(e.assets, function (e) {
          e || t.trigger("loaded_images");
        }), this.loadSegments(), this.updaFrameModifier(), this.renderer.globalData.fontManager ? this.waitForFontsLoaded() : (dataManager.completeData(this.animationData, this.renderer.globalData.fontManager), this.checkLoaded()));
      }, AnimationItem.prototype.waitForFontsLoaded = function () {
        return function () {
          (function checkFontsLoaded() {
            this.renderer.globalData.fontManager.loaded ? (dataManager.completeData(this.animationData, this.renderer.globalData.fontManager), this.checkLoaded()) : setTimeout(checkFontsLoaded.bind(this), 20);
          }).bind(this)();
        };
      }(), AnimationItem.prototype.addPendingElement = function () {
        this.pendingElements += 1;
      }, AnimationItem.prototype.elementLoaded = function () {
        this.pendingElements--, this.checkLoaded();
      }, AnimationItem.prototype.checkLoaded = function () {
        0 === this.pendingElements && (expressionsPlugin && expressionsPlugin.initExpressions(this), this.renderer.initItems(), setTimeout(function () {
          this.trigger("DOMLoaded");
        }.bind(this), 0), this.isLoaded = !0, this.gotoFrame(), this.autoplay && this.play());
      }, AnimationItem.prototype.resize = function () {
        this.renderer.updateContainerSize();
      }, AnimationItem.prototype.setSubframe = function (e) {
        this.subframeEnabled = !!e;
      }, AnimationItem.prototype.gotoFrame = function () {
        this.subframeEnabled ? this.currentFrame = this.currentRawFrame : this.currentFrame = Math.floor(this.currentRawFrame), this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame();
      }, AnimationItem.prototype.renderFrame = function () {
        !1 !== this.isLoaded && this.renderer.renderFrame(this.currentFrame + this.firstFrame);
      }, AnimationItem.prototype.play = function (e) {
        e && this.name != e || !0 === this.isPaused && (this.isPaused = !1, this._idle && (this._idle = !1, this.trigger("_active")));
      }, AnimationItem.prototype.pause = function (e) {
        e && this.name != e || !1 === this.isPaused && (this.isPaused = !0, this.pendingSegment || (this._idle = !0, this.trigger("_idle")));
      }, AnimationItem.prototype.togglePause = function (e) {
        e && this.name != e || (!0 === this.isPaused ? this.play() : this.pause());
      }, AnimationItem.prototype.stop = function (e) {
        e && this.name != e || (this.pause(), this.currentFrame = this.currentRawFrame = 0, this.playCount = 0, this.gotoFrame());
      }, AnimationItem.prototype.goToAndStop = function (e, t, n) {
        n && this.name != n || (t ? this.setCurrentRawFrameValue(e) : this.setCurrentRawFrameValue(e * this.frameModifier), this.pause());
      }, AnimationItem.prototype.goToAndPlay = function (e, t, n) {
        this.goToAndStop(e, t, n), this.play();
      }, AnimationItem.prototype.advanceTime = function (e) {
        if (this.pendingSegment) return this.pendingSegment = !1, this.adjustSegment(this.segments.shift()), void (this.isPaused && this.play());
        !0 !== this.isPaused && !1 !== this.isLoaded && this.setCurrentRawFrameValue(this.currentRawFrame + e * this.frameModifier);
      }, AnimationItem.prototype.updateAnimation = function (e) {
        this.setCurrentRawFrameValue(this.totalFrames * e);
      }, AnimationItem.prototype.moveFrame = function (e, t) {
        t && this.name != t || this.setCurrentRawFrameValue(this.currentRawFrame + e);
      }, AnimationItem.prototype.adjustSegment = function (e) {
        this.playCount = 0, e[1] < e[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = e[0] - e[1], this.firstFrame = e[1], this.setCurrentRawFrameValue(this.totalFrames - .01)) : e[1] > e[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = e[1] - e[0], this.firstFrame = e[0], this.setCurrentRawFrameValue(0)), this.trigger("segmentStart");
      }, AnimationItem.prototype.setSegment = function (e, t) {
        var n = -1;
        this.isPaused && (this.currentRawFrame + this.firstFrame < e ? n = e : this.currentRawFrame + this.firstFrame > t && (n = t - e - .01)), this.firstFrame = e, this.totalFrames = t - e, -1 !== n && this.goToAndStop(n, !0);
      }, AnimationItem.prototype.playSegments = function (e, t) {
        if ("object" === typeof e[0]) {
          var n,
              r = e.length;

          for (n = 0; n < r; n += 1) {
            this.segments.push(e[n]);
          }
        } else this.segments.push(e);

        t && this.adjustSegment(this.segments.shift()), this.isPaused && this.play();
      }, AnimationItem.prototype.resetSegments = function (e) {
        this.segments.length = 0, this.segments.push([this.animationData.ip * this.frameRate, Math.floor(this.animationData.op - this.animationData.ip + this.animationData.ip * this.frameRate)]), e && this.adjustSegment(this.segments.shift());
      }, AnimationItem.prototype.checkSegments = function () {
        this.segments.length && (this.pendingSegment = !0);
      }, AnimationItem.prototype.remove = function (e) {
        e && this.name != e || this.renderer.destroy();
      }, AnimationItem.prototype.destroy = function (e) {
        e && this.name != e || this.renderer && this.renderer.destroyed || (this.renderer.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null);
      }, AnimationItem.prototype.setCurrentRawFrameValue = function (e) {
        if (this.currentRawFrame = e, this.currentRawFrame >= this.totalFrames) {
          if (this.checkSegments(), !1 === this.loop) return this.currentRawFrame = this.totalFrames - .01, this.gotoFrame(), this.pause(), void this.trigger("complete");
          if (this.trigger("loopComplete"), this.playCount += 1, !0 !== this.loop && this.playCount == this.loop || this.pendingSegment) return this.currentRawFrame = this.totalFrames - .01, this.gotoFrame(), this.pause(), void this.trigger("complete");
          this.currentRawFrame = this.currentRawFrame % this.totalFrames;
        } else if (this.currentRawFrame < 0) return this.checkSegments(), this.playCount -= 1, this.playCount < 0 && (this.playCount = 0), !1 === this.loop || this.pendingSegment ? (this.currentRawFrame = 0, this.gotoFrame(), this.pause(), void this.trigger("complete")) : (this.trigger("loopComplete"), this.currentRawFrame = (this.totalFrames + this.currentRawFrame) % this.totalFrames, void this.gotoFrame());

        this.gotoFrame();
      }, AnimationItem.prototype.setSpeed = function (e) {
        this.playSpeed = e, this.updaFrameModifier();
      }, AnimationItem.prototype.setDirection = function (e) {
        this.playDirection = e < 0 ? -1 : 1, this.updaFrameModifier();
      }, AnimationItem.prototype.updaFrameModifier = function () {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
      }, AnimationItem.prototype.getPath = function () {
        return this.path;
      }, AnimationItem.prototype.getAssetsPath = function (e) {
        var t = "";

        if (this.assetsPath) {
          var n = e.p;
          -1 !== n.indexOf("images/") && (n = n.split("/")[1]), t = this.assetsPath + n;
        } else t = this.path, t += e.u ? e.u : "", t += e.p;

        return t;
      }, AnimationItem.prototype.getAssetData = function (e) {
        for (var t = 0, n = this.assets.length; t < n;) {
          if (e == this.assets[t].id) return this.assets[t];
          t += 1;
        }
      }, AnimationItem.prototype.hide = function () {
        this.renderer.hide();
      }, AnimationItem.prototype.show = function () {
        this.renderer.show();
      }, AnimationItem.prototype.getAssets = function () {
        return this.assets;
      }, AnimationItem.prototype.trigger = function (e) {
        if (this._cbs && this._cbs[e]) switch (e) {
          case "enterFrame":
            this.triggerEvent(e, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameMult));
            break;

          case "loopComplete":
            this.triggerEvent(e, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult));
            break;

          case "complete":
            this.triggerEvent(e, new BMCompleteEvent(e, this.frameMult));
            break;

          case "segmentStart":
            this.triggerEvent(e, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames));
            break;

          case "destroy":
            this.triggerEvent(e, new BMDestroyEvent(e, this));
            break;

          default:
            this.triggerEvent(e);
        }
        "enterFrame" === e && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(e, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === e && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(e, this.loop, this.playCount, this.frameMult)), "complete" === e && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(e, this.frameMult)), "segmentStart" === e && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(e, this.firstFrame, this.totalFrames)), "destroy" === e && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(e, this));
      }, AnimationItem.prototype.addEventListener = _addEventListener, AnimationItem.prototype.removeEventListener = _removeEventListener, AnimationItem.prototype.triggerEvent = _triggerEvent, extendPrototype(BaseRenderer, CanvasRenderer), CanvasRenderer.prototype.createBase = function (e) {
        return new CVBaseElement(e, this, this.globalData);
      }, CanvasRenderer.prototype.createShape = function (e) {
        return new CVShapeElement(e, this, this.globalData);
      }, CanvasRenderer.prototype.createText = function (e) {
        return new CVTextElement(e, this, this.globalData);
      }, CanvasRenderer.prototype.createImage = function (e) {
        return new CVImageElement(e, this, this.globalData);
      }, CanvasRenderer.prototype.createComp = function (e) {
        return new CVCompElement(e, this, this.globalData);
      }, CanvasRenderer.prototype.createSolid = function (e) {
        return new CVSolidElement(e, this, this.globalData);
      }, CanvasRenderer.prototype.ctxTransform = function (e) {
        if (1 !== e[0] || 0 !== e[1] || 0 !== e[4] || 1 !== e[5] || 0 !== e[12] || 0 !== e[13]) if (this.renderConfig.clearCanvas) {
          this.transformMat.cloneFromProps(e), this.transformMat.transform(this.contextData.cTr.props[0], this.contextData.cTr.props[1], this.contextData.cTr.props[2], this.contextData.cTr.props[3], this.contextData.cTr.props[4], this.contextData.cTr.props[5], this.contextData.cTr.props[6], this.contextData.cTr.props[7], this.contextData.cTr.props[8], this.contextData.cTr.props[9], this.contextData.cTr.props[10], this.contextData.cTr.props[11], this.contextData.cTr.props[12], this.contextData.cTr.props[13], this.contextData.cTr.props[14], this.contextData.cTr.props[15]), this.contextData.cTr.cloneFromProps(this.transformMat.props);
          var t = this.contextData.cTr.props;
          this.canvasContext.setTransform(t[0], t[1], t[4], t[5], t[12], t[13]);
        } else this.canvasContext.transform(e[0], e[1], e[4], e[5], e[12], e[13]);
      }, CanvasRenderer.prototype.ctxOpacity = function (e) {
        1 !== e && (this.renderConfig.clearCanvas ? (this.contextData.cO *= e < 0 ? 0 : e, this.canvasContext.globalAlpha = this.contextData.cO) : this.canvasContext.globalAlpha *= e < 0 ? 0 : e);
      }, CanvasRenderer.prototype.reset = function () {
        this.renderConfig.clearCanvas ? (this.contextData.cArrPos = 0, this.contextData.cTr.reset(), this.contextData.cO = 1) : this.canvasContext.restore();
      }, CanvasRenderer.prototype.save = function (e) {
        if (this.renderConfig.clearCanvas) {
          e && this.canvasContext.save();
          var t = this.contextData.cTr.props;
          null !== this.contextData.saved[this.contextData.cArrPos] && void 0 !== this.contextData.saved[this.contextData.cArrPos] || (this.contextData.saved[this.contextData.cArrPos] = new Array(16));
          var n,
              r = this.contextData.saved[this.contextData.cArrPos];

          for (n = 0; n < 16; n += 1) {
            r[n] = t[n];
          }

          this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO, this.contextData.cArrPos += 1;
        } else this.canvasContext.save();
      }, CanvasRenderer.prototype.restore = function (e) {
        if (this.renderConfig.clearCanvas) {
          e && this.canvasContext.restore(), this.contextData.cArrPos -= 1;
          var t,
              n = this.contextData.saved[this.contextData.cArrPos],
              r = this.contextData.cTr.props;

          for (t = 0; t < 16; t += 1) {
            r[t] = n[t];
          }

          this.canvasContext.setTransform(n[0], n[1], n[4], n[5], n[12], n[13]), n = this.contextData.savedOp[this.contextData.cArrPos], this.contextData.cO = n, this.canvasContext.globalAlpha = n;
        } else this.canvasContext.restore();
      }, CanvasRenderer.prototype.configAnimation = function (e) {
        this.animationItem.wrapper ? (this.animationItem.container = document.createElement("canvas"), this.animationItem.container.style.width = "100%", this.animationItem.container.style.height = "100%", this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style["-webkit-transform"] = "0px 0px 0px", this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className)) : this.canvasContext = this.renderConfig.context, this.data = e, this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.totalFrames = Math.floor(e.tf), this.globalData.compWidth = e.w, this.globalData.compHeight = e.h, this.globalData.frameRate = e.fr, this.globalData.frameId = 0, this.globalData.compSize = {
          w: e.w,
          h: e.h
        }, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.layers = e.layers, this.transformCanvas = {}, this.transformCanvas.w = e.w, this.transformCanvas.h = e.h, this.globalData.fontManager = new FontManager(), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, document.body), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem), this.globalData.addPendingElement = this.animationItem.addPendingElement.bind(this.animationItem), this.globalData.transformCanvas = this.transformCanvas, this.elements = Array.apply(null, {
          length: e.layers.length
        }), this.updateContainerSize();
      }, CanvasRenderer.prototype.updateContainerSize = function () {
        var e, t, n, r;

        if (this.animationItem.wrapper && this.animationItem.container ? (e = this.animationItem.wrapper.offsetWidth, t = this.animationItem.wrapper.offsetHeight, this.animationItem.container.setAttribute("width", e * this.renderConfig.dpr), this.animationItem.container.setAttribute("height", t * this.renderConfig.dpr)) : (e = this.canvasContext.canvas.width * this.renderConfig.dpr, t = this.canvasContext.canvas.height * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
          var i = this.renderConfig.preserveAspectRatio.split(" "),
              a = i[1] || "meet",
              o = i[0] || "xMidYMid",
              s = o.substr(0, 4),
              l = o.substr(4);
          n = e / t, (r = this.transformCanvas.w / this.transformCanvas.h) > n && "meet" === a || r < n && "slice" === a ? (this.transformCanvas.sx = e / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = e / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = t / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = t / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === s && (r < n && "meet" === a || r > n && "slice" === a) ? (e - this.transformCanvas.w * (t / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === s && (r < n && "meet" === a || r > n && "slice" === a) ? (e - this.transformCanvas.w * (t / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === l && (r > n && "meet" === a || r < n && "slice" === a) ? (t - this.transformCanvas.h * (e / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === l && (r > n && "meet" === a || r < n && "slice" === a) ? (t - this.transformCanvas.h * (e / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
        } else "none" == this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = e / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = t / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);

        this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
        var c,
            p = this.elements.length;

        for (c = 0; c < p; c += 1) {
          this.elements[c] && 0 === this.elements[c].data.ty && this.elements[c].resize(this.globalData.transformCanvas);
        }
      }, CanvasRenderer.prototype.destroy = function () {
        var e;

        for (this.renderConfig.clearCanvas && (this.animationItem.wrapper.innerHTML = ""), e = (this.layers ? this.layers.length : 0) - 1; e >= 0; e -= 1) {
          this.elements[e] && this.elements[e].destroy();
        }

        this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
      }, CanvasRenderer.prototype.renderFrame = function (e) {
        if (!(this.renderedFrame == e && !0 === this.renderConfig.clearCanvas || this.destroyed || null === e)) {
          this.renderedFrame = e, this.globalData.frameNum = e - this.animationItem.firstFrame, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = e, !0 === this.renderConfig.clearCanvas ? (this.reset(), this.canvasContext.save(), this.canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy)) : this.save(), this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip();
          var t,
              n = this.layers.length;

          for (this.completeLayers || this.checkLayers(e), t = 0; t < n; t++) {
            (this.completeLayers || this.elements[t]) && this.elements[t].prepareFrame(e - this.layers[t].st);
          }

          for (t = n - 1; t >= 0; t -= 1) {
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
          }

          !0 !== this.renderConfig.clearCanvas ? this.restore() : this.canvasContext.restore();
        }
      }, CanvasRenderer.prototype.buildItem = function (e) {
        var t = this.elements;

        if (!t[e] && 99 != this.layers[e].ty) {
          var n = this.createItem(this.layers[e], this, this.globalData);
          t[e] = n, n.initExpressions(), 0 === this.layers[e].ty && n.resize(this.globalData.transformCanvas);
        }
      }, CanvasRenderer.prototype.checkPendingElements = function () {
        for (; this.pendingElements.length;) {
          this.pendingElements.pop().checkParenting();
        }
      }, CanvasRenderer.prototype.hide = function () {
        this.animationItem.container.style.display = "none";
      }, CanvasRenderer.prototype.show = function () {
        this.animationItem.container.style.display = "block";
      }, CanvasRenderer.prototype.searchExtraCompositions = function (e) {
        var t,
            n = e.length;
        document.createElementNS(svgNS, "g");

        for (t = 0; t < n; t += 1) {
          if (e[t].xt) {
            var r = this.createComp(e[t], this.globalData.comp, this.globalData);
            r.initExpressions(), this.globalData.projectInterface.registerComposition(r);
          }
        }
      }, extendPrototype(BaseRenderer, HybridRenderer), HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRenderer.prototype.checkPendingElements = function () {
        for (; this.pendingElements.length;) {
          this.pendingElements.pop().checkParenting();
        }
      }, HybridRenderer.prototype.appendElementInPos = function (e, t) {
        var n = e.getBaseElement();

        if (n) {
          var r = this.layers[t];
          if (r.ddd && this.supports3d) this.addTo3dContainer(n, t);else {
            for (var i, a, o = 0; o < t;) {
              this.elements[o] && !0 !== this.elements[o] && this.elements[o].getBaseElement && (a = this.elements[o], i = this.layers[o].ddd ? this.getThreeDContainerByPos(o) : a.getBaseElement()), o += 1;
            }

            i ? r.ddd && this.supports3d || this.layerElement.insertBefore(n, i) : r.ddd && this.supports3d || this.layerElement.appendChild(n);
          }
        }
      }, HybridRenderer.prototype.createBase = function (e) {
        return new SVGBaseElement(e, this.layerElement, this.globalData, this);
      }, HybridRenderer.prototype.createShape = function (e) {
        return this.supports3d ? new HShapeElement(e, this.layerElement, this.globalData, this) : new IShapeElement(e, this.layerElement, this.globalData, this);
      }, HybridRenderer.prototype.createText = function (e) {
        return this.supports3d ? new HTextElement(e, this.layerElement, this.globalData, this) : new SVGTextElement(e, this.layerElement, this.globalData, this);
      }, HybridRenderer.prototype.createCamera = function (e) {
        return this.camera = new HCameraElement(e, this.layerElement, this.globalData, this), this.camera;
      }, HybridRenderer.prototype.createImage = function (e) {
        return this.supports3d ? new HImageElement(e, this.layerElement, this.globalData, this) : new IImageElement(e, this.layerElement, this.globalData, this);
      }, HybridRenderer.prototype.createComp = function (e) {
        return this.supports3d ? new HCompElement(e, this.layerElement, this.globalData, this) : new ICompElement(e, this.layerElement, this.globalData, this);
      }, HybridRenderer.prototype.createSolid = function (e) {
        return this.supports3d ? new HSolidElement(e, this.layerElement, this.globalData, this) : new ISolidElement(e, this.layerElement, this.globalData, this);
      }, HybridRenderer.prototype.getThreeDContainerByPos = function (e) {
        for (var t = 0, n = this.threeDElements.length; t < n;) {
          if (this.threeDElements[t].startPos <= e && this.threeDElements[t].endPos >= e) return this.threeDElements[t].perspectiveElem;
          t += 1;
        }
      }, HybridRenderer.prototype.createThreeDContainer = function (e) {
        var t = document.createElement("div");
        styleDiv(t), t.style.width = this.globalData.compSize.w + "px", t.style.height = this.globalData.compSize.h + "px", t.style.transformOrigin = t.style.mozTransformOrigin = t.style.webkitTransformOrigin = "50% 50%";
        var n = document.createElement("div");
        styleDiv(n), n.style.transform = n.style.webkitTransform = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)", t.appendChild(n), this.resizerElem.appendChild(t);
        var r = {
          container: n,
          perspectiveElem: t,
          startPos: e,
          endPos: e
        };
        return this.threeDElements.push(r), r;
      }, HybridRenderer.prototype.build3dContainers = function () {
        var e,
            t,
            n = this.layers.length;

        for (e = 0; e < n; e += 1) {
          this.layers[e].ddd ? (t || (t = this.createThreeDContainer(e)), t.endPos = Math.max(t.endPos, e)) : t = null;
        }
      }, HybridRenderer.prototype.addTo3dContainer = function (e, t) {
        for (var n = 0, r = this.threeDElements.length; n < r;) {
          if (t <= this.threeDElements[n].endPos) {
            for (var i, a = this.threeDElements[n].startPos; a < t;) {
              this.elements[a] && this.elements[a].getBaseElement && (i = this.elements[a].getBaseElement()), a += 1;
            }

            i ? this.threeDElements[n].container.insertBefore(e, i) : this.threeDElements[n].container.appendChild(e);
            break;
          }

          n += 1;
        }
      }, HybridRenderer.prototype.configAnimation = function (e) {
        var t = document.createElement("div"),
            n = this.animationItem.wrapper;
        t.style.width = e.w + "px", t.style.height = e.h + "px", this.resizerElem = t, styleDiv(t), t.style.transformStyle = t.style.webkitTransformStyle = t.style.mozTransformStyle = "flat", this.renderConfig.className && n.setAttribute("class", this.renderConfig.className), n.appendChild(t), t.style.overflow = "hidden";
        var r = document.createElementNS(svgNS, "svg");
        r.setAttribute("width", "1"), r.setAttribute("height", "1"), styleDiv(r), this.resizerElem.appendChild(r);
        var i = document.createElementNS(svgNS, "defs");
        r.appendChild(i), this.globalData.defs = i, this.data = e, this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem), this.globalData.frameId = 0, this.globalData.compSize = {
          w: e.w,
          h: e.h
        }, this.globalData.frameRate = e.fr, this.layers = e.layers, this.globalData.fontManager = new FontManager(), this.globalData.fontManager.addChars(e.chars), this.globalData.fontManager.addFonts(e.fonts, r), this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
      }, HybridRenderer.prototype.destroy = function () {
        this.animationItem.wrapper.innerHTML = "", this.animationItem.container = null, this.globalData.defs = null;
        var e,
            t = this.layers ? this.layers.length : 0;

        for (e = 0; e < t; e++) {
          this.elements[e].destroy();
        }

        this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
      }, HybridRenderer.prototype.updateContainerSize = function () {
        var e,
            t,
            n,
            r,
            i = this.animationItem.wrapper.offsetWidth,
            a = this.animationItem.wrapper.offsetHeight,
            o = i / a;
        this.globalData.compSize.w / this.globalData.compSize.h > o ? (e = i / this.globalData.compSize.w, t = i / this.globalData.compSize.w, n = 0, r = (a - this.globalData.compSize.h * (i / this.globalData.compSize.w)) / 2) : (e = a / this.globalData.compSize.h, t = a / this.globalData.compSize.h, n = (i - this.globalData.compSize.w * (a / this.globalData.compSize.h)) / 2, r = 0), this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = "matrix3d(" + e + ",0,0,0,0," + t + ",0,0,0,0,1,0," + n + "," + r + ",0,1)";
      }, HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRenderer.prototype.hide = function () {
        this.resizerElem.style.display = "none";
      }, HybridRenderer.prototype.show = function () {
        this.resizerElem.style.display = "block";
      }, HybridRenderer.prototype.initItems = function () {
        if (this.buildAllItems(), this.camera) this.camera.setup();else {
          var e,
              t = this.globalData.compSize.w,
              n = this.globalData.compSize.h,
              r = this.threeDElements.length;

          for (e = 0; e < r; e += 1) {
            this.threeDElements[e].perspectiveElem.style.perspective = this.threeDElements[e].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(t, 2) + Math.pow(n, 2)) + "px";
          }
        }
      }, HybridRenderer.prototype.searchExtraCompositions = function (e) {
        var t,
            n = e.length,
            r = document.createElement("div");

        for (t = 0; t < n; t += 1) {
          if (e[t].xt) {
            var i = this.createComp(e[t], r, this.globalData.comp, null);
            i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
          }
        }
      }, createElement(BaseElement, CVBaseElement), CVBaseElement.prototype.createElements = function () {
        this.checkParenting();
      }, CVBaseElement.prototype.checkBlendMode = function (e) {
        if (e.blendMode !== this.data.bm) {
          e.blendMode = this.data.bm;
          var t = "";

          switch (this.data.bm) {
            case 0:
              t = "normal";
              break;

            case 1:
              t = "multiply";
              break;

            case 2:
              t = "screen";
              break;

            case 3:
              t = "overlay";
              break;

            case 4:
              t = "darken";
              break;

            case 5:
              t = "lighten";
              break;

            case 6:
              t = "color-dodge";
              break;

            case 7:
              t = "color-burn";
              break;

            case 8:
              t = "hard-light";
              break;

            case 9:
              t = "soft-light";
              break;

            case 10:
              t = "difference";
              break;

            case 11:
              t = "exclusion";
              break;

            case 12:
              t = "hue";
              break;

            case 13:
              t = "saturation";
              break;

            case 14:
              t = "color";
              break;

            case 15:
              t = "luminosity";
          }

          e.canvasContext.globalCompositeOperation = t;
        }
      }, CVBaseElement.prototype.renderFrame = function (e) {
        if (3 === this.data.ty) return !1;
        if (this.checkBlendMode(0 === this.data.ty ? this.parentGlobalData : this.globalData), !this.isVisible) return this.isVisible;
        var t;
        this.finalTransform.opMdf = this.finalTransform.op.mdf, this.finalTransform.matMdf = this.finalTransform.mProp.mdf, this.finalTransform.opacity = this.finalTransform.op.v;
        var n = this.finalTransform.mat;

        if (this.hierarchy) {
          var r,
              i = this.hierarchy.length;

          for (t = this.finalTransform.mProp.v.props, n.cloneFromProps(t), r = 0; r < i; r += 1) {
            this.finalTransform.matMdf = !!this.hierarchy[r].finalTransform.mProp.mdf || this.finalTransform.matMdf, t = this.hierarchy[r].finalTransform.mProp.v.props, n.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
          }
        } else e ? (t = this.finalTransform.mProp.v.props, n.cloneFromProps(t)) : n.cloneFromProps(this.finalTransform.mProp.v.props);

        return e && (t = e.mat.props, n.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]), this.finalTransform.opacity *= e.opacity, this.finalTransform.opMdf = !!e.opMdf || this.finalTransform.opMdf, this.finalTransform.matMdf = !!e.matMdf || this.finalTransform.matMdf), this.data.hasMask && (this.globalData.renderer.save(!0), this.maskManager.renderFrame(0 === this.data.ty ? null : n)), this.data.hd && (this.isVisible = !1), this.isVisible;
      }, CVBaseElement.prototype.addMasks = function (e) {
        this.maskManager = new CVMaskElement(e, this, this.globalData);
      }, CVBaseElement.prototype.destroy = function () {
        this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager && this.maskManager.destroy();
      }, CVBaseElement.prototype.mHelper = new Matrix(), createElement(CVBaseElement, CVCompElement), CVCompElement.prototype.ctxTransform = CanvasRenderer.prototype.ctxTransform, CVCompElement.prototype.ctxOpacity = CanvasRenderer.prototype.ctxOpacity, CVCompElement.prototype.save = CanvasRenderer.prototype.save, CVCompElement.prototype.restore = CanvasRenderer.prototype.restore, CVCompElement.prototype.reset = function () {
        this.contextData.cArrPos = 0, this.contextData.cTr.reset(), this.contextData.cO = 1;
      }, CVCompElement.prototype.resize = function (e) {
        var t = Math.max(e.sx, e.sy);
        this.canvas.width = this.data.w * t, this.canvas.height = this.data.h * t, this.transformCanvas = {
          sc: t,
          w: this.data.w * t,
          h: this.data.h * t,
          props: [t, 0, 0, 0, 0, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
        };
        var n,
            r = this.elements.length;

        for (n = 0; n < r; n += 1) {
          this.elements[n] && 0 === this.elements[n].data.ty && this.elements[n].resize(e);
        }
      }, CVCompElement.prototype.prepareFrame = function (e) {
        if (this.globalData.frameId = this.parentGlobalData.frameId, this.globalData.mdf = !1, this._parent.prepareFrame.call(this, e), !1 !== this.isVisible || this.data.xt) {
          var t = e;
          this.tm && (t = this.tm.v) === this.data.op && (t = this.data.op - 1), this.renderedFrame = t / this.data.sr;
          var n,
              r = this.elements.length;

          for (this.completeLayers || this.checkLayers(e), n = 0; n < r; n += 1) {
            (this.completeLayers || this.elements[n]) && (this.elements[n].prepareFrame(t / this.data.sr - this.layers[n].st), 0 === this.elements[n].data.ty && this.elements[n].globalData.mdf && (this.globalData.mdf = !0));
          }

          this.globalData.mdf && !this.data.xt && (this.canvasContext.clearRect(0, 0, this.data.w, this.data.h), this.ctxTransform(this.transformCanvas.props));
        }
      }, CVCompElement.prototype.renderFrame = function (e) {
        if (!1 !== this._parent.renderFrame.call(this, e)) {
          var t;
          if (this.globalData.mdf) for (t = this.layers.length - 1; t >= 0; t -= 1) {
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
          }
          this.data.hasMask && this.globalData.renderer.restore(!0), this.firstFrame && (this.firstFrame = !1), this.parentGlobalData.renderer.save(), this.parentGlobalData.renderer.ctxTransform(this.finalTransform.mat.props), this.parentGlobalData.renderer.ctxOpacity(this.finalTransform.opacity), this.parentGlobalData.renderer.canvasContext.drawImage(this.canvas, 0, 0, this.data.w, this.data.h), this.parentGlobalData.renderer.restore(), this.globalData.mdf && this.reset();
        }
      }, CVCompElement.prototype.setElements = function (e) {
        this.elements = e;
      }, CVCompElement.prototype.getElements = function () {
        return this.elements;
      }, CVCompElement.prototype.destroy = function () {
        var e;

        for (e = this.layers.length - 1; e >= 0; e -= 1) {
          this.elements[e].destroy();
        }

        this.layers = null, this.elements = null, this._parent.destroy.call(this._parent);
      }, CVCompElement.prototype.checkLayers = CanvasRenderer.prototype.checkLayers, CVCompElement.prototype.buildItem = CanvasRenderer.prototype.buildItem, CVCompElement.prototype.checkPendingElements = CanvasRenderer.prototype.checkPendingElements, CVCompElement.prototype.addPendingElement = CanvasRenderer.prototype.addPendingElement, CVCompElement.prototype.buildAllItems = CanvasRenderer.prototype.buildAllItems, CVCompElement.prototype.createItem = CanvasRenderer.prototype.createItem, CVCompElement.prototype.createImage = CanvasRenderer.prototype.createImage, CVCompElement.prototype.createComp = CanvasRenderer.prototype.createComp, CVCompElement.prototype.createSolid = CanvasRenderer.prototype.createSolid, CVCompElement.prototype.createShape = CanvasRenderer.prototype.createShape, CVCompElement.prototype.createText = CanvasRenderer.prototype.createText, CVCompElement.prototype.createBase = CanvasRenderer.prototype.createBase, CVCompElement.prototype.buildElementParenting = CanvasRenderer.prototype.buildElementParenting, createElement(CVBaseElement, CVImageElement), CVImageElement.prototype.createElements = function () {
        var e = function () {
          if (this.globalData.elementLoaded(), this.assetData.w !== this.img.width || this.assetData.h !== this.img.height) {
            var e = document.createElement("canvas");
            e.width = this.assetData.w, e.height = this.assetData.h;
            var t,
                n,
                r = e.getContext("2d"),
                i = this.img.width,
                a = this.img.height,
                o = i / a,
                s = this.assetData.w / this.assetData.h;
            o > s ? t = (n = a) * s : n = (t = i) / s, r.drawImage(this.img, (i - t) / 2, (a - n) / 2, t, n, 0, 0, this.assetData.w, this.assetData.h), this.img = e;
          }
        }.bind(this),
            t = function () {
          this.failed = !0, this.globalData.elementLoaded();
        }.bind(this);

        this.img = new Image(), this.img.addEventListener("load", e, !1), this.img.addEventListener("error", t, !1);
        var n = this.globalData.getAssetsPath(this.assetData);
        this.img.src = n, this._parent.createElements.call(this);
      }, CVImageElement.prototype.renderFrame = function (e) {
        if (!this.failed && !1 !== this._parent.renderFrame.call(this, e)) {
          var t = this.canvasContext;
          this.globalData.renderer.save();
          var n = this.finalTransform.mat.props;
          this.globalData.renderer.ctxTransform(n), this.globalData.renderer.ctxOpacity(this.finalTransform.opacity), t.drawImage(this.img, 0, 0), this.globalData.renderer.restore(this.data.hasMask), this.firstFrame && (this.firstFrame = !1);
        }
      }, CVImageElement.prototype.destroy = function () {
        this.img = null, this._parent.destroy.call(this._parent);
      }, CVMaskElement.prototype.prepareFrame = function (e) {
        var t,
            n = this.dynamicProperties.length;

        for (t = 0; t < n; t += 1) {
          this.dynamicProperties[t].getValue(e), this.dynamicProperties[t].mdf && (this.element.globalData.mdf = !0);
        }
      }, CVMaskElement.prototype.renderFrame = function (e) {
        var t,
            n,
            r,
            i,
            a,
            o = this.element.canvasContext,
            s = this.data.masksProperties.length,
            l = !1;

        for (t = 0; t < s; t++) {
          if ("n" !== this.masksProperties[t].mode) {
            !1 === l && (o.beginPath(), l = !0), this.masksProperties[t].inv && (o.moveTo(0, 0), o.lineTo(this.element.globalData.compWidth, 0), o.lineTo(this.element.globalData.compWidth, this.element.globalData.compHeight), o.lineTo(0, this.element.globalData.compHeight), o.lineTo(0, 0)), a = this.viewData[t].v, n = e ? e.applyToPointArray(a.v[0][0], a.v[0][1], 0) : a.v[0], o.moveTo(n[0], n[1]);
            var c,
                p = a._length;

            for (c = 1; c < p; c++) {
              n = e ? e.applyToPointArray(a.o[c - 1][0], a.o[c - 1][1], 0) : a.o[c - 1], r = e ? e.applyToPointArray(a.i[c][0], a.i[c][1], 0) : a.i[c], i = e ? e.applyToPointArray(a.v[c][0], a.v[c][1], 0) : a.v[c], o.bezierCurveTo(n[0], n[1], r[0], r[1], i[0], i[1]);
            }

            n = e ? e.applyToPointArray(a.o[c - 1][0], a.o[c - 1][1], 0) : a.o[c - 1], r = e ? e.applyToPointArray(a.i[0][0], a.i[0][1], 0) : a.i[0], i = e ? e.applyToPointArray(a.v[0][0], a.v[0][1], 0) : a.v[0], o.bezierCurveTo(n[0], n[1], r[0], r[1], i[0], i[1]);
          }
        }

        l && o.clip();
      }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function () {
        this.element = null;
      }, createElement(CVBaseElement, CVShapeElement), CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        mat: new Matrix(),
        matMdf: !1,
        opMdf: !1
      }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createElements = function () {
        this._parent.createElements.call(this), this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.dynamicProperties, !0);
      }, CVShapeElement.prototype.createStyleElement = function (e, t) {
        var n = {
          data: e,
          type: e.ty,
          elements: []
        },
            r = {};

        if ("fl" != e.ty && "st" != e.ty || (r.c = PropertyFactory.getProp(this, e.c, 1, 255, t), r.c.k || (n.co = "rgb(" + bm_floor(r.c.v[0]) + "," + bm_floor(r.c.v[1]) + "," + bm_floor(r.c.v[2]) + ")")), r.o = PropertyFactory.getProp(this, e.o, 0, .01, t), "st" == e.ty) {
          if (n.lc = this.lcEnum[e.lc] || "round", n.lj = this.ljEnum[e.lj] || "round", 1 == e.lj && (n.ml = e.ml), r.w = PropertyFactory.getProp(this, e.w, 0, null, t), r.w.k || (n.wi = r.w.v), e.d) {
            var i = PropertyFactory.getDashProp(this, e.d, "canvas", t);
            r.d = i, r.d.k || (n.da = r.d.dasharray, n.do = r.d.dashoffset);
          }
        } else n.r = 2 === e.r ? "evenodd" : "nonzero";

        return this.stylesList.push(n), r.style = n, r;
      }, CVShapeElement.prototype.createGroupElement = function (e) {
        return {
          it: [],
          prevViewData: []
        };
      }, CVShapeElement.prototype.createTransformElement = function (e, t) {
        return {
          transform: {
            mat: new Matrix(),
            opacity: 1,
            matMdf: !1,
            opMdf: !1,
            op: PropertyFactory.getProp(this, e.o, 0, .01, t),
            mProps: PropertyFactory.getProp(this, e, 2, null, t)
          },
          elements: []
        };
      }, CVShapeElement.prototype.createShapeElement = function (e, t) {
        var n = {
          nodes: [],
          trNodes: [],
          tr: [0, 0, 0, 0, 0, 0]
        },
            r = 4;
        "rc" == e.ty ? r = 5 : "el" == e.ty ? r = 6 : "sr" == e.ty && (r = 7), n.sh = ShapePropertyFactory.getShapeProp(this, e, r, t), this.shapes.push(n.sh), this.addShapeToModifiers(n), jLen = this.stylesList.length;
        var i = !1,
            a = !1;

        for (j = 0; j < jLen; j += 1) {
          this.stylesList[j].closed || (this.stylesList[j].elements.push(n), "st" === this.stylesList[j].type ? i = !0 : a = !0);
        }

        return n.st = i, n.fl = a, n;
      }, CVShapeElement.prototype.reloadShapes = function () {
        this.firstFrame = !0;
        var e = this.itemsData.length;

        for (t = 0; t < e; t += 1) {
          this.prevViewData[t] = this.itemsData[t];
        }

        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.dynamicProperties, !0);
        var t;
        e = this.dynamicProperties.length;

        for (t = 0; t < e; t += 1) {
          this.dynamicProperties[t].getValue();
        }

        this.renderModifiers();
      }, CVShapeElement.prototype.searchShapes = function (e, t, n, r, i) {
        var a,
            o,
            s,
            l,
            c = e.length - 1,
            p = [],
            d = [];

        for (a = c; a >= 0; a -= 1) {
          if ((l = this.searchProcessedElement(e[a])) ? t[a] = n[l - 1] : e[a]._render = i, "fl" == e[a].ty || "st" == e[a].ty) l ? t[a].style.closed = !1 : t[a] = this.createStyleElement(e[a], r), p.push(t[a].style);else if ("gr" == e[a].ty) {
            if (l) for (s = t[a].it.length, o = 0; o < s; o += 1) {
              t[a].prevViewData[o] = t[a].it[o];
            } else t[a] = this.createGroupElement(e[a]);
            this.searchShapes(e[a].it, t[a].it, t[a].prevViewData, r, i);
          } else if ("tr" == e[a].ty) l || (t[a] = this.createTransformElement(e[a], r));else if ("sh" == e[a].ty || "rc" == e[a].ty || "el" == e[a].ty || "sr" == e[a].ty) l || (t[a] = this.createShapeElement(e[a], r));else if ("tm" == e[a].ty || "rd" == e[a].ty) {
            if (l) (h = t[a]).closed = !1;else {
              var h = ShapeModifiers.getModifier(e[a].ty);
              h.init(this, e[a], r), t[a] = h, this.shapeModifiers.push(h);
            }
            d.push(h);
          } else "rp" == e[a].ty && (l ? (h = t[a]).closed = !0 : (h = ShapeModifiers.getModifier(e[a].ty), t[a] = h, h.init(this, e, a, t, r), this.shapeModifiers.push(h), i = !1), d.push(h));
          this.addProcessedElement(e[a], a + 1);
        }

        for (c = p.length, a = 0; a < c; a += 1) {
          p[a].closed = !0;
        }

        for (c = d.length, a = 0; a < c; a += 1) {
          d[a].closed = !0;
        }
      }, CVShapeElement.prototype.addShapeToModifiers = IShapeElement.prototype.addShapeToModifiers, CVShapeElement.prototype.renderModifiers = IShapeElement.prototype.renderModifiers, CVShapeElement.prototype.lcEnum = IShapeElement.prototype.lcEnum, CVShapeElement.prototype.ljEnum = IShapeElement.prototype.ljEnum, CVShapeElement.prototype.searchProcessedElement = IShapeElement.prototype.searchProcessedElement, CVShapeElement.prototype.addProcessedElement = IShapeElement.prototype.addProcessedElement, CVShapeElement.prototype.renderFrame = function (e) {
        !1 !== this._parent.renderFrame.call(this, e) && (this.transformHelper.mat.reset(), this.transformHelper.opacity = this.finalTransform.opacity, this.transformHelper.matMdf = !1, this.transformHelper.opMdf = this.finalTransform.opMdf, this.renderModifiers(), this.renderShape(this.transformHelper, null, null, !0), this.data.hasMask && this.globalData.renderer.restore(!0));
      }, CVShapeElement.prototype.renderShape = function (e, t, n, r) {
        var i, a, o, s;
        if (!t) for (t = this.shapesData, a = this.stylesList.length, i = 0; i < a; i += 1) {
          this.stylesList[i].d = "", this.stylesList[i].mdf = !1;
        }

        for (n || (n = this.itemsData), o = e, i = a = t.length - 1; i >= 0; i -= 1) {
          if ("tr" == t[i].ty) {
            o = n[i].transform;
            var l = n[i].transform.mProps.v.props;

            if (o.matMdf = o.mProps.mdf, o.opMdf = o.op.mdf, (s = o.mat).cloneFromProps(l), e) {
              var c = e.mat.props;
              o.opacity = e.opacity, o.opacity *= n[i].transform.op.v, o.matMdf = !!e.matMdf || o.matMdf, o.opMdf = !!e.opMdf || o.opMdf, s.transform(c[0], c[1], c[2], c[3], c[4], c[5], c[6], c[7], c[8], c[9], c[10], c[11], c[12], c[13], c[14], c[15]);
            } else o.opacity = o.op.o;
          } else "sh" == t[i].ty || "el" == t[i].ty || "rc" == t[i].ty || "sr" == t[i].ty ? this.renderPath(t[i], n[i], o) : "fl" == t[i].ty ? this.renderFill(t[i], n[i], o) : "st" == t[i].ty ? this.renderStroke(t[i], n[i], o) : "gr" == t[i].ty ? this.renderShape(o, t[i].it, n[i].it) : t[i].ty;
        }

        if (r) {
          a = this.stylesList.length;
          var p,
              d,
              h,
              u,
              f,
              m,
              g,
              v = this.globalData.renderer,
              b = this.globalData.canvasContext;

          for (v.save(), v.ctxTransform(this.finalTransform.mat.props), i = 0; i < a; i += 1) {
            if (("st" !== (g = this.stylesList[i].type) || 0 !== this.stylesList[i].wi) && this.stylesList[i].data._render) {
              for (v.save(), f = this.stylesList[i].elements, "st" === g ? (b.strokeStyle = this.stylesList[i].co, b.lineWidth = this.stylesList[i].wi, b.lineCap = this.stylesList[i].lc, b.lineJoin = this.stylesList[i].lj, b.miterLimit = this.stylesList[i].ml || 0) : b.fillStyle = this.stylesList[i].co, v.ctxOpacity(this.stylesList[i].coOp), "st" !== g && b.beginPath(), d = f.length, p = 0; p < d; p += 1) {
                for ("st" === g && (b.beginPath(), this.stylesList[i].da ? (b.setLineDash(this.stylesList[i].da), b.lineDashOffset = this.stylesList[i].do, this.globalData.isDashed = !0) : this.globalData.isDashed && (b.setLineDash(this.dashResetter), this.globalData.isDashed = !1)), u = (m = f[p].trNodes).length, h = 0; h < u; h += 1) {
                  "m" == m[h].t ? b.moveTo(m[h].p[0], m[h].p[1]) : "c" == m[h].t ? b.bezierCurveTo(m[h].p1[0], m[h].p1[1], m[h].p2[0], m[h].p2[1], m[h].p3[0], m[h].p3[1]) : b.closePath();
                }

                "st" === g && b.stroke();
              }

              "st" !== g && b.fill(this.stylesList[i].r), v.restore();
            }
          }

          v.restore(), this.firstFrame && (this.firstFrame = !1);
        }
      }, CVShapeElement.prototype.renderPath = function (e, t, n) {
        var r, i, a, o;

        if (n.matMdf || t.sh.mdf || this.firstFrame) {
          var s = t.sh.paths,
              l = n.mat;
          o = s._length;
          var c = t.trNodes;

          for (c.length = 0, a = 0; a < o; a += 1) {
            var p = s.shapes[a];

            if (p && p.v) {
              for (r = p._length, i = 1; i < r; i += 1) {
                1 == i && c.push({
                  t: "m",
                  p: l.applyToPointArray(p.v[0][0], p.v[0][1], 0)
                }), c.push({
                  t: "c",
                  p1: l.applyToPointArray(p.o[i - 1][0], p.o[i - 1][1], 0),
                  p2: l.applyToPointArray(p.i[i][0], p.i[i][1], 0),
                  p3: l.applyToPointArray(p.v[i][0], p.v[i][1], 0)
                });
              }

              1 == r && c.push({
                t: "m",
                p: l.applyToPointArray(p.v[0][0], p.v[0][1], 0)
              }), p.c && r && (c.push({
                t: "c",
                p1: l.applyToPointArray(p.o[i - 1][0], p.o[i - 1][1], 0),
                p2: l.applyToPointArray(p.i[0][0], p.i[0][1], 0),
                p3: l.applyToPointArray(p.v[0][0], p.v[0][1], 0)
              }), c.push({
                t: "z"
              })), t.lStr = c;
            }
          }

          if (t.st) for (i = 0; i < 16; i += 1) {
            t.tr[i] = n.mat.props[i];
          }
          t.trNodes = c;
        }
      }, CVShapeElement.prototype.renderFill = function (e, t, n) {
        var r = t.style;
        (t.c.mdf || this.firstFrame) && (r.co = "rgb(" + bm_floor(t.c.v[0]) + "," + bm_floor(t.c.v[1]) + "," + bm_floor(t.c.v[2]) + ")"), (t.o.mdf || n.opMdf || this.firstFrame) && (r.coOp = t.o.v * n.opacity);
      }, CVShapeElement.prototype.renderStroke = function (e, t, n) {
        var r = t.style,
            i = t.d;
        i && (i.mdf || this.firstFrame) && (r.da = i.dasharray, r.do = i.dashoffset), (t.c.mdf || this.firstFrame) && (r.co = "rgb(" + bm_floor(t.c.v[0]) + "," + bm_floor(t.c.v[1]) + "," + bm_floor(t.c.v[2]) + ")"), (t.o.mdf || n.opMdf || this.firstFrame) && (r.coOp = t.o.v * n.opacity), (t.w.mdf || this.firstFrame) && (r.wi = t.w.v);
      }, CVShapeElement.prototype.destroy = function () {
        this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemData.length = 0, this._parent.destroy.call(this._parent);
      }, createElement(CVBaseElement, CVSolidElement), CVSolidElement.prototype.renderFrame = function (e) {
        if (!1 !== this._parent.renderFrame.call(this, e)) {
          var t = this.canvasContext;
          this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(this.finalTransform.mat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.opacity), t.fillStyle = this.data.sc, t.fillRect(0, 0, this.data.sw, this.data.sh), this.globalData.renderer.restore(this.data.hasMask), this.firstFrame && (this.firstFrame = !1);
        }
      }, createElement(CVBaseElement, CVTextElement), extendPrototype(ITextElement, CVTextElement), CVTextElement.prototype.tHelper = document.createElement("canvas").getContext("2d"), CVTextElement.prototype.createElements = function () {
        this._parent.createElements.call(this);
      }, CVTextElement.prototype.buildNewText = function () {
        var e = this.textProperty.currentData;
        this.renderedLetters = Array.apply(null, {
          length: e.l ? e.l.length : 0
        });
        var t = !1;
        e.fc ? (t = !0, this.values.fill = this.buildColor(e.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = t;
        var n = !1;
        e.sc && (n = !0, this.values.stroke = this.buildColor(e.sc), this.values.sWidth = e.sw);
        var r,
            i,
            a = this.globalData.fontManager.getFontByName(e.f),
            o = e.l,
            s = this.mHelper;
        this.stroke = n, this.values.fValue = e.s + "px " + this.globalData.fontManager.getFontByName(e.f).fFamily, i = e.t.length;
        var l,
            c,
            p,
            d,
            h,
            u,
            f,
            m,
            g,
            v,
            b = this.data.singleShape,
            y = e.tr / 1e3 * e.s,
            x = 0,
            w = 0,
            E = !0,
            C = 0;

        for (r = 0; r < i; r += 1) {
          for (c = (l = this.globalData.fontManager.getCharData(e.t.charAt(r), a.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily)) && l.data || {}, s.reset(), b && o[r].n && (x = -y, w += e.yOffset, w += E ? 1 : 0, E = !1), f = (h = c.shapes ? c.shapes[0].it : []).length, s.scale(e.s / 100, e.s / 100), b && this.applyTextPropertiesToMatrix(e, s, o[r].line, x, w), g = Array.apply(null, {
            length: f
          }), u = 0; u < f; u += 1) {
            for (d = h[u].ks.k.i.length, m = h[u].ks.k, v = [], p = 1; p < d; p += 1) {
              1 == p && v.push(s.applyToX(m.v[0][0], m.v[0][1], 0), s.applyToY(m.v[0][0], m.v[0][1], 0)), v.push(s.applyToX(m.o[p - 1][0], m.o[p - 1][1], 0), s.applyToY(m.o[p - 1][0], m.o[p - 1][1], 0), s.applyToX(m.i[p][0], m.i[p][1], 0), s.applyToY(m.i[p][0], m.i[p][1], 0), s.applyToX(m.v[p][0], m.v[p][1], 0), s.applyToY(m.v[p][0], m.v[p][1], 0));
            }

            v.push(s.applyToX(m.o[p - 1][0], m.o[p - 1][1], 0), s.applyToY(m.o[p - 1][0], m.o[p - 1][1], 0), s.applyToX(m.i[0][0], m.i[0][1], 0), s.applyToY(m.i[0][0], m.i[0][1], 0), s.applyToX(m.v[0][0], m.v[0][1], 0), s.applyToY(m.v[0][0], m.v[0][1], 0)), g[u] = v;
          }

          b && (x += o[r].l, x += y), this.textSpans[C] ? this.textSpans[C].elem = g : this.textSpans[C] = {
            elem: g
          }, C += 1;
        }
      }, CVTextElement.prototype.renderFrame = function (e) {
        if (!1 !== this._parent.renderFrame.call(this, e)) {
          var t,
              n,
              r,
              i,
              a,
              o,
              s = this.canvasContext,
              l = this.finalTransform.mat.props;
          this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(l), this.globalData.renderer.ctxOpacity(this.finalTransform.opacity), s.font = this.values.fValue, s.lineCap = "butt", s.lineJoin = "miter", s.miterLimit = 4, this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
          var c,
              p = this.textAnimator.renderedLetters,
              d = this.textProperty.currentData.l;
          n = d.length;
          var h,
              u,
              f = null,
              m = null,
              g = null;

          for (t = 0; t < n; t += 1) {
            if (!d[t].n) {
              if ((c = p[t]) && (this.globalData.renderer.save(), this.globalData.renderer.ctxTransform(c.p), this.globalData.renderer.ctxOpacity(c.o)), this.fill) {
                for (c && c.fc ? f !== c.fc && (f = c.fc, s.fillStyle = c.fc) : f !== this.values.fill && (f = this.values.fill, s.fillStyle = this.values.fill), i = (h = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1) {
                  for (o = (u = h[r]).length, this.globalData.canvasContext.moveTo(u[0], u[1]), a = 2; a < o; a += 6) {
                    this.globalData.canvasContext.bezierCurveTo(u[a], u[a + 1], u[a + 2], u[a + 3], u[a + 4], u[a + 5]);
                  }
                }

                this.globalData.canvasContext.closePath(), this.globalData.canvasContext.fill();
              }

              if (this.stroke) {
                for (c && c.sw ? g !== c.sw && (g = c.sw, s.lineWidth = c.sw) : g !== this.values.sWidth && (g = this.values.sWidth, s.lineWidth = this.values.sWidth), c && c.sc ? m !== c.sc && (m = c.sc, s.strokeStyle = c.sc) : m !== this.values.stroke && (m = this.values.stroke, s.strokeStyle = this.values.stroke), i = (h = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r = 0; r < i; r += 1) {
                  for (o = (u = h[r]).length, this.globalData.canvasContext.moveTo(u[0], u[1]), a = 2; a < o; a += 6) {
                    this.globalData.canvasContext.bezierCurveTo(u[a], u[a + 1], u[a + 2], u[a + 3], u[a + 4], u[a + 5]);
                  }
                }

                this.globalData.canvasContext.closePath(), this.globalData.canvasContext.stroke();
              }

              c && this.globalData.renderer.restore();
            }
          }

          this.globalData.renderer.restore(this.data.hasMask), this.firstFrame && (this.firstFrame = !1);
        }
      }, createElement(BaseElement, HBaseElement), HBaseElement.prototype.checkBlendMode = function () {}, HBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode, HBaseElement.prototype.getBaseElement = function () {
        return this.baseElement;
      }, HBaseElement.prototype.createElements = function () {
        this.data.hasMask ? (this.layerElement = document.createElementNS(svgNS, "svg"), styleDiv(this.layerElement), this.baseElement = this.layerElement, this.maskedElement = this.layerElement) : this.layerElement = this.parentContainer, this.transformedElement = this.layerElement, !this.data.ln || 4 !== this.data.ty && 0 !== this.data.ty || (this.layerElement === this.parentContainer && (this.layerElement = document.createElementNS(svgNS, "g"), this.baseElement = this.layerElement), this.layerElement.setAttribute("id", this.data.ln)), this.setBlendMode(), this.layerElement !== this.parentContainer && (this.placeholder = null), this.checkParenting();
      }, HBaseElement.prototype.renderFrame = function (e) {
        if (3 === this.data.ty) return !1;
        if (this.currentFrameNum === this.lastNum || !this.isVisible) return this.isVisible;
        var t;
        this.lastNum = this.currentFrameNum, this.finalTransform.opMdf = this.finalTransform.op.mdf, this.finalTransform.matMdf = this.finalTransform.mProp.mdf, this.finalTransform.opacity = this.finalTransform.op.v, this.firstFrame && (this.finalTransform.opMdf = !0, this.finalTransform.matMdf = !0);
        var n = this.finalTransform.mat;

        if (this.hierarchy) {
          var r,
              i = this.hierarchy.length;

          for (t = this.finalTransform.mProp.v.props, n.cloneFromProps(t), r = 0; r < i; r += 1) {
            this.finalTransform.matMdf = !!this.hierarchy[r].finalTransform.mProp.mdf || this.finalTransform.matMdf, t = this.hierarchy[r].finalTransform.mProp.v.props, n.transform(t[0], t[1], t[2], t[3], t[4], t[5], t[6], t[7], t[8], t[9], t[10], t[11], t[12], t[13], t[14], t[15]);
          }
        } else this.isVisible && this.finalTransform.matMdf && (e ? (t = this.finalTransform.mProp.v.props, n.cloneFromProps(t)) : n.cloneFromProps(this.finalTransform.mProp.v.props));

        return this.data.hasMask && this.maskManager.renderFrame(n), e && (t = e.mat.props, n.cloneFromProps(t), this.finalTransform.opacity *= e.opacity, this.finalTransform.opMdf = !!e.opMdf || this.finalTransform.opMdf, this.finalTransform.matMdf = !!e.matMdf || this.finalTransform.matMdf), this.finalTransform.matMdf && (this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = n.toCSS(), this.finalMat = n), this.finalTransform.opMdf && (this.transformedElement.style.opacity = this.finalTransform.opacity), this.isVisible;
      }, HBaseElement.prototype.destroy = function () {
        this.layerElement = null, this.transformedElement = null, this.parentContainer = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
      }, HBaseElement.prototype.getDomElement = function () {
        return this.layerElement;
      }, HBaseElement.prototype.addMasks = function (e) {
        this.maskManager = new MaskElement(e, this, this.globalData);
      }, HBaseElement.prototype.hide = function () {}, HBaseElement.prototype.setMatte = function () {}, HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting, createElement(HBaseElement, HSolidElement), HSolidElement.prototype.createElements = function () {
        var e = document.createElement("div");
        styleDiv(e);
        var t = document.createElementNS(svgNS, "svg");
        styleDiv(t), t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), e.appendChild(t), this.layerElement = e, this.transformedElement = e, this.baseElement = e, this.innerElem = e, this.data.ln && this.innerElem.setAttribute("id", this.data.ln), 0 !== this.data.bm && this.setBlendMode();
        var n = document.createElementNS(svgNS, "rect");
        n.setAttribute("width", this.data.sw), n.setAttribute("height", this.data.sh), n.setAttribute("fill", this.data.sc), t.appendChild(n), this.data.hasMask && (this.maskedElement = n), this.checkParenting();
      }, HSolidElement.prototype.hide = SVGBaseElement.prototype.hide, HSolidElement.prototype.show = SVGBaseElement.prototype.show, HSolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame, HSolidElement.prototype.destroy = IImageElement.prototype.destroy, createElement(HBaseElement, HCompElement), HCompElement.prototype.createElements = function () {
        var e = document.createElement("div");

        if (styleDiv(e), this.data.ln && e.setAttribute("id", this.data.ln), e.style.clip = "rect(0px, " + this.data.w + "px, " + this.data.h + "px, 0px)", this.data.hasMask) {
          var t = document.createElementNS(svgNS, "svg");
          styleDiv(t), t.setAttribute("width", this.data.w), t.setAttribute("height", this.data.h);
          var n = document.createElementNS(svgNS, "g");
          t.appendChild(n), e.appendChild(t), this.maskedElement = n, this.baseElement = e, this.layerElement = n, this.transformedElement = e;
        } else this.layerElement = e, this.baseElement = this.layerElement, this.transformedElement = e;

        this.checkParenting();
      }, HCompElement.prototype.hide = ICompElement.prototype.hide, HCompElement.prototype.prepareFrame = ICompElement.prototype.prepareFrame, HCompElement.prototype.setElements = ICompElement.prototype.setElements, HCompElement.prototype.getElements = ICompElement.prototype.getElements, HCompElement.prototype.destroy = ICompElement.prototype.destroy, HCompElement.prototype.renderFrame = function (e) {
        var t,
            n = this._parent.renderFrame.call(this, e),
            r = this.layers.length;

        if (!1 !== n) {
          for (this.hidden = !1, t = 0; t < r; t += 1) {
            (this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
          }

          this.firstFrame && (this.firstFrame = !1);
        } else this.hide();
      }, HCompElement.prototype.checkLayers = BaseRenderer.prototype.checkLayers, HCompElement.prototype.buildItem = HybridRenderer.prototype.buildItem, HCompElement.prototype.checkPendingElements = HybridRenderer.prototype.checkPendingElements, HCompElement.prototype.addPendingElement = HybridRenderer.prototype.addPendingElement, HCompElement.prototype.buildAllItems = BaseRenderer.prototype.buildAllItems, HCompElement.prototype.createItem = HybridRenderer.prototype.createItem, HCompElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting, HCompElement.prototype.createImage = HybridRenderer.prototype.createImage, HCompElement.prototype.createComp = HybridRenderer.prototype.createComp, HCompElement.prototype.createSolid = HybridRenderer.prototype.createSolid, HCompElement.prototype.createShape = HybridRenderer.prototype.createShape, HCompElement.prototype.createText = HybridRenderer.prototype.createText, HCompElement.prototype.createBase = HybridRenderer.prototype.createBase, HCompElement.prototype.appendElementInPos = HybridRenderer.prototype.appendElementInPos, createElement(HBaseElement, HShapeElement);
      var parent = HShapeElement.prototype._parent;

      function HTextElement(e, t, n, r, i) {
        this.textSpans = [], this.textPaths = [], this.currentBBox = {
          x: 999999,
          y: -999999,
          h: 0,
          w: 0
        }, this.renderType = "svg", this.isMasked = !1, this._parent.constructor.call(this, e, t, n, r, i);
      }

      function HImageElement(e, t, n, r, i) {
        this.assetData = n.getAssetData(e.refId), this._parent.constructor.call(this, e, t, n, r, i);
      }

      function HCameraElement(e, t, n, r, i) {
        this._parent.constructor.call(this, e, t, n, r, i);

        var a = PropertyFactory.getProp;

        if (this.pe = a(this, e.pe, 0, 0, this.dynamicProperties), e.ks.p.s ? (this.px = a(this, e.ks.p.x, 1, 0, this.dynamicProperties), this.py = a(this, e.ks.p.y, 1, 0, this.dynamicProperties), this.pz = a(this, e.ks.p.z, 1, 0, this.dynamicProperties)) : this.p = a(this, e.ks.p, 1, 0, this.dynamicProperties), e.ks.a && (this.a = a(this, e.ks.a, 1, 0, this.dynamicProperties)), e.ks.or.k.length && e.ks.or.k[0].to) {
          var o,
              s = e.ks.or.k.length;

          for (o = 0; o < s; o += 1) {
            e.ks.or.k[o].to = null, e.ks.or.k[o].ti = null;
          }
        }

        this.or = a(this, e.ks.or, 1, degToRads, this.dynamicProperties), this.or.sh = !0, this.rx = a(this, e.ks.rx, 0, degToRads, this.dynamicProperties), this.ry = a(this, e.ks.ry, 0, degToRads, this.dynamicProperties), this.rz = a(this, e.ks.rz, 0, degToRads, this.dynamicProperties), this.mat = new Matrix();
      }

      extendPrototype(IShapeElement, HShapeElement), HShapeElement.prototype._parent = parent, HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderFrame, HShapeElement.prototype.createElements = function () {
        var e = document.createElement("div");
        styleDiv(e);
        var t = document.createElementNS(svgNS, "svg");
        styleDiv(t);
        var n = this.comp.data ? this.comp.data : this.globalData.compSize;

        if (t.setAttribute("width", n.w), t.setAttribute("height", n.h), this.data.hasMask) {
          var r = document.createElementNS(svgNS, "g");
          e.appendChild(t), t.appendChild(r), this.maskedElement = r, this.layerElement = r, this.shapesContainer = r;
        } else e.appendChild(t), this.layerElement = t, this.shapesContainer = document.createElementNS(svgNS, "g"), this.layerElement.appendChild(this.shapesContainer);

        this.data.hd || (this.baseElement = e), this.innerElem = e, this.data.ln && this.innerElem.setAttribute("id", this.data.ln), this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, this.dynamicProperties, 0, [], !0), this.buildExpressionInterface(), this.layerElement = e, this.transformedElement = e, this.shapeCont = t, 0 !== this.data.bm && this.setBlendMode(), this.checkParenting();
      }, HShapeElement.prototype.renderFrame = function (e) {
        var t = this.firstFrame;

        if (this._renderShapeFrame(), this.isVisible && (this.elemMdf || t)) {
          var n = this.shapeCont.getBBox(),
              r = !1;
          this.currentBBox.w !== n.width && (this.currentBBox.w = n.width, this.shapeCont.setAttribute("width", n.width), r = !0), this.currentBBox.h !== n.height && (this.currentBBox.h = n.height, this.shapeCont.setAttribute("height", n.height), r = !0), (r || this.currentBBox.x !== n.x || this.currentBBox.y !== n.y) && (this.currentBBox.w = n.width, this.currentBBox.h = n.height, this.currentBBox.x = n.x, this.currentBBox.y = n.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)");
        }
      }, createElement(HBaseElement, HTextElement), extendPrototype(ITextElement, HTextElement), HTextElement.prototype.createElements = function () {
        this.isMasked = this.checkMasks();
        var e = document.createElement("div");

        if (styleDiv(e), this.layerElement = e, this.transformedElement = e, this.isMasked) {
          this.renderType = "svg";
          var t = document.createElementNS(svgNS, "svg");
          styleDiv(t), this.cont = t, this.compW = this.comp.data.w, this.compH = this.comp.data.h, t.setAttribute("width", this.compW), t.setAttribute("height", this.compH);
          var n = document.createElementNS(svgNS, "g");
          t.appendChild(n), e.appendChild(t), this.maskedElement = n, this.innerElem = n;
        } else this.renderType = "html", this.innerElem = e;

        this.baseElement = e, this.checkParenting();
      }, HTextElement.prototype.buildNewText = function () {
        var e = this.textProperty.currentData;
        this.renderedLetters = Array.apply(null, {
          length: this.textProperty.currentData.l ? this.textProperty.currentData.l.length : 0
        });
        var t = this.innerElem.style;
        t.color = t.fill = e.fc ? this.buildColor(e.fc) : "rgba(0,0,0,0)", e.sc && (t.stroke = this.buildColor(e.sc), t.strokeWidth = e.sw + "px");
        var n,
            r,
            i = this.globalData.fontManager.getFontByName(e.f);
        if (!this.globalData.fontManager.chars) if (t.fontSize = e.s + "px", t.lineHeight = e.s + "px", i.fClass) this.innerElem.className = i.fClass;else {
          t.fontFamily = i.fFamily;
          var a = e.fWeight,
              o = e.fStyle;
          t.fontStyle = o, t.fontWeight = a;
        }
        var s,
            l,
            c,
            p = e.l;
        r = p.length;
        var d,
            h = this.mHelper,
            u = "",
            f = 0;

        for (n = 0; n < r; n += 1) {
          if (this.globalData.fontManager.chars ? (this.textPaths[f] ? s = this.textPaths[f] : ((s = document.createElementNS(svgNS, "path")).setAttribute("stroke-linecap", "butt"), s.setAttribute("stroke-linejoin", "round"), s.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[f] ? c = (l = this.textSpans[f]).children[0] : (l = document.createElement("div"), (c = document.createElementNS(svgNS, "svg")).appendChild(s), styleDiv(l)))) : this.isMasked ? s = this.textPaths[f] ? this.textPaths[f] : document.createElementNS(svgNS, "text") : this.textSpans[f] ? (l = this.textSpans[f], s = this.textPaths[f]) : (styleDiv(l = document.createElement("span")), styleDiv(s = document.createElement("span")), l.appendChild(s)), this.globalData.fontManager.chars) {
            var m,
                g = this.globalData.fontManager.getCharData(e.t.charAt(n), i.fStyle, this.globalData.fontManager.getFontByName(e.f).fFamily);
            if (m = g ? g.data : null, h.reset(), m && m.shapes && (d = m.shapes[0].it, h.scale(e.s / 100, e.s / 100), u = this.createPathShape(h, d), s.setAttribute("d", u)), this.isMasked) this.innerElem.appendChild(s);else if (this.innerElem.appendChild(l), m && m.shapes) {
              document.body.appendChild(c);
              var v = c.getBBox();
              c.setAttribute("width", v.width + 2), c.setAttribute("height", v.height + 2), c.setAttribute("viewBox", v.x - 1 + " " + (v.y - 1) + " " + (v.width + 2) + " " + (v.height + 2)), c.style.transform = c.style.webkitTransform = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)", p[n].yOffset = v.y - 1, l.appendChild(c);
            } else c.setAttribute("width", 1), c.setAttribute("height", 1);
          } else s.textContent = p[n].val, s.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked ? this.innerElem.appendChild(s) : (this.innerElem.appendChild(l), s.style.transform = s.style.webkitTransform = "translate3d(0," + -e.s / 1.2 + "px,0)");

          this.isMasked ? this.textSpans[f] = s : this.textSpans[f] = l, this.textSpans[f].style.display = "block", this.textPaths[f] = s, f += 1;
        }

        for (; f < this.textSpans.length;) {
          this.textSpans[f].style.display = "none", f += 1;
        }
      }, HTextElement.prototype.hide = SVGTextElement.prototype.hide, HTextElement.prototype.renderFrame = function (e) {
        if (!1 !== this._parent.renderFrame.call(this, e)) {
          if (this.hidden && (this.hidden = !1, this.innerElem.style.display = "block", this.layerElement.style.display = "block"), this.data.singleShape) {
            if (!this.firstFrame && !this.lettersChangedFlag) return;
            this.isMasked && this.finalTransform.matMdf && (this.cont.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), this.cont.style.transform = this.cont.style.webkitTransform = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)");
          }

          if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
            var t,
                n,
                r,
                i,
                a,
                o = 0,
                s = this.textAnimator.renderedLetters,
                l = this.textProperty.currentData.l;

            for (n = l.length, t = 0; t < n; t += 1) {
              l[t].n ? o += 1 : (i = this.textSpans[t], a = this.textPaths[t], r = s[o], o += 1, this.isMasked ? i.setAttribute("transform", r.m) : i.style.transform = i.style.webkitTransform = r.m, i.style.opacity = r.o, r.sw && a.setAttribute("stroke-width", r.sw), r.sc && a.setAttribute("stroke", r.sc), r.fc && (a.setAttribute("fill", r.fc), a.style.color = r.fc));
            }

            if (this.isVisible && (this.elemMdf || this.firstFrame) && this.innerElem.getBBox) {
              var c = this.innerElem.getBBox();
              this.currentBBox.w !== c.width && (this.currentBBox.w = c.width, this.cont.setAttribute("width", c.width)), this.currentBBox.h !== c.height && (this.currentBBox.h = c.height, this.cont.setAttribute("height", c.height));
              this.currentBBox.w === c.width + 2 && this.currentBBox.h === c.height + 2 && this.currentBBox.x === c.x - 1 && this.currentBBox.y === c.y - 1 || (this.currentBBox.w = c.width + 2, this.currentBBox.h = c.height + 2, this.currentBBox.x = c.x - 1, this.currentBBox.y = c.y - 1, this.cont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), this.cont.style.transform = this.cont.style.webkitTransform = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)");
            }

            this.firstFrame && (this.firstFrame = !1);
          }
        } else this.hide();
      }, createElement(HBaseElement, HImageElement), HImageElement.prototype.createElements = function () {
        var e = this.globalData.getAssetsPath(this.assetData),
            t = new Image();

        if (this.data.hasMask) {
          var n = document.createElement("div");
          styleDiv(n);
          var r = document.createElementNS(svgNS, "svg");
          styleDiv(r), r.setAttribute("width", this.assetData.w), r.setAttribute("height", this.assetData.h), n.appendChild(r), this.imageElem = document.createElementNS(svgNS, "image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", e), r.appendChild(this.imageElem), this.layerElement = n, this.transformedElement = n, this.baseElement = n, this.innerElem = n, this.maskedElement = this.imageElem;
        } else styleDiv(t), this.layerElement = t, this.baseElement = t, this.innerElem = t, this.transformedElement = t;

        t.src = e, this.data.ln && this.innerElem.setAttribute("id", this.data.ln), this.checkParenting();
      }, HImageElement.prototype.show = HSolidElement.prototype.show, HImageElement.prototype.hide = HSolidElement.prototype.hide, HImageElement.prototype.renderFrame = HSolidElement.prototype.renderFrame, HImageElement.prototype.destroy = HSolidElement.prototype.destroy, createElement(HBaseElement, HCameraElement), HCameraElement.prototype.setup = function () {
        var e,
            t,
            n = this.comp.threeDElements.length;

        for (e = 0; e < n; e += 1) {
          (t = this.comp.threeDElements[e]).perspectiveElem.style.perspective = t.perspectiveElem.style.webkitPerspective = this.pe.v + "px", t.container.style.transformOrigin = t.container.style.mozTransformOrigin = t.container.style.webkitTransformOrigin = "0px 0px 0px", t.perspectiveElem.style.transform = t.perspectiveElem.style.webkitTransform = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        }
      }, HCameraElement.prototype.createElements = function () {}, HCameraElement.prototype.hide = function () {}, HCameraElement.prototype.renderFrame = function () {
        var e,
            t,
            n = this.firstFrame;
        if (this.hierarchy) for (t = this.hierarchy.length, e = 0; e < t; e += 1) {
          n = !!this.hierarchy[e].finalTransform.mProp.mdf || n;
        }

        if (n || this.p && this.p.mdf || this.px && (this.px.mdf || this.py.mdf || this.pz.mdf) || this.rx.mdf || this.ry.mdf || this.rz.mdf || this.or.mdf || this.a && this.a.mdf) {
          if (this.mat.reset(), this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
            var r = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]],
                i = Math.sqrt(Math.pow(r[0], 2) + Math.pow(r[1], 2) + Math.pow(r[2], 2)),
                a = [r[0] / i, r[1] / i, r[2] / i],
                o = Math.sqrt(a[2] * a[2] + a[0] * a[0]),
                s = Math.atan2(a[1], o),
                l = Math.atan2(a[0], -a[2]);
            this.mat.rotateY(l).rotateX(-s);
          }

          var c, p;
          if (this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v), this.hierarchy) for (t = this.hierarchy.length, e = 0; e < t; e += 1) {
            c = this.hierarchy[e].finalTransform.mProp.iv.props, this.mat.transform(c[0], c[1], c[2], c[3], c[4], c[5], c[6], c[7], c[8], c[9], c[10], c[11], -c[12], -c[13], c[14], c[15]);
          }

          for (t = this.comp.threeDElements.length, e = 0; e < t; e += 1) {
            (p = this.comp.threeDElements[e]).container.style.transform = p.container.style.webkitTransform = this.mat.toCSS();
          }
        }

        this.firstFrame = !1;
      }, HCameraElement.prototype.destroy = function () {};

      var Expressions = function () {
        var e = {};
        return e.initExpressions = function initExpressions(e) {
          e.renderer.compInterface = CompExpressionInterface(e.renderer), e.renderer.globalData.projectInterface.registerComposition(e.renderer);
        }, e;
      }();

      expressionsPlugin = Expressions, function addPropertyDecorator() {
        function getStaticValueAtTime() {
          return this.pv;
        }

        function loopOut(e, t, n) {
          if (!this.k || !this.keyframes) return this.pv;
          var r,
              i,
              a = this.comp.renderedFrame,
              o = this.keyframes,
              s = o[o.length - 1].t;
          if (a <= s) return this.pv;
          n ? i = s - (r = t ? Math.abs(s - elem.comp.globalData.frameRate * t) : Math.max(0, s - this.elem.data.ip)) : ((!t || t > o.length - 1) && (t = o.length - 1), r = s - (i = o[o.length - 1 - t].t));
          var l,
              c,
              p,
              d = this.offsetTime || 0;

          if ("pingpong" === e.toLowerCase()) {
            if (Math.floor((a - i) / r) % 2 !== 0) return this.getValueAtTime((r - (a - i) % r + i - d) / this.comp.globalData.frameRate, 0);
          } else {
            if ("offset" === e) {
              var h = this.getValueAtTime(i / this.comp.globalData.frameRate, 0),
                  u = this.getValueAtTime(s / this.comp.globalData.frameRate, 0),
                  f = this.getValueAtTime(((a - i) % r + i) / this.comp.globalData.frameRate, 0),
                  m = Math.floor((a - i) / r);

              if (this.pv.length) {
                for (c = (p = new Array(h.length)).length, l = 0; l < c; l += 1) {
                  p[l] = (u[l] - h[l]) * m + f[l];
                }

                return p;
              }

              return (u - h) * m + f;
            }

            if ("continue" === e) {
              var g = this.getValueAtTime(s / this.comp.globalData.frameRate, 0),
                  v = this.getValueAtTime((s - .001) / this.comp.globalData.frameRate, 0);

              if (this.pv.length) {
                for (c = (p = new Array(g.length)).length, l = 0; l < c; l += 1) {
                  p[l] = g[l] + (g[l] - v[l]) * ((a - s) / this.comp.globalData.frameRate) / 5e-4;
                }

                return p;
              }

              return g + (a - s) / .001 * (g - v);
            }
          }

          return this.getValueAtTime(((a - i) % r + i - d) / this.comp.globalData.frameRate, 0);
        }

        function loopIn(e, t, n) {
          if (!this.k) return this.pv;
          var r,
              i,
              a,
              o,
              s,
              l = time * elem.comp.globalData.frameRate,
              c = this.keyframes,
              p = c[0].t,
              d = this.offsetTime || 0;
          if (l >= p) return this.pv;

          if (n ? i = p + (r = t ? Math.abs(elem.comp.globalData.frameRate * t) : Math.max(0, this.elem.data.op - p)) : ((!t || t > c.length - 1) && (t = c.length - 1), r = (i = c[t].t) - p), "pingpong" === e) {
            if (Math.floor((p - l) / r) % 2 === 0) return this.getValueAtTime(((p - l) % r + p - d) / this.comp.globalData.frameRate, 0);
          } else {
            if ("offset" === e) {
              var h = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
                  u = this.getValueAtTime(i / this.comp.globalData.frameRate, 0),
                  f = this.getValueAtTime((r - (p - l) % r + p) / this.comp.globalData.frameRate, 0),
                  m = Math.floor((p - l) / r) + 1;

              if (this.pv.length) {
                for (o = (s = new Array(h.length)).length, a = 0; a < o; a += 1) {
                  s[a] = f[a] - (u[a] - h[a]) * m;
                }

                return s;
              }

              return f - (u - h) * m;
            }

            if ("continue" === e) {
              var g = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
                  v = this.getValueAtTime((p + .001) / this.comp.globalData.frameRate, 0);

              if (this.pv.length) {
                for (o = (s = new Array(g.length)).length, a = 0; a < o; a += 1) {
                  s[a] = g[a] + (g[a] - v[a]) * (p - l) / .001;
                }

                return s;
              }

              return g + (g - v) * (p - l) / .001;
            }
          }

          return this.getValueAtTime((r - (p - l) % r + p - d) / this.comp.globalData.frameRate, 0);
        }

        function getValueAtTime(e) {
          if (this._cachingAtTime || (this._cachingAtTime = {
            lastValue: -99999,
            lastIndex: 0
          }), e !== this._cachingAtTime.lastFrame) {
            e *= this.elem.globalData.frameRate, e -= this.offsetTime;
            var t = this._caching.lastFrame < e ? this._caching.lastIndex : 0,
                n = this.interpolateValue(e, t, this.pv, this._cachingAtTime);
            this._cachingAtTime.lastIndex = n.iterationIndex, this._cachingAtTime.value = n.value, this._cachingAtTime.lastFrame = e;
          }

          return this._cachingAtTime.value;
        }

        function getVelocityAtTime(e) {
          if (void 0 !== this.vel) return this.vel;
          var t,
              n,
              r = this.getValueAtTime(e),
              i = this.getValueAtTime(e + -.01);
          if (r.length) for (t = Array.apply(null, {
            length: r.length
          }), n = 0; n < r.length; n += 1) {
            t[n] = (i[n] - r[n]) / -.01;
          } else t = (i - r) / -.01;
          return t;
        }

        function setGroupProperty(e) {
          this.propertyGroup = e;
        }

        function searchExpressions(e, t, n) {
          t.x && (n.k = !0, n.x = !0, n.getValue && (n.getPreValue = n.getValue), n.getValue = ExpressionManager.initiateExpression.bind(n)(e, t, n));
        }

        var e = function () {
          function getValueProxy(e, t) {
            return this.textIndex = e + 1, this.textTotal = t, this.getValue(), this.v;
          }

          return function TextExpressionSelectorProp(e, t) {
            this.pv = 1, this.comp = e.comp, this.elem = e, this.mult = .01, this.type = "textSelector", this.textTotal = t.totalChars, this.selectorValue = 100, this.lastValue = [1, 1, 1], searchExpressions.bind(this)(e, t, this), this.getMult = getValueProxy, this.getVelocityAtTime = getVelocityAtTime, this.kf ? this.getValueAtTime = getValueAtTime.bind(this) : this.getValueAtTime = getStaticValueAtTime.bind(this), this.setGroupProperty = setGroupProperty;
          };
        }(),
            t = PropertyFactory.getProp;

        PropertyFactory.getProp = function (e, n, r, i, a) {
          var o = t(e, n, r, i, a);
          2 === r ? o.dynamicProperties.length ? o.getValueAtTime = function getTransformValueAtTime(e) {
            console.log("time:", e);
          }.bind(o) : o.getValueAtTime = function getTransformStaticValueAtTime(e) {}.bind(o) : o.kf ? o.getValueAtTime = getValueAtTime.bind(o) : o.getValueAtTime = getStaticValueAtTime.bind(o), o.setGroupProperty = setGroupProperty, o.loopOut = loopOut, o.loopIn = loopIn, o.getVelocityAtTime = getVelocityAtTime, o.numKeys = 1 === n.a ? n.k.length : 0;
          var s = o.k;
          return void 0 !== n.ix && Object.defineProperty(o, "propertyIndex", {
            get: function get() {
              return n.ix;
            }
          }), searchExpressions(e, n, o), !s && o.x && a.push(o), o;
        };

        var n = ShapePropertyFactory.getConstructorFunction(),
            r = ShapePropertyFactory.getKeyframedConstructorFunction();
        n.prototype.vertices = function (e, t) {
          var n = this.v;
          void 0 !== t && (n = this.getValueAtTime(t, 0));
          var r,
              i = n._length,
              a = n[e],
              o = n.v,
              s = Array.apply(null, {
            length: i
          });

          for (r = 0; r < i; r += 1) {
            s[r] = "i" === e || "o" === e ? [a[r][0] - o[r][0], a[r][1] - o[r][1]] : [a[r][0], a[r][1]];
          }

          return s;
        }, n.prototype.points = function (e) {
          return this.vertices("v", e);
        }, n.prototype.inTangents = function (e) {
          return this.vertices("i", e);
        }, n.prototype.outTangents = function (e) {
          return this.vertices("o", e);
        }, n.prototype.isClosed = function () {
          return this.v.c;
        }, n.prototype.pointOnPath = function (e, t) {
          var n = this.v;
          void 0 !== t && (n = this.getValueAtTime(t, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(n));

          for (var r = this._segmentsLength, i = r.lengths, a = r.totalLength * e, o = 0, s = i.length, l = 0; o < s;) {
            if (l + i[o].addedLength > a) {
              i[o].segments;
              var c = o,
                  p = n.c && o === s - 1 ? 0 : o + 1,
                  d = (a - l) / i[o].addedLength,
                  h = bez.getPointInSegment(n.v[c], n.v[p], n.o[c], n.i[p], d, i[o]);
              break;
            }

            l += i[o].addedLength, o += 1;
          }

          return h || (h = n.c ? [n.v[0][0], n.v[0][1]] : [n.v[n._length - 1][0], n.v[n._length - 1][1]]), h;
        }, n.prototype.vectorOnPath = function (e, t, n) {
          e = 1 == e ? this.v.c ? 0 : .999 : e;
          var r = this.pointOnPath(e, t),
              i = this.pointOnPath(e + .001, t),
              a = i[0] - r[0],
              o = i[1] - r[1],
              s = Math.sqrt(Math.pow(a, 2) + Math.pow(o, 2));
          return "tangent" === n ? [a / s, o / s] : [-o / s, a / s];
        }, n.prototype.tangentOnPath = function (e, t) {
          return this.vectorOnPath(e, t, "tangent");
        }, n.prototype.normalOnPath = function (e, t) {
          return this.vectorOnPath(e, t, "normal");
        }, n.prototype.setGroupProperty = setGroupProperty, n.prototype.getValueAtTime = getStaticValueAtTime, r.prototype.vertices = n.prototype.vertices, r.prototype.points = n.prototype.points, r.prototype.inTangents = n.prototype.inTangents, r.prototype.outTangents = n.prototype.outTangents, r.prototype.isClosed = n.prototype.isClosed, r.prototype.pointOnPath = n.prototype.pointOnPath, r.prototype.vectorOnPath = n.prototype.vectorOnPath, r.prototype.tangentOnPath = n.prototype.tangentOnPath, r.prototype.normalOnPath = n.prototype.normalOnPath, r.prototype.setGroupProperty = n.prototype.setGroupProperty, r.prototype.getValueAtTime = function getShapeValueAtTime(e) {
          if (this._shapeValueAtTime || (this._lastIndexAtTime = 0, this._lastTimeAtTime = -999999, this._shapeValueAtTime = shape_pool.clone(this.pv)), e !== this._lastTimeAtTime) {
            this._lastTimeAtTime = e, e *= this.elem.globalData.frameRate;
            var t = this.interpolateShape(e, this._lastIndexAtTime, this._shapeValueAtTime, !1);
            this._lastIndexAtTime = t.iterationIndex;
          }

          return this._shapeValueAtTime;
        };
        var i = ShapePropertyFactory.getShapeProp;

        ShapePropertyFactory.getShapeProp = function (e, t, n, r, a) {
          var o = i(e, t, n, r, a),
              s = o.k;
          return void 0 !== t.ix && Object.defineProperty(o, "propertyIndex", {
            get: function get() {
              return t.ix;
            }
          }), 3 === n ? searchExpressions(e, t.pt, o) : 4 === n && searchExpressions(e, t.ks, o), !s && o.x && r.push(o), o;
        };

        var a = PropertyFactory.getTextSelectorProp;

        PropertyFactory.getTextSelectorProp = function (t, n, r) {
          return 1 === n.t ? new e(t, n, r) : a(t, n, r);
        };
      }(), function addTextPropertyDecorator() {
        TextProperty.prototype.searchProperty = function () {
          return this.kf = this.searchExpressions() || this.data.d.k.length > 1, this.kf;
        }, TextProperty.prototype.getExpressionValue = function (e) {
          this.calculateExpression(), this.mdf && (this.currentData.t = this.v.toString(), this.completeTextData(this.currentData));
        }, TextProperty.prototype.searchExpressions = function searchExpressions() {
          return !!this.data.d.x && (this.comp = this.elem.comp, this.getValue && (this.getPreValue = this.getValue), this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.getValue = this.getExpressionValue, !0);
        };
      }();

      var ExpressionManager = function () {
        var ob = {},
            Math = BMMath,
            window = null,
            document = null;

        function duplicatePropertyValue(e, t) {
          if (t = t || 1, "number" === typeof e || e instanceof Number) return e * t;
          if (e.i) return JSON.parse(JSON.stringify(e));
          var n,
              r = Array.apply(null, {
            length: e.length
          }),
              i = e.length;

          for (n = 0; n < i; n += 1) {
            r[n] = e[n] * t;
          }

          return r;
        }

        function shapesEqual(e, t) {
          if (e._length !== t._length || e.c !== t.c) return !1;
          var n,
              r = e._length;

          for (n = 0; n < r; n += 1) {
            if (e.v[n][0] !== t.v[n][0] || e.v[n][1] !== t.v[n][1] || e.o[n][0] !== t.o[n][0] || e.o[n][1] !== t.o[n][1] || e.i[n][0] !== t.i[n][0] || e.i[n][1] !== t.i[n][1]) return !1;
          }

          return !0;
        }

        function $bm_neg(e) {
          var t = typeof e;
          if ("number" === t || "boolean" === t || e instanceof Number) return -e;

          if (e.constructor === Array) {
            var n,
                r = e.length,
                i = [];

            for (n = 0; n < r; n += 1) {
              i[n] = -e[n];
            }

            return i;
          }
        }

        function sum(e, t) {
          var n = typeof e,
              r = typeof t;
          if ("string" === n || "string" === r) return e + t;
          if (("number" === n || "boolean" === n || "string" === n || e instanceof Number) && ("number" === r || "boolean" === r || "string" === r || t instanceof Number)) return e + t;
          if (e.constructor === Array && ("number" === r || "boolean" === r || "string" === r || t instanceof Number)) return e[0] = e[0] + t, e;
          if (("number" === n || "boolean" === n || "string" === n || e instanceof Number) && t.constructor === Array) return t[0] = e + t[0], t;

          if (e.constructor === Array && t.constructor === Array) {
            for (var i = 0, a = e.length, o = t.length, s = []; i < a || i < o;) {
              ("number" === typeof e[i] || e[i] instanceof Number) && ("number" === typeof t[i] || t[i] instanceof Number) ? s[i] = e[i] + t[i] : s[i] = void 0 == t[i] ? e[i] : e[i] || t[i], i += 1;
            }

            return s;
          }

          return 0;
        }

        var add = sum;

        function sub(e, t) {
          var n = typeof e,
              r = typeof t;
          if (("number" === n || "boolean" === n || "string" === n || e instanceof Number) && ("number" === r || "boolean" === r || "string" === r || t instanceof Number)) return "string" === n && (e = parseInt(e)), "string" === r && (t = parseInt(t)), e - t;
          if (e.constructor === Array && ("number" === r || "boolean" === r || "string" === r || t instanceof Number)) return e[0] = e[0] - t, e;
          if (("number" === n || "boolean" === n || "string" === n || e instanceof Number) && t.constructor === Array) return t[0] = e - t[0], t;

          if (e.constructor === Array && t.constructor === Array) {
            for (var i = 0, a = e.length, o = t.length, s = []; i < a || i < o;) {
              ("number" === typeof e[i] || e[i] instanceof Number) && ("number" === typeof t[i] || (t[i], Number), 1) ? s[i] = e[i] - t[i] : s[i] = void 0 == t[i] ? e[i] : e[i] || t[i], i += 1;
            }

            return s;
          }

          return 0;
        }

        function mul(e, t) {
          var n,
              r,
              i,
              a = typeof e,
              o = typeof t;
          if (("number" === a || "boolean" === a || "string" === a || e instanceof Number) && ("number" === o || "boolean" === o || "string" === o || t instanceof Number)) return e * t;

          if (e.constructor === Array && ("number" === o || "boolean" === o || "string" === o || t instanceof Number)) {
            for (i = e.length, n = Array.apply(null, {
              length: i
            }), r = 0; r < i; r += 1) {
              n[r] = e[r] * t;
            }

            return n;
          }

          if (("number" === a || "boolean" === a || "string" === a || e instanceof Number) && t.constructor === Array) {
            for (i = t.length, n = Array.apply(null, {
              length: i
            }), r = 0; r < i; r += 1) {
              n[r] = e * t[r];
            }

            return n;
          }

          return 0;
        }

        function div(e, t) {
          var n,
              r,
              i,
              a = typeof e,
              o = typeof t;
          if (("number" === a || "boolean" === a || "string" === a || e instanceof Number) && ("number" === o || "boolean" === o || "string" === o || t instanceof Number)) return e / t;

          if (e.constructor === Array && ("number" === o || "boolean" === o || "string" === o || t instanceof Number)) {
            for (i = e.length, n = Array.apply(null, {
              length: i
            }), r = 0; r < i; r += 1) {
              n[r] = e[r] / t;
            }

            return n;
          }

          if (("number" === a || "boolean" === a || "string" === a || e instanceof Number) && t.constructor === Array) {
            for (i = t.length, n = Array.apply(null, {
              length: i
            }), r = 0; r < i; r += 1) {
              n[r] = e / t[r];
            }

            return n;
          }

          return 0;
        }

        function mod(e, t) {
          return "string" === typeof e && (e = parseInt(e)), "string" === typeof t && (t = parseInt(t)), e % t;
        }

        function clamp(e, t, n) {
          if (t > n) {
            var r = n;
            n = t, t = r;
          }

          return Math.min(Math.max(e, t), n);
        }

        function radiansToDegrees(e) {
          return e / degToRads;
        }

        var radians_to_degrees = radiansToDegrees;

        function degreesToRadians(e) {
          return e * degToRads;
        }

        var degrees_to_radians = radiansToDegrees,
            helperLengthArray = [0, 0, 0, 0, 0, 0];

        function length(e, t) {
          if ("number" === typeof e || e instanceof Number) return t = t || 0, Math.abs(e - t);
          t || (t = helperLengthArray);
          var n,
              r = Math.min(e.length, t.length),
              i = 0;

          for (n = 0; n < r; n += 1) {
            i += Math.pow(t[n] - e[n], 2);
          }

          return Math.sqrt(i);
        }

        function normalize(e) {
          return div(e, length(e));
        }

        function rgbToHsl(e) {
          var t,
              n,
              r = e[0],
              i = e[1],
              a = e[2],
              o = Math.max(r, i, a),
              s = Math.min(r, i, a),
              l = (o + s) / 2;
          if (o == s) t = n = 0;else {
            var c = o - s;

            switch (n = l > .5 ? c / (2 - o - s) : c / (o + s), o) {
              case r:
                t = (i - a) / c + (i < a ? 6 : 0);
                break;

              case i:
                t = (a - r) / c + 2;
                break;

              case a:
                t = (r - i) / c + 4;
            }

            t /= 6;
          }
          return [t, n, l, e[3]];
        }

        function hslToRgb(e) {
          var t,
              n,
              r,
              i = e[0],
              a = e[1],
              o = e[2];
          if (0 == a) t = n = r = o;else {
            var s = function hue2rgb(e, t, n) {
              return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
            },
                l = o < .5 ? o * (1 + a) : o + a - o * a,
                c = 2 * o - l;

            t = s(c, l, i + 1 / 3), n = s(c, l, i), r = s(c, l, i - 1 / 3);
          }
          return [t, n, r, e[3]];
        }

        function linear(e, t, n, r, i) {
          if (void 0 === r || void 0 === i) return linear(e, 0, 1, t, n);
          if (e <= t) return r;
          if (e >= n) return i;
          var a = n === t ? 0 : (e - t) / (n - t);
          if (!r.length) return r + (i - r) * a;
          var o,
              s = r.length,
              l = Array.apply(null, {
            length: s
          });

          for (o = 0; o < s; o += 1) {
            l[o] = r[o] + (i[o] - r[o]) * a;
          }

          return l;
        }

        function random(e, t) {
          if (void 0 === t && (void 0 === e ? (e = 0, t = 1) : (t = e, e = void 0)), t.length) {
            var n,
                r = t.length;
            e || (e = Array.apply(null, {
              length: r
            }));
            var i = Array.apply(null, {
              length: r
            }),
                a = BMMath.random();

            for (n = 0; n < r; n += 1) {
              i[n] = e[n] + a * (t[n] - e[n]);
            }

            return i;
          }

          return void 0 === e && (e = 0), e + BMMath.random() * (t - e);
        }

        function createPath(e, t, n, r) {
          t = t && t.length ? t : e, n = n && n.length ? n : e;
          var a = shape_pool.newShape(),
              o = e.length;

          for (a.setPathData(r, o), i = 0; i < o; i += 1) {
            a.setTripleAt(e[i][0], e[i][1], n[i][0] + e[i][0], n[i][1] + e[i][1], t[i][0] + e[i][0], t[i][1] + e[i][1], i, !0);
          }

          return a;
        }

        function initiateExpression(elem, data, property) {
          var val = data.x,
              needsVelocity = /velocity(?![\w\d])/.test(val),
              _needsRandom = -1 !== val.indexOf("random"),
              elemType = elem.data.ty,
              transform,
              content,
              effect,
              thisComp = elem.comp,
              thisProperty = property;

          elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;

          var inPoint = elem.data.ip / elem.comp.globalData.frameRate,
              outPoint = elem.data.op / elem.comp.globalData.frameRate,
              width = elem.data.sw ? elem.data.sw : 0,
              height = elem.data.sh ? elem.data.sh : 0,
              loopIn,
              loop_in,
              loopOut,
              loop_out,
              toWorld,
              fromWorld,
              fromComp,
              fromCompToSurface,
              anchorPoint,
              thisLayer,
              thisComp,
              mask,
              valueAtTime,
              velocityAtTime,
              fn = new Function(),
              fn = eval("[function(){" + val + ";if($bm_rt.__shapeObject){this.v=shape_pool.clone($bm_rt.v);}else{this.v=$bm_rt;}}]")[0],
              bindedFn = fn.bind(this),
              numKeys = property.kf ? data.k.length : 0,
              wiggle = function wiggle(e, t) {
            var n,
                r,
                i = this.pv.length ? this.pv.length : 1,
                a = Array.apply(null, {
              len: i
            });

            for (r = 0; r < i; r += 1) {
              a[r] = 0;
            }

            var o = Math.floor(5 * time);

            for (n = 0, r = 0; n < o;) {
              for (r = 0; r < i; r += 1) {
                a[r] += -t + 2 * t * BMMath.random();
              }

              n += 1;
            }

            var s = 5 * time,
                l = s - Math.floor(s),
                c = Array.apply({
              length: i
            });

            if (i > 1) {
              for (r = 0; r < i; r += 1) {
                c[r] = this.pv[r] + a[r] + (-t + 2 * t * BMMath.random()) * l;
              }

              return c;
            }

            return this.pv + a[0] + (-t + 2 * t * BMMath.random()) * l;
          }.bind(this);

          thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut);

          var loopInDuration = function loopInDuration(e, t) {
            return loopIn(e, t, !0);
          }.bind(this),
              loopOutDuration = function loopOutDuration(e, t) {
            return loopOut(e, t, !0);
          }.bind(this);

          this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
          var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface),
              time,
              velocity,
              value,
              textIndex,
              textTotal,
              selectorValue;

          function lookAt(e, t) {
            var n = [t[0] - e[0], t[1] - e[1], t[2] - e[2]],
                r = Math.atan2(n[0], Math.sqrt(n[1] * n[1] + n[2] * n[2])) / degToRads;
            return [-Math.atan2(n[1], n[2]) / degToRads, r, 0];
          }

          function easeOut(e, t, n) {
            return -(n - t) * e * (e - 2) + t;
          }

          function nearestKey(e) {
            var t,
                n,
                r,
                i = data.k.length;
            if (data.k.length && "number" !== typeof data.k[0]) {
              if (n = -1, (e *= elem.comp.globalData.frameRate) < data.k[0].t) n = 1, r = data.k[0].t;else {
                for (t = 0; t < i - 1; t += 1) {
                  if (e === data.k[t].t) {
                    n = t + 1, r = data.k[t].t;
                    break;
                  }

                  if (e > data.k[t].t && e < data.k[t + 1].t) {
                    e - data.k[t].t > data.k[t + 1].t - e ? (n = t + 2, r = data.k[t + 1].t) : (n = t + 1, r = data.k[t].t);
                    break;
                  }
                }

                -1 === n && (n = t + 1, r = data.k[t].t);
              }
            } else n = 0, r = 0;
            var a = {};
            return a.index = n, a.time = r / elem.comp.globalData.frameRate, a;
          }

          function key(e) {
            var t, n, r, i;
            if (!data.k.length || "number" === typeof data.k[0]) throw new Error("The property has no keyframe at index " + e);

            for (e -= 1, t = {
              time: data.k[e].t / elem.comp.globalData.frameRate
            }, r = (i = e !== data.k.length - 1 || data.k[e].h ? data.k[e].s : data.k[e - 1].e).length, n = 0; n < r; n += 1) {
              t[n] = i[n];
            }

            return t;
          }

          function framesToTime(e, t) {
            return t || (t = elem.comp.globalData.frameRate), e / t;
          }

          function timeToFrames(e, t) {
            return e || 0 === e || (e = time), t || (t = elem.comp.globalData.frameRate), e * t;
          }

          function seedRandom(e) {
            BMMath.seedrandom(randSeed + e);
          }

          function sourceRectAtTime() {
            return elem.sourceRectAtTime();
          }

          var index = elem.data.ind,
              hasParent = !(!elem.hierarchy || !elem.hierarchy.length),
              parent,
              randSeed = Math.floor(1e6 * Math.random());

          function executeExpression() {
            if (_needsRandom && seedRandom(randSeed), this.frameExpressionId !== elem.globalData.frameId || "textSelector" === this.type) {
              if (this.lock) return this.v = duplicatePropertyValue(this.pv, this.mult), !0;
              var e, t;
              if ("textSelector" === this.type && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), anchorPoint = transform.anchorPoint), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), this.lock = !0, this.getPreValue && this.getPreValue(), value = this.pv, time = this.comp.renderedFrame / this.comp.globalData.frameRate, needsVelocity && (velocity = velocityAtTime(time)), bindedFn(), this.frameExpressionId = elem.globalData.frameId, this.mult) if ("number" === typeof this.v || this.v instanceof Number || this.v instanceof String || "string" === typeof this.v) this.v *= this.mult;else if (1 === this.v.length) this.v = this.v[0] * this.mult;else for (t = this.v.length, value === this.v && (this.v = 2 === t ? [value[0], value[1]] : [value[0], value[1], value[2]]), e = 0; e < t; e += 1) {
                this.v[e] *= this.mult;
              }
              if (1 === this.v.length && (this.v = this.v[0]), "number" === typeof this.v || this.v instanceof Number || this.v instanceof String || "string" === typeof this.v) this.lastValue !== this.v && (this.lastValue = this.v, this.mdf = !0);else if (this.v._length) shapesEqual(this.v, this.localShapeCollection.shapes[0]) || (this.mdf = !0, this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(shape_pool.clone(this.v)));else for (t = this.v.length, e = 0; e < t; e += 1) {
                this.v[e] !== this.lastValue[e] && (this.lastValue[e] = this.v[e], this.mdf = !0);
              }
              this.lock = !1;
            }
          }

          return executeExpression;
        }

        return ob.initiateExpression = initiateExpression, ob;
      }(),
          ShapeExpressionInterface = function () {
        var e = {
          createShapeInterface: function createShapeInterface(e, n, r) {
            return t(e, n, r);
          },
          createGroupInterface: function createGroupInterface(e, t, n) {
            return r(e, t, n);
          },
          createTrimInterface: function createTrimInterface(e, t, n) {
            return o(e, t, n);
          },
          createStrokeInterface: function createStrokeInterface(e, t, n) {
            return a(e, t, n);
          },
          createTransformInterface: function createTransformInterface(e, t, n) {
            return s(e, t, n);
          },
          createEllipseInterface: function createEllipseInterface(e, t, n) {
            return l(e, t, n);
          },
          createStarInterface: function createStarInterface(e, t, n) {
            return c(e, t, n);
          },
          createRectInterface: function createRectInterface(e, t, n) {
            return p(e, t, n);
          },
          createRoundedInterface: function createRoundedInterface(e, t, n) {
            return d(e, t, n);
          },
          createRepatearInterface: function createRepatearInterface(e, t, n) {
            return h(e, t, n);
          },
          createPathInterface: function createPathInterface(e, t, n) {
            return u(e, t, n);
          },
          createFillInterface: function createFillInterface(e, t, n) {
            return i(e, t, n);
          }
        };

        function iterateElements(e, t, n) {
          var r,
              i = [],
              a = e ? e.length : 0;

          for (r = 0; r < a; r += 1) {
            "gr" == e[r].ty ? i.push(ShapeExpressionInterface.createGroupInterface(e[r], t[r], n)) : "fl" == e[r].ty ? i.push(ShapeExpressionInterface.createFillInterface(e[r], t[r], n)) : "st" == e[r].ty ? i.push(ShapeExpressionInterface.createStrokeInterface(e[r], t[r], n)) : "tm" == e[r].ty ? i.push(ShapeExpressionInterface.createTrimInterface(e[r], t[r], n)) : "tr" == e[r].ty || ("el" == e[r].ty ? i.push(ShapeExpressionInterface.createEllipseInterface(e[r], t[r], n)) : "sr" == e[r].ty ? i.push(ShapeExpressionInterface.createStarInterface(e[r], t[r], n)) : "sh" == e[r].ty ? i.push(ShapeExpressionInterface.createPathInterface(e[r], t[r], n)) : "rc" == e[r].ty ? i.push(ShapeExpressionInterface.createRectInterface(e[r], t[r], n)) : "rd" == e[r].ty ? i.push(ShapeExpressionInterface.createRoundedInterface(e[r], t[r], n)) : "rp" == e[r].ty && i.push(ShapeExpressionInterface.createRepatearInterface(e[r], t[r], n)));
          }

          return i;
        }

        var t = function t(e, _t2, n) {
          var r;

          function _interfaceFunction(e) {
            if ("number" === typeof e) return r[e - 1];

            for (var t = 0, n = r.length; t < n;) {
              if (r[t]._name === e) return r[t];
              t += 1;
            }
          }

          return _interfaceFunction.propertyGroup = n, r = iterateElements(e, _t2, _interfaceFunction), _interfaceFunction;
        },
            n = function n(e, t, _n2) {
          var r,
              i = function _interfaceFunction(e) {
            for (var t = 0, n = r.length; t < n;) {
              if (r[t]._name === e || r[t].mn === e || r[t].propertyIndex === e || r[t].ix === e || r[t].ind === e) return r[t];
              t += 1;
            }

            if ("number" === typeof e) return r[e - 1];
          };

          return i.propertyGroup = function (e) {
            return 1 === e ? i : _n2(e - 1);
          }, r = iterateElements(e.it, t.it, i.propertyGroup), i.numProperties = r.length, i.propertyIndex = e.cix, i;
        },
            r = function r(e, t, _r2) {
          var i = function _interfaceFunction(e) {
            switch (e) {
              case "ADBE Vectors Group":
              case "Contents":
              case 2:
                return i.content;

              case "ADBE Vector Transform Group":
              case 3:
              default:
                return i.transform;
            }
          };

          i.propertyGroup = function (e) {
            return 1 === e ? i : _r2(e - 1);
          };

          var a = n(e, t, i.propertyGroup),
              o = ShapeExpressionInterface.createTransformInterface(e.it[e.it.length - 1], t.it[t.it.length - 1], i.propertyGroup);
          return i.content = a, i.transform = o, Object.defineProperty(i, "_name", {
            get: function get() {
              return e.nm;
            }
          }), i.numProperties = e.np, i.propertyIndex = e.ix, i.nm = e.nm, i.mn = e.mn, i;
        },
            i = function i(e, t, n) {
          function interfaceFunction(e) {
            return "Color" === e || "color" === e ? interfaceFunction.color : "Opacity" === e || "opacity" === e ? interfaceFunction.opacity : void 0;
          }

          return Object.defineProperty(interfaceFunction, "color", {
            get: function get() {
              return ExpressionValue(t.c, 1 / t.c.mult, "color");
            }
          }), Object.defineProperty(interfaceFunction, "opacity", {
            get: function get() {
              return ExpressionValue(t.o, 100);
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            value: e.nm
          }), Object.defineProperty(interfaceFunction, "mn", {
            value: e.mn
          }), t.c.setGroupProperty(n), t.o.setGroupProperty(n), interfaceFunction;
        },
            a = function a(t, n, r) {
          function _propertyGroup(t) {
            return 1 === t ? e : r(t - 1);
          }

          function _dashPropertyGroup(e) {
            return 1 === e ? o : _propertyGroup(e - 1);
          }

          function addPropertyToDashOb(e) {
            Object.defineProperty(o, t.d[e].nm, {
              get: function get() {
                return ExpressionValue(n.d.dataProps[e].p);
              }
            });
          }

          var i,
              a = t.d ? t.d.length : 0,
              o = {};

          for (i = 0; i < a; i += 1) {
            addPropertyToDashOb(i), n.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
          }

          function interfaceFunction(e) {
            return "Color" === e || "color" === e ? interfaceFunction.color : "Opacity" === e || "opacity" === e ? interfaceFunction.opacity : "Stroke Width" === e || "stroke width" === e ? interfaceFunction.strokeWidth : void 0;
          }

          return Object.defineProperty(interfaceFunction, "color", {
            get: function get() {
              return ExpressionValue(n.c, 1 / n.c.mult, "color");
            }
          }), Object.defineProperty(interfaceFunction, "opacity", {
            get: function get() {
              return ExpressionValue(n.o, 100);
            }
          }), Object.defineProperty(interfaceFunction, "strokeWidth", {
            get: function get() {
              return ExpressionValue(n.w);
            }
          }), Object.defineProperty(interfaceFunction, "dash", {
            get: function get() {
              return o;
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            value: t.nm
          }), Object.defineProperty(interfaceFunction, "mn", {
            value: t.mn
          }), n.c.setGroupProperty(_propertyGroup), n.o.setGroupProperty(_propertyGroup), n.w.setGroupProperty(_propertyGroup), interfaceFunction;
        },
            o = function o(e, t, n) {
          function _propertyGroup(e) {
            return 1 == e ? interfaceFunction : n(--e);
          }

          function interfaceFunction(t) {
            return t === e.e.ix || "End" === t || "end" === t ? interfaceFunction.end : t === e.s.ix ? interfaceFunction.start : t === e.o.ix ? interfaceFunction.offset : void 0;
          }

          return interfaceFunction.propertyIndex = e.ix, t.s.setGroupProperty(_propertyGroup), t.e.setGroupProperty(_propertyGroup), t.o.setGroupProperty(_propertyGroup), interfaceFunction.propertyIndex = e.ix, Object.defineProperty(interfaceFunction, "start", {
            get: function get() {
              return ExpressionValue(t.s, 1 / t.s.mult);
            }
          }), Object.defineProperty(interfaceFunction, "end", {
            get: function get() {
              return ExpressionValue(t.e, 1 / t.e.mult);
            }
          }), Object.defineProperty(interfaceFunction, "offset", {
            get: function get() {
              return ExpressionValue(t.o);
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            get: function get() {
              return e.nm;
            }
          }), interfaceFunction.mn = e.mn, interfaceFunction;
        },
            s = function s(e, t, n) {
          function _propertyGroup(e) {
            return 1 == e ? interfaceFunction : n(--e);
          }

          function interfaceFunction(t) {
            return e.a.ix === t ? interfaceFunction.anchorPoint : e.o.ix === t ? interfaceFunction.opacity : e.p.ix === t ? interfaceFunction.position : e.r.ix === t ? interfaceFunction.rotation : e.s.ix === t ? interfaceFunction.scale : e.sk && e.sk.ix === t ? interfaceFunction.skew : e.sa && e.sa.ix === t ? interfaceFunction.skewAxis : "Opacity" === t ? interfaceFunction.opacity : "Position" === t ? interfaceFunction.position : "Anchor Point" === t ? interfaceFunction.anchorPoint : "Scale" === t ? interfaceFunction.scale : "Rotation" === t || "ADBE Vector Rotation" === t ? interfaceFunction.rotation : "Skew" === t ? interfaceFunction.skew : "Skew Axis" === t ? interfaceFunction.skewAxis : void 0;
          }

          return t.transform.mProps.o.setGroupProperty(_propertyGroup), t.transform.mProps.p.setGroupProperty(_propertyGroup), t.transform.mProps.a.setGroupProperty(_propertyGroup), t.transform.mProps.s.setGroupProperty(_propertyGroup), t.transform.mProps.r.setGroupProperty(_propertyGroup), t.transform.mProps.sk && (t.transform.mProps.sk.setGroupProperty(_propertyGroup), t.transform.mProps.sa.setGroupProperty(_propertyGroup)), t.transform.op.setGroupProperty(_propertyGroup), Object.defineProperty(interfaceFunction, "opacity", {
            get: function get() {
              return ExpressionValue(t.transform.mProps.o, 1 / t.transform.mProps.o.mult);
            }
          }), Object.defineProperty(interfaceFunction, "position", {
            get: function get() {
              return ExpressionValue(t.transform.mProps.p);
            }
          }), Object.defineProperty(interfaceFunction, "anchorPoint", {
            get: function get() {
              return ExpressionValue(t.transform.mProps.a);
            }
          }), Object.defineProperty(interfaceFunction, "scale", {
            get: function get() {
              return ExpressionValue(t.transform.mProps.s, 1 / t.transform.mProps.s.mult);
            }
          }), Object.defineProperty(interfaceFunction, "rotation", {
            get: function get() {
              return ExpressionValue(t.transform.mProps.r, 1 / t.transform.mProps.r.mult);
            }
          }), Object.defineProperty(interfaceFunction, "skew", {
            get: function get() {
              return ExpressionValue(t.transform.mProps.sk);
            }
          }), Object.defineProperty(interfaceFunction, "skewAxis", {
            get: function get() {
              return ExpressionValue(t.transform.mProps.sa);
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            get: function get() {
              return e.nm;
            }
          }), interfaceFunction.ty = "tr", interfaceFunction.mn = e.mn, interfaceFunction;
        },
            l = function l(e, t, n) {
          function _propertyGroup(e) {
            return 1 == e ? interfaceFunction : n(--e);
          }

          interfaceFunction.propertyIndex = e.ix;
          var r = "tm" === t.sh.ty ? t.sh.prop : t.sh;

          function interfaceFunction(t) {
            return e.p.ix === t ? interfaceFunction.position : e.s.ix === t ? interfaceFunction.size : void 0;
          }

          return r.s.setGroupProperty(_propertyGroup), r.p.setGroupProperty(_propertyGroup), Object.defineProperty(interfaceFunction, "size", {
            get: function get() {
              return ExpressionValue(r.s);
            }
          }), Object.defineProperty(interfaceFunction, "position", {
            get: function get() {
              return ExpressionValue(r.p);
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            get: function get() {
              return e.nm;
            }
          }), interfaceFunction.mn = e.mn, interfaceFunction;
        },
            c = function c(e, t, n) {
          function _propertyGroup(e) {
            return 1 == e ? interfaceFunction : n(--e);
          }

          var r = "tm" === t.sh.ty ? t.sh.prop : t.sh;

          function interfaceFunction(t) {
            return e.p.ix === t ? interfaceFunction.position : e.r.ix === t ? interfaceFunction.rotation : e.pt.ix === t ? interfaceFunction.points : e.or.ix === t || "ADBE Vector Star Outer Radius" === t ? interfaceFunction.outerRadius : e.os.ix === t ? interfaceFunction.outerRoundness : !e.ir || e.ir.ix !== t && "ADBE Vector Star Inner Radius" !== t ? e.is && e.is.ix === t ? interfaceFunction.innerRoundness : void 0 : interfaceFunction.innerRadius;
          }

          return interfaceFunction.propertyIndex = e.ix, r.or.setGroupProperty(_propertyGroup), r.os.setGroupProperty(_propertyGroup), r.pt.setGroupProperty(_propertyGroup), r.p.setGroupProperty(_propertyGroup), r.r.setGroupProperty(_propertyGroup), e.ir && (r.ir.setGroupProperty(_propertyGroup), r.is.setGroupProperty(_propertyGroup)), Object.defineProperty(interfaceFunction, "position", {
            get: function get() {
              return ExpressionValue(r.p);
            }
          }), Object.defineProperty(interfaceFunction, "rotation", {
            get: function get() {
              return ExpressionValue(r.r, 1 / r.r.mult);
            }
          }), Object.defineProperty(interfaceFunction, "points", {
            get: function get() {
              return ExpressionValue(r.pt);
            }
          }), Object.defineProperty(interfaceFunction, "outerRadius", {
            get: function get() {
              return ExpressionValue(r.or);
            }
          }), Object.defineProperty(interfaceFunction, "outerRoundness", {
            get: function get() {
              return ExpressionValue(r.os);
            }
          }), Object.defineProperty(interfaceFunction, "innerRadius", {
            get: function get() {
              return r.ir ? ExpressionValue(r.ir) : 0;
            }
          }), Object.defineProperty(interfaceFunction, "innerRoundness", {
            get: function get() {
              return r.is ? ExpressionValue(r.is, 1 / r.is.mult) : 0;
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            get: function get() {
              return e.nm;
            }
          }), interfaceFunction.mn = e.mn, interfaceFunction;
        },
            p = function p(e, t, n) {
          function _propertyGroup(e) {
            return 1 == e ? interfaceFunction : n(--e);
          }

          var r = "tm" === t.sh.ty ? t.sh.prop : t.sh;

          function interfaceFunction(t) {
            return e.p.ix === t ? interfaceFunction.position : e.r.ix === t ? interfaceFunction.roundness : e.s.ix === t || "Size" === t ? interfaceFunction.size : void 0;
          }

          return interfaceFunction.propertyIndex = e.ix, r.p.setGroupProperty(_propertyGroup), r.s.setGroupProperty(_propertyGroup), r.r.setGroupProperty(_propertyGroup), Object.defineProperty(interfaceFunction, "position", {
            get: function get() {
              return ExpressionValue(r.p);
            }
          }), Object.defineProperty(interfaceFunction, "roundness", {
            get: function get() {
              return ExpressionValue(r.r);
            }
          }), Object.defineProperty(interfaceFunction, "size", {
            get: function get() {
              return ExpressionValue(r.s);
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            get: function get() {
              return e.nm;
            }
          }), interfaceFunction.mn = e.mn, interfaceFunction;
        },
            d = function d(e, t, n) {
          var r = t;

          function interfaceFunction(t) {
            if (e.r.ix === t || "Round Corners 1" === t) return interfaceFunction.radius;
          }

          return interfaceFunction.propertyIndex = e.ix, r.rd.setGroupProperty(function _propertyGroup(e) {
            return 1 == e ? interfaceFunction : n(--e);
          }), Object.defineProperty(interfaceFunction, "radius", {
            get: function get() {
              return ExpressionValue(r.rd);
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            get: function get() {
              return e.nm;
            }
          }), interfaceFunction.mn = e.mn, interfaceFunction;
        },
            h = function h(e, t, n) {
          function _propertyGroup(e) {
            return 1 == e ? interfaceFunction : n(--e);
          }

          var r = t;

          function interfaceFunction(t) {
            return e.c.ix === t || "Copies" === t ? interfaceFunction.copies : e.o.ix === t || "Offset" === t ? interfaceFunction.offset : void 0;
          }

          return interfaceFunction.propertyIndex = e.ix, r.c.setGroupProperty(_propertyGroup), r.o.setGroupProperty(_propertyGroup), Object.defineProperty(interfaceFunction, "copies", {
            get: function get() {
              return ExpressionValue(r.c);
            }
          }), Object.defineProperty(interfaceFunction, "offset", {
            get: function get() {
              return ExpressionValue(r.o);
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            get: function get() {
              return e.nm;
            }
          }), interfaceFunction.mn = e.mn, interfaceFunction;
        },
            u = function u(e, t, n) {
          var r = t.sh;

          function interfaceFunction(e) {
            if ("Shape" === e || "shape" === e || "Path" === e || "path" === e || "ADBE Vector Shape" === e || 2 === e) return interfaceFunction.path;
          }

          return r.setGroupProperty(function _propertyGroup(e) {
            return 1 == e ? interfaceFunction : n(--e);
          }), Object.defineProperty(interfaceFunction, "path", {
            get: function get() {
              return r.k && r.getValue(), r;
            }
          }), Object.defineProperty(interfaceFunction, "shape", {
            get: function get() {
              return r.k && r.getValue(), r;
            }
          }), Object.defineProperty(interfaceFunction, "_name", {
            value: e.nm
          }), Object.defineProperty(interfaceFunction, "ix", {
            value: e.ix
          }), Object.defineProperty(interfaceFunction, "mn", {
            value: e.mn
          }), interfaceFunction;
        };

        return e;
      }(),
          TextExpressionInterface = function TextExpressionInterface(e) {
        var t;

        function _thisLayerFunction() {}

        return Object.defineProperty(_thisLayerFunction, "sourceText", {
          get: function get() {
            var n = e.textProperty.currentData.t;
            return void 0 !== e.textProperty.currentData.t && (e.textProperty.currentData.t = void 0, (t = new String(n)).value = n || new String(n)), t;
          }
        }), _thisLayerFunction;
      },
          LayerExpressionInterface = function () {
        function toWorld(e, t) {
          var n = new Matrix();

          if (n.reset(), this._elem.finalTransform.mProp.applyToMatrix(n), this._elem.hierarchy && this._elem.hierarchy.length) {
            var r,
                i = this._elem.hierarchy.length;

            for (r = 0; r < i; r += 1) {
              this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(n);
            }

            return n.applyToPointArray(e[0], e[1], e[2] || 0);
          }

          return n.applyToPointArray(e[0], e[1], e[2] || 0);
        }

        function fromWorld(e, t) {
          var n = new Matrix();

          if (n.reset(), this._elem.finalTransform.mProp.applyToMatrix(n), this._elem.hierarchy && this._elem.hierarchy.length) {
            var r,
                i = this._elem.hierarchy.length;

            for (r = 0; r < i; r += 1) {
              this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(n);
            }

            return n.inversePoint(e);
          }

          return n.inversePoint(e);
        }

        function fromComp(e) {
          var t = new Matrix();

          if (t.reset(), this._elem.finalTransform.mProp.applyToMatrix(t), this._elem.hierarchy && this._elem.hierarchy.length) {
            var n,
                r = this._elem.hierarchy.length;

            for (n = 0; n < r; n += 1) {
              this._elem.hierarchy[n].finalTransform.mProp.applyToMatrix(t);
            }

            return t.inversePoint(e);
          }

          return t.inversePoint(e);
        }

        return function (e) {
          var t = TransformExpressionInterface(e.transform);

          function _thisLayerFunction(e) {
            switch (e) {
              case "ADBE Root Vectors Group":
              case "Contents":
              case 2:
                return _thisLayerFunction.shapeInterface;

              case 1:
              case 6:
              case "Transform":
              case "transform":
              case "ADBE Transform Group":
                return t;

              case 4:
              case "ADBE Effect Parade":
                return _thisLayerFunction.effect;
            }
          }

          return _thisLayerFunction.toWorld = toWorld, _thisLayerFunction.fromWorld = fromWorld, _thisLayerFunction.toComp = toWorld, _thisLayerFunction.fromComp = fromComp, _thisLayerFunction.sourceRectAtTime = e.sourceRectAtTime.bind(e), _thisLayerFunction._elem = e, Object.defineProperty(_thisLayerFunction, "hasParent", {
            get: function get() {
              return !!e.hierarchy;
            }
          }), Object.defineProperty(_thisLayerFunction, "parent", {
            get: function get() {
              return e.hierarchy[0].layerInterface;
            }
          }), Object.defineProperty(_thisLayerFunction, "rotation", {
            get: function get() {
              return t.rotation;
            }
          }), Object.defineProperty(_thisLayerFunction, "scale", {
            get: function get() {
              return t.scale;
            }
          }), Object.defineProperty(_thisLayerFunction, "position", {
            get: function get() {
              return t.position;
            }
          }), Object.defineProperty(_thisLayerFunction, "anchorPoint", {
            get: function get() {
              return t.anchorPoint;
            }
          }), Object.defineProperty(_thisLayerFunction, "transform", {
            get: function get() {
              return t;
            }
          }), Object.defineProperty(_thisLayerFunction, "width", {
            get: function get() {
              return 0 === e.data.ty ? e.data.w : 100;
            }
          }), Object.defineProperty(_thisLayerFunction, "height", {
            get: function get() {
              return 0 === e.data.ty ? e.data.h : 100;
            }
          }), Object.defineProperty(_thisLayerFunction, "source", {
            get: function get() {
              return e.data.refId;
            }
          }), Object.defineProperty(_thisLayerFunction, "index", {
            get: function get() {
              return e.data.ind;
            }
          }), Object.defineProperty(_thisLayerFunction, "_name", {
            value: e.data.nm
          }), Object.defineProperty(_thisLayerFunction, "content", {
            get: function get() {
              return _thisLayerFunction.shapeInterface;
            }
          }), Object.defineProperty(_thisLayerFunction, "active", {
            get: function get() {
              return e.isVisible;
            }
          }), Object.defineProperty(_thisLayerFunction, "text", {
            get: function get() {
              return _thisLayerFunction.textInterface;
            }
          }), _thisLayerFunction.registerMaskInterface = function _registerMaskInterface(t) {
            _thisLayerFunction.mask = new MaskManagerInterface(t, e);
          }, _thisLayerFunction.registerEffectsInterface = function _registerEffectsInterface(e) {
            _thisLayerFunction.effect = e;
          }, _thisLayerFunction;
        };
      }(),
          CompExpressionInterface = function CompExpressionInterface(e) {
        function _thisLayerFunction(t) {
          for (var n = 0, r = e.layers.length; n < r;) {
            if (e.layers[n].nm === t || e.layers[n].ind === t) return e.elements[n].layerInterface;
            n += 1;
          }

          return {
            active: !1
          };
        }

        return Object.defineProperty(_thisLayerFunction, "_name", {
          value: e.data.nm
        }), _thisLayerFunction.layer = _thisLayerFunction, _thisLayerFunction.pixelAspect = 1, _thisLayerFunction.height = e.globalData.compSize.h, _thisLayerFunction.width = e.globalData.compSize.w, _thisLayerFunction.pixelAspect = 1, _thisLayerFunction.frameDuration = 1 / e.globalData.frameRate, _thisLayerFunction;
      },
          TransformExpressionInterface = function TransformExpressionInterface(e) {
        function _thisFunction(t) {
          switch (t) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return _thisFunction.scale;

            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return _thisFunction.rotation;

            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return e.position;

            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return _thisFunction.anchorPoint;

            case "opacity":
            case "Opacity":
            case 11:
              return _thisFunction.opacity;
          }
        }

        return Object.defineProperty(_thisFunction, "rotation", {
          get: function get() {
            return e.rotation;
          }
        }), Object.defineProperty(_thisFunction, "scale", {
          get: function get() {
            return e.scale;
          }
        }), Object.defineProperty(_thisFunction, "position", {
          get: function get() {
            return e.position;
          }
        }), Object.defineProperty(_thisFunction, "xPosition", {
          get: function get() {
            return e.xPosition;
          }
        }), Object.defineProperty(_thisFunction, "yPosition", {
          get: function get() {
            return e.yPosition;
          }
        }), Object.defineProperty(_thisFunction, "anchorPoint", {
          get: function get() {
            return e.anchorPoint;
          }
        }), Object.defineProperty(_thisFunction, "opacity", {
          get: function get() {
            return e.opacity;
          }
        }), Object.defineProperty(_thisFunction, "skew", {
          get: function get() {
            return e.skew;
          }
        }), Object.defineProperty(_thisFunction, "skewAxis", {
          get: function get() {
            return e.skewAxis;
          }
        }), _thisFunction;
      },
          ProjectInterface = function () {
        function registerComposition(e) {
          this.compositions.push(e);
        }

        return function () {
          function _thisProjectFunction(e) {
            for (var t = 0, n = this.compositions.length; t < n;) {
              if (this.compositions[t].data && this.compositions[t].data.nm === e) return this.compositions[t].prepareFrame && this.compositions[t].prepareFrame(this.currentFrame), this.compositions[t].compInterface;
              t += 1;
            }
          }

          return _thisProjectFunction.compositions = [], _thisProjectFunction.currentFrame = 0, _thisProjectFunction.registerComposition = registerComposition, _thisProjectFunction;
        };
      }(),
          EffectsExpressionInterface = function () {
        function createGroupInterface(e, t, n, r) {
          var i,
              a = [],
              o = e.ef.length;

          for (i = 0; i < o; i += 1) {
            5 === e.ef[i].ty ? a.push(createGroupInterface(e.ef[i], t.effectElements[i], t.effectElements[i].propertyGroup, r)) : a.push(createValueInterface(t.effectElements[i], e.ef[i].ty, r, _propertyGroup));
          }

          function _propertyGroup(e) {
            return 1 === e ? s : n(e - 1);
          }

          var s = function groupInterface(t) {
            for (var n = e.ef, r = 0, i = n.length; r < i;) {
              if (t === n[r].nm || t === n[r].mn || t === n[r].ix) return 5 === n[r].ty ? a[r] : a[r]();
              r += 1;
            }

            return a[0]();
          };

          return s.propertyGroup = _propertyGroup, "ADBE Color Control" === e.mn && Object.defineProperty(s, "color", {
            get: function get() {
              return a[0]();
            }
          }), Object.defineProperty(s, "numProperties", {
            get: function get() {
              return e.np;
            }
          }), s.active = 0 !== e.en, s;
        }

        function createValueInterface(e, t, n, r) {
          return e.p.setGroupProperty && e.p.setGroupProperty(r), function interfaceFunction() {
            return 10 === t ? n.comp.compInterface(e.p.v) : ExpressionValue(e.p);
          };
        }

        return {
          createEffectsInterface: function createEffectsInterface(e, t) {
            if (e.effects) {
              var n,
                  r = [],
                  i = e.data.ef,
                  a = e.effects.effectElements.length;

              for (n = 0; n < a; n += 1) {
                r.push(createGroupInterface(i[n], e.effects.effectElements[n], t, e));
              }

              return function (t) {
                for (var n = e.data.ef, i = 0, a = n.length; i < a;) {
                  if (t === n[i].nm || t === n[i].mn || t === n[i].ix) return r[i];
                  i += 1;
                }
              };
            }
          }
        };
      }(),
          MaskManagerInterface = function () {
        function MaskInterface(e, t) {
          this._mask = e, this._data = t;
        }

        Object.defineProperty(MaskInterface.prototype, "maskPath", {
          get: function get() {
            return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
          }
        });
        return function MaskManager(e, t) {
          var n,
              r = Array.apply(null, {
            length: e.viewData.length
          }),
              i = e.viewData.length;

          for (n = 0; n < i; n += 1) {
            r[n] = new MaskInterface(e.viewData[n], e.masksProperties[n]);
          }

          return function maskFunction(t) {
            for (n = 0; n < i;) {
              if (e.masksProperties[n].nm === t) return r[n];
              n += 1;
            }
          };
        };
      }(),
          ExpressionValue = function ExpressionValue(e, t, n) {
        var r, i, a, o;

        if (e.k && e.getValue(), n) {
          if ("color" === n) {
            for (a = 4, r = Array.apply(null, {
              length: a
            }), o = Array.apply(null, {
              length: a
            }), i = 0; i < a; i += 1) {
              r[i] = o[i] = t && i < 3 ? e.v[i] * t : 1;
            }

            r.value = o;
          }
        } else if ("number" === typeof e.v || e.v instanceof Number) (r = t ? new Number(e.v * t) : new Number(e.v)).value = t ? e.v * t : e.v;else {
          for (a = e.v.length, r = Array.apply(null, {
            length: a
          }), o = Array.apply(null, {
            length: a
          }), i = 0; i < a; i += 1) {
            r[i] = o[i] = t ? e.v[i] * t : e.v[i];
          }

          r.value = o;
        }

        return r.numKeys = e.keyframes ? e.keyframes.length : 0, r.key = function (t) {
          return r.numKeys ? e.keyframes[t - 1].t : 0;
        }, r.valueAtTime = e.getValueAtTime, r.propertyGroup = e.propertyGroup, r;
      };

      function SliderEffect(e, t, n) {
        this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
      }

      function AngleEffect(e, t, n) {
        this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
      }

      function ColorEffect(e, t, n) {
        this.p = PropertyFactory.getProp(t, e.v, 1, 0, n);
      }

      function PointEffect(e, t, n) {
        this.p = PropertyFactory.getProp(t, e.v, 1, 0, n);
      }

      function LayerIndexEffect(e, t, n) {
        this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
      }

      function MaskIndexEffect(e, t, n) {
        this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
      }

      function CheckboxEffect(e, t, n) {
        this.p = PropertyFactory.getProp(t, e.v, 0, 0, n);
      }

      function NoValueEffect() {
        this.p = {};
      }

      function EffectsManager(e, t, n) {
        var r = e.ef;
        this.effectElements = [];
        var i,
            a,
            o = r.length;

        for (i = 0; i < o; i++) {
          a = new GroupEffect(r[i], t, n), this.effectElements.push(a);
        }
      }

      function GroupEffect(e, t, n) {
        this.dynamicProperties = [], this.init(e, t, this.dynamicProperties), this.dynamicProperties.length && n.push(this);
      }

      GroupEffect.prototype.getValue = function () {
        this.mdf = !1;
        var e,
            t = this.dynamicProperties.length;

        for (e = 0; e < t; e += 1) {
          this.dynamicProperties[e].getValue(), this.mdf = !!this.dynamicProperties[e].mdf || this.mdf;
        }
      }, GroupEffect.prototype.init = function (e, t, n) {
        this.data = e, this.mdf = !1, this.effectElements = [];
        var r,
            i,
            a = this.data.ef.length,
            o = this.data.ef;

        for (r = 0; r < a; r += 1) {
          switch (o[r].ty) {
            case 0:
              i = new SliderEffect(o[r], t, n), this.effectElements.push(i);
              break;

            case 1:
              i = new AngleEffect(o[r], t, n), this.effectElements.push(i);
              break;

            case 2:
              i = new ColorEffect(o[r], t, n), this.effectElements.push(i);
              break;

            case 3:
              i = new PointEffect(o[r], t, n), this.effectElements.push(i);
              break;

            case 4:
            case 7:
              i = new CheckboxEffect(o[r], t, n), this.effectElements.push(i);
              break;

            case 10:
              i = new LayerIndexEffect(o[r], t, n), this.effectElements.push(i);
              break;

            case 11:
              i = new MaskIndexEffect(o[r], t, n), this.effectElements.push(i);
              break;

            case 5:
              i = new EffectsManager(o[r], t, n), this.effectElements.push(i);
              break;

            case 6:
              i = new NoValueEffect(o[r], t, n), this.effectElements.push(i);
          }
        }
      };
      var bodymovinjs = {};

      function setLocationHref(e) {
        locationHref = e;
      }

      function play(e) {
        animationManager.play(e);
      }

      function pause(e) {
        animationManager.pause(e);
      }

      function togglePause(e) {
        animationManager.togglePause(e);
      }

      function setSpeed(e, t) {
        animationManager.setSpeed(e, t);
      }

      function setDirection(e, t) {
        animationManager.setDirection(e, t);
      }

      function stop(e) {
        animationManager.stop(e);
      }

      function moveFrame(e) {
        animationManager.moveFrame(e);
      }

      function searchAnimations() {
        !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
      }

      function registerAnimation(e) {
        return animationManager.registerAnimation(e);
      }

      function resize() {
        animationManager.resize();
      }

      function start() {
        animationManager.start();
      }

      function goToAndStop(e, t, n) {
        animationManager.goToAndStop(e, t, n);
      }

      function setSubframeRendering(e) {
        subframeEnabled = e;
      }

      function loadAnimation(e) {
        return !0 === standalone && (e.animationData = JSON.parse(animationData)), animationManager.loadAnimation(e);
      }

      function destroy(e) {
        return animationManager.destroy(e);
      }

      function setQuality(e) {
        if ("string" === typeof e) switch (e) {
          case "high":
            defaultCurveSegments = 200;
            break;

          case "medium":
            defaultCurveSegments = 50;
            break;

          case "low":
            defaultCurveSegments = 10;
        } else !isNaN(e) && e > 1 && (defaultCurveSegments = e);
        roundValues(!(defaultCurveSegments >= 50));
      }

      function inBrowser() {
        return "undefined" !== typeof navigator;
      }

      function installPlugin(e, t) {
        "expressions" === e && (expressionsPlugin = t);
      }

      function getFactory(e) {
        switch (e) {
          case "propertyFactory":
            return PropertyFactory;

          case "shapePropertyFactory":
            return ShapePropertyFactory;

          case "matrix":
            return Matrix;
        }
      }

      function checkReady() {
        "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
      }

      function getQueryVariable(e) {
        for (var t = queryString.split("&"), n = 0; n < t.length; n++) {
          var r = t[n].split("=");
          if (decodeURIComponent(r[0]) == e) return decodeURIComponent(r[1]);
        }
      }

      bodymovinjs.play = play, bodymovinjs.pause = pause, bodymovinjs.setLocationHref = setLocationHref, bodymovinjs.togglePause = togglePause, bodymovinjs.setSpeed = setSpeed, bodymovinjs.setDirection = setDirection, bodymovinjs.stop = stop, bodymovinjs.moveFrame = moveFrame, bodymovinjs.searchAnimations = searchAnimations, bodymovinjs.registerAnimation = registerAnimation, bodymovinjs.loadAnimation = loadAnimation, bodymovinjs.setSubframeRendering = setSubframeRendering, bodymovinjs.resize = resize, bodymovinjs.start = start, bodymovinjs.goToAndStop = goToAndStop, bodymovinjs.destroy = destroy, bodymovinjs.setQuality = setQuality, bodymovinjs.inBrowser = inBrowser, bodymovinjs.installPlugin = installPlugin, bodymovinjs.__getFactory = getFactory, bodymovinjs.version = "4.13.0";
      var standalone = "__[STANDALONE]__",
          animationData = "__[ANIMATIONDATA]__",
          renderer = "";

      if (standalone) {
        var scripts = document.getElementsByTagName("script"),
            index = scripts.length - 1,
            myScript = scripts[index] || {
          src: ""
        },
            queryString = myScript.src.replace(/^[^\?]+\??/, "");
        renderer = getQueryVariable("renderer");
      }

      var readyStateCheckInterval = setInterval(checkReady, 100);
      return bodymovinjs;
    }, void 0 === (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return factory(root);
    }.call(exports, __webpack_require__, exports, module)) || (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        a = n(0),
        o = _interopRequireDefault(a),
        s = _interopRequireDefault(n(2));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var l = {
      position: "absolute",
      top: 0,
      left: 0,
      visibility: "hidden",
      height: 0,
      overflow: "scroll",
      whiteSpace: "pre"
    },
        c = ["extraWidth", "injectStyles", "inputClassName", "inputRef", "inputStyle", "minWidth", "onAutosize", "placeholderIsMinWidth"],
        p = function copyStyles(e, t) {
      t.style.fontSize = e.fontSize, t.style.fontFamily = e.fontFamily, t.style.fontWeight = e.fontWeight, t.style.fontStyle = e.fontStyle, t.style.letterSpacing = e.letterSpacing, t.style.textTransform = e.textTransform;
    },
        d = !("undefined" === typeof window || !window.navigator) && /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent),
        h = function generateId() {
      return d ? "_" + Math.random().toString(36).substr(2, 12) : void 0;
    },
        u = function (e) {
      function AutosizeInput(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, AutosizeInput);

        var t = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, e));

        return t.inputRef = function (e) {
          t.input = e, "function" === typeof t.props.inputRef && t.props.inputRef(e);
        }, t.placeHolderSizerRef = function (e) {
          t.placeHolderSizer = e;
        }, t.sizerRef = function (e) {
          t.sizer = e;
        }, t.state = {
          inputWidth: e.minWidth,
          inputId: e.id || h()
        }, t;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(AutosizeInput, a.Component), i(AutosizeInput, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.mounted = !0, this.copyInputStyles(), this.updateInputWidth();
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          var t = e.id;
          t !== this.props.id && this.setState({
            inputId: t || h()
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e, t) {
          t.inputWidth !== this.state.inputWidth && "function" === typeof this.props.onAutosize && this.props.onAutosize(this.state.inputWidth), this.updateInputWidth();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.mounted = !1;
        }
      }, {
        key: "copyInputStyles",
        value: function copyInputStyles() {
          if (this.mounted && window.getComputedStyle) {
            var e = this.input && window.getComputedStyle(this.input);
            e && (p(e, this.sizer), this.placeHolderSizer && p(e, this.placeHolderSizer));
          }
        }
      }, {
        key: "updateInputWidth",
        value: function updateInputWidth() {
          if (this.mounted && this.sizer && "undefined" !== typeof this.sizer.scrollWidth) {
            var e = void 0;
            e = this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth) ? Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2 : this.sizer.scrollWidth + 2, (e += "number" === this.props.type && void 0 === this.props.extraWidth ? 16 : parseInt(this.props.extraWidth) || 0) < this.props.minWidth && (e = this.props.minWidth), e !== this.state.inputWidth && this.setState({
              inputWidth: e
            });
          }
        }
      }, {
        key: "getInput",
        value: function getInput() {
          return this.input;
        }
      }, {
        key: "focus",
        value: function focus() {
          this.input.focus();
        }
      }, {
        key: "blur",
        value: function blur() {
          this.input.blur();
        }
      }, {
        key: "select",
        value: function select() {
          this.input.select();
        }
      }, {
        key: "renderStyles",
        value: function renderStyles() {
          var e = this.props.injectStyles;
          return d && e ? o.default.createElement("style", {
            dangerouslySetInnerHTML: {
              __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
            }
          }) : null;
        }
      }, {
        key: "render",
        value: function render() {
          var e = [this.props.defaultValue, this.props.value, ""].reduce(function (e, t) {
            return null !== e && void 0 !== e ? e : t;
          }),
              t = r({}, this.props.style);
          t.display || (t.display = "inline-block");

          var n = r({
            boxSizing: "content-box",
            width: this.state.inputWidth + "px"
          }, this.props.inputStyle),
              i = function _objectWithoutProperties(e, t) {
            var n = {};

            for (var r in e) {
              t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
            }

            return n;
          }(this.props, []);

          return function cleanInputProps(e) {
            c.forEach(function (t) {
              return delete e[t];
            });
          }(i), i.className = this.props.inputClassName, i.id = this.state.inputId, i.style = n, o.default.createElement("div", {
            className: this.props.className,
            style: t
          }, this.renderStyles(), o.default.createElement("input", r({}, i, {
            ref: this.inputRef
          })), o.default.createElement("div", {
            ref: this.sizerRef,
            style: l
          }, e), this.props.placeholder ? o.default.createElement("div", {
            ref: this.placeHolderSizerRef,
            style: l
          }, this.props.placeholder) : null);
        }
      }]), AutosizeInput;
    }();

    u.propTypes = {
      className: s.default.string,
      defaultValue: s.default.any,
      extraWidth: s.default.oneOfType([s.default.number, s.default.string]),
      id: s.default.string,
      injectStyles: s.default.bool,
      inputClassName: s.default.string,
      inputRef: s.default.func,
      inputStyle: s.default.object,
      minWidth: s.default.oneOfType([s.default.number, s.default.string]),
      onAutosize: s.default.func,
      onChange: s.default.func,
      placeholder: s.default.string,
      placeholderIsMinWidth: s.default.bool,
      style: s.default.object,
      value: s.default.any
    }, u.defaultProps = {
      minWidth: 1,
      injectStyles: !0
    }, t.default = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        a = n(0),
        o = _interopRequireDefault(a),
        s = _interopRequireDefault(n(2)),
        l = _interopRequireDefault(n(19)),
        c = _interopRequireDefault(n(242)),
        p = _interopRequireDefault(n(253));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var d = function (e) {
      function ContainerDimensions() {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, ContainerDimensions);

        var e = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (ContainerDimensions.__proto__ || Object.getPrototypeOf(ContainerDimensions)).call(this));

        return e.state = {
          initiated: !1
        }, e.onResize = e.onResize.bind(e), e;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(ContainerDimensions, a.Component), i(ContainerDimensions, null, [{
        key: "getDomNodeDimensions",
        value: function getDomNodeDimensions(e) {
          var t = e.getBoundingClientRect();
          return {
            top: t.top,
            right: t.right,
            bottom: t.bottom,
            left: t.left,
            width: t.width,
            height: t.height
          };
        }
      }]), i(ContainerDimensions, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.parentNode = l.default.findDOMNode(this).parentNode, this.elementResizeDetector = (0, c.default)({
            strategy: "scroll",
            callOnAdd: !1
          }), this.elementResizeDetector.listenTo(this.parentNode, this.onResize), this.componentIsMounted = !0, this.onResize();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.componentIsMounted = !1, this.elementResizeDetector.uninstall(this.parentNode);
        }
      }, {
        key: "onResize",
        value: function onResize() {
          var e = ContainerDimensions.getDomNodeDimensions(this.parentNode);
          this.componentIsMounted && this.setState(r({
            initiated: !0
          }, e));
        }
      }, {
        key: "render",
        value: function render() {
          if ((0, p.default)(this.props.children, "Expected children to be one of function or React.Element"), !this.state.initiated) return o.default.createElement("div", null);

          if ("function" === typeof this.props.children) {
            var e = this.props.children(this.state);
            return e && a.Children.only(e);
          }

          return a.Children.only(o.default.cloneElement(this.props.children, this.state));
        }
      }]), ContainerDimensions;
    }();

    d.propTypes = {
      children: s.default.oneOfType([s.default.element, s.default.func]).isRequired
    }, t.default = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CustomPicker = t.TwitterPicker = t.SwatchesPicker = t.SliderPicker = t.SketchPicker = t.PhotoshopPicker = t.MaterialPicker = t.HuePicker = t.GithubPicker = t.CompactPicker = t.ChromePicker = t.default = t.CirclePicker = t.BlockPicker = t.AlphaPicker = void 0;
    var r = n(278);
    Object.defineProperty(t, "AlphaPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(r).default;
      }
    });
    var i = n(470);
    Object.defineProperty(t, "BlockPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(i).default;
      }
    });
    var a = n(511);
    Object.defineProperty(t, "CirclePicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(a).default;
      }
    });
    var o = n(513);
    Object.defineProperty(t, "ChromePicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(o).default;
      }
    });
    var s = n(518);
    Object.defineProperty(t, "CompactPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(s).default;
      }
    });
    var l = n(521);
    Object.defineProperty(t, "GithubPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(l).default;
      }
    });
    var c = n(523);
    Object.defineProperty(t, "HuePicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(c).default;
      }
    });
    var p = n(525);
    Object.defineProperty(t, "MaterialPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(p).default;
      }
    });
    var d = n(526);
    Object.defineProperty(t, "PhotoshopPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(d).default;
      }
    });
    var h = n(532);
    Object.defineProperty(t, "SketchPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(h).default;
      }
    });
    var u = n(535);
    Object.defineProperty(t, "SliderPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(u).default;
      }
    });
    var f = n(539);
    Object.defineProperty(t, "SwatchesPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(f).default;
      }
    });
    var m = n(543);
    Object.defineProperty(t, "TwitterPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(m).default;
      }
    });
    var g = n(125);
    Object.defineProperty(t, "CustomPicker", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(g).default;
      }
    });

    var v = _interopRequireDefault(o);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    t.default = v.default;
  }, function (e, t, n) {
    e.exports = n(552);
  }, function (e, t, n) {
    var r = n(144);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-accordion--row {\n  border-top: 1px solid var(--color-p1-4);\n  border-bottom: 1px solid var(--color-p1-4);\n  padding: 22px 16px;\n  cursor: pointer;\n}\n\n.tide-accordion--row:hover:not(.tide-accordion--row--open) {\n  background: var(--color-p3-2);\n}\n\n.tide-accordion--row .tide-heading-4 {\n  margin: 0;\n}\n\n.tide-accordion--row .tide-paragraph {\n  margin-bottom: 0;\n  font-size: 14px;\n  color: var(--color-p1-6);\n}\n\n.tide-accordion--row--link-fake {\n  color: var(--color-p3);\n}\n\n.tide-accordion--row--header-text {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  height: 58px;\n}\n\n.tide-accordion--row--header-text-container {\n  width: 90%;\n  margin-right: 32px;\n}\n\n.tide-accordion--row--action {\n  -webkit-align-self: flex-end;\n          align-self: flex-end;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  width: 10%;\n  height: 100%;\n}\n\n.tide-accordion--row--body {\n  cursor: default;\n}", ""]);
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" !== typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" !== typeof e) return e;
      var n = t.protocol + "//" + t.host,
          r = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var i,
            a = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? e : (i = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? n + a : r + a.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")");
      });
    };
  }, function (e, t, n) {
    var r = n(147);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-icon {\n\tvertical-align: middle;\n\tdisplay: inline-block\n}\n\n.tide-icon path {\n\tfill: var(--color-p1-10);\n}\n\n.tide-icon.slack-icon rect,\n.tide-icon.slack-icon path {\n  fill: var(--main-navy)\n}\n\n/* COLORWAY */\n.colorway-icon {\n\tdisplay: block;\n}\n\n/* open new tab icon */\n.tide-icon.tide--open-new-tab path {\n\tfill: none;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(149);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-circle-loader {\n  position: relative;\n  --loader-color: var(--color-p3-4);\n  width: 32px;\n  height: 32px;\n}\n\n.tide-circle-loader--spinner {\n  -webkit-animation: rotate 2s linear infinite;\n          animation: rotate 2s linear infinite;\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n\n.tide-circle-loader---loading-circle {\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-width: 10%;\n  -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n          animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n  stroke-linecap: round;\n}\n\n@-webkit-keyframes rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px;\n  }\n}\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px;\n  }\n}\n\n@-webkit-keyframes color {\n  100%, 0%, 40%, 66%, 80%, 90% {\n    stroke: var(--loader-color);\n  }\n}\n\n@keyframes color {\n  100%, 0%, 40%, 66%, 80%, 90% {\n    stroke: var(--loader-color);\n  }\n}\n\n.tide-circle-loader.small {\n  width: 16px;\n  height: 16px;\n}\n\n.tide-circle-loader.large {\n  width: 80px;\n  height: 80px;\n}\n\n.tide-circle-loader.light {\n  --loader-color: var(--color-p1-2);\n}\n\n.tide-circle-loader.small .tide-circle-loader---loading-circle {\n  stroke-width: 13%;\n}\n\n.tide-circle-loader.large .tide-circle-loader---loading-circle {\n  stroke-width: 3px;\n}", ""]);
  }, function (e, t, n) {
    var r = n(151);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-button {\n  display: inline-block;\n  zoom: 1;\n  line-height: normal;\n  white-space: nowrap;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  -webkit-user-drag: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  box-sizing: border-box;\n  font-family: var(--marketing-font-family--semibold);\n  padding: 7px 24px 5px;\n  color: var(--color-p1);\n  border: 1px solid var(--color-p1-5);\n  background-color: var(--color-p1-2);\n  text-decoration: none;\n  border-radius: 3px;\n  transition: all .3s ease;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  width: auto;\n}\n\n.tide-button .tide-text-span {\n  font-family: var(--marketing-font-family--semibold);\n}\n\n.tide-button .tide-text-hidden {\n  visibility: hidden;\n}\n\n.tide-button::-moz-focus-inner {\n  padding: 0;\n  border: 0;\n}\n\n.tide-button.small .tide-text-span {\n  line-height: 16px;\n  font-size: 12px;\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-button.small {\n  padding: 5px 16px 3px;\n}\n\n.tide-button.medium .tide-text-span {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.tide-button.large {\n  padding: 8px 32px;\n}\n\n.tide-button.large .tide-text-span {\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.tide-button svg {\n  display: inline-block;\n  height: 1.15em;\n  max-width: 1.3em;;\n  vertical-align: top;\n}\n\n.tide-button.icon-left svg {\n  margin: 1px 8px 0 0;\n}\n\n.tide-button.icon-right svg {\n  margin: 1px 0 0 8px;\n}\n\n.tide-button.small svg {\n  margin-top: -1px;\n  vertical-align: text-bottom;\n}\n\n.tide-button.large svg {\n  margin-top: 5px;\n}\n\n.tide-button svg path {\n  fill: currentColor;\n}\n\n.tide-button:focus {\n  outline: 0;\n}\n.tide-button--active,\n.tide-button:active {\n  outline: 0;\n}\n\n.tide-button[disabled],\n.tide-button--disabled,\n.tide-button--disabled:hover,\n.tide-button--disabled:focus,\n.tide-button--disabled:active {\n  background-color: var(--color-p1-3);\n  color: var(--color-p1-5);\n  cursor: not-allowed;\n  box-shadow: none;\n  pointer-events: none;\n  border: 1px solid var(--color-p1-5);\n  border-radius: 3px;\n}\n\n.tide-button--hidden {\n  display: none;\n}\n\n.tide-button--primary,\n.tide-button--selected,\na.tide-button--primary,\na.tide-button--selected {\n  background-color: var(--color-p3);\n  border-color: var(--color-p3);\n  color: var(--color-p1-2);\n}\n\n.tide-button--primary:hover,\n.tide-button--primary-hover,\n.tide-button--primary:focus {\n  color: var(--color-p1-2);\n  background-color: var(--color-p3-7);\n  border-color: var(--color-p3-7);\n}\n\n.tide-button--primary.tide-anchor-link:hover, .tide-button--secondary.tide-anchor-link:hover, .tide-button--danger.tide-anchor-link:hover {\n  color: var(--color-p1-2);\n}\n\n.tide-button--tertiary.tide-anchor-link:hover,\n.tide-button--utility.tide-anchor-link:hover,\n.tide-button--inline-utility.tide-anchor-link:hover {\n  color: var(--color-p1);\n}\n\n.tide-button--secondary,\n.tide-button--selected,\na.tide-button--secondary,\na.tide-button--selected {\n  background-color: var(--color-p1);\n  border-color: var(--color-p1);\n  color: var(--color-p1-2);\n}\n\n.tide-button--secondary:hover,\n.tide-button--secondary-hover,\n.tide-button--secondary:focus {\n  background-color: var(--color-p1-10);\n  border-color: var(--color-p1-10);\n  color: var(--color-p1-2);\n}\n\n.tide-button--subtle,\n.tide-button--selected,\na.tide-button--subtle,\na.tide-button--selected {\n  background: var(--color-p1-3);\n  color: var(--color-p1-10);\n  border-color: var(--color-p1-5);\n}\n\n.tide-button--subtle:hover,\na.tide-button--subtle:hover,\n.tide-button--subtle:focus {\n  background: var(--color-p1-2);\n  color: var(--color-p1-10);\n}\n\n.tide-button--tertiary,\na.tide-button--tertiary {\n  background: var(--color-p1-2);\n  color: var(--color-p1-10);\n  border-color: var(--color-p1-5);\n}\n\n.tide-button--tertiary:hover,\na.tide-button--tertiary:hover,\n.tide-button--tertiary:focus {\n  background: var(--color-p1-3);\n  color: var(--color-p1-10);\n}\n\n.tide-button--danger,\na.tide-button--danger {\n  background-color: var(--color-s3);\n  border-color: var(--color-s3);\n  color: var(--color-p1-2);\n}\n\n.tide-button--danger:hover,\n.tide-button--danger-hover,\n.tide-button--danger:focus {\n  color: var(--color-p1-2);\n  background-color: var(--color-s3-7);\n  border-color: var(--color-s3-7);\n}\n\n.tide-button--utility,\n.tide-button--utility:focus,\na.tide-button--utility,\na.tide-button--utility:focus,\n.tide-button--inline-utility,\n.tide-button--inline-utility:focus,\na.tide-button--inline-utility,\na.tide-button--inline-utility:focus {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--color-p1-10);\n}\n\n.tide-button.tide-button--utility {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.tide-button.small.tide-button--utility {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n\n.tide-button.large.tide-button--utility {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.tide-button--utility:hover,\na.tide-button--utility:hover {\n  border-color: transparent;\n  color: var(--color-p1-10);\n  background-color: rgba(var(--color-p1-a), 0.1);\n}\n\n.tide-button--utility.tide-button--education-hover:hover,\na.tide-button--utility.tide-button--education-hover:hover {\n  background: var(--marketing-education--gradient);\n  -webkit-background-clip: text;\n          background-clip: text;\n  color: transparent;\n  transition: color 0.2s ease;\n}\n\n.tide-button .tide-button-loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%)\n}\n\n.tide-button.small .tide-button-loader {\n  margin: 0px 5px;\n}\n\n.tide-button.large .tide-button-loader {\n  margin: 4px 10px;\n}\n\n.tide-button.small .tide-button-loader svg,\n.tide-button.large .tide-button-loader svg {\n  margin-top: 0px;\n}\n\n.tide-pill-set .tide-button.selected {\n  background: var(--main-navy-light);\n}\n\n.tide-pill-set .tide-button {\n  margin: 0;\n  color: var(--main-navy-dark);\n  float: left;\n}\n\n.tide-pill-set .tide-button:not(.selected):hover {\n  color: var(--main-navy-extra-dark);\n}\n\n.tide-pill-set .tide-button:first-child {\n  border-radius: 5px 0 0 5px;\n  border-right: 1px solid transparent;\n}\n\n.tide-pill-set .tide-button:last-child {\n  border-radius: 0 5px 5px 0;\n}\n\n.tide-pill-set .tide-button:not(:last-child):not(:first-child) {\n  border-radius: 0;\n  border-right: 1px solid transparent;\n}\n\n.tide-button--inline-utility {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  color: var(--color-p1-6);\n}\n\n.tide-button--inline-utility:hover {\n  color: var(--color-p1-7);\n}\n\n.tide-button--inline-utility.tide-button[disabled],\n.tide-button--inline-utility.tide-button--disabled,\n.tide-button--inline-utility.tide-button--disabled:hover,\n.tide-button--inline-utility.tide-button--disabled:focus,\n.tide-button--inline-utility.tide-button--disabled:active {\n  background-color: transparent;\n  border: none;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = n(0),
        i = (_interopRequireDefault(r), _interopRequireDefault(n(153))),
        a = _interopRequireDefault(n(156));

    _interopRequireDefault(n(157));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function _classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function _possibleConstructorReturn(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    }

    function _inherits(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var o = 1073741823;
    t.default = function createReactContext(e, t) {
      var n,
          s,
          l = "__create-react-context-" + (0, a.default)() + "__",
          c = function (e) {
        function Provider() {
          var t, n;

          _classCallCheck(this, Provider);

          for (var r = arguments.length, i = Array(r), a = 0; a < r; a++) {
            i[a] = arguments[a];
          }

          return t = n = _possibleConstructorReturn(this, e.call.apply(e, [this].concat(i))), n.emitter = function createEventEmitter(e) {
            var t = [];
            return {
              on: function on(e) {
                t.push(e);
              },
              off: function off(e) {
                t = t.filter(function (t) {
                  return t !== e;
                });
              },
              get: function get() {
                return e;
              },
              set: function set(n, r) {
                e = n, t.forEach(function (t) {
                  return t(e, r);
                });
              }
            };
          }(n.props.value), _possibleConstructorReturn(n, t);
        }

        return _inherits(Provider, e), Provider.prototype.getChildContext = function getChildContext() {
          var e;
          return (e = {})[l] = this.emitter, e;
        }, Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(e) {
          if (this.props.value !== e.value) {
            var n = this.props.value,
                r = e.value,
                i = void 0;
            !function objectIs(e, t) {
              return e === t ? 0 !== e || 1 / e === 1 / t : e !== e && t !== t;
            }(n, r) ? (i = "function" === typeof t ? t(n, r) : o, 0 !== (i |= 0) && this.emitter.set(e.value, i)) : i = 0;
          }
        }, Provider.prototype.render = function render() {
          return this.props.children;
        }, Provider;
      }(r.Component);

      c.childContextTypes = ((n = {})[l] = i.default.object.isRequired, n);

      var p = function (t) {
        function Consumer() {
          var e, n;

          _classCallCheck(this, Consumer);

          for (var r = arguments.length, i = Array(r), a = 0; a < r; a++) {
            i[a] = arguments[a];
          }

          return e = n = _possibleConstructorReturn(this, t.call.apply(t, [this].concat(i))), n.state = {
            value: n.getValue()
          }, n.onUpdate = function (e, t) {
            0 !== ((0 | n.observedBits) & t) && n.setState({
              value: n.getValue()
            });
          }, _possibleConstructorReturn(n, e);
        }

        return _inherits(Consumer, t), Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(e) {
          var t = e.observedBits;
          this.observedBits = void 0 === t || null === t ? o : t;
        }, Consumer.prototype.componentDidMount = function componentDidMount() {
          this.context[l] && this.context[l].on(this.onUpdate);
          var e = this.props.observedBits;
          this.observedBits = void 0 === e || null === e ? o : e;
        }, Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
          this.context[l] && this.context[l].off(this.onUpdate);
        }, Consumer.prototype.getValue = function getValue() {
          return this.context[l] ? this.context[l].get() : e;
        }, Consumer.prototype.render = function render() {
          return function onlyChild(e) {
            return Array.isArray(e) ? e[0] : e;
          }(this.props.children)(this.state.value);
        }, Consumer;
      }(r.Component);

      return p.contextTypes = ((s = {})[l] = i.default.object, s), {
        Provider: c,
        Consumer: p
      };
    }, e.exports = t.default;
  }, function (e, t, n) {
    e.exports = n(154)();
  }, function (e, t, n) {
    "use strict";

    var r = n(155);

    function emptyFunction() {}

    function emptyFunctionWithReset() {}

    emptyFunctionWithReset.resetWarningCache = emptyFunction, e.exports = function () {
      function shim(e, t, n, i, a, o) {
        if (o !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return e.PropTypes = e, e;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      var n = "__global_unique_id__";

      e.exports = function () {
        return t[n] = (t[n] || 0) + 1;
      };
    }).call(this, n(32));
  }, function (e, t, n) {
    "use strict";

    var r = n(158);
    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    function makeEmptyFunction(e) {
      return function () {
        return e;
      };
    }

    var r = function emptyFunction() {};

    r.thatReturns = makeEmptyFunction, r.thatReturnsFalse = makeEmptyFunction(!1), r.thatReturnsTrue = makeEmptyFunction(!0), r.thatReturnsNull = makeEmptyFunction(null), r.thatReturnsThis = function () {
      return this;
    }, r.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = r;
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-action-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.tide-action-dropdown > button svg {\n  max-width: 12px;\n}\n\n.tide-action-dropdown .tide-button.icon-right.tide-action-dropdown-with-chevron svg {\n  max-height: 7px;\n  vertical-align: middle;\n  margin-top: 0;\n}\n\n.tide-div.tide-action-dropdown-actions {\n  position: absolute;\n  top: calc(100% + 8px);\n  border: 1px solid var(--color-p1-6);\n\n  background: var(--color-p1-2);\n  border-radius: 3px;\n  padding: 3px 0;\n  width: auto;\n  white-space: pre;\n}\n\n.tide-div.tide-action-dropdown-actions.flowUp {\n  top: unset;\n  bottom: calc(100% + 8px);\n}\n\n.tide-div.tide-action-dropdown-action {\n  padding: 8px 21px 8px 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--color-p1-8);\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n}\n\n.tide-action-dropdown-action > .tide-icon {\n  margin-right: 10px;\n}\n\n.tide-action-dropdown-action svg {\n  max-height: 14px;\n}\n\n.tide-action-dropdown-action:hover {\n  background: var(--color-p1-4)\n}\n\n.tide-action-dropdown--with-icon .tide-button.icon-right svg {\n  margin: 1px 0 0;\n}\n\n.tide-action-dropdown-action--disabled .tide-text-span {\n  color: rgba(var(--color-p1-a), 0.3);\n}\n\n.tide-action-dropdown-action--disabled .tide-icon path {\n  fill: rgba(var(--color-p1-a), 0.3);\n}\n\n.tide-action-dropdown-heading {\n  font-weight: bold;\n  color: var(--main-navy);\n  text-transform: uppercase;\n  font-size: var(--font-size-subtle);\n  border-bottom: 1px solid var(--main-navy-light);\n  margin: 5px;\n  padding: 2px;\n}\n\n.tide-action-dropdown-icon {\n  display: inline-block;\n  margin-right: 10px;\n  background-color: var(--main-navy-extra-light);\n  border: 1px solid rgba(var(--main-navy-extra-dark-a), 0.1);\n  padding: 6px;\n  border-radius: 20px;\n  text-align: center;\n}\n\n.tide-action-dropdown-entry {\n  display: inline-block;\n  padding: 4px 0;\n}\n\n.tide-action-dropdown-entry-label {\n  display: block;\n  font-family: var(--marketing-font-family--semibold);\n}\n\n.tide-action-dropdown-entry-description {\n  display: block;\n  font-size: 12px;\n  color: var(--color-p1-10);\n  margin-top: 5px;\n}\n\n.tide-action-dropdown-entry:hover .tide-action-dropdown-entry-description {\n  color: var(--color-p1);\n}\n\n\n.tide-action-dropdown--simple-label {\n  width: 100%;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(161);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, '.tide-agent-status-toggle {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 52px;\n  height: 32px;\n}\n\n.tide-agent-status-toggle-outer {\n  position: absolute;\n  top: 14px;\n  left: 24px;\n  width: 50px;\n  height: 30px;\n  border-radius: 100px;\n  margin: -10px -20px;\n  overflow: hidden;\n}\n\n.tide-agent-status-toggle-outer.small {\n  height: 20px;\n  width: 35px;\n}\n\n.tide-agent-status-toggle-outer.medium {\n  height: 24px;\n  width: 44px;\n}\n\n.tide-agent-status-toggle-outer.large {\n  height: 30px;\n  width: 54px;\n}\n\n.tide-agent-status-toggle-checkbox {\n  position: absolute;\n  display: block;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  z-index: 6;\n}\n\n.tide-agent-status-toggle-checkbox:checked ~ .tide-agent-status-toggle--switch {\n  right: 2px;\n  left: 22px;\n  transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);\n  transition-property: left, right;\n  transition-delay: .05s, 0s;\n}\n\n.tide-agent-status-toggle--switch {\n  position: absolute;\n  left: 2px;\n  top: 2px;\n  bottom: 2px;\n  right: 22px;\n  border-radius: 36px;\n  z-index: 1;\n  transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);\n  transition-property: left, right;\n  transition-delay: 0s, .05s;\n  background-color: transparent;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.tide-agent-status-toggle--track {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);\n  border-radius: 40px;\n}\n\n/* Chat Limit */\n.tide-agent-status-toggle-chat-limit .tide-agent-status-toggle-checkbox:checked ~ .tide-agent-status-toggle--switch {\n  background-image: url("data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSI4IiBmaWxsPSIjRkZGQkYwIi8+CiAgICAgICAgPHBhdGggZmlsbD0iI0Y0QjgwNiIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNOC44NDIgOS43MzhINi45MjRsLS4zMzYtNi4wNzZoMi41NzZsLS4zMjIgNi4wNzZ6bS0uOTUyIDMuNDE2YTEuMzMzIDEuMzMzIDAgMCAxLTEuMzE2LTEuMzE2YzAtLjcuNjAyLTEuMzAyIDEuMzE2LTEuMzAyLjcxNCAwIDEuMzAyLjYwMiAxLjMwMiAxLjMwMiAwIC43MTQtLjU4OCAxLjMxNi0xLjMwMiAxLjMxNnoiLz4KICAgIDwvZz4KPC9zdmc+Cg==");\n}\n\n.tide-agent-status-toggle-chat-limit .tide-agent-status-toggle-checkbox:checked  ~ .tide-agent-status-toggle--track {\n  background: var(--color-s1-7);\n}\n\n.tide-agent-status-toggle-chat-limit .tide-agent-status-toggle-checkbox:checked:hover ~ .tide-agent-status-toggle--track {\n  background: var(--color-s1-8);\n}\n\n/* Available */\n.tide-agent-status-toggle-available .tide-agent-status-toggle-checkbox:checked ~ .tide-agent-status-toggle--switch {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiNGNEY5RkYiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjMDA3MUVCIiBkPSJNNC45OCA4TDMuOTIyIDkuMzZsMy41MDUgMi44MDIgNC44MDUtNS45NzktMS4zNDYtMS4wODUtMy43MzcgNC42NzZ6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=");\n}\n\n.tide-agent-status-toggle-available .tide-agent-status-toggle-checkbox:checked  ~ .tide-agent-status-toggle--track {\n  background: var(--color-p3-6);\n}\n\n.tide-agent-status-toggle-available .tide-agent-status-toggle-checkbox:checked:hover ~ .tide-agent-status-toggle--track {\n  background: var(--color-p3-7);\n}\n\n/* Away */\n.tide-agent-status-toggle-away .tide-agent-status-toggle-checkbox ~ .tide-agent-status-toggle--switch {\n  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiM2ODc4ODIiLz4KICAgICAgICA8cGF0aCBzdHJva2U9IiNENkRERTEiIHN0cm9rZS13aWR0aD0iMi4xNSIgZD0iTTQgOC42NGg4Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=");\n}\n\n.tide-agent-status-toggle-away .tide-agent-status-toggle-checkbox ~ .tide-agent-status-toggle--track {\n  background: var(--color-p1-5);\n}\n\n.tide-agent-status-toggle-away .tide-agent-status-toggle-checkbox:hover ~ .tide-agent-status-toggle--track {\n  background: var(--color-p1-6);\n}\n', ""]);
  }, function (e, t, n) {
    var r = n(163);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".user-avatar {\n  -webkit-flex-shrink: 0;\n          flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  font-family: var(--marketing-font-family--semibold);\n}\n\n/* avatar font sizes */\n.user-avatar.icon span {\n  font-size: var(--font-size-subtle);\n}\n.user-avatar.small span {\n  font-size: 24px;\n}\n.user-avatar.jumbo span {\n  font-size: var(--font-size-jumbo);\n}\n.user-avatar.mini span {\n  font-size: var(--font-size-mini);\n}\n\n/* scale avatar with border to creat inset border effect*/\n\n.withBorder .user-avatar {\n  -webkit-transform: scale(.75);\n          transform: scale(.75);\n}\n\n.avatar-image {\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n}\n\n.avatar-initials {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-align-items: center;\n          align-items: center;\n  height: 100%;\n  width: 100%;\n  border-radius: inherit;\n}\n\n.avatar-initials > span {\n  text-transform: uppercase;\n}\n\n.avatar-initials-icon {\n  height: 50%;\n  width: 50%;\n}\n\n.avatar-initials-icon path {\n  fill: white;\n}\n\n.avatar-initials .avatar-initials-text {\n  margin-top: 2px;\n}\n\n/* base style for avatar + presence dot container */\n.user-avatar-container {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-align-items: center;\n          align-items: center;\n  position: relative;\n  width: 32px;\n  height: 32px;\n  background-color: inherit;\n}\n\n.user-avatar-container.withBorder {\n  border-radius: 100%;\n}\n\n:not(.user-avatar-container) .user-avatar.icon,\n.user-avatar-container.icon {\n  width: 32px;\n  height: 32px;\n}\n\n:not(.user-avatar-container) .user-avatar.small,\n.user-avatar-container.small {\n  width: 64px;\n  height: 64px;\n}\n\n:not(.user-avatar-container) .user-avatar.jumbo,\n.user-avatar-container.jumbo {\n  width: 96px;\n  height: 96px;\n}\n\n:not(.user-avatar-container) .user-avatar.mini,\n.user-avatar-container.mini {\n  width: 24px;\n  height: 24px;\n}\n\n\n/* border colors for presence states */\n.user-avatar-container.available {\n  background-color: var(--color-p3-6);\n}\n.user-avatar-container.away {\n  background-color: var(--color-p1-10);\n}\n.user-avatar-container.chat_limit {\n  background-color: var(--color-s1-7);\n}\n\n/* grayscale treatment for away state */\n.user-avatar-container.away .user-avatar {\n  -webkit-filter: grayscale(1);\n          filter: grayscale(1);\n}\n\n\n/* presence dot outer circle base styles */\n.presence-dot-outer {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-align-items: center;\n          align-items: center;\n  height: 12px;\n  width: 12px;\n  border-radius: 50%;\n  margin-top: -2px;\n  bottom: -1px;\n  right: -1px;\n  background-color: inherit;\n  position: absolute;\n}\n\n.small + .presence-dot-outer {\n  height: 24px;\n  width: 24px;\n  bottom: -1px;\n  right: -1px;\n}\n\n.jumbo + .presence-dot-outer {\n  height: 36px;\n  width: 36px;\n  bottom: -3px;\n  right: -3px;\n}\n\n.mini + .presence-dot-outer {\n  height: 6px;\n  width: 6px;\n  bottom: 1px;\n  right: 1px;\n}\n\n/* scale dot when border present */\n.presence-dot-outer.withBorder {\n  -webkit-transform: scale(1.344);\n          transform: scale(1.344)\n}\n\n/* presence dot icon base styles */\n.presence-dot-outer > .presence-dot-inner {\n  height: 8px;\n  width: 8px;\n  transition: 500ms ease;\n}\n\n.mini + .presence-dot-outer > .presence-dot-inner {\n  height: 4px;\n  width: 4px;\n}\n\n.jumbo + .presence-dot-outer > .presence-dot-inner {\n  height: 28px;\n  width: 28px;\n}\n\n.small + .presence-dot-outer > .presence-dot-inner {\n  height: 18px;\n  width: 18px;\n}\n\n.presence-dot-inner.green {\n  border-radius: 100%;\n  background-color: var(--color-p2);\n}\n\n.presence-dot-inner.grey {\n  border-radius: 100%;\n  background-color: var(--color-p1-6);\n}\n\n/* overwrites for tide-icon svg fill behavior */\n.user-avatar-container .presence-dot-outer .tide-icon path {\n  fill: white;\n}\n.user-avatar-container.available .presence-dot-outer.withBorder .tide-icon path {\n  fill: var(--color-p3-6);\n}\n.user-avatar-container.away .presence-dot-outer.withBorder .tide-icon path {\n  fill: var(--color-p1-10);\n}\n.user-avatar-container.chat_limit .presence-dot-outer.withBorder .tide-icon path {\n  fill: var(--color-s1-7);\n}\n\n.avatar-placeholder {\n  background: var(--color-p1-8)\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(165);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-breadcrumbs-main {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n}\n\n.tide-breadcrumbs-page:last-child .tide-breadcrumbs-icon {\n  display: none;\n}\n\n.tide-breadcrumbs-page {\n  display: -webkit-flex;\n  display: flex;\n}\n\n.tide-breadcrumbs-icon {\n  margin: 14px 8px 0;\n}\n\n.tide-breadcrumbs-icon path {\n  fill: var(--color-p1-6);\n}\n\na.tide-anchor-link.tide-breadcrumbs-link {\n  color: var(--color-p1-6);\n  font-family: var(--marketing-font-family);\n  font-size: var(--font-size-subtle);\n  margin-top: 8px;\n  margin-bottom: 2px;\n  text-decoration: none;\n}\n\na.tide-anchor-link.tide-breadcrumbs-link.active {\n  pointer-events: none;\n}\n\n.tide-breadcrumbs-link:hover {\n  color: var(--color-p1);\n}\n\n.tide-breadcrumbs-name {\n  font-size: 28px;\n  color: var(--color-p1);\n  margin-bottom: 20px;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(167);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-icon-button {\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  text-decoration: none;\n  border-radius: 3px;\n  transition: all .3s ease;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  box-sizing: border-box;\n  transition: all .3s ease;\n  padding: 0;\n}\n\n.tide-icon-button[disabled],\n.tide-icon-button--disabled,\n.tide-icon-button--disabled:hover,\n.tide-icon-button--disabled:focus,\n.tide-icon-button--disabled:active  {\n  cursor: not-allowed;\n  box-shadow: none;\n  pointer-events: none;\n  border-radius: 3px;\n}\n\n.tide-icon-button[disabled],\n.tide-icon-button--disabled {\n  opacity: 0.5;\n}\n\n.tide-icon-button.small {\n  padding: 7px 6px 5px;\n  height: 24px;\n  width: 24px;\n}\n\n.tide-icon-button.small span {\n  height: 10px;\n  width: 10px;\n}\n\n.tide-icon-button.medium {\n  padding: 8px;\n  height: 32px;\n  width: 32px;\n}\n\n.tide-icon-button.large {\n  height: 40px;\n  width: 40px;\n}\n\n.tide-icon-button.large span {\n  height: 20px;\n  width: 20px;\n}\n\n.tide-icon-button svg {\n  display: inline-block;\n  max-width: 1.3em;;\n  vertical-align: top;\n}\n\n.tide-icon-button svg path {\n  fill: var(--color-p1-10);\n}\n\n.tide-icon-button.small svg {\n  height: 10px;\n  width: 10px;\n}\n\n.tide-icon-button.medium svg {\n  height: 16px;\n  width: 16px;\n}\n\n.tide-icon-button.large svg {\n  height: 20px;\n  width: 20px;\n}\n\n.tide-icon-button:focus {\n  outline: 0;\n}\n.tide-icon-button--active,\n.tide-icon-button:active {\n  outline: 0;\n}\n\n.tide-icon-button:not(.inline):hover,\n.tide-icon-button:not(.inline):focus {\n  background-color: rgba(var(--color-p1-6-a), 0.1);\n  color: var(--color-p1-10);\n}\n\n.tide-icon-button.inline {\n  border: none;\n}\n\n.tide-icon-button.inline-default:hover svg path,\n.tide-icon-button.inline-default:focus svg path {\n  fill: var(--color-p3-6);\n}\n\n.tide-icon-button.inline-subtle:hover svg path,\n.tide-icon-button.inline-subtle:focus svg path {\n  fill: var(--color-p1-7);\n}\n\n.tide-icon-button.inline-default svg path {\n  fill: var(--color-p1-10);\n}\n\n.tide-icon-button.inline-subtle svg path {\n  fill: var(--color-p1-6);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(169);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-card {\n  cursor: pointer;\n  min-width: 224px;\n  padding: 24px 16px;\n  border: 1px solid var(--color-p3-4);\n  border-radius: 3px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-align-items: center;\n          align-items: center;\n  box-shadow: var(--box-shadow-1);\n  margin: 12px;\n  transition: var(--transition-catchall-simple);\n  text-align: center;\n  background: var(--color-p1-2);\n  position: relative;\n}\n\n.tide-card--left {\n  text-align: left;\n  -webkit-align-items: start;\n          align-items: start;\n  padding: 16px 16px 24px 16px;\n}\n\n.tide-card.unselected:hover {\n  box-shadow: var(--box-shadow-2);\n  border: 1px solid var(--color-p3-5);\n  -webkit-transform: translateY(-3px);\n          transform: translateY(-3px);\n  cursor: pointer;\n}\n\n.tide-card--image {\n  width: 64px;\n  height: 64px;\n  margin-bottom: 8px;\n}\n\n.tide-card--left .tide-card--image {\n  width: 36px;\n  height: 36px;\n}\n\n.tide-card .tide-icon {\n  margin-bottom: 8px;\n}\n\n.tide-card--header,\n.tide-card--description {\n  margin: 0px;\n}\n\n.tide-card--left .tide-card--description {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  line-height: var(--main-spacing-paragraph-2);\n}\n\n.tide-card--disabled {\n  background: var(--color-p1-3);\n  -webkit-transform: none !important;\n          transform: none !important;\n  cursor: not-allowed;\n  color: var(--color-p1-6);\n  box-shadow: none;\n  border: 1px solid var(--color-p1-5);\n  transition: none !important;\n}\n\n.tide-card.unselected.tide-card--disabled:hover {\n  transition: none !important;\n  -webkit-transform: none !important;\n          transform: none !important;\n  box-shadow: none;\n  border: 1px solid var(--color-p1-5);\n}\n\n.tide-card--disabled .tide-heading-3, .tide-card--disabled .tide-paragraph {\n  color: var(--color-p1-6);\n}\n\n.tide-card--disabled .tide-icon path {\n  fill: currentColor;\n}\n\n.tide-card--upgrade-callout {\n  position: absolute;\n  top: 13px;\n  left: 10px;\n}\n\n.tide-card.selected {\n  border-color: var(--color-p3-6)\n}\n\n.tide-card.selected:hover {\n  cursor: default;\n}\n\n", ""]);
  }, function (e, t, n) {
    var r = n(171);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-card-container {\n  border: 1px solid var(--color-p1-5);\n  border-radius: 3px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  margin: 12px;\n  transition: all .2s linear;\n  background: var(--color-p1-2);\n  position: relative;\n\n  font-family: var(--marketing-font-family);\n  letter-spacing: var(--main-letter-spacing);\n  color: var(--color-p1-8);\n  font-size: var(--font-size-copy);\n  line-height: var(--main-spacing-paragraph-1);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.tide-card-container.tide-card-container-padding-small {\n  padding: 8px;\n}\n\n.tide-card-container.tide-card-container-padding-medium {\n  padding: 16px;\n}\n\n.tide-card-container.tide-card-container-padding-large {\n  padding: 24px;\n}\n\n.tide-card-container--header {\n  margin: 0;\n}\n\n.tide-content-container > .tide-card-container {\n  -webkit-align-self: stretch;\n          align-self: stretch;\n  margin: 0;\n}", ""]);
  }, function (e, t, n) {
    var r = n(173);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-callout-arrow--container {\n  position: relative;\n  max-width: -webkit-fit-content;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n}\n\n.tide-callout-arrow--image {\n  position: absolute;\n}\n\n.tide-callout-arrow--text {\n  width: 200px;\n  font-family: var(--marketing-font-family--semibold);\n}\n\n.tide-callout-arrow--image--right {\n  -webkit-transform: scaleX(-1);\n          transform: scaleX(-1);\n}\n\n.tide-callout-arrow--image--horizontal, .tide-callout-arrow--image--90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.tide-callout-arrow--image--neg90 {\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n\n.tide-callout-arrow--image--180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.tide-callout-arrow--image--neg180 {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n\n.tide-callout-arrow--image--270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.tide-callout-arrow--image--neg270 {\n  -webkit-transform: rotate(-270deg);\n          transform: rotate(-270deg);\n}\n\n.tide-callout-arrow--image--360 {\n  -webkit-transform: rotate(360deg);\n          transform: rotate(360deg);\n}\n\n.tide-callout-arrow--image--neg360 {\n  -webkit-transform: rotate(-360deg);\n          transform: rotate(-360deg);\n}\n\n.tide-callout-arrow--image--medium.tide-callout-arrow--image--left {\n  left: -44px;\n  top: -32px;\n}\n\n.tide-callout-arrow--image--medium.tide-callout-arrow--image--top { \n  left: calc(50% - 24px);\n  top: -40px;\n}\n\n.tide-callout-arrow--image--medium.tide-callout-arrow--image--right {\n  right: -19%;\n  top: -50%;\n}\n\n.tide-callout-arrow--image--medium.tide-callout-arrow--image--bottom { \n  bottom: -48px;\n  left: calc(50% - 16px);\n}\n\n.tide-callout-arrow--image--large.tide-callout-arrow--image--left { \n  left: -80px;\n  top: -85px;\n}\n\n.tide-callout-arrow--image--large.tide-callout-arrow--image--top { \n  left: calc(50% - 36px);\n  top: -85px;\n}\n\n.tide-callout-arrow--image--large.tide-callout-arrow--image--right {\n  right: -40%;\n  top: -78%;\n}\n\n.tide-callout-arrow--image--large.tide-callout-arrow--image--bottom { \n  bottom: -105px;\n  left: calc(50% - 36px);\n}\n", ""]);
  }, function (e, t) {
    !function (e) {
      var t = e.util.clone(e.languages.javascript);
      e.languages.jsx = e.languages.extend("markup", t), e.languages.jsx.tag.pattern = /<\/?(?:[\w.:-]+\s*(?:\s+(?:[\w.:-]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s{'">=]+|\{(?:\{(?:\{[^}]*\}|[^{}])*\}|[^{}])+\}))?|\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}))*\s*\/?)?>/i, e.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/i, e.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">]+)/i, e.languages.insertBefore("inside", "attr-name", {
        spread: {
          pattern: /\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}/,
          inside: {
            punctuation: /\.{3}|[{}.]/,
            "attr-value": /\w+/
          }
        }
      }, e.languages.jsx.tag), e.languages.insertBefore("inside", "attr-value", {
        script: {
          pattern: /=(\{(?:\{(?:\{[^}]*\}|[^}])*\}|[^}])+\})/i,
          inside: {
            "script-punctuation": {
              pattern: /^=(?={)/,
              alias: "punctuation"
            },
            rest: e.languages.jsx
          },
          alias: "language-javascript"
        }
      }, e.languages.jsx.tag);

      var n = function stringifyToken(e) {
        return e ? "string" === typeof e ? e : "string" === typeof e.content ? e.content : e.content.map(stringifyToken).join("") : "";
      };

      e.hooks.add("after-tokenize", function (t) {
        "jsx" !== t.language && "tsx" !== t.language || function walkTokens(t) {
          for (var r = [], i = 0; i < t.length; i++) {
            var a = t[i],
                o = !1;

            if ("string" !== typeof a && ("tag" === a.type && a.content[0] && "tag" === a.content[0].type ? "</" === a.content[0].content[0].content ? r.length > 0 && r[r.length - 1].tagName === n(a.content[0].content[1]) && r.pop() : "/>" === a.content[a.content.length - 1].content || r.push({
              tagName: n(a.content[0].content[1]),
              openedBraces: 0
            }) : r.length > 0 && "punctuation" === a.type && "{" === a.content ? r[r.length - 1].openedBraces++ : r.length > 0 && r[r.length - 1].openedBraces > 0 && "punctuation" === a.type && "}" === a.content ? r[r.length - 1].openedBraces-- : o = !0), (o || "string" === typeof a) && r.length > 0 && 0 === r[r.length - 1].openedBraces) {
              var s = n(a);
              i < t.length - 1 && ("string" === typeof t[i + 1] || "plain-text" === t[i + 1].type) && (s += n(t[i + 1]), t.splice(i + 1, 1)), i > 0 && ("string" === typeof t[i - 1] || "plain-text" === t[i - 1].type) && (s = n(t[i - 1]) + s, t.splice(i - 1, 1), i--), t[i] = new e.Token("plain-text", s, null, s);
            }

            a.content && "string" !== typeof a.content && walkTokens(a.content);
          }
        }(t.tokens);
      });
    }(Prism);
  }, function (e, t, n) {
    var r = n(176);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".code-block--monokai code,\n.code-block--monokai pre {\n  color: #f8f8f2;\n  text-shadow: 0 1px rgba(0, 0, 0, 0.3);\n  font-family: var(--code-font-family);\n  direction: ltr;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  line-height: 1.5;\n\n  -moz-tab-size: 4;\n  tab-size: 4;\n\n  -webkit-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n}\n\n.code-block--monokai pre {\n  padding: 1em;\n  margin: .5em 0;\n  overflow: auto;\n  border-radius: 0.3em;\n}\n\n:not(pre) > .code-block--monokai code,\n.code-block--monokai pre {\n  background: #252525;\n}\n\n:not(pre) > .code-block--monokai code {\n  padding: .1em;\n  border-radius: .3em;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: #778090;\n}\n\n.token.punctuation {\n  color: #F8F8F2;\n}\n\n.namespace {\n  opacity: .7;\n}\n\n.token.property,\n.token.tag,\n.token.constant,\n.token.symbol,\n.token.deleted {\n  color: #F92672;\n}\n\n.token.boolean,\n.token.number {\n  color: #AE81FF;\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n  color: #A6E22E;\n}\n\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string,\n.token.variable {\n  color: #F8F8F2;\n}\n\n.token.atrule,\n.token.attr-value,\n.token.function {\n  color: #E6DB74;\n}\n\n.token.keyword {\n  color: #F92672;\n}\n\n.token.regex,\n.token.important {\n  color: #FD971F;\n}\n\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n.token.italic {\n  font-style: italic;\n}\n\n.token.entity {\n  cursor: help;\n}", ""]);
  }, function (e, t, n) {
    var r = n(178);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-fingerguntooltip.normal {\n  font-size: 14px;\n  line-height: 24px;\n  color: var(--color-p1-9);\n}\n\n.tide-fingerguntooltip.small {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--color-p1-7);\n}\n\n.tide-fingerguntooltip-emoji {\n  padding-right: 4px;\n}", ""]);
  }, function (e, t, n) {
    var r = n(180);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-checkbox {\n  cursor: pointer;\n  display: -webkit-flex;\n  display: flex;\n}\n\n.tide-checkbox-input {\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--color-p3-4);\n  background-color: white;\n  border-radius: 3px;\n  display: inline-block;\n  transition: border-color 0.3s ease, background-color 0.3s ease;\n}\n\n.doc-page .tide-checkbox p {\n  margin: auto;\n}\n\n.tide-checkbox-input:hover {\n  border: 1px solid var(--color-p3-5);\n}\n\n.tide-checkbox-input--checked {\n  background-color: var(--color-p3-6);\n  border: 1px solid var(--color-p3-6);\n  background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxM3B4IiBoZWlnaHQ9IjEwcHgiIHZpZXdCb3g9IjAgMCAxMyAxMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gIDxnIGlkPSJzdWJtaXQtIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgPGcgaWQ9ImFjY291bnR0YS1ibGUtY29weS04IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDMzLjAwMDAwMCwgLTEwNzIuMDAwMDAwKSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0iIzAwMDAwMCI+ICAgICAgPGcgaWQ9IkNoZWNrZWQtQ29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDMyLjAwMDAwMCwgMTA2OS4wMDAwMDApIj4gICAgICAgIDxwYXRoIGQ9Ik02LjE3NjU3OTU2LDExLjcyMTAwMiBDNi4wNjk4NTk1NiwxMS43MjEwMDIgNS45NjcyMjg0NSwxMS42NzkwMzcxIDUuODkxMTc1MTIsMTEuNjA0NzkxNSBMMi42MjAwNjQwMSw4LjM5NTI4MjY5IEMyLjQ2MTAwNjIzLDguMjM5MTI0OCAyLjQ1OTc3OTU2LDcuOTg1MzE3NzggMi42MTc2MTA2Nyw3LjgyNzk0OTM2IEMyLjc3NTAzMjksNy42NzA1ODA5NCAzLjAzMTgxNTEyLDcuNjY5NzczOTIgMy4xOTEyODE3OCw3LjgyNTUyODMxIEw2LjE1NTMxNzM0LDEwLjczMzYxNiBMMTEuNTIxNTc1MSw0LjYzNzgwOTAxIEMxMS42Njc5NTczLDQuNDcwNzU2MzggMTEuOTI0MzMwNyw0LjQ1MzAwMTk5IDEyLjA5MzYxMDcsNC41OTg2Njg2NiBDMTIuMjYyNDgxOCw0Ljc0NDMzNTMzIDEyLjI4MDA2NCw0Ljk5NzczODgzIDEyLjEzMjg2NCw1LjE2NDc5MTQ3IEw2LjQ4MjQyODQ1LDExLjU4MzAwMiBDNi40MDg4Mjg0NSwxMS42NjY5MzE4IDYuMzAzNzQ0MDEsMTEuNzE2NTYzNCA2LjE5MTcwODQ1LDExLjcyMDU5ODUgQzYuMTg2ODAxNzgsMTEuNzIxMDAyIDYuMTgxODk1MTIsMTEuNzIxMDAyIDYuMTc2NTc5NTYsMTEuNzIxMDAyIFoiIGlkPSJTaGFwZS1Db3B5LTciPiAgICAgICAgPC9wYXRoPiAgICAgIDwvZz4gICAgPC9nPiAgPC9nPjwvc3ZnPg==);\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.tide-checkbox-input--checked:hover {\n  background-color: var(--color-p3-7);\n  border: 1px solid var(--color-p3-7);\n}\n\n.tide-checkbox--label {\n  display: inline-block;\n  width: auto;\n  margin: 0 0 0 8px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.tide-checkbox-input--disabled,\n.tide-checkbox-input--disabled:hover {\n  background-color: var(--color-p1-3);\n  border: 1px solid var(--color-p1-5);\n  cursor: auto;\n}\n\n\n.tide-checkbox-input--checked.tide-checkbox-input--disabled,\n.tide-checkbox-input--checked.tide-checkbox-input--disabled:hover {\n  background-color: var(--color-p1-5);\n  border: 1px solid var(--color-p1-5);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(182);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, '.tide-controlled-inline-input--input-field input.tide-input[type="text"],\n.tide-controlled-inline-input--input-field input.tide-input[type="text"]:focus,\n.tide-controlled-inline-input--input-field input.tide-input[type="text"]:hover,\n.tide-controlled-inline-input--input-field input.tide-input[type="text"]:active {\n  border: none;\n  -webkit-flex: 1 1;\n          flex: 1 1;\n}\n\n.tide-controlled-inline-input--input-field {\n  -webkit-align-items: center;\n          align-items: center;\n  border: 1px solid var(--color-p3-4);\n  border-radius: 3px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n}\n\n.tide-controlled-inline-input--input-field:hover {\n  border-color: var(--color-p3-5);\n}\n\n.tide-controlled-inline-input--input-field.active {\n  border-color: var(--color-p3);\n}\n\n.tide-controlled-inline-input--controlled-actions .controlled-action {\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.tide-controlled-inline-input--controlled-actions .controlled-action.small {\n  padding: 4px;\n}\n\n.tide-controlled-inline-input--controlled-actions .controlled-action.small svg {\n  height: 8px;\n  width: 14px;\n}\n\n.tide-controlled-inline-input--controlled-actions .controlled-action.medium,\n.tide-controlled-inline-input--controlled-actions .controlled-action.large {\n  padding: 6px;\n}\n\n.tide-controlled-inline-input--controlled-actions .controlled-action.medium svg,\n.tide-controlled-inline-input--controlled-actions .controlled-action.large svg {\n  height: 10px;\n  width: 16px;\n}\n\n.tide-controlled-inline-input--input-field .controlled-action--save {\n  border: 1px solid transparent;\n  background-color: var(--color-p3-6);\n}\n\n.tide-controlled-inline-input--input-field .controlled-action--save.disable {\n  border: 1px solid var(--color-p1-5);\n  background-color: var(--color-p1-3);\n  pointer-events: none;\n}\n\n.tide-controlled-inline-input--input-field .controlled-action--save.disable svg path {\n  fill: var(--color-p1-5);\n}\n\n.tide-controlled-inline-input--input-field .controlled-action--save:hover {\n  background-color: var(--color-p3-7);\n}\n\n.tide-controlled-inline-input--input-field .controlled-action--cancel {\n  border: 1px solid var(--color-p1-5);\n  margin: 0 2px;\n}\n\n.tide-controlled-inline-input--input-field .controlled-action--cancel:hover {\n  border: 1px solid var(--color-p1-5-5);\n  background-color: var(--color-p1-3);\n}\n\n.tide-controlled-inline-input--input-field .controlled-action--save svg path {\n  fill: var(--main-white);\n}\n', ""]);
  }, function (e, t, n) {
    var r = n(184);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-controlled-inline-input--link {\n  -webkit-align-items: center;\n          align-items: center;\n  border: 1px solid var(--color-p3-4);\n  border-radius: 3px;\n  display: -webkit-inline-flex;\n  display: inline-flex;\n}\n\n.tide-controlled-inline-input--link:hover,\n.tide-controlled-inline-input--link:hover .tide-controlled-inline-input--link__leading-text {\n  border-color: var(--color-p3-5);\n}\n\n.tide-controlled-inline-input--link.active,\n.tide-controlled-inline-input--link.active .tide-controlled-inline-input--link__leading-text {\n  border-color: var(--color-p3);\n}\n\n.tide-controlled-inline-input--link__leading-text.small {\n  line-height: 1;\n  padding: 8px;\n}\n\n.tide-controlled-inline-input--link__leading-text.medium {\n  line-height: var(--main-spacing-heading-5);\n  padding: 8px;\n}\n\n.tide-controlled-inline-input--link__leading-text.large {\n  line-height: var(--main-spacing-heading-5);\n  padding: 12px 12px 12px 8px;\n  font-size: 16px;\n}\n\n.tide-controlled-inline-input--link__leading-text {\n  background: var(--color-p3-2);\n  border-bottom-left-radius: 3px;\n  border-right: 1px solid var(--color-p3-4);\n  border-top-left-radius: 3px;\n  color: var(--color-p1-10);\n  padding: 5px 8px;\n}\n\n\n.tide-controlled-inline-input--editing-wrapper.tide-controlled-inline-input--editing-link .tide-controlled-inline-input--input-field {\n  border: none;\n}\n\n.tide-controlled-inline-input--link {\n  -webkit-animation: link-slide-in 350ms ease forwards;\n          animation: link-slide-in 350ms ease forwards;\n}\n\n\n@-webkit-keyframes link-slide-in {\n  from {\n    -webkit-transform: translateX(-12px);\n            transform: translateX(-12px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n\n\n@keyframes link-slide-in {\n  from {\n    -webkit-transform: translateX(-12px);\n            transform: translateX(-12px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(186);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-controlled-inline-input--row .tide-heading {\n  margin-top: 0;\n  line-height: normal;\n}\n\n.tide-controlled-inline-input--row .tide-heading-6 {\n  margin-top: 4px;\n}\n\n.tide-controlled-inline-input--editing-wrapper.tide-controlled-inline-input--editing-heading .tide-input,\n.tide-controlled-inline-input--row--heading .tide-controlled-inline-input--row--heading-input .tide-input {\n  font-family: var(--marketing-font-family--semibold);\n}\n\n.tide-controlled-inline-input--editing-heading .tide-controlled-inline-input--input-field .tide-input {\n  letter-spacing: var(--main-letter-spacing);\n  padding: 8px;\n}\n\n.editing-heading--h1 .tide-controlled-inline-input--input-field .tide-input {\n  font-size: var(--font-size-large);\n  padding: 4px;\n}\n\n.editing-heading--h2 .tide-controlled-inline-input--input-field .tide-input {\n  font-size: 24px;\n  padding: 4px;\n}\n\n.editing-heading--h3 .tide-controlled-inline-input--input-field .tide-input {\n  font-size: 20px;\n  padding: 6px;\n}\n\n.editing-heading--h4 .tide-controlled-inline-input--input-field .tide-input {\n  font-size: var(--font-size-small);\n  padding: 6px;\n}\n\n.editing-heading.editing-heading--h5 .tide-controlled-inline-input--input-field,\n.editing-heading.editing-heading--h6 .tide-controlled-inline-input--input-field {\n  height: 30px;\n}\n\n.editing-heading--h5 .tide-controlled-inline-input--input-field .tide-input {\n  font-size: var(--font-size-copy);\n}\n\n.editing-heading--h6 .tide-controlled-inline-input--input-field .tide-input {\n  font-size: var(--font-size-subtle);\n  letter-spacing: var(--main-letter-spacing--loose);\n  text-transform: uppercase;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(188);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-controlled-inline-input--row {\n  -webkit-align-items: center;\n          align-items: center;\n  border-bottom: 1px dotted transparent;\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  color: var(--color-p1-8);\n  cursor: text;\n  min-height: 30px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: border-bottom 100ms ease-out;\n  white-space: nowrap;\n}\n\n.tide-controlled-inline-input--row:hover {\n  border-bottom: 1px dotted var(--color-p1-9);\n  color: var(--color-p1-9);\n}\n\n.tide-controlled-inline-input--icon-wrapper {\n  cursor: pointer;\n  margin-left: 16px;\n}\n\n.tide-controlled-inline-input--icon-wrapper svg path {\n  fill: var(--color-p1-8);\n}\n\n.tide-controlled-inline-input--row {\n  -webkit-animation: tide-inline-editor--slide-out 250ms ease forwards;\n          animation: tide-inline-editor--slide-out 250ms ease forwards;\n}\n\n.tide-controlled-inline-input--editing-wrapper {\n  -webkit-animation: tide-inline-editor--slide-in 250ms ease forwards;\n          animation: tide-inline-editor--slide-in 250ms ease forwards;\n}\n\n@-webkit-keyframes tide-inline-editor--slide-out {\n  from {\n    -webkit-transform: translateX(4px);\n            transform: translateX(4px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n\n@keyframes tide-inline-editor--slide-out {\n  from {\n    -webkit-transform: translateX(4px);\n            transform: translateX(4px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n\n@-webkit-keyframes tide-inline-editor--slide-in {\n  from {\n    -webkit-transform: translateX(-4px);\n            transform: translateX(-4px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n\n@keyframes tide-inline-editor--slide-in {\n  from {\n    -webkit-transform: translateX(-4px);\n            transform: translateX(-4px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(190);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, '.tide-inline-editor input.tide-input,\n.tide-inline-editor input.tide-input[type="text"]:focus,\n.tide-inline-editor input.tide-input[type="text"]:hover,\n.tide-inline-editor input.tide-input[type="text"]:active {\n  border: none;\n}\n\n\n.tide-inline-editor--loading:after {\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  right: calc(50% - 20px);\n  top: calc(50% - 23px);\n  display: block;\n  content: \'\';\n  border-radius: 50%;\n  border: 3px solid var(--color-p3-4);\n  border-right-color: transparent;\n  background: none;\n  -webkit-animation: rotating .6s ease infinite;\n          animation: rotating .6s ease infinite;\n  -webkit-animation-delay: .4s;\n          animation-delay: .4s;\n  color: rgba(0,0,0,0);\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n\n@-webkit-keyframes rotating {\n  from {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes rotating {\n  from {\n    -webkit-transform: rotate(0);\n            transform: rotate(0);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n.tide-inline-editor--row {\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  -webkit-align-items: center;\n          align-items: center;\n  color: var(--color-p1-8);\n  padding: 9px 0 8px;\n  border-bottom: 1px dotted transparent;\n  transition: border-bottom 100ms ease-out, padding-left 100ms ease;\n  will-change: padding;\n  cursor: text;\n}\n\n.tide-inline-editor--link .tide-inline-editor--row {\n  padding: 0;\n}\n\n.tide-inline-editor--link .tide-inline-editor--link--anchor {\n  padding-top: 7px;\n  padding-bottom: 5px;\n}\n\n.tide-inline-editor:not(.tide-inline-editor--is-editing):not(.tide-inline-editor--loading) .tide-inline-editor--row:hover {\n  border-bottom: 1px dotted var(--color-p1-9);\n  color: var(--color-p1-9);\n}\n\n.tide-inline-editor--row .tide-icon.tide-inline-editor--icon path {\n  fill: var(--color-p1-8);\n}\n\n.tide-inline-editor--row:hover .tide-icon.tide-inline-editor--icon path {\n  fill: var(--color-p1-9);\n}\n\n.tide-inline-editor--icon-wrapper {\n  padding-left: 8px;\n  cursor: pointer;\n}\n\n.tide-inline-editor--link-editing {\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  -webkit-align-items: center;\n          align-items: center;\n  border: 1px solid var(--color-p3-6);\n  border-radius: 3px;\n}\n\n.tide-inline-editor--editing-wrapper.invalid,\n.tide-inline-editor--editing-wrapper.invalid .tide-inline-editor--input-prompt {\n  border-color: var(--color-s3-6);\n}\n\n.tide-inline-editor .tide-inline-editor--editing-wrapper {\n  -webkit-animation: tide-inline-editor--slide-in 150ms ease forwards;\n          animation: tide-inline-editor--slide-in 150ms ease forwards;\n}\n\n.tide-inline-editor--has-ever-finished-editing .tide-inline-editor--row {\n  -webkit-animation: tide-inline-editor--slide-out 150ms ease forwards;\n          animation: tide-inline-editor--slide-out 150ms ease forwards;\n}\n\n@-webkit-keyframes tide-inline-editor--slide-out {\n  from {\n    -webkit-transform: translateX(8px);\n            transform: translateX(8px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n\n@keyframes tide-inline-editor--slide-out {\n  from {\n    -webkit-transform: translateX(8px);\n            transform: translateX(8px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n\n@-webkit-keyframes tide-inline-editor--slide-in {\n  from {\n    -webkit-transform: translateX(-8px);\n            transform: translateX(-8px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n\n@keyframes tide-inline-editor--slide-in {\n  from {\n    -webkit-transform: translateX(-8px);\n            transform: translateX(-8px);\n  }\n  to {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n  }\n}\n\n.tide-inline-editor--input-prompt.large {\n  line-height: var(--main-spacing-heading-5);\n  padding: 12px 12px 12px 8px;\n}\n\n.tide-inline-editor--input-prompt.medium {\n  line-height: var(--main-spacing-heading-5);\n  padding: 8px;\n}\n\n.tide-inline-editor--input-prompt {\n  background: var(--color-p3-2);\n  padding: 5px 8px;\n  color: var(--color-p1-10);\n  border-right: 1px solid var(--color-p3-6);\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.tide-inline-editor--input-container .tide-inline-editor--link-input .tide-input {\n  border: none;\n}\n\n.tide-inline-editor .tide-inline-editor--link--inactive {\n  color: var(--color-p1-8);\n}\n\n.tide-inline-editor:hover .tide-inline-editor--link--inactive {\n  color: var(--color-p1-9);\n  cursor: text;\n}\n\n.tide-inline-editor .tide-heading {\n  margin-top: 0;\n}\n\n.tide-inline-editor--heading .tide-inline-editor--heading-input .tide-input {\n  font-family: var(--marketing-font-family--semibold);\n}\n\n.tide-inline-editor--heading .tide-inline-editor--heading-input-h1 .tide-input {\n  line-height: var(--main-spacing-heading-1);\n  font-size: var(--font-size-large);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-inline-editor--heading .tide-inline-editor--heading-input-h2 .tide-input {\n  line-height: var(--main-spacing-heading-2);\n  font-size: 24px;\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-inline-editor--heading .tide-inline-editor--heading-input-h3 .tide-input {\n  line-height: var(--main-spacing-heading-3);\n  font-size: 20px;\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-inline-editor--heading .tide-inline-editor--heading-input-h4 .tide-input {\n  line-height: var(--main-spacing-heading-4);\n  font-size: var(--font-size-small);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-inline-editor--heading .tide-inline-editor--heading-input-h5 .tide-input {\n  line-height: var(--main-spacing-heading-5);\n  font-size: var(--font-size-copy);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-inline-editor--heading .tide-inline-editor--heading-input-h6 .tide-input {\n  line-height: var(--main-spacing-heading-6);\n  font-size: var(--font-size-subtle);\n  letter-spacing: var(--main-letter-spacing--loose);\n  text-transform: uppercase;\n}\n', ""]);
  }, function (e, t, n) {
    var r = n(192);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, 'input.tide-input[type="text"],\ninput.tide-input[type="password"],\ninput.tide-input[type="email"],\ninput.tide-input[type="url"],\ninput.tide-input[type="date"],\ninput.tide-input[type="month"],\ninput.tide-input[type="time"],\ninput.tide-input[type="datetime"],\ninput.tide-input[type="datetime-local"],\ninput.tide-input[type="week"],\ninput.tide-input[type="number"],\ninput.tide-input[type="search"],\ninput.tide-input[type="tel"],\ninput.tide-input[type="color"],\nselect.tide-select,\ntextarea.tide-input {\n  font-family: var(--marketing-font-family);\n  padding: 8px;\n  display: inline-block;\n  color: var(--color-p1);\n  border: 1px solid var(--color-p3-4);\n  background-color: var(--color-p1-2);\n  border-radius: 3px;\n  vertical-align: middle;\n  box-sizing: border-box;\n  font-size: 14px;\n  transition: all .2s ease-in;\n  line-height: var(--main-spacing-heading-5);\n}\n\ninput.tide-input[type="search"] {\n  -webkit-appearance: button;\n}\n\ninput.tide-input.small {\n  line-height: 1;\n}\n\ninput.tide-input.medium{\n  line-height: var(--main-spacing-heading-5);\n}\n\ninput.tide-input.large{\n  line-height: var(--main-spacing-heading-5);\n  padding: 12px 12px 12px 8px;\n  font-size: 16px;\n}\n\n.tide-input--no-label {\n  display: inline-block;\n}\n\ninput.tide-input[type="text"]:hover,\ninput.tide-input[type="password"]:hover,\ninput.tide-input[type="email"]:hover,\ninput.tide-input[type="url"]:hover,\ninput.tide-input[type="date"]:hover,\ninput.tide-input[type="month"]:hover,\ninput.tide-input[type="time"]:hover,\ninput.tide-input[type="datetime"]:hover,\ninput.tide-input[type="datetime-local"]:hover,\ninput.tide-input[type="week"]:hover,\ninput.tide-input[type="number"]:hover,\ninput.tide-input[type="search"]:hover,\ninput.tide-input[type="tel"]:hover,\ninput.tide-input[type="color"]:hover,\nselect.tide-select:hover,\ntextarea.tide-input:hover {\n  border-color: var(--color-p3-5);\n}\n\ninput.tide-input[type="text"]:focus,\ninput.tide-input[type="password"]:focus,\ninput.tide-input[type="email"]:focus,\ninput.tide-input[type="url"]:focus,\ninput.tide-input[type="date"]:focus,\ninput.tide-input[type="month"]:focus,\ninput.tide-input[type="time"]:focus,\ninput.tide-input[type="datetime"]:focus,\ninput.tide-input[type="datetime-local"]:focus,\ninput.tide-input[type="week"]:focus,\ninput.tide-input[type="number"]:focus,\ninput.tide-input[type="search"]:focus,\ninput.tide-input[type="tel"]:focus,\ninput.tide-input[type="color"]:focus,\nselect.tide-select:focus,\ntextarea.tide-input:focus {\n  outline: 0;\n  border-color: var(--color-p3);\n}\n\ninput.tide-input::-webkit-input-placeholder {\n  color: var(--color-p1-5);\n}\n\ninput.tide-input:-moz-placeholder {\n  color: var(--color-p1-5);\n}\n\ninput.tide-input::-moz-placeholder {\n  color: var(--color-p1-5);\n}\n\ninput.tide-input:-ms-input-placeholder {\n  color: var(--color-p1-5);\n}\n\ninput.tide-input[type="file"]:focus,\ninput.tide-input[type="radio"]:focus,\ninput.tide-input[type="checkbox"]:focus {\n  outline: thin solid var(--color-p3-6);\n  outline: 1px auto var(--color-p3-6);\n}\n\n.tide-radio {\n  margin: 0.5em 0;\n  display: block;\n}\n\ninput.tide-input[type="radio"] {\n  background-color: var(--color-p1-2);\n  border: 1px solid var(--color-p3-4);\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 0 var(--color-p3);\n  cursor: pointer;\n  font: inherit;\n  height: 1em;\n  width: 1em;\n  outline: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n\ninput.tide-input[type="radio"]:checked,\ninput.tide-input[type="radio"]:checked:hover {\n  background-color: var(--color-p3);\n  box-shadow: inset 0 0 0 .1em var(--color-p1-2);\n  transition: background .15s, box-shadow .1s;\n  border: 1px solid var(--color-p3);\n}\n\ninput.tide-input[type="radio"]:hover {\n  border: 1px solid var(--color-p3-5);\n}\n\ninput.tide-input[type="radio"]:checked,\ninput.tide-input[type="radio"]:focus,\ninput.tide-input[type="radio"]:active {\n  outline: none;\n}\n\ninput.tide-input:disabled,\ninput.tide-input[type="text"][disabled],\ninput.tide-input[type="password"][disabled],\ninput.tide-input[type="email"][disabled],\ninput.tide-input[type="url"][disabled],\ninput.tide-input[type="date"][disabled],\ninput.tide-input[type="month"][disabled],\ninput.tide-input[type="time"][disabled],\ninput.tide-input[type="datetime"][disabled],\ninput.tide-input[type="datetime-local"][disabled],\ninput.tide-input[type="week"][disabled],\ninput.tide-input[type="number"][disabled],\ninput.tide-input[type="search"][disabled],\ninput.tide-input[type="tel"][disabled],\ninput.tide-input[type="color"][disabled],\nselect.tide-select[disabled],\ntextarea.tide-input[disabled] {\n  cursor: not-allowed;\n  background-color: var(--color-p1-3);\n  border: 1px solid var(--color-p1-5);\n  color: var(--color-p1-5);\n}\n\ninput.tide-input[readonly],\nselect.tide-select[readonly],\ntextarea.tide-input[readonly] {\n  background-color: var(--main-navy-extra-light);\n  color: var(--main-navy);\n}\n\ninput.tide-input:focus:invalid,\ntextarea.tide-input:focus:invalid,\nselect.tide-select:focus:invalid,\ninput.tide-input.tide-input--invalid:focus,\ntextarea.tide-input.tide-input--invalid:focus,\nselect.tide-select.tide-input--invalid:focus {\n  border-color: var(--color-s3-6);\n}\n\ninput.tide-input[type="file"]:focus:invalid:focus,\ninput.tide-input[type="radio"]:focus:invalid:focus,\ninput.tide-input[type="checkbox"]:focus:invalid:focus {\n  outline-color: var(--color-s3-6);\n}\n\ninput.tide-input.tide-input--invalid,\ntextarea.tide-input.tide-input--invalid,\nselect.tide-input.tide-select--invalid {\n  border-color: var(--color-s3-6);\n}\n\n.tide-input--error {\n  font-family: var(--marketing-font-family--semibold);\n  color: var(--color-s3-6);\n  font-size: var(--font-size-subtle);\n  display: block;\n  margin-top: 5px;\n  line-height: var(--main-spacing-paragraph-2);\n}\n\nselect.tide-select {\n  height: 2.5em;\n  background-color: var(--color-p1-2);\n}\n\nselect.tide-select[multiple] {\n  height: auto;\n}\n\n.tide-input.medium ~ .tide-input--description,\n.tide-input.large ~ .tide-input--description {\n  margin-top: 5px;\n}\n\nlabel input.tide-input[type="text"],\nlabel input.tide-input[type="password"],\nlabel input.tide-input[type="email"],\nlabel input.tide-input[type="url"],\nlabel input.tide-input[type="date"],\nlabel input.tide-input[type="month"],\nlabel input.tide-input[type="time"],\nlabel input.tide-input[type="datetime"],\nlabel input.tide-input[type="datetime-local"],\nlabel input.tide-input[type="week"],\nlabel input.tide-input[type="number"],\nlabel input.tide-input[type="search"],\nlabel input.tide-input[type="tel"],\nlabel input.tide-input[type="color"],\nlabel .tide-select.Select,\nlabel textarea.tide-input {\n  display: block;\n  margin: 8px 0 0 0;\n}\n\n.tide-form fieldset {\n  margin: 0 0 20px 0;\n  padding: 0;\n  border: 0;\n}\n\n.tide-form fieldset:last-child {\n  margin:0;\n}\n\n.tide-form fieldset > *:not(legend){\n  margin: 0 5px;\n}\n\n.tide-form fieldset > *:not(legend):first-child {\n  margin: 0 5px 0 0;\n}\n\n.tide-form fieldset > *:not(legend):not(:first-child):last-child{\n  margin: 0 0 0 5px;\n}\n\n.tide-form fieldset legend {\n  display: block;\n  width: 100%;\n  padding: 0.3em 0;\n  margin-bottom: 0.3em;\n  color: var(--main-navy-extra-dark);\n  border-bottom: 1px solid var(--main-navy);\n}\n\n\n input.tide-input[type=range] {\n  -webkit-appearance: none;\n  width: 100%;\n}\n\n input.tide-input[type=range]:focus {\n  outline: none;\n}\n\n input.tide-input[type=range]::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 10px;\n  cursor: pointer;\n  animate: 0.2s;\n  box-shadow: 0px 0px 0px var(--main-navy-light), 0px 0px 0px var(--main-navy-light);\n  background-color: var(--main-navy-light);\n  border-radius: 25px;\n  border: 0px solid var(--main-navy-light);\n}\n\n input.tide-input[type=range]::-webkit-slider-thumb {\n  box-shadow: 0px 0px 0px var(--color-p2-6), 0px 0px 0px var(--color-p2-6);\n  border: 0px solid var(--color-p2-6);\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  background-color: var(--color-p2-6);\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -6px;\n}\n\n input.tide-input[type=range][disabled]::-webkit-slider-thumb,\n input.tide-input[type=range].tide-disabled::-webkit-slider-thumb {\n  background-color: var(--main-navy);\n}\n\n input.tide-input[type=range]:focus::-webkit-slider-runnable-track {\n  background-color: var(--main-navy-light);\n}\n\n input.tide-input[type=range]::-moz-range-track {\n  width: 100%;\n  height: 10px;\n  cursor: pointer;\n  animate: 0.2s;\n  box-shadow: 0px 0px 0px var(--main-navy-light), 0px 0px 0px var(--main-navy-light);\n  background-color: var(--main-navy-light);\n  border-radius: 24px;\n  border: 0px solid var(--main-navy-light);\n}\n\n input.tide-input[type=range]::-moz-range-thumb {\n  box-shadow: 0px 0px 0px var(--color-p2-6), 0px 0px 0px var(--color-p2-6);\n  border: 0px solid var(--color-p2-6);\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  background-color: var(--color-p2-6);\n  cursor: pointer;\n}\n\n input.tide-input[type=range][disabled]::-moz-range-thumb,\n input.tide-input[type=range].tide-disabled::-moz-range-thumb {\n  background-color: var(--main-navy);\n}\n\n input.tide-input[type=range]::-ms-track {\n  width: 100%;\n  height: 10px;\n  cursor: pointer;\n  animate: 0.2s;\n  background-color: transparent;\n  border-color: transparent;\n  border-width: 24px 0;\n  color: transparent;\n}\n\n input.tide-input[type=range]::-ms-fill-lower {\n  background-color: var(--main-navy-light);\n  border: 0px solid var(--main-navy-light);\n  border-radius: 50px;\n  box-shadow: 0px 0px 0px var(--main-navy-light), 0px 0px 0px var(--main-navy-light);\n}\n\n input.tide-input[type=range]::-ms-fill-upper {\n  background-color: var(--main-navy-light);\n  border: 0px solid var(--main-navy-light);\n  border-radius: 50px;\n  box-shadow: 0px 0px 0px var(--main-navy-light), 0px 0px 0px var(--main-navy-light);\n}\n\n input.tide-input[type=range]::-ms-thumb {\n  box-shadow: 0px 0px 0px var(--color-p2-6), 0px 0px 0px var(--color-p2-6);\n  border: 0px solid var(--color-p2-6);\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  background-color: var(--color-p2-6);\n  cursor: pointer;\n}\n\n input.tide-input[type=range][disabled]::-ms-thumb,\n input.tide-input[type=range].tide-disabled::-ms-thumb {\n  background-color: var(--main-navy);\n}\n\n input.tide-input[type=range]:focus::-ms-fill-lower {\n  background-color: var(--main-navy-light);\n}\n\n input.tide-input[type=range]:focus::-ms-fill-upper {\n  background-color: var(--main-navy-light);\n}\n\n.icon-input {\n  position: relative;\n  display: block;\n}\n\n.icon-input .tide-icon {\n  position: absolute;\n  top: 7px;\n  left: 10px;\n}\n\n.icon-input .tide-icon path {\n  fill: var(--main-navy-dark);\n}\n\n.icon-input.small .tide-icon {\n  top: 3px;\n}\n\n.icon-input.large .tide-icon {\n  top: 10px;\n}\n\n.icon-input input.tide-input {\n  padding-left: 30px;\n}\n\n.raw-input {\n  display: block;\n}\n\n.raw-input input {\n  display: block;\n  width: 100%;\n}\n\n.prefix-text-wrapper,\n.postfix-text-wrapper {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-grow: 1;\n          flex-grow: 1;\n  -webkit-align-content: stretch;\n          align-content: stretch;\n  -webkit-align-items: center;\n          align-items: center;\n  border-radius: 3px;\n  background-color: var(--color-p3-2);\n  border: 1px solid var(--color-p3-4);\n  font-size: 14px;\n}\n\n.prefix-text-wrapper:hover, .postfix-text-wrapper:hover  {\n  border: 1px solid var(--color-p3-5);\n  cursor: pointer;\n}\n\n.prefix-text-wrapper:focus-within, .postfix-text-wrapper:focus-within {\n  border: 1px solid var(--color-p3-6);\n  cursor: pointer;\n}\n\n.prefix-text-wrapper input[type=\'text\']:hover,\n.postfix-text-wrapper input[type=\'text\']:hover {\n  cursor: pointer;\n}\n\n.prefix-text-wrapper.small,\n.postfix-text-wrapper.small {\n  height: 30px;\n}\n\n.prefix-text-wrapper.small .input-prefix,\n.postfix-text-wrapper.small .input-postfix {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.prefix-text-wrapper.large,\n.postfix-text-wrapper.large {\n  height: 46px;\n}\n\n.prefix-text-wrapper.large .input-prefix,\n.postfix-text-wrapper.large .input-postfix {\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n\n.prefix-text-wrapper .input-prefix,\n.postfix-text-wrapper .input-postfix {\n  display: inline-block;\n  color: var(--color-p1-7);\n  padding: 10px;\n  font-family: var(--marketing-font-family);\n}\n\n.prefix-text-wrapper .input-prefix {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 1px solid var(--color-p3-4);\n}\n\n.postfix-text-wrapper .input-postfix {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: 1px solid var(--color-p3-4);\n}\n\n.postfix-text-wrapper:hover .input-postfix {\n  background-color: var(--color-p3-3);\n  border-left: 1px solid var(--color-p3-5);\n}\n\n.prefix-text-wrapper:hover .input-prefix {\n  background-color: var(--color-p3-3);\n  border-right: 1px solid var(--color-p3-5);\n}\n\n.postfix-text-wrapper:focus-within .input-postfix {\n  background-color: var(--color-p3-2);\n  border-left: 1px solid var(--color-p3-6);\n}\n\n.prefix-text-wrapper:focus-within .input-prefix {\n  background-color: var(--color-p3-2);\n  border-right: 1px solid var(--color-p3-6);\n}\n\n.prefix-text-wrapper input[type=\'text\'],\n.postfix-text-wrapper input[type=\'text\'] {\n  border: 0;\n  border-radius: 0;\n  width: 100%;\n}\n\nlabel .tide-input-wrapper {\n  /* display: block; */\n  margin: 8px 0 0 0;\n}\n\nlabel .tide-input-wrapper input.tide-input[type="text"],\nlabel .tide-input-wrapper input.tide-input[type="password"],\nlabel .tide-input-wrapper input.tide-input[type="email"],\nlabel .tide-input-wrapper input.tide-input[type="url"],\nlabel .tide-input-wrapper input.tide-input[type="date"],\nlabel .tide-input-wrapper input.tide-input[type="month"],\nlabel .tide-input-wrapper input.tide-input[type="time"],\nlabel .tide-input-wrapper input.tide-input[type="datetime"],\nlabel .tide-input-wrapper input.tide-input[type="datetime-local"],\nlabel .tide-input-wrapper input.tide-input[type="week"],\nlabel .tide-input-wrapper input.tide-input[type="number"],\nlabel .tide-input-wrapper input.tide-input[type="search"],\nlabel .tide-input-wrapper input.tide-input[type="tel"],\nlabel .tide-input-wrapper input.tide-input[type="color"],\nlabel .tide-input-wrapper .tide-select.Select,\nlabel .tide-input-wrapper textarea.tide-input {\n  margin: unset\n}\n\n.tide-label .tide-input.medium,\n.tide-label .tide-input.large {\n  margin-top: 3px;\n}\n\n/* inline input */\ninput.tide-input.tide-input--inline {\n  padding: 1px 4px 1px 4px;\n  border: 1px solid transparent;\n  border-bottom: 1px dashed var(--color-p1-8);\n  border-radius: 0;\n  background-color: transparent;\n  transition: none;\n  line-height: var(--main-spacing-heading-6);\n}\n\ninput.tide-input.tide-input--inline:hover {\n  border-color: var(--color-p3-5);\n  border-bottom: 1px solid var(--color-p3-5);\n  border-radius: 3px;\n  background-color: var(--color-p3-2);\n  cursor: pointer;\n}\n\ninput.tide-input.tide-input--inline:focus {\n  outline: 0;\n  background-color: var(--color-p1-2);\n  border: 1px solid var(--color-p3);\n  border-radius: 3px;\n  cursor: text;\n}\n', ""]);
  }, function (e, t, n) {
    var r = n(194);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-inline-warning {\n  margin: 15px 0 0 0;\n}\n\n.tide-inline-warning--title-box {\n  border: 1px solid var(--color-s2-5);\n  border-top-width: 4px;\n  border-radius: 3px;\n  background: var(--color-p1-2);\n  padding: 16px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n}\n\n.tide-inline-warning--no-title-box {\n  margin: 6px 0 0 0;\n}\n\n.tide-inline-warning--no-title-box .tide-inline-warning-copy-block {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n}\n\n.tide-inline-warning--no-title-box .tide-inline-warning-icon {\n  padding: 4px 0 4px 0;\n}\n\n.tide-inline-warning.tide-inline-warning--danger {\n  border-color: var(--color-s3-6);\n}\n\n.tide-inline-warning.tide-inline-warning--danger .tide-inline-warning-title,\n.tide-inline-warning--no-title-box.tide-inline-warning--danger .tide-inline-warning-text {\n  color: var(--color-s3-6);\n}\n\n.tide-inline-warning.tide-inline-warning--danger .tide-inline-warning-title svg path {\n  fill: var(--color-s3-6);\n}\n\n.tide-inline-warning.tide-inline-warning--info {\n  border-color: var(--color-p1-5);\n  border-top-color: var(--color-p1-6);\n}\n\n.tide-inline-warning.tide-inline-warning--warning {\n  border-color: var(--color-s2-4);\n  border-top-color: var(--color-s2-5);\n}\n\n.tide-inline-warning.tide-inline-warning--danger {\n  border-color: var(--color-s3-5);\n  border-top-color: var(--color-s3-6);\n}\n\n.tide-inline-warning.tide-inline-warning--info .tide-inline-warning-title,\n.tide-inline-warning--no-title-box.tide-inline-warning--info .tide-inline-warning-text{\n  color: var(--color-p1-8);\n}\n\n.tide-inline-warning.tide-inline-warning--info .tide-inline-warning-title svg path {\n  fill: var(--color-p1-8);\n}\n\n.tide-inline-warning--no-title-box.tide-inline-warning--warning .tide-inline-warning-text {\n  color: var(--color-s2-6);\n}\n\n.tide-inline-warning .tide-inline-warning-title {\n  margin-bottom: 7px;\n  display: -webkit-flex;\n  display: flex;\n  color: var(--color-s2-5);\n  -webkit-align-items: center;\n          align-items: center;\n}\n\n.tide-inline-warning-button {\n  margin: 0 0 0 30px;\n}\n\n.tide-inline-warning--no-title-box .tide-inline-warning-title {\n  margin-bottom: 0px;\n}\n\n.tide-inline-warning .tide-inline-warning-title h4 {\n  margin: 0;\n}\n\n.tide-inline-warning.tide-inline-warning--danger .tide-inline-warning-title h4 {\n  color: var(--color-s3-6);\n}\n\n.tide-inline-warning.tide-inline-warning--warning .tide-inline-warning-title h4 {\n  color: var(--color-s2-7);\n}\n\n.tide-inline-warning .tide-inline-warning-title svg {\n  margin-right: 8px;\n  height: 21px;\n  width: 12px;\n}\n\n.tide-inline-warning .tide-inline-warning-title svg path {\n  fill: var(--color-s2-6);\n}\n\n.tide-inline-warning--no-title-box .tide-inline-warning-text {\n  margin-top: 1px;\n}\n\n.tide-inline-warning .tide-inline-warning-body {\n  display: -webkit-flex;\n  display: flex;\n}\n\n.tide-inline-warning .tide-inline-warning-body p {\n  -webkit-flex: auto;\n          flex: auto;\n  margin: 0;\n}\n\n.tide-inline-warning--no-title-box .tide-inline-warning-body p {\n  -webkit-flex: auto;\n          flex: auto;\n}\n\n.tide-inline-warning--title-box .tide-inline-warning-body p .action-emphasis {\n  font-family: var(--main-font-family--bold);\n}\n\n.tide-inline-warning .tide-inline-warning-body button {\n  margin-left: 20px;\n  display: inline-block;\n  vertical-align: top;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(196);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-heading-1, .tide-heading-2, .tide-heading-3, .tide-heading-4, .tide-heading-5, .tide-heading-6 {\n  font-family: var(--marketing-font-family--semibold);\n  color: var(--color-p1-10);\n  margin-bottom: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.tide-heading + .tide-paragraph {\n  margin-top: 6px;\n}\n\n.tide-heading-1 {\n  line-height: var(--main-spacing-heading-1);\n  font-size: var(--font-size-large);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-heading-2 {\n  line-height: var(--main-spacing-heading-2);\n  font-size: 24px;\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-heading-3 {\n  line-height: var(--main-spacing-heading-3);\n  font-size: 20px;\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-heading-3.tide-heading-3--inverse {\n  color: var(--color-p1-2);\n  background: var(--color-p1);\n}\n\n.tide-heading-4 {\n  line-height: var(--main-spacing-heading-4);\n  font-size: var(--font-size-small);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-heading-5 {\n  line-height: var(--main-spacing-heading-5);\n  font-size: var(--font-size-copy);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-heading-6 {\n  line-height: var(--main-spacing-heading-6);\n  font-size: var(--font-size-subtle);\n  letter-spacing: var(--main-letter-spacing--loose);\n  text-transform: uppercase;\n}\n\nlabel.tide-label {\n  font-family: var(--marketing-font-family--semibold);\n  line-height: var(--main-spacing-heading-6);\n  font-size: var(--font-size-subtle);\n  margin-bottom: 8px;\n  color: var(--color-p1-10);\n  display: inline-block;\n  vertical-align: top;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.tide-paragraph {\n  font-family: var(--marketing-font-family);\n  letter-spacing: var(--main-letter-spacing);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.tide-paragraph-1 {\n  color: var(--color-p1-8);\n  font-size: var(--font-size-copy);\n  line-height: var(--main-spacing-paragraph-1);\n}\n\n.tide-paragraph-2 {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  line-height: var(--main-spacing-paragraph-2);\n}\n\n.tide-paragraph-1.tide-paragraph-1--inverse {\n  color: var(--color-p1-2);\n  background: var(--color-p1);\n}\n\n.tide-paragraph-1.tide-paragraph-1--subtle {\n  color: var(--color-p1-6);\n}\n\n.tide-text-span {\n  font-family: var(--marketing-font-family);\n  font-size: var(--font-size-copy);\n  line-height: var(--main-spacing-paragraph-1);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.tide-text-span.tide-text-span--error {\n  color: var(--color-s3);\n  font-size: 12px;\n}\n\n.tide-anchor-link {\n  font-family: var(--marketing-font-family);\n  font-size: var(--font-size-copy);\n  letter-spacing: var(--main-letter-spacing);\n  color: var(--color-p3-6);\n  line-height: var(--main-spacing-paragraph-1);\n  text-decoration: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.tide-anchor-link:hover { \n  cursor: pointer;\n  color: var(--color-p3-8);\n}\n\n.tide-anchor-link.tide-anchor-link-2 {\n  font-size: var(--font-size-subtle);\n  line-height: var(--main-spacing-paragraph-2);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-anchor-link.secondary-link {\n  color: var(--color-p1-8);\n  text-decoration: underline;\n}\n\n.tide-anchor-link.secondary-link:hover {\n  color: var(--color-p3-6);\n  cursor: pointer;\n}\n\n.tide-small {\n  font-size: 12px;\n  font-family: var(--marketing-font-family);\n  color: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.tide-strong {\n  font-size: inherit;\n  font-family: var(--marketing-font-family--semibold);\n  color: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n\n.tide-em {\n  font-size: inherit;\n  font-family: var(--marketing-font-family);\n  color: inherit;\n  font-style: italic;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(198);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-layout {\n  padding: 32px;\n}\n\n.tide-layout.tide-layout--subtle {\n  background: var(--color-p1-3);\n}", ""]);
  }, function (e, t, n) {
    var r = n(200);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ":root {\n  /*\n    MAIN COLORS: our main palette; \n\n    THIS IS BEING DEPRECATED, DO NOT ADD ANY MORE COLORS\n  */\n\n  /*navy set*/\n  --main-navy-extra-light: rgb(242,246,248);\n  --main-navy-extra-light-a: 242,246,248;\n\n  --main-navy-light: rgb(225,238,244);\n  --main-navy-light-a: 225,238,244;\n\n  --main-navy: rgb(181,210,225);\n  --main-navy-a: 181,210,225;\n\n  --main-navy-medium: rgb(205, 219, 226);\n  --main-navy-medium-a: 205, 219, 226;\n\n  --main-navy-dark: rgb(118,149,165);\n  --main-navy-dark-a: 118,149,165;\n\n  --main-navy-extra-dark: rgb(57,79,90);\n  --main-navy-extra-dark-a: 57,79,90;\n\n  /*green set*/\n  --main-green-light-a: 229, 250, 240;\n  --main-green-light: rgb(229, 250, 240);\n\n  --main-green-a: 19,203,110;\n  --main-green: rgb(19,203,110);\n\n  --main-green-dark-a: 31,164,92;\n  --main-green-dark: rgb(31,164,92);\n\n\n  /*blue set*/\n  --main-blue-extra-light-a: 239,250,255;\n  --main-blue-extra-light: rgb(239,250,255);\n\n  --main-blue-light-a: 158,220,247;\n  --main-blue-light: rgb(158,220,247);\n\n  --main-blue-a: 10, 91, 255;\n  --main-blue: rgb(10, 91, 255);\n\n  --main-blue-dark-a: 9,96,197;\n  --main-blue-dark: rgb(9,96,197);\n\n  --main-white-a: 255,255,255;\n  --main-white: rgb(255,255,255);\n\n  --main-black-a: 0,0,0;\n  --main-black: rgb(0,0,0);\n\n  /*gray set*/\n  --main-gray-extra-light-a: 248,248,248;\n  --main-gray-extra-light: rgb(248,248,248);\n\n  --main-gray-light-a: 238,238,238;\n  --main-gray-light: rgb(238,238,238);\n\n  --main-gray-a: 204,204,204;\n  --main-gray: rgb(204,204,204);\n\n  --main-gray-dark-a: 154,154,154;\n  --main-gray-dark: rgb(154,154,154);\n\n  --main-gray-extra-dark-a: 51,51,51;\n  --main-gray-extra-dark: rgb(51,51,51);\n\n  --main-gray-accessible-light-a: 122,138,148;\n  --main-gray-accessible-light: rgb(122,138,148);\n\n  --main-gray-accessible-a: 82,98,107; \n  --main-gray-accessible: rgb(82,98,107);\n  \n  /*teal set*/\n  --main-teal-a: 19,221,176;\n  --main-teal: rgb(19,221,176);\n\n  --main-teal-dark-a: 16,185,147;\n  --main-teal-dark: rgb(16,185,147);\n\n  /*violet set*/\n  --main-violet-a: 220,129,255;\n  --main-violet: rgb(220,129,255);\n\n  --main-violet-dark-a: 112,67,213;\n  --main-violet-dark: rgb(112,67,213);\n\n  /*\n    UTILITY PALLETTE: used for errors/warnings/successes;\n  */\n\n  /*blue set*/\n  --utility-blue-a: 10, 91, 255;\n  --utility-blue: rgb(10, 91, 255);\n\n  --utility-blue-light-a: 158,220,247;\n  --utility-blue-light: rgb(158,220,247);\n\n\n  /*red set*/\n  --utility-red-light-a: 233,46,75;\n  --utility-red-light: rgb(233,46,75);\n\n  --utility-red-a: 233,46,75;\n  --utility-red: rgb(233,46,75);\n\n  --utility-red-dark-a: 208,2,27;\n  --utility-red-dark: rgb(208,2,27);\n\n\n  /*yellow set*/\n  --utility-yellow-a: 254,247,158;\n  --utility-yellow: rgb(254,247,158);\n\n  --utility-yellow-light-a: 255,252,217;\n  --utility-yellow-light: rgb(255,252,217);\n\n  /*orange set*/\n  --utility-orange-a: 245,116,3;\n  --utility-orange: rgb(245,116,3);\n\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(202);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, "/*\nFont:     Proxima Soft Semibold\nStyle:    Regular\nURL:    https://www.youworkforthem.com/font/T7442/proxima-soft\nFoundry:  Mark Simonson\nFoundry:  https://www.youworkforthem.com/designer/73/mark-simonson\nCopyright:  Copyright (c) Mark Simonson, 2016. All rights reserved.\nVersion:  17\nCreated:  January 24, 2017\nLicense:  https://www.youworkforthem.com/font-license\nLicense:  The WebFont(s) listed in this document must follow the YouWorkForThem\n      WebFont license rules. All other parties are strictly restricted\n      from using the WebFonts(s) listed without a purchased license.\n      All details above must always remain unaltered and visible in your CSS.\n*/\n\n:root {\n  --main-font-family: ProximaSoft-Regular;\n  --main-font-family--bold: ProximaSoft-Semibold;\n  --main-font-family--light: ProximaSoft-Light;\n  --main-font-family--italic: ProximaSoft-RegularIt;\n  --marketing-font-family: ProximaNova-Regular;\n  --marketing-font-family--bold: ProximaNova-Bold;\n  --marketing-font-family--semibold: ProximaNova-Semibold;\n  --marketing-font-family--extrabold: ProximaNova-Extrabold;\n  --marketing-font-family--light: ProximaNova-Light;\n  --marketing-font-family--black: ProximaNova-Black;\n  --code-font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;\n\n  --font-size-jumbo: 36px;\n  --font-size-extra-large: 32px;\n  --font-size-large: 28px;\n  --font-size-medium: 21px;\n  --font-size-small: 16px;\n  --font-size-copy: 14px;\n  --font-size-subtle: 12px;\n  --font-size-mini: 9px;\n}\n\n@font-face {\n  font-family: 'ProximaNova-Black';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-nova-black.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'ProximaNova-Bold';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-nova-bold.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'ProximaNova-Light';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-nova-light.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'ProximaNova-Regular';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-nova-regular.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'ProximaNova-Semibold';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-nova-semibold.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'ProximaNova-Extrabold';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-nova-extrabold.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'ProximaSoft-Regular';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-soft.eot');\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-soft.eot?#iefix') format('embedded-opentype'),\n             url('https://s3.amazonaws.com/tide-assets/proxima-soft.woff2') format('woff2'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft.woff') format('woff'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft.ttf') format('truetype'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft.svg#youworkforthem') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'ProximaSoft-RegularIt';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-soft-it.eot');\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-soft-it.eot?#iefix') format('embedded-opentype'),\n             url('https://s3.amazonaws.com/tide-assets/proxima-soft-it.woff2') format('woff2'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft-it.woff') format('woff'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft-it.ttf') format('truetype'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft-it.svg#youworkforthem') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n\n@font-face {\n  font-family: 'ProximaSoft-Light';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-soft-light.eot');\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-soft-light.eot?#iefix') format('embedded-opentype'),\n             url('https://s3.amazonaws.com/tide-assets/proxima-soft-light.woff2') format('woff2'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft-light.woff') format('woff'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft-light.ttf') format('truetype'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft-light.svg#youworkforthem') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'ProximaSoft-Semibold';\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.eot');\n  src: url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.eot?#iefix') format('embedded-opentype'),\n             url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.woff2') format('woff2'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.woff') format('woff'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.ttf') format('truetype'),\n       url('https://s3.amazonaws.com/tide-assets/proxima-soft-semibold.svg#youworkforthem') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(204);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ":root {\n  --main-spacing-one-third: calc(100% / 3);\n  --main-spacing-one-half: calc(100% / 2);\n  --main-spacing-one-quarter: calc(100% / 4);\n  --main-spacing-paragraph-1: 20px;\n  --main-spacing-paragraph-2: 16px;\n  --main-spacing-heading-1: 40px;\n  --main-spacing-heading-2: 32px;\n  --main-spacing-heading-3: 28px;\n  --main-spacing-heading-4: 24px;\n  --main-spacing-heading-5: 20px;\n  --main-spacing-heading-6: 16px;\n  --main-letter-spacing: -0.16px;\n  --main-letter-spacing--loose: 0.32px;\n}", ""]);
  }, function (e, t, n) {
    var r = n(206);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ":root {\n  /* NEW COLOR PALETTE\n\n  SEE ZEPPLIN FOR USAGE GUIDELINES: https://zpl.io/29oRK9y\n  */\n\n  /* Primaries with associated shades */\n\n  --color-p1: rgb(70, 82, 89); /* Default Primary */\n  --color-p1-a: 70, 82, 89; /* only color in this set that is allowed to be alpha-able */\n  --color-p1-2: rgb(255, 255, 255); /* N10 */\n  --color-p1-3: rgb(245, 248, 250); /* N20 */\n  --color-p1-4: rgb(239,243,245); /* N30 */\n  --color-p1-5: rgb(214,221,225); /* N40 */\n  --color-p1-5-5: rgb(158, 171, 179); /* N45 */\n  --color-p1-6: rgb(104,120,130); /* N50 */\n  --color-p1-6-a: 104, 120, 130; /* N50 */\n  --color-p1-7: rgb(93,106,116); /* N60 */\n  --color-p1-8: rgb(78,92,101); /* N70 */\n  --color-p1-9: rgb(70, 82, 89); /* N80 */\n  --color-p1-10: rgb(53, 63, 69); /* N90 */\n\n  --color-p2: rgb(19, 203, 110); /* Default Primary */\n  --color-p2-a: 19, 203, 110; /* only color in this set that is allowed to be alpha-able */\n  --color-p2-2: rgb(242, 253, 248);  /* G10 */\n  --color-p2-3: rgb(229,255,243); /* G20 */\n  --color-p2-4: rgb(204,255,230); /* G30 */\n  --color-p2-5: rgb(166,247,207); /* G40 */\n  --color-p2-6: rgb(12, 136, 74); /* G50 */\n  --color-p2-7: rgb(5,122, 64); /* G60 */\n  --color-p2-8: rgb(11, 96, 54); /* G70 */\n  --color-p2-9: rgb(27, 70, 48); /* G80 */\n  --color-p2-10: rgb(22, 45, 32); /* G90 */\n\n  --color-p3: rgb(0, 120, 251); /* Default Primary */\n  --color-p3-a: 0, 120, 251; /* only color in this set that is allowed to be alpha-able */\n  --color-p3-2: rgb(244, 249, 255); /* B10 */\n  --color-p3-3: rgb(229,241,255); /* B20 */\n  --color-p3-4: rgb(199,225,255); /* B30 */\n  --color-p3-5: rgb(148,200,255); /* B40 */\n  --color-p3-6: rgb(0, 113, 235); /* B50 */\n  --color-p3-7: rgb(13, 104, 201); /* B60 */\n  --color-p3-8: rgb(17, 89, 166); /* B70 */\n  --color-p3-9: rgb(8, 62, 119); /* B80 */\n  --color-p3-10: rgb(8, 37, 68); /* B90 */\n\n  /* Secondary Palette */\n\n  --color-s1: rgb(255, 200, 37);\n  --color-s1-2: rgb(255, 251, 240); /* Y10 */\n  --color-s1-3: rgb(255,247,224); /* Y20 */\n  --color-s1-4: rgb(255,237,184); /* Y30 */\n  --color-s1-5: rgb(255,224,133); /* Y40 */\n  --color-s1-6: rgb(255, 200, 37); /* Y50 */\n  --color-s1-7: rgb(244, 184, 6); /* Y60 */\n  --color-s1-8: rgb(215, 147, 9); /* Y70 */\n  --color-s1-9: rgb(147, 106, 37); /* Y80 */\n  --color-s1-10: rgb(100, 66, 22); /* Y90 */\n\n  --color-s2: rgb(247, 107, 27);\n  --color-s2-2: rgb(255, 246, 240); /* O10 */\n  --color-s2-3: rgb(255,239,229); /* O20 */\n  --color-s2-4: rgb(255,194,158); /* O30 */\n  --color-s2-5: rgb(253,165,114); /* O40 */\n  --color-s2-6: rgb(200, 82, 14); /* O50 */\n  --color-s2-7: rgb(190,71,25); /* O60 */\n  --color-s2-8: rgb(170, 65, 24); /* O70 */\n  --color-s2-9: rgb(143, 59, 25); /* O80 */\n  --color-s2-10: rgb(115, 42, 13); /* O90 */\n\n  --color-s3: rgb(246, 60, 44);\n  --color-s3-2: rgb(255, 235, 235); /* R10 */\n  --color-s3-3: rgb(255,223,219); /* R20 */\n  --color-s3-4: rgb(254,162,154); /* R30 */\n  --color-s3-5: rgb(252,126,115); /* R40 */\n  --color-s3-6: rgb(226, 43, 34); /* R50 */\n  --color-s3-7: rgb(210,40,25); /* R60 */\n  --color-s3-8: rgb(173, 43, 31); /* R70 */\n  --color-s3-9: rgb(150, 48, 39); /* R80 */\n  --color-s3-10: rgb(114, 36, 29); /* R90 */\n\n  --color-s4: rgb(154, 98, 186);\n  --color-s4-2: rgb(251, 245, 255); /* P10 */\n  --color-s4-3: rgb(246,237,253); /* P20 */\n  --color-s4-4: rgb(221,188,240); /* P30 */\n  --color-s4-5: rgb(193,149,218); /* P40 */\n  --color-s4-6: rgb(154, 98, 186); /* P50 */\n  --color-s4-7: rgb(129, 75, 160); /* P60 */\n  --color-s4-8: rgb(106, 64, 130); /* P70 */\n  --color-s4-9: rgb(91, 59, 109); /* P80 */\n  --color-s4-10: rgb(66, 42, 81); /* P90 */\n\n  --color-s5: rgb(80, 177, 186);\n  --color-s5-2: rgb(240, 253, 254); /* T10 */\n  --color-s5-3: rgb(202, 243, 247); /* T20 */\n  --color-s5-4: rgb(151, 223, 231); /* T30 */\n  --color-s5-5: rgb(103, 209, 218); /* T40 */\n  --color-s5-6: rgb(80, 177, 186); /* T50 */\n  --color-s5-7: rgb(66, 132, 138); /* T60 */\n  --color-s5-8: rgb(50, 99, 103); /* T70 */\n  --color-s5-9: rgb(43, 81, 84); /* T80 */\n  --color-s5-10: rgb(33, 61, 63); /* T90 */\n\n  --marketing-education--gradient: linear-gradient(135deg, #ED1886, #8711FF);\n  --marketing-upgrade--gradient: linear-gradient(to right, #13CB6E , #3FB6AC);\n  --marketing-education--p1: rgb(237,24,134);\n  --marketing-education--p2: rgb(250,230,23);\n\n  --onboarding--gradient: linear-gradient(135deg, #F5F8FA, #E0E5E7);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(208);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, "\n:root {\n  --box-shadow-1: 0 1px 2px 0 rgba(var(--color-p1-a), 0.24), 0 1px 3px 0 rgba(var(--color-p1-a), 0.12);\n  --box-shadow-2: 0 2px 4px 0 rgba(var(--color-p1-a), 0.12), 0 3px 6px 0 rgba(var(--color-p1-a), 0.15);\n  --box-shadow-3: 0 3px 6px 0 rgba(var(--color-p1-a), 0.1), 0 10px 20px 0 rgba(var(--color-p1-a), 0.15);\n  --box-shadow-4: 0 5px 10px 0 rgba(var(--color-p1-a), 0.05), 0 15px 25px 0 rgba(var(--color-p1-a), 0.15);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(210);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ":root {\n  --transition-catchall-simple: all 0.3s ease;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(212);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, "body:not(.drift-widget-body) {\n  font-family: var(--marketing-font-family);\n  letter-spacing: var(--main-letter-spacing);\n  font-size: var(--font-size-copy);\n  line-height: var(--main-spacing-paragraph-1);\n  color: var(--color-p1-10);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: auto;\n}", ""]);
  }, function (e, t, n) {
    var r = n(214);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, '[tooltip] {\n  z-index: 10000;\n}\n\n[tooltip]::before,\n[tooltip]::after {\n  text-transform: none;\n  font-size: .9em;\n  line-height: 1;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  pointer-events: none;\n  position: absolute;\n  display: none;\n  opacity: 0;\n}\n\n[tooltip]::before {\n  content: \'\';\n  border: 5px solid transparent;\n  z-index: 1001;\n}\n\n[tooltip]::after {\n  content: attr(tooltip);\n\n  min-width: 3em;\n  max-width: 21em;\n  white-space: pre-wrap;\n  padding: 1ch 1.5ch;\n  border-radius: .3ch;\n  box-shadow: 0 1em 2em -.5em rgba(0, 0, 0, 0.35);\n  background: var(--main-navy-extra-dark);\n  line-height: 1.2;\n  color: #fff;\n  z-index: 1000;\n}\n\n[tooltip]:hover::before,\n[tooltip]:hover::after {\n  display: block;\n}\n\n\n[tooltip=\'\']::before,\n[tooltip=\'\']::after {\n  display: none !important;\n}\n\n[tooltip]:not([flow])::before,\n[tooltip][flow^="up"]::before {\n  bottom: 100%;\n  border-bottom-width: 0;\n  border-top-color: var(--main-navy-extra-dark);\n}\n[tooltip]:not([flow])::after,\n[tooltip][flow^="up"]::after {\n  bottom: calc(100% + 5px);\n}\n[tooltip]:not([flow])::before,\n[tooltip]:not([flow])::after,\n[tooltip][flow^="up"]::before,\n[tooltip][flow^="up"]::after {\n  left: 50%;\n  -webkit-transform: translate(-50%, -.5em);\n          transform: translate(-50%, -.5em);\n}\n\n[tooltip][flow^="down"]::before {\n  top: 100%;\n  border-top-width: 0;\n  border-bottom-color: var(--main-navy-extra-dark);\n}\n[tooltip][flow^="down"]::after {\n  top: calc(100% + 5px);\n}\n[tooltip][flow^="down"]::before,\n[tooltip][flow^="down"]::after {\n  left: 50%;\n  -webkit-transform: translate(-50%, .5em);\n          transform: translate(-50%, .5em);\n}\n\n[tooltip][flow^="left"]::before {\n  top: 50%;\n  border-right-width: 0;\n  border-left-color: var(--main-navy-extra-dark);\n  left: calc(0em - 5px);\n  -webkit-transform: translate(-.5em, -50%);\n          transform: translate(-.5em, -50%);\n}\n[tooltip][flow^="left"]::after {\n  top: 50%;\n  right: calc(100% + 5px);\n  -webkit-transform: translate(-.5em, -50%);\n          transform: translate(-.5em, -50%);\n}\n\n[tooltip][flow^="right"]::before {\n  top: 50%;\n  border-left-width: 0;\n  border-right-color: var(--main-navy-extra-dark);\n  right: calc(0em - 5px);\n  -webkit-transform: translate(.5em, -50%);\n          transform: translate(.5em, -50%);\n}\n[tooltip][flow^="right"]::after {\n  top: 50%;\n  left: calc(100% + 5px);\n  -webkit-transform: translate(.5em, -50%);\n          transform: translate(.5em, -50%);\n}\n\n@-webkit-keyframes tooltips-vert {\n  to {\n    opacity: .9;\n    -webkit-transform: translate(-50%, 0);\n            transform: translate(-50%, 0);\n  }\n}\n\n@keyframes tooltips-vert {\n  to {\n    opacity: .9;\n    -webkit-transform: translate(-50%, 0);\n            transform: translate(-50%, 0);\n  }\n}\n\n@-webkit-keyframes tooltips-horz {\n  to {\n    opacity: .9;\n    -webkit-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n  }\n}\n\n@keyframes tooltips-horz {\n  to {\n    opacity: .9;\n    -webkit-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n  }\n}\n\n[tooltip]:not([flow]):hover::before,\n[tooltip]:not([flow]):hover::after,\n[tooltip][flow^="up"]:hover::before,\n[tooltip][flow^="up"]:hover::after,\n[tooltip][flow^="down"]:hover::before,\n[tooltip][flow^="down"]:hover::after {\n  -webkit-animation: tooltips-vert 300ms ease-out forwards;\n          animation: tooltips-vert 300ms ease-out forwards;\n}\n\n[tooltip][flow^="left"]:hover::before,\n[tooltip][flow^="left"]:hover::after,\n[tooltip][flow^="right"]:hover::before,\n[tooltip][flow^="right"]:hover::after {\n  -webkit-animation: tooltips-horz 300ms ease-out forwards;\n          animation: tooltips-horz 300ms ease-out forwards;\n}', ""]);
  }, function (e, t, n) {
    var r = n(216);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-loading-icon g g g g:not(:first-child) path{\n  fill: var(--color-p3-4);\n}\n\n.tide-loading-icon g g g g g path{\n  fill: var(--color-p3-2);\n}", ""]);
  }, function (e, t, n) {
    var r = n(218);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ":root { \n  --tide-modal-max-size--large: 1000px;\n  --tide-modal-max-size--medium: 750px;\n  --tide-modal-max-size--small: 450px;\n  --tide-modal-warning-background: var(--color-s2-6);\n  --tide-modal-error-background: var(--color-s3-6);\n}\n\n.tide-base-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  opacity: 0;\n  transition: all .5s ease;\n}\n\n.tide-base-modal.tide-base-modal--open {\n  opacity: 1;\n}\n\n.tide-base-modal--overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(var(--color-p1-a), 0.6);\n}\n\n.tide-base-modal-content {\n  background: var(--main-white);\n  border-radius: 3px;\n  z-index: 1;\n}\n\n.tide-base-modal-content.tide-base-modal--small {\n  width: 450px;\n  width: var(--tide-modal-max-size--small);\n}\n\n.tide-base-modal-content.tide-base-modal--medium {\n  width: 750px;\n  width: var(--tide-modal-max-size--medium);\n}\n\n.tide-base-modal-content.tide-base-modal--large {\n  width: 1000px;\n  width: var(--tide-modal-max-size--large);\n}\n\n.tide-base-modal-header {\n  background: var(--color-p1);\n  height: 48px;\n  display: -webkit-flex;\n  display: flex;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n  padding: 0 24px 0 24px;\n}\n\n.tide-base-modal-header-title {\n  width: calc(100% - 70px);\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  padding: 12px 0 12px 0px;\n}\n\n.tide-base-modal-header-title .tide-heading-4 {\n  color: var(--color-p1-2);\n  margin-top: 0;\n}\n\n.tide-base-modal-close {\n  height: 48px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  cursor: pointer;\n}\n\n.tide-base-modal-header svg path {\n  fill: var(--main-white);\n}\n\n.tide-base-modal-content--body {\n  max-height: 80vh;\n  padding: 16px 24px 24px;\n  height: 100%;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.tide-base-modal-content--body.tide-base-modal-content--body__flow {\n  max-height: 40vh;\n  min-height: 40vh;\n}\n\n.tide-base-modal-content--body h3.tide-heading-3 {\n  margin-top: 0;\n}\n\n.tide-base-modal-content--body footer {\n  width: calc(100% - 48px);\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  padding: 0;\n  margin-top: 24px;\n}\n\n.tide-base-modal-content--body footer .tide-button:first-of-type {\n  margin-right: 8px;\n}\n\n.tide-base-modal-footer {\n  border-top: 1px solid var(--color-p1-5);\n  display: -webkit-flex;\n  display: flex;\n  padding: 24px;\n}\n\n/* warning styles */\n\n.tide-base-modal--warning .tide-base-modal-header-title .tide-heading-4 {\n  padding-left: 8px;\n}\n\n.tide-base-modal--warning .tide-base-modal-header {\n  background: var(--color-s2-6);\n  background: var(--tide-modal-warning-background);\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n}\n\n.tide-base-modal--warning .tide-base-modal-header .tide-base-modal-close {\n  height: 48px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-self: flex-end;\n          align-self: flex-end;\n  cursor: pointer;\n}\n\n/* error styles */\n\n.tide-base-modal--error .tide-base-modal-header-title .tide-heading-4 {\n  padding-left: 8px;\n}\n\n.tide-base-modal--error .tide-base-modal-header {\n  background: var(--color-s3-6);\n  background: var(--tide-modal-error-background);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(220);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tabby-tabs {\n  max-width: 100%;\n}\n\n.tabby-tabs-tabs {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.tabby-tabs--default .tabby-tabs-tabs {\n  border-bottom: 2px solid var(--color-p1-4);\n}\n\n.tabby-tabs-tab {\n  font-size: 14px;\n  font-family: var(--marketing-font-family--semibold);\n  line-height: var(--main-spacing-heading-5);\n  letter-spacing: var(--main-letter-spacing);\n  display: inline-block;\n  color: var(--color-p1-6);\n  cursor: pointer;\n  padding: 8px;\n  margin-bottom: -2px;\n  white-space: nowrap;\n  margin-right: 16px;\n  width: auto;\n  outline: none;\n}\n\n.tabby-tabs--default .tabby-tabs-tab {\n  border-bottom: 2px solid transparent;\n  transition: border-bottom 150ms, color 150ms;\n}\n\n.tabby-tabs-tab:not(.tabby-tabs-tab--active):focus,\n.tabby-tabs-tab:not(.tabby-tabs-tab--active):hover {\n  border-bottom: 2px solid var(--color-p1-5);\n  color: var(--color-p1-9);\n}\n\n.tabby-tabs--default .tabby-tabs-tab--active {\n  border-bottom: 2px solid var(--color-p1-10);\n  line-height: var(--main-spacing-heading-5);\n  font-size: var(--font-size-copy);\n  letter-spacing: var(--main-letter-spacing);\n  font-family: var(--marketing-font-family--semibold);\n  color: var(--color-p1-10);\n}\n\n.tabby-tabs--default .tabby-tabs-tab--external,\n.tabby-tabs-tab.tabby-tabs-tab--external:not(.tabby-tabs-tab--active):focus,\n.tabby-tabs-tab.tabby-tabs-tab--external:not(.tabby-tabs-tab--active):hover {\n  color: var(--color-p3-6);\n  border-bottom: none;\n}\n\n.tabby-tabs-content {\n  background-color: var(--tab-bg);\n}\n\n.tabby-tabs-content > .property-list-filter input {\n  width: 100%;\n}\n\n/* TABBY TABS WITH ROUNDED CURVES */\n.tabby-tabs--rounded > .tabby-tabs-tabs {\n  background-color: var(--tabs-bg);\n  padding: 0 32px;\n  position: relative;\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs::before {\n  z-index: 1;\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs::after {\n  bottom: 0;\n  content: '';\n  left: 0;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs .tabby-tabs-tab {\n  border-top-left-radius: 4.5px;\n  border-top-right-radius: 4.5px;\n  color: var(--tab-title-color);\n  position: relative;\n  z-index: 0;\n  margin: 8px 0 0;\n  padding: 8px 24px;\n  text-align: center;\n  transition: background-color 150ms;\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs .tabby-tabs-tab:not(.tabby-tabs-tab--active):hover {\n  background-color: var(--tab-hover);\n  border-bottom: none;\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs .tabby-tabs-tab::before,\n.tabby-tabs--rounded > .tabby-tabs-tabs .tabby-tabs-tab::after {\n  bottom: 0;\n  content: \" \";\n  height: 6px;\n  position: absolute;\n  width: 6px;\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs .tabby-tabs-tab::before {\n  border-bottom-right-radius: 4.5px;\n  border-width: 0 1px 1px 0;\n  left: -6px;\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs .tabby-tabs-tab::after {\n  border-bottom-left-radius: 4.5px;\n  border-width: 0 0 1px 1px;\n  right: -6px;\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs .tabby-tabs-tab--active {\n  background-color: var(--tab-bg);\n  border-bottom: none;\n  z-index: 2;\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs .tabby-tabs-tab--active::before {\n  box-shadow: 1px 2px 0 var(--tab-bg);\n}\n\n.tabby-tabs--rounded > .tabby-tabs-tabs .tabby-tabs-tab--active::after {\n  box-shadow: -1px 2px 0 var(--tab-bg);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(222);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-header-nav--container {\n  position: relative;\n  background-color: var(--color-p1-2);\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.tide-header-nav--container--with-nav {\n  border-bottom: none;\n}\n\n.tide-header-nav--container .tabby-tabs-tab:first-child {\n  margin-left: 24px;\n}\n\n.tide-header-nav--container .tabby-tabs-tabs {\n  margin-top: -8px;\n}\n\n.tide-header-nav--title-block {\n  padding: 28px 32px 24px;\n}\n\n.tide-header-nav--title {\n  padding: 0;\n}\n\n.tide-header-nav--title.tide-heading-3 {\n  margin: 0;\n}\n\n.tide-header-nav--secondary {\n  position: absolute;\n  top: 0;\n  left: 32px;\n}\n\n.tide-header-nav--title-actions {\n  position: absolute;\n  top: 24px;\n  right: 32px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-align-items: flex-start;\n          align-items: flex-start;\n}\n\n.tide-header-nav--title-actions > * {\n  margin-left: 8px;\n}\n\n.tide-header-nav--title-actions > *:first-child {\n  margin-left: 0;\n}\n\n", ""]);
  }, function (e, t, n) {
    var r = n(224);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-table--paginator {\n  width: 100%;\n  padding: 16px 0 0;\n}\n\n.tide-table--paginator.tide-table--paginator--fixed {\n  box-sizing: border-box;\n  position: fixed;\n  left: 48px;\n  bottom: 0;\n  width: calc(100% - 48px); /* -left shift */\n  padding: 16px 32px 16px;\n  border-top: 1px solid var(--color-p1-4);\n  background: var(--color-p1-2);\n}\n\n.tide-table--paginator { \n  display: -webkit-flex; \n  display: flex;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-align-items: center;\n          align-items: center;\n}\n\n.tide-table--paginator > .tide-table--paginator-navigation {\n  -webkit-flex: 1 1;\n          flex: 1 1;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  margin-right: 120px; /* Width of the Select component */\n  height: 30px;\n  color: var(--color-p1-10);\n}\n\n.tide-table--paginator button {\n  font-size: 12px;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\n.tide-table--paginator button svg {\n  cursor: pointer;\n}\n\n.tide-table--paginator button svg path {\n  fill: var(--color-p1-7);\n}\n\n.tide-table--paginator > .tide-select.Select.tide-table--paginator-size-select {\n  width: 120px;\n}\n\n.tide-table--paginator-size-select .Select-menu-outer {\n  top: auto;\n  bottom: 100%;\n}\n\n.paginator-navigation .paginator-button--hidden {\n  visibility: hidden;\n}", ""]);
  }, function (e, t, n) {
    var r = function () {
      return this || "object" === typeof self && self;
    }() || Function("return this")(),
        i = r.regeneratorRuntime && Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime") >= 0,
        a = i && r.regeneratorRuntime;

    if (r.regeneratorRuntime = void 0, e.exports = n(226), i) r.regeneratorRuntime = a;else try {
      delete r.regeneratorRuntime;
    } catch (o) {
      r.regeneratorRuntime = void 0;
    }
  }, function (e, t) {
    !function (t) {
      "use strict";

      var n,
          r = Object.prototype,
          i = r.hasOwnProperty,
          a = "function" === typeof Symbol ? Symbol : {},
          o = a.iterator || "@@iterator",
          s = a.asyncIterator || "@@asyncIterator",
          l = a.toStringTag || "@@toStringTag",
          c = "object" === typeof e,
          p = t.regeneratorRuntime;
      if (p) c && (e.exports = p);else {
        (p = t.regeneratorRuntime = c ? e.exports : {}).wrap = wrap;
        var d = "suspendedStart",
            h = "suspendedYield",
            u = "executing",
            f = "completed",
            m = {},
            g = {};

        g[o] = function () {
          return this;
        };

        var v = Object.getPrototypeOf,
            b = v && v(v(values([])));
        b && b !== r && i.call(b, o) && (g = b);
        var y = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(g);
        GeneratorFunction.prototype = y.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunctionPrototype[l] = GeneratorFunction.displayName = "GeneratorFunction", p.isGeneratorFunction = function (e) {
          var t = "function" === typeof e && e.constructor;
          return !!t && (t === GeneratorFunction || "GeneratorFunction" === (t.displayName || t.name));
        }, p.mark = function (e) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, l in e || (e[l] = "GeneratorFunction")), e.prototype = Object.create(y), e;
        }, p.awrap = function (e) {
          return {
            __await: e
          };
        }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[s] = function () {
          return this;
        }, p.AsyncIterator = AsyncIterator, p.async = function (e, t, n, r) {
          var i = new AsyncIterator(wrap(e, t, n, r));
          return p.isGeneratorFunction(t) ? i : i.next().then(function (e) {
            return e.done ? e.value : i.next();
          });
        }, defineIteratorMethods(y), y[l] = "Generator", y[o] = function () {
          return this;
        }, y.toString = function () {
          return "[object Generator]";
        }, p.keys = function (e) {
          var t = [];

          for (var n in e) {
            t.push(n);
          }

          return t.reverse(), function next() {
            for (; t.length;) {
              var n = t.pop();
              if (n in e) return next.value = n, next.done = !1, next;
            }

            return next.done = !0, next;
          };
        }, p.values = values, Context.prototype = {
          constructor: Context,
          reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(resetTryEntry), !e) for (var t in this) {
              "t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = n);
            }
          },
          stop: function stop() {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var t = this;

            function handle(r, i) {
              return o.type = "throw", o.arg = e, t.next = r, i && (t.method = "next", t.arg = n), !!i;
            }

            for (var r = this.tryEntries.length - 1; r >= 0; --r) {
              var a = this.tryEntries[r],
                  o = a.completion;
              if ("root" === a.tryLoc) return handle("end");

              if (a.tryLoc <= this.prev) {
                var s = i.call(a, "catchLoc"),
                    l = i.call(a, "finallyLoc");

                if (s && l) {
                  if (this.prev < a.catchLoc) return handle(a.catchLoc, !0);
                  if (this.prev < a.finallyLoc) return handle(a.finallyLoc);
                } else if (s) {
                  if (this.prev < a.catchLoc) return handle(a.catchLoc, !0);
                } else {
                  if (!l) throw new Error("try statement without catch or finally");
                  if (this.prev < a.finallyLoc) return handle(a.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(e, t) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var r = this.tryEntries[n];

              if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                var a = r;
                break;
              }
            }

            a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
            var o = a ? a.completion : {};
            return o.type = e, o.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, m) : this.complete(o);
          },
          complete: function complete(e, t) {
            if ("throw" === e.type) throw e.arg;
            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
          },
          finish: function finish(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var n = this.tryEntries[t];
              if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), resetTryEntry(n), m;
            }
          },
          catch: function _catch(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var n = this.tryEntries[t];

              if (n.tryLoc === e) {
                var r = n.completion;

                if ("throw" === r.type) {
                  var i = r.arg;
                  resetTryEntry(n);
                }

                return i;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(e, t, r) {
            return this.delegate = {
              iterator: values(e),
              resultName: t,
              nextLoc: r
            }, "next" === this.method && (this.arg = n), m;
          }
        };
      }

      function wrap(e, t, n, r) {
        var i = t && t.prototype instanceof Generator ? t : Generator,
            a = Object.create(i.prototype),
            o = new Context(r || []);
        return a._invoke = function makeInvokeMethod(e, t, n) {
          var r = d;
          return function invoke(i, a) {
            if (r === u) throw new Error("Generator is already running");

            if (r === f) {
              if ("throw" === i) throw a;
              return doneResult();
            }

            for (n.method = i, n.arg = a;;) {
              var o = n.delegate;

              if (o) {
                var s = maybeInvokeDelegate(o, n);

                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }

              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === d) throw r = f, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = u;
              var l = tryCatch(e, t, n);

              if ("normal" === l.type) {
                if (r = n.done ? f : h, l.arg === m) continue;
                return {
                  value: l.arg,
                  done: n.done
                };
              }

              "throw" === l.type && (r = f, n.method = "throw", n.arg = l.arg);
            }
          };
        }(e, n, o), a;
      }

      function tryCatch(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (r) {
          return {
            type: "throw",
            arg: r
          };
        }
      }

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {}

      function defineIteratorMethods(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }

      function AsyncIterator(e) {
        var t;

        this._invoke = function enqueue(n, r) {
          function callInvokeWithMethodAndArg() {
            return new Promise(function (t, a) {
              !function invoke(t, n, r, a) {
                var o = tryCatch(e[t], e, n);

                if ("throw" !== o.type) {
                  var s = o.arg,
                      l = s.value;
                  return l && "object" === typeof l && i.call(l, "__await") ? Promise.resolve(l.__await).then(function (e) {
                    invoke("next", e, r, a);
                  }, function (e) {
                    invoke("throw", e, r, a);
                  }) : Promise.resolve(l).then(function (e) {
                    s.value = e, r(s);
                  }, function (e) {
                    return invoke("throw", e, r, a);
                  });
                }

                a(o.arg);
              }(n, r, t, a);
            });
          }

          return t = t ? t.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }

      function maybeInvokeDelegate(e, t) {
        var r = e.iterator[t.method];

        if (r === n) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = n, maybeInvokeDelegate(e, t), "throw" === t.method)) return m;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return m;
        }

        var i = tryCatch(r, e.iterator, t.arg);
        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (t[e.resultName] = a.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = n), t.delegate = null, m) : a : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, m);
      }

      function pushTryEntry(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function resetTryEntry(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function Context(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(pushTryEntry, this), this.reset(!0);
      }

      function values(e) {
        if (e) {
          var t = e[o];
          if (t) return t.call(e);
          if ("function" === typeof e.next) return e;

          if (!isNaN(e.length)) {
            var r = -1,
                a = function next() {
              for (; ++r < e.length;) {
                if (i.call(e, r)) return next.value = e[r], next.done = !1, next;
              }

              return next.value = n, next.done = !0, next;
            };

            return a.next = a;
          }
        }

        return {
          next: doneResult
        };
      }

      function doneResult() {
        return {
          value: n,
          done: !0
        };
      }
    }(function () {
      return this || "object" === typeof self && self;
    }() || Function("return this")());
  }, function (e, t, n) {
    var r = n(228);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-placeholder-shimmer svg {\n  opacity: 1;\n  -webkit-animation: fadeIn 1s linear;\n          animation: fadeIn 1s linear;\n  -webkit-animation-iteration-count: 1;\n          animation-iteration-count: 1;\n}\n\n.tide-placeholder-shimmer--loaded svg {\n  opacity: 0;\n  -webkit-animation: fadeOut .5s linear;\n          animation: fadeOut .5s linear;\n  -webkit-animation-iteration-count: 1;\n          animation-iteration-count: 1;\n}\n\n\n@-webkit-keyframes fadeIn {\n  0% { opacity: 0 }\n  50% {opacity: 0.5 }\n  100% { opacity: 1 }\n}\n\n\n@keyframes fadeIn {\n  0% { opacity: 0 }\n  50% {opacity: 0.5 }\n  100% { opacity: 1 }\n}\n\n@-webkit-keyframes fadeOut {\n  0% {opacity: 1}\n  50% {opacity: 0.5 }\n  100% { opacity: 0 }\n}\n\n@keyframes fadeOut {\n  0% {opacity: 1}\n  50% {opacity: 0.5 }\n  100% { opacity: 0 }\n}", ""]);
  }, function (e, t, n) {
    var r = n(230);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-ribbon {\n  padding: 2px 4px 0px 4px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  line-height: 12px;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  background-image: var(--marketing-education--gradient);\n  font-size: var(--font-size-subtle);\n  font-family: var(--marketing-font-family--extrabold);\n  letter-spacing: 0.5px;\n  color: var(--main-white);\n  margin-bottom: 4px;\n  text-transform: uppercase;\n}\n\n.tide-upgrade-ribbon {\n  background-image: var(--marketing-upgrade--gradient);\n}\n\n.tide-ribbon--container {\n  position: relative;\n}\n\n.tide-icon.tide-ribbon--lightning-icon path{\n  fill: var(--marketing-education--p2);\n}\n\n.tide-ribbon--lightning-icon {\n  position: absolute;\n  left: -8px;\n  top: -13px;\n}", ""]);
  }, function (e, t, n) {
    "use strict";

    var r = n(232);

    function emptyFunction() {}

    e.exports = function () {
      function shim(e, t, n, i, a, o) {
        if (o !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim
      };
      return e.checkPropTypes = emptyFunction, e.PropTypes = e, e;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, "/**\n * React Select\n * ============\n * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/\n * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n * MIT License: https://github.com/JedWatson/react-select\n*/\n.Select {\n  position: relative;\n}\n.Select input::-webkit-contacts-auto-fill-button,\n.Select input::-webkit-credentials-auto-fill-button {\n  display: none !important;\n}\n.Select input::-ms-clear {\n  display: none !important;\n}\n.Select input::-ms-reveal {\n  display: none !important;\n}\n.Select,\n.Select div,\n.Select input,\n.Select span {\n  box-sizing: border-box;\n}\n.Select.is-disabled .Select-arrow-zone {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.35;\n}\n.Select.is-disabled > .Select-control {\n  background-color: #f9f9f9;\n}\n.Select.is-disabled > .Select-control:hover {\n  box-shadow: none;\n}\n.Select.is-open > .Select-control {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  background: #fff;\n  border-color: #b3b3b3 #ccc #d9d9d9;\n}\n.Select.is-open > .Select-control .Select-arrow {\n  top: -2px;\n  border-color: transparent transparent #999;\n  border-width: 0 5px 5px;\n}\n.Select.is-searchable.is-open > .Select-control {\n  cursor: text;\n}\n.Select.is-searchable.is-focused:not(.is-open) > .Select-control {\n  cursor: text;\n}\n.Select.is-focused > .Select-control {\n  background: #fff;\n}\n.Select.is-focused:not(.is-open) > .Select-control {\n  border-color: #007eff;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);\n  background: #fff;\n}\n.Select.has-value.is-clearable.Select--single > .Select-control .Select-value {\n  padding-right: 42px;\n}\n.Select.has-value.Select--single > .Select-control .Select-value .Select-value-label,\n.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {\n  color: #333;\n}\n.Select.has-value.Select--single > .Select-control .Select-value a.Select-value-label,\n.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label {\n  cursor: pointer;\n  text-decoration: none;\n}\n.Select.has-value.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n.Select.has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,\n.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {\n  color: #007eff;\n  outline: none;\n  text-decoration: underline;\n}\n.Select.has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,\n.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {\n  background: #fff;\n}\n.Select.has-value.is-pseudo-focused .Select-input {\n  opacity: 0;\n}\n.Select.is-open .Select-arrow,\n.Select .Select-arrow-zone:hover > .Select-arrow {\n  border-top-color: #666;\n}\n.Select.Select--rtl {\n  direction: rtl;\n  text-align: right;\n}\n.Select-control {\n  background-color: #fff;\n  border-color: #d9d9d9 #ccc #b3b3b3;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  color: #333;\n  cursor: default;\n  display: table;\n  border-spacing: 0;\n  border-collapse: separate;\n  height: 36px;\n  outline: none;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.Select-control:hover {\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n}\n.Select-control .Select-input:focus {\n  outline: none;\n  background: #fff;\n}\n.Select-placeholder,\n.Select--single > .Select-control .Select-value {\n  bottom: 0;\n  color: #aaa;\n  left: 0;\n  line-height: 34px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.Select-input {\n  height: 34px;\n  padding-left: 10px;\n  padding-right: 10px;\n  vertical-align: middle;\n}\n.Select-input > input {\n  width: 100%;\n  background: none transparent;\n  border: 0 none;\n  box-shadow: none;\n  cursor: default;\n  display: inline-block;\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  outline: none;\n  line-height: 17px;\n  /* For IE 8 compatibility */\n  padding: 8px 0 12px;\n  /* For IE 8 compatibility */\n  -webkit-appearance: none;\n}\n.is-focused .Select-input > input {\n  cursor: text;\n}\n.has-value.is-pseudo-focused .Select-input {\n  opacity: 0;\n}\n.Select-control:not(.is-searchable) > .Select-input {\n  outline: none;\n}\n.Select-loading-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 16px;\n}\n.Select-loading {\n  -webkit-animation: Select-animation-spin 400ms infinite linear;\n  animation: Select-animation-spin 400ms infinite linear;\n  width: 16px;\n  height: 16px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  border-right-color: #333;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n}\n.Select-clear-zone {\n  -webkit-animation: Select-animation-fadeIn 200ms;\n  animation: Select-animation-fadeIn 200ms;\n  color: #999;\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 17px;\n}\n.Select-clear-zone:hover {\n  color: #D0021B;\n}\n.Select-clear {\n  display: inline-block;\n  font-size: 18px;\n  line-height: 1;\n}\n.Select--multi .Select-clear-zone {\n  width: 17px;\n}\n.Select-arrow-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 25px;\n  padding-right: 5px;\n}\n.Select--rtl .Select-arrow-zone {\n  padding-right: 0;\n  padding-left: 5px;\n}\n.Select-arrow {\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2.5px;\n  display: inline-block;\n  height: 0;\n  width: 0;\n  position: relative;\n}\n.Select-control > *:last-child {\n  padding-right: 5px;\n}\n.Select--multi .Select-multi-value-wrapper {\n  display: inline-block;\n}\n.Select .Select-aria-only {\n  position: absolute;\n  display: inline-block;\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  clip: rect(0, 0, 0, 0);\n  overflow: hidden;\n  float: left;\n}\n@-webkit-keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.Select-menu-outer {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-top-color: #e6e6e6;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  position: absolute;\n  left: 0;\n  top: 100%;\n  width: 100%;\n  z-index: 1;\n  -webkit-overflow-scrolling: touch;\n}\n.Select-menu {\n  max-height: 198px;\n  overflow-y: auto;\n}\n.Select-option {\n  box-sizing: border-box;\n  background-color: #fff;\n  color: #666666;\n  cursor: pointer;\n  display: block;\n  padding: 8px 10px;\n}\n.Select-option:last-child {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.Select-option.is-selected {\n  background-color: #f5faff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.04);\n  color: #333;\n}\n.Select-option.is-focused {\n  background-color: #ebf5ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.08);\n  color: #333;\n}\n.Select-option.is-disabled {\n  color: #cccccc;\n  cursor: default;\n}\n.Select-noresults {\n  box-sizing: border-box;\n  color: #999999;\n  cursor: default;\n  display: block;\n  padding: 8px 10px;\n}\n.Select--multi .Select-input {\n  vertical-align: middle;\n  margin-left: 10px;\n  padding: 0;\n}\n.Select--multi.Select--rtl .Select-input {\n  margin-left: 0;\n  margin-right: 10px;\n}\n.Select--multi.has-value .Select-input {\n  margin-left: 5px;\n}\n.Select--multi .Select-value {\n  background-color: #ebf5ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.08);\n  border-radius: 2px;\n  border: 1px solid #c2e0ff;\n  /* Fallback color for IE 8 */\n  border: 1px solid rgba(0, 126, 255, 0.24);\n  color: #007eff;\n  display: inline-block;\n  font-size: 0.9em;\n  line-height: 1.4;\n  margin-left: 5px;\n  margin-top: 5px;\n  vertical-align: top;\n}\n.Select--multi .Select-value-icon,\n.Select--multi .Select-value-label {\n  display: inline-block;\n  vertical-align: middle;\n}\n.Select--multi .Select-value-label {\n  border-bottom-right-radius: 2px;\n  border-top-right-radius: 2px;\n  cursor: default;\n  padding: 2px 5px;\n}\n.Select--multi a.Select-value-label {\n  color: #007eff;\n  cursor: pointer;\n  text-decoration: none;\n}\n.Select--multi a.Select-value-label:hover {\n  text-decoration: underline;\n}\n.Select--multi .Select-value-icon {\n  cursor: pointer;\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n  border-right: 1px solid #c2e0ff;\n  /* Fallback color for IE 8 */\n  border-right: 1px solid rgba(0, 126, 255, 0.24);\n  padding: 1px 5px 3px;\n}\n.Select--multi .Select-value-icon:hover,\n.Select--multi .Select-value-icon:focus {\n  background-color: #d8eafd;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 113, 230, 0.08);\n  color: #0071e6;\n}\n.Select--multi .Select-value-icon:active {\n  background-color: #c2e0ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.24);\n}\n.Select--multi.Select--rtl .Select-value {\n  margin-left: 0;\n  margin-right: 5px;\n}\n.Select--multi.Select--rtl .Select-value-icon {\n  border-right: none;\n  border-left: 1px solid #c2e0ff;\n  /* Fallback color for IE 8 */\n  border-left: 1px solid rgba(0, 126, 255, 0.24);\n}\n.Select--multi.is-disabled .Select-value {\n  background-color: #fcfcfc;\n  border: 1px solid #e3e3e3;\n  color: #333;\n}\n.Select--multi.is-disabled .Select-value-icon {\n  cursor: not-allowed;\n  border-right: 1px solid #e3e3e3;\n}\n.Select--multi.is-disabled .Select-value-icon:hover,\n.Select--multi.is-disabled .Select-value-icon:focus,\n.Select--multi.is-disabled .Select-value-icon:active {\n  background-color: #fcfcfc;\n}\n@keyframes Select-animation-spin {\n  to {\n    -webkit-transform: rotate(1turn);\n            transform: rotate(1turn);\n  }\n}\n@-webkit-keyframes Select-animation-spin {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(235);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, "\n.tide-select.Select {\n  display: inline-block;\n  vertical-align: bottom;\n  width: 100%;\n}\n\n.tide-select .Select-control {\n  color: var(--color-p1);\n  border: 1px solid;\n  font-family: var(--marketing-font-family);\n  border-color: var(--color-p3-4);\n  background-color: var(--color-p1-2);\n  border-radius: 3px;\n  vertical-align: middle;\n  box-sizing: border-box;\n  font-size: 14px;\n  box-shadow: none;\n}\n\n.tide-select .Select-control:hover {\n  border-color: var(--color-p3-5);\n  cursor: pointer;\n}\n\n.tide-select .Select-placeholder {\n  color: var(--color-p1-6);\n}\n\n.tide-select.large .Select-placeholder {\n  line-height: 38px;\n}\n\n.tide-select .Select-arrow-zone {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  text-align: center;\n}\n\n.tide-select .Select-arrow {\n  border-color: transparent;\n  border-style: none;\n  border-width: 0px;\n  position: relative;\n}\n\n.tide-select.Select.is-open > .Select-control {\n  border-color: var(--color-p3-5);\n}\n\n.tide-select .Select-arrow:after {\n  content: '\\2304';\n  position: absolute;\n  top: -4px;\n  left: -6px;\n  height: 10px;\n  width: 10px;\n  display: block;\n  font-size: 21px;\n  line-height: 0px;\n  -webkit-transform: scaleX(1.4);\n          transform: scaleX(1.4);\n}\n\n.tide-select .Select-menu-outer {\n  border: 1px solid;\n  border-color: var(--color-p3-2);\n  box-shadow: 0 2px 8px 0 var(--color-p1-3);\n}\n\n.tide-select .Select-option.is-focused {\n  background: var(--color-p3-3);\n  color: var(--color-p1);\n}\n\n.tide-select .Select-option {\n  cursor: pointer;\n}\n\n.tide-select .Select-arrow-zone:before {\n  content: '';\n  width: 0px;\n  height: calc(100% - 14px);\n  border-left: 1px solid var(--color-p3-4);\n  position: absolute;\n  top: 7px;\n  left: 0;\n}\n\n.tide-select.small .Select-control {\n  height: 23px;\n}\n\n.tide-select.medium .Select-control {\n  height: 30px;\n}\n\n.tide-select.large .Select-control {\n  height: 38px;\n}\n\n.tide-select.small .Select-input {\n  height: 28px;\n}\n\n.tide-select.large .Select-input {\n  height: 36px;\n}\n\n.tide-select .is-focused:not(.is-open) > .Select-control {\n  border-color: var(--color-p3);\n  box-shadow: unset;\n}\n\n.tide-select .is-open > .Select-control {\n  outline-color: transparent;\n  border-color: var(--color-p3);\n}\n\n.tide-select--label {\n  color: var(--color-p1-10);\n  font-size: 12px;\n  margin-bottom: 3px;\n  display: block;\n  font-family: var(--marketing-font-family--semibold);\n}\n\n.tide-select--description {\n  color: var(--color-p1-7);\n  font-size: 12px;\n  margin: 8px 0 0 0;\n}\n\n.tide-select .Select-option:hover,\n.tide-select .Select-option.is-focused {\n  background-color: var(--color-p3-2);\n}\n\n.tide-select .Select-option.is-selected {\n  background-color: var(--color-p3-3);\n}\n\n.tide-select.Select.is-disabled .Select-control {\n  border: 1px solid var(--color-p1-5);\n  background: var(--color-p1-3);\n}\n\n.tide-select.Select.is-disabled > .Select-control .Select-value .Select-value-label {\n  color: var(--color-p1-5);\n}\n\n.tide-select.is-disabled .Select-arrow:after {\n  color:var(--color-p1-6);\n}\n\n.tide-select.is-disabled .Select-control:hover {\n  cursor: not-allowed;\n  border-color: var(--color-p1-4);\n}\n\n.tide-select.is-disabled .Select-arrow-zone:before {\n  border-color: var(--color-p1-5);\n}\n\n.tide-select .Select-control > *:last-child {\n  padding-right: 0;\n}\n\n.tide-select.Select.is-open > .Select-control .Select-arrow {\n  top: 0px;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(237);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-sidebar-wrapper {\n  background: rgba(var(--color-p1-a), .8);\n  width: 100%;\n  height: 100%;\n  display: block;\n  min-height: 100vh;\n  position: fixed;\n  top: 0;\n  right: 0 !important;\n  left: auto !important;\n  transition: opacity .1s ease-out;\n  opacity: 0;\n  z-index: 10000;\n}\n\n.tide-sidebar-wrapper--no-overlay {\n  background: none !important;\n  width: 0 !important;\n  min-width: 380px !important;\n}\n\n.tide-sidebar-bg {\n  transition: opacity .1s ease-out;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  position: absolute;\n  background: rgba(var(--color-p1-a), .8);\n}\n\n.tide-sidebar {\n  width: 40%;\n  min-width: 380px !important;\n  max-width: 600px;\n  height: 100%;\n  float: right;\n  background: var(--color-p1-2);\n  position: relative;\n  -webkit-transform: translateX(630px);\n          transform: translateX(630px);\n  transition: -webkit-transform .3s ease-in;\n  transition: transform .3s ease-in;\n  transition: transform .3s ease-in, -webkit-transform .3s ease-in;\n  transition-delay: .1s;\n}\n\n.tide-sidebar-wrapper--no-overlay .tide-sidebar {\n  transition-delay: 0 !important;\n  border-left: 1px solid var(--main-navy-extra-light);\n  box-shadow: 30px 0 35px 20px var(--color-p1);\n  transition-delay: 0s;\n}\n\n.tide-header.tide-sidebar--header {\n  background: var(--color-p1);\n  padding: 16px 12px;\n}\n\n.tide-header.tide-sidebar--header .tide-heading-3 {\n  color: var(--color-p1-2);\n  margin: 0;\n}\n.tide-sidebar-wrapper--open {\n  opacity: 1;\n}\n\n.tide-sidebar-wrapper--open .tide-sidebar {\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n}\n\n.tide-sidebar .close-button {\n  position: absolute;\n  top: 18px;\n  right: 16px;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.tide-sidebar .close-button path {\n  fill: var(--color-p1-2);\n}", ""]);
  }, function (e, t, n) {
    var r = n(239);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-tag {\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-align-items: center;\n          align-items: center;\n  background: rgba(var(--color-p1-a), 0.2);\n  margin: 0 5px;\n  border-radius: 4px;\n}\n\n.tide-tag .tide-icon {\n  height: 14px;\n  margin-right: 4px\n}\n\n.tide-tag-contents {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-align-items: center;\n          align-items: center;\n  padding: 4px 8px;\n}\n\n.tide-tag-text {\n  color: var(--color-p1);\n  font-size: 14px;\n}\n\n.tide-tag-text-size--subtle {\n  font-size: var(--font-size-subtle);\n}\n\n.tide-tag-text-size--copy {\n  font-size: var(--font-size-copy);\n}\n\n.tide-tag-text-size--small {\n  font-size: var(--font-size-small);\n}\n\n.tide-tag-text-size--medium {\n  font-size: var(--font-size-medium);\n}\n\n.tide-tag-text-size--large {\n  font-size: var(--font-size-large);\n}\n\n.tide-tag-type-status.tide-tag-type-status-on {\n  background-color: var(--color-p2-3);\n}\n\n.tide-tag-type-status.tide-tag-type-status-off {\n  background-color: var(--color-s3-2);\n}\n\n.tide-tag-type-status .tide-tag-text {\n  font-family: var(--marketing-font-family--semibold);\n  font-size: var(--font-size-subtle);\n  line-height: 12px;\n}\n\n.tide-tag-type-status.tide-tag-type-status-on .tide-tag-text {\n  color: var(--color-p2-6);\n}\n\n.tide-tag-type-status.tide-tag-type-status-off .tide-tag-text {\n  color: var(--color-s3-6);\n}\n\n.tide-tag.tide-tag-type-status-default {\n  background-color: var(--color-p1-3);\n}\n\n.tide-tag.tide-tag-type-status-default .tide-tag-text {\n  color: var(--color-p1-6);\n  font-family: var(--marketing-font-family--semibold);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(241);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-bot-skills--skills {\n  margin-top: 60px;\n}\n\n.tide-bot-skills--skills-item {\n  border: 1px solid var(--color-p3-4);\n  border-radius: 3px;\n  margin: 8px 0;\n  box-sizing: unset;\n  box-shadow: var(--box-shadow-1);\n}\n\n.tide-bot-skills--skills-item.interactive:hover {\n  border-color: var(--color-p3-5);\n  box-shadow: var(--box-shadow-2);\n  transition: all .2s linear;\n}\n\n.tide-bot-skills--skills-item.selected-row,\n.tide-bot-skills--skills-item.selected-row:hover {\n  border-color: var(--color-p3-4);\n  box-shadow: var(--box-shadow-1);\n}\n\n.tide-bot-skills--skills-item-header {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  height: 120px;\n  width: 100%;\n  position: relative;\n  cursor: pointer;\n}\n\n.ribbon {\n  overflow: hidden;\n}\n\n.tide-bot-skills--skills-item-header.ribbon-coming {\n  cursor: auto;\n  cursor: initial;\n}\n\n.tide-bot-skills--skills-item-header.ribbon.ribbon-upgrade:after {\n  content: 'UPGRADE';\n  width: 174px;\n  background: var(--color-p3-6);\n  position: absolute;\n  top: 22px;\n  right: -53px;\n  left: auto;\n  text-align: center;\n  line-height: 31px;\n  letter-spacing: 0px;\n  color: var(--color-p1-2);\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n\n.tide-bot-skills--skills-item-header.ribbon.ribbon-coming:after {\n  content: 'COMING SOON';\n  width: 174px;\n  background: var(--bot-skills-blue-gradient);\n  position: absolute;\n  font-size: 12px;\n  top: 33px;\n  right: -45px;\n  left: auto;\n  text-align: center;\n  line-height: 31px;\n  letter-spacing: 0px;\n  color: var(--color-p1-2);\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n\n.tide-bot-skills--skills-item-icon-container {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  -webkit-flex: 0 0 130px;\n          flex: 0 0 130px;\n  height: 100%;\n}\n\n.tide-bot-skills--skills-item-icon {\n  width: 80px;\n  height: 80px;\n}\n\n.tide-bot-skills--skills-item-text {\n  -webkit-flex-grow: 2;\n          flex-grow: 2;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-justify-content: center;\n          justify-content: center;\n}\n\n.tide-bot-skills--skills-item-title-container {\n  -webkit-align-items: center;\n          align-items: center;\n  display: -webkit-flex;\n  display: flex;\n  margin-top: 20px;\n}\n\n.tide-bot-skills--skills-item-text h3 {\n  margin: 0;\n}\n\n.tide-bot-skills--status {\n  margin-left: 15px;\n}\n\n.tide-bot-skills--skills-item-text p {\n  color: var(--color-p1-6);\n  margin-top: 6px;\n}\n\n.tide-bot-skills--skills-item-toggle {\n  -webkit-align-self: flex-end;\n          align-self: flex-end;\n  height: 100%;\n  width: 90px;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-shrink: 0;\n          flex-shrink: 0;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n}\n\n.tide-bot-skills--skills-item-coming-soon {\n  background: var(--main-navy-extra-light);\n  box-shadow: none;\n}\n\n.tide-bot-skills--skills-item-drawer {\n  padding: 24px;\n}\n\n.tide-bot-skills--skill-drawer-container.routing-availability li.tabby-tabs-tab--active.tabby-tabs-tab,\n.tide-bot-skills--skill-drawer-container.routing-availability li.tabby-tabs-tab.tabby-tabs-tab-ghost {\n  padding-left: 0;\n  padding-bottom: 15px;\n}\n\ndiv.tide-bot-skills {\n  width: 755px;\n  padding-right: 0;\n  margin-right: 0;\n}\n\ndiv.tide-bot-skills--routing-parent {\n  padding-right: 0;\n  padding-left: 0;\n  width: 100%;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";

    var r = n(85).forEach,
        i = n(243),
        a = n(244),
        o = n(245),
        s = n(246),
        l = n(247),
        c = n(86),
        p = n(248),
        d = n(250),
        h = n(251),
        u = n(252);

    function isCollection(e) {
      return Array.isArray(e) || void 0 !== e.length;
    }

    function toArray(e) {
      if (Array.isArray(e)) return e;
      var t = [];
      return r(e, function (e) {
        t.push(e);
      }), t;
    }

    function isElement(e) {
      return e && 1 === e.nodeType;
    }

    function getOption(e, t, n) {
      var r = e[t];
      return void 0 !== r && null !== r || void 0 === n ? r : n;
    }

    e.exports = function (e) {
      var t;
      if ((e = e || {}).idHandler) t = {
        get: function get(t) {
          return e.idHandler.get(t, !0);
        },
        set: e.idHandler.set
      };else {
        var n = o(),
            f = s({
          idGenerator: n,
          stateHandler: d
        });
        t = f;
      }
      var m = e.reporter;
      m || (m = l(!1 === m));
      var g = getOption(e, "batchProcessor", p({
        reporter: m
      })),
          v = {};
      v.callOnAdd = !!getOption(e, "callOnAdd", !0), v.debug = !!getOption(e, "debug", !1);
      var b,
          y = a(t),
          x = i({
        stateHandler: d
      }),
          w = getOption(e, "strategy", "object"),
          E = getOption(e, "important", !1),
          C = {
        reporter: m,
        batchProcessor: g,
        stateHandler: d,
        idHandler: t,
        important: E
      };
      if ("scroll" === w && (c.isLegacyOpera() ? (m.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy."), w = "object") : c.isIE(9) && (m.warn("Scroll strategy is not supported on IE9. Changing to object strategy."), w = "object")), "scroll" === w) b = u(C);else {
        if ("object" !== w) throw new Error("Invalid strategy name: " + w);
        b = h(C);
      }
      var k = {};
      return {
        listenTo: function listenTo(e, n, i) {
          function onResizeCallback(e) {
            var t = y.get(e);
            r(t, function callListenerProxy(t) {
              t(e);
            });
          }

          function addListener(e, t, n) {
            y.add(t, n), e && n(t);
          }

          if (i || (i = n, n = e, e = {}), !n) throw new Error("At least one element required.");
          if (!i) throw new Error("Listener required.");
          if (isElement(n)) n = [n];else {
            if (!isCollection(n)) return m.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
            n = toArray(n);
          }
          var a = 0,
              o = getOption(e, "callOnAdd", v.callOnAdd),
              s = getOption(e, "onReady", function noop() {}),
              l = getOption(e, "debug", v.debug);
          r(n, function attachListenerToElement(e) {
            d.getState(e) || (d.initState(e), t.set(e));
            var c = t.get(e);
            if (l && m.log("Attaching listener to element", c, e), !x.isDetectable(e)) return l && m.log(c, "Not detectable."), x.isBusy(e) ? (l && m.log(c, "System busy making it detectable"), addListener(o, e, i), k[c] = k[c] || [], void k[c].push(function onReady() {
              ++a === n.length && s();
            })) : (l && m.log(c, "Making detectable..."), x.markBusy(e, !0), b.makeDetectable({
              debug: l,
              important: E
            }, e, function onElementDetectable(e) {
              if (l && m.log(c, "onElementDetectable"), d.getState(e)) {
                x.markAsDetectable(e), x.markBusy(e, !1), b.addListener(e, onResizeCallback), addListener(o, e, i);
                var t = d.getState(e);

                if (t && t.startSize) {
                  var p = e.offsetWidth,
                      h = e.offsetHeight;
                  t.startSize.width === p && t.startSize.height === h || onResizeCallback(e);
                }

                k[c] && r(k[c], function (e) {
                  e();
                });
              } else l && m.log(c, "Element uninstalled before being detectable.");

              delete k[c], ++a === n.length && s();
            }));
            l && m.log(c, "Already detecable, adding listener."), addListener(o, e, i), a++;
          }), a === n.length && s();
        },
        removeListener: y.removeListener,
        removeAllListeners: y.removeAllListeners,
        uninstall: function uninstall(e) {
          if (!e) return m.error("At least one element is required.");
          if (isElement(e)) e = [e];else {
            if (!isCollection(e)) return m.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
            e = toArray(e);
          }
          r(e, function (e) {
            y.removeAllListeners(e), b.uninstall(e), d.cleanState(e);
          });
        },
        initDocument: function initDocument(e) {
          b.initDocument && b.initDocument(e);
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = e.stateHandler.getState;
      return {
        isDetectable: function isDetectable(e) {
          var n = t(e);
          return n && !!n.isDetectable;
        },
        markAsDetectable: function markAsDetectable(e) {
          t(e).isDetectable = !0;
        },
        isBusy: function isBusy(e) {
          return !!t(e).busy;
        },
        markBusy: function markBusy(e, n) {
          t(e).busy = !!n;
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = {};

      function getListeners(n) {
        var r = e.get(n);
        return void 0 === r ? [] : t[r] || [];
      }

      return {
        get: getListeners,
        add: function addListener(n, r) {
          var i = e.get(n);
          t[i] || (t[i] = []), t[i].push(r);
        },
        removeListener: function removeListener(e, t) {
          for (var n = getListeners(e), r = 0, i = n.length; r < i; ++r) {
            if (n[r] === t) {
              n.splice(r, 1);
              break;
            }
          }
        },
        removeAllListeners: function removeAllListeners(e) {
          var t = getListeners(e);
          t && (t.length = 0);
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function () {
      var e = 1;
      return {
        generate: function generate() {
          return e++;
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = e.idGenerator,
          n = e.stateHandler.getState;
      return {
        get: function getId(e) {
          var t = n(e);
          return t && void 0 !== t.id ? t.id : null;
        },
        set: function setId(e) {
          var r = n(e);
          if (!r) throw new Error("setId required the element to have a resize detection state.");
          var i = t.generate();
          return r.id = i, i;
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      function noop() {}

      var t = {
        log: noop,
        warn: noop,
        error: noop
      };

      if (!e && window.console) {
        var n = function attachFunction(e, t) {
          e[t] = function reporterProxy() {
            var e = console[t];
            if (e.apply) e.apply(console, arguments);else for (var n = 0; n < arguments.length; n++) {
              e(arguments[n]);
            }
          };
        };

        n(t, "log"), n(t, "warn"), n(t, "error");
      }

      return t;
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(249);

    function Batch() {
      var e = {},
          t = 0,
          n = 0,
          r = 0;
      return {
        add: function add(i, a) {
          a || (a = i, i = 0), i > n ? n = i : i < r && (r = i), e[i] || (e[i] = []), e[i].push(a), t++;
        },
        process: function process() {
          for (var t = r; t <= n; t++) {
            for (var i = e[t], a = 0; a < i.length; a++) {
              (0, i[a])();
            }
          }
        },
        size: function getSize() {
          return t;
        }
      };
    }

    e.exports = function batchProcessorMaker(e) {
      var t = (e = e || {}).reporter,
          n = r.getOption(e, "async", !0),
          i = r.getOption(e, "auto", !0);
      i && !n && (t && t.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true."), n = !0);
      var a,
          o = Batch(),
          s = !1;

      function processBatch() {
        for (s = !0; o.size();) {
          var e = o;
          o = Batch(), e.process();
        }

        s = !1;
      }

      function processBatchAsync() {
        a = function requestFrame(e) {
          return function raf(e) {
            return setTimeout(e, 0);
          }(e);
        }(processBatch);
      }

      return {
        add: function addFunction(e, t) {
          !s && i && n && 0 === o.size() && processBatchAsync(), o.add(e, t);
        },
        force: function forceProcessBatch(e) {
          s || (void 0 === e && (e = n), a && (function cancelFrame(e) {
            return clearTimeout(e);
          }(a), a = null), e ? processBatchAsync() : processBatch());
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    (e.exports = {}).getOption = function getOption(e, t, n) {
      var r = e[t];
      if ((void 0 === r || null === r) && void 0 !== n) return n;
      return r;
    };
  }, function (e, t, n) {
    "use strict";

    var r = "_erd";

    function getState(e) {
      return e[r];
    }

    e.exports = {
      initState: function initState(e) {
        return e[r] = {}, getState(e);
      },
      getState: getState,
      cleanState: function cleanState(e) {
        delete e[r];
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(86);

    e.exports = function (e) {
      var t = (e = e || {}).reporter,
          n = e.batchProcessor,
          i = e.stateHandler.getState;
      if (!t) throw new Error("Missing required dependency: reporter.");

      function buildCssTextString(t) {
        var n = e.important ? " !important; " : "; ";
        return (t.join(n) + n).trim();
      }

      function getObject(e) {
        return i(e).object;
      }

      return {
        makeDetectable: function makeDetectable(e, a, o) {
          o || (o = a, a = e, e = null), (e = e || {}).debug, r.isIE(8) ? o(a) : function injectObject(a, o) {
            var s = buildCssTextString(["display: block", "position: absolute", "top: 0", "left: 0", "width: 100%", "height: 100%", "border: none", "padding: 0", "margin: 0", "opacity: 0", "z-index: -1000", "pointer-events: none"]),
                l = !1,
                c = window.getComputedStyle(a),
                p = a.offsetWidth,
                d = a.offsetHeight;

            function mutateDom() {
              function alterPositionStyles() {
                if ("static" === c.position) {
                  a.style.setProperty("position", "relative", e.important ? "important" : "");

                  var n = function removeRelativeStyles(t, n, r, i) {
                    var a = r[i];
                    "auto" !== a && "0" !== function getNumericalValue(e) {
                      return e.replace(/[^-\d\.]/g, "");
                    }(a) && (t.warn("An element that is positioned static has style." + i + "=" + a + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + i + " will be set to 0. Element: ", n), n.style.setProperty(i, "0", e.important ? "important" : ""));
                  };

                  n(t, a, c, "top"), n(t, a, c, "right"), n(t, a, c, "bottom"), n(t, a, c, "left");
                }
              }

              "" !== c.position && (alterPositionStyles(), l = !0);
              var n = document.createElement("object");
              n.style.cssText = s, n.tabIndex = -1, n.type = "text/html", n.onload = function onObjectLoad() {
                l || alterPositionStyles(), function getDocument(e, t) {
                  e.contentDocument ? t(e.contentDocument) : setTimeout(function checkForObjectDocument() {
                    getDocument(e, t);
                  }, 100);
                }(this, function onObjectDocumentReady(e) {
                  o(a);
                });
              }, r.isIE() || (n.data = "about:blank"), i(a) && (a.appendChild(n), i(a).object = n, r.isIE() && (n.data = "about:blank"));
            }

            i(a).startSize = {
              width: p,
              height: d
            }, n ? n.add(mutateDom) : mutateDom();
          }(a, o);
        },
        addListener: function addListener(e, t) {
          function listenerProxy() {
            t(e);
          }

          if (r.isIE(8)) i(e).object = {
            proxy: listenerProxy
          }, e.attachEvent("onresize", listenerProxy);else {
            var n = getObject(e);
            if (!n) throw new Error("Element is not detectable by this strategy.");
            n.contentDocument.defaultView.addEventListener("resize", listenerProxy);
          }
        },
        uninstall: function uninstall(e) {
          if (i(e)) {
            var t = getObject(e);
            t && (r.isIE(8) ? e.detachEvent("onresize", t.proxy) : e.removeChild(t), delete i(e).object);
          }
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(85).forEach;

    e.exports = function (e) {
      var t = (e = e || {}).reporter,
          n = e.batchProcessor,
          i = e.stateHandler.getState,
          a = (e.stateHandler.hasState, e.idHandler);
      if (!n) throw new Error("Missing required dependency: batchProcessor");
      if (!t) throw new Error("Missing required dependency: reporter.");

      var o = function getScrollbarSizes() {
        var e = document.createElement("div");
        e.style.cssText = buildCssTextString(["position: absolute", "width: 1000px", "height: 1000px", "visibility: hidden", "margin: 0", "padding: 0"]);
        var t = document.createElement("div");
        t.style.cssText = buildCssTextString(["position: absolute", "width: 500px", "height: 500px", "overflow: scroll", "visibility: none", "top: -1500px", "left: -1500px", "visibility: hidden", "margin: 0", "padding: 0"]), t.appendChild(e), document.body.insertBefore(t, document.body.firstChild);
        var n = 500 - t.clientWidth,
            r = 500 - t.clientHeight;
        return document.body.removeChild(t), {
          width: n,
          height: r
        };
      }(),
          s = "erd_scroll_detection_scrollbar_style",
          l = "erd_scroll_detection_container";

      function initDocument(e) {
        !function injectScrollStyle(e, t, n) {
          if (!e.getElementById(t)) {
            var r = n + "_animation",
                i = n + "_animation_active",
                a = "/* Created by the element-resize-detector library. */\n";
            a += "." + n + " > div::-webkit-scrollbar { " + buildCssTextString(["display: none"]) + " }\n\n", a += "." + i + " { " + buildCssTextString(["-webkit-animation-duration: 0.1s", "animation-duration: 0.1s", "-webkit-animation-name: " + r, "animation-name: " + r]) + " }\n", a += "@-webkit-keyframes " + r + " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n", function injectStyle(n, r) {
              r = r || function (t) {
                e.head.appendChild(t);
              };

              var i = e.createElement("style");
              return i.innerHTML = n, i.id = t, r(i), i;
            }(a += "@keyframes " + r + " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }");
          }
        }(e, s, l);
      }

      function buildCssTextString(t) {
        var n = e.important ? " !important; " : "; ";
        return (t.join(n) + n).trim();
      }

      function addEvent(e, n, r) {
        if (e.addEventListener) e.addEventListener(n, r);else {
          if (!e.attachEvent) return t.error("[scroll] Don't know how to add event listeners.");
          e.attachEvent("on" + n, r);
        }
      }

      function removeEvent(e, n, r) {
        if (e.removeEventListener) e.removeEventListener(n, r);else {
          if (!e.detachEvent) return t.error("[scroll] Don't know how to remove event listeners.");
          e.detachEvent("on" + n, r);
        }
      }

      function getExpandElement(e) {
        return i(e).container.childNodes[0].childNodes[0].childNodes[0];
      }

      function getShrinkElement(e) {
        return i(e).container.childNodes[0].childNodes[0].childNodes[1];
      }

      return initDocument(window.document), {
        makeDetectable: function makeDetectable(e, s, c) {
          function debug() {
            if (e.debug) {
              var n = Array.prototype.slice.call(arguments);
              if (n.unshift(a.get(s), "Scroll: "), t.log.apply) t.log.apply(null, n);else for (var r = 0; r < n.length; r++) {
                t.log(n[r]);
              }
            }
          }

          function isUnrendered(e) {
            var t = i(e).container.childNodes[0],
                n = window.getComputedStyle(t);
            return !n.width || -1 === n.width.indexOf("px");
          }

          function getStyle() {
            var e = window.getComputedStyle(s),
                t = {};
            return t.position = e.position, t.width = s.offsetWidth, t.height = s.offsetHeight, t.top = e.top, t.right = e.right, t.bottom = e.bottom, t.left = e.left, t.widthCSS = e.width, t.heightCSS = e.height, t;
          }

          function storeStyle() {
            if (debug("storeStyle invoked."), i(s)) {
              var e = getStyle();
              i(s).style = e;
            } else debug("Aborting because element has been uninstalled");
          }

          function storeCurrentSize(e, t, n) {
            i(e).lastWidth = t, i(e).lastHeight = n;
          }

          function getWidthOffset() {
            return 2 * o.width + 1;
          }

          function getHeightOffset() {
            return 2 * o.height + 1;
          }

          function getExpandWidth(e) {
            return e + 10 + getWidthOffset();
          }

          function getExpandHeight(e) {
            return e + 10 + getHeightOffset();
          }

          function positionScrollbars(e, t, n) {
            var r = getExpandElement(e),
                i = getShrinkElement(e),
                a = getExpandWidth(t),
                o = getExpandHeight(n),
                s = function getShrinkWidth(e) {
              return 2 * e + getWidthOffset();
            }(t),
                l = function getShrinkHeight(e) {
              return 2 * e + getHeightOffset();
            }(n);

            r.scrollLeft = a, r.scrollTop = o, i.scrollLeft = s, i.scrollTop = l;
          }

          function injectContainerElement() {
            var e = i(s).container;

            if (!e) {
              (e = document.createElement("div")).className = l, e.style.cssText = buildCssTextString(["visibility: hidden", "display: inline", "width: 0px", "height: 0px", "z-index: -1", "overflow: hidden", "margin: 0", "padding: 0"]), i(s).container = e, function addAnimationClass(e) {
                e.className += " " + l + "_animation_active";
              }(e), s.appendChild(e);

              var t = function onAnimationStart() {
                i(s).onRendered && i(s).onRendered();
              };

              addEvent(e, "animationstart", t), i(s).onAnimationStart = t;
            }

            return e;
          }

          function injectScrollElements() {
            if (debug("Injecting elements"), i(s)) {
              !function alterPositionStyles() {
                var n = i(s).style;

                if ("static" === n.position) {
                  s.style.setProperty("position", "relative", e.important ? "important" : "");

                  var r = function removeRelativeStyles(e, t, n, r) {
                    var i = n[r];
                    "auto" !== i && "0" !== function getNumericalValue(e) {
                      return e.replace(/[^-\d\.]/g, "");
                    }(i) && (e.warn("An element that is positioned static has style." + r + "=" + i + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + r + " will be set to 0. Element: ", t), t.style[r] = 0);
                  };

                  r(t, s, n, "top"), r(t, s, n, "right"), r(t, s, n, "bottom"), r(t, s, n, "left");
                }
              }();
              var n = i(s).container;
              n || (n = injectContainerElement());
              var r = o.width,
                  a = o.height,
                  c = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%", "left: 0px", "top: 0px"]),
                  p = buildCssTextString(["position: absolute", "flex: none", "overflow: hidden", "z-index: -1", "visibility: hidden"].concat(function getLeftTopBottomRightCssText(e, t, n, r) {
                return ["left: " + (e = e ? e + "px" : "0"), "top: " + (t = t ? t + "px" : "0"), "right: " + (r = r ? r + "px" : "0"), "bottom: " + (n = n ? n + "px" : "0")];
              }(-(1 + r), -(1 + a), -a, -r))),
                  d = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]),
                  h = buildCssTextString(["position: absolute", "flex: none", "overflow: scroll", "z-index: -1", "visibility: hidden", "width: 100%", "height: 100%"]),
                  u = buildCssTextString(["position: absolute", "left: 0", "top: 0"]),
                  f = buildCssTextString(["position: absolute", "width: 200%", "height: 200%"]),
                  m = document.createElement("div"),
                  g = document.createElement("div"),
                  v = document.createElement("div"),
                  b = document.createElement("div"),
                  y = document.createElement("div"),
                  x = document.createElement("div");
              m.dir = "ltr", m.style.cssText = c, m.className = l, g.className = l, g.style.cssText = p, v.style.cssText = d, b.style.cssText = u, y.style.cssText = h, x.style.cssText = f, v.appendChild(b), y.appendChild(x), g.appendChild(v), g.appendChild(y), m.appendChild(g), n.appendChild(m), addEvent(v, "scroll", onExpandScroll), addEvent(y, "scroll", onShrinkScroll), i(s).onExpandScroll = onExpandScroll, i(s).onShrinkScroll = onShrinkScroll;
            } else debug("Aborting because element has been uninstalled");

            function onExpandScroll() {
              i(s).onExpand && i(s).onExpand();
            }

            function onShrinkScroll() {
              i(s).onShrink && i(s).onShrink();
            }
          }

          function registerListenersAndPositionElements() {
            function updateChildSizes(t, n, r) {
              var i = function getExpandChildElement(e) {
                return getExpandElement(e).childNodes[0];
              }(t),
                  a = getExpandWidth(n),
                  o = getExpandHeight(r);

              i.style.setProperty("width", a + "px", e.important ? "important" : ""), i.style.setProperty("height", o + "px", e.important ? "important" : "");
            }

            function updateDetectorElements(r) {
              var o = s.offsetWidth,
                  l = s.offsetHeight,
                  c = o !== i(s).lastWidth || l !== i(s).lastHeight;
              debug("Storing current size", o, l), storeCurrentSize(s, o, l), n.add(0, function performUpdateChildSizes() {
                if (c) if (i(s)) {
                  if (areElementsInjected()) {
                    if (e.debug) {
                      var n = s.offsetWidth,
                          r = s.offsetHeight;
                      n === o && r === l || t.warn(a.get(s), "Scroll: Size changed before updating detector elements.");
                    }

                    updateChildSizes(s, o, l);
                  } else debug("Aborting because element container has not been initialized");
                } else debug("Aborting because element has been uninstalled");
              }), n.add(1, function updateScrollbars() {
                i(s) ? areElementsInjected() ? positionScrollbars(s, o, l) : debug("Aborting because element container has not been initialized") : debug("Aborting because element has been uninstalled");
              }), c && r && n.add(2, function () {
                i(s) ? areElementsInjected() ? r() : debug("Aborting because element container has not been initialized") : debug("Aborting because element has been uninstalled");
              });
            }

            function areElementsInjected() {
              return !!i(s).container;
            }

            function notifyListenersIfNeeded() {
              debug("notifyListenersIfNeeded invoked");
              var e = i(s);
              return function isFirstNotify() {
                return void 0 === i(s).lastNotifiedWidth;
              }() && e.lastWidth === e.startSize.width && e.lastHeight === e.startSize.height ? debug("Not notifying: Size is the same as the start size, and there has been no notification yet.") : e.lastWidth === e.lastNotifiedWidth && e.lastHeight === e.lastNotifiedHeight ? debug("Not notifying: Size already notified") : (debug("Current size not notified, notifying..."), e.lastNotifiedWidth = e.lastWidth, e.lastNotifiedHeight = e.lastHeight, void r(i(s).listeners, function (e) {
                e(s);
              }));
            }

            function handleScroll() {
              debug("Scroll detected."), isUnrendered(s) ? debug("Scroll event fired while unrendered. Ignoring...") : updateDetectorElements(notifyListenersIfNeeded);
            }

            if (debug("registerListenersAndPositionElements invoked."), i(s)) {
              i(s).onRendered = function handleRender() {
                if (debug("startanimation triggered."), isUnrendered(s)) debug("Ignoring since element is still unrendered...");else {
                  debug("Element rendered.");
                  var e = getExpandElement(s),
                      t = getShrinkElement(s);
                  0 !== e.scrollLeft && 0 !== e.scrollTop && 0 !== t.scrollLeft && 0 !== t.scrollTop || (debug("Scrollbars out of sync. Updating detector elements..."), updateDetectorElements(notifyListenersIfNeeded));
                }
              }, i(s).onExpand = handleScroll, i(s).onShrink = handleScroll;
              var o = i(s).style;
              updateChildSizes(s, o.width, o.height);
            } else debug("Aborting because element has been uninstalled");
          }

          function finalizeDomMutation() {
            if (debug("finalizeDomMutation invoked."), i(s)) {
              var e = i(s).style;
              storeCurrentSize(s, e.width, e.height), positionScrollbars(s, e.width, e.height);
            } else debug("Aborting because element has been uninstalled");
          }

          function ready() {
            c(s);
          }

          function install() {
            debug("Installing..."), function initListeners() {
              i(s).listeners = [];
            }(), function storeStartSize() {
              var e = getStyle();
              i(s).startSize = {
                width: e.width,
                height: e.height
              }, debug("Element start size", i(s).startSize);
            }(), n.add(0, storeStyle), n.add(1, injectScrollElements), n.add(2, registerListenersAndPositionElements), n.add(3, finalizeDomMutation), n.add(4, ready);
          }

          c || (c = s, s = e, e = null), e = e || {}, debug("Making detectable..."), function isDetached(e) {
            return !function isInDocument(e) {
              return e === e.ownerDocument.body || e.ownerDocument.body.contains(e);
            }(e) || null === window.getComputedStyle(e);
          }(s) ? (debug("Element is detached"), injectContainerElement(), debug("Waiting until element is attached..."), i(s).onRendered = function () {
            debug("Element is now attached"), install();
          }) : install();
        },
        addListener: function addListener(e, t) {
          if (!i(e).listeners.push) throw new Error("Cannot add listener to an element that is not detectable.");
          i(e).listeners.push(t);
        },
        uninstall: function uninstall(e) {
          var t = i(e);
          t && (t.onExpandScroll && removeEvent(getExpandElement(e), "scroll", t.onExpandScroll), t.onShrinkScroll && removeEvent(getShrinkElement(e), "scroll", t.onShrinkScroll), t.onAnimationStart && removeEvent(t.container, "animationstart", t.onAnimationStart), t.container && e.removeChild(t.container));
        },
        initDocument: initDocument
      };
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = function invariant(e, t, n, r, i, a, o, s) {
      if (!e) {
        var l;
        if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [n, r, i, a, o, s],
              p = 0;
          (l = new Error(t.replace(/%s/g, function () {
            return c[p++];
          }))).name = "Invariant Violation";
        }
        throw l.framesToPop = 1, l;
      }
    };
  }, function (e, t, n) {
    var r = n(255);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-table {\n  border-spacing: 0;\n  empty-cells: show;\n  border: 1px solid var(--color-p1-4);\n  font-family: var(--marketing-font-family);\n  color: var(--color-p1-10);\n  font-size: 14px;\n  width: 100%;\n  border-radius: 3px;\n}\n\n.tide-table-scroll-x {\n  display: block;\n  overflow-x: auto;\n  width: 100%;\n}\n\n.tide-table caption {\n  color: var(--color-p1-10);\n  font: italic 85%/1;\n  padding: 1em 0;\n  text-align: center;\n}\n\n.tide-table td,\n.tide-table th {\n  border-left: 1px solid transparent;\n  font-size: inherit;\n  margin: 0;\n  overflow: visible;\n  padding: 1em;\n}\n\n.tide-table th {\n  padding: 6px 14px;\n  color: var(--color-p1-10);\n}\n\n.tide-table thead,\n.tide-table thead td,\n.tide-table thead th {\n  background-color: var(--color-p1-3);\n  text-align: left;\n  vertical-align: middle;\n  line-height: var(--main-spacing-heading-6);\n  letter-spacing: var(--main-letter-spacing--loose)\n}\n\n.tide-table thead th span.tide-text-span {\n  position: relative;\n  font-size: 12px;\n}\n\n.tide-table tbody td {\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.tide-table.tide-table--clickable-rows tbody tr {\n  cursor: pointer;\n}\n\n.tide-table.tide-table--clickable-rows tbody tr:hover {\n  box-shadow: var(--box-shadow-2);\n  z-index: 1;\n}\n\n.tide-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.tide-table-column-header--sortable {\n  cursor: pointer;\n  position: relative;\n}\n\n.tide-table-column-header--sortable.tide-table-column-header--sorting-asc > span:after {\n  content: '';\n  width: 0; \n  height: 0;\n  position: absolute;\n  top: 2px;\n  right: -15px;\n  display: inline-block;\n  vertical-align: top;\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n  border-bottom: 4px solid var(--color-p1-10);\n  opacity: 0;\n  transition: opacity .3s ease-in\n}\n\n.tide-table-column-header--sorting-desc.tide-table-column-header--sortable > span:after {\n  content: '';\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: 2px;\n  right: -15px;\n  display: inline-block;\n  vertical-align: top;\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n  border-top: 4px solid var(--color-p1-10);\n  opacity: 0;\n  transition: opacity .1s ease-in\n}\n\n.tide-table th.tide-table-column-header--sortable:hover,\n.tide-table th.tide-table-column-header--sorting {\n  color: var(--color-p1-10);\n}\n\n.tide-table-column-header--sortable.tide-table-column-header--sorting > span:after,\n.tide-table-column-header--sortable:hover > span:after {\n  opacity: 1;\n}\n\n.tide-table-fetcher {\n  height: 6px;\n  overflow: hidden;\n  display: block;\n  margin: -6px 0 0 0;\n}", ""]);
  }, function (e, t, n) {
    var r = n(257);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-textarea {\n  border: 1px solid var(--color-p3-4);\n  background: var(--color-p1-2);\n  border-radius: 3px;\n  padding: 8px;\n  font-size: 14px;\n  line-height: var(--main-spacing-heading-5);\n  letter-spacing: var(--main-letter-spacing);\n  width: 100%;\n  display: block;\n  color: var(--color-p1-8);\n  box-sizing: border-box;\n}\n\n.tide-textarea:hover {\n  border-color: var(--color-p3-5);\n}\n\n.tide-textarea::-webkit-input-placeholder {\n  color: var(--color-p1-5);\n  font-size: var(--font-size-copy);\n  line-height: var(--main-spacing-paragraph-1);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-textarea::-ms-input-placeholder {\n  color: var(--color-p1-5);\n  font-size: var(--font-size-copy);\n  line-height: var(--main-spacing-paragraph-1);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-textarea::placeholder {\n  color: var(--color-p1-5);\n  font-size: var(--font-size-copy);\n  line-height: var(--main-spacing-paragraph-1);\n  letter-spacing: var(--main-letter-spacing);\n}\n\n.tide-textarea:focus {\n  outline: none;\n  border: 1px solid var(--color-p3);\n}\n\n.tide-textarea:disabled {\n  background: var(--color-p1-3);\n  border-color: var(--color-p1-5);\n  cursor: not-allowed;\n}\n\n.tide-textarea.tide-textarea--error {\n  border-color: var(--color-s3);\n}\n\n.tide-textarea.tide-textarea--error:hover {\n  border-color: var(--color-s3-7); \n}\n\n.tide-textarea--wrapper .tide-textarea--label {\n  margin-bottom: 4px;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(259);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-text-loader {\n  opacity: 1;\n  transition: all .5s ease;\n  display: block;\n  width: 300px;\n  height: 100px;\n}\n\n.tide-text-loader--loaded {\n  opacity: 0;\n  height: 0;\n  overflow: hidden;\n  display: block;\n  margin: 0 auto;\n}\n\n.tide-text-loader p {\n  display: block;\n  text-align: center\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(261);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-toggle {\n  position: relative;\n  display: inline-block;\n  vertical-align: top;\n  width: 60px;\n  height: 40px;\n}\n\n.tide-toggle-outer {\n  position: absolute;\n  top: 14px;\n  left: 24px;\n  width: 50px;\n  height: 30px;\n  border-radius: 100px;\n  background-color: var(--color-p1-5);\n  margin: -10px -20px;\n  overflow: hidden;\n  transition: var(--transition-catchall-simple);\n}\n\n.tide-toggle-outer:hover {\n  background: var(--color-p1-5-5);\n}\n\n.tide-toggle-outer.tide-toggle-small {\n  height: 20px;\n  width: 35px;\n}\n\n.tide-toggle-outer.tide-toggle-medium {\n  height: 24px;\n  width: 44px;\n}\n\n.tide-toggle-outer.tide-toggle-large {\n  height: 30px;\n  width: 54px;\n}\n\n.tide-toggle-checkbox {\n  position: absolute;\n  display: block;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  z-index: 6;\n}\n\n.tide-toggle-checkbox:checked ~ .tide-toggle--switch {\n  right: 2px;\n  left: 22px;\n  transition-property: left, right;\n  transition-delay: .05s, 0s;\n}\n\n.tide-toggle-small .tide-toggle-checkbox:checked ~ .tide-toggle--switch {\n  right: 2px;\n  left: 17px;\n}\n\n.tide-toggle-large .tide-toggle-checkbox:checked ~ .tide-toggle--switch {\n  right: 2px;\n  left: 26px;\n}\n\n.tide-toggle-small .tide-toggle--switch {\n  height: 16px;\n  width: 16px;\n}\n\n.tide-toggle-medium .tide-toggle--switch {\n  height: 20px;\n  width: 20px;\n}\n\n.tide-toggle-large .tide-toggle--switch {\n  height: 26px;\n  width: 26px;\n}\n\n.tide-toggle--switch {\n  position: absolute;\n  left: 2px;\n  top: 2px;\n  bottom: 2px;\n  right: 22px;\n  background-color: var(--color-p1-2);\n  border-radius: 50%;\n  transition: var(--transition-catchall-simple);\n  transition-property: left, right;\n  transition-delay: 0s, .05s;\n}\n\n.tide-toggle--track {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  transition: var(--transition-catchall-simple);\n  border-radius: 40px;\n}\n\n.tide-toggle-checkbox:checked  ~ .tide-toggle--track {\n   background: var(--color-p3);\n}\n\n.tide-toggle-checkbox:checked:hover ~ .tide-toggle--track {\n  background: var(--color-p3-7);\n}\n\n/* disabled styles */\n.tide-toggle.disabled .tide-toggle-checkbox {\n  cursor: default;\n}\n\n.tide-toggle.disabled .tide-toggle-checkbox ~ .tide-toggle--track {\n  background: var(--color-p1-4);\n}\n\n.tide-toggle.disabled .tide-toggle-checkbox:checked  ~ .tide-toggle--track {\n  background: var(--color-p3-4);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(263);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-tooltip {\n  z-index: 10000;\n  width: 100%;\n  white-space: nowrap;\n  width: auto;\n  font-family: var(--marketing-font-family--semibold);\n  font-size: 12px;\n}\n\n.tide-tooltip--wrapper {\n  position: relative;\n}\n\n.tide-tooltip::before,\n.tide-tooltip {\n  text-transform: none;\n  font-size: .9em;\n  line-height: 1;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  position: absolute;\n  display: none;\n  opacity: 0;\n}\n\n.tide-tooltip::before {\n  content: '';\n  border: 5px solid transparent;\n  z-index: 1001;\n}\n\n.tide-tooltip {\n  padding: 8px;\n  border-radius: 3px;\n  box-shadow: 0 1em 2em -.5em rgba(var(--color-p1-a), 0.35);\n  background: var(--color-p1);\n  line-height: 1.2;\n  color: #fff;\n  z-index: 1000;\n  position: absolute;\n}\n\n.tide-tooltip--hover:hover .tide-tooltip::before,\n.tide-tooltip.tide-tooltip--open::before,\n.tide-tooltip.tide-tooltip--open,\n.tide-tooltip--hover:hover .tide-tooltip{\n  display: block;\n  content: '';\n}\n\n.tide-tooltip--up {\n  bottom: calc(100% + 2.5ex);\n  left: 50%;\n  -webkit-transform: translate(-50%, -.5em);\n          transform: translate(-50%, -.5em);\n}\n\n.tide-tooltip--up::before{\n  left: 50%;\n  bottom: -11px;\n  -webkit-transform: translate(-50%, -.5em);\n          transform: translate(-50%, -.5em);\n  border-bottom-width: 0;\n  border-top-color: var(--color-p1);\n}\n\n.tide-tooltip--down::before {\n  bottom: calc(100% + 6px);\n  border-top-width: 0;\n  border-bottom-color: var(--color-p1);\n}\n.tide-tooltip--down {\n  top: calc(100% + 2.5ex);\n}\n.tide-tooltip--down::before,\n.tide-tooltip--down {\n  left: 50%;\n  -webkit-transform: translate(-50%, .5em);\n          transform: translate(-50%, .5em);\n}\n\n.tide-tooltip--left::before {\n  top: 50%;\n  border-right-width: 0;\n  border-left-color: var(--color-p1);\n  right: -11px;\n  -webkit-transform: translate(-.5em, -50%);\n          transform: translate(-.5em, -50%);\n}\n\n.tide-tooltip--left {\n  top: 50%;\n  right: calc(100% + 2.5ex);\n  -webkit-transform: translate(-.5em, -50%);\n          transform: translate(-.5em, -50%);\n}\n\n.tide-tooltip--right::before {\n  top: 50%;\n  border-left-width: 0;\n  border-right-color: var(--color-p1);\n  left: -10px;\n  -webkit-transform: translate(.5em, -50%);\n          transform: translate(.5em, -50%);\n}\n.tide-tooltip--right {\n  top: 50%;\n  left: calc(100% + 2.5ex);\n  -webkit-transform: translate(.5em, -50%);\n          transform: translate(.5em, -50%);\n}\n\n@-webkit-keyframes tooltips-vert {\n  to {\n    -webkit-transform: translate(-50%, 0);\n            transform: translate(-50%, 0);\n  }\n}\n\n@keyframes tooltips-vert {\n  to {\n    -webkit-transform: translate(-50%, 0);\n            transform: translate(-50%, 0);\n  }\n}\n\n@-webkit-keyframes tooltips-horz {\n  to {\n    -webkit-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n  }\n}\n\n@keyframes tooltips-horz {\n  to {\n    -webkit-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n  }\n}\n\n@-webkit-keyframes fade-display {\n  from { opacity: 0; }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fade-display {\n  from { opacity: 0; }\n  to {\n    opacity: 1;\n  }\n}\n\n.tide-tooltip--hover:hover .tide-tooltip--up,\n.tide-tooltip--hover:hover .tide-tooltip--down,\n.tide-tooltip--open.tide-tooltip--up,\n.tide-tooltip--open.tide-tooltip--down {\n  -webkit-animation: tooltips-vert 250ms ease-out forwards, \n    fade-display 250ms ease-out forwards;\n          animation: tooltips-vert 250ms ease-out forwards, \n    fade-display 250ms ease-out forwards;\n}\n\n.tide-tooltip--hover:hover .tide-tooltip--left,\n.tide-tooltip--hover:hover .tide-tooltip--right,\n.tide-tooltip--open.tide-tooltip--left,\n.tide-tooltip--open.tide-tooltip--right {\n  -webkit-animation: tooltips-horz 250ms ease-out forwards, \n    fade-display 250ms ease-out forwards;\n          animation: tooltips-horz 250ms ease-out forwards, \n    fade-display 250ms ease-out forwards;\n}\n\n\n.tide-tooltip--hover:hover .tide-tooltip::before,\n.tide-tooltip--open::before  {\n  -webkit-animation: fade-display 250ms ease-out forwards;\n          animation: fade-display 250ms ease-out forwards;\n}", ""]);
  }, function (e, t, n) {
    var r = n(265);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, '.tide-tooltip-tethered--wrapper {\n  display: inline-block;\n}\n\n.tide-tooltip-tethered--target {\n  display: block;\n}\n\n.tide-tooltip-tethered {\n  white-space: nowrap;\n  width: auto;\n  font-family: var(--marketing-font-family--semibold);\n  font-size: 12px;\n  padding: 8px;\n  border-radius: 3px;\n  box-shadow: 0 1em 2em -.5em rgba(var(--color-p1-a), 0.35);\n  background: var(--color-p1);\n  line-height: 1.2;\n  color: #fff;\n  transition: opacity 75ms ease-out;\n  z-index: 100000;\n  pointer-events: none;\n\n  opacity: 0;\n  display: none;\n}\n\n.tide-tooltip-tethered::before {\n  content: \'\';\n  display: block;\n  position: absolute;\n  border: 5px solid transparent;\n}\n\n.tide-tooltip-tethered.tide-tooltip-tethered--open {\n  opacity: 1;\n  display: block;\n}\n\n.tide-tooltip-tethered[data-out-of-bounds="true"] {\n  opacity: 0;\n  display: none;\n}\n\n.tide-tooltip-tethered[data-placement="right"]::before {\n  border-right-color: var(--color-p1);\n  -webkit-transform: translateY(2.5px);\n          transform: translateY(2.5px);\n  left: -10px;\n}\n\n.tide-tooltip-tethered[data-placement="left"]::before {\n  border-left-color: var(--color-p1);\n  -webkit-transform: translateY(2.5px);\n          transform: translateY(2.5px);\n  right: -10px;\n}\n\n.tide-tooltip-tethered[data-placement="top"]::before {\n  border-top-color: var(--color-p1);\n  left: calc(50% - 5px);\n  bottom: -10px;\n}\n\n.tide-tooltip-tethered[data-placement="bottom"]::before {\n  border-bottom-color: var(--color-p1);\n  left: calc(50% - 5px);\n  top: -10px;\n}\n\n/**\n * Animations\n */\n\n.tide-tooltip-tethered--open[data-placement="top"] {\n  -webkit-animation: tide-tooltip-tethered--slide-in--top 250ms ease forwards;\n          animation: tide-tooltip-tethered--slide-in--top 250ms ease forwards;\n}\n\n.tide-tooltip-tethered--open[data-placement="bottom"] {\n  -webkit-animation: tide-tooltip-tethered--slide-in--bottom 250ms ease forwards;\n          animation: tide-tooltip-tethered--slide-in--bottom 250ms ease forwards;\n}\n\n.tide-tooltip-tethered--open[data-placement="left"] {\n  -webkit-animation: tide-tooltip-tethered--slide-in--left 250ms ease forwards;\n          animation: tide-tooltip-tethered--slide-in--left 250ms ease forwards;\n}\n\n.tide-tooltip-tethered--open[data-placement="right"] {\n  -webkit-animation: tide-tooltip-tethered--slide-in--right 250ms ease forwards;\n          animation: tide-tooltip-tethered--slide-in--right 250ms ease forwards;\n}\n\n@-webkit-keyframes tide-tooltip-tethered--slide-in--top {\n  from { top: -8px; }\n  to { top: 0; }\n}\n\n@keyframes tide-tooltip-tethered--slide-in--top {\n  from { top: -8px; }\n  to { top: 0; }\n}\n\n@-webkit-keyframes tide-tooltip-tethered--slide-in--bottom {\n  from { top: 8px; }\n  to { top: 0; }\n}\n\n@keyframes tide-tooltip-tethered--slide-in--bottom {\n  from { top: 8px; }\n  to { top: 0; }\n}\n\n@-webkit-keyframes tide-tooltip-tethered--slide-in--left {\n  from { left: -8px; }\n  to { left: 0; }\n}\n\n@keyframes tide-tooltip-tethered--slide-in--left {\n  from { left: -8px; }\n  to { left: 0; }\n}\n\n@-webkit-keyframes tide-tooltip-tethered--slide-in--right {\n  from { left: 8px; }\n  to { left: 0; }\n}\n\n@keyframes tide-tooltip-tethered--slide-in--right {\n  from { left: 8px; }\n  to { left: 0; }\n}', ""]);
  }, function (e, t, n) {
    var r = n(267);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".multi-string-compact-container {\n  background: var(--main-white);\n  border: 1px solid var(--color-p3-4);\n  box-sizing: border-box;\n  border-radius: 3px;\n  display: block;\n  margin: 0;\n  min-height: 75px;\n  padding: 5px;\n  position: relative;\n  width: 100%;\n  color: var(--color-p1-10);\n}\n\n.multi-string-compact-container.disabled {\n  background: var(--color-p1-3);\n  border: 1px solid var(--color-p1-5);\n}\n\n.multi-string-compact-chip {\n  height: 20px;\n  -webkit-align-items: center;\n          align-items: center;\n  background: var(--color-p3-2);\n  border: 1px solid var(--color-p3-4);\n  border-radius: 100px;\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  margin: 2px 0 2px 2px;\n  padding: 0 0 0 8px;\n  transition: var(--transition-catchall-simple);\n}\n\n.multi-string-compact-container .multi-string-compact-chip p {\n  line-height: 20px;\n  padding: 2px 0;\n  color: var(--color-p3-10);\n}\n\n.multi-string-compact-chip.icon-hover:hover {\n  border: 1px solid var(--color-p3-5);\n}\n\n.multi-string-compact-chip.disabled {\n  background: var(--color-p1-3);\n  border: 1px solid var(--color-p1-5);\n  color: var(--color-p1-7);\n  margin: 2px;\n  padding: 2px 8px;\n}\n\n.multi-string-compact-chip-icon-container {\n  cursor: pointer;\n  margin-left: 2px;\n  height: 20px;\n  border-radius: 0 100px 100px 0;\n  transition: var(--transition-catchall-simple);\n}\n\n.multi-string-compact-chip-icon-container:hover {\n  background: var(--color-p3-3);\n}\n\n.multi-string-compact-chip-icon path {\n  fill: var(--color-p3-10);\n  transition: var(--transition-catchall-simple);\n}\n\n.multi-string-compact-chip-icon-container:hover .multi-string-compact-chip-icon path {\n  fill: var(--color-p3-6);\n}\n\n.multi-string-compact-chip svg {\n  margin: 0 8px 1px 6px;\n}\n\n.multi-string-compact-chip.disabled svg {\n  cursor: default;\n}\n\n.multi-string-compact-input {\n  background: transparent;\n  border: none;\n  color: var(--color-p1-10);\n  font-size: var(--font-size-copy);\n  height: 24px;\n  line-height: 24px;\n  margin: 2px;\n  vertical-align: top;\n}\n\n.multi-string-compact-input:active,\n.multi-string-compact-input:focus {\n  outline: none;\n}\n.multi-string-compact-error {\n  color: var(--utility-red-light);\n  display: inline-block;\n}\n\n.multi-string-compact-count {\n  color: var(--color-p1-6)\n}\n\n.multi-string-compact-bottom-bar {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n  margin-top: 5px;\n}\n\nspan.multi-string-compact-error .tide-inline-warning {\n  margin: 0px;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(269);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-content-container--fixed-width {\n  max-width: 800px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.tide-content-container--split-width, .tide-content-container--left-aligned, .tide-content-container--right-aligned {\n  width: 100%;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n}\n\n.tide-content-container--split-width > div.tide-div {\n  width: var(--main-spacing-one-half);\n}\n\n.tide-content-container--split-width > div.tide-div:first-of-type {\n  margin-right: 24px;\n}\n\n.tide-content-container--left-aligned > div.tide-div:first-of-type {\n  width: calc(var(--main-spacing-one-third) * 2);\n  margin-right: 24px;\n}\n\n.tide-content-container--left-aligned > div.tide-div:last-of-type {\n  width: var(--main-spacing-one-third);\n}\n\n.tide-content-container--right-aligned > div.tide-div:first-of-type {\n  width: var(--main-spacing-one-third);\n  margin-right: 24px;\n}\n\n.tide-content-container--right-aligned > div.tide-div:last-of-type {\n  width: calc(var(--main-spacing-one-third) * 2);\n}", ""]);
  }, function (e, t, n) {
    var r = n(271);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-toggle-block {\n  display: -webkit-flex;\n  display: flex;\n  padding: 18px 24px;\n  border: 1px solid var(--color-p1-4);\n  border-radius: 3px;\n  width: 100%;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n}\n\n.tide-toggle-block-content {\n  margin-right: 24px;\n}\n\n.tide-toggle-block-title {\n  margin-top: 0;\n}\n\n.tide-toggle-block-description {\n  margin: 3px 0 0;\n  font-size: var(--font-size-subtle);\n  color: var(--color-p1-8);\n  line-height: 16px;\n  font-family: var(--marketing-font-family);\n}\n\n.tide-toggle-block-toggle-wrapper {\n  margin: auto 0;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(273);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-header-container{\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  border-bottom: 1px solid var(--color-p1-5);\n}\n\n.tide-title-container{\n  display: -webkit-flex;\n  display: flex;\n  padding: 0px 0px 8px 0px;\n}\n\n.tide-header-title {\n  margin: 0 0 4px 0;\n}\n\n.tide-header-content-container {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: center;\n          align-items: center;\n  margin: 0 0 10px 0;\n}\n\n.tide-header-content-container-text {\n  margin-right: 24px;\n}\n\n.tide-header-content-description {\n  margin: 0px;\n  font-family: var(--marketing-font-family);\n  font-size: 14px;\n  line-height: 1.43;\n  letter-spacing: -0.16px;\n  color: var(--color-p1-6);\n}\n\n.tide-header-content-button-container {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-self: flex-end;\n          align-self: flex-end;\n  margin: auto;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(275);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, '.tide-selection-blocks--header {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-justify-content: space-between;\n          justify-content: space-between;\n}\n\n.tide-selection-blocks--header .tide-heading-4 {\n  margin: 0;\n}\n\n.tide-selection-blocks-option {\n  margin: 8px 0 0;\n  padding: 10px 16px;\n  border: 1px solid var(--color-p3-4);\n  border-radius: 3px;\n}\n\n.tide-selection-blocks-option:not(.tide-selection-blocks-option--selected):hover {\n  background-color: var(--color-p3-2);\n  border: 1px solid var(--color-p3-5);\n}\n\n.tide-selection-blocks-option:not(.tide-selection-blocks-option--selected):hover input.tide-input[type="radio"],\n.tide-selection-blocks-option:not(.tide-selection-blocks-option--selected):hover {\n  border: 1px solid var(--color-p3-5);\n}\n\n.tide-selection-blocks-option--selected {\n  background-color: var(--color-p3-2);\n  border: 1px solid var(--color-p3-6);\n}\n\n.tide-selection-blocks-option-selectable {\n  display: -webkit-flex;\n  display: flex;\n}\n\n.tide-selection-blocks-option-selectable .raw-input {\n  vertical-align: top;\n}\n\n.tide-selection-blocks-option--label {\n  margin: 0 0 0 8px;\n  width: 100%;\n  cursor: pointer;\n}\n\n.tide-selection-blocks-option--selected .tide-selection-blocks-option--label {\n  cursor: default;\n}\n\n.tide-selection-blocks-option--title {\n  font-family: var(--marketing-font-family--semibold);\n}\n\n.tide-selection-blocks-option--label .tide-paragraph {\n  margin: 0;\n}\n\n.tide-selection-blocks-option-content {\n  margin: 16px 0 0 28px;\n}', ""]);
  }, function (e, t, n) {
    var r = n(277);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-quick-item {\n  -webkit-align-items: center;\n          align-items: center;\n  color: var(--color-p1-6);\n  cursor: pointer;\n  display: -webkit-flex;\n  display: flex;\n  position: relative;\n  transition: color 150ms ease-out;\n}\n\n.tide-quick-item:hover {\n  color: var(--color-p1-8);\n}\n\n.tide-quick-item.position-left::before,\n.tide-quick-item.position-right::after {\n  content: attr(data-content-copy);\n}\n\n.tide-quick-item.position-right::after {\n  margin-left: 8px;\n}\n\n.tide-quick-item.position-left::before {\n  margin-right: 8px;\n}\n\n.tide-quick-item__icon {\n  -webkit-align-items: center;\n          align-items: center;\n  background-color: var(--color-p1-2);\n  border-radius: 50%;\n  border: 2px solid var(--color-p1-5);\n  cursor: pointer;\n  display: -webkit-flex;\n  display: flex;\n  height: 24px;\n  -webkit-justify-content: center;\n          justify-content: center;\n  opacity: 1;\n  position: relative;\n  transition: background-color 150ms ease-out;\n  width: 24px;\n  box-sizing: border-box;\n}\n\n.tide-quick-item:hover .tide-quick-item__icon {\n  background-color: var(--color-p1-3);\n}\n\n/* disabled styles */\n.tide-quick-item.disabled:hover,\n.tide-quick-item.disabled:hover .tide-quick-item__icon {\n  cursor: default;\n}\n\n.tide-quick-item.disabled .tide-quick-item__icon {\n  background-color: var(--color-p1-3);\n  border: 2px solid var(--color-p1-4);\n}\n\n.tide-quick-item.disabled:hover .tide-quick-item__icon {\n  border: 2px solid var(--color-p1-4);\n}\n\n.tide-quick-item.disabled .tide-quick-item__icon svg path {\n  fill: var(--color-p1-5);\n  stroke: var(--color-p1-5);\n}\n\n.tide-quick-item.disabled:hover .tide-quick-item__icon svg path {\n  fill: var(--color-p1-5);\n  stroke: var(--color-p1-5);\n}\n\n/* builder styles */\n.builder-style .tide-quick-item__icon {\n  border: 2px solid var(--color-p1-5-5);\n  background-color: var(--color-p3-2);\n}\n\n.builder-style:hover .tide-quick-item__icon {\n  border: 2px solid var(--color-p1-6);\n}\n\n.builder-style .tide-quick-item__icon svg path {\n  stroke: var(--color-p1-5-5);\n  fill: var(--color-p1-5-5);\n}\n\n.builder-style:hover .tide-quick-item__icon svg path {\n  stroke: var(--color-p1-6);\n  fill: var(--color-p1-6);\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AlphaPicker = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = _interopRequireDefault(n(0)),
        a = _interopRequireDefault(n(5)),
        o = n(7),
        s = _interopRequireDefault(n(469));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var l = t.AlphaPicker = function AlphaPicker(e) {
      var t = e.rgb,
          n = e.hsl,
          s = e.width,
          l = e.height,
          c = e.onChange,
          p = e.direction,
          d = e.style,
          h = e.renderers,
          u = e.pointer,
          f = e.className,
          m = void 0 === f ? "" : f,
          g = (0, a.default)({
        default: {
          picker: {
            position: "relative",
            width: s,
            height: l
          },
          alpha: {
            radius: "2px",
            style: d
          }
        }
      });
      return i.default.createElement("div", {
        style: g.picker,
        className: "alpha-picker " + m
      }, i.default.createElement(o.Alpha, r({}, g.alpha, {
        rgb: t,
        hsl: n,
        pointer: u,
        renderers: h,
        onChange: c,
        direction: p
      })));
    };

    l.defaultProps = {
      width: "316px",
      height: "16px",
      direction: "horizontal",
      pointer: s.default
    }, t.default = (0, o.ColorWrap)(l);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.flattenNames = void 0;

    var r = _interopRequireDefault(n(280)),
        i = _interopRequireDefault(n(52)),
        a = _interopRequireDefault(n(292)),
        o = _interopRequireDefault(n(293));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.flattenNames = function flattenNames() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = [];
      return (0, o.default)(e, function (e) {
        Array.isArray(e) ? flattenNames(e).map(function (e) {
          return t.push(e);
        }) : (0, a.default)(e) ? (0, i.default)(e, function (e, n) {
          !0 === e && t.push(n), t.push(n + "-" + e);
        }) : (0, r.default)(e) && t.push(e);
      }), t;
    };

    t.default = s;
  }, function (e, t, n) {
    var r = n(22),
        i = n(12),
        a = n(18),
        o = "[object String]";

    e.exports = function isString(e) {
      return "string" == typeof e || !i(e) && a(e) && r(e) == o;
    };
  }, function (e, t, n) {
    var r = n(33),
        i = Object.prototype,
        a = i.hasOwnProperty,
        o = i.toString,
        s = r ? r.toStringTag : void 0;

    e.exports = function getRawTag(e) {
      var t = a.call(e, s),
          n = e[s];

      try {
        e[s] = void 0;
        var r = !0;
      } catch (l) {}

      var i = o.call(e);
      return r && (t ? e[s] = n : delete e[s]), i;
    };
  }, function (e, t) {
    var n = Object.prototype.toString;

    e.exports = function objectToString(e) {
      return n.call(e);
    };
  }, function (e, t, n) {
    var r = n(284)();
    e.exports = r;
  }, function (e, t) {
    e.exports = function createBaseFor(e) {
      return function (t, n, r) {
        for (var i = -1, a = Object(t), o = r(t), s = o.length; s--;) {
          var l = o[e ? s : ++i];
          if (!1 === n(a[l], l, a)) break;
        }

        return t;
      };
    };
  }, function (e, t) {
    e.exports = function baseTimes(e, t) {
      for (var n = -1, r = Array(e); ++n < e;) {
        r[n] = t(n);
      }

      return r;
    };
  }, function (e, t, n) {
    var r = n(22),
        i = n(18),
        a = "[object Arguments]";

    e.exports = function baseIsArguments(e) {
      return i(e) && r(e) == a;
    };
  }, function (e, t) {
    e.exports = function stubFalse() {
      return !1;
    };
  }, function (e, t, n) {
    var r = n(22),
        i = n(54),
        a = n(18),
        o = {};
    o["[object Float32Array]"] = o["[object Float64Array]"] = o["[object Int8Array]"] = o["[object Int16Array]"] = o["[object Int32Array]"] = o["[object Uint8Array]"] = o["[object Uint8ClampedArray]"] = o["[object Uint16Array]"] = o["[object Uint32Array]"] = !0, o["[object Arguments]"] = o["[object Array]"] = o["[object ArrayBuffer]"] = o["[object Boolean]"] = o["[object DataView]"] = o["[object Date]"] = o["[object Error]"] = o["[object Function]"] = o["[object Map]"] = o["[object Number]"] = o["[object Object]"] = o["[object RegExp]"] = o["[object Set]"] = o["[object String]"] = o["[object WeakMap]"] = !1, e.exports = function baseIsTypedArray(e) {
      return a(e) && i(e.length) && !!o[r(e)];
    };
  }, function (e, t, n) {
    var r = n(57),
        i = n(290),
        a = Object.prototype.hasOwnProperty;

    e.exports = function baseKeys(e) {
      if (!r(e)) return i(e);
      var t = [];

      for (var n in Object(e)) {
        a.call(e, n) && "constructor" != n && t.push(n);
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(93)(Object.keys, Object);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(95);

    e.exports = function castFunction(e) {
      return "function" == typeof e ? e : r;
    };
  }, function (e, t, n) {
    var r = n(22),
        i = n(58),
        a = n(18),
        o = "[object Object]",
        s = Function.prototype,
        l = Object.prototype,
        c = s.toString,
        p = l.hasOwnProperty,
        d = c.call(Object);

    e.exports = function isPlainObject(e) {
      if (!a(e) || r(e) != o) return !1;
      var t = i(e);
      if (null === t) return !0;
      var n = p.call(t, "constructor") && t.constructor;
      return "function" == typeof n && n instanceof n && c.call(n) == d;
    };
  }, function (e, t, n) {
    var r = n(96),
        i = n(294),
        a = n(352),
        o = n(12);

    e.exports = function map(e, t) {
      return (o(e) ? r : a)(e, i(t, 3));
    };
  }, function (e, t, n) {
    var r = n(295),
        i = n(339),
        a = n(95),
        o = n(12),
        s = n(349);

    e.exports = function baseIteratee(e) {
      return "function" == typeof e ? e : null == e ? a : "object" == typeof e ? o(e) ? i(e[0], e[1]) : r(e) : s(e);
    };
  }, function (e, t, n) {
    var r = n(296),
        i = n(338),
        a = n(106);

    e.exports = function baseMatches(e) {
      var t = i(e);
      return 1 == t.length && t[0][2] ? a(t[0][0], t[0][1]) : function (n) {
        return n === e || r(n, e, t);
      };
    };
  }, function (e, t, n) {
    var r = n(59),
        i = n(98),
        a = 1,
        o = 2;

    e.exports = function baseIsMatch(e, t, n, s) {
      var l = n.length,
          c = l,
          p = !s;
      if (null == e) return !c;

      for (e = Object(e); l--;) {
        var d = n[l];
        if (p && d[2] ? d[1] !== e[d[0]] : !(d[0] in e)) return !1;
      }

      for (; ++l < c;) {
        var h = (d = n[l])[0],
            u = e[h],
            f = d[1];

        if (p && d[2]) {
          if (void 0 === u && !(h in e)) return !1;
        } else {
          var m = new r();
          if (s) var g = s(u, f, h, e, t, m);
          if (!(void 0 === g ? i(f, u, a | o, s, m) : g)) return !1;
        }
      }

      return !0;
    };
  }, function (e, t) {
    e.exports = function listCacheClear() {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, n) {
    var r = n(38),
        i = Array.prototype.splice;

    e.exports = function listCacheDelete(e) {
      var t = this.__data__,
          n = r(t, e);
      return !(n < 0) && (n == t.length - 1 ? t.pop() : i.call(t, n, 1), --this.size, !0);
    };
  }, function (e, t, n) {
    var r = n(38);

    e.exports = function listCacheGet(e) {
      var t = this.__data__,
          n = r(t, e);
      return n < 0 ? void 0 : t[n][1];
    };
  }, function (e, t, n) {
    var r = n(38);

    e.exports = function listCacheHas(e) {
      return r(this.__data__, e) > -1;
    };
  }, function (e, t, n) {
    var r = n(38);

    e.exports = function listCacheSet(e, t) {
      var n = this.__data__,
          i = r(n, e);
      return i < 0 ? (++this.size, n.push([e, t])) : n[i][1] = t, this;
    };
  }, function (e, t, n) {
    var r = n(37);

    e.exports = function stackClear() {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (e, t) {
    e.exports = function stackDelete(e) {
      var t = this.__data__,
          n = t.delete(e);
      return this.size = t.size, n;
    };
  }, function (e, t) {
    e.exports = function stackGet(e) {
      return this.__data__.get(e);
    };
  }, function (e, t) {
    e.exports = function stackHas(e) {
      return this.__data__.has(e);
    };
  }, function (e, t, n) {
    var r = n(37),
        i = n(61),
        a = n(62),
        o = 200;

    e.exports = function stackSet(e, t) {
      var n = this.__data__;

      if (n instanceof r) {
        var s = n.__data__;
        if (!i || s.length < o - 1) return s.push([e, t]), this.size = ++n.size, this;
        n = this.__data__ = new a(s);
      }

      return n.set(e, t), this.size = n.size, this;
    };
  }, function (e, t, n) {
    var r = n(94),
        i = n(308),
        a = n(28),
        o = n(97),
        s = /^\[object .+?Constructor\]$/,
        l = Function.prototype,
        c = Object.prototype,
        p = l.toString,
        d = c.hasOwnProperty,
        h = RegExp("^" + p.call(d).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function baseIsNative(e) {
      return !(!a(e) || i(e)) && (r(e) ? h : s).test(o(e));
    };
  }, function (e, t, n) {
    var r = n(309),
        i = function () {
      var e = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }();

    e.exports = function isMasked(e) {
      return !!i && i in e;
    };
  }, function (e, t, n) {
    var r = n(17)["__core-js_shared__"];
    e.exports = r;
  }, function (e, t) {
    e.exports = function getValue(e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, n) {
    var r = n(312),
        i = n(37),
        a = n(61);

    e.exports = function mapCacheClear() {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || i)(),
        string: new r()
      };
    };
  }, function (e, t, n) {
    var r = n(313),
        i = n(314),
        a = n(315),
        o = n(316),
        s = n(317);

    function Hash(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    Hash.prototype.clear = r, Hash.prototype.delete = i, Hash.prototype.get = a, Hash.prototype.has = o, Hash.prototype.set = s, e.exports = Hash;
  }, function (e, t, n) {
    var r = n(39);

    e.exports = function hashClear() {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (e, t) {
    e.exports = function hashDelete(e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, n) {
    var r = n(39),
        i = "__lodash_hash_undefined__",
        a = Object.prototype.hasOwnProperty;

    e.exports = function hashGet(e) {
      var t = this.__data__;

      if (r) {
        var n = t[e];
        return n === i ? void 0 : n;
      }

      return a.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, n) {
    var r = n(39),
        i = Object.prototype.hasOwnProperty;

    e.exports = function hashHas(e) {
      var t = this.__data__;
      return r ? void 0 !== t[e] : i.call(t, e);
    };
  }, function (e, t, n) {
    var r = n(39),
        i = "__lodash_hash_undefined__";

    e.exports = function hashSet(e, t) {
      var n = this.__data__;
      return this.size += this.has(e) ? 0 : 1, n[e] = r && void 0 === t ? i : t, this;
    };
  }, function (e, t, n) {
    var r = n(40);

    e.exports = function mapCacheDelete(e) {
      var t = r(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t) {
    e.exports = function isKeyable(e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, n) {
    var r = n(40);

    e.exports = function mapCacheGet(e) {
      return r(this, e).get(e);
    };
  }, function (e, t, n) {
    var r = n(40);

    e.exports = function mapCacheHas(e) {
      return r(this, e).has(e);
    };
  }, function (e, t, n) {
    var r = n(40);

    e.exports = function mapCacheSet(e, t) {
      var n = r(this, e),
          i = n.size;
      return n.set(e, t), this.size += n.size == i ? 0 : 1, this;
    };
  }, function (e, t, n) {
    var r = n(59),
        i = n(99),
        a = n(329),
        o = n(332),
        s = n(41),
        l = n(12),
        c = n(53),
        p = n(92),
        d = 1,
        h = "[object Arguments]",
        u = "[object Array]",
        f = "[object Object]",
        m = Object.prototype.hasOwnProperty;

    e.exports = function baseIsEqualDeep(e, t, n, g, v, b) {
      var y = l(e),
          x = l(t),
          w = y ? u : s(e),
          E = x ? u : s(t),
          C = (w = w == h ? f : w) == f,
          k = (E = E == h ? f : E) == f,
          S = w == E;

      if (S && c(e)) {
        if (!c(t)) return !1;
        y = !0, C = !1;
      }

      if (S && !C) return b || (b = new r()), y || p(e) ? i(e, t, n, g, v, b) : a(e, t, w, n, g, v, b);

      if (!(n & d)) {
        var _ = C && m.call(e, "__wrapped__"),
            M = k && m.call(t, "__wrapped__");

        if (_ || M) {
          var L = _ ? e.value() : e,
              P = M ? t.value() : t;
          return b || (b = new r()), v(L, P, n, g, b);
        }
      }

      return !!S && (b || (b = new r()), o(e, t, n, g, v, b));
    };
  }, function (e, t, n) {
    var r = n(62),
        i = n(325),
        a = n(326);

    function SetCache(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.__data__ = new r(); ++t < n;) {
        this.add(e[t]);
      }
    }

    SetCache.prototype.add = SetCache.prototype.push = i, SetCache.prototype.has = a, e.exports = SetCache;
  }, function (e, t) {
    var n = "__lodash_hash_undefined__";

    e.exports = function setCacheAdd(e) {
      return this.__data__.set(e, n), this;
    };
  }, function (e, t) {
    e.exports = function setCacheHas(e) {
      return this.__data__.has(e);
    };
  }, function (e, t) {
    e.exports = function arraySome(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
        if (t(e[n], n, e)) return !0;
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function cacheHas(e, t) {
      return e.has(t);
    };
  }, function (e, t, n) {
    var r = n(33),
        i = n(100),
        a = n(60),
        o = n(99),
        s = n(330),
        l = n(331),
        c = 1,
        p = 2,
        d = "[object Boolean]",
        h = "[object Date]",
        u = "[object Error]",
        f = "[object Map]",
        m = "[object Number]",
        g = "[object RegExp]",
        v = "[object Set]",
        b = "[object String]",
        y = "[object Symbol]",
        x = "[object ArrayBuffer]",
        w = "[object DataView]",
        E = r ? r.prototype : void 0,
        C = E ? E.valueOf : void 0;

    e.exports = function equalByTag(e, t, n, r, E, k, S) {
      switch (n) {
        case w:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case x:
          return !(e.byteLength != t.byteLength || !k(new i(e), new i(t)));

        case d:
        case h:
        case m:
          return a(+e, +t);

        case u:
          return e.name == t.name && e.message == t.message;

        case g:
        case b:
          return e == t + "";

        case f:
          var _ = s;

        case v:
          var M = r & c;
          if (_ || (_ = l), e.size != t.size && !M) return !1;
          var L = S.get(e);
          if (L) return L == t;
          r |= p, S.set(e, t);
          var P = o(_(e), _(t), r, E, k, S);
          return S.delete(e), P;

        case y:
          if (C) return C.call(e) == C.call(t);
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function mapToArray(e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e, r) {
        n[++t] = [r, e];
      }), n;
    };
  }, function (e, t) {
    e.exports = function setToArray(e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e) {
        n[++t] = e;
      }), n;
    };
  }, function (e, t, n) {
    var r = n(101),
        i = 1,
        a = Object.prototype.hasOwnProperty;

    e.exports = function equalObjects(e, t, n, o, s, l) {
      var c = n & i,
          p = r(e),
          d = p.length;
      if (d != r(t).length && !c) return !1;

      for (var h = d; h--;) {
        var u = p[h];
        if (!(c ? u in t : a.call(t, u))) return !1;
      }

      var f = l.get(e);
      if (f && l.get(t)) return f == t;
      var m = !0;
      l.set(e, t), l.set(t, e);

      for (var g = c; ++h < d;) {
        var v = e[u = p[h]],
            b = t[u];
        if (o) var y = c ? o(b, v, u, t, e, l) : o(v, b, u, e, t, l);

        if (!(void 0 === y ? v === b || s(v, b, n, o, l) : y)) {
          m = !1;
          break;
        }

        g || (g = "constructor" == u);
      }

      if (m && !g) {
        var x = e.constructor,
            w = t.constructor;
        x != w && "constructor" in e && "constructor" in t && !("function" == typeof x && x instanceof x && "function" == typeof w && w instanceof w) && (m = !1);
      }

      return l.delete(e), l.delete(t), m;
    };
  }, function (e, t) {
    e.exports = function arrayFilter(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, i = 0, a = []; ++n < r;) {
        var o = e[n];
        t(o, n, e) && (a[i++] = o);
      }

      return a;
    };
  }, function (e, t, n) {
    var r = n(23)(n(17), "DataView");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(23)(n(17), "Promise");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(23)(n(17), "Set");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(23)(n(17), "WeakMap");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(105),
        i = n(34);

    e.exports = function getMatchData(e) {
      for (var t = i(e), n = t.length; n--;) {
        var a = t[n],
            o = e[a];
        t[n] = [a, o, r(o)];
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(98),
        i = n(340),
        a = n(346),
        o = n(64),
        s = n(105),
        l = n(106),
        c = n(42),
        p = 1,
        d = 2;

    e.exports = function baseMatchesProperty(e, t) {
      return o(e) && s(t) ? l(c(e), t) : function (n) {
        var o = i(n, e);
        return void 0 === o && o === t ? a(n, e) : r(t, o, p | d);
      };
    };
  }, function (e, t, n) {
    var r = n(107);

    e.exports = function get(e, t, n) {
      var i = null == e ? void 0 : r(e, t);
      return void 0 === i ? n : i;
    };
  }, function (e, t, n) {
    var r = n(342),
        i = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        a = /\\(\\)?/g,
        o = r(function (e) {
      var t = [];
      return 46 === e.charCodeAt(0) && t.push(""), e.replace(i, function (e, n, r, i) {
        t.push(r ? i.replace(a, "$1") : n || e);
      }), t;
    });
    e.exports = o;
  }, function (e, t, n) {
    var r = n(343),
        i = 500;

    e.exports = function memoizeCapped(e) {
      var t = r(e, function (e) {
        return n.size === i && n.clear(), e;
      }),
          n = t.cache;
      return t;
    };
  }, function (e, t, n) {
    var r = n(62),
        i = "Expected a function";

    function memoize(e, t) {
      if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(i);

      var n = function memoized() {
        var n = arguments,
            r = t ? t.apply(this, n) : n[0],
            i = memoized.cache;
        if (i.has(r)) return i.get(r);
        var a = e.apply(this, n);
        return memoized.cache = i.set(r, a) || i, a;
      };

      return n.cache = new (memoize.Cache || r)(), n;
    }

    memoize.Cache = r, e.exports = memoize;
  }, function (e, t, n) {
    var r = n(345);

    e.exports = function toString(e) {
      return null == e ? "" : r(e);
    };
  }, function (e, t, n) {
    var r = n(33),
        i = n(96),
        a = n(12),
        o = n(65),
        s = 1 / 0,
        l = r ? r.prototype : void 0,
        c = l ? l.toString : void 0;

    e.exports = function baseToString(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return i(e, baseToString) + "";
      if (o(e)) return c ? c.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -s ? "-0" : t;
    };
  }, function (e, t, n) {
    var r = n(347),
        i = n(348);

    e.exports = function hasIn(e, t) {
      return null != e && i(e, t, r);
    };
  }, function (e, t) {
    e.exports = function baseHasIn(e, t) {
      return null != e && t in Object(e);
    };
  }, function (e, t, n) {
    var r = n(108),
        i = n(90),
        a = n(12),
        o = n(91),
        s = n(54),
        l = n(42);

    e.exports = function hasPath(e, t, n) {
      for (var c = -1, p = (t = r(t, e)).length, d = !1; ++c < p;) {
        var h = l(t[c]);
        if (!(d = null != e && n(e, h))) break;
        e = e[h];
      }

      return d || ++c != p ? d : !!(p = null == e ? 0 : e.length) && s(p) && o(h, p) && (a(e) || i(e));
    };
  }, function (e, t, n) {
    var r = n(350),
        i = n(351),
        a = n(64),
        o = n(42);

    e.exports = function property(e) {
      return a(e) ? r(o(e)) : i(e);
    };
  }, function (e, t) {
    e.exports = function baseProperty(e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    };
  }, function (e, t, n) {
    var r = n(107);

    e.exports = function basePropertyDeep(e) {
      return function (t) {
        return r(t, e);
      };
    };
  }, function (e, t, n) {
    var r = n(353),
        i = n(36);

    e.exports = function baseMap(e, t) {
      var n = -1,
          a = i(e) ? Array(e.length) : [];
      return r(e, function (e, r, i) {
        a[++n] = t(e, r, i);
      }), a;
    };
  }, function (e, t, n) {
    var r = n(88),
        i = n(354)(r);
    e.exports = i;
  }, function (e, t, n) {
    var r = n(36);

    e.exports = function createBaseEach(e, t) {
      return function (n, i) {
        if (null == n) return n;
        if (!r(n)) return e(n, i);

        for (var a = n.length, o = t ? a : -1, s = Object(n); (t ? o-- : ++o < a) && !1 !== i(s[o], o, s);) {
          ;
        }

        return n;
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.mergeClasses = void 0;

    var r = _interopRequireDefault(n(52)),
        i = _interopRequireDefault(n(356)),
        a = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var o = t.mergeClasses = function mergeClasses(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
          n = e.default && (0, i.default)(e.default) || {};
      return t.map(function (t) {
        var i = e[t];
        return i && (0, r.default)(i, function (e, t) {
          n[t] || (n[t] = {}), n[t] = a({}, n[t], i[t]);
        }), t;
      }), n;
    };

    t.default = o;
  }, function (e, t, n) {
    var r = n(357),
        i = 1,
        a = 4;

    e.exports = function cloneDeep(e) {
      return r(e, i | a);
    };
  }, function (e, t, n) {
    var r = n(59),
        i = n(358),
        a = n(109),
        o = n(360),
        s = n(361),
        l = n(364),
        c = n(365),
        p = n(366),
        d = n(367),
        h = n(101),
        u = n(368),
        f = n(41),
        m = n(369),
        g = n(370),
        v = n(375),
        b = n(12),
        y = n(53),
        x = n(377),
        w = n(28),
        E = n(379),
        C = n(34),
        k = 1,
        S = 2,
        _ = 4,
        M = "[object Arguments]",
        L = "[object Function]",
        P = "[object GeneratorFunction]",
        F = "[object Object]",
        A = {};
    A[M] = A["[object Array]"] = A["[object ArrayBuffer]"] = A["[object DataView]"] = A["[object Boolean]"] = A["[object Date]"] = A["[object Float32Array]"] = A["[object Float64Array]"] = A["[object Int8Array]"] = A["[object Int16Array]"] = A["[object Int32Array]"] = A["[object Map]"] = A["[object Number]"] = A[F] = A["[object RegExp]"] = A["[object Set]"] = A["[object String]"] = A["[object Symbol]"] = A["[object Uint8Array]"] = A["[object Uint8ClampedArray]"] = A["[object Uint16Array]"] = A["[object Uint32Array]"] = !0, A["[object Error]"] = A[L] = A["[object WeakMap]"] = !1, e.exports = function baseClone(e, t, n, D, N, O) {
      var z,
          T = t & k,
          I = t & S,
          R = t & _;
      if (n && (z = N ? n(e, D, N, O) : n(e)), void 0 !== z) return z;
      if (!w(e)) return e;
      var j = b(e);

      if (j) {
        if (z = m(e), !T) return c(e, z);
      } else {
        var B = f(e),
            V = B == L || B == P;
        if (y(e)) return l(e, T);

        if (B == F || B == M || V && !N) {
          if (z = I || V ? {} : v(e), !T) return I ? d(e, s(z, e)) : p(e, o(z, e));
        } else {
          if (!A[B]) return N ? e : {};
          z = g(e, B, T);
        }
      }

      O || (O = new r());
      var H = O.get(e);
      if (H) return H;
      O.set(e, z), E(e) ? e.forEach(function (r) {
        z.add(baseClone(r, t, n, r, e, O));
      }) : x(e) && e.forEach(function (r, i) {
        z.set(i, baseClone(r, t, n, i, e, O));
      });
      var W = R ? I ? u : h : I ? keysIn : C,
          G = j ? void 0 : W(e);
      return i(G || e, function (r, i) {
        G && (r = e[i = r]), a(z, i, baseClone(r, t, n, i, e, O));
      }), z;
    };
  }, function (e, t) {
    e.exports = function arrayEach(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e);) {
        ;
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(23),
        i = function () {
      try {
        var e = r(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (t) {}
    }();

    e.exports = i;
  }, function (e, t, n) {
    var r = n(43),
        i = n(34);

    e.exports = function baseAssign(e, t) {
      return e && r(t, i(t), e);
    };
  }, function (e, t, n) {
    var r = n(43),
        i = n(111);

    e.exports = function baseAssignIn(e, t) {
      return e && r(t, i(t), e);
    };
  }, function (e, t, n) {
    var r = n(28),
        i = n(57),
        a = n(363),
        o = Object.prototype.hasOwnProperty;

    e.exports = function baseKeysIn(e) {
      if (!r(e)) return a(e);
      var t = i(e),
          n = [];

      for (var s in e) {
        ("constructor" != s || !t && o.call(e, s)) && n.push(s);
      }

      return n;
    };
  }, function (e, t) {
    e.exports = function nativeKeysIn(e) {
      var t = [];
      if (null != e) for (var n in Object(e)) {
        t.push(n);
      }
      return t;
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(17),
          i = t && !t.nodeType && t,
          a = i && "object" == typeof e && e && !e.nodeType && e,
          o = a && a.exports === i ? r.Buffer : void 0,
          s = o ? o.allocUnsafe : void 0;

      e.exports = function cloneBuffer(e, t) {
        if (t) return e.slice();
        var n = e.length,
            r = s ? s(n) : new e.constructor(n);
        return e.copy(r), r;
      };
    }).call(this, n(27)(e));
  }, function (e, t) {
    e.exports = function copyArray(e, t) {
      var n = -1,
          r = e.length;

      for (t || (t = Array(r)); ++n < r;) {
        t[n] = e[n];
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(43),
        i = n(63);

    e.exports = function copySymbols(e, t) {
      return r(e, i(e), t);
    };
  }, function (e, t, n) {
    var r = n(43),
        i = n(112);

    e.exports = function copySymbolsIn(e, t) {
      return r(e, i(e), t);
    };
  }, function (e, t, n) {
    var r = n(102),
        i = n(112),
        a = n(111);

    e.exports = function getAllKeysIn(e) {
      return r(e, a, i);
    };
  }, function (e, t) {
    var n = Object.prototype.hasOwnProperty;

    e.exports = function initCloneArray(e) {
      var t = e.length,
          r = new e.constructor(t);
      return t && "string" == typeof e[0] && n.call(e, "index") && (r.index = e.index, r.input = e.input), r;
    };
  }, function (e, t, n) {
    var r = n(66),
        i = n(371),
        a = n(372),
        o = n(373),
        s = n(374),
        l = "[object Boolean]",
        c = "[object Date]",
        p = "[object Map]",
        d = "[object Number]",
        h = "[object RegExp]",
        u = "[object Set]",
        f = "[object String]",
        m = "[object Symbol]",
        g = "[object ArrayBuffer]",
        v = "[object DataView]",
        b = "[object Float32Array]",
        y = "[object Float64Array]",
        x = "[object Int8Array]",
        w = "[object Int16Array]",
        E = "[object Int32Array]",
        C = "[object Uint8Array]",
        k = "[object Uint8ClampedArray]",
        S = "[object Uint16Array]",
        _ = "[object Uint32Array]";

    e.exports = function initCloneByTag(e, t, n) {
      var M = e.constructor;

      switch (t) {
        case g:
          return r(e);

        case l:
        case c:
          return new M(+e);

        case v:
          return i(e, n);

        case b:
        case y:
        case x:
        case w:
        case E:
        case C:
        case k:
        case S:
        case _:
          return s(e, n);

        case p:
          return new M();

        case d:
        case f:
          return new M(e);

        case h:
          return a(e);

        case u:
          return new M();

        case m:
          return o(e);
      }
    };
  }, function (e, t, n) {
    var r = n(66);

    e.exports = function cloneDataView(e, t) {
      var n = t ? r(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.byteLength);
    };
  }, function (e, t) {
    var n = /\w*$/;

    e.exports = function cloneRegExp(e) {
      var t = new e.constructor(e.source, n.exec(e));
      return t.lastIndex = e.lastIndex, t;
    };
  }, function (e, t, n) {
    var r = n(33),
        i = r ? r.prototype : void 0,
        a = i ? i.valueOf : void 0;

    e.exports = function cloneSymbol(e) {
      return a ? Object(a.call(e)) : {};
    };
  }, function (e, t, n) {
    var r = n(66);

    e.exports = function cloneTypedArray(e, t) {
      var n = t ? r(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.length);
    };
  }, function (e, t, n) {
    var r = n(376),
        i = n(58),
        a = n(57);

    e.exports = function initCloneObject(e) {
      return "function" != typeof e.constructor || a(e) ? {} : r(i(e));
    };
  }, function (e, t, n) {
    var r = n(28),
        i = Object.create,
        a = function () {
      function object() {}

      return function (e) {
        if (!r(e)) return {};
        if (i) return i(e);
        object.prototype = e;
        var t = new object();
        return object.prototype = void 0, t;
      };
    }();

    e.exports = a;
  }, function (e, t, n) {
    var r = n(378),
        i = n(55),
        a = n(56),
        o = a && a.isMap,
        s = o ? i(o) : r;
    e.exports = s;
  }, function (e, t, n) {
    var r = n(41),
        i = n(18),
        a = "[object Map]";

    e.exports = function baseIsMap(e) {
      return i(e) && r(e) == a;
    };
  }, function (e, t, n) {
    var r = n(380),
        i = n(55),
        a = n(56),
        o = a && a.isSet,
        s = o ? i(o) : r;
    e.exports = s;
  }, function (e, t, n) {
    var r = n(41),
        i = n(18),
        a = "[object Set]";

    e.exports = function baseIsSet(e) {
      return i(e) && r(e) == a;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.autoprefix = void 0;

    var r = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n(52)),
        i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    var a = {
      borderRadius: function borderRadius(e) {
        return {
          msBorderRadius: e,
          MozBorderRadius: e,
          OBorderRadius: e,
          WebkitBorderRadius: e,
          borderRadius: e
        };
      },
      boxShadow: function boxShadow(e) {
        return {
          msBoxShadow: e,
          MozBoxShadow: e,
          OBoxShadow: e,
          WebkitBoxShadow: e,
          boxShadow: e
        };
      },
      userSelect: function userSelect(e) {
        return {
          WebkitTouchCallout: e,
          KhtmlUserSelect: e,
          MozUserSelect: e,
          msUserSelect: e,
          WebkitUserSelect: e,
          userSelect: e
        };
      },
      flex: function flex(e) {
        return {
          WebkitBoxFlex: e,
          MozBoxFlex: e,
          WebkitFlex: e,
          msFlex: e,
          flex: e
        };
      },
      flexBasis: function flexBasis(e) {
        return {
          WebkitFlexBasis: e,
          flexBasis: e
        };
      },
      justifyContent: function justifyContent(e) {
        return {
          WebkitJustifyContent: e,
          justifyContent: e
        };
      },
      transition: function transition(e) {
        return {
          msTransition: e,
          MozTransition: e,
          OTransition: e,
          WebkitTransition: e,
          transition: e
        };
      },
      transform: function transform(e) {
        return {
          msTransform: e,
          MozTransform: e,
          OTransform: e,
          WebkitTransform: e,
          transform: e
        };
      },
      absolute: function absolute(e) {
        var t = e && e.split(" ");
        return {
          position: "absolute",
          top: t && t[0],
          right: t && t[1],
          bottom: t && t[2],
          left: t && t[3]
        };
      },
      extend: function extend(e, t) {
        var n = t[e];
        return n || {
          extend: e
        };
      }
    },
        o = t.autoprefix = function autoprefix(e) {
      var t = {};
      return (0, r.default)(e, function (e, n) {
        var o = {};
        (0, r.default)(e, function (e, t) {
          var n = a[t];
          n ? o = i({}, o, n(e)) : o[t] = e;
        }), t[n] = o;
      }), t;
    };

    t.default = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.hover = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n(0));

    function _possibleConstructorReturn(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    }

    var a = t.hover = function hover(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "span";
      return function (n) {
        function Hover() {
          var n, a, o;
          !function _classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, Hover);

          for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) {
            l[c] = arguments[c];
          }

          return a = o = _possibleConstructorReturn(this, (n = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(n, [this].concat(l))), o.state = {
            hover: !1
          }, o.handleMouseOver = function () {
            return o.setState({
              hover: !0
            });
          }, o.handleMouseOut = function () {
            return o.setState({
              hover: !1
            });
          }, o.render = function () {
            return i.default.createElement(t, {
              onMouseOver: o.handleMouseOver,
              onMouseOut: o.handleMouseOut
            }, i.default.createElement(e, r({}, o.props, o.state)));
          }, _possibleConstructorReturn(o, a);
        }

        return function _inherits(e, t) {
          if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(Hover, i.default.Component), Hover;
      }();
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.active = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n(0));

    function _possibleConstructorReturn(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    }

    var a = t.active = function active(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "span";
      return function (n) {
        function Active() {
          var n, a, o;
          !function _classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, Active);

          for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) {
            l[c] = arguments[c];
          }

          return a = o = _possibleConstructorReturn(this, (n = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(n, [this].concat(l))), o.state = {
            active: !1
          }, o.handleMouseDown = function () {
            return o.setState({
              active: !0
            });
          }, o.handleMouseUp = function () {
            return o.setState({
              active: !1
            });
          }, o.render = function () {
            return i.default.createElement(t, {
              onMouseDown: o.handleMouseDown,
              onMouseUp: o.handleMouseUp
            }, i.default.createElement(e, r({}, o.props, o.state)));
          }, _possibleConstructorReturn(o, a);
        }

        return function _inherits(e, t) {
          if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(Active, i.default.Component), Active;
      }();
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    t.default = function loopable(e, t) {
      var n = {},
          r = function setProp(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        n[e] = t;
      };

      return 0 === e && r("first-child"), e === t - 1 && r("last-child"), (0 === e || e % 2 === 0) && r("even"), 1 === Math.abs(e % 2) && r("odd"), r("nth-child", e), n;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Alpha = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        a = n(0),
        o = _interopRequireDefault(a),
        s = _interopRequireDefault(n(5)),
        l = function _interopRequireWildcard(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }(n(386)),
        c = _interopRequireDefault(n(67));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function _possibleConstructorReturn(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    }

    var p = t.Alpha = function (e) {
      function Alpha() {
        var e, t, n;
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Alpha);

        for (var r = arguments.length, i = Array(r), a = 0; a < r; a++) {
          i[a] = arguments[a];
        }

        return t = n = _possibleConstructorReturn(this, (e = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(e, [this].concat(i))), n.handleChange = function (e) {
          var t = l.calculateChange(e, n.props.hsl, n.props.direction, n.props.a, n.container);
          t && "function" === typeof n.props.onChange && n.props.onChange(t, e);
        }, n.handleMouseDown = function (e) {
          n.handleChange(e), window.addEventListener("mousemove", n.handleChange), window.addEventListener("mouseup", n.handleMouseUp);
        }, n.handleMouseUp = function () {
          n.unbindEventListeners();
        }, n.unbindEventListeners = function () {
          window.removeEventListener("mousemove", n.handleChange), window.removeEventListener("mouseup", n.handleMouseUp);
        }, _possibleConstructorReturn(n, t);
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(Alpha, a.PureComponent || a.Component), i(Alpha, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unbindEventListeners();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props.rgb,
              n = (0, s.default)({
            default: {
              alpha: {
                absolute: "0px 0px 0px 0px",
                borderRadius: this.props.radius
              },
              checkboard: {
                absolute: "0px 0px 0px 0px",
                overflow: "hidden",
                borderRadius: this.props.radius
              },
              gradient: {
                absolute: "0px 0px 0px 0px",
                background: "linear-gradient(to right, rgba(" + t.r + "," + t.g + "," + t.b + ", 0) 0%,\n           rgba(" + t.r + "," + t.g + "," + t.b + ", 1) 100%)",
                boxShadow: this.props.shadow,
                borderRadius: this.props.radius
              },
              container: {
                position: "relative",
                height: "100%",
                margin: "0 3px"
              },
              pointer: {
                position: "absolute",
                left: 100 * t.a + "%"
              },
              slider: {
                width: "4px",
                borderRadius: "1px",
                height: "8px",
                boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                background: "#fff",
                marginTop: "1px",
                transform: "translateX(-2px)"
              }
            },
            vertical: {
              gradient: {
                background: "linear-gradient(to bottom, rgba(" + t.r + "," + t.g + "," + t.b + ", 0) 0%,\n           rgba(" + t.r + "," + t.g + "," + t.b + ", 1) 100%)"
              },
              pointer: {
                left: 0,
                top: 100 * t.a + "%"
              }
            },
            overwrite: r({}, this.props.style)
          }, {
            vertical: "vertical" === this.props.direction,
            overwrite: !0
          });
          return o.default.createElement("div", {
            style: n.alpha
          }, o.default.createElement("div", {
            style: n.checkboard
          }, o.default.createElement(c.default, {
            renderers: this.props.renderers
          })), o.default.createElement("div", {
            style: n.gradient
          }), o.default.createElement("div", {
            style: n.container,
            ref: function ref(t) {
              return e.container = t;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          }, o.default.createElement("div", {
            style: n.pointer
          }, this.props.pointer ? o.default.createElement(this.props.pointer, this.props) : o.default.createElement("div", {
            style: n.slider
          }))));
        }
      }]), Alpha;
    }();

    t.default = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    t.calculateChange = function calculateChange(e, t, n, r, i) {
      var a = i.clientWidth,
          o = i.clientHeight,
          s = "number" === typeof e.pageX ? e.pageX : e.touches[0].pageX,
          l = "number" === typeof e.pageY ? e.pageY : e.touches[0].pageY,
          c = s - (i.getBoundingClientRect().left + window.pageXOffset),
          p = l - (i.getBoundingClientRect().top + window.pageYOffset);

      if ("vertical" === n) {
        var d = void 0;
        if (d = p < 0 ? 0 : p > o ? 1 : Math.round(100 * p / o) / 100, t.a !== d) return {
          h: t.h,
          s: t.s,
          l: t.l,
          a: d,
          source: "rgb"
        };
      } else {
        var h = void 0;
        if (r !== (h = c < 0 ? 0 : c > a ? 1 : Math.round(100 * c / a) / 100)) return {
          h: t.h,
          s: t.s,
          l: t.l,
          a: h,
          source: "rgb"
        };
      }

      return null;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = {},
        i = t.render = function render(e, t, n, r) {
      if ("undefined" === typeof document && !r) return null;
      var i = r ? new r() : document.createElement("canvas");
      i.width = 2 * n, i.height = 2 * n;
      var a = i.getContext("2d");
      return a ? (a.fillStyle = e, a.fillRect(0, 0, i.width, i.height), a.fillStyle = t, a.fillRect(0, 0, n, n), a.translate(n, n), a.fillRect(0, 0, n, n), i.toDataURL()) : null;
    };

    t.get = function get(e, t, n, a) {
      var o = e + "-" + t + "-" + n + (a ? "-server" : "");
      if (r[o]) return r[o];
      var s = i(e, t, n, a);
      return r[o] = s, s;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.EditableInput = void 0;

    var r = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        i = n(0),
        a = _interopRequireDefault(i),
        o = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = 38,
        l = [s, 40],
        c = function isValidKeyCode(e) {
      return l.indexOf(e) > -1;
    },
        p = function getFormattedPercentage(e) {
      return e + "%";
    },
        d = function getNumberValue(e) {
      return Number(String(e).replace(/%/g, ""));
    },
        h = t.EditableInput = function (e) {
      function EditableInput(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, EditableInput);

        var t = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

        return t.handleBlur = function () {
          t.state.blurValue && t.setState({
            value: t.state.blurValue,
            blurValue: null
          });
        }, t.handleChange = function (e) {
          t.setUpdatedValue(e.target.value, e);
        }, t.handleKeyDown = function (e) {
          var n = d(e.target.value);

          if (!isNaN(n) && c(e.keyCode)) {
            var r = t.getArrowOffset(),
                i = e.keyCode === s ? n + r : n - r;
            t.setUpdatedValue(i, e);
          }
        }, t.handleDrag = function (e) {
          if (t.props.dragLabel) {
            var n = Math.round(t.props.value + e.movementX);
            n >= 0 && n <= t.props.dragMax && t.props.onChange && t.props.onChange(t.getValueObjectWithLabel(n), e);
          }
        }, t.handleMouseDown = function (e) {
          t.props.dragLabel && (e.preventDefault(), t.handleDrag(e), window.addEventListener("mousemove", t.handleDrag), window.addEventListener("mouseup", t.handleMouseUp));
        }, t.handleMouseUp = function () {
          t.unbindEventListeners();
        }, t.unbindEventListeners = function () {
          window.removeEventListener("mousemove", t.handleDrag), window.removeEventListener("mouseup", t.handleMouseUp);
        }, t.state = {
          value: String(e.value).toUpperCase(),
          blurValue: String(e.value).toUpperCase()
        }, t;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(EditableInput, i.PureComponent || i.Component), r(EditableInput, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          var t = this.input;
          e.value !== this.state.value && (t === document.activeElement ? this.setState({
            blurValue: String(e.value).toUpperCase()
          }) : this.setState({
            value: String(e.value).toUpperCase(),
            blurValue: !this.state.blurValue && String(e.value).toUpperCase()
          }));
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unbindEventListeners();
        }
      }, {
        key: "getValueObjectWithLabel",
        value: function getValueObjectWithLabel(e) {
          return function _defineProperty(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }({}, this.props.label, e);
        }
      }, {
        key: "getArrowOffset",
        value: function getArrowOffset() {
          return this.props.arrowOffset || 1;
        }
      }, {
        key: "setUpdatedValue",
        value: function setUpdatedValue(e, t) {
          var n = null !== this.props.label ? this.getValueObjectWithLabel(e) : e;
          this.props.onChange && this.props.onChange(n, t);

          var r = function getIsPercentage(e) {
            return String(e).indexOf("%") > -1;
          }(t.target.value);

          this.setState({
            value: r ? p(e) : e
          });
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = (0, o.default)({
            default: {
              wrap: {
                position: "relative"
              }
            },
            "user-override": {
              wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
              input: this.props.style && this.props.style.input ? this.props.style.input : {},
              label: this.props.style && this.props.style.label ? this.props.style.label : {}
            },
            "dragLabel-true": {
              label: {
                cursor: "ew-resize"
              }
            }
          }, {
            "user-override": !0
          }, this.props);
          return a.default.createElement("div", {
            style: t.wrap
          }, a.default.createElement("input", {
            style: t.input,
            ref: function ref(t) {
              return e.input = t;
            },
            value: this.state.value,
            onKeyDown: this.handleKeyDown,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
            placeholder: this.props.placeholder,
            spellCheck: "false"
          }), this.props.label && !this.props.hideLabel ? a.default.createElement("span", {
            style: t.label,
            onMouseDown: this.handleMouseDown
          }, this.props.label) : null);
        }
      }]), EditableInput;
    }();

    t.default = h;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Hue = void 0;

    var r = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        i = n(0),
        a = _interopRequireDefault(i),
        o = _interopRequireDefault(n(5)),
        s = function _interopRequireWildcard(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }(n(390));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function _possibleConstructorReturn(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    }

    var l = t.Hue = function (e) {
      function Hue() {
        var e, t, n;
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Hue);

        for (var r = arguments.length, i = Array(r), a = 0; a < r; a++) {
          i[a] = arguments[a];
        }

        return t = n = _possibleConstructorReturn(this, (e = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(e, [this].concat(i))), n.handleChange = function (e) {
          var t = s.calculateChange(e, n.props.direction, n.props.hsl, n.container);
          t && "function" === typeof n.props.onChange && n.props.onChange(t, e);
        }, n.handleMouseDown = function (e) {
          n.handleChange(e), window.addEventListener("mousemove", n.handleChange), window.addEventListener("mouseup", n.handleMouseUp);
        }, n.handleMouseUp = function () {
          n.unbindEventListeners();
        }, _possibleConstructorReturn(n, t);
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(Hue, i.PureComponent || i.Component), r(Hue, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unbindEventListeners();
        }
      }, {
        key: "unbindEventListeners",
        value: function unbindEventListeners() {
          window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props.direction,
              n = void 0 === t ? "horizontal" : t,
              r = (0, o.default)({
            default: {
              hue: {
                absolute: "0px 0px 0px 0px",
                borderRadius: this.props.radius,
                boxShadow: this.props.shadow
              },
              container: {
                padding: "0 2px",
                position: "relative",
                height: "100%",
                borderRadius: this.props.radius
              },
              pointer: {
                position: "absolute",
                left: 100 * this.props.hsl.h / 360 + "%"
              },
              slider: {
                marginTop: "1px",
                width: "4px",
                borderRadius: "1px",
                height: "8px",
                boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                background: "#fff",
                transform: "translateX(-2px)"
              }
            },
            vertical: {
              pointer: {
                left: "0px",
                top: -100 * this.props.hsl.h / 360 + 100 + "%"
              }
            }
          }, {
            vertical: "vertical" === n
          });
          return a.default.createElement("div", {
            style: r.hue
          }, a.default.createElement("div", {
            className: "hue-" + n,
            style: r.container,
            ref: function ref(t) {
              return e.container = t;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          }, a.default.createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), a.default.createElement("div", {
            style: r.pointer
          }, this.props.pointer ? a.default.createElement(this.props.pointer, this.props) : a.default.createElement("div", {
            style: r.slider
          }))));
        }
      }]), Hue;
    }();

    t.default = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    t.calculateChange = function calculateChange(e, t, n, r) {
      var i = r.clientWidth,
          a = r.clientHeight,
          o = "number" === typeof e.pageX ? e.pageX : e.touches[0].pageX,
          s = "number" === typeof e.pageY ? e.pageY : e.touches[0].pageY,
          l = o - (r.getBoundingClientRect().left + window.pageXOffset),
          c = s - (r.getBoundingClientRect().top + window.pageYOffset);

      if ("vertical" === t) {
        var p = void 0;
        if (c < 0) p = 359;else if (c > a) p = 0;else {
          p = 360 * (-100 * c / a + 100) / 100;
        }
        if (n.h !== p) return {
          h: p,
          s: n.s,
          l: n.l,
          a: n.a,
          source: "rgb"
        };
      } else {
        var d = void 0;
        if (l < 0) d = 0;else if (l > i) d = 359;else {
          d = 360 * (100 * l / i) / 100;
        }
        if (n.h !== d) return {
          h: d,
          s: n.s,
          l: n.l,
          a: n.a,
          source: "rgb"
        };
      }

      return null;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Raised = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(10)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(11));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.Raised = function Raised(e) {
      var t = e.zDepth,
          n = e.radius,
          i = e.background,
          s = e.children,
          l = e.styles,
          c = void 0 === l ? {} : l,
          p = (0, a.default)((0, o.default)({
        default: {
          wrap: {
            position: "relative",
            display: "inline-block"
          },
          content: {
            position: "relative"
          },
          bg: {
            absolute: "0px 0px 0px 0px",
            boxShadow: "0 " + t + "px " + 4 * t + "px rgba(0,0,0,.24)",
            borderRadius: n,
            background: i
          }
        },
        "zDepth-0": {
          bg: {
            boxShadow: "none"
          }
        },
        "zDepth-1": {
          bg: {
            boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
          }
        },
        "zDepth-2": {
          bg: {
            boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
          }
        },
        "zDepth-3": {
          bg: {
            boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
          }
        },
        "zDepth-4": {
          bg: {
            boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
          }
        },
        "zDepth-5": {
          bg: {
            boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
          }
        },
        square: {
          bg: {
            borderRadius: "0"
          }
        },
        circle: {
          bg: {
            borderRadius: "50%"
          }
        }
      }, c), {
        "zDepth-1": 1 === t
      });
      return r.default.createElement("div", {
        style: p.wrap
      }, r.default.createElement("div", {
        style: p.bg
      }), r.default.createElement("div", {
        style: p.content
      }, s));
    };

    s.propTypes = {
      background: i.default.string,
      zDepth: i.default.oneOf([0, 1, 2, 3, 4, 5]),
      radius: i.default.number,
      styles: i.default.object
    }, s.defaultProps = {
      background: "#fff",
      zDepth: 1,
      radius: 2,
      styles: {}
    }, t.default = s;
  }, function (e, t, n) {
    "use strict";

    var r = n(393);

    function emptyFunction() {}

    function emptyFunctionWithReset() {}

    emptyFunctionWithReset.resetWarningCache = emptyFunction, e.exports = function () {
      function shim(e, t, n, i, a, o) {
        if (o !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return e.PropTypes = e, e;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    var r = n(68),
        i = n(115),
        a = n(117),
        o = n(424),
        s = n(14),
        l = n(122),
        c = n(121);

    e.exports = function baseMerge(e, t, n, p, d) {
      e !== t && a(t, function (a, l) {
        if (d || (d = new r()), s(a)) o(e, t, l, n, baseMerge, p, d);else {
          var h = p ? p(c(e, l), a, l + "", e, t, d) : void 0;
          void 0 === h && (h = a), i(e, l, h);
        }
      }, l);
    };
  }, function (e, t) {
    e.exports = function listCacheClear() {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, n) {
    var r = n(45),
        i = Array.prototype.splice;

    e.exports = function listCacheDelete(e) {
      var t = this.__data__,
          n = r(t, e);
      return !(n < 0) && (n == t.length - 1 ? t.pop() : i.call(t, n, 1), --this.size, !0);
    };
  }, function (e, t, n) {
    var r = n(45);

    e.exports = function listCacheGet(e) {
      var t = this.__data__,
          n = r(t, e);
      return n < 0 ? void 0 : t[n][1];
    };
  }, function (e, t, n) {
    var r = n(45);

    e.exports = function listCacheHas(e) {
      return r(this.__data__, e) > -1;
    };
  }, function (e, t, n) {
    var r = n(45);

    e.exports = function listCacheSet(e, t) {
      var n = this.__data__,
          i = r(n, e);
      return i < 0 ? (++this.size, n.push([e, t])) : n[i][1] = t, this;
    };
  }, function (e, t, n) {
    var r = n(44);

    e.exports = function stackClear() {
      this.__data__ = new r(), this.size = 0;
    };
  }, function (e, t) {
    e.exports = function stackDelete(e) {
      var t = this.__data__,
          n = t.delete(e);
      return this.size = t.size, n;
    };
  }, function (e, t) {
    e.exports = function stackGet(e) {
      return this.__data__.get(e);
    };
  }, function (e, t) {
    e.exports = function stackHas(e) {
      return this.__data__.has(e);
    };
  }, function (e, t, n) {
    var r = n(44),
        i = n(69),
        a = n(71),
        o = 200;

    e.exports = function stackSet(e, t) {
      var n = this.__data__;

      if (n instanceof r) {
        var s = n.__data__;
        if (!i || s.length < o - 1) return s.push([e, t]), this.size = ++n.size, this;
        n = this.__data__ = new a(s);
      }

      return n.set(e, t), this.size = n.size, this;
    };
  }, function (e, t, n) {
    var r = n(70),
        i = n(408),
        a = n(14),
        o = n(114),
        s = /^\[object .+?Constructor\]$/,
        l = Function.prototype,
        c = Object.prototype,
        p = l.toString,
        d = c.hasOwnProperty,
        h = RegExp("^" + p.call(d).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function baseIsNative(e) {
      return !(!a(e) || i(e)) && (r(e) ? h : s).test(o(e));
    };
  }, function (e, t, n) {
    var r = n(46),
        i = Object.prototype,
        a = i.hasOwnProperty,
        o = i.toString,
        s = r ? r.toStringTag : void 0;

    e.exports = function getRawTag(e) {
      var t = a.call(e, s),
          n = e[s];

      try {
        e[s] = void 0;
        var r = !0;
      } catch (l) {}

      var i = o.call(e);
      return r && (t ? e[s] = n : delete e[s]), i;
    };
  }, function (e, t) {
    var n = Object.prototype.toString;

    e.exports = function objectToString(e) {
      return n.call(e);
    };
  }, function (e, t, n) {
    var r = n(409),
        i = function () {
      var e = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
      return e ? "Symbol(src)_1." + e : "";
    }();

    e.exports = function isMasked(e) {
      return !!i && i in e;
    };
  }, function (e, t, n) {
    var r = n(13)["__core-js_shared__"];
    e.exports = r;
  }, function (e, t) {
    e.exports = function getValue(e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, n) {
    var r = n(412),
        i = n(44),
        a = n(69);

    e.exports = function mapCacheClear() {
      this.size = 0, this.__data__ = {
        hash: new r(),
        map: new (a || i)(),
        string: new r()
      };
    };
  }, function (e, t, n) {
    var r = n(413),
        i = n(414),
        a = n(415),
        o = n(416),
        s = n(417);

    function Hash(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.clear(); ++t < n;) {
        var r = e[t];
        this.set(r[0], r[1]);
      }
    }

    Hash.prototype.clear = r, Hash.prototype.delete = i, Hash.prototype.get = a, Hash.prototype.has = o, Hash.prototype.set = s, e.exports = Hash;
  }, function (e, t, n) {
    var r = n(47);

    e.exports = function hashClear() {
      this.__data__ = r ? r(null) : {}, this.size = 0;
    };
  }, function (e, t) {
    e.exports = function hashDelete(e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, n) {
    var r = n(47),
        i = "__lodash_hash_undefined__",
        a = Object.prototype.hasOwnProperty;

    e.exports = function hashGet(e) {
      var t = this.__data__;

      if (r) {
        var n = t[e];
        return n === i ? void 0 : n;
      }

      return a.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, n) {
    var r = n(47),
        i = Object.prototype.hasOwnProperty;

    e.exports = function hashHas(e) {
      var t = this.__data__;
      return r ? void 0 !== t[e] : i.call(t, e);
    };
  }, function (e, t, n) {
    var r = n(47),
        i = "__lodash_hash_undefined__";

    e.exports = function hashSet(e, t) {
      var n = this.__data__;
      return this.size += this.has(e) ? 0 : 1, n[e] = r && void 0 === t ? i : t, this;
    };
  }, function (e, t, n) {
    var r = n(48);

    e.exports = function mapCacheDelete(e) {
      var t = r(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t) {
    e.exports = function isKeyable(e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, n) {
    var r = n(48);

    e.exports = function mapCacheGet(e) {
      return r(this, e).get(e);
    };
  }, function (e, t, n) {
    var r = n(48);

    e.exports = function mapCacheHas(e) {
      return r(this, e).has(e);
    };
  }, function (e, t, n) {
    var r = n(48);

    e.exports = function mapCacheSet(e, t) {
      var n = r(this, e),
          i = n.size;
      return n.set(e, t), this.size += n.size == i ? 0 : 1, this;
    };
  }, function (e, t) {
    e.exports = function createBaseFor(e) {
      return function (t, n, r) {
        for (var i = -1, a = Object(t), o = r(t), s = o.length; s--;) {
          var l = o[e ? s : ++i];
          if (!1 === n(a[l], l, a)) break;
        }

        return t;
      };
    };
  }, function (e, t, n) {
    var r = n(115),
        i = n(425),
        a = n(426),
        o = n(428),
        s = n(429),
        l = n(74),
        c = n(15),
        p = n(432),
        d = n(76),
        h = n(70),
        u = n(14),
        f = n(434),
        m = n(77),
        g = n(121),
        v = n(438);

    e.exports = function baseMergeDeep(e, t, n, b, y, x, w) {
      var E = g(e, n),
          C = g(t, n),
          k = w.get(C);
      if (k) r(e, n, k);else {
        var S = x ? x(E, C, n + "", e, t, w) : void 0,
            _ = void 0 === S;

        if (_) {
          var M = c(C),
              L = !M && d(C),
              P = !M && !L && m(C);
          S = C, M || L || P ? c(E) ? S = E : p(E) ? S = o(E) : L ? (_ = !1, S = i(C, !0)) : P ? (_ = !1, S = a(C, !0)) : S = [] : f(C) || l(C) ? (S = E, l(E) ? S = v(E) : u(E) && !h(E) || (S = s(C))) : _ = !1;
        }

        _ && (w.set(C, S), y(S, C, b, x, w), w.delete(C)), r(e, n, S);
      }
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(13),
          i = t && !t.nodeType && t,
          a = i && "object" == typeof e && e && !e.nodeType && e,
          o = a && a.exports === i ? r.Buffer : void 0,
          s = o ? o.allocUnsafe : void 0;

      e.exports = function cloneBuffer(e, t) {
        if (t) return e.slice();
        var n = e.length,
            r = s ? s(n) : new e.constructor(n);
        return e.copy(r), r;
      };
    }).call(this, n(27)(e));
  }, function (e, t, n) {
    var r = n(427);

    e.exports = function cloneTypedArray(e, t) {
      var n = t ? r(e.buffer) : e.buffer;
      return new e.constructor(n, e.byteOffset, e.length);
    };
  }, function (e, t, n) {
    var r = n(118);

    e.exports = function cloneArrayBuffer(e) {
      var t = new e.constructor(e.byteLength);
      return new r(t).set(new r(e)), t;
    };
  }, function (e, t) {
    e.exports = function copyArray(e, t) {
      var n = -1,
          r = e.length;

      for (t || (t = Array(r)); ++n < r;) {
        t[n] = e[n];
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(430),
        i = n(119),
        a = n(73);

    e.exports = function initCloneObject(e) {
      return "function" != typeof e.constructor || a(e) ? {} : r(i(e));
    };
  }, function (e, t, n) {
    var r = n(14),
        i = Object.create,
        a = function () {
      function object() {}

      return function (e) {
        if (!r(e)) return {};
        if (i) return i(e);
        object.prototype = e;
        var t = new object();
        return object.prototype = void 0, t;
      };
    }();

    e.exports = a;
  }, function (e, t, n) {
    var r = n(29),
        i = n(25),
        a = "[object Arguments]";

    e.exports = function baseIsArguments(e) {
      return i(e) && r(e) == a;
    };
  }, function (e, t, n) {
    var r = n(30),
        i = n(25);

    e.exports = function isArrayLikeObject(e) {
      return i(e) && r(e);
    };
  }, function (e, t) {
    e.exports = function stubFalse() {
      return !1;
    };
  }, function (e, t, n) {
    var r = n(29),
        i = n(119),
        a = n(25),
        o = "[object Object]",
        s = Function.prototype,
        l = Object.prototype,
        c = s.toString,
        p = l.hasOwnProperty,
        d = c.call(Object);

    e.exports = function isPlainObject(e) {
      if (!a(e) || r(e) != o) return !1;
      var t = i(e);
      if (null === t) return !0;
      var n = p.call(t, "constructor") && t.constructor;
      return "function" == typeof n && n instanceof n && c.call(n) == d;
    };
  }, function (e, t, n) {
    var r = n(29),
        i = n(75),
        a = n(25),
        o = {};
    o["[object Float32Array]"] = o["[object Float64Array]"] = o["[object Int8Array]"] = o["[object Int16Array]"] = o["[object Int32Array]"] = o["[object Uint8Array]"] = o["[object Uint8ClampedArray]"] = o["[object Uint16Array]"] = o["[object Uint32Array]"] = !0, o["[object Arguments]"] = o["[object Array]"] = o["[object ArrayBuffer]"] = o["[object Boolean]"] = o["[object DataView]"] = o["[object Date]"] = o["[object Error]"] = o["[object Function]"] = o["[object Map]"] = o["[object Number]"] = o["[object Object]"] = o["[object RegExp]"] = o["[object Set]"] = o["[object String]"] = o["[object WeakMap]"] = !1, e.exports = function baseIsTypedArray(e) {
      return a(e) && i(e.length) && !!o[r(e)];
    };
  }, function (e, t) {
    e.exports = function baseUnary(e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t, n) {
    (function (e) {
      var r = n(113),
          i = t && !t.nodeType && t,
          a = i && "object" == typeof e && e && !e.nodeType && e,
          o = a && a.exports === i && r.process,
          s = function () {
        try {
          var e = a && a.require && a.require("util").types;

          return e || o && o.binding && o.binding("util");
        } catch (t) {}
      }();

      e.exports = s;
    }).call(this, n(27)(e));
  }, function (e, t, n) {
    var r = n(439),
        i = n(122);

    e.exports = function toPlainObject(e) {
      return r(e, i(e));
    };
  }, function (e, t, n) {
    var r = n(440),
        i = n(72);

    e.exports = function copyObject(e, t, n, a) {
      var o = !n;
      n || (n = {});

      for (var s = -1, l = t.length; ++s < l;) {
        var c = t[s],
            p = a ? a(n[c], e[c], c, n, e) : void 0;
        void 0 === p && (p = e[c]), o ? i(n, c, p) : r(n, c, p);
      }

      return n;
    };
  }, function (e, t, n) {
    var r = n(72),
        i = n(35),
        a = Object.prototype.hasOwnProperty;

    e.exports = function assignValue(e, t, n) {
      var o = e[t];
      a.call(e, t) && i(o, n) && (void 0 !== n || t in e) || r(e, t, n);
    };
  }, function (e, t) {
    e.exports = function baseTimes(e, t) {
      for (var n = -1, r = Array(e); ++n < e;) {
        r[n] = t(n);
      }

      return r;
    };
  }, function (e, t, n) {
    var r = n(14),
        i = n(73),
        a = n(443),
        o = Object.prototype.hasOwnProperty;

    e.exports = function baseKeysIn(e) {
      if (!r(e)) return a(e);
      var t = i(e),
          n = [];

      for (var s in e) {
        ("constructor" != s || !t && o.call(e, s)) && n.push(s);
      }

      return n;
    };
  }, function (e, t) {
    e.exports = function nativeKeysIn(e) {
      var t = [];
      if (null != e) for (var n in Object(e)) {
        t.push(n);
      }
      return t;
    };
  }, function (e, t, n) {
    var r = n(445),
        i = n(452);

    e.exports = function createAssigner(e) {
      return r(function (t, n) {
        var r = -1,
            a = n.length,
            o = a > 1 ? n[a - 1] : void 0,
            s = a > 2 ? n[2] : void 0;

        for (o = e.length > 3 && "function" == typeof o ? (a--, o) : void 0, s && i(n[0], n[1], s) && (o = a < 3 ? void 0 : o, a = 1), t = Object(t); ++r < a;) {
          var l = n[r];
          l && e(t, l, r, o);
        }

        return t;
      });
    };
  }, function (e, t, n) {
    var r = n(49),
        i = n(446),
        a = n(448);

    e.exports = function baseRest(e, t) {
      return a(i(e, t, r), e + "");
    };
  }, function (e, t, n) {
    var r = n(447),
        i = Math.max;

    e.exports = function overRest(e, t, n) {
      return t = i(void 0 === t ? e.length - 1 : t, 0), function () {
        for (var a = arguments, o = -1, s = i(a.length - t, 0), l = Array(s); ++o < s;) {
          l[o] = a[t + o];
        }

        o = -1;

        for (var c = Array(t + 1); ++o < t;) {
          c[o] = a[o];
        }

        return c[t] = n(l), r(e, this, c);
      };
    };
  }, function (e, t) {
    e.exports = function apply(e, t, n) {
      switch (n.length) {
        case 0:
          return e.call(t);

        case 1:
          return e.call(t, n[0]);

        case 2:
          return e.call(t, n[0], n[1]);

        case 3:
          return e.call(t, n[0], n[1], n[2]);
      }

      return e.apply(t, n);
    };
  }, function (e, t, n) {
    var r = n(449),
        i = n(451)(r);
    e.exports = i;
  }, function (e, t, n) {
    var r = n(450),
        i = n(116),
        a = n(49),
        o = i ? function (e, t) {
      return i(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: r(t),
        writable: !0
      });
    } : a;
    e.exports = o;
  }, function (e, t) {
    e.exports = function constant(e) {
      return function () {
        return e;
      };
    };
  }, function (e, t) {
    var n = 800,
        r = 16,
        i = Date.now;

    e.exports = function shortOut(e) {
      var t = 0,
          a = 0;
      return function () {
        var o = i(),
            s = r - (o - a);

        if (a = o, s > 0) {
          if (++t >= n) return arguments[0];
        } else t = 0;

        return e.apply(void 0, arguments);
      };
    };
  }, function (e, t, n) {
    var r = n(35),
        i = n(30),
        a = n(78),
        o = n(14);

    e.exports = function isIterateeCall(e, t, n) {
      if (!o(n)) return !1;
      var s = typeof t;
      return !!("number" == s ? i(n) && a(t, n.length) : "string" == s && t in n) && r(n[t], e);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Saturation = void 0;

    var r = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        i = n(0),
        a = _interopRequireDefault(i),
        o = _interopRequireDefault(n(5)),
        s = _interopRequireDefault(n(454)),
        l = function _interopRequireWildcard(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }(n(457));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var c = t.Saturation = function (e) {
      function Saturation(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Saturation);

        var t = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, e));

        return t.handleChange = function (e) {
          "function" === typeof t.props.onChange && t.throttle(t.props.onChange, l.calculateChange(e, t.props.hsl, t.container), e);
        }, t.handleMouseDown = function (e) {
          t.handleChange(e), window.addEventListener("mousemove", t.handleChange), window.addEventListener("mouseup", t.handleMouseUp);
        }, t.handleMouseUp = function () {
          t.unbindEventListeners();
        }, t.throttle = (0, s.default)(function (e, t, n) {
          e(t, n);
        }, 50), t;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(Saturation, i.PureComponent || i.Component), r(Saturation, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.throttle.cancel(), this.unbindEventListeners();
        }
      }, {
        key: "unbindEventListeners",
        value: function unbindEventListeners() {
          window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props.style || {},
              n = t.color,
              r = t.white,
              i = t.black,
              s = t.pointer,
              l = t.circle,
              c = (0, o.default)({
            default: {
              color: {
                absolute: "0px 0px 0px 0px",
                background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
                borderRadius: this.props.radius
              },
              white: {
                absolute: "0px 0px 0px 0px",
                borderRadius: this.props.radius
              },
              black: {
                absolute: "0px 0px 0px 0px",
                boxShadow: this.props.shadow,
                borderRadius: this.props.radius
              },
              pointer: {
                position: "absolute",
                top: -100 * this.props.hsv.v + 100 + "%",
                left: 100 * this.props.hsv.s + "%",
                cursor: "default"
              },
              circle: {
                width: "4px",
                height: "4px",
                boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
                borderRadius: "50%",
                cursor: "hand",
                transform: "translate(-2px, -2px)"
              }
            },
            custom: {
              color: n,
              white: r,
              black: i,
              pointer: s,
              circle: l
            }
          }, {
            custom: !!this.props.style
          });
          return a.default.createElement("div", {
            style: c.color,
            ref: function ref(t) {
              return e.container = t;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          }, a.default.createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), a.default.createElement("div", {
            style: c.white,
            className: "saturation-white"
          }, a.default.createElement("div", {
            style: c.black,
            className: "saturation-black"
          }), a.default.createElement("div", {
            style: c.pointer
          }, this.props.pointer ? a.default.createElement(this.props.pointer, this.props) : a.default.createElement("div", {
            style: c.circle
          }))));
        }
      }]), Saturation;
    }();

    t.default = c;
  }, function (e, t, n) {
    var r = n(124),
        i = n(14),
        a = "Expected a function";

    e.exports = function throttle(e, t, n) {
      var o = !0,
          s = !0;
      if ("function" != typeof e) throw new TypeError(a);
      return i(n) && (o = "leading" in n ? !!n.leading : o, s = "trailing" in n ? !!n.trailing : s), r(e, t, {
        leading: o,
        maxWait: t,
        trailing: s
      });
    };
  }, function (e, t, n) {
    var r = n(13);

    e.exports = function now() {
      return r.Date.now();
    };
  }, function (e, t, n) {
    var r = n(14),
        i = n(50),
        a = NaN,
        o = /^\s+|\s+$/g,
        s = /^[-+]0x[0-9a-f]+$/i,
        l = /^0b[01]+$/i,
        c = /^0o[0-7]+$/i,
        p = parseInt;

    e.exports = function toNumber(e) {
      if ("number" == typeof e) return e;
      if (i(e)) return a;

      if (r(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = r(t) ? t + "" : t;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = e.replace(o, "");
      var n = l.test(e);
      return n || c.test(e) ? p(e.slice(2), n ? 2 : 8) : s.test(e) ? a : +e;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    t.calculateChange = function calculateChange(e, t, n) {
      var r = n.getBoundingClientRect(),
          i = r.width,
          a = r.height,
          o = "number" === typeof e.pageX ? e.pageX : e.touches[0].pageX,
          s = "number" === typeof e.pageY ? e.pageY : e.touches[0].pageY,
          l = o - (n.getBoundingClientRect().left + window.pageXOffset),
          c = s - (n.getBoundingClientRect().top + window.pageYOffset);
      l < 0 ? l = 0 : l > i ? l = i : c < 0 ? c = 0 : c > a && (c = a);
      var p = 100 * l / i,
          d = -100 * c / a + 100;
      return {
        h: t.h,
        s: p,
        v: d,
        a: t.a,
        source: "rgb"
      };
    };
  }, function (e, t, n) {
    e.exports = n(459);
  }, function (e, t, n) {
    var r = n(460),
        i = n(126),
        a = n(465),
        o = n(15);

    e.exports = function forEach(e, t) {
      return (o(e) ? r : i)(e, a(t));
    };
  }, function (e, t) {
    e.exports = function arrayEach(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e);) {
        ;
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(117),
        i = n(79);

    e.exports = function baseForOwn(e, t) {
      return e && r(e, t, i);
    };
  }, function (e, t, n) {
    var r = n(73),
        i = n(463),
        a = Object.prototype.hasOwnProperty;

    e.exports = function baseKeys(e) {
      if (!r(e)) return i(e);
      var t = [];

      for (var n in Object(e)) {
        a.call(e, n) && "constructor" != n && t.push(n);
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(120)(Object.keys, Object);
    e.exports = r;
  }, function (e, t, n) {
    var r = n(30);

    e.exports = function createBaseEach(e, t) {
      return function (n, i) {
        if (null == n) return n;
        if (!r(n)) return e(n, i);

        for (var a = n.length, o = t ? a : -1, s = Object(n); (t ? o-- : ++o < a) && !1 !== i(s[o], o, s);) {
          ;
        }

        return n;
      };
    };
  }, function (e, t, n) {
    var r = n(49);

    e.exports = function castFunction(e) {
      return "function" == typeof e ? e : r;
    };
  }, function (e, t, n) {
    var r;
    !function (i) {
      var a = /^\s+/,
          o = /\s+$/,
          s = 0,
          l = i.round,
          c = i.min,
          p = i.max,
          d = i.random;

      function tinycolor(e, t) {
        if (t = t || {}, (e = e || "") instanceof tinycolor) return e;
        if (!(this instanceof tinycolor)) return new tinycolor(e, t);

        var n = function inputToRGB(e) {
          var t = {
            r: 0,
            g: 0,
            b: 0
          },
              n = 1,
              r = null,
              s = null,
              l = null,
              d = !1,
              u = !1;
          "string" == typeof e && (e = function stringInputToObject(e) {
            e = e.replace(a, "").replace(o, "").toLowerCase();
            var t,
                n = !1;
            if (h[e]) e = h[e], n = !0;else if ("transparent" == e) return {
              r: 0,
              g: 0,
              b: 0,
              a: 0,
              format: "name"
            };
            if (t = f.rgb.exec(e)) return {
              r: t[1],
              g: t[2],
              b: t[3]
            };
            if (t = f.rgba.exec(e)) return {
              r: t[1],
              g: t[2],
              b: t[3],
              a: t[4]
            };
            if (t = f.hsl.exec(e)) return {
              h: t[1],
              s: t[2],
              l: t[3]
            };
            if (t = f.hsla.exec(e)) return {
              h: t[1],
              s: t[2],
              l: t[3],
              a: t[4]
            };
            if (t = f.hsv.exec(e)) return {
              h: t[1],
              s: t[2],
              v: t[3]
            };
            if (t = f.hsva.exec(e)) return {
              h: t[1],
              s: t[2],
              v: t[3],
              a: t[4]
            };
            if (t = f.hex8.exec(e)) return {
              r: parseIntFromHex(t[1]),
              g: parseIntFromHex(t[2]),
              b: parseIntFromHex(t[3]),
              a: convertHexToDecimal(t[4]),
              format: n ? "name" : "hex8"
            };
            if (t = f.hex6.exec(e)) return {
              r: parseIntFromHex(t[1]),
              g: parseIntFromHex(t[2]),
              b: parseIntFromHex(t[3]),
              format: n ? "name" : "hex"
            };
            if (t = f.hex4.exec(e)) return {
              r: parseIntFromHex(t[1] + "" + t[1]),
              g: parseIntFromHex(t[2] + "" + t[2]),
              b: parseIntFromHex(t[3] + "" + t[3]),
              a: convertHexToDecimal(t[4] + "" + t[4]),
              format: n ? "name" : "hex8"
            };
            if (t = f.hex3.exec(e)) return {
              r: parseIntFromHex(t[1] + "" + t[1]),
              g: parseIntFromHex(t[2] + "" + t[2]),
              b: parseIntFromHex(t[3] + "" + t[3]),
              format: n ? "name" : "hex"
            };
            return !1;
          }(e));
          "object" == typeof e && (isValidCSSUnit(e.r) && isValidCSSUnit(e.g) && isValidCSSUnit(e.b) ? (t = function rgbToRgb(e, t, n) {
            return {
              r: 255 * bound01(e, 255),
              g: 255 * bound01(t, 255),
              b: 255 * bound01(n, 255)
            };
          }(e.r, e.g, e.b), d = !0, u = "%" === String(e.r).substr(-1) ? "prgb" : "rgb") : isValidCSSUnit(e.h) && isValidCSSUnit(e.s) && isValidCSSUnit(e.v) ? (r = convertToPercentage(e.s), s = convertToPercentage(e.v), t = function hsvToRgb(e, t, n) {
            e = 6 * bound01(e, 360), t = bound01(t, 100), n = bound01(n, 100);
            var r = i.floor(e),
                a = e - r,
                o = n * (1 - t),
                s = n * (1 - a * t),
                l = n * (1 - (1 - a) * t),
                c = r % 6;
            return {
              r: 255 * [n, s, o, o, l, n][c],
              g: 255 * [l, n, n, s, o, o][c],
              b: 255 * [o, o, l, n, n, s][c]
            };
          }(e.h, r, s), d = !0, u = "hsv") : isValidCSSUnit(e.h) && isValidCSSUnit(e.s) && isValidCSSUnit(e.l) && (r = convertToPercentage(e.s), l = convertToPercentage(e.l), t = function hslToRgb(e, t, n) {
            var r, i, a;

            function hue2rgb(e, t, n) {
              return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
            }

            if (e = bound01(e, 360), t = bound01(t, 100), n = bound01(n, 100), 0 === t) r = i = a = n;else {
              var o = n < .5 ? n * (1 + t) : n + t - n * t,
                  s = 2 * n - o;
              r = hue2rgb(s, o, e + 1 / 3), i = hue2rgb(s, o, e), a = hue2rgb(s, o, e - 1 / 3);
            }
            return {
              r: 255 * r,
              g: 255 * i,
              b: 255 * a
            };
          }(e.h, r, l), d = !0, u = "hsl"), e.hasOwnProperty("a") && (n = e.a));
          return n = boundAlpha(n), {
            ok: d,
            format: e.format || u,
            r: c(255, p(t.r, 0)),
            g: c(255, p(t.g, 0)),
            b: c(255, p(t.b, 0)),
            a: n
          };
        }(e);

        this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = l(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = l(this._r)), this._g < 1 && (this._g = l(this._g)), this._b < 1 && (this._b = l(this._b)), this._ok = n.ok, this._tc_id = s++;
      }

      function rgbToHsl(e, t, n) {
        e = bound01(e, 255), t = bound01(t, 255), n = bound01(n, 255);
        var r,
            i,
            a = p(e, t, n),
            o = c(e, t, n),
            s = (a + o) / 2;
        if (a == o) r = i = 0;else {
          var l = a - o;

          switch (i = s > .5 ? l / (2 - a - o) : l / (a + o), a) {
            case e:
              r = (t - n) / l + (t < n ? 6 : 0);
              break;

            case t:
              r = (n - e) / l + 2;
              break;

            case n:
              r = (e - t) / l + 4;
          }

          r /= 6;
        }
        return {
          h: r,
          s: i,
          l: s
        };
      }

      function rgbToHsv(e, t, n) {
        e = bound01(e, 255), t = bound01(t, 255), n = bound01(n, 255);
        var r,
            i,
            a = p(e, t, n),
            o = c(e, t, n),
            s = a,
            l = a - o;
        if (i = 0 === a ? 0 : l / a, a == o) r = 0;else {
          switch (a) {
            case e:
              r = (t - n) / l + (t < n ? 6 : 0);
              break;

            case t:
              r = (n - e) / l + 2;
              break;

            case n:
              r = (e - t) / l + 4;
          }

          r /= 6;
        }
        return {
          h: r,
          s: i,
          v: s
        };
      }

      function rgbToHex(e, t, n, r) {
        var i = [pad2(l(e).toString(16)), pad2(l(t).toString(16)), pad2(l(n).toString(16))];
        return r && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
      }

      function rgbaToArgbHex(e, t, n, r) {
        return [pad2(convertDecimalToHex(r)), pad2(l(e).toString(16)), pad2(l(t).toString(16)), pad2(l(n).toString(16))].join("");
      }

      function _desaturate(e, t) {
        t = 0 === t ? 0 : t || 10;
        var n = tinycolor(e).toHsl();
        return n.s -= t / 100, n.s = clamp01(n.s), tinycolor(n);
      }

      function _saturate(e, t) {
        t = 0 === t ? 0 : t || 10;
        var n = tinycolor(e).toHsl();
        return n.s += t / 100, n.s = clamp01(n.s), tinycolor(n);
      }

      function _greyscale(e) {
        return tinycolor(e).desaturate(100);
      }

      function _lighten(e, t) {
        t = 0 === t ? 0 : t || 10;
        var n = tinycolor(e).toHsl();
        return n.l += t / 100, n.l = clamp01(n.l), tinycolor(n);
      }

      function _brighten(e, t) {
        t = 0 === t ? 0 : t || 10;
        var n = tinycolor(e).toRgb();
        return n.r = p(0, c(255, n.r - l(-t / 100 * 255))), n.g = p(0, c(255, n.g - l(-t / 100 * 255))), n.b = p(0, c(255, n.b - l(-t / 100 * 255))), tinycolor(n);
      }

      function _darken(e, t) {
        t = 0 === t ? 0 : t || 10;
        var n = tinycolor(e).toHsl();
        return n.l -= t / 100, n.l = clamp01(n.l), tinycolor(n);
      }

      function _spin(e, t) {
        var n = tinycolor(e).toHsl(),
            r = (n.h + t) % 360;
        return n.h = r < 0 ? 360 + r : r, tinycolor(n);
      }

      function _complement(e) {
        var t = tinycolor(e).toHsl();
        return t.h = (t.h + 180) % 360, tinycolor(t);
      }

      function _triad(e) {
        var t = tinycolor(e).toHsl(),
            n = t.h;
        return [tinycolor(e), tinycolor({
          h: (n + 120) % 360,
          s: t.s,
          l: t.l
        }), tinycolor({
          h: (n + 240) % 360,
          s: t.s,
          l: t.l
        })];
      }

      function _tetrad(e) {
        var t = tinycolor(e).toHsl(),
            n = t.h;
        return [tinycolor(e), tinycolor({
          h: (n + 90) % 360,
          s: t.s,
          l: t.l
        }), tinycolor({
          h: (n + 180) % 360,
          s: t.s,
          l: t.l
        }), tinycolor({
          h: (n + 270) % 360,
          s: t.s,
          l: t.l
        })];
      }

      function _splitcomplement(e) {
        var t = tinycolor(e).toHsl(),
            n = t.h;
        return [tinycolor(e), tinycolor({
          h: (n + 72) % 360,
          s: t.s,
          l: t.l
        }), tinycolor({
          h: (n + 216) % 360,
          s: t.s,
          l: t.l
        })];
      }

      function _analogous(e, t, n) {
        t = t || 6, n = n || 30;
        var r = tinycolor(e).toHsl(),
            i = 360 / n,
            a = [tinycolor(e)];

        for (r.h = (r.h - (i * t >> 1) + 720) % 360; --t;) {
          r.h = (r.h + i) % 360, a.push(tinycolor(r));
        }

        return a;
      }

      function _monochromatic(e, t) {
        t = t || 6;

        for (var n = tinycolor(e).toHsv(), r = n.h, i = n.s, a = n.v, o = [], s = 1 / t; t--;) {
          o.push(tinycolor({
            h: r,
            s: i,
            v: a
          })), a = (a + s) % 1;
        }

        return o;
      }

      tinycolor.prototype = {
        isDark: function isDark() {
          return this.getBrightness() < 128;
        },
        isLight: function isLight() {
          return !this.isDark();
        },
        isValid: function isValid() {
          return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
          return this._originalInput;
        },
        getFormat: function getFormat() {
          return this._format;
        },
        getAlpha: function getAlpha() {
          return this._a;
        },
        getBrightness: function getBrightness() {
          var e = this.toRgb();
          return (299 * e.r + 587 * e.g + 114 * e.b) / 1e3;
        },
        getLuminance: function getLuminance() {
          var e,
              t,
              n,
              r = this.toRgb();
          return e = r.r / 255, t = r.g / 255, n = r.b / 255, .2126 * (e <= .03928 ? e / 12.92 : i.pow((e + .055) / 1.055, 2.4)) + .7152 * (t <= .03928 ? t / 12.92 : i.pow((t + .055) / 1.055, 2.4)) + .0722 * (n <= .03928 ? n / 12.92 : i.pow((n + .055) / 1.055, 2.4));
        },
        setAlpha: function setAlpha(e) {
          return this._a = boundAlpha(e), this._roundA = l(100 * this._a) / 100, this;
        },
        toHsv: function toHsv() {
          var e = rgbToHsv(this._r, this._g, this._b);
          return {
            h: 360 * e.h,
            s: e.s,
            v: e.v,
            a: this._a
          };
        },
        toHsvString: function toHsvString() {
          var e = rgbToHsv(this._r, this._g, this._b),
              t = l(360 * e.h),
              n = l(100 * e.s),
              r = l(100 * e.v);
          return 1 == this._a ? "hsv(" + t + ", " + n + "%, " + r + "%)" : "hsva(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
          var e = rgbToHsl(this._r, this._g, this._b);
          return {
            h: 360 * e.h,
            s: e.s,
            l: e.l,
            a: this._a
          };
        },
        toHslString: function toHslString() {
          var e = rgbToHsl(this._r, this._g, this._b),
              t = l(360 * e.h),
              n = l(100 * e.s),
              r = l(100 * e.l);
          return 1 == this._a ? "hsl(" + t + ", " + n + "%, " + r + "%)" : "hsla(" + t + ", " + n + "%, " + r + "%, " + this._roundA + ")";
        },
        toHex: function toHex(e) {
          return rgbToHex(this._r, this._g, this._b, e);
        },
        toHexString: function toHexString(e) {
          return "#" + this.toHex(e);
        },
        toHex8: function toHex8(e) {
          return function rgbaToHex(e, t, n, r, i) {
            var a = [pad2(l(e).toString(16)), pad2(l(t).toString(16)), pad2(l(n).toString(16)), pad2(convertDecimalToHex(r))];
            if (i && a[0].charAt(0) == a[0].charAt(1) && a[1].charAt(0) == a[1].charAt(1) && a[2].charAt(0) == a[2].charAt(1) && a[3].charAt(0) == a[3].charAt(1)) return a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) + a[3].charAt(0);
            return a.join("");
          }(this._r, this._g, this._b, this._a, e);
        },
        toHex8String: function toHex8String(e) {
          return "#" + this.toHex8(e);
        },
        toRgb: function toRgb() {
          return {
            r: l(this._r),
            g: l(this._g),
            b: l(this._b),
            a: this._a
          };
        },
        toRgbString: function toRgbString() {
          return 1 == this._a ? "rgb(" + l(this._r) + ", " + l(this._g) + ", " + l(this._b) + ")" : "rgba(" + l(this._r) + ", " + l(this._g) + ", " + l(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
          return {
            r: l(100 * bound01(this._r, 255)) + "%",
            g: l(100 * bound01(this._g, 255)) + "%",
            b: l(100 * bound01(this._b, 255)) + "%",
            a: this._a
          };
        },
        toPercentageRgbString: function toPercentageRgbString() {
          return 1 == this._a ? "rgb(" + l(100 * bound01(this._r, 255)) + "%, " + l(100 * bound01(this._g, 255)) + "%, " + l(100 * bound01(this._b, 255)) + "%)" : "rgba(" + l(100 * bound01(this._r, 255)) + "%, " + l(100 * bound01(this._g, 255)) + "%, " + l(100 * bound01(this._b, 255)) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
          return 0 === this._a ? "transparent" : !(this._a < 1) && (u[rgbToHex(this._r, this._g, this._b, !0)] || !1);
        },
        toFilter: function toFilter(e) {
          var t = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a),
              n = t,
              r = this._gradientType ? "GradientType = 1, " : "";

          if (e) {
            var i = tinycolor(e);
            n = "#" + rgbaToArgbHex(i._r, i._g, i._b, i._a);
          }

          return "progid:DXImageTransform.Microsoft.gradient(" + r + "startColorstr=" + t + ",endColorstr=" + n + ")";
        },
        toString: function toString(e) {
          var t = !!e;
          e = e || this._format;
          var n = !1,
              r = this._a < 1 && this._a >= 0;
          return t || !r || "hex" !== e && "hex6" !== e && "hex3" !== e && "hex4" !== e && "hex8" !== e && "name" !== e ? ("rgb" === e && (n = this.toRgbString()), "prgb" === e && (n = this.toPercentageRgbString()), "hex" !== e && "hex6" !== e || (n = this.toHexString()), "hex3" === e && (n = this.toHexString(!0)), "hex4" === e && (n = this.toHex8String(!0)), "hex8" === e && (n = this.toHex8String()), "name" === e && (n = this.toName()), "hsl" === e && (n = this.toHslString()), "hsv" === e && (n = this.toHsvString()), n || this.toHexString()) : "name" === e && 0 === this._a ? this.toName() : this.toRgbString();
        },
        clone: function clone() {
          return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(e, t) {
          var n = e.apply(null, [this].concat([].slice.call(t)));
          return this._r = n._r, this._g = n._g, this._b = n._b, this.setAlpha(n._a), this;
        },
        lighten: function lighten() {
          return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
          return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
          return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
          return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
          return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
          return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
          return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(e, t) {
          return e.apply(null, [this].concat([].slice.call(t)));
        },
        analogous: function analogous() {
          return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
          return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
          return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
          return this._applyCombination(_splitcomplement, arguments);
        },
        triad: function triad() {
          return this._applyCombination(_triad, arguments);
        },
        tetrad: function tetrad() {
          return this._applyCombination(_tetrad, arguments);
        }
      }, tinycolor.fromRatio = function (e, t) {
        if ("object" == typeof e) {
          var n = {};

          for (var r in e) {
            e.hasOwnProperty(r) && (n[r] = "a" === r ? e[r] : convertToPercentage(e[r]));
          }

          e = n;
        }

        return tinycolor(e, t);
      }, tinycolor.equals = function (e, t) {
        return !(!e || !t) && tinycolor(e).toRgbString() == tinycolor(t).toRgbString();
      }, tinycolor.random = function () {
        return tinycolor.fromRatio({
          r: d(),
          g: d(),
          b: d()
        });
      }, tinycolor.mix = function (e, t, n) {
        n = 0 === n ? 0 : n || 50;
        var r = tinycolor(e).toRgb(),
            i = tinycolor(t).toRgb(),
            a = n / 100;
        return tinycolor({
          r: (i.r - r.r) * a + r.r,
          g: (i.g - r.g) * a + r.g,
          b: (i.b - r.b) * a + r.b,
          a: (i.a - r.a) * a + r.a
        });
      }, tinycolor.readability = function (e, t) {
        var n = tinycolor(e),
            r = tinycolor(t);
        return (i.max(n.getLuminance(), r.getLuminance()) + .05) / (i.min(n.getLuminance(), r.getLuminance()) + .05);
      }, tinycolor.isReadable = function (e, t, n) {
        var r,
            i,
            a = tinycolor.readability(e, t);

        switch (i = !1, (r = function validateWCAG2Parms(e) {
          var t, n;
          t = ((e = e || {
            level: "AA",
            size: "small"
          }).level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), "AA" !== t && "AAA" !== t && (t = "AA");
          "small" !== n && "large" !== n && (n = "small");
          return {
            level: t,
            size: n
          };
        }(n)).level + r.size) {
          case "AAsmall":
          case "AAAlarge":
            i = a >= 4.5;
            break;

          case "AAlarge":
            i = a >= 3;
            break;

          case "AAAsmall":
            i = a >= 7;
        }

        return i;
      }, tinycolor.mostReadable = function (e, t, n) {
        var r,
            i,
            a,
            o,
            s = null,
            l = 0;
        i = (n = n || {}).includeFallbackColors, a = n.level, o = n.size;

        for (var c = 0; c < t.length; c++) {
          (r = tinycolor.readability(e, t[c])) > l && (l = r, s = tinycolor(t[c]));
        }

        return tinycolor.isReadable(e, s, {
          level: a,
          size: o
        }) || !i ? s : (n.includeFallbackColors = !1, tinycolor.mostReadable(e, ["#fff", "#000"], n));
      };

      var h = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
      },
          u = tinycolor.hexNames = function flip(e) {
        var t = {};

        for (var n in e) {
          e.hasOwnProperty(n) && (t[e[n]] = n);
        }

        return t;
      }(h);

      function boundAlpha(e) {
        return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
      }

      function bound01(e, t) {
        (function isOnePointZero(e) {
          return "string" == typeof e && -1 != e.indexOf(".") && 1 === parseFloat(e);
        })(e) && (e = "100%");

        var n = function isPercentage(e) {
          return "string" === typeof e && -1 != e.indexOf("%");
        }(e);

        return e = c(t, p(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), i.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
      }

      function clamp01(e) {
        return c(1, p(0, e));
      }

      function parseIntFromHex(e) {
        return parseInt(e, 16);
      }

      function pad2(e) {
        return 1 == e.length ? "0" + e : "" + e;
      }

      function convertToPercentage(e) {
        return e <= 1 && (e = 100 * e + "%"), e;
      }

      function convertDecimalToHex(e) {
        return i.round(255 * parseFloat(e)).toString(16);
      }

      function convertHexToDecimal(e) {
        return parseIntFromHex(e) / 255;
      }

      var f = function () {
        var e = "(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)",
            t = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?",
            n = "[\\s|\\(]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")[,|\\s]+(" + e + ")\\s*\\)?";
        return {
          CSS_UNIT: new RegExp(e),
          rgb: new RegExp("rgb" + t),
          rgba: new RegExp("rgba" + n),
          hsl: new RegExp("hsl" + t),
          hsla: new RegExp("hsla" + n),
          hsv: new RegExp("hsv" + t),
          hsva: new RegExp("hsva" + n),
          hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
      }();

      function isValidCSSUnit(e) {
        return !!f.CSS_UNIT.exec(e);
      }

      e.exports ? e.exports = tinycolor : void 0 === (r = function () {
        return tinycolor;
      }.call(t, n, t, e)) || (e.exports = r);
    }(Math);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Swatch = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = _interopRequireDefault(n(0)),
        a = _interopRequireDefault(n(5)),
        o = n(468),
        s = _interopRequireDefault(n(67));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var l = t.Swatch = function Swatch(e) {
      var t = e.color,
          n = e.style,
          o = e.onClick,
          l = void 0 === o ? function () {} : o,
          c = e.onHover,
          p = e.title,
          d = void 0 === p ? t : p,
          h = e.children,
          u = e.focus,
          f = e.focusStyle,
          m = void 0 === f ? {} : f,
          g = "transparent" === t,
          v = (0, a.default)({
        default: {
          swatch: r({
            background: t,
            height: "100%",
            width: "100%",
            cursor: "pointer",
            position: "relative",
            outline: "none"
          }, n, u ? m : {})
        }
      }),
          b = {};
      return c && (b.onMouseOver = function handleHover(e) {
        return c(t, e);
      }), i.default.createElement("div", r({
        style: v.swatch,
        onClick: function handleClick(e) {
          return l(t, e);
        },
        title: d,
        tabIndex: 0,
        onKeyDown: function handleKeyDown(e) {
          return 13 === e.keyCode && l(t, e);
        }
      }, b), h, g && i.default.createElement(s.default, {
        borderRadius: v.swatch.borderRadius,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
      }));
    };

    t.default = (0, o.handleFocus)(l);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.handleFocus = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        a = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n(0));

    function _possibleConstructorReturn(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    }

    t.handleFocus = function handleFocus(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "span";
      return function (n) {
        function Focus() {
          var e, t, n;
          !function _classCallCheck(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, Focus);

          for (var r = arguments.length, i = Array(r), a = 0; a < r; a++) {
            i[a] = arguments[a];
          }

          return t = n = _possibleConstructorReturn(this, (e = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(e, [this].concat(i))), n.state = {
            focus: !1
          }, n.handleFocus = function () {
            return n.setState({
              focus: !0
            });
          }, n.handleBlur = function () {
            return n.setState({
              focus: !1
            });
          }, _possibleConstructorReturn(n, t);
        }

        return function _inherits(e, t) {
          if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(Focus, a.default.Component), i(Focus, [{
          key: "render",
          value: function render() {
            return a.default.createElement(t, {
              onFocus: this.handleFocus,
              onBlur: this.handleBlur
            }, a.default.createElement(e, r({}, this.props, this.state)));
          }
        }]), Focus;
      }();
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.AlphaPointer = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.AlphaPointer = function AlphaPointer(e) {
      var t = e.direction,
          n = (0, i.default)({
        default: {
          picker: {
            width: "18px",
            height: "18px",
            borderRadius: "50%",
            transform: "translate(-9px, -1px)",
            backgroundColor: "rgb(248, 248, 248)",
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
          }
        },
        vertical: {
          picker: {
            transform: "translate(-3px, -9px)"
          }
        }
      }, {
        vertical: "vertical" === t
      });
      return r.default.createElement("div", {
        style: n.picker
      });
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Block = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(10)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(11)),
        s = _interopRequireDefault(n(16)),
        l = n(7),
        c = _interopRequireDefault(n(471));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var p = t.Block = function Block(e) {
      var t = e.onChange,
          n = e.onSwatchHover,
          i = e.hex,
          p = e.colors,
          d = e.width,
          h = e.triangle,
          u = e.styles,
          f = void 0 === u ? {} : u,
          m = e.className,
          g = void 0 === m ? "" : m,
          v = "transparent" === i,
          b = function handleChange(e, n) {
        s.default.isValidHex(e) && t({
          hex: e,
          source: "hex"
        }, n);
      },
          y = (0, a.default)((0, o.default)({
        default: {
          card: {
            width: d,
            background: "#fff",
            boxShadow: "0 1px rgba(0,0,0,.1)",
            borderRadius: "6px",
            position: "relative"
          },
          head: {
            height: "110px",
            background: i,
            borderRadius: "6px 6px 0 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative"
          },
          body: {
            padding: "10px"
          },
          label: {
            fontSize: "18px",
            color: s.default.getContrastingColor(i),
            position: "relative"
          },
          triangle: {
            width: "0px",
            height: "0px",
            borderStyle: "solid",
            borderWidth: "0 10px 10px 10px",
            borderColor: "transparent transparent " + i + " transparent",
            position: "absolute",
            top: "-10px",
            left: "50%",
            marginLeft: "-10px"
          },
          input: {
            width: "100%",
            fontSize: "12px",
            color: "#666",
            border: "0px",
            outline: "none",
            height: "22px",
            boxShadow: "inset 0 0 0 1px #ddd",
            borderRadius: "4px",
            padding: "0 7px",
            boxSizing: "border-box"
          }
        },
        "hide-triangle": {
          triangle: {
            display: "none"
          }
        }
      }, f), {
        "hide-triangle": "hide" === h
      });

      return r.default.createElement("div", {
        style: y.card,
        className: "block-picker " + g
      }, r.default.createElement("div", {
        style: y.triangle
      }), r.default.createElement("div", {
        style: y.head
      }, v && r.default.createElement(l.Checkboard, {
        borderRadius: "6px 6px 0 0"
      }), r.default.createElement("div", {
        style: y.label
      }, i)), r.default.createElement("div", {
        style: y.body
      }, r.default.createElement(c.default, {
        colors: p,
        onClick: b,
        onSwatchHover: n
      }), r.default.createElement(l.EditableInput, {
        style: {
          input: y.input
        },
        value: i,
        onChange: b
      })));
    };

    p.propTypes = {
      width: i.default.oneOfType([i.default.string, i.default.number]),
      colors: i.default.arrayOf(i.default.string),
      triangle: i.default.oneOf(["top", "hide"]),
      styles: i.default.object
    }, p.defaultProps = {
      width: 170,
      colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
      triangle: "top",
      styles: {}
    }, t.default = (0, l.ColorWrap)(p);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.BlockSwatches = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = _interopRequireDefault(n(26)),
        o = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.BlockSwatches = function BlockSwatches(e) {
      var t = e.colors,
          n = e.onClick,
          s = e.onSwatchHover,
          l = (0, i.default)({
        default: {
          swatches: {
            marginRight: "-10px"
          },
          swatch: {
            width: "22px",
            height: "22px",
            float: "left",
            marginRight: "10px",
            marginBottom: "10px",
            borderRadius: "4px"
          },
          clear: {
            clear: "both"
          }
        }
      });
      return r.default.createElement("div", {
        style: l.swatches
      }, (0, a.default)(t, function (e) {
        return r.default.createElement(o.Swatch, {
          key: e,
          color: e,
          style: l.swatch,
          onClick: n,
          onHover: s,
          focusStyle: {
            boxShadow: "0 0 4px " + e
          }
        });
      }), r.default.createElement("div", {
        style: l.clear
      }));
    };

    t.default = s;
  }, function (e, t, n) {
    var r = n(473),
        i = n(497),
        a = n(49),
        o = n(15),
        s = n(507);

    e.exports = function baseIteratee(e) {
      return "function" == typeof e ? e : null == e ? a : "object" == typeof e ? o(e) ? i(e[0], e[1]) : r(e) : s(e);
    };
  }, function (e, t, n) {
    var r = n(474),
        i = n(496),
        a = n(131);

    e.exports = function baseMatches(e) {
      var t = i(e);
      return 1 == t.length && t[0][2] ? a(t[0][0], t[0][1]) : function (n) {
        return n === e || r(n, e, t);
      };
    };
  }, function (e, t, n) {
    var r = n(68),
        i = n(128),
        a = 1,
        o = 2;

    e.exports = function baseIsMatch(e, t, n, s) {
      var l = n.length,
          c = l,
          p = !s;
      if (null == e) return !c;

      for (e = Object(e); l--;) {
        var d = n[l];
        if (p && d[2] ? d[1] !== e[d[0]] : !(d[0] in e)) return !1;
      }

      for (; ++l < c;) {
        var h = (d = n[l])[0],
            u = e[h],
            f = d[1];

        if (p && d[2]) {
          if (void 0 === u && !(h in e)) return !1;
        } else {
          var m = new r();
          if (s) var g = s(u, f, h, e, t, m);
          if (!(void 0 === g ? i(f, u, a | o, s, m) : g)) return !1;
        }
      }

      return !0;
    };
  }, function (e, t, n) {
    var r = n(68),
        i = n(129),
        a = n(481),
        o = n(484),
        s = n(491),
        l = n(15),
        c = n(76),
        p = n(77),
        d = 1,
        h = "[object Arguments]",
        u = "[object Array]",
        f = "[object Object]",
        m = Object.prototype.hasOwnProperty;

    e.exports = function baseIsEqualDeep(e, t, n, g, v, b) {
      var y = l(e),
          x = l(t),
          w = y ? u : s(e),
          E = x ? u : s(t),
          C = (w = w == h ? f : w) == f,
          k = (E = E == h ? f : E) == f,
          S = w == E;

      if (S && c(e)) {
        if (!c(t)) return !1;
        y = !0, C = !1;
      }

      if (S && !C) return b || (b = new r()), y || p(e) ? i(e, t, n, g, v, b) : a(e, t, w, n, g, v, b);

      if (!(n & d)) {
        var _ = C && m.call(e, "__wrapped__"),
            M = k && m.call(t, "__wrapped__");

        if (_ || M) {
          var L = _ ? e.value() : e,
              P = M ? t.value() : t;
          return b || (b = new r()), v(L, P, n, g, b);
        }
      }

      return !!S && (b || (b = new r()), o(e, t, n, g, v, b));
    };
  }, function (e, t, n) {
    var r = n(71),
        i = n(477),
        a = n(478);

    function SetCache(e) {
      var t = -1,
          n = null == e ? 0 : e.length;

      for (this.__data__ = new r(); ++t < n;) {
        this.add(e[t]);
      }
    }

    SetCache.prototype.add = SetCache.prototype.push = i, SetCache.prototype.has = a, e.exports = SetCache;
  }, function (e, t) {
    var n = "__lodash_hash_undefined__";

    e.exports = function setCacheAdd(e) {
      return this.__data__.set(e, n), this;
    };
  }, function (e, t) {
    e.exports = function setCacheHas(e) {
      return this.__data__.has(e);
    };
  }, function (e, t) {
    e.exports = function arraySome(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) {
        if (t(e[n], n, e)) return !0;
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function cacheHas(e, t) {
      return e.has(t);
    };
  }, function (e, t, n) {
    var r = n(46),
        i = n(118),
        a = n(35),
        o = n(129),
        s = n(482),
        l = n(483),
        c = 1,
        p = 2,
        d = "[object Boolean]",
        h = "[object Date]",
        u = "[object Error]",
        f = "[object Map]",
        m = "[object Number]",
        g = "[object RegExp]",
        v = "[object Set]",
        b = "[object String]",
        y = "[object Symbol]",
        x = "[object ArrayBuffer]",
        w = "[object DataView]",
        E = r ? r.prototype : void 0,
        C = E ? E.valueOf : void 0;

    e.exports = function equalByTag(e, t, n, r, E, k, S) {
      switch (n) {
        case w:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case x:
          return !(e.byteLength != t.byteLength || !k(new i(e), new i(t)));

        case d:
        case h:
        case m:
          return a(+e, +t);

        case u:
          return e.name == t.name && e.message == t.message;

        case g:
        case b:
          return e == t + "";

        case f:
          var _ = s;

        case v:
          var M = r & c;
          if (_ || (_ = l), e.size != t.size && !M) return !1;
          var L = S.get(e);
          if (L) return L == t;
          r |= p, S.set(e, t);
          var P = o(_(e), _(t), r, E, k, S);
          return S.delete(e), P;

        case y:
          if (C) return C.call(e) == C.call(t);
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function mapToArray(e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e, r) {
        n[++t] = [r, e];
      }), n;
    };
  }, function (e, t) {
    e.exports = function setToArray(e) {
      var t = -1,
          n = Array(e.size);
      return e.forEach(function (e) {
        n[++t] = e;
      }), n;
    };
  }, function (e, t, n) {
    var r = n(485),
        i = 1,
        a = Object.prototype.hasOwnProperty;

    e.exports = function equalObjects(e, t, n, o, s, l) {
      var c = n & i,
          p = r(e),
          d = p.length;
      if (d != r(t).length && !c) return !1;

      for (var h = d; h--;) {
        var u = p[h];
        if (!(c ? u in t : a.call(t, u))) return !1;
      }

      var f = l.get(e);
      if (f && l.get(t)) return f == t;
      var m = !0;
      l.set(e, t), l.set(t, e);

      for (var g = c; ++h < d;) {
        var v = e[u = p[h]],
            b = t[u];
        if (o) var y = c ? o(b, v, u, t, e, l) : o(v, b, u, e, t, l);

        if (!(void 0 === y ? v === b || s(v, b, n, o, l) : y)) {
          m = !1;
          break;
        }

        g || (g = "constructor" == u);
      }

      if (m && !g) {
        var x = e.constructor,
            w = t.constructor;
        x != w && "constructor" in e && "constructor" in t && !("function" == typeof x && x instanceof x && "function" == typeof w && w instanceof w) && (m = !1);
      }

      return l.delete(e), l.delete(t), m;
    };
  }, function (e, t, n) {
    var r = n(486),
        i = n(488),
        a = n(79);

    e.exports = function getAllKeys(e) {
      return r(e, a, i);
    };
  }, function (e, t, n) {
    var r = n(487),
        i = n(15);

    e.exports = function baseGetAllKeys(e, t, n) {
      var a = t(e);
      return i(e) ? a : r(a, n(e));
    };
  }, function (e, t) {
    e.exports = function arrayPush(e, t) {
      for (var n = -1, r = t.length, i = e.length; ++n < r;) {
        e[i + n] = t[n];
      }

      return e;
    };
  }, function (e, t, n) {
    var r = n(489),
        i = n(490),
        a = Object.prototype.propertyIsEnumerable,
        o = Object.getOwnPropertySymbols,
        s = o ? function (e) {
      return null == e ? [] : (e = Object(e), r(o(e), function (t) {
        return a.call(e, t);
      }));
    } : i;
    e.exports = s;
  }, function (e, t) {
    e.exports = function arrayFilter(e, t) {
      for (var n = -1, r = null == e ? 0 : e.length, i = 0, a = []; ++n < r;) {
        var o = e[n];
        t(o, n, e) && (a[i++] = o);
      }

      return a;
    };
  }, function (e, t) {
    e.exports = function stubArray() {
      return [];
    };
  }, function (e, t, n) {
    var r = n(492),
        i = n(69),
        a = n(493),
        o = n(494),
        s = n(495),
        l = n(29),
        c = n(114),
        p = c(r),
        d = c(i),
        h = c(a),
        u = c(o),
        f = c(s),
        m = l;
    (r && "[object DataView]" != m(new r(new ArrayBuffer(1))) || i && "[object Map]" != m(new i()) || a && "[object Promise]" != m(a.resolve()) || o && "[object Set]" != m(new o()) || s && "[object WeakMap]" != m(new s())) && (m = function getTag(e) {
      var t = l(e),
          n = "[object Object]" == t ? e.constructor : void 0,
          r = n ? c(n) : "";
      if (r) switch (r) {
        case p:
          return "[object DataView]";

        case d:
          return "[object Map]";

        case h:
          return "[object Promise]";

        case u:
          return "[object Set]";

        case f:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = m;
  }, function (e, t, n) {
    var r = n(24)(n(13), "DataView");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(24)(n(13), "Promise");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(24)(n(13), "Set");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(24)(n(13), "WeakMap");
    e.exports = r;
  }, function (e, t, n) {
    var r = n(130),
        i = n(79);

    e.exports = function getMatchData(e) {
      for (var t = i(e), n = t.length; n--;) {
        var a = t[n],
            o = e[a];
        t[n] = [a, o, r(o)];
      }

      return t;
    };
  }, function (e, t, n) {
    var r = n(128),
        i = n(498),
        a = n(504),
        o = n(80),
        s = n(130),
        l = n(131),
        c = n(51),
        p = 1,
        d = 2;

    e.exports = function baseMatchesProperty(e, t) {
      return o(e) && s(t) ? l(c(e), t) : function (n) {
        var o = i(n, e);
        return void 0 === o && o === t ? a(n, e) : r(t, o, p | d);
      };
    };
  }, function (e, t, n) {
    var r = n(132);

    e.exports = function get(e, t, n) {
      var i = null == e ? void 0 : r(e, t);
      return void 0 === i ? n : i;
    };
  }, function (e, t, n) {
    var r = n(500),
        i = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        a = /\\(\\)?/g,
        o = r(function (e) {
      var t = [];
      return 46 === e.charCodeAt(0) && t.push(""), e.replace(i, function (e, n, r, i) {
        t.push(r ? i.replace(a, "$1") : n || e);
      }), t;
    });
    e.exports = o;
  }, function (e, t, n) {
    var r = n(501),
        i = 500;

    e.exports = function memoizeCapped(e) {
      var t = r(e, function (e) {
        return n.size === i && n.clear(), e;
      }),
          n = t.cache;
      return t;
    };
  }, function (e, t, n) {
    var r = n(71),
        i = "Expected a function";

    function memoize(e, t) {
      if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(i);

      var n = function memoized() {
        var n = arguments,
            r = t ? t.apply(this, n) : n[0],
            i = memoized.cache;
        if (i.has(r)) return i.get(r);
        var a = e.apply(this, n);
        return memoized.cache = i.set(r, a) || i, a;
      };

      return n.cache = new (memoize.Cache || r)(), n;
    }

    memoize.Cache = r, e.exports = memoize;
  }, function (e, t, n) {
    var r = n(503);

    e.exports = function toString(e) {
      return null == e ? "" : r(e);
    };
  }, function (e, t, n) {
    var r = n(46),
        i = n(127),
        a = n(15),
        o = n(50),
        s = 1 / 0,
        l = r ? r.prototype : void 0,
        c = l ? l.toString : void 0;

    e.exports = function baseToString(e) {
      if ("string" == typeof e) return e;
      if (a(e)) return i(e, baseToString) + "";
      if (o(e)) return c ? c.call(e) : "";
      var t = e + "";
      return "0" == t && 1 / e == -s ? "-0" : t;
    };
  }, function (e, t, n) {
    var r = n(505),
        i = n(506);

    e.exports = function hasIn(e, t) {
      return null != e && i(e, t, r);
    };
  }, function (e, t) {
    e.exports = function baseHasIn(e, t) {
      return null != e && t in Object(e);
    };
  }, function (e, t, n) {
    var r = n(133),
        i = n(74),
        a = n(15),
        o = n(78),
        s = n(75),
        l = n(51);

    e.exports = function hasPath(e, t, n) {
      for (var c = -1, p = (t = r(t, e)).length, d = !1; ++c < p;) {
        var h = l(t[c]);
        if (!(d = null != e && n(e, h))) break;
        e = e[h];
      }

      return d || ++c != p ? d : !!(p = null == e ? 0 : e.length) && s(p) && o(h, p) && (a(e) || i(e));
    };
  }, function (e, t, n) {
    var r = n(508),
        i = n(509),
        a = n(80),
        o = n(51);

    e.exports = function property(e) {
      return a(e) ? r(o(e)) : i(e);
    };
  }, function (e, t) {
    e.exports = function baseProperty(e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    };
  }, function (e, t, n) {
    var r = n(132);

    e.exports = function basePropertyDeep(e) {
      return function (t) {
        return r(t, e);
      };
    };
  }, function (e, t, n) {
    var r = n(126),
        i = n(30);

    e.exports = function baseMap(e, t) {
      var n = -1,
          a = i(e) ? Array(e.length) : [];
      return r(e, function (e, r, i) {
        a[++n] = t(e, r, i);
      }), a;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Circle = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(10)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(26)),
        s = _interopRequireDefault(n(11)),
        l = function _interopRequireWildcard(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }(n(134)),
        c = n(7),
        p = _interopRequireDefault(n(512));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var d = t.Circle = function Circle(e) {
      var t = e.width,
          n = e.onChange,
          i = e.onSwatchHover,
          l = e.colors,
          c = e.hex,
          d = e.circleSize,
          h = e.styles,
          u = void 0 === h ? {} : h,
          f = e.circleSpacing,
          m = e.className,
          g = void 0 === m ? "" : m,
          v = (0, a.default)((0, s.default)({
        default: {
          card: {
            width: t,
            display: "flex",
            flexWrap: "wrap",
            marginRight: -f,
            marginBottom: -f
          }
        }
      }, u)),
          b = function handleChange(e, t) {
        return n({
          hex: e,
          source: "hex"
        }, t);
      };

      return r.default.createElement("div", {
        style: v.card,
        className: "circle-picker " + g
      }, (0, o.default)(l, function (e) {
        return r.default.createElement(p.default, {
          key: e,
          color: e,
          onClick: b,
          onSwatchHover: i,
          active: c === e.toLowerCase(),
          circleSize: d,
          circleSpacing: f
        });
      }));
    };

    d.propTypes = {
      width: i.default.oneOfType([i.default.string, i.default.number]),
      circleSize: i.default.number,
      circleSpacing: i.default.number,
      styles: i.default.object
    }, d.defaultProps = {
      width: 252,
      circleSize: 28,
      circleSpacing: 14,
      colors: [l.red[500], l.pink[500], l.purple[500], l.deepPurple[500], l.indigo[500], l.blue[500], l.lightBlue[500], l.cyan[500], l.teal[500], l.green[500], l.lightGreen[500], l.lime[500], l.yellow[500], l.amber[500], l.orange[500], l.deepOrange[500], l.brown[500], l.blueGrey[500]],
      styles: {}
    }, t.default = (0, c.ColorWrap)(d);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CircleSwatch = void 0;

    var r = _interopRequireDefault(n(0)),
        i = n(5),
        a = _interopRequireDefault(i),
        o = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.CircleSwatch = function CircleSwatch(e) {
      var t = e.color,
          n = e.onClick,
          i = e.onSwatchHover,
          s = e.hover,
          l = e.active,
          c = e.circleSize,
          p = e.circleSpacing,
          d = (0, a.default)({
        default: {
          swatch: {
            width: c,
            height: c,
            marginRight: p,
            marginBottom: p,
            transform: "scale(1)",
            transition: "100ms transform ease"
          },
          Swatch: {
            borderRadius: "50%",
            background: "transparent",
            boxShadow: "inset 0 0 0 " + c / 2 + "px " + t,
            transition: "100ms box-shadow ease"
          }
        },
        hover: {
          swatch: {
            transform: "scale(1.2)"
          }
        },
        active: {
          Swatch: {
            boxShadow: "inset 0 0 0 3px " + t
          }
        }
      }, {
        hover: s,
        active: l
      });
      return r.default.createElement("div", {
        style: d.swatch
      }, r.default.createElement(o.Swatch, {
        style: d.Swatch,
        color: t,
        onClick: n,
        onHover: i,
        focusStyle: {
          boxShadow: d.Swatch.boxShadow + ", 0 0 5px " + t
        }
      }));
    };

    s.defaultProps = {
      circleSize: 28,
      circleSpacing: 14
    }, t.default = (0, i.handleHover)(s);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Chrome = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(10)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(11)),
        s = n(7),
        l = _interopRequireDefault(n(514)),
        c = _interopRequireDefault(n(516)),
        p = _interopRequireDefault(n(517));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var d = t.Chrome = function Chrome(e) {
      var t = e.width,
          n = e.onChange,
          i = e.disableAlpha,
          d = e.rgb,
          h = e.hsl,
          u = e.hsv,
          f = e.hex,
          m = e.renderers,
          g = e.styles,
          v = void 0 === g ? {} : g,
          b = e.className,
          y = void 0 === b ? "" : b,
          x = (0, a.default)((0, o.default)({
        default: {
          picker: {
            width: t,
            background: "#fff",
            borderRadius: "2px",
            boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
            boxSizing: "initial",
            fontFamily: "Menlo"
          },
          saturation: {
            width: "100%",
            paddingBottom: "55%",
            position: "relative",
            borderRadius: "2px 2px 0 0",
            overflow: "hidden"
          },
          Saturation: {
            radius: "2px 2px 0 0"
          },
          body: {
            padding: "16px 16px 12px"
          },
          controls: {
            display: "flex"
          },
          color: {
            width: "32px"
          },
          swatch: {
            marginTop: "6px",
            width: "16px",
            height: "16px",
            borderRadius: "8px",
            position: "relative",
            overflow: "hidden"
          },
          active: {
            absolute: "0px 0px 0px 0px",
            borderRadius: "8px",
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
            background: "rgba(" + d.r + ", " + d.g + ", " + d.b + ", " + d.a + ")",
            zIndex: "2"
          },
          toggles: {
            flex: "1"
          },
          hue: {
            height: "10px",
            position: "relative",
            marginBottom: "8px"
          },
          Hue: {
            radius: "2px"
          },
          alpha: {
            height: "10px",
            position: "relative"
          },
          Alpha: {
            radius: "2px"
          }
        },
        disableAlpha: {
          color: {
            width: "22px"
          },
          alpha: {
            display: "none"
          },
          hue: {
            marginBottom: "0px"
          },
          swatch: {
            width: "10px",
            height: "10px",
            marginTop: "0px"
          }
        }
      }, v), {
        disableAlpha: i
      });
      return r.default.createElement("div", {
        style: x.picker,
        className: "chrome-picker " + y
      }, r.default.createElement("div", {
        style: x.saturation
      }, r.default.createElement(s.Saturation, {
        style: x.Saturation,
        hsl: h,
        hsv: u,
        pointer: p.default,
        onChange: n
      })), r.default.createElement("div", {
        style: x.body
      }, r.default.createElement("div", {
        style: x.controls,
        className: "flexbox-fix"
      }, r.default.createElement("div", {
        style: x.color
      }, r.default.createElement("div", {
        style: x.swatch
      }, r.default.createElement("div", {
        style: x.active
      }), r.default.createElement(s.Checkboard, {
        renderers: m
      }))), r.default.createElement("div", {
        style: x.toggles
      }, r.default.createElement("div", {
        style: x.hue
      }, r.default.createElement(s.Hue, {
        style: x.Hue,
        hsl: h,
        pointer: c.default,
        onChange: n
      })), r.default.createElement("div", {
        style: x.alpha
      }, r.default.createElement(s.Alpha, {
        style: x.Alpha,
        rgb: d,
        hsl: h,
        pointer: c.default,
        renderers: m,
        onChange: n
      })))), r.default.createElement(l.default, {
        rgb: d,
        hsl: h,
        hex: f,
        onChange: n,
        disableAlpha: i
      })));
    };

    d.propTypes = {
      width: i.default.oneOfType([i.default.string, i.default.number]),
      disableAlpha: i.default.bool,
      styles: i.default.object
    }, d.defaultProps = {
      width: 225,
      disableAlpha: !1,
      styles: {}
    }, t.default = (0, s.ColorWrap)(d);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChromeFields = void 0;

    var r = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        i = _interopRequireDefault(n(0)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(16)),
        s = n(7),
        l = _interopRequireDefault(n(515));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function _possibleConstructorReturn(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    }

    var c = t.ChromeFields = function (e) {
      function ChromeFields() {
        var e, t, n;
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, ChromeFields);

        for (var r = arguments.length, i = Array(r), a = 0; a < r; a++) {
          i[a] = arguments[a];
        }

        return t = n = _possibleConstructorReturn(this, (e = ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call.apply(e, [this].concat(i))), n.state = {
          view: ""
        }, n.toggleViews = function () {
          "hex" === n.state.view ? n.setState({
            view: "rgb"
          }) : "rgb" === n.state.view ? n.setState({
            view: "hsl"
          }) : "hsl" === n.state.view && (1 === n.props.hsl.a ? n.setState({
            view: "hex"
          }) : n.setState({
            view: "rgb"
          }));
        }, n.handleChange = function (e, t) {
          e.hex ? o.default.isValidHex(e.hex) && n.props.onChange({
            hex: e.hex,
            source: "hex"
          }, t) : e.r || e.g || e.b ? n.props.onChange({
            r: e.r || n.props.rgb.r,
            g: e.g || n.props.rgb.g,
            b: e.b || n.props.rgb.b,
            source: "rgb"
          }, t) : e.a ? (e.a < 0 ? e.a = 0 : e.a > 1 && (e.a = 1), n.props.onChange({
            h: n.props.hsl.h,
            s: n.props.hsl.s,
            l: n.props.hsl.l,
            a: Math.round(100 * e.a) / 100,
            source: "rgb"
          }, t)) : (e.h || e.s || e.l) && ("string" === typeof e.s && e.s.includes("%") && (e.s = e.s.replace("%", "")), "string" === typeof e.l && e.l.includes("%") && (e.l = e.l.replace("%", "")), n.props.onChange({
            h: e.h || n.props.hsl.h,
            s: Number(e.s && e.s || n.props.hsl.s),
            l: Number(e.l && e.l || n.props.hsl.l),
            source: "hsl"
          }, t));
        }, n.showHighlight = function (e) {
          e.currentTarget.style.background = "#eee";
        }, n.hideHighlight = function (e) {
          e.currentTarget.style.background = "transparent";
        }, _possibleConstructorReturn(n, t);
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(ChromeFields, i.default.Component), r(ChromeFields, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          1 === this.props.hsl.a && "hex" !== this.state.view ? this.setState({
            view: "hex"
          }) : "rgb" !== this.state.view && "hsl" !== this.state.view && this.setState({
            view: "rgb"
          });
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          1 !== e.hsl.a && "hex" === this.state.view && this.setState({
            view: "rgb"
          });
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = (0, a.default)({
            default: {
              wrap: {
                paddingTop: "16px",
                display: "flex"
              },
              fields: {
                flex: "1",
                display: "flex",
                marginLeft: "-6px"
              },
              field: {
                paddingLeft: "6px",
                width: "100%"
              },
              alpha: {
                paddingLeft: "6px",
                width: "100%"
              },
              toggle: {
                width: "32px",
                textAlign: "right",
                position: "relative"
              },
              icon: {
                marginRight: "-4px",
                marginTop: "12px",
                cursor: "pointer",
                position: "relative"
              },
              iconHighlight: {
                position: "absolute",
                width: "24px",
                height: "28px",
                background: "#eee",
                borderRadius: "4px",
                top: "10px",
                left: "12px",
                display: "none"
              },
              input: {
                fontSize: "11px",
                color: "#333",
                width: "100%",
                borderRadius: "2px",
                border: "none",
                boxShadow: "inset 0 0 0 1px #dadada",
                height: "21px",
                textAlign: "center"
              },
              label: {
                textTransform: "uppercase",
                fontSize: "11px",
                lineHeight: "11px",
                color: "#969696",
                textAlign: "center",
                display: "block",
                marginTop: "12px"
              },
              svg: {
                fill: "#333",
                width: "24px",
                height: "24px",
                border: "1px transparent solid",
                borderRadius: "5px"
              }
            },
            disableAlpha: {
              alpha: {
                display: "none"
              }
            }
          }, this.props, this.state),
              n = void 0;
          return "hex" === this.state.view ? n = i.default.createElement("div", {
            style: t.fields,
            className: "flexbox-fix"
          }, i.default.createElement("div", {
            style: t.field
          }, i.default.createElement(s.EditableInput, {
            style: {
              input: t.input,
              label: t.label
            },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          }))) : "rgb" === this.state.view ? n = i.default.createElement("div", {
            style: t.fields,
            className: "flexbox-fix"
          }, i.default.createElement("div", {
            style: t.field
          }, i.default.createElement(s.EditableInput, {
            style: {
              input: t.input,
              label: t.label
            },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })), i.default.createElement("div", {
            style: t.field
          }, i.default.createElement(s.EditableInput, {
            style: {
              input: t.input,
              label: t.label
            },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })), i.default.createElement("div", {
            style: t.field
          }, i.default.createElement(s.EditableInput, {
            style: {
              input: t.input,
              label: t.label
            },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })), i.default.createElement("div", {
            style: t.alpha
          }, i.default.createElement(s.EditableInput, {
            style: {
              input: t.input,
              label: t.label
            },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: .01,
            onChange: this.handleChange
          }))) : "hsl" === this.state.view && (n = i.default.createElement("div", {
            style: t.fields,
            className: "flexbox-fix"
          }, i.default.createElement("div", {
            style: t.field
          }, i.default.createElement(s.EditableInput, {
            style: {
              input: t.input,
              label: t.label
            },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })), i.default.createElement("div", {
            style: t.field
          }, i.default.createElement(s.EditableInput, {
            style: {
              input: t.input,
              label: t.label
            },
            label: "s",
            value: Math.round(100 * this.props.hsl.s) + "%",
            onChange: this.handleChange
          })), i.default.createElement("div", {
            style: t.field
          }, i.default.createElement(s.EditableInput, {
            style: {
              input: t.input,
              label: t.label
            },
            label: "l",
            value: Math.round(100 * this.props.hsl.l) + "%",
            onChange: this.handleChange
          })), i.default.createElement("div", {
            style: t.alpha
          }, i.default.createElement(s.EditableInput, {
            style: {
              input: t.input,
              label: t.label
            },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: .01,
            onChange: this.handleChange
          })))), i.default.createElement("div", {
            style: t.wrap,
            className: "flexbox-fix"
          }, n, i.default.createElement("div", {
            style: t.toggle
          }, i.default.createElement("div", {
            style: t.icon,
            onClick: this.toggleViews,
            ref: function ref(t) {
              return e.icon = t;
            }
          }, i.default.createElement(l.default, {
            style: t.svg,
            onMouseOver: this.showHighlight,
            onMouseEnter: this.showHighlight,
            onMouseOut: this.hideHighlight
          }))));
        }
      }]), ChromeFields;
    }();

    t.default = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n(0));

    t.default = function (e) {
      var t = e.fill,
          n = void 0 === t ? "currentColor" : t,
          a = e.width,
          o = void 0 === a ? 24 : a,
          s = e.height,
          l = void 0 === s ? 24 : s,
          c = e.style,
          p = void 0 === c ? {} : c,
          d = function _objectWithoutProperties(e, t) {
        var n = {};

        for (var r in e) {
          t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
        }

        return n;
      }(e, ["fill", "width", "height", "style"]);

      return i.default.createElement("svg", r({
        viewBox: "0 0 24 24",
        style: r({
          fill: n,
          width: o,
          height: l
        }, p)
      }, d), i.default.createElement("path", {
        d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChromePointer = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.ChromePointer = function ChromePointer() {
      var e = (0, i.default)({
        default: {
          picker: {
            width: "12px",
            height: "12px",
            borderRadius: "6px",
            transform: "translate(-6px, -1px)",
            backgroundColor: "rgb(248, 248, 248)",
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
          }
        }
      });
      return r.default.createElement("div", {
        style: e.picker
      });
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.ChromePointerCircle = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.ChromePointerCircle = function ChromePointerCircle() {
      var e = (0, i.default)({
        default: {
          picker: {
            width: "12px",
            height: "12px",
            borderRadius: "6px",
            boxShadow: "inset 0 0 0 1px #fff",
            transform: "translate(-6px, -6px)"
          }
        }
      });
      return r.default.createElement("div", {
        style: e.picker
      });
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Compact = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(10)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(26)),
        s = _interopRequireDefault(n(11)),
        l = _interopRequireDefault(n(16)),
        c = n(7),
        p = _interopRequireDefault(n(519)),
        d = _interopRequireDefault(n(520));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var h = t.Compact = function Compact(e) {
      var t = e.onChange,
          n = e.onSwatchHover,
          i = e.colors,
          h = e.hex,
          u = e.rgb,
          f = e.styles,
          m = void 0 === f ? {} : f,
          g = e.className,
          v = void 0 === g ? "" : g,
          b = (0, a.default)((0, s.default)({
        default: {
          Compact: {
            background: "#f6f6f6",
            radius: "4px"
          },
          compact: {
            paddingTop: "5px",
            paddingLeft: "5px",
            boxSizing: "initial",
            width: "240px"
          },
          clear: {
            clear: "both"
          }
        }
      }, m)),
          y = function handleChange(e, n) {
        e.hex ? l.default.isValidHex(e.hex) && t({
          hex: e.hex,
          source: "hex"
        }, n) : t(e, n);
      };

      return r.default.createElement(c.Raised, {
        style: b.Compact,
        styles: m
      }, r.default.createElement("div", {
        style: b.compact,
        className: "compact-picker " + v
      }, r.default.createElement("div", null, (0, o.default)(i, function (e) {
        return r.default.createElement(p.default, {
          key: e,
          color: e,
          active: e.toLowerCase() === h,
          onClick: y,
          onSwatchHover: n
        });
      }), r.default.createElement("div", {
        style: b.clear
      })), r.default.createElement(d.default, {
        hex: h,
        rgb: u,
        onChange: y
      })));
    };

    h.propTypes = {
      colors: i.default.arrayOf(i.default.string),
      styles: i.default.object
    }, h.defaultProps = {
      colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
      styles: {}
    }, t.default = (0, c.ColorWrap)(h);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CompactColor = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = _interopRequireDefault(n(16)),
        o = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.CompactColor = function CompactColor(e) {
      var t = e.color,
          n = e.onClick,
          s = void 0 === n ? function () {} : n,
          l = e.onSwatchHover,
          c = e.active,
          p = (0, i.default)({
        default: {
          color: {
            background: t,
            width: "15px",
            height: "15px",
            float: "left",
            marginRight: "5px",
            marginBottom: "5px",
            position: "relative",
            cursor: "pointer"
          },
          dot: {
            absolute: "5px 5px 5px 5px",
            background: a.default.getContrastingColor(t),
            borderRadius: "50%",
            opacity: "0"
          }
        },
        active: {
          dot: {
            opacity: "1"
          }
        },
        "color-#FFFFFF": {
          color: {
            boxShadow: "inset 0 0 0 1px #ddd"
          },
          dot: {
            background: "#000"
          }
        },
        transparent: {
          dot: {
            background: "#000"
          }
        }
      }, {
        active: c,
        "color-#FFFFFF": "#FFFFFF" === t,
        transparent: "transparent" === t
      });
      return r.default.createElement(o.Swatch, {
        style: p.color,
        color: t,
        onClick: s,
        onHover: l,
        focusStyle: {
          boxShadow: "0 0 4px " + t
        }
      }, r.default.createElement("div", {
        style: p.dot
      }));
    };

    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CompactFields = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var o = t.CompactFields = function CompactFields(e) {
      var t = e.hex,
          n = e.rgb,
          o = e.onChange,
          s = (0, i.default)({
        default: {
          fields: {
            display: "flex",
            paddingBottom: "6px",
            paddingRight: "5px",
            position: "relative"
          },
          active: {
            position: "absolute",
            top: "6px",
            left: "5px",
            height: "9px",
            width: "9px",
            background: t
          },
          HEXwrap: {
            flex: "6",
            position: "relative"
          },
          HEXinput: {
            width: "80%",
            padding: "0px",
            paddingLeft: "20%",
            border: "none",
            outline: "none",
            background: "none",
            fontSize: "12px",
            color: "#333",
            height: "16px"
          },
          HEXlabel: {
            display: "none"
          },
          RGBwrap: {
            flex: "3",
            position: "relative"
          },
          RGBinput: {
            width: "70%",
            padding: "0px",
            paddingLeft: "30%",
            border: "none",
            outline: "none",
            background: "none",
            fontSize: "12px",
            color: "#333",
            height: "16px"
          },
          RGBlabel: {
            position: "absolute",
            top: "3px",
            left: "0px",
            lineHeight: "16px",
            textTransform: "uppercase",
            fontSize: "12px",
            color: "#999"
          }
        }
      }),
          l = function handleChange(e, t) {
        e.r || e.g || e.b ? o({
          r: e.r || n.r,
          g: e.g || n.g,
          b: e.b || n.b,
          source: "rgb"
        }, t) : o({
          hex: e.hex,
          source: "hex"
        }, t);
      };

      return r.default.createElement("div", {
        style: s.fields,
        className: "flexbox-fix"
      }, r.default.createElement("div", {
        style: s.active
      }), r.default.createElement(a.EditableInput, {
        style: {
          wrap: s.HEXwrap,
          input: s.HEXinput,
          label: s.HEXlabel
        },
        label: "hex",
        value: t,
        onChange: l
      }), r.default.createElement(a.EditableInput, {
        style: {
          wrap: s.RGBwrap,
          input: s.RGBinput,
          label: s.RGBlabel
        },
        label: "r",
        value: n.r,
        onChange: l
      }), r.default.createElement(a.EditableInput, {
        style: {
          wrap: s.RGBwrap,
          input: s.RGBinput,
          label: s.RGBlabel
        },
        label: "g",
        value: n.g,
        onChange: l
      }), r.default.createElement(a.EditableInput, {
        style: {
          wrap: s.RGBwrap,
          input: s.RGBinput,
          label: s.RGBlabel
        },
        label: "b",
        value: n.b,
        onChange: l
      }));
    };

    t.default = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Github = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(10)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(26)),
        s = _interopRequireDefault(n(11)),
        l = n(7),
        c = _interopRequireDefault(n(522));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var p = t.Github = function Github(e) {
      var t = e.width,
          n = e.colors,
          i = e.onChange,
          l = e.onSwatchHover,
          p = e.triangle,
          d = e.styles,
          h = void 0 === d ? {} : d,
          u = e.className,
          f = void 0 === u ? "" : u,
          m = (0, a.default)((0, s.default)({
        default: {
          card: {
            width: t,
            background: "#fff",
            border: "1px solid rgba(0,0,0,0.2)",
            boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
            borderRadius: "4px",
            position: "relative",
            padding: "5px",
            display: "flex",
            flexWrap: "wrap"
          },
          triangle: {
            position: "absolute",
            border: "7px solid transparent",
            borderBottomColor: "#fff"
          },
          triangleShadow: {
            position: "absolute",
            border: "8px solid transparent",
            borderBottomColor: "rgba(0,0,0,0.15)"
          }
        },
        "hide-triangle": {
          triangle: {
            display: "none"
          },
          triangleShadow: {
            display: "none"
          }
        },
        "top-left-triangle": {
          triangle: {
            top: "-14px",
            left: "10px"
          },
          triangleShadow: {
            top: "-16px",
            left: "9px"
          }
        },
        "top-right-triangle": {
          triangle: {
            top: "-14px",
            right: "10px"
          },
          triangleShadow: {
            top: "-16px",
            right: "9px"
          }
        },
        "bottom-left-triangle": {
          triangle: {
            top: "35px",
            left: "10px",
            transform: "rotate(180deg)"
          },
          triangleShadow: {
            top: "37px",
            left: "9px",
            transform: "rotate(180deg)"
          }
        },
        "bottom-right-triangle": {
          triangle: {
            top: "35px",
            right: "10px",
            transform: "rotate(180deg)"
          },
          triangleShadow: {
            top: "37px",
            right: "9px",
            transform: "rotate(180deg)"
          }
        }
      }, h), {
        "hide-triangle": "hide" === p,
        "top-left-triangle": "top-left" === p,
        "top-right-triangle": "top-right" === p,
        "bottom-left-triangle": "bottom-left" === p,
        "bottom-right-triangle": "bottom-right" === p
      }),
          g = function handleChange(e, t) {
        return i({
          hex: e,
          source: "hex"
        }, t);
      };

      return r.default.createElement("div", {
        style: m.card,
        className: "github-picker " + f
      }, r.default.createElement("div", {
        style: m.triangleShadow
      }), r.default.createElement("div", {
        style: m.triangle
      }), (0, o.default)(n, function (e) {
        return r.default.createElement(c.default, {
          color: e,
          key: e,
          onClick: g,
          onSwatchHover: l
        });
      }));
    };

    p.propTypes = {
      width: i.default.oneOfType([i.default.string, i.default.number]),
      colors: i.default.arrayOf(i.default.string),
      triangle: i.default.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
      styles: i.default.object
    }, p.defaultProps = {
      width: 200,
      colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
      triangle: "top-left",
      styles: {}
    }, t.default = (0, l.ColorWrap)(p);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.GithubSwatch = void 0;

    var r = _interopRequireDefault(n(0)),
        i = n(5),
        a = _interopRequireDefault(i),
        o = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.GithubSwatch = function GithubSwatch(e) {
      var t = e.hover,
          n = e.color,
          i = e.onClick,
          s = e.onSwatchHover,
          l = {
        position: "relative",
        zIndex: "2",
        outline: "2px solid #fff",
        boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
      },
          c = (0, a.default)({
        default: {
          swatch: {
            width: "25px",
            height: "25px",
            fontSize: "0"
          }
        },
        hover: {
          swatch: l
        }
      }, {
        hover: t
      });
      return r.default.createElement("div", {
        style: c.swatch
      }, r.default.createElement(o.Swatch, {
        color: n,
        onClick: i,
        onHover: s,
        focusStyle: l
      }));
    };

    t.default = (0, i.handleHover)(s);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.HuePicker = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = _interopRequireDefault(n(0)),
        a = _interopRequireDefault(n(10)),
        o = _interopRequireDefault(n(5)),
        s = _interopRequireDefault(n(11)),
        l = n(7),
        c = _interopRequireDefault(n(524));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var p = t.HuePicker = function HuePicker(e) {
      var t = e.width,
          n = e.height,
          a = e.onChange,
          c = e.hsl,
          p = e.direction,
          d = e.pointer,
          h = e.styles,
          u = void 0 === h ? {} : h,
          f = e.className,
          m = void 0 === f ? "" : f,
          g = (0, o.default)((0, s.default)({
        default: {
          picker: {
            position: "relative",
            width: t,
            height: n
          },
          hue: {
            radius: "2px"
          }
        }
      }, u));
      return i.default.createElement("div", {
        style: g.picker,
        className: "hue-picker " + m
      }, i.default.createElement(l.Hue, r({}, g.hue, {
        hsl: c,
        pointer: d,
        onChange: function handleChange(e) {
          return a({
            a: 1,
            h: e.h,
            l: .5,
            s: 1
          });
        },
        direction: p
      })));
    };

    p.propTypes = {
      styles: a.default.object
    }, p.defaultProps = {
      width: "316px",
      height: "16px",
      direction: "horizontal",
      pointer: c.default,
      styles: {}
    }, t.default = (0, l.ColorWrap)(p);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SliderPointer = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.SliderPointer = function SliderPointer(e) {
      var t = e.direction,
          n = (0, i.default)({
        default: {
          picker: {
            width: "18px",
            height: "18px",
            borderRadius: "50%",
            transform: "translate(-9px, -1px)",
            backgroundColor: "rgb(248, 248, 248)",
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
          }
        },
        vertical: {
          picker: {
            transform: "translate(-3px, -9px)"
          }
        }
      }, {
        vertical: "vertical" === t
      });
      return r.default.createElement("div", {
        style: n.picker
      });
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Material = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = _interopRequireDefault(n(11)),
        o = _interopRequireDefault(n(16)),
        s = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var l = t.Material = function Material(e) {
      var t = e.onChange,
          n = e.hex,
          l = e.rgb,
          c = e.styles,
          p = void 0 === c ? {} : c,
          d = e.className,
          h = void 0 === d ? "" : d,
          u = (0, i.default)((0, a.default)({
        default: {
          material: {
            width: "98px",
            height: "98px",
            padding: "16px",
            fontFamily: "Roboto"
          },
          HEXwrap: {
            position: "relative"
          },
          HEXinput: {
            width: "100%",
            marginTop: "12px",
            fontSize: "15px",
            color: "#333",
            padding: "0px",
            border: "0px",
            borderBottom: "2px solid " + n,
            outline: "none",
            height: "30px"
          },
          HEXlabel: {
            position: "absolute",
            top: "0px",
            left: "0px",
            fontSize: "11px",
            color: "#999999",
            textTransform: "capitalize"
          },
          Hex: {
            style: {}
          },
          RGBwrap: {
            position: "relative"
          },
          RGBinput: {
            width: "100%",
            marginTop: "12px",
            fontSize: "15px",
            color: "#333",
            padding: "0px",
            border: "0px",
            borderBottom: "1px solid #eee",
            outline: "none",
            height: "30px"
          },
          RGBlabel: {
            position: "absolute",
            top: "0px",
            left: "0px",
            fontSize: "11px",
            color: "#999999",
            textTransform: "capitalize"
          },
          split: {
            display: "flex",
            marginRight: "-10px",
            paddingTop: "11px"
          },
          third: {
            flex: "1",
            paddingRight: "10px"
          }
        }
      }, p)),
          f = function handleChange(e, n) {
        e.hex ? o.default.isValidHex(e.hex) && t({
          hex: e.hex,
          source: "hex"
        }, n) : (e.r || e.g || e.b) && t({
          r: e.r || l.r,
          g: e.g || l.g,
          b: e.b || l.b,
          source: "rgb"
        }, n);
      };

      return r.default.createElement(s.Raised, {
        styles: p
      }, r.default.createElement("div", {
        style: u.material,
        className: "material-picker " + h
      }, r.default.createElement(s.EditableInput, {
        style: {
          wrap: u.HEXwrap,
          input: u.HEXinput,
          label: u.HEXlabel
        },
        label: "hex",
        value: n,
        onChange: f
      }), r.default.createElement("div", {
        style: u.split,
        className: "flexbox-fix"
      }, r.default.createElement("div", {
        style: u.third
      }, r.default.createElement(s.EditableInput, {
        style: {
          wrap: u.RGBwrap,
          input: u.RGBinput,
          label: u.RGBlabel
        },
        label: "r",
        value: l.r,
        onChange: f
      })), r.default.createElement("div", {
        style: u.third
      }, r.default.createElement(s.EditableInput, {
        style: {
          wrap: u.RGBwrap,
          input: u.RGBinput,
          label: u.RGBlabel
        },
        label: "g",
        value: l.g,
        onChange: f
      })), r.default.createElement("div", {
        style: u.third
      }, r.default.createElement(s.EditableInput, {
        style: {
          wrap: u.RGBwrap,
          input: u.RGBinput,
          label: u.RGBlabel
        },
        label: "b",
        value: l.b,
        onChange: f
      })))));
    };

    t.default = (0, s.ColorWrap)(l);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Photoshop = void 0;

    var r = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        i = _interopRequireDefault(n(0)),
        a = _interopRequireDefault(n(10)),
        o = _interopRequireDefault(n(5)),
        s = _interopRequireDefault(n(11)),
        l = n(7),
        c = _interopRequireDefault(n(527)),
        p = _interopRequireDefault(n(528)),
        d = _interopRequireDefault(n(529)),
        h = _interopRequireDefault(n(530)),
        u = _interopRequireDefault(n(531));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var f = t.Photoshop = function (e) {
      function Photoshop(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Photoshop);

        var t = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

        return t.state = {
          currentColor: e.hex
        }, t;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(Photoshop, i.default.Component), r(Photoshop, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.styles,
              n = void 0 === t ? {} : t,
              r = e.className,
              a = void 0 === r ? "" : r,
              f = (0, o.default)((0, s.default)({
            default: {
              picker: {
                background: "#DCDCDC",
                borderRadius: "4px",
                boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
                boxSizing: "initial",
                width: "513px"
              },
              head: {
                backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
                borderBottom: "1px solid #B1B1B1",
                boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
                height: "23px",
                lineHeight: "24px",
                borderRadius: "4px 4px 0 0",
                fontSize: "13px",
                color: "#4D4D4D",
                textAlign: "center"
              },
              body: {
                padding: "15px 15px 0",
                display: "flex"
              },
              saturation: {
                width: "256px",
                height: "256px",
                position: "relative",
                border: "2px solid #B3B3B3",
                borderBottom: "2px solid #F0F0F0",
                overflow: "hidden"
              },
              hue: {
                position: "relative",
                height: "256px",
                width: "19px",
                marginLeft: "10px",
                border: "2px solid #B3B3B3",
                borderBottom: "2px solid #F0F0F0"
              },
              controls: {
                width: "180px",
                marginLeft: "10px"
              },
              top: {
                display: "flex"
              },
              previews: {
                width: "60px"
              },
              actions: {
                flex: "1",
                marginLeft: "20px"
              }
            }
          }, n));
          return i.default.createElement("div", {
            style: f.picker,
            className: "photoshop-picker " + a
          }, i.default.createElement("div", {
            style: f.head
          }, this.props.header), i.default.createElement("div", {
            style: f.body,
            className: "flexbox-fix"
          }, i.default.createElement("div", {
            style: f.saturation
          }, i.default.createElement(l.Saturation, {
            hsl: this.props.hsl,
            hsv: this.props.hsv,
            pointer: p.default,
            onChange: this.props.onChange
          })), i.default.createElement("div", {
            style: f.hue
          }, i.default.createElement(l.Hue, {
            direction: "vertical",
            hsl: this.props.hsl,
            pointer: d.default,
            onChange: this.props.onChange
          })), i.default.createElement("div", {
            style: f.controls
          }, i.default.createElement("div", {
            style: f.top,
            className: "flexbox-fix"
          }, i.default.createElement("div", {
            style: f.previews
          }, i.default.createElement(u.default, {
            rgb: this.props.rgb,
            currentColor: this.state.currentColor
          })), i.default.createElement("div", {
            style: f.actions
          }, i.default.createElement(h.default, {
            label: "OK",
            onClick: this.props.onAccept,
            active: !0
          }), i.default.createElement(h.default, {
            label: "Cancel",
            onClick: this.props.onCancel
          }), i.default.createElement(c.default, {
            onChange: this.props.onChange,
            rgb: this.props.rgb,
            hsv: this.props.hsv,
            hex: this.props.hex
          }))))));
        }
      }]), Photoshop;
    }();

    f.propTypes = {
      header: a.default.string,
      styles: a.default.object
    }, f.defaultProps = {
      header: "Color Picker",
      styles: {}
    }, t.default = (0, l.ColorWrap)(f);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PhotoshopPicker = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = _interopRequireDefault(n(16)),
        o = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.PhotoshopPicker = function PhotoshopPicker(e) {
      var t = e.onChange,
          n = e.rgb,
          s = e.hsv,
          l = e.hex,
          c = (0, i.default)({
        default: {
          fields: {
            paddingTop: "5px",
            paddingBottom: "9px",
            width: "80px",
            position: "relative"
          },
          divider: {
            height: "5px"
          },
          RGBwrap: {
            position: "relative"
          },
          RGBinput: {
            marginLeft: "40%",
            width: "40%",
            height: "18px",
            border: "1px solid #888888",
            boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
            marginBottom: "5px",
            fontSize: "13px",
            paddingLeft: "3px",
            marginRight: "10px"
          },
          RGBlabel: {
            left: "0px",
            width: "34px",
            textTransform: "uppercase",
            fontSize: "13px",
            height: "18px",
            lineHeight: "22px",
            position: "absolute"
          },
          HEXwrap: {
            position: "relative"
          },
          HEXinput: {
            marginLeft: "20%",
            width: "80%",
            height: "18px",
            border: "1px solid #888888",
            boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
            marginBottom: "6px",
            fontSize: "13px",
            paddingLeft: "3px"
          },
          HEXlabel: {
            position: "absolute",
            top: "0px",
            left: "0px",
            width: "14px",
            textTransform: "uppercase",
            fontSize: "13px",
            height: "18px",
            lineHeight: "22px"
          },
          fieldSymbols: {
            position: "absolute",
            top: "5px",
            right: "-7px",
            fontSize: "13px"
          },
          symbol: {
            height: "20px",
            lineHeight: "22px",
            paddingBottom: "7px"
          }
        }
      }),
          p = function handleChange(e, r) {
        e["#"] ? a.default.isValidHex(e["#"]) && t({
          hex: e["#"],
          source: "hex"
        }, r) : e.r || e.g || e.b ? t({
          r: e.r || n.r,
          g: e.g || n.g,
          b: e.b || n.b,
          source: "rgb"
        }, r) : (e.h || e.s || e.v) && t({
          h: e.h || s.h,
          s: e.s || s.s,
          v: e.v || s.v,
          source: "hsv"
        }, r);
      };

      return r.default.createElement("div", {
        style: c.fields
      }, r.default.createElement(o.EditableInput, {
        style: {
          wrap: c.RGBwrap,
          input: c.RGBinput,
          label: c.RGBlabel
        },
        label: "h",
        value: Math.round(s.h),
        onChange: p
      }), r.default.createElement(o.EditableInput, {
        style: {
          wrap: c.RGBwrap,
          input: c.RGBinput,
          label: c.RGBlabel
        },
        label: "s",
        value: Math.round(100 * s.s),
        onChange: p
      }), r.default.createElement(o.EditableInput, {
        style: {
          wrap: c.RGBwrap,
          input: c.RGBinput,
          label: c.RGBlabel
        },
        label: "v",
        value: Math.round(100 * s.v),
        onChange: p
      }), r.default.createElement("div", {
        style: c.divider
      }), r.default.createElement(o.EditableInput, {
        style: {
          wrap: c.RGBwrap,
          input: c.RGBinput,
          label: c.RGBlabel
        },
        label: "r",
        value: n.r,
        onChange: p
      }), r.default.createElement(o.EditableInput, {
        style: {
          wrap: c.RGBwrap,
          input: c.RGBinput,
          label: c.RGBlabel
        },
        label: "g",
        value: n.g,
        onChange: p
      }), r.default.createElement(o.EditableInput, {
        style: {
          wrap: c.RGBwrap,
          input: c.RGBinput,
          label: c.RGBlabel
        },
        label: "b",
        value: n.b,
        onChange: p
      }), r.default.createElement("div", {
        style: c.divider
      }), r.default.createElement(o.EditableInput, {
        style: {
          wrap: c.HEXwrap,
          input: c.HEXinput,
          label: c.HEXlabel
        },
        label: "#",
        value: l.replace("#", ""),
        onChange: p
      }), r.default.createElement("div", {
        style: c.fieldSymbols
      }, r.default.createElement("div", {
        style: c.symbol
      }, "\xb0"), r.default.createElement("div", {
        style: c.symbol
      }, "%"), r.default.createElement("div", {
        style: c.symbol
      }, "%")));
    };

    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PhotoshopPointerCircle = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.PhotoshopPointerCircle = function PhotoshopPointerCircle(e) {
      var t = e.hsl,
          n = (0, i.default)({
        default: {
          picker: {
            width: "12px",
            height: "12px",
            borderRadius: "6px",
            boxShadow: "inset 0 0 0 1px #fff",
            transform: "translate(-6px, -6px)"
          }
        },
        "black-outline": {
          picker: {
            boxShadow: "inset 0 0 0 1px #000"
          }
        }
      }, {
        "black-outline": t.l > .5
      });
      return r.default.createElement("div", {
        style: n.picker
      });
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PhotoshopPointerCircle = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
      var e = (0, i.default)({
        default: {
          triangle: {
            width: 0,
            height: 0,
            borderStyle: "solid",
            borderWidth: "4px 0 4px 6px",
            borderColor: "transparent transparent transparent #fff",
            position: "absolute",
            top: "1px",
            left: "1px"
          },
          triangleBorder: {
            width: 0,
            height: 0,
            borderStyle: "solid",
            borderWidth: "5px 0 5px 8px",
            borderColor: "transparent transparent transparent #555"
          },
          left: {
            Extend: "triangleBorder",
            transform: "translate(-13px, -4px)"
          },
          leftInside: {
            Extend: "triangle",
            transform: "translate(-8px, -5px)"
          },
          right: {
            Extend: "triangleBorder",
            transform: "translate(20px, -14px) rotate(180deg)"
          },
          rightInside: {
            Extend: "triangle",
            transform: "translate(-8px, -5px)"
          }
        }
      });
      return r.default.createElement("div", {
        style: e.pointer
      }, r.default.createElement("div", {
        style: e.left
      }, r.default.createElement("div", {
        style: e.leftInside
      })), r.default.createElement("div", {
        style: e.right
      }, r.default.createElement("div", {
        style: e.rightInside
      })));
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PhotoshopButton = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.PhotoshopButton = function PhotoshopButton(e) {
      var t = e.onClick,
          n = e.label,
          a = e.children,
          o = e.active,
          s = (0, i.default)({
        default: {
          button: {
            backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
            border: "1px solid #878787",
            borderRadius: "2px",
            height: "20px",
            boxShadow: "0 1px 0 0 #EAEAEA",
            fontSize: "14px",
            color: "#000",
            lineHeight: "20px",
            textAlign: "center",
            marginBottom: "10px",
            cursor: "pointer"
          }
        },
        active: {
          button: {
            boxShadow: "0 0 0 1px #878787"
          }
        }
      }, {
        active: o
      });
      return r.default.createElement("div", {
        style: s.button,
        onClick: t
      }, n || a);
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PhotoshopPreviews = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.PhotoshopPreviews = function PhotoshopPreviews(e) {
      var t = e.rgb,
          n = e.currentColor,
          a = (0, i.default)({
        default: {
          swatches: {
            border: "1px solid #B3B3B3",
            borderBottom: "1px solid #F0F0F0",
            marginBottom: "2px",
            marginTop: "1px"
          },
          new: {
            height: "34px",
            background: "rgb(" + t.r + "," + t.g + ", " + t.b + ")",
            boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
          },
          current: {
            height: "34px",
            background: n,
            boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
          },
          label: {
            fontSize: "14px",
            color: "#000",
            textAlign: "center"
          }
        }
      });
      return r.default.createElement("div", null, r.default.createElement("div", {
        style: a.label
      }, "new"), r.default.createElement("div", {
        style: a.swatches
      }, r.default.createElement("div", {
        style: a.new
      }), r.default.createElement("div", {
        style: a.current
      })), r.default.createElement("div", {
        style: a.label
      }, "current"));
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Sketch = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = _interopRequireDefault(n(0)),
        a = _interopRequireDefault(n(10)),
        o = _interopRequireDefault(n(5)),
        s = _interopRequireDefault(n(11)),
        l = n(7),
        c = _interopRequireDefault(n(533)),
        p = _interopRequireDefault(n(534));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var d = t.Sketch = function Sketch(e) {
      var t = e.width,
          n = e.rgb,
          a = e.hex,
          d = e.hsv,
          h = e.hsl,
          u = e.onChange,
          f = e.onSwatchHover,
          m = e.disableAlpha,
          g = e.presetColors,
          v = e.renderers,
          b = e.styles,
          y = void 0 === b ? {} : b,
          x = e.className,
          w = void 0 === x ? "" : x,
          E = (0, o.default)((0, s.default)({
        default: r({
          picker: {
            width: t,
            padding: "10px 10px 0",
            boxSizing: "initial",
            background: "#fff",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
          },
          saturation: {
            width: "100%",
            paddingBottom: "75%",
            position: "relative",
            overflow: "hidden"
          },
          Saturation: {
            radius: "3px",
            shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
          },
          controls: {
            display: "flex"
          },
          sliders: {
            padding: "4px 0",
            flex: "1"
          },
          color: {
            width: "24px",
            height: "24px",
            position: "relative",
            marginTop: "4px",
            marginLeft: "4px",
            borderRadius: "3px"
          },
          activeColor: {
            absolute: "0px 0px 0px 0px",
            borderRadius: "2px",
            background: "rgba(" + n.r + "," + n.g + "," + n.b + "," + n.a + ")",
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
          },
          hue: {
            position: "relative",
            height: "10px",
            overflow: "hidden"
          },
          Hue: {
            radius: "2px",
            shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
          },
          alpha: {
            position: "relative",
            height: "10px",
            marginTop: "4px",
            overflow: "hidden"
          },
          Alpha: {
            radius: "2px",
            shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
          }
        }, y),
        disableAlpha: {
          color: {
            height: "10px"
          },
          hue: {
            height: "10px"
          },
          alpha: {
            display: "none"
          }
        }
      }, y), {
        disableAlpha: m
      });
      return i.default.createElement("div", {
        style: E.picker,
        className: "sketch-picker " + w
      }, i.default.createElement("div", {
        style: E.saturation
      }, i.default.createElement(l.Saturation, {
        style: E.Saturation,
        hsl: h,
        hsv: d,
        onChange: u
      })), i.default.createElement("div", {
        style: E.controls,
        className: "flexbox-fix"
      }, i.default.createElement("div", {
        style: E.sliders
      }, i.default.createElement("div", {
        style: E.hue
      }, i.default.createElement(l.Hue, {
        style: E.Hue,
        hsl: h,
        onChange: u
      })), i.default.createElement("div", {
        style: E.alpha
      }, i.default.createElement(l.Alpha, {
        style: E.Alpha,
        rgb: n,
        hsl: h,
        renderers: v,
        onChange: u
      }))), i.default.createElement("div", {
        style: E.color
      }, i.default.createElement(l.Checkboard, null), i.default.createElement("div", {
        style: E.activeColor
      }))), i.default.createElement(c.default, {
        rgb: n,
        hsl: h,
        hex: a,
        onChange: u,
        disableAlpha: m
      }), i.default.createElement(p.default, {
        colors: g,
        onClick: u,
        onSwatchHover: f
      }));
    };

    d.propTypes = {
      disableAlpha: a.default.bool,
      width: a.default.oneOfType([a.default.string, a.default.number]),
      styles: a.default.object
    }, d.defaultProps = {
      disableAlpha: !1,
      width: 200,
      styles: {},
      presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
    }, t.default = (0, l.ColorWrap)(d);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SketchFields = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = _interopRequireDefault(n(16)),
        o = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.SketchFields = function SketchFields(e) {
      var t = e.onChange,
          n = e.rgb,
          s = e.hsl,
          l = e.hex,
          c = e.disableAlpha,
          p = (0, i.default)({
        default: {
          fields: {
            display: "flex",
            paddingTop: "4px"
          },
          single: {
            flex: "1",
            paddingLeft: "6px"
          },
          alpha: {
            flex: "1",
            paddingLeft: "6px"
          },
          double: {
            flex: "2"
          },
          input: {
            width: "80%",
            padding: "4px 10% 3px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #ccc",
            fontSize: "11px"
          },
          label: {
            display: "block",
            textAlign: "center",
            fontSize: "11px",
            color: "#222",
            paddingTop: "3px",
            paddingBottom: "4px",
            textTransform: "capitalize"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, {
        disableAlpha: c
      }),
          d = function handleChange(e, r) {
        e.hex ? a.default.isValidHex(e.hex) && t({
          hex: e.hex,
          source: "hex"
        }, r) : e.r || e.g || e.b ? t({
          r: e.r || n.r,
          g: e.g || n.g,
          b: e.b || n.b,
          a: n.a,
          source: "rgb"
        }, r) : e.a && (e.a < 0 ? e.a = 0 : e.a > 100 && (e.a = 100), e.a /= 100, t({
          h: s.h,
          s: s.s,
          l: s.l,
          a: e.a,
          source: "rgb"
        }, r));
      };

      return r.default.createElement("div", {
        style: p.fields,
        className: "flexbox-fix"
      }, r.default.createElement("div", {
        style: p.double
      }, r.default.createElement(o.EditableInput, {
        style: {
          input: p.input,
          label: p.label
        },
        label: "hex",
        value: l.replace("#", ""),
        onChange: d
      })), r.default.createElement("div", {
        style: p.single
      }, r.default.createElement(o.EditableInput, {
        style: {
          input: p.input,
          label: p.label
        },
        label: "r",
        value: n.r,
        onChange: d,
        dragLabel: "true",
        dragMax: "255"
      })), r.default.createElement("div", {
        style: p.single
      }, r.default.createElement(o.EditableInput, {
        style: {
          input: p.input,
          label: p.label
        },
        label: "g",
        value: n.g,
        onChange: d,
        dragLabel: "true",
        dragMax: "255"
      })), r.default.createElement("div", {
        style: p.single
      }, r.default.createElement(o.EditableInput, {
        style: {
          input: p.input,
          label: p.label
        },
        label: "b",
        value: n.b,
        onChange: d,
        dragLabel: "true",
        dragMax: "255"
      })), r.default.createElement("div", {
        style: p.alpha
      }, r.default.createElement(o.EditableInput, {
        style: {
          input: p.input,
          label: p.label
        },
        label: "a",
        value: Math.round(100 * n.a),
        onChange: d,
        dragLabel: "true",
        dragMax: "100"
      })));
    };

    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SketchPresetColors = void 0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = _interopRequireDefault(n(0)),
        a = _interopRequireDefault(n(10)),
        o = _interopRequireDefault(n(5)),
        s = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var l = t.SketchPresetColors = function SketchPresetColors(e) {
      var t = e.colors,
          n = e.onClick,
          a = void 0 === n ? function () {} : n,
          l = e.onSwatchHover,
          c = (0, o.default)({
        default: {
          colors: {
            margin: "0 -10px",
            padding: "10px 0 0 10px",
            borderTop: "1px solid #eee",
            display: "flex",
            flexWrap: "wrap",
            position: "relative"
          },
          swatchWrap: {
            width: "16px",
            height: "16px",
            margin: "0 10px 10px 0"
          },
          swatch: {
            borderRadius: "3px",
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
          }
        },
        "no-presets": {
          colors: {
            display: "none"
          }
        }
      }, {
        "no-presets": !t || !t.length
      }),
          p = function handleClick(e, t) {
        a({
          hex: e,
          source: "hex"
        }, t);
      };

      return i.default.createElement("div", {
        style: c.colors,
        className: "flexbox-fix"
      }, t.map(function (e) {
        var t = "string" === typeof e ? {
          color: e
        } : e,
            n = "" + t.color + (t.title || "");
        return i.default.createElement("div", {
          key: n,
          style: c.swatchWrap
        }, i.default.createElement(s.Swatch, r({}, t, {
          style: c.swatch,
          onClick: p,
          onHover: l,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + t.color
          }
        })));
      }));
    };

    l.propTypes = {
      colors: a.default.arrayOf(a.default.oneOfType([a.default.string, a.default.shape({
        color: a.default.string,
        title: a.default.string
      })])).isRequired
    }, t.default = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Slider = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(10)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(11)),
        s = n(7),
        l = _interopRequireDefault(n(536)),
        c = _interopRequireDefault(n(538));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var p = t.Slider = function Slider(e) {
      var t = e.hsl,
          n = e.onChange,
          i = e.pointer,
          c = e.styles,
          p = void 0 === c ? {} : c,
          d = e.className,
          h = void 0 === d ? "" : d,
          u = (0, a.default)((0, o.default)({
        default: {
          hue: {
            height: "12px",
            position: "relative"
          },
          Hue: {
            radius: "2px"
          }
        }
      }, p));
      return r.default.createElement("div", {
        style: u.wrap || {},
        className: "slider-picker " + h
      }, r.default.createElement("div", {
        style: u.hue
      }, r.default.createElement(s.Hue, {
        style: u.Hue,
        hsl: t,
        pointer: i,
        onChange: n
      })), r.default.createElement("div", {
        style: u.swatches
      }, r.default.createElement(l.default, {
        hsl: t,
        onClick: n
      })));
    };

    p.propTypes = {
      styles: i.default.object
    }, p.defaultProps = {
      pointer: c.default,
      styles: {}
    }, t.default = (0, s.ColorWrap)(p);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SliderSwatches = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = _interopRequireDefault(n(537));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var o = t.SliderSwatches = function SliderSwatches(e) {
      var t = e.onClick,
          n = e.hsl,
          o = (0, i.default)({
        default: {
          swatches: {
            marginTop: "20px"
          },
          swatch: {
            boxSizing: "border-box",
            width: "20%",
            paddingRight: "1px",
            float: "left"
          },
          clear: {
            clear: "both"
          }
        }
      });
      return r.default.createElement("div", {
        style: o.swatches
      }, r.default.createElement("div", {
        style: o.swatch
      }, r.default.createElement(a.default, {
        hsl: n,
        offset: ".80",
        active: Math.abs(n.l - .8) < .1 && Math.abs(n.s - .5) < .1,
        onClick: t,
        first: !0
      })), r.default.createElement("div", {
        style: o.swatch
      }, r.default.createElement(a.default, {
        hsl: n,
        offset: ".65",
        active: Math.abs(n.l - .65) < .1 && Math.abs(n.s - .5) < .1,
        onClick: t
      })), r.default.createElement("div", {
        style: o.swatch
      }, r.default.createElement(a.default, {
        hsl: n,
        offset: ".50",
        active: Math.abs(n.l - .5) < .1 && Math.abs(n.s - .5) < .1,
        onClick: t
      })), r.default.createElement("div", {
        style: o.swatch
      }, r.default.createElement(a.default, {
        hsl: n,
        offset: ".35",
        active: Math.abs(n.l - .35) < .1 && Math.abs(n.s - .5) < .1,
        onClick: t
      })), r.default.createElement("div", {
        style: o.swatch
      }, r.default.createElement(a.default, {
        hsl: n,
        offset: ".20",
        active: Math.abs(n.l - .2) < .1 && Math.abs(n.s - .5) < .1,
        onClick: t,
        last: !0
      })), r.default.createElement("div", {
        style: o.clear
      }));
    };

    t.default = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SliderSwatch = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.SliderSwatch = function SliderSwatch(e) {
      var t = e.hsl,
          n = e.offset,
          a = e.onClick,
          o = void 0 === a ? function () {} : a,
          s = e.active,
          l = e.first,
          c = e.last,
          p = (0, i.default)({
        default: {
          swatch: {
            height: "12px",
            background: "hsl(" + t.h + ", 50%, " + 100 * n + "%)",
            cursor: "pointer"
          }
        },
        first: {
          swatch: {
            borderRadius: "2px 0 0 2px"
          }
        },
        last: {
          swatch: {
            borderRadius: "0 2px 2px 0"
          }
        },
        active: {
          swatch: {
            transform: "scaleY(1.8)",
            borderRadius: "3.6px/2px"
          }
        }
      }, {
        active: s,
        first: l,
        last: c
      });
      return r.default.createElement("div", {
        style: p.swatch,
        onClick: function handleClick(e) {
          return o({
            h: t.h,
            s: .5,
            l: n,
            source: "hsl"
          }, e);
        }
      });
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SliderPointer = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = t.SliderPointer = function SliderPointer() {
      var e = (0, i.default)({
        default: {
          picker: {
            width: "14px",
            height: "14px",
            borderRadius: "6px",
            transform: "translate(-7px, -1px)",
            backgroundColor: "rgb(248, 248, 248)",
            boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
          }
        }
      });
      return r.default.createElement("div", {
        style: e.picker
      });
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Swatches = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(10)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(26)),
        s = _interopRequireDefault(n(11)),
        l = _interopRequireDefault(n(16)),
        c = function _interopRequireWildcard(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
      return t.default = e, t;
    }(n(134)),
        p = n(7),
        d = _interopRequireDefault(n(540));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var h = t.Swatches = function Swatches(e) {
      var t = e.width,
          n = e.height,
          i = e.onChange,
          c = e.onSwatchHover,
          h = e.colors,
          u = e.hex,
          f = e.styles,
          m = void 0 === f ? {} : f,
          g = e.className,
          v = void 0 === g ? "" : g,
          b = (0, a.default)((0, s.default)({
        default: {
          picker: {
            width: t,
            height: n
          },
          overflow: {
            height: n,
            overflowY: "scroll"
          },
          body: {
            padding: "16px 0 6px 16px"
          },
          clear: {
            clear: "both"
          }
        }
      }, m)),
          y = function handleChange(e, t) {
        l.default.isValidHex(e) && i({
          hex: e,
          source: "hex"
        }, t);
      };

      return r.default.createElement("div", {
        style: b.picker,
        className: "swatches-picker " + v
      }, r.default.createElement(p.Raised, null, r.default.createElement("div", {
        style: b.overflow
      }, r.default.createElement("div", {
        style: b.body
      }, (0, o.default)(h, function (e) {
        return r.default.createElement(d.default, {
          key: e.toString(),
          group: e,
          active: u,
          onClick: y,
          onSwatchHover: c
        });
      }), r.default.createElement("div", {
        style: b.clear
      })))));
    };

    h.propTypes = {
      width: i.default.oneOfType([i.default.string, i.default.number]),
      height: i.default.oneOfType([i.default.string, i.default.number]),
      colors: i.default.arrayOf(i.default.arrayOf(i.default.string)),
      styles: i.default.object
    }, h.defaultProps = {
      width: 320,
      height: 240,
      colors: [[c.red[900], c.red[700], c.red[500], c.red[300], c.red[100]], [c.pink[900], c.pink[700], c.pink[500], c.pink[300], c.pink[100]], [c.purple[900], c.purple[700], c.purple[500], c.purple[300], c.purple[100]], [c.deepPurple[900], c.deepPurple[700], c.deepPurple[500], c.deepPurple[300], c.deepPurple[100]], [c.indigo[900], c.indigo[700], c.indigo[500], c.indigo[300], c.indigo[100]], [c.blue[900], c.blue[700], c.blue[500], c.blue[300], c.blue[100]], [c.lightBlue[900], c.lightBlue[700], c.lightBlue[500], c.lightBlue[300], c.lightBlue[100]], [c.cyan[900], c.cyan[700], c.cyan[500], c.cyan[300], c.cyan[100]], [c.teal[900], c.teal[700], c.teal[500], c.teal[300], c.teal[100]], ["#194D33", c.green[700], c.green[500], c.green[300], c.green[100]], [c.lightGreen[900], c.lightGreen[700], c.lightGreen[500], c.lightGreen[300], c.lightGreen[100]], [c.lime[900], c.lime[700], c.lime[500], c.lime[300], c.lime[100]], [c.yellow[900], c.yellow[700], c.yellow[500], c.yellow[300], c.yellow[100]], [c.amber[900], c.amber[700], c.amber[500], c.amber[300], c.amber[100]], [c.orange[900], c.orange[700], c.orange[500], c.orange[300], c.orange[100]], [c.deepOrange[900], c.deepOrange[700], c.deepOrange[500], c.deepOrange[300], c.deepOrange[100]], [c.brown[900], c.brown[700], c.brown[500], c.brown[300], c.brown[100]], [c.blueGrey[900], c.blueGrey[700], c.blueGrey[500], c.blueGrey[300], c.blueGrey[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
      styles: {}
    }, t.default = (0, p.ColorWrap)(h);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SwatchesGroup = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = _interopRequireDefault(n(26)),
        o = _interopRequireDefault(n(541));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.SwatchesGroup = function SwatchesGroup(e) {
      var t = e.onClick,
          n = e.onSwatchHover,
          s = e.group,
          l = e.active,
          c = (0, i.default)({
        default: {
          group: {
            paddingBottom: "10px",
            width: "40px",
            float: "left",
            marginRight: "10px"
          }
        }
      });
      return r.default.createElement("div", {
        style: c.group
      }, (0, a.default)(s, function (e, i) {
        return r.default.createElement(o.default, {
          key: e,
          color: e,
          active: e.toLowerCase() === l,
          first: 0 === i,
          last: i === s.length - 1,
          onClick: t,
          onSwatchHover: n
        });
      }));
    };

    t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SwatchesColor = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(5)),
        a = _interopRequireDefault(n(16)),
        o = n(7),
        s = _interopRequireDefault(n(542));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var l = t.SwatchesColor = function SwatchesColor(e) {
      var t = e.color,
          n = e.onClick,
          l = void 0 === n ? function () {} : n,
          c = e.onSwatchHover,
          p = e.first,
          d = e.last,
          h = e.active,
          u = (0, i.default)({
        default: {
          color: {
            width: "40px",
            height: "24px",
            cursor: "pointer",
            background: t,
            marginBottom: "1px"
          },
          check: {
            color: a.default.getContrastingColor(t),
            marginLeft: "8px",
            display: "none"
          }
        },
        first: {
          color: {
            overflow: "hidden",
            borderRadius: "2px 2px 0 0"
          }
        },
        last: {
          color: {
            overflow: "hidden",
            borderRadius: "0 0 2px 2px"
          }
        },
        active: {
          check: {
            display: "block"
          }
        },
        "color-#FFFFFF": {
          color: {
            boxShadow: "inset 0 0 0 1px #ddd"
          },
          check: {
            color: "#333"
          }
        },
        transparent: {
          check: {
            color: "#333"
          }
        }
      }, {
        first: p,
        last: d,
        active: h,
        "color-#FFFFFF": "#FFFFFF" === t,
        transparent: "transparent" === t
      });
      return r.default.createElement(o.Swatch, {
        color: t,
        style: u.color,
        onClick: l,
        onHover: c,
        focusStyle: {
          boxShadow: "0 0 4px " + t
        }
      }, r.default.createElement("div", {
        style: u.check
      }, r.default.createElement(s.default, null)));
    };

    t.default = l;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n(0));

    t.default = function (e) {
      var t = e.fill,
          n = void 0 === t ? "currentColor" : t,
          a = e.width,
          o = void 0 === a ? 24 : a,
          s = e.height,
          l = void 0 === s ? 24 : s,
          c = e.style,
          p = void 0 === c ? {} : c,
          d = function _objectWithoutProperties(e, t) {
        var n = {};

        for (var r in e) {
          t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
        }

        return n;
      }(e, ["fill", "width", "height", "style"]);

      return i.default.createElement("svg", r({
        viewBox: "0 0 24 24",
        style: r({
          fill: n,
          width: o,
          height: l
        }, p)
      }, d), i.default.createElement("path", {
        d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
      }));
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Twitter = void 0;

    var r = _interopRequireDefault(n(0)),
        i = _interopRequireDefault(n(10)),
        a = _interopRequireDefault(n(5)),
        o = _interopRequireDefault(n(26)),
        s = _interopRequireDefault(n(11)),
        l = _interopRequireDefault(n(16)),
        c = n(7);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var p = t.Twitter = function Twitter(e) {
      var t = e.onChange,
          n = e.onSwatchHover,
          i = e.hex,
          p = e.colors,
          d = e.width,
          h = e.triangle,
          u = e.styles,
          f = void 0 === u ? {} : u,
          m = e.className,
          g = void 0 === m ? "" : m,
          v = (0, a.default)((0, s.default)({
        default: {
          card: {
            width: d,
            background: "#fff",
            border: "0 solid rgba(0,0,0,0.25)",
            boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
            borderRadius: "4px",
            position: "relative"
          },
          body: {
            padding: "15px 9px 9px 15px"
          },
          label: {
            fontSize: "18px",
            color: "#fff"
          },
          triangle: {
            width: "0px",
            height: "0px",
            borderStyle: "solid",
            borderWidth: "0 9px 10px 9px",
            borderColor: "transparent transparent #fff transparent",
            position: "absolute"
          },
          triangleShadow: {
            width: "0px",
            height: "0px",
            borderStyle: "solid",
            borderWidth: "0 9px 10px 9px",
            borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
            position: "absolute"
          },
          hash: {
            background: "#F0F0F0",
            height: "30px",
            width: "30px",
            borderRadius: "4px 0 0 4px",
            float: "left",
            color: "#98A1A4",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          input: {
            width: "100px",
            fontSize: "14px",
            color: "#666",
            border: "0px",
            outline: "none",
            height: "28px",
            boxShadow: "inset 0 0 0 1px #F0F0F0",
            boxSizing: "content-box",
            borderRadius: "0 4px 4px 0",
            float: "left",
            paddingLeft: "8px"
          },
          swatch: {
            width: "30px",
            height: "30px",
            float: "left",
            borderRadius: "4px",
            margin: "0 6px 6px 0"
          },
          clear: {
            clear: "both"
          }
        },
        "hide-triangle": {
          triangle: {
            display: "none"
          },
          triangleShadow: {
            display: "none"
          }
        },
        "top-left-triangle": {
          triangle: {
            top: "-10px",
            left: "12px"
          },
          triangleShadow: {
            top: "-11px",
            left: "12px"
          }
        },
        "top-right-triangle": {
          triangle: {
            top: "-10px",
            right: "12px"
          },
          triangleShadow: {
            top: "-11px",
            right: "12px"
          }
        }
      }, f), {
        "hide-triangle": "hide" === h,
        "top-left-triangle": "top-left" === h,
        "top-right-triangle": "top-right" === h
      }),
          b = function handleChange(e, n) {
        l.default.isValidHex(e) && t({
          hex: e,
          source: "hex"
        }, n);
      };

      return r.default.createElement("div", {
        style: v.card,
        className: "twitter-picker " + g
      }, r.default.createElement("div", {
        style: v.triangleShadow
      }), r.default.createElement("div", {
        style: v.triangle
      }), r.default.createElement("div", {
        style: v.body
      }, (0, o.default)(p, function (e, t) {
        return r.default.createElement(c.Swatch, {
          key: t,
          color: e,
          hex: e,
          style: v.swatch,
          onClick: b,
          onHover: n,
          focusStyle: {
            boxShadow: "0 0 4px " + e
          }
        });
      }), r.default.createElement("div", {
        style: v.hash
      }, "#"), r.default.createElement(c.EditableInput, {
        label: null,
        style: {
          input: v.input
        },
        value: i.replace("#", ""),
        onChange: b
      }), r.default.createElement("div", {
        style: v.clear
      })));
    };

    p.propTypes = {
      width: i.default.oneOfType([i.default.string, i.default.number]),
      triangle: i.default.oneOf(["hide", "top-left", "top-right"]),
      colors: i.default.arrayOf(i.default.string),
      styles: i.default.object
    }, p.defaultProps = {
      width: 276,
      colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
      triangle: "top-left",
      styles: {}
    }, t.default = (0, c.ColorWrap)(p);
  }, function (e, t, n) {
    var r = n(545);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-color-picker {\n  margin-bottom: 16px;\n}\n\n.tide-color-picker .color-preview-square {\n  border-radius: 3px;\n  border: 1px solid var(--color-p3-4);\n  bottom: -8px;\n  cursor: pointer;\n  height: 25px;\n  left: 5px;\n  position: absolute;\n  width: 25px;\n}\n\n.tide-color-picker .color-preview-input {\n  width: 100%;\n}\n\n.tide-color-picker .color-preview-square:hover + .color-preview-input input.tide-input {\n  border: 1px solid var(--color-p3-5);\n}\n\n.tide-color-picker .color-preview-input input.tide-input {\n  padding-left: 40px;\n}\n\n.tide-color-picker .color-preview-input--active input.tide-input {\n  border: 1px solid var(--color-p3-6);\n}\n\n.tide-color-picker .color-preview-container {\n  display: -webkit-inline-flex;\n  display: inline-flex;\n  min-width: 80px;\n  width: 100%;\n}\n\n\n\n.tide-color-picker .tide-color-picker-label {\n  font-size: var(--font-size-subtle);\n  margin: 8px 4px 6px 0;\n  color: var(--color-p1-10);\n  font-family: var(--marketing-font-family--semibold);\n}\n\n.tide-color-picker .tide-color-picker-color-option {\n  width: calc(50% - 5px);\n  display: inline-block;\n  position: relative;\n}\n\n.tide-color-picker .tide-color-picker-color-option.tide-color-picker--solid-option {\n  width: 100%;\n}\n\n.tide-color-picker .chrome-picker {\n  position: absolute;\n  top: 64px;\n  z-index: 1;\n}\n\n.tide-color-picker .tide-color-picker-container {\n  position: absolute;\n  bottom: 60px;\n}\n\n.tide-color-picker .tide-color-picker-tooltip--info svg {\n  cursor: pointer;\n}\n\n.tide-color-picker .tide-color-picker-tooltip .tide-tooltip {\n  width: 200px;\n  word-wrap: break-word;\n  white-space: normal;\n}\n\n.tide-color-picker .tide-color-picker-tooltip--focus .tide-tooltip--up {\n  bottom: 48px;\n}\n\n.tide-color-picker .tide-color-picker-tooltip--focus .tide-tooltip--up,\n.tide-color-picker .tide-color-picker-tooltip--focus .tide-tooltip--down {\n  width: 100%;\n}\n\n.tide-color-picker .tide-color-picker-subtext {\n  margin: 4px 0;\n}\n\n.tide-color-picker .tide-color-picker-error {\n  margin: 3px 0 4px;\n  color: var(--color-s3-6);\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(547);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, '.tide-colorway-theme--CMYK {\n  --tide-colorway-theme-1: url("https://tide-assets.s3.amazonaws.com/colorway-themes/CMYK/CMYK-1.svg");\n  --tide-colorway-theme-2: url("https://tide-assets.s3.amazonaws.com/colorway-themes/CMYK/CMYK-2.svg");\n  --tide-colorway-theme-3: url("https://tide-assets.s3.amazonaws.com/colorway-themes/CMYK/CMYK-3.svg");\n  --tide-colorway-theme-4: url("https://tide-assets.s3.amazonaws.com/colorway-themes/CMYK/CMYK-4.svg");\n}\n\n.tide-colorway-theme--AUTO {\n  --tide-colorway-theme-1: url("https://tide-assets.s3.amazonaws.com/colorway-themes/AUTO/AUTO-1.svg");\n  --tide-colorway-theme-2: url("https://tide-assets.s3.amazonaws.com/colorway-themes/AUTO/AUTO-2.svg");\n  --tide-colorway-theme-3: url("https://tide-assets.s3.amazonaws.com/colorway-themes/AUTO/AUTO-3.svg");\n  --tide-colorway-theme-4: url("https://tide-assets.s3.amazonaws.com/colorway-themes/AUTO/AUTO-4.svg");\n}\n\n.tide-colorway-theme--HG {\n  --tide-colorway-theme-1: url("https://tide-assets.s3.amazonaws.com/colorway-themes/HG/80x80-HG2020-1.svg");\n  --tide-colorway-theme-2: url("https://tide-assets.s3.amazonaws.com/colorway-themes/HG/80x80-HG2020-2.svg");\n  --tide-colorway-theme-3: url("https://tide-assets.s3.amazonaws.com/colorway-themes/HG/80x80-HG2020-3.svg");\n  --tide-colorway-theme-4: url("https://tide-assets.s3.amazonaws.com/colorway-themes/HG/80x80-HG2020-4.svg");\n}\n\n.tide-colorway {\n  width: 80px;\n  height: 80px;\n  display: block;\n  position: relative;\n\n  background: var(--tide-colorway-theme-1);\n  background-repeat: no-repeat;\n}\n\n.tide-colorway-size--large {\n  background-size: 120px 120px;\n  width: 120px;\n  height: 120px;\n}\n\n.tide-colorway-size--medium {\n  background-size: auto;\n}\n\n.tide-colorway-size--small {\n  background-size: 50%;\n  background-position: center;\n}\n\n.tide-colorway--content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n\n.tide-colorway.tide-colorway-type--1 {\n  background-image: var(--tide-colorway-theme-1);\n}\n\n.tide-colorway.tide-colorway-type--2 {\n  background-image: var(--tide-colorway-theme-2);\n}\n\n.tide-colorway.tide-colorway-type--3 {\n  background-image: var(--tide-colorway-theme-3);\n}\n\n.tide-colorway.tide-colorway-type--4 {\n  background-image: var(--tide-colorway-theme-4);\n}\n\n\n', ""]);
  }, function (e, t, n) {
    var r = n(549);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, ".tide-opt-banner {\n  height: 40px;\n  padding: 6px 16px;\n  background-color: var(--color-p1-3);\n  -webkit-justify-content: space-around;\n          justify-content: space-around;\n  display: -webkit-flex;\n  display: flex;\n}\n\n.tide-opt-banner--in,\n.tide-opt-banner--actions {\n  display: -webkit-flex;\n  display: flex;\n}\n\n.tide-opt-banner--in .tide-ribbon {\n  margin: 0;\n}\n\n.tide-opt-banner--in .tide-ribbon--container {\n  margin: auto 0;\n}\n\n.tide-opt-banner--first-button {\n  margin-right: 8px;\n}\n\n.tide-opt-banner--divide {\n  border-left: 1px solid var(--color-p1-10);\n  content: '';\n  margin: auto 0;\n  height: 24px;\n}\n\n.tide-opt-banner--second-button {\n  margin-left: 8px;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(551);
    "string" === typeof r && (r = [[e.i, r, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(4)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(3)(!1)).push([e.i, "\n.tide-inline-select.Select {\n  display: inline-block;\n  vertical-align: bottom;\n  width: 100%;\n}\n\n/* Select-control */\n.tide-inline-select .Select-control {\n  border: 1px solid transparent;\n  border-bottom: 1px dashed var(--color-p1-8);\n  border-radius: 0;\n  color: var(--color-p1);\n  font-family: var(--marketing-font-family);\n  background-color: transparent;\n  vertical-align: middle;\n  box-sizing: border-box;\n  font-size: 14px;\n  box-shadow: none;\n  height: 20px;\n}\n\n.tide-inline-select .Select-control:hover {\n  border-color: var(--color-p3-5);\n  border-bottom: 1px solid var(--color-p3-5);\n  background-color: var(--color-p3-2);\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n.tide-inline-select.Select.is-open > .Select-control {\n  border: 1px solid var(--color-p3);\n  border-radius: 3px;\n  outline-color: transparent;\n}\n\n.tide-inline-select.is-focused:not(.is-open) > .Select-control {\n  box-shadow: unset;\n  border: 1px solid var(--color-p3);\n  border-radius: 3px;\n}\n\n.tide-inline-select .Select-control > *:last-child {\n  padding-right: 14px;\n}\n\n/* Select-placeholder */\n.tide-inline-select .Select-placeholder {\n  color: var(--color-p1-6);\n  line-height: 18px;\n  padding: 1px 4px 0px 4px;\n}\n\n/* Select-arrow-zone */\n.tide-inline-select .Select-arrow-zone {\n  position: relative;\n  padding: 0px 14px 0px;\n}\n\n/* Select-arrow */\n.tide-inline-select .Select-arrow {\n  border-color: transparent;\n  border-style: none;\n  border-width: 0px;\n  position: relative;\n}\n\n.tide-inline-select .Select-arrow:after {\n  content: '\\2304';\n  position: absolute;\n  top: -4px;\n  left: -6px;\n  height: 10px;\n  width: 10px;\n  display: block;\n  font-size: 21px;\n  line-height: 0px;\n  -webkit-transform: scaleX(1.4);\n          transform: scaleX(1.4);\n}\n\n.tide-inline-select.Select.is-open > .Select-control .Select-arrow {\n  top: 0px;\n}\n\n/* Select-menu-outer */\n.tide-inline-select .Select-menu-outer {\n  box-shadow: var(--box-shadow-1);\n  border-radius: 3px;\n  margin-top: 4px;\n}\n\n/* Select-option */\n.tide-inline-select .Select-option.is-focused {\n  color: var(--color-p1);\n}\n\n.tide-inline-select .Select-option {\n  cursor: pointer;\n}\n\n.tide-inline-select .Select-option:hover,\n.tide-inline-select .Select-option.is-focused {\n  background-color: var(--color-p3-2);\n}\n\n.tide-inline-select .Select-option.is-selected {\n  background-color: var(--color-p3-3);\n}\n\n/* Select-input */\n.tide-inline-select .Select-input {\n  height: 14px;\n}\n\n.tide-inline-select .Select-control .Select-input:focus {\n  background-color: transparent;\n}\n\n/* Select-value */\n.tide-inline-select .Select-control .Select-value {\n  line-height: 18px;\n  padding: 1px 4px 0px 4px;\n}\n", ""]);
  }, function (e, t, n) {
    "use strict";

    function _defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function _classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function _createClass(e, t, n) {
      return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
    }

    function _typeof2(e) {
      return (_typeof2 = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof2(e) {
        return typeof e;
      } : function _typeof2(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function _typeof(e) {
      return (_typeof = "function" === typeof Symbol && "symbol" === _typeof2(Symbol.iterator) ? function _typeof(e) {
        return _typeof2(e);
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof2(e);
      })(e);
    }

    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" !== typeof t ? function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _inherits(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && _setPrototypeOf(e, t);
    }

    n.r(t);
    var r = n(0),
        i = n.n(r),
        a = n(1),
        o = n.n(a),
        s = (n(143), function (e) {
      function AccordionRow(e) {
        var t;
        return _classCallCheck(this, AccordionRow), (t = _possibleConstructorReturn(this, _getPrototypeOf(AccordionRow).call(this, e))).performAction = function () {
          var e = t.props,
              n = e.href,
              r = e.onClick;
          "link" === e.actionType ? (r && r(), n && window.open(n, "_self")) : t.expandDrawer();
        }, t.expandDrawer = function () {
          var e = t.props,
              n = e.children,
              r = e.actionType;
          n && "link" !== r && t.setState(function (e) {
            return {
              isOpen: !e.isOpen
            };
          });
        }, t.onHover = function () {
          if ("dropdown" === t.props.actionType) return !1;
          t.setState(function (e) {
            return {
              viewLinkVisible: !e.viewLinkVisible
            };
          });
        }, t.state = {
          viewLinkVisible: !1,
          isOpen: e.startOpen || !1
        }, t;
      }

      return _inherits(AccordionRow, r["Component"]), _createClass(AccordionRow, [{
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.isOpen,
              n = e.viewLinkVisible,
              r = this.props,
              a = r.children,
              s = r.title,
              l = r.description,
              c = r.href,
              d = r.linkText,
              h = void 0 === d ? "View" : d,
              u = r.actionType,
              f = r.className;
          return i.a.createElement(li, {
            className: o()("tide-accordion--row", _defineProperty({
              "tide-accordion--row--open": t
            }, f, !!f))
          }, i.a.createElement(li, {
            className: "tide-accordion--row--header",
            onMouseEnter: this.onHover,
            onMouseLeave: this.onHover,
            onClick: this.performAction
          }, i.a.createElement(li, {
            className: "tide-accordion--row--header-text"
          }, i.a.createElement(li, {
            className: "tide-accordion--row--header-text-container"
          }, i.a.createElement(ri, null, s), !!l && i.a.createElement(si, {
            type: "small"
          }, l)), i.a.createElement(li, {
            className: "tide-accordion--row--action"
          }, n && "link" === u && i.a.createElement(oi, {
            className: "tide-accordion--row--link-fake"
          }, h), "dropdown" === u && !t && i.a.createElement(p, {
            name: "chevron-right-bold",
            height: 20
          }), "dropdown" === u && t && i.a.createElement(p, {
            name: "chevron-down-bold"
          })))), !!a && !c && t && "link" !== u && i.a.createElement(li, {
            className: "tide-accordion--row--body"
          }, a));
        }
      }]), AccordionRow;
    }());

    var l = {
      "widget-online": function widgetOnline(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "28" : n,
            a = e.height,
            o = void 0 === a ? "25" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 28 25"
        }, i.a.createElement("g", {
          fill: "#7695A5",
          fillRule: "evenodd"
        }, i.a.createElement("path", {
          d: "M14 1.75c-6.755 0-12.25 3.925-12.25 8.75 0 3.74 3.535 6.066 5.64 7.12.298.148.485.45.485.782 0 1.557-.47 2.98-.945 4.018 1.235-.367 2.825-1.13 3.676-2.698.15-.28.444-.455.762-.458 0 0 1.703-.014 2.632-.014 6.755 0 12.25-3.925 12.25-8.75S20.755 1.75 14 1.75zM5.25 24.5c-.32 0-.618-.176-.77-.46-.16-.297-.136-.658.063-.93.014-.02 1.37-1.914 1.56-4.187C2.16 16.805 0 13.83 0 10.5 0 4.71 6.28 0 14 0s14 4.71 14 10.5S21.72 21 14 21c-.61 0-1.554.006-2.126.01-2.11 3.234-6.392 3.48-6.582 3.49H5.25z"
        }), i.a.createElement("path", {
          d: "M12.19 14.608c.372.373.982.353 1.33-.044l5.73-6.25c.33-.38.293-.956-.086-1.288-.38-.33-.954-.293-1.286.086l-5.09 5.517-2.045-2.045c-.355-.356-.933-.356-1.29 0-.354.356-.354.933 0 1.29l2.736 2.733z"
        })));
      },
      "widget-offline": function widgetOffline(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "28" : n,
            a = e.height,
            o = void 0 === a ? "25" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 28 25"
        }, i.a.createElement("path", {
          d: "M5.25 24.5c-.32 0-.618-.176-.77-.46-.16-.297-.136-.658.063-.93.014-.02 1.37-1.914 1.56-4.187C2.16 16.805 0 13.83 0 10.5 0 4.71 6.28 0 14 0s14 4.71 14 10.5S21.72 21 14 21c-.61 0-1.554.006-2.126.01-2.11 3.234-6.392 3.48-6.582 3.49H5.25zM14 1.75c-6.755 0-12.25 3.925-12.25 8.75 0 3.74 3.535 6.066 5.64 7.12.298.148.485.45.485.782 0 1.557-.47 2.98-.945 4.018 1.235-.367 2.825-1.13 3.676-2.698.15-.28.444-.455.762-.458 0 0 1.703-.014 2.632-.014 6.755 0 12.25-3.925 12.25-8.75S20.755 1.75 14 1.75zM10.432 7c0-.483.39-.875.87-.875h5.225c.33 0 .632.187.78.484.147.295.115.65-.083.916l-4.18 5.6h3.483c.48 0 .87.39.87.874s-.39.875-.87.875h-5.225c-.33 0-.63-.187-.778-.484-.147-.296-.116-.65.083-.915l4.18-5.6H11.3c-.48 0-.87-.392-.87-.875z",
          fill: "#7695A5",
          fillRule: "evenodd"
        }));
      },
      "window-search": function windowSearch(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M24 24h-21.818c-1.203 0-2.182-0.98-2.182-2.182v-19.636c0-1.203 0.979-2.182 2.182-2.182h21.818c1.203 0 2.182 0.979 2.182 2.182v19.636c0 1.202-0.979 2.182-2.182 2.182zM23.997 21.818l0.002-15.273h-21.817v15.273h21.815zM2.182 2.182v2.182h21.818v-2.182h-21.818zM12 8.68c2.407 0 4.364 1.957 4.364 4.364 0 0.807-0.235 1.553-0.619 2.203l2.481 2.481c0.427 0.425 0.427 1.116 0 1.543-0.213 0.214-0.492 0.32-0.771 0.32s-0.559-0.106-0.771-0.32l-2.481-2.481c-0.649 0.384-1.395 0.619-2.203 0.619-2.407 0-4.364-1.957-4.364-4.364s1.957-4.364 4.364-4.364zM12 15.226c0.425 0 0.82-0.128 1.157-0.339 0.051-0.157 0.128-0.307 0.253-0.432 0.125-0.124 0.275-0.202 0.432-0.253 0.212-0.337 0.339-0.731 0.339-1.157 0-1.202-0.979-2.182-2.182-2.182s-2.182 0.98-2.182 2.182c0 1.203 0.979 2.182 2.182 2.182z"
        }));
      },
      "window-content": function windowContent(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M24 24h-21.818c-1.203 0-2.182-0.979-2.182-2.182v-19.636c0-1.202 0.979-2.182 2.182-2.182h21.818c1.203 0 2.182 0.98 2.182 2.182v19.636c0 1.203-0.979 2.182-2.182 2.182zM2.182 21.818h21.815l0.002-15.273h-21.817v15.273zM2.182 2.182v2.182h21.818v-2.182h-21.818zM20.727 15.273h-6.545c-0.602 0-1.091-0.488-1.091-1.091s0.489-1.091 1.091-1.091h6.545c0.602 0 1.091 0.488 1.091 1.091s-0.489 1.091-1.091 1.091zM20.727 12h-6.545c-0.602 0-1.091-0.488-1.091-1.091 0-0.602 0.489-1.091 1.091-1.091h6.545c0.602 0 1.091 0.489 1.091 1.091 0 0.603-0.489 1.091-1.091 1.091zM9.818 18.545h-4.364c-0.602 0-1.091-0.489-1.091-1.091v-6.545c0-0.602 0.489-1.091 1.091-1.091h4.364c0.602 0 1.091 0.489 1.091 1.091v6.545c0 0.602-0.489 1.091-1.091 1.091zM8.727 12h-2.182v4.364h2.182v-4.364zM14.182 16.364h2.182c0.602 0 1.091 0.488 1.091 1.091 0 0.602-0.489 1.091-1.091 1.091h-2.182c-0.602 0-1.091-0.489-1.091-1.091 0-0.603 0.489-1.091 1.091-1.091z"
        }));
      },
      "window-code": function windowCode(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M24 24h-21.818c-1.203 0-2.182-0.979-2.182-2.182v-19.636c0-1.202 0.979-2.182 2.182-2.182h21.818c1.203 0 2.182 0.98 2.182 2.182v19.636c0 1.203-0.979 2.182-2.182 2.182zM2.182 21.818h21.815l0.002-15.273h-21.817v15.273zM2.182 2.182v2.182h21.818v-2.182h-21.818zM16.044 18.227c-0.213 0.213-0.492 0.32-0.771 0.32s-0.559-0.107-0.771-0.32c-0.427-0.425-0.427-1.116 0-1.543l2.501-2.501-2.501-2.501c-0.427-0.427-0.427-1.116 0-1.543 0.427-0.425 1.116-0.425 1.543 0l3.273 3.273c0.427 0.427 0.427 1.117 0 1.543l-3.273 3.273zM11.68 18.226c-0.213 0.213-0.492 0.32-0.771 0.32s-0.559-0.107-0.771-0.32l-3.273-3.273c-0.427-0.427-0.427-1.116 0-1.543l3.273-3.273c0.427-0.427 1.116-0.427 1.543 0 0.427 0.425 0.427 1.116 0 1.543l-2.501 2.501 2.501 2.501c0.427 0.427 0.427 1.117 0 1.543z"
        }));
      },
      "window-bookmark": function windowBookmark(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M24 24h-21.818c-1.203 0-2.182-0.979-2.182-2.182v-19.636c0-1.202 0.979-2.182 2.182-2.182h21.818c1.202 0 2.182 0.98 2.182 2.182v19.636c0 1.203-0.98 2.182-2.182 2.182zM2.182 21.818h21.815l0.002-15.273h-2.181v5.455c0 0.403-0.221 0.772-0.576 0.962-0.161 0.086-0.338 0.129-0.515 0.129-0.212 0-0.423-0.061-0.605-0.183l-2.666-1.778-2.668 1.778c-0.335 0.223-0.766 0.244-1.12 0.055s-0.576-0.56-0.576-0.962v-5.455h-10.909v15.273zM2.182 4.364h10.909v-2.182h-10.909v2.182zM15.273 2.182v7.78l1.577-1.052c0.367-0.244 0.844-0.244 1.211 0l1.575 1.051v-7.779h-4.364zM21.818 2.182v2.182h2.182v-2.182h-2.182z"
        }));
      },
      "link-1": function link1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22.421 9.243l-2.175 2.175c-1.025 1.024-2.386 1.588-3.834 1.588h-0.416c-0.553 0-1.001-0.448-1.001-1s0.449-1.001 1.001-1.001h0.416c0.913 0 1.772-0.356 2.419-1.001l2.175-2.175c0.646-0.648 1.001-1.507 1.001-2.422 0-0.913-0.355-1.772-1.001-2.42-1.335-1.333-3.505-1.333-4.839 0l-2.174 2.176c-0.646 0.646-1.002 1.507-1.002 2.421v0.408c0 0.554-0.449 1.002-1.001 1.002s-1.001-0.449-1.001-1.002v-0.408c0-1.448 0.565-2.81 1.588-3.836l2.176-2.176c2.115-2.114 5.556-2.114 7.67 0 1.025 1.024 1.589 2.386 1.589 3.835s-0.564 2.811-1.589 3.837zM7.987 17.004c-0.256 0-0.511-0.098-0.707-0.293-0.391-0.391-0.391-1.025 0-1.416l8.010-8.010c0.39-0.391 1.024-0.391 1.415 0s0.39 1.025 0 1.415l-8.010 8.011c-0.196 0.195-0.451 0.293-0.708 0.293zM7.993 12.993h-0.414c-0.913 0-1.773 0.356-2.421 1.001l-2.174 2.176c-1.333 1.334-1.334 3.507 0 4.84 1.334 1.332 3.506 1.332 4.84 0l2.174-2.175c0.646-0.648 1.002-1.507 1.002-2.422v-0.41c0-0.554 0.449-1.001 1.001-1.001s1.001 0.448 1.001 1.001v0.41c0 1.449-0.565 2.811-1.589 3.837l-2.175 2.175c-1.057 1.057-2.447 1.586-3.836 1.586s-2.778-0.528-3.835-1.586c-2.114-2.114-2.114-5.555-0.001-7.672l2.175-2.175c1.026-1.025 2.388-1.589 3.836-1.589h0.414c0.554 0 1.001 0.448 1.001 1.001s-0.448 1.001-1.001 1.001z"
        }));
      },
      "firewall-done": function firewallDone(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 20 24"
        }, i.a.createElement("path", {
          d: "M20.073 10.016c-0.001 0.104-0.222 10.491-9.687 13.916-0.007 0.002-0.014 0.001-0.020 0.003-0.103 0.035-0.212 0.057-0.323 0.057s-0.22-0.022-0.323-0.057c-0.007-0.002-0.013-0.001-0.020-0.003-9.465-3.425-9.686-13.812-9.687-13.916-0.006-0.552-0.011-1.456-0.011-2.008v-2.997c0-1.101 0.901-1.998 2.008-1.998h1.004c4.218 0 6.116-2.481 6.195-2.587 0.191-0.255 0.48-0.379 0.776-0.389 0.339-0.028 0.684 0.099 0.896 0.394 0.075 0.1 1.974 2.582 6.192 2.582h1.004c1.108 0 2.008 0.898 2.008 1.998v2.997c0 0.552-0.005 1.456-0.011 2.008zM18.075 5.010h-1.004c-3.669 0-5.935-1.564-7.029-2.575-1.095 1.011-3.36 2.575-7.029 2.575h-1.004v2.997c0 0.546 0.005 1.441 0.011 1.987 0.005 0.364 0.234 8.841 8.021 11.912 7.821-3.089 8.022-11.822 8.023-11.912 0.006-0.546 0.011-1.441 0.011-1.987v-2.997zM10.43 15.593c-0.164 0.222-0.414 0.367-0.689 0.4-0.040 0.005-0.079 0.007-0.12 0.007-0.235 0-0.463-0.082-0.645-0.233l-3.595-2.997c-0.426-0.354-0.481-0.984-0.126-1.408 0.355-0.422 0.99-0.48 1.415-0.124l2.776 2.314 3.805-5.137c0.329-0.444 0.957-0.539 1.404-0.212s0.542 0.953 0.213 1.397l-4.438 5.994z"
        }));
      },
      "code-3": function code3(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M26.016 12.775l-5.488 5.463c-0.214 0.213-0.495 0.319-0.776 0.319s-0.562-0.106-0.776-0.319c-0.429-0.427-0.429-1.118 0-1.544l4.712-4.691-4.712-4.685c-0.429-0.426-0.429-1.118 0-1.545 0.429-0.426 1.123-0.426 1.552 0l5.488 5.458c0.206 0.205 0.322 0.482 0.322 0.771s-0.115 0.568-0.322 0.773zM10.928 23.237c-0.143 0.473-0.578 0.777-1.051 0.777-0.104 0-0.21-0.014-0.315-0.045-0.581-0.173-0.91-0.784-0.736-1.36l6.584-21.84c0.173-0.577 0.782-0.908 1.366-0.732 0.581 0.173 0.91 0.781 0.736 1.359l-6.584 21.841zM7.361 18.235c-0.214 0.213-0.495 0.319-0.776 0.319s-0.562-0.106-0.776-0.319l-5.488-5.458c-0.205-0.204-0.322-0.482-0.322-0.771 0-0.289 0.116-0.567 0.322-0.773l5.488-5.462c0.429-0.427 1.123-0.427 1.552 0 0.429 0.426 0.429 1.117 0 1.544l-4.712 4.69 4.712 4.685c0.429 0.426 0.429 1.118 0 1.545z"
        }));
      },
      "flag-1": function flag1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "22" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 22 24"
        }, i.a.createElement("path", {
          d: "M21.147 12.95c-1.89 1.525-3.831 2.042-5.742 2.042-2.004 0-3.975-0.557-5.824-1.079-2.93-0.828-5.476-1.52-7.599-0.029v9.101c0 0.552-0.44 0.999-0.985 0.999s-0.986-0.447-0.986-0.999v-20.506c0-0.029 0.014-0.054 0.016-0.083-0.009-0.298 0.097-0.596 0.34-0.801 2.982-2.512 6.419-1.54 9.744-0.601 3.518 0.992 6.838 1.93 9.979-0.731 0.138-0.118 0.301-0.173 0.466-0.202 0.056-0.015 0.102-0.045 0.166-0.045 0.027 0 0.056 0.016 0.084 0.018 0.010 0.001 0.019 0.006 0.029 0.007 0.522 0.066 1.114 0.559 1.114 1.074v10.959c0 0.412-0.381 0.737-0.801 0.876zM15.404 3.999c-2.004 0-3.975-0.557-5.824-1.079-2.93-0.828-5.476-1.52-7.599-0.029v8.709c2.575-1.15 5.388-0.387 8.129 0.389 3.468 0.978 6.745 1.896 9.845-0.629v-8.569c-1.509 0.887-3.039 1.207-4.551 1.207z"
        }));
      },
      users: function users(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "34" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 34 24"
        }, i.a.createElement("path", {
          d: "M34 19.407v0.593c0 0.552-0.448 1-1 1h-10c-0.552 0-1-0.448-1-1s0.448-1 1-1h8.985c-0.238-3.292-3.34-6-6.985-6-1.618 0-3.146 0.512-4.419 1.482-0.44 0.334-1.066 0.249-1.401-0.189-0.335-0.439-0.25-1.067 0.19-1.402 0.907-0.691 1.949-1.184 3.045-1.5-2.012-0.97-3.415-3.012-3.415-5.391 0-3.308 2.691-6 6-6s6 2.692 6 6c0 2.369-1.392 4.403-3.39 5.377 3.653 1.074 6.39 4.317 6.39 8.030zM29 6c0-2.205-1.794-4-4-4s-4 1.795-4 4c0 2.205 1.794 4 4 4s4-1.795 4-4zM12.823 13.4c4.097 1.17 7.177 4.785 7.177 8.933v0.667c0 0.552-0.448 1-1 1h-18c-0.552 0-1-0.448-1-1v-0.667c0-4.148 3.080-7.763 7.177-8.933-2.457-1.088-4.177-3.545-4.177-6.4 0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4zM2.009 22h15.982c-0.197-3.827-3.776-7-7.991-7s-7.794 3.173-7.991 7zM10 2c-2.757 0-5 2.243-5 5s2.243 5 5 5c2.757 0 5-2.243 5-5s-2.243-5-5-5z"
        }));
      },
      user: function user(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 20 24"
        }, i.a.createElement("path", {
          d: "M19 24h-18c-0.552 0-1-0.448-1-1v-0.667c0-4.148 3.080-7.763 7.177-8.933-2.457-1.088-4.177-3.545-4.177-6.4 0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4 4.097 1.17 7.177 4.785 7.177 8.933v0.667c0 0.552-0.448 1-1 1zM15 7c0-2.757-2.243-5-5-5s-5 2.243-5 5c0 2.757 2.243 5 5 5s5-2.243 5-5zM10 15c-4.215 0-7.794 3.173-7.991 7h15.982c-0.197-3.827-3.776-7-7.991-7z"
        }));
      },
      "user-target": function userTarget(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M12 24c-6.617 0-12-5.383-12-12s5.383-12 12-12c6.617 0 12 5.383 12 12s-5.383 12-12 12zM13 2.051v0.949c0 0.552-0.448 1-1 1s-1-0.448-1-1v-0.949c-4.717 0.47-8.478 4.232-8.949 8.949h0.949c0.552 0 1 0.448 1 1s-0.448 1-1 1h-0.949c0.471 4.717 4.232 8.479 8.949 8.95v-0.95c0-0.552 0.448-1 1-1s1 0.448 1 1v0.95c4.717-0.471 8.478-4.233 8.948-8.95h-0.948c-0.552 0-1-0.448-1-1s0.448-1 1-1h0.948c-0.47-4.717-4.231-8.479-8.948-8.949zM15 17h-6c-1.103 0-2-0.785-2-1.75v-0.75c0-0.045 0.020-0.083 0.026-0.126 0.009-0.070 0.017-0.137 0.041-0.204 0.021-0.060 0.052-0.112 0.084-0.167 0.033-0.056 0.064-0.11 0.107-0.159 0.046-0.051 0.098-0.090 0.153-0.131 0.036-0.027 0.061-0.064 0.102-0.087l1.81-1.009c-0.322-0.827-0.33-1.59-0.32-1.851 0-0.006-0.003-0.011-0.003-0.017l0.002-2.25c0-0.026 0.013-0.047 0.015-0.073 0.002-0.031-0.009-0.060-0.003-0.092 0.243-1.441 1.739-2.333 2.986-2.333 1.256 0.041 2.743 0.89 2.986 2.333 0.006 0.032-0.005 0.061-0.003 0.092 0.002 0.025 0.015 0.047 0.015 0.073l0.002 2.25c0 0.006-0.003 0.011-0.003 0.017 0.010 0.262 0.001 1.020-0.318 1.844l1.811 1.018c0.039 0.022 0.063 0.059 0.098 0.085 0.056 0.041 0.109 0.081 0.155 0.133 0.043 0.049 0.074 0.103 0.107 0.158 0.032 0.055 0.062 0.107 0.084 0.168 0.023 0.066 0.032 0.133 0.041 0.203 0.005 0.043 0.025 0.081 0.025 0.125v0.75c0 0.965-0.897 1.75-2 1.75zM12.843 13.872c-0.019-0.011-0.029-0.029-0.047-0.040-0.024-0.016-0.051-0.022-0.074-0.040-0.035-0.027-0.053-0.066-0.084-0.097-0.048-0.048-0.093-0.094-0.13-0.15-0.035-0.054-0.060-0.109-0.084-0.168-0.025-0.060-0.047-0.117-0.060-0.181-0.013-0.062-0.015-0.123-0.015-0.186-0.001-0.065 0-0.126 0.012-0.191s0.036-0.125 0.061-0.188c0.016-0.040 0.018-0.083 0.039-0.121 0.013-0.022 0.034-0.035 0.048-0.056s0.017-0.045 0.033-0.065c0.504-0.654 0.456-1.562 0.456-1.571-0.001-0.017 0.006-0.031 0.006-0.047 0-0.007-0.004-0.013-0.004-0.020l-0.002-2.116c-0.076-0.286-0.55-0.635-0.998-0.635s-0.921 0.35-0.998 0.635l-0.002 2.116c0 0.007-0.004 0.012-0.004 0.019 0 0.017 0.008 0.031 0.006 0.048-0.001 0.031-0.042 0.925 0.457 1.57 0.022 0.029 0.028 0.064 0.046 0.094 0.010 0.016 0.027 0.025 0.036 0.042 0.016 0.028 0.016 0.059 0.028 0.088 0.032 0.074 0.059 0.146 0.072 0.223 0.011 0.062 0.012 0.121 0.012 0.182-0.001 0.060-0.003 0.118-0.015 0.177-0.015 0.077-0.041 0.147-0.073 0.219-0.018 0.040-0.035 0.078-0.059 0.116-0.049 0.081-0.112 0.149-0.185 0.214-0.016 0.015-0.024 0.035-0.041 0.048-0.012 0.009-0.027 0.012-0.039 0.021-0.031 0.022-0.051 0.054-0.086 0.073l-1.999 1.115h5.694l-2.007-1.128z"
        }));
      },
      "user-profile-2": function userProfile2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "29" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 29 24"
        }, i.a.createElement("path", {
          d: "M26.72 20.4h-24.641c-1.147 0-2.080-0.942-2.080-2.1v-16.2c0-1.158 0.932-2.1 2.080-2.1h24.641c1.147 0 2.080 0.942 2.080 2.1v16.2c0 1.158-0.932 2.1-2.080 2.1zM26.4 2.4h-24v15.6h24v-15.6zM3.683 13.392c0.026-0.073 0.067-0.134 0.107-0.199 0.040-0.066 0.074-0.132 0.127-0.19 0.058-0.064 0.126-0.11 0.197-0.161 0.044-0.032 0.076-0.077 0.125-0.103l2.3-1.217c-0.422-1.034-0.457-1.973-0.457-2.191 0-0.012-0.006-0.022-0.006-0.032l0.002-2.7c0-0.031 0.014-0.056 0.017-0.086 0.002-0.038-0.010-0.073-0.004-0.112 0.292-1.73 2.1-2.801 3.608-2.801 1.499 0 3.298 1.070 3.589 2.801 0.007 0.038-0.006 0.073-0.004 0.112 0.002 0.030 0.018 0.055 0.018 0.086l0.002 2.7c0 0.012-0.006 0.022-0.007 0.032-0.001 0.212-0.037 1.164-0.469 2.209l2.159 1.214c0.046 0.025 0.073 0.067 0.115 0.098 0.068 0.050 0.133 0.1 0.19 0.163 0.052 0.059 0.088 0.122 0.126 0.188 0.040 0.066 0.076 0.128 0.102 0.202 0.028 0.080 0.038 0.161 0.049 0.246 0.007 0.050 0.030 0.095 0.030 0.148v0.9c0 1.158-0.898 2.1-2 2.1h-7.999c-1.103 0-2-0.942-2-2.1v-0.9c0-0.056 0.025-0.104 0.032-0.158 0.012-0.086 0.020-0.169 0.050-0.25zM10.61 13.046c-0.023-0.013-0.036-0.036-0.058-0.049-0.029-0.019-0.061-0.026-0.088-0.048-0.042-0.031-0.064-0.078-0.1-0.114-0.058-0.058-0.113-0.114-0.157-0.181-0.042-0.065-0.072-0.132-0.102-0.203-0.029-0.071-0.055-0.139-0.071-0.215s-0.018-0.149-0.018-0.226c-0.001-0.077 0-0.151 0.014-0.228 0.014-0.078 0.042-0.149 0.072-0.222 0.019-0.049 0.022-0.102 0.048-0.149 0.016-0.028 0.042-0.043 0.060-0.070 0.016-0.024 0.019-0.053 0.037-0.076 0.635-0.823 0.65-1.955 0.65-1.967 0-0.011 0.006-0.019 0.006-0.029l-0.002-2.509c-0.092-0.343-0.662-0.762-1.204-0.762-0.551 0-1.13 0.42-1.223 0.762l-0.001 2.514c0 0.011 0.005 0.019 0.005 0.030 0 0.037 0.018 1.15 0.644 1.961 0.030 0.038 0.037 0.085 0.062 0.126 0.013 0.023 0.036 0.036 0.048 0.060 0.017 0.031 0.016 0.066 0.029 0.097 0.037 0.089 0.065 0.175 0.079 0.268 0.013 0.073 0.016 0.143 0.014 0.217-0.002 0.071-0.007 0.139-0.023 0.209-0.018 0.091-0.047 0.175-0.085 0.26-0.023 0.048-0.046 0.092-0.074 0.138-0.060 0.096-0.133 0.176-0.22 0.253-0.019 0.017-0.028 0.040-0.047 0.054-0.018 0.013-0.038 0.018-0.056 0.030-0.041 0.030-0.070 0.071-0.116 0.096l-2.503 1.325h6.785l-2.407-1.354zM16.8 7.2h4.8c0.664 0 1.2 0.538 1.2 1.2s-0.536 1.2-1.2 1.2h-4.8c-0.664 0-1.2-0.538-1.2-1.2s0.536-1.2 1.2-1.2zM15.6 4.8c0-0.662 0.536-1.2 1.2-1.2h7.2c0.664 0 1.2 0.538 1.2 1.2s-0.536 1.2-1.2 1.2h-7.2c-0.664 0-1.2-0.538-1.2-1.2zM7.2 21.6h14.4c0.664 0 1.2 0.538 1.2 1.2s-0.536 1.2-1.2 1.2h-14.4c-0.664 0-1.2-0.538-1.2-1.2s0.536-1.2 1.2-1.2z"
        }));
      },
      "user-picture-1": function userPicture1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22.022 24h-20.045c-1.090 0-1.977-0.887-1.977-1.977v-20.045c0-1.091 0.887-1.978 1.977-1.978h20.045c1.091 0 1.978 0.887 1.978 1.978v20.045c0 1.090-0.887 1.977-1.978 1.977zM22 22v-3h-20.003l0.003 3.023 20-0.023zM12 14c-1.858 0-3.411 1.28-3.858 3h7.716c-0.447-1.72-2-3-3.858-3zM14 9c0-1.103-0.897-2-2-2s-2 0.897-2 2c0 1.103 0.897 2 2 2s2-0.897 2-2zM1.977 2l0.017 15h4.094c0.361-2.126 1.848-3.865 3.824-4.604-1.142-0.705-1.912-1.958-1.912-3.396 0-2.206 1.794-4 4-4s4 1.794 4 4c0 1.438-0.77 2.691-1.912 3.396 1.976 0.739 3.463 2.478 3.824 4.604h4.088v-15.022l-20.023 0.022z"
        }));
      },
      "user-picture-2": function userPicture2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M21.533 24h-19.066c-1.361 0-2.467-1.106-2.467-2.467v-19.066c0-1.36 1.106-2.467 2.467-2.467h19.066c1.361 0 2.467 1.107 2.467 2.467v19.066c0 1.361-1.106 2.467-2.467 2.467zM22 2.467c0-0.253-0.214-0.467-0.467-0.467h-19.066c-0.253 0-0.467 0.214-0.467 0.467v19.066c0 0.253 0.214 0.467 0.467 0.467h19.066c0.253 0 0.467-0.214 0.467-0.467v-19.066zM18.020 20c-0.007 0-0.014 0-0.020 0h-12c-0.552 0-1-0.448-1-1 0-2.687 1.871-4.834 4.602-5.64-1.542-0.852-2.602-2.477-2.602-4.36 0-2.757 2.243-5 5-5s5 2.243 5 5c0 1.882-1.058 3.505-2.598 4.358 2.655 0.784 4.496 2.838 4.594 5.423 0.016 0.070 0.024 0.144 0.024 0.219 0 0.552-0.448 1-1 1zM12 6c-1.654 0-3 1.346-3 3s1.346 3 3 3c1.654 0 3-1.346 3-3s-1.346-3-3-3zM12 15c-2.461 0-4.349 1.214-4.861 3h9.722c-0.512-1.786-2.4-3-4.861-3z"
        }));
      },
      "user-delete": function userDelete(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "28" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 28 24"
        }, i.a.createElement("path", {
          d: "M25.32 12l2.286 2.293c0.389 0.39 0.389 1.023 0 1.414-0.195 0.195-0.45 0.293-0.705 0.293s-0.51-0.098-0.705-0.293l-2.285-2.293-2.286 2.293c-0.195 0.195-0.45 0.293-0.705 0.293s-0.51-0.098-0.704-0.293c-0.39-0.391-0.39-1.024 0-1.414l2.285-2.293-2.285-2.293c-0.39-0.391-0.39-1.024 0-1.414 0.389-0.391 1.020-0.391 1.409 0l2.286 2.293 2.285-2.293c0.389-0.391 1.020-0.391 1.41 0 0.389 0.39 0.389 1.023 0 1.414l-2.286 2.293zM19.924 22.334v0.666c0 0.552-0.447 1-0.997 1h-17.942c-0.55 0-0.996-0.448-0.996-1v-0.666c0-4.151 3.074-7.768 7.161-8.936-2.452-1.086-4.171-3.541-4.171-6.398 0-3.86 3.13-7 6.977-7s6.977 3.14 6.977 7c0 2.857-1.719 5.312-4.171 6.398 4.087 1.168 7.162 4.785 7.162 8.936zM14.94 7c0-2.757-2.236-5-4.984-5s-4.984 2.243-4.984 5c0 2.757 2.236 5 4.984 5s4.984-2.243 4.984-5zM9.956 15c-4.201 0-7.768 3.173-7.965 7h15.93c-0.197-3.827-3.764-7-7.965-7z"
        }));
      },
      "user-circle": function userCircle(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M12 24c-6.617 0-12-5.383-12-12s5.383-12 12-12c6.617 0 12 5.383 12 12s-5.383 12-12 12zM17.3 20.464c-0.006-0.033-0.024-0.061-0.027-0.096-0.182-2.409-2.547-4.368-5.273-4.368-2.662 0-5.024 2.009-5.273 4.481 1.533 0.957 3.337 1.519 5.273 1.519 1.948 0 3.762-0.569 5.3-1.536zM15.022 10c0-1.654-1.345-3-2.999-3-1.655 0-3.001 1.346-3.001 3s1.346 3 3.001 3c1.654 0 2.999-1.345 2.999-3zM12 2c-5.514 0-10 4.486-10 10 0 2.779 1.141 5.295 2.978 7.109 0.658-2.189 2.479-3.96 4.721-4.709-1.583-0.84-2.677-2.486-2.677-4.4 0-2.757 2.244-5 5.001-5 2.756 0 4.999 2.243 4.999 5 0 1.905-1.083 3.545-2.655 4.389 2.3 0.733 4.094 2.482 4.692 4.687 1.816-1.812 2.941-4.315 2.941-7.076 0-5.514-4.486-10-10-10z"
        }));
      },
      "user-check": function userCheck(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "29" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 29 24"
        }, i.a.createElement("path", {
          d: "M28.675 8.579l-4.949 7c-0.169 0.239-0.434 0.392-0.725 0.417l-0.086 0.004c-0.261 0-0.514-0.103-0.701-0.289l-3.016-3.001c-0.391-0.388-0.394-1.021-0.007-1.414 0.386-0.392 1.017-0.396 1.408-0.006l2.183 2.17 4.27-6.039c0.319-0.45 0.94-0.555 1.388-0.237 0.448 0.32 0.554 0.945 0.235 1.395zM12.753 13.4c4.079 1.17 7.145 4.786 7.145 8.934v0.666c0 0.552-0.445 1-0.995 1h-17.922c-0.55 0-0.996-0.448-0.996-1v-0.666c0-4.148 3.067-7.764 7.146-8.934-2.446-1.088-4.159-3.545-4.159-6.4 0-3.86 3.127-7 6.97-7s6.97 3.14 6.97 7c0 2.855-1.713 5.312-4.159 6.4zM1.985 22h15.913c-0.196-3.827-3.76-7-7.956-7s-7.76 3.173-7.957 7zM9.942 2c-2.745 0-4.978 2.243-4.978 5s2.233 5 4.978 5c2.745 0 4.978-2.243 4.978-5s-2.233-5-4.978-5z"
        }));
      },
      "user-add": function userAdd(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "29" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 29 24"
        }, i.a.createElement("path", {
          d: "M28 13h-3v3c0 0.552-0.448 1-1 1s-1-0.448-1-1v-3h-3c-0.552 0-1-0.448-1-1s0.448-1 1-1h3v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3h3c0.552 0 1 0.448 1 1s-0.448 1-1 1zM12.823 13.4c4.097 1.17 7.177 4.786 7.177 8.934v0.666c0 0.552-0.448 1-1 1h-18c-0.552 0-1-0.448-1-1v-0.666c0-4.148 3.080-7.764 7.177-8.934-2.457-1.088-4.177-3.545-4.177-6.4 0-3.86 3.14-7 7-7s7 3.14 7 7c0 2.855-1.72 5.312-4.177 6.4zM2.009 22h15.982c-0.197-3.827-3.777-7-7.991-7s-7.793 3.173-7.991 7zM10 2c-2.757 0-5 2.243-5 5s2.243 5 5 5c2.757 0 5-2.243 5-5s-2.243-5-5-5z"
        }));
      },
      "team-2": function team2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M24 23c0 0.552-0.448 1-1 1h-8c-0.552 0-1-0.448-1-1 0-2.109 1.317-3.908 3.168-4.642-0.705-0.549-1.168-1.397-1.168-2.358 0-1.654 1.346-3 3-3s3 1.346 3 3c0 0.961-0.463 1.809-1.168 2.358 1.851 0.734 3.168 2.533 3.168 4.642zM19 15c-0.551 0-1 0.449-1 1s0.449 1 1 1c0.551 0 1-0.449 1-1s-0.449-1-1-1zM19 20c-1.304 0-2.416 0.836-2.829 2h5.658c-0.413-1.164-1.525-2-2.829-2zM16.020 11c-0.007 0-0.014 0-0.020 0h-8c-0.552 0-1-0.448-1-1 0-2.109 1.317-3.908 3.168-4.641-0.705-0.55-1.168-1.397-1.168-2.359 0-1.654 1.346-3 3-3s3 1.346 3 3c0 0.96-0.461 1.806-1.164 2.355 1.784 0.708 3.070 2.41 3.159 4.422 0.016 0.072 0.025 0.146 0.025 0.223 0 0.552-0.448 1-1 1zM12 2c-0.551 0-1 0.449-1 1s0.449 1 1 1c0.551 0 1-0.449 1-1s-0.449-1-1-1zM12 7c-1.304 0-2.416 0.836-2.829 2h5.658c-0.413-1.164-1.525-2-2.829-2zM8 16c0 0.961-0.463 1.809-1.168 2.358 1.851 0.734 3.168 2.533 3.168 4.642 0 0.552-0.448 1-1 1h-8c-0.552 0-1-0.448-1-1 0-2.109 1.317-3.908 3.168-4.642-0.705-0.549-1.168-1.397-1.168-2.358 0-1.654 1.346-3 3-3s3 1.346 3 3zM2.171 22h5.658c-0.413-1.164-1.525-2-2.829-2s-2.416 0.836-2.829 2zM5 15c-0.551 0-1 0.449-1 1s0.449 1 1 1c0.551 0 1-0.449 1-1s-0.449-1-1-1zM9.106 16.448c-0.248-0.495-0.047-1.095 0.447-1.342l1.447-0.724v-1.382c0-0.552 0.448-1 1-1s1 0.448 1 1v1.382l1.447 0.724c0.494 0.247 0.695 0.847 0.448 1.342-0.176 0.35-0.529 0.552-0.896 0.552-0.15 0-0.303-0.034-0.446-0.106l-1.553-0.776-1.553 0.776c-0.143 0.072-0.296 0.106-0.446 0.106-0.367 0-0.72-0.202-0.895-0.552z"
        }));
      },
      activity: function activity(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "40" : n,
            a = e.height,
            o = void 0 === a ? "28" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 20"
        }, i.a.createElement("g", {
          id: "Integration-Types",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "Multi-Level-1",
          transform: "translate(-385.000000, -469.000000)",
          fill: "#394F5A"
        }, i.a.createElement("path", {
          d: "M400.654273,488.988333 C400.635455,488.99 400.619091,489 400.599455,489 L387.400545,489 C387.380909,489 387.364545,488.99 387.345727,488.988333 C386.043182,488.929167 385,487.84 385,486.5 L385,474.833333 C385,474.3725 385.366545,474 385.818182,474 L388.218727,474 C388.237545,474 388.253909,474.01 388.272727,474.010833 L388.272727,469.833333 C388.272727,469.3725 388.639273,469 389.090909,469 L402.181818,469 C402.633455,469 403,469.3725 403,469.833333 L403,486.5 C403,487.84 401.956818,488.929167 400.654273,488.988333 Z M388.272727,475.655833 C388.253909,475.656667 388.237545,475.666667 388.218727,475.666667 L386.636364,475.666667 L386.636364,486.5 C386.636364,486.96 387.003727,487.333333 387.454545,487.333333 C387.905364,487.333333 388.272727,486.96 388.272727,486.5 L388.272727,475.655833 Z M401.363636,470.666667 L389.909091,470.666667 L389.909091,486.5 C389.909091,486.794167 389.850182,487.071667 389.758545,487.333333 L400.545455,487.333333 C400.996273,487.333333 401.363636,486.96 401.363636,486.5 L401.363636,470.666667 Z M399.727273,483.166667 L391.545455,483.166667 C391.093818,483.166667 390.727273,482.794167 390.727273,482.333333 C390.727273,481.873333 391.093818,481.5 391.545455,481.5 L399.727273,481.5 C400.178909,481.5 400.545455,481.873333 400.545455,482.333333 C400.545455,482.794167 400.178909,483.166667 399.727273,483.166667 Z M399.727273,479.833333 L391.545455,479.833333 C391.093818,479.833333 390.727273,479.460833 390.727273,479 C390.727273,478.539167 391.093818,478.166667 391.545455,478.166667 L399.727273,478.166667 C400.178909,478.166667 400.545455,478.539167 400.545455,479 C400.545455,479.460833 400.178909,479.833333 399.727273,479.833333 Z M396.454545,475.666667 L391.545455,475.666667 C391.093818,475.666667 390.727273,475.294167 390.727273,474.833333 C390.727273,474.3725 391.093818,474 391.545455,474 L396.454545,474 C396.906182,474 397.272727,474.3725 397.272727,474.833333 C397.272727,475.294167 396.906182,475.666667 396.454545,475.666667 Z",
          id: "activity"
        }))));
      },
      rolodex: function rolodex(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "45" : n,
            a = e.height,
            o = void 0 === a ? "31" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 45 31"
        }, i.a.createElement("path", {
          d: "M43.594 31H1.406C.63 31 0 30.37 0 29.59V1.41C0 .63.63 0 1.406 0h42.188C44.37 0 45 .63 45 1.41v28.18c0 .78-.63 1.41-1.406 1.41zM42.187 2.818H2.813v25.364H8.44v-1.41c0-.777.63-1.408 1.407-1.408.776 0 1.406.63 1.406 1.41v1.408H33.75v-1.41c0-.777.63-1.408 1.406-1.408.778 0 1.407.63 1.407 1.41v1.408h5.624V2.818zm-5.624 14.09h-11.25c-.775 0-1.405-.63-1.405-1.408 0-.778.63-1.41 1.406-1.41h11.248c.778 0 1.407.632 1.407 1.41 0 .778-.63 1.41-1.407 1.41zm0-5.635h-11.25c-.775 0-1.405-.632-1.405-1.41 0-.777.63-1.408 1.406-1.408h11.248c.778 0 1.407.63 1.407 1.41 0 .776-.63 1.408-1.407 1.408zm-17.81 11.272H9.376c-1.292 0-2.343-1.107-2.343-2.467V19.02c0-.044.02-.08.024-.123.008-.097.028-.188.058-.28.025-.087.054-.168.095-.247.042-.077.093-.146.147-.217.06-.076.124-.142.2-.204.033-.03.052-.07.09-.093l2.67-1.836c-.448-1.03-.48-1.904-.468-2.26 0-.006-.003-.01-.003-.017V10.57c0-.037.02-.068.022-.103.002-.044-.012-.085-.005-.13.34-2.032 2.444-3.29 4.2-3.29h.007c1.748 0 3.848 1.257 4.19 3.29.008.042-.006.083-.003.127.002.037.02.068.02.106l.003 3.173-.003.015c.012.353-.02 1.225-.467 2.255l2.673 1.846c.037.024.055.062.087.09.075.06.14.13.2.206.055.07.104.138.145.216.042.08.07.16.097.248.028.09.046.18.056.277.004.043.025.08.025.123v1.058c0 1.36-1.05 2.467-2.343 2.467zm-3.58-4.934c-.03-.017-.063-.026-.09-.047-.126-.097-.216-.22-.3-.345-.01-.013-.023-.023-.03-.037-.072-.113-.11-.24-.146-.368-.014-.05-.04-.097-.05-.15-.014-.085 0-.173.003-.262.002-.098-.004-.194.02-.29.01-.046.038-.086.053-.13.04-.12.075-.24.15-.35.01-.016.03-.024.042-.04v-.003c.68-.885.648-1.693.647-1.702-.003-.03.01-.058.008-.09 0-.015-.01-.03-.01-.048l-.003-2.986c-.11-.403-.773-.896-1.403-.896s-1.297.493-1.404.896l-.002 2.987c0 .014-.007.025-.007.04 0 .026.01.05.01.077-.005.066-.025.855.642 1.722.01.01.01.025.018.038.008.01.02.015.03.027.046.07.06.147.092.22.04.087.09.168.11.258.02.092.014.184.017.277.002.087.014.173 0 .26-.014.09-.055.174-.085.26-.03.083-.05.167-.098.245-.047.08-.12.142-.184.213-.055.06-.09.13-.156.178-.01.01-.027.014-.04.023-.01.008-.013.02-.024.026l-3.086 2.117h8.34L15.17 17.61zm10.14 2.117h5.626c.775 0 1.405.632 1.405 1.41 0 .777-.63 1.408-1.406 1.408h-5.626c-.776 0-1.406-.63-1.406-1.41 0-.776.63-1.408 1.406-1.408z",
          fill: "#0176FF",
          fillRule: "evenodd"
        }));
      },
      "location-2": function location2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 24"
        }, i.a.createElement("path", {
          d: "M9.651 23.759c-0.187 0.16-0.419 0.241-0.651 0.241s-0.464-0.081-0.651-0.241c-0.341-0.293-8.349-7.255-8.349-14.716 0-4.986 4.037-9.043 9-9.043s9 4.057 9 9.043c0 7.461-8.008 14.423-8.349 14.716zM9 2c-3.859 0-7 3.16-7 7.043 0 5.402 5.148 10.823 6.999 12.597 1.851-1.776 7.001-7.205 7.001-12.597 0-3.883-3.141-7.043-7-7.043zM9 13.074c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zM9 7.074c-1.102 0-2 0.897-2 2s0.898 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2z"
        }));
      },
      infinite: function infinite(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "47" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 47 24"
        }, i.a.createElement("path", {
          d: "M43.161 20.489c-2.365 2.355-5.543 3.534-8.709 3.534-3.135 0-6.257-1.151-8.577-3.464-0.772-0.768-0.792-2.030-0.043-2.822s1.98-0.811 2.75-0.043c3.145 3.133 8.69 3.096 11.87-0.070 1.505-1.501 2.334-3.491 2.334-5.605-0.002-2.11-0.83-4.096-2.334-5.59-3.137-3.131-8.237-3.133-11.387-0.021-1.599 1.729-2.641 3.878-3.742 6.154-1.28 2.645-2.6 5.38-4.928 7.877-0.010 0.010-0.023 0.012-0.033 0.021-0.008 0.010-0.010 0.021-0.019 0.029-2.318 2.311-5.364 3.466-8.414 3.466-3.046 0-6.091-1.155-8.412-3.466-2.266-2.26-3.516-5.269-3.514-8.472 0.002-3.197 1.251-6.2 3.514-8.454 4.703-4.687 12.618-4.722 17.286-0.074 0.772 0.768 0.792 2.030 0.043 2.822-0.751 0.794-1.982 0.809-2.75 0.043-3.145-3.131-8.69-3.098-11.868 0.074-1.507 1.496-2.334 3.481-2.336 5.592 0 2.114 0.827 4.104 2.334 5.607 3.139 3.122 8.237 3.125 11.382 0.019 1.904-2.048 3.036-4.384 4.232-6.858 1.188-2.458 2.418-4.998 4.442-7.173 0.008-0.010 0.021-0.012 0.031-0.021 0.008-0.010 0.012-0.021 0.019-0.029 4.639-4.627 12.191-4.627 16.829 0 2.266 2.252 3.512 5.255 3.514 8.453 0.002 3.203-1.247 6.212-3.514 8.472z"
        }));
      },
      "calendar-check": function calendarCheck(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22 24h-20c-1.103 0-2-0.897-2-2v-18c0-1.103 0.897-2 2-2h4v-1c0-0.552 0.447-1 1-1s1 0.448 1 1v1h8v-1c0-0.552 0.447-1 1-1s1 0.448 1 1v1h4c1.102 0 2 0.897 2 2v18c0 1.103-0.898 2-2 2zM18 4v1c0 0.552-0.447 1-1 1s-1-0.448-1-1v-1h-8v1c0 0.552-0.447 1-1 1s-1-0.448-1-1v-1h-4v18h19.997l0.003-18h-4zM11.603 17.652c-0.184 0.215-0.452 0.341-0.735 0.347-0.008 0.001-0.015 0.001-0.023 0.001-0.276 0-0.538-0.113-0.728-0.314l-2.844-3.016c-0.379-0.401-0.361-1.034 0.040-1.413 0.403-0.379 1.035-0.361 1.415 0.041l2.082 2.208 4.431-5.158c0.362-0.419 0.993-0.465 1.41-0.106 0.419 0.359 0.467 0.991 0.108 1.41l-5.156 6z"
        }));
      },
      "video-camera": function videoCamera(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "34" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 34 24"
        }, i.a.createElement("path", {
          d: "M33.196 23.813c-0.209 0.113-0.438 0.167-0.668 0.167-0.274 0-0.547-0.079-0.785-0.236l-6.286-4.179v1.595c0 1.556-1.269 2.82-2.829 2.82h-19.8c-1.56 0-2.829-1.264-2.829-2.82v-18.332c0-1.554 1.269-2.82 2.829-2.82h19.8c1.56 0 2.829 1.266 2.829 2.82v1.597l6.286-4.179c0.433-0.289 0.993-0.317 1.452-0.071s0.747 0.724 0.747 1.243v21.152c0 0.52-0.287 0.997-0.747 1.243zM31.114 4.055l-6.286 4.178c-0.037 0.024-0.079 0.027-0.117 0.048-0.085 0.047-0.173 0.081-0.269 0.109-0.091 0.027-0.177 0.045-0.269 0.054-0.045 0.004-0.085 0.027-0.13 0.027-0.048 0-0.089-0.023-0.137-0.028-0.095-0.008-0.182-0.027-0.273-0.055-0.089-0.027-0.171-0.059-0.25-0.102-0.078-0.041-0.147-0.089-0.216-0.144-0.076-0.062-0.143-0.129-0.205-0.205-0.028-0.035-0.069-0.055-0.095-0.093-0.024-0.037-0.028-0.081-0.048-0.119-0.047-0.083-0.079-0.168-0.107-0.262s-0.048-0.182-0.057-0.276c-0.004-0.044-0.025-0.082-0.025-0.126v-4.231h-19.8v18.385h19.8v-4.284c0-0.044 0.021-0.082 0.025-0.126 0.008-0.095 0.028-0.184 0.057-0.276 0.028-0.093 0.061-0.178 0.107-0.263 0.020-0.038 0.024-0.081 0.048-0.117 0.025-0.038 0.066-0.059 0.096-0.095 0.061-0.075 0.126-0.14 0.202-0.202 0.071-0.057 0.141-0.106 0.222-0.149 0.076-0.041 0.154-0.072 0.239-0.099 0.095-0.030 0.188-0.048 0.287-0.057 0.045-0.006 0.083-0.027 0.13-0.027 0.044 0 0.081 0.021 0.123 0.025 0.096 0.008 0.187 0.027 0.28 0.055s0.18 0.062 0.263 0.109c0.038 0.020 0.082 0.023 0.119 0.048l6.286 4.178v-15.881z"
        }));
      },
      photo: function photo(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "29" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 29 24"
        }, i.a.createElement("path", {
          d: "M26.177 24h-23.78c-1.312 0-2.378-1.076-2.378-2.4v-19.2c0-1.324 1.067-2.4 2.378-2.4h23.78c1.31 0 2.586 1.076 2.586 2.4v19.2c0 1.324-1.276 2.4-2.586 2.4zM26.363 2.4h-23.966v10.59l6.36-5.501c0.47-0.408 1.175-0.382 1.614 0.062l6.406 6.464 3.931-2.976c0.506-0.383 1.222-0.299 1.626 0.192l4.030 4.879v-13.711zM26.363 19.86l-5.134-6.216-3.852 2.916c-0.473 0.359-1.135 0.311-1.554-0.112l-6.355-6.414-7.072 6.118v5.448h23.966v-1.74zM19.043 7.2c0-1.324 1.067-2.4 2.38-2.4 1.31 0 2.376 1.076 2.376 2.4s-1.066 2.4-2.376 2.4c-1.313 0-2.38-1.076-2.38-2.4zM21.419 7.201l0.004 1.199 0.001-1.2c-0.001 0-0.004 0-0.005 0.001z"
        }));
      },
      camera: function camera(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "29" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 29 24"
        }, i.a.createElement("path", {
          d: "M25.2 24h-21.6c-1.985 0-3.6-1.615-3.6-3.6v-13.2c0-1.985 1.615-3.6 3.6-3.6h2.879l1.577-2.963c0.208-0.392 0.616-0.637 1.060-0.637h10.57c0.444 0 0.852 0.245 1.060 0.637l1.577 2.963h2.879c1.985 0 3.6 1.615 3.6 3.6v13.2c0 1.985-1.615 3.6-3.6 3.6zM26.4 7.2c0-0.661-0.539-1.2-1.2-1.2h-3.6c-0.202 0-0.383-0.062-0.55-0.15-0.046-0.024-0.082-0.054-0.125-0.084-0.13-0.091-0.236-0.202-0.322-0.336-0.017-0.026-0.048-0.037-0.064-0.066l-1.576-2.964h-9.13l-1.576 2.964c-0.028 0.052-0.073 0.083-0.106 0.128-0.049 0.068-0.095 0.134-0.157 0.191-0.059 0.053-0.124 0.089-0.191 0.128-0.065 0.040-0.126 0.080-0.199 0.107-0.079 0.029-0.161 0.037-0.245 0.049-0.055 0.007-0.104 0.032-0.162 0.032h-3.6c-0.661 0-1.2 0.539-1.2 1.2v13.2c0 0.661 0.539 1.2 1.2 1.2h21.6c0.661 0 1.2-0.539 1.2-1.2v-13.2zM14.4 19.2c-3.64 0-6.6-2.96-6.6-6.599 0-3.64 2.96-6.6 6.6-6.6s6.6 2.96 6.6 6.6c0 3.638-2.96 6.599-6.6 6.599zM14.4 8.401c-2.316 0-4.2 1.884-4.2 4.2 0 2.315 1.884 4.199 4.2 4.199s4.2-1.884 4.2-4.199c0-2.316-1.884-4.2-4.2-4.2z"
        }));
      },
      "target-4": function target4(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23 13h-2.061c-0.463 4.164-3.775 7.478-7.939 7.941v2.059c0 0.552-0.447 1-1 1s-1-0.448-1-1v-2.059c-4.164-0.463-7.476-3.777-7.939-7.941h-2.061c-0.553 0-1-0.448-1-1s0.447-1 1-1h2.061c0.463-4.164 3.774-7.479 7.939-7.942v-2.058c0-0.552 0.447-1 1-1s1 0.448 1 1v2.058c4.165 0.463 7.476 3.778 7.939 7.942h2.061c0.553 0 1 0.448 1 1s-0.447 1-1 1zM13 18.899c3.054-0.443 5.464-2.848 5.907-5.899h-2.017c-0.4 1.954-1.935 3.5-3.89 3.898v2.001zM13 11h1.816c-0.304-0.843-0.97-1.514-1.816-1.816v1.816zM14.815 13h-1.815v1.815c0.846-0.302 1.511-0.973 1.815-1.815zM11 13h-1.815c0.304 0.842 0.969 1.513 1.815 1.815v-1.815zM11 18.899v-2.001c-1.955-0.398-3.49-1.944-3.89-3.898h-2.017c0.443 3.051 2.853 5.456 5.907 5.899zM11 5.1c-3.055 0.443-5.464 2.849-5.907 5.9h2.017c0.399-1.954 1.935-3.5 3.89-3.899v-2.001zM9.184 11h1.816v-1.816c-0.846 0.302-1.512 0.973-1.816 1.816zM13 5.1v2.001c1.955 0.399 3.491 1.945 3.89 3.899h2.017c-0.443-3.051-2.852-5.457-5.907-5.9z"
        }));
      },
      "target-2": function target2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22.893 17.042c-0.234 0.5-0.828 0.719-1.328 0.486-0.501-0.233-0.719-0.828-0.487-1.328 0.612-1.318 0.922-2.731 0.922-4.2 0-5.514-4.486-10-10-10s-10 4.486-10 10c0 5.514 4.486 10 10 10 1.483 0 2.912-0.317 4.244-0.942 0.504-0.237 1.096-0.020 1.33 0.48 0.235 0.5 0.020 1.095-0.48 1.33-1.601 0.751-3.315 1.132-5.094 1.132-6.617 0-12-5.383-12-12s5.383-12 12-12c6.617 0 12 5.383 12 12 0 1.762-0.373 3.458-1.107 5.042zM12 17.976c0.58 0 1.153-0.083 1.705-0.247 0.532-0.16 1.086 0.144 1.243 0.672 0.158 0.53-0.143 1.086-0.673 1.244-0.736 0.22-1.501 0.331-2.275 0.331-4.379 0-7.941-3.562-7.941-7.941 0-4.417 3.576-8.011 7.972-8.011 4.362 0 7.911 3.594 7.911 8.011 0 0.685-0.088 1.365-0.261 2.023-0.14 0.534-0.689 0.852-1.221 0.713-0.534-0.141-0.853-0.688-0.713-1.222 0.129-0.492 0.195-1.001 0.195-1.514 0-3.314-2.652-6.011-5.911-6.011-3.293 0-5.972 2.697-5.972 6.011 0 3.276 2.665 5.941 5.941 5.941zM12 15.998c-2.204 0-3.997-1.794-3.997-3.998s1.793-3.997 3.997-3.997c2.204 0 3.997 1.793 3.997 3.997 0 0.739-0.215 1.423-0.566 2.017l4.961 4.96h2.577c0.553 0 1 0.448 1 1s-0.447 1-1 1h-1.991v1.992c0 0.552-0.448 0.999-1 0.999-0.553 0-1-0.447-1-0.999v-2.578l-4.961-4.96c-0.594 0.351-1.278 0.567-2.017 0.567zM13.997 12c0-1.101-0.895-1.997-1.997-1.997s-1.997 0.896-1.997 1.997c0 1.101 0.895 1.997 1.997 1.997 0.177 0 0.346-0.030 0.509-0.074l-0.219-0.219c-0.391-0.39-0.391-1.024 0-1.414 0.391-0.391 1.024-0.391 1.414 0l0.219 0.219c0.044-0.163 0.074-0.332 0.074-0.509z"
        }));
      },
      "speech-buble-money": function speechBubleMoney(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M13.091 20.727h-1.783c-2.112 3.101-6.708 3.267-6.914 3.273-0.010 0-0.021 0-0.031 0-0.435 0-0.832-0.261-1.004-0.663-0.176-0.411-0.082-0.888 0.237-1.203 0.045-0.046 1.651-1.679 1.955-3.616-3.587-2.073-5.552-4.963-5.552-8.196 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 3.466 3.143 5.631 5.016 6.613 0.36 0.188 0.585 0.561 0.585 0.967 0 1.284-0.428 2.47-0.94 3.429 1.103-0.375 2.28-1.034 2.879-2.194 0.188-0.362 0.562-0.59 0.97-0.59h2.4c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM13.091 8.727c1.836 0 3.273 1.198 3.273 2.727 0 1.216-0.916 2.212-2.212 2.573 0.008 0.052 0.031 0.099 0.031 0.154v1.091c0 0.602-0.488 1.091-1.091 1.091s-1.091-0.489-1.091-1.091v-1.091h-1.091c-0.603 0-1.091-0.489-1.091-1.091s0.488-1.091 1.091-1.091h2.182c0.676 0 1.091-0.352 1.091-0.545 0-0.192-0.415-0.545-1.091-0.545-1.836 0-3.273-1.198-3.273-2.727 0-1.216 0.916-2.212 2.212-2.573-0.008-0.052-0.031-0.099-0.031-0.154v-1.091c0-0.602 0.488-1.091 1.091-1.091s1.091 0.489 1.091 1.091v1.091h1.091c0.603 0 1.091 0.489 1.091 1.091s-0.488 1.091-1.091 1.091h-2.182c-0.676 0-1.091 0.353-1.091 0.545s0.415 0.545 1.091 0.545z"
        }));
      },
      "money-bag": function moneyBag(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "21" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 21 24"
        }, i.a.createElement("path", {
          d: "M20.944 16.246c0 4.94-1.985 7.751-6.979 7.751h-5.985c-4.994 0-7.988-2.811-7.988-7.751 0-3.977 4.215-8.106 5.77-9.494-0.74-1.178-2.040-3.535-1.715-5.156 0.118-0.586 0.431-1.057 0.906-1.365 1.087-0.701 2.019 0.415 2.578 1.080 0.080 0.096 0.185 0.22 0.287 0.336 0.004-0.008 0.008-0.015 0.012-0.021 0.346-0.606 0.925-1.621 2.141-1.621 1.078 0 1.628 0.521 1.957 0.83 0.039 0.038 0.075 0.076 0.114 0.109 0.364-0.013 0.517-0.115 0.802-0.305 0.408-0.272 0.965-0.644 2-0.644 0.805 0 1.485 0.495 1.82 1.324 0.543 1.34 0.185 3.614-1.421 5.524 1.648 1.48 5.702 5.518 5.702 9.403zM14.77 1.958c-0.369 0.011-0.521 0.113-0.808 0.304-0.407 0.272-0.965 0.645-2 0.645-0.719 0-1.153-0.41-1.413-0.655-0.231-0.218-0.301-0.284-0.579-0.284-0.082 0.054-0.291 0.422-0.404 0.619-0.296 0.518-0.743 1.301-1.65 1.301-0.788 0-1.348-0.643-1.884-1.282 0.203 0.98 0.98 2.438 1.633 3.43h5.63c1.183-1.147 1.616-2.476 1.618-3.352 0.002-0.413-0.090-0.64-0.143-0.727zM13.568 7.999h-6.238c-1.712 1.471-5.346 5.224-5.346 8.247 0 3.843 2.117 5.756 5.996 5.756h5.985c3.879 0 4.987-1.912 4.987-5.756 0-3.023-3.661-6.778-5.384-8.247zM10.448 14.070c1.374 0 2.49 1.1 2.49 2.452 0 1.003-0.616 1.865-1.494 2.244v0.207c0 0.542-0.445 0.982-0.996 0.982s-0.996-0.44-0.996-0.982h-0.498c-0.551 0-0.997-0.439-0.997-0.981s0.446-0.981 0.997-0.981h1.493c0.274 0 0.498-0.22 0.498-0.491s-0.223-0.49-0.498-0.49c-1.373 0-2.49-1.1-2.49-2.452 0-1.004 0.616-1.865 1.494-2.244v-0.208c0-0.542 0.445-0.981 0.996-0.981s0.996 0.439 0.996 0.981h0.499c0.55 0 0.996 0.44 0.996 0.982s-0.446 0.981-0.996 0.981h-1.494c-0.274 0-0.498 0.22-0.498 0.491s0.223 0.49 0.498 0.49z"
        }));
      },
      "donut-chart-2": function donutChart2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23 11h-6c-0.395 0-1.065-0.159-1.225-0.521-0.653-1.476-2.108-2.43-3.707-2.43-2.225 0-4.035 1.814-4.035 4.042 0 1.602 0.951 3.059 2.426 3.713 0.361 0.16 0.541 0.8 0.541 1.196v6c0 0.297-0.079 0.579-0.307 0.769-0.181 0.151-0.407 0.231-0.639 0.231-0.060 0-0.121-0.005-0.18-0.017-5.725-1.053-9.88-6.055-9.88-11.892 0-6.667 5.416-12.091 12.074-12.091 5.829 0 10.824 4.16 11.876 9.894 0.053 0.292-0.026 0.593-0.215 0.821-0.19 0.227-0.432 0.285-0.729 0.285zM12.068 2c-5.557 0-10.077 4.527-10.077 10.091 0 4.461 2.907 8.337 7.064 9.634v-4.396c-1.853-1.078-3.020-3.069-3.020-5.238 0-3.331 2.706-6.042 6.033-6.042 2.166 0 4.153 1.168 5.231 3.025h4.39c-1.295-4.163-5.166-7.074-9.621-7.074zM13.677 15.804c0.938-0.417 1.683-1.163 2.098-2.102 0.16-0.361 0.83-0.702 1.225-0.702h6c0.297 0 0.539 0.239 0.729 0.467 0.189 0.228 0.268 0.529 0.215 0.821-0.899 4.899-4.789 8.796-9.682 9.695-0.061 0.012-0.12 0.017-0.18 0.017-0.232 0-0.459-0.080-0.639-0.232-0.228-0.19-0.36-0.471-0.36-0.768v-6.282c0-0.395 0.233-0.754 0.594-0.914zM15.080 21.724c3.134-0.985 5.937-3.585 6.92-6.724h-5c-0.534 0.923-0.998 1.794-1.92 2.329v4.395z"
        }));
      },
      "bar-chart": function barChart(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "23" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 23 24"
        }, i.a.createElement("path", {
          d: "M22 24h-5c-0.553 0-1-0.448-1-1v-22c0-0.552 0.447-1 1-1h5c0.553 0 1 0.448 1 1v22c0 0.552-0.447 1-1 1zM21 2h-3v20h3v-20zM14 24h-5c-0.553 0-1-0.448-1-1v-10c0-0.552 0.447-1 1-1h5c0.553 0 1 0.448 1 1v10c0 0.552-0.447 1-1 1zM13 14h-3v8h3v-8zM6 24h-5c-0.553 0-1-0.448-1-1v-15c0-0.552 0.447-1 1-1h5c0.553 0 1 0.448 1 1v15c0 0.552-0.447 1-1 1zM5 9h-3v13h3v-13z"
        }));
      },
      "download-2": function download2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22 24h-20c-1.103 0-2-0.897-2-1.999v-5.998c0-0.552 0.447-0.999 1-0.999s1 0.447 1 0.999v5.998h20v-5.998c0-0.552 0.447-0.999 1-0.999s1 0.447 1 0.999v5.998c0 1.102-0.898 1.999-2 1.999zM12.708 17.699c-0.092 0.093-0.203 0.166-0.326 0.217-0.122 0.051-0.252 0.077-0.382 0.077s-0.26-0.026-0.382-0.077c-0.121-0.050-0.23-0.122-0.322-0.213 0-0.001-0.001-0.001-0.002-0.002v0c-0.001-0.001-0.001-0.001-0.002-0.002l-4.998-4.987c-0.392-0.39-0.392-1.022-0.002-1.413 0.391-0.392 1.023-0.39 1.414-0.002l3.294 3.286v-13.584c0-0.552 0.447-0.999 1-0.999s1 0.447 1 0.999v13.584l3.294-3.286c0.391-0.388 1.023-0.39 1.414 0.002 0.39 0.391 0.39 1.023-0.002 1.413l-4.998 4.987z"
        }));
      },
      "upload-2": function upload2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22.087 23.993h-20.079c-1.106 0-2.008-0.898-2.008-2v-6c0-0.552 0.449-1 1.004-1s1.004 0.448 1.004 1v6h20.079v-6c0-0.552 0.449-1 1.004-1s1.004 0.448 1.004 1v6c0 1.102-0.901 2-2.008 2zM17.067 6.976c-0.257 0-0.513-0.098-0.709-0.292l-3.307-3.287v13.587c0 0.552-0.449 0.999-1.004 0.999s-1.004-0.447-1.004-0.999v-13.587l-3.307 3.287c-0.393 0.389-1.027 0.391-1.42-0.002-0.392-0.391-0.392-1.024 0.002-1.414l5.018-4.989c0.092-0.092 0.205-0.166 0.328-0.217 0.094-0.039 0.195-0.051 0.296-0.059 0.030-0.003 0.055-0.018 0.086-0.018s0.056 0.015 0.086 0.018c0.1 0.008 0.202 0.020 0.296 0.059 0.122 0.050 0.232 0.122 0.324 0.214 0 0 0.001 0.001 0.002 0.001v0c0.001 0.001 0.001 0.001 0.002 0.002l5.018 4.989c0.394 0.39 0.394 1.023 0.002 1.414-0.196 0.196-0.454 0.294-0.711 0.294z"
        }));
      },
      "warning-circle": function warningCircle(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M12 24c-6.617 0-12-5.383-12-12s5.383-12 12-12c6.617 0 12 5.383 12 12s-5.383 12-12 12zM12 2c-5.514 0-10 4.486-10 10s4.486 10 10 10c5.514 0 10-4.486 10-10s-4.486-10-10-10zM12 19c-0.26 0-0.52-0.11-0.71-0.29-0.181-0.19-0.29-0.45-0.29-0.71 0-0.27 0.109-0.52 0.29-0.71 0.37-0.37 1.040-0.37 1.42 0 0.18 0.19 0.29 0.44 0.29 0.71 0 0.26-0.11 0.52-0.29 0.71-0.19 0.18-0.45 0.29-0.71 0.29zM12 15c-0.553 0-1-0.448-1-1v-8c0-0.552 0.447-1 1-1s1 0.448 1 1v8c0 0.552-0.447 1-1 1z"
        }));
      },
      "warning-triangle": function warningTriangle(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "15" : n,
            a = e.height,
            o = void 0 === a ? "15" : a;
        return i.a.createElement("svg", {
          className: t,
          height: o,
          width: r,
          viewBox: "0 0 24 22",
          fill: "none"
        }, i.a.createElement("path", {
          d: "M23.8121 20.4957L12.9159 0.564103C12.728 0.188034 12.3523 0 11.9765 0C11.6008 0 11.225 0.188034 11.0372 0.564103L0.1409 20.4957C-0.0469667 20.8718 -0.0469667 21.2479 0.1409 21.4359C0.328767 21.812 0.704501 22 1.08023 22H23.0607C23.4364 22 23.8121 21.812 24 21.4359C24 21.2479 24 20.8718 23.8121 20.4957ZM11.0372 9.02564C11.0372 8.46154 11.4129 8.08547 11.9765 8.08547C12.5401 8.08547 12.9159 8.46154 12.9159 9.02564V14.1026C12.9159 14.6667 12.5401 15.0427 11.9765 15.0427C11.4129 15.0427 11.0372 14.6667 11.0372 14.1026V9.02564ZM12.728 17.8632C12.3523 18.2393 11.6008 18.2393 11.225 17.8632C10.8493 17.2991 10.8493 16.735 11.225 16.359C11.6008 15.9829 12.3523 15.9829 12.728 16.359C13.1037 16.735 13.1037 17.2991 12.728 17.8632Z",
          fill: "#C8520E"
        }));
      },
      trash: function trash(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 20 24"
        }, i.a.createElement("path", {
          d: "M19 6h-1.090l-1.805 16.117c-0.118 1.056-1.043 1.883-2.105 1.883h-8c-1.064 0-1.987-0.828-2.104-1.885l-1.776-16.115h-1.12c-0.552 0-1-0.448-1-1s0.448-1 1-1h5v-1c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1h5c0.552 0 1 0.448 1 1s-0.448 1-1 1zM12 3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v1h4v-1zM4.132 6l1.753 15.897c0.004 0.039 0.075 0.103 0.115 0.103h8c0.040 0 0.113-0.065 0.118-0.105l1.78-15.895h-11.766z"
        }));
      },
      plus: function plus(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "35" : n,
            a = e.height,
            o = void 0 === a ? "30" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 11 11"
        }, i.a.createElement("g", {
          id: "Integration-Types",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "Multi-Level--3",
          transform: "translate(-422.000000, -1011.000000)",
          fill: "#394F5A",
          stroke: "#394F5A"
        }, i.a.createElement("path", {
          d: "M427.91243,1016.49996 L430.914487,1019.5023 C431.028504,1019.61618 431.028504,1019.80092 430.914487,1019.9148 C430.857773,1019.9716 430.783133,1020 430.708493,1020 C430.633852,1020 430.559212,1019.9716 430.502204,1019.9148 L427.499853,1016.91247 L424.497796,1019.9148 C424.441081,1019.9716 424.366441,1020 424.291801,1020 C424.217161,1020 424.142521,1019.9716 424.085513,1019.9148 C423.971496,1019.80092 423.971496,1019.61618 424.085513,1019.5023 L427.08757,1016.49996 L424.085513,1013.49792 C423.971496,1013.38404 423.971496,1013.1993 424.085513,1013.08541 C424.19953,1012.97153 424.384073,1012.97153 424.497796,1013.08541 L427.499853,1016.08745 L430.50191,1013.08541 C430.615927,1012.97153 430.80047,1012.97153 430.914487,1013.08541 C431.02821,1013.1993 431.02821,1013.38404 430.914487,1013.49792 L427.91243,1016.49996 Z",
          id: "plus",
          transform: "translate(427.500000, 1016.500000) rotate(45.000000) translate(-427.500000, -1016.500000) "
        }))));
      },
      minus: function minus(e) {
        var t = e.className,
            n = e.height,
            r = void 0 === n ? "12" : n,
            a = e.width,
            o = void 0 === a ? "12" : a;
        return i.a.createElement("svg", {
          className: t,
          width: o,
          height: r,
          viewBox: "0 0 53.06 53.06"
        }, i.a.createElement("g", {
          id: "Symbols"
        }, i.a.createElement("g", {
          id: "controls",
          transform: "translate(-113.000000, -15.000000)"
        }, i.a.createElement("g", {
          id: "Group-8-Copy",
          transform: "translate(71.000000, 0.000000)"
        }, i.a.createElement("g", {
          id: "Group-8",
          transform: "translate(31.000000, 0.000000)"
        }, i.a.createElement("path", {
          fill: "#465259",
          d: "M59.058,46.53H16.001c-2.762,0-5-2.236-5-5s2.238-5,5-5h43.057c2.762,0,5,2.236,5,5S61.82,46.53,59.058,46.53z"
        }))))));
      },
      "share-1": function share1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M25.863 6.214l-4.366 4.364c-0.213 0.214-0.492 0.32-0.771 0.32s-0.559-0.106-0.772-0.32c-0.426-0.426-0.426-1.116 0-1.543l2.503-2.502h-5.006c-4.734 0-8.732 3.898-8.732 8.511 0 0.604-0.489 1.091-1.091 1.091-0.604 0-1.092-0.488-1.092-1.091 0-5.895 4.897-10.693 10.915-10.693h5.006l-2.503-2.501c-0.426-0.426-0.426-1.116 0-1.544 0.426-0.426 1.117-0.426 1.544 0l4.366 4.365c0.426 0.426 0.426 1.116 0 1.544zM6.535 6.533h-4.366v15.276h19.647v-7.637c0-0.603 0.489-1.091 1.091-1.091 0.604 0 1.092 0.489 1.092 1.091v7.637c0 1.204-0.981 2.182-2.184 2.182h-19.647c-1.203 0-2.182-0.978-2.182-2.182v-15.276c0-1.202 0.979-2.182 2.182-2.182h4.366c0.604 0 1.092 0.489 1.092 1.091 0 0.604-0.489 1.091-1.092 1.091z"
        }));
      },
      "settings-1": function settings1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "33" : n,
            a = e.height,
            o = void 0 === a ? "34" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 33 34"
        }, i.a.createElement("path", {
          d: "M29.173 17.01c0-.753-.05-1.42-.165-2.036l-.983.185.655.754 3.075-2.667-.656-.755.554.832c.635-.423.846-1.238.55-1.93C31.574 9.458 30.448 7.52 29 5.87a1.57 1.57 0 0 0-1.85-.445l-3.785 1.307.955.167a12.855 12.855 0 0 0-3.452-2.007l.62.74-.777-4C20.62.986 20.05.418 19.353.318a16.15 16.15 0 0 0-6.415.01c-.64.09-1.21.658-1.31 1.357l-.77 3.95.622-.74C10.2 5.387 9 6.08 8.01 6.91l.97-.18L5.13 5.4c-.606-.264-1.335-.068-1.8.49C1.9 7.52.773 9.457.113 11.477c-.265.608-.054 1.423.58 1.846l.555-.832-.655.755 3.074 2.667.655-.755-.98-.186c-.117.617-.167 1.283-.167 2.037s.05 1.42.166 2.037l.98-.185-.654-.755-3.074 2.667.655.755-.554-.833c-.635.423-.846 1.238-.55 1.93.63 1.936 1.755 3.874 3.205 5.525a1.57 1.57 0 0 0 1.85.444L8.98 27.29l-.97-.18c.99.83 2.187 1.523 3.467 2.018l-.622-.74.778 4c.092.648.66 1.216 1.36 1.316 1.076.2 2.126.307 3.177.307 1.05 0 2.102-.105 3.22-.312.658-.094 1.226-.662 1.326-1.36l.768-3.95-.62.74a12.936 12.936 0 0 0 3.452-2.006l-.955.167 3.852 1.332c.606.263 1.335.067 1.8-.49 1.43-1.63 2.558-3.57 3.218-5.588.265-.61.054-1.424-.58-1.847l-.556.832.655-.756-3.075-2.667-.655.755.983.185c.116-.617.165-1.283.165-2.036zm-2.236 2.232l.433.376 3.074 2.666.1.077a.434.434 0 0 1-.18-.52 14.434 14.434 0 0 1-2.868 4.992c.072-.087.28-.143.442-.074l-3.92-1.36-.523-.18-.43.348c-.893.72-1.88 1.294-2.92 1.697l-.514.2-.105.542-.778 4c.018-.13.14-.255.322-.28a15.787 15.787 0 0 1-2.897.286c-.922 0-1.852-.093-2.855-.28.14.02.264.144.29.324l-.786-4.05-.106-.54-.515-.2c-1.08-.42-2.086-1-2.902-1.686l-.434-.365-.536.186-3.852 1.332c.094-.043.303.013.39.12-1.29-1.47-2.28-3.174-2.853-4.93.04.086-.018.31-.21.44l.1-.078 3.074-2.666.433-.376-.106-.564a9.106 9.106 0 0 1-.13-1.667c0-.64.04-1.186.13-1.667l.106-.564-.433-.377-3.074-2.666-.1-.077c.192.13.25.353.178.522a14.463 14.463 0 0 1 2.87-4.993c-.07.086-.28.142-.44.073l3.918 1.36.536.185.434-.365c.816-.685 1.823-1.267 2.903-1.685l.516-.2.106-.542.777-4c-.018.13-.142.255-.322.28 1.926-.39 3.864-.39 5.733-.01-.122-.015-.245-.14-.27-.32l.785 4.05.106.543.516.198c1.04.403 2.026.977 2.918 1.697l.43.35.525-.183 3.85-1.333c-.093.042-.302-.014-.39-.12 1.29 1.47 2.28 3.173 2.854 4.93-.04-.087.017-.31.21-.44l-.1.077-3.074 2.666-.433.376.105.563c.09.48.13 1.028.13 1.668 0 .64-.04 1.187-.13 1.668l-.105.564zm-15.764-2.23c0-2.76 2.233-5 5-5 2.744 0 5 2.255 5 5a5 5 0 0 1-5 5c-2.78 0-5-2.22-5-5zm12 0c0-3.85-3.15-7-7-7-3.873 0-7 3.138-7 7 0 3.884 3.115 7 7 7a7 7 0 0 0 7-7z",
          fill: "#B5D2E1",
          fillRule: "evenodd"
        }));
      },
      question: function question(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24",
          fill: "none"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 24C5.383 24 0 18.617 0 12C0 5.383 5.383 0 12 0C18.617 0 24 5.383 24 12C24 18.617 18.617 24 12 24ZM14.389 12.344C12.94 13.517 12.994 14.816 12.997 14.87C13.028 15.415 12.616 15.892 12.072 15.932C12.046 15.934 12.022 15.935 11.997 15.935C11.484 15.935 11.05 15.551 11.004 15.032C10.996 14.936 10.821 12.659 13.13 10.789C13.772 10.27 14 9.814 14 9.051C14 7.889 13.103 6.943 12 6.943C10.86 6.943 10 7.803 10 8.943C10 9.496 9.552 9.943 9 9.943C8.448 9.943 8 9.496 8 8.943C8 6.701 9.757 4.944 12 4.944C14.206 4.944 16 6.786 16 9.051C16 10.426 15.503 11.442 14.389 12.344ZM12.985 18.114C13.079 17.569 12.709 17.08 12.165 16.986C11.618 16.891 11.099 17.286 11.005 17.83C10.911 18.374 11.276 18.891 11.82 18.985C11.878 18.995 11.935 19 11.991 19C12.469 19 12.892 18.656 12.976 18.17L12.985 18.114Z",
          fill: "#353F45"
        }));
      },
      "refresh-2": function refresh2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "28" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 28 24"
        }, i.a.createElement("path", {
          d: "M27.82 19.074c-0.17 0.085-0.353 0.126-0.53 0.126-0.436 0-0.854-0.244-1.063-0.664l-0.994-2.010c-1.762 4.469-5.996 7.474-11.002 7.474-5.438 0-10.298-3.548-11.82-8.628-0.19-0.635 0.164-1.304 0.792-1.496 0.624-0.193 1.29 0.166 1.48 0.8 1.222 4.076 5.148 6.924 9.548 6.924 4.128 0 7.481-2.436 8.838-6.126l-2.372 1.199c-0.588 0.298-1.3 0.056-1.592-0.536s-0.055-1.313 0.53-1.609l4.748-2.401c0.589-0.296 1.301-0.055 1.594 0.538l2.374 4.8c0.294 0.593 0.055 1.314-0.53 1.61zM25.259 10.126c-0.626 0.191-1.291-0.167-1.481-0.802-1.223-4.076-5.148-6.924-9.547-6.924-4.132 0-7.486 2.437-8.842 6.127l2.375-1.201c0.588-0.296 1.301-0.055 1.592 0.538 0.294 0.593 0.056 1.314-0.53 1.61l-4.748 2.399c-0.17 0.086-0.352 0.127-0.529 0.127-0.437 0-0.856-0.242-1.063-0.662l-2.375-4.801c-0.293-0.593-0.055-1.314 0.532-1.61 0.589-0.296 1.3-0.055 1.592 0.538l0.994 2.008c1.759-4.468 5.994-7.471 11.003-7.471 5.436 0 10.296 3.548 11.819 8.628 0.191 0.635-0.164 1.304-0.791 1.498z"
        }));
      },
      "paper-clip": function paperClip(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "27" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 27 24"
        }, i.a.createElement("path", {
          d: "M12.483 24c-0.287 0-0.573-0.112-0.793-0.334-0.439-0.446-0.439-1.168 0-1.614l11.638-11.833c0.868-0.882 1.346-2.056 1.346-3.303s-0.478-2.42-1.346-3.3c-1.791-1.822-4.706-1.821-6.496 0l-13.501 13.726c-0.761 0.775-1.127 1.52-1.086 2.217 0.039 0.679 0.461 1.203 0.71 1.454 0.418 0.426 0.871 0.604 1.38 0.538 0.639-0.081 1.373-0.527 2.125-1.292l10.594-10.771c0.437-0.445 1.148-0.445 1.586 0 0.439 0.445 0.439 1.168 0 1.613l-10.593 10.773c-1.124 1.142-2.279 1.796-3.434 1.942-1.21 0.153-2.331-0.259-3.244-1.187-0.816-0.83-1.301-1.871-1.363-2.932-0.081-1.376 0.505-2.711 1.74-3.966l13.501-13.727c2.666-2.71 7.004-2.71 9.669 0 1.291 1.311 2.003 3.057 2.003 4.914s-0.712 3.603-2.003 4.916l-11.638 11.833c-0.219 0.222-0.506 0.334-0.794 0.334z"
        }));
      },
      "notification-paused": function notificationPaused(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 20 24"
        }, i.a.createElement("path", {
          d: "M19.63 19.263c-0.287 0.468-0.803 0.737-1.416 0.737h-4.323c0 2.205-1.783 4-3.975 4-2.19 0-3.973-1.795-3.973-4h-4.321c-0.612 0-1.128-0.269-1.415-0.737-0.288-0.468-0.296-1.054-0.022-1.605l2.78-4.923v-5.735c0-3.86 3.119-7 6.951-7 3.835 0 6.954 3.14 6.954 7v5.735l2.756 4.876c0.299 0.598 0.291 1.183 0.004 1.652zM9.916 22c1.096 0 1.988-0.897 1.988-2h-3.974c0 1.103 0.891 2 1.986 2zM15.014 13.494c-0.010-0.017-0.009-0.036-0.018-0.054-0.029-0.059-0.044-0.123-0.062-0.189-0.017-0.066-0.035-0.128-0.039-0.195-0.001-0.020-0.011-0.036-0.011-0.056v-6c0-2.757-2.229-5-4.968-5-2.737 0-4.964 2.243-4.964 5v6c0 0.020-0.010 0.037-0.012 0.056-0.003 0.066-0.021 0.129-0.038 0.194-0.018 0.066-0.033 0.13-0.063 0.19-0.008 0.018-0.008 0.037-0.017 0.054l-2.546 4.506h15.285l-2.547-4.506zM6.938 8c0-0.552 0.445-1 0.993-1h3.973c0.382 0 0.73 0.221 0.895 0.567 0.166 0.346 0.119 0.757-0.119 1.058l-2.682 3.375h1.906c0.549 0 0.993 0.448 0.993 1s-0.444 1-0.993 1h-3.973c-0.381 0-0.73-0.221-0.895-0.567s-0.119-0.757 0.12-1.058l2.682-3.375h-1.907c-0.548 0-0.993-0.448-0.993-1z"
        }));
      },
      notification: function notification(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 20 24"
        }, i.a.createElement("path", {
          d: "M19.633 19.263c-0.287 0.468-0.804 0.737-1.416 0.737h-4.323c0 2.205-1.783 4-3.974 4s-3.973-1.795-3.973-4h-4.321c-0.612 0-1.129-0.269-1.416-0.737s-0.295-1.054-0.022-1.605l2.781-4.923v-5.735c0-3.86 3.118-7 6.951-7 3.834 0 6.954 3.14 6.954 7v5.735l2.756 4.876c0.298 0.598 0.291 1.184 0.003 1.652zM9.92 22c1.096 0 1.988-0.897 1.988-2h-3.975c0 1.103 0.891 2 1.987 2zM15.018 13.494c-0.142-0.25-0.159-0.534-0.080-0.789v-5.454c-0.022-0.082-0.050-0.162-0.050-0.251 0-2.757-2.229-5-4.968-5-2.737 0-4.964 2.243-4.964 5v6c0 0.020-0.011 0.036-0.012 0.056-0.003 0.067-0.022 0.129-0.039 0.195s-0.032 0.13-0.062 0.189c-0.008 0.018-0.008 0.037-0.017 0.054l-2.547 4.506h15.286l-2.547-4.506z"
        }));
      },
      "magnifier-1": function magnifier1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23.608 23.707c-0.195 0.195-0.45 0.293-0.705 0.293s-0.51-0.098-0.704-0.293l-7.653-7.682c-1.535 1.233-3.477 1.975-5.59 1.975-4.944 0-8.967-4.037-8.967-8.999 0-4.963 4.023-9.001 8.967-9.001s8.966 4.038 8.966 9.001c0 2.121-0.739 4.070-1.967 5.61l7.653 7.682c0.389 0.39 0.389 1.024 0 1.414zM8.956 2c-3.846 0-6.974 3.141-6.974 7.001s3.128 6.999 6.974 6.999c3.845 0 6.974-3.14 6.974-6.999s-3.129-7.001-6.974-7.001z"
        }));
      },
      home: function home(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23.588 13.723c-0.192 0.177-0.433 0.263-0.673 0.263-0.27 0-0.538-0.108-0.735-0.324l-0.261-0.286v8.614c0 1.102-0.893 2.001-1.99 2.001h-3.982c-0.549 0-0.995-0.449-0.995-1.001 0-0.127 0.029-0.248 0.072-0.36v-6.66l-6.045 0.018v7.002c0 0.552-0.446 1.001-0.995 1.001h-3.982c-1.097 0-1.99-0.898-1.99-2.001v-8.614l-0.261 0.286c-0.371 0.408-1.002 0.435-1.406 0.061-0.406-0.372-0.433-1.006-0.061-1.413l10.948-12.004c0.377-0.413 1.090-0.413 1.467 0l10.948 12.004c0.372 0.408 0.344 1.041-0.060 1.413zM20.044 11.319l-8.077-8.856-7.963 8.73v10.797h2.986v-6.003c0-1.103 0.893-2.002 1.99-2.002h5.972c1.097 0 1.99 0.898 1.99 2.002v6.003l3.101 0.002v-10.673z"
        }));
      },
      "flash-2": function flash2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 24"
        }, i.a.createElement("path", {
          d: "M15.217 11.119l-8.204 12.176c-0.137 0.407-0.513 0.695-0.955 0.695-0.042 0-0.084-0.002-0.127-0.008-0.474-0.056-0.814-0.427-0.87-0.869-0.006-0.027-0.003-0.055-0.007-0.082-0.002-0.054-0.019-0.105-0.012-0.16l0.009-0.079c0.005-0.037 0.006-0.073 0.014-0.111l0.965-7.673-4.708-0.001c-0.742 0-1.068-0.398-1.197-0.635-0.363-0.668 0.085-1.315 0.232-1.528l9.966-12.476c0.349-0.435 0.992-0.512 1.435-0.173 0.249 0.19 0.37 0.469 0.38 0.755 0.016 0.12 0.016 0.244-0.016 0.369l-1.928 7.698h4.087c0.738 0 1.058 0.383 1.184 0.611 0.342 0.625-0.043 1.188-0.249 1.491zM9.749 11.012c-0.459 0-0.883-0.197-1.194-0.557-0.361-0.417-0.527-1.016-0.431-1.562l0.92-3.677-6.227 7.793h3.68c0.574 0 1.018 0.175 1.319 0.521 0.16 0.184 0.412 0.584 0.31 1.203l-0.507 4.031 5.223-7.752h-3.092z"
        }));
      },
      "edit-1": function edit1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23.918 4.155c-0.006 0.044-0.029 0.081-0.041 0.122-0.015 0.055-0.029 0.108-0.053 0.16-0.035 0.073-0.081 0.134-0.13 0.195-0.022 0.028-0.032 0.062-0.057 0.087l-9.998 9.992c-0.017 0.016-0.039 0.022-0.057 0.037-0.049 0.044-0.106 0.077-0.164 0.11-0.060 0.033-0.118 0.066-0.183 0.087-0.021 0.007-0.037 0.023-0.060 0.028l-4 1.001c-0.080 0.020-0.161 0.030-0.242 0.030-0.262 0-0.518-0.104-0.707-0.293-0.248-0.249-0.348-0.609-0.263-0.949l1-3.998c0.006-0.023 0.022-0.039 0.030-0.062 0.020-0.065 0.052-0.121 0.086-0.181 0.033-0.059 0.066-0.114 0.109-0.163 0.015-0.018 0.021-0.041 0.038-0.059l9.998-9.992c0.029-0.029 0.068-0.041 0.1-0.066 0.052-0.041 0.104-0.080 0.164-0.11 0.064-0.031 0.127-0.051 0.194-0.069 0.037-0.010 0.069-0.032 0.107-0.037 0.212-0.030 2.098-0.26 3.249 0.974 1.126 1.199 0.91 2.958 0.882 3.155zM21.576 2.366c-0.282-0.304-0.833-0.374-1.208-0.375l-9.534 9.527-0.529 2.114 2.114-0.529 9.534-9.527c-0.004-0.36-0.077-0.89-0.377-1.21zM12.106 3.914h-10.088v18.159h18.159v-10.088c0-0.552 0.2-0.977 0.753-0.977s1 0.447 1 0.999v10.991c0 0.553-0.448 1-1 1h-19.997c-0.552 0-0.932-0.364-0.932-0.916v-20.177c0-0.552 0.38-0.89 0.932-0.89h10.998c0.552 0 1 0.447 1 1 0 0.552-0.272 0.899-0.824 0.899z"
        }));
      },
      "config-1": function config1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22 9.815v13.185c0 0.552-0.448 1-1 1s-1-0.448-1-1v-13.185c-1.162-0.414-2-1.513-2-2.815s0.838-2.401 2-2.816v-3.184c0-0.552 0.448-1 1-1s1 0.448 1 1v3.184c1.161 0.415 2 1.514 2 2.816s-0.839 2.401-2 2.815zM21 6c-0.551 0-1 0.448-1 1 0 0.551 0.449 1 1 1s1-0.449 1-1c0-0.552-0.449-1-1-1zM13 19.816v3.184c0 0.552-0.448 1-1 1s-1-0.448-1-1v-3.184c-1.161-0.415-2-1.514-2-2.816s0.839-2.401 2-2.816v-13.184c0-0.552 0.448-1 1-1s1 0.448 1 1v13.184c1.162 0.415 2 1.514 2 2.816s-0.838 2.401-2 2.816zM12 16c-0.551 0-1 0.448-1 1s0.449 1 1 1c0.551 0 1-0.448 1-1s-0.449-1-1-1zM4 14.816v8.184c0 0.552-0.448 1-1 1s-1-0.448-1-1v-8.184c-1.162-0.414-2-1.514-2-2.816s0.838-2.402 2-2.816v-8.184c0-0.552 0.448-1 1-1s1 0.448 1 1v8.184c1.161 0.414 2 1.514 2 2.816s-0.839 2.402-2 2.816zM3 11c-0.551 0-1 0.449-1 1s0.449 1 1 1c0.551 0 1-0.449 1-1s-0.449-1-1-1z"
        }));
      },
      check: function check(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "32" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 32 24"
        }, i.a.createElement("path", {
          d: "M12.043 23.981c-0.35 0-0.686-0.139-0.936-0.386l-10.723-10.661c-0.521-0.519-0.525-1.362-0.008-1.885 0.516-0.523 1.358-0.525 1.88-0.008l9.716 9.66 17.591-20.248c0.48-0.555 1.32-0.614 1.875-0.13 0.554 0.484 0.611 1.326 0.129 1.88l-18.522 21.319c-0.241 0.279-0.586 0.444-0.953 0.457-0.016 0.001-0.032 0.001-0.050 0.001z"
        }));
      },
      close: function close(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M13.357 11.993l10.256 10.295c0.39 0.391 0.39 1.024 0 1.415-0.194 0.195-0.449 0.292-0.704 0.292s-0.51-0.097-0.705-0.292l-10.257-10.295-10.256 10.295c-0.194 0.195-0.449 0.292-0.704 0.292s-0.51-0.097-0.705-0.292c-0.39-0.391-0.39-1.024 0-1.415l10.256-10.295-10.256-10.294c-0.39-0.391-0.39-1.024 0-1.415s1.020-0.391 1.409 0l10.256 10.294 10.256-10.294c0.39-0.391 1.020-0.391 1.41 0 0.389 0.391 0.389 1.024 0 1.415l-10.256 10.294z"
        }));
      },
      "cancel-square": function cancelSquare(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23 24h-22c-0.552 0-1-0.448-1-1v-22c0-0.552 0.448-1 1-1h22c0.552 0 1 0.448 1 1v22c0 0.552-0.448 1-1 1zM22 2h-20v20h20v-20zM7.293 7.293c0.391-0.391 1.023-0.391 1.414 0l3.293 3.293 3.293-3.293c0.391-0.391 1.023-0.391 1.414 0 0.391 0.39 0.391 1.024 0 1.414l-3.293 3.293 3.293 3.293c0.391 0.39 0.391 1.024 0 1.414-0.195 0.195-0.451 0.293-0.707 0.293s-0.512-0.098-0.707-0.293l-3.293-3.293-3.293 3.293c-0.195 0.195-0.451 0.293-0.707 0.293s-0.512-0.098-0.707-0.293c-0.391-0.39-0.391-1.024 0-1.414l3.293-3.293-3.293-3.293c-0.391-0.39-0.391-1.024 0-1.414z"
        }));
      },
      "cancel-circle": function cancelCircle(e) {
        var t = e.className,
            n = e.height,
            r = void 0 === n ? "30" : n,
            a = e.width,
            o = void 0 === a ? "30" : a;
        return i.a.createElement("svg", {
          className: t,
          height: r,
          width: o,
          viewBox: "0 0 30 30"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15 30C6.72937 30 0 23.2716 0 15C0 6.72937 6.72937 0 15 0C23.2706 0 30 6.72937 30 15C30 23.2716 23.2706 30 15 30ZM15 1.875C7.7625 1.875 1.875 7.7625 1.875 15C1.875 22.2366 7.7625 28.125 15 28.125C22.2375 28.125 28.125 22.2366 28.125 15C28.125 7.7625 22.2375 1.875 15 1.875ZM20.3503 20.3503C20.1675 20.5331 19.9275 20.625 19.6875 20.625C19.4475 20.625 19.2075 20.5331 19.0247 20.3503L15 16.3256L10.9753 20.3503C10.7925 20.5331 10.5525 20.625 10.3125 20.625C10.0725 20.625 9.8325 20.5331 9.64969 20.3503C9.28312 19.9847 9.28312 19.3903 9.64969 19.0247L13.6744 15L9.64969 10.9753C9.28312 10.6097 9.28312 10.0163 9.64969 9.65063C10.0162 9.28312 10.6087 9.28312 10.9753 9.65063L15 13.6744L19.0247 9.65063C19.3912 9.28312 19.9837 9.28312 20.3503 9.65063C20.7169 10.0163 20.7169 10.6097 20.3503 10.9753L16.3256 15L20.3503 19.0247C20.7169 19.3903 20.7169 19.9847 20.3503 20.3503Z",
          fill: "#4E5C65"
        }));
      },
      "check-square": function checkSquare(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23 24h-22c-0.552 0-1-0.448-1-1v-22c0-0.552 0.448-1 1-1h22c0.552 0 1 0.448 1 1v22c0 0.552-0.448 1-1 1zM22 2h-20v20h20v-20zM6.624 11.219l4.253 3.402 6.371-7.279c0.363-0.416 0.995-0.458 1.411-0.095 0.415 0.364 0.457 0.996 0.093 1.412l-7 7.999c-0.197 0.226-0.474 0.342-0.752 0.342-0.22 0-0.44-0.072-0.624-0.219l-5.001-4c-0.431-0.345-0.501-0.975-0.156-1.406 0.344-0.431 0.975-0.501 1.405-0.156z"
        }));
      },
      write: function write(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23.552 4.819l-16.565 16.676c-0.001 0-0.001 0.001-0.002 0.001l-0.005 0.005c-0.069 0.070-0.155 0.116-0.241 0.162-0.029 0.016-0.049 0.042-0.080 0.055l-5.281 2.206c-0.123 0.051-0.252 0.076-0.381 0.076-0.258 0-0.512-0.102-0.702-0.293-0.284-0.286-0.369-0.716-0.215-1.090l2.191-5.318c0.034-0.083 0.092-0.147 0.144-0.215 0.027-0.035 0.040-0.076 0.071-0.108l0.003-0.003c0.002-0.002 0.003-0.003 0.004-0.004l13.638-13.73c0-0.001 0.001-0.002 0.001-0.002 0.001-0.001 0.002-0.001 0.003-0.002l2.922-2.942c0.186-0.188 0.439-0.293 0.702-0.293s0.516 0.105 0.702 0.293l3.091 3.112c0.388 0.391 0.388 1.024 0 1.414zM3.537 19.448l-0.701 1.701 1.69-0.706-0.989-0.995zM4.593 17.683l1.685 1.697 12.243-12.324-1.686-1.698-12.242 12.325zM19.759 2.414l-1.52 1.53 1.686 1.698 1.52-1.529-1.686-1.699zM8.944 22h11.919c0.548 0 0.993 0.448 0.993 1s-0.445 1-0.993 1h-11.919c-0.549 0-0.994-0.448-0.994-1s0.445-1 0.994-1z"
        }));
      },
      underline: function underline(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 24"
        }, i.a.createElement("path", {
          d: "M17 24h-16c-0.552 0-1-0.448-1-1s0.448-1 1-1h16c0.552 0 1 0.448 1 1s-0.448 1-1 1zM9 20c-4.187 0-7-2.813-7-7v-12c0-0.552 0.448-1 1-1s1 0.448 1 1v12c0 3.084 1.916 5 5 5s5-1.916 5-5v-12c0-0.552 0.448-1 1-1s1 0.448 1 1v12c0 4.187-2.813 7-7 7z"
        }));
      },
      "text-italic": function textItalic(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 14 24"
        }, i.a.createElement("path", {
          d: "M13.049 1.994h-2.244l-5.476 19.991h1.697c0.554 0 1.004 0.447 1.004 1 0 0.551-0.45 0.999-1.004 0.999h-6.023c-0.554 0-1.004-0.448-1.004-0.999 0-0.553 0.45-1 1.004-1h2.244l5.476-19.991h-1.697c-0.554 0-1.004-0.448-1.004-1s0.45-1 1.004-1h6.023c0.554 0 1.004 0.448 1.004 1s-0.45 1-1.004 1z"
        }));
      },
      bold: function bold(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 24"
        }, i.a.createElement("path", {
          d: "M12.489 10.896c2.129 1.165 3.511 3.408 3.511 6.104 0 4.056-2.916 7-6.934 7h-8.066c-0.552 0-1-0.448-1-1v-22c0-0.552 0.448-1 1-1h8.066c3.383 0 5.934 2.579 5.934 6 0 2.049-0.986 3.818-2.511 4.896zM14 17c0-2.469-1.707-4.969-4.969-4.969-0.054 0-0.101-0.023-0.154-0.031h-6.877v10h7.066c3.39 0 4.934-2.592 4.934-5zM9.066 2h-7.066v8h7c2.28 0 4-1.72 4-4 0-2.318-1.654-4-3.934-4z"
        }));
      },
      "paragraph-down": function paragraphDown(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22.962 18.994h-10.98c-0.551 0-0.999-0.448-0.999-0.999s0.401-0.952 0.952-0.952h11.028c0.551 0 0.996 0.401 0.996 0.952s-0.447 0.999-0.998 0.999zM22.962 13.999h-10.98c-0.551 0-0.999-0.447-0.999-0.999 0-0.551 0.447-0.999 0.999-0.999h10.98c0.55 0 0.998 0.447 0.998 0.999s-0.447 0.999-0.998 0.999zM22.962 9.004h-5.99c-0.551 0-0.998-0.447-0.998-0.999s0.446-0.999 0.997-0.999h5.99c0.55 0 0.998 0.447 0.998 0.999 0 0.551-0.447 0.999-0.998 0.999zM22.962 4.008h-7.986c-0.551 0-0.999-0.447-0.999-0.999 0-0.551 0.447-0.999 0.999-0.999h7.986c0.55 0 0.998 0.447 0.998 0.999s-0.447 0.999-0.998 0.999zM12.981 8.604c-0.272 0-0.542-0.11-0.739-0.327l-4.317-4.751v19.532c0 0.552-0.384 0.931-0.935 0.931s-1.070-0.379-1.070-0.931v-19.384l-4.181 4.603c-0.37 0.408-1.001 0.439-1.411 0.067-0.407-0.372-0.437-1.003-0.066-1.412l5.796-6.381c0.186-0.318 0.545-0.539 0.931-0.539 0.147 0 0.28 0.035 0.4 0.092 0.126 0.052 0.244 0.13 0.338 0.235l5.991 6.593c0.371 0.408 0.341 1.040-0.067 1.412-0.191 0.173-0.432 0.26-0.671 0.26zM11.936 22.055h11.028c0.551 0 0.996 0.384 0.996 0.935s-0.447 0.999-0.998 0.999h-10.98c-0.551 0-0.999-0.447-0.999-0.999s0.401-0.935 0.952-0.935z"
        }));
      },
      "paragraph-up": function paragraphUp(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22.933 17h-5.974c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1h5.974c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1zM22.933 12h-10.953c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1h10.953c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1zM22.933 7h-10.953c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1h10.953c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1zM22.933 2h-10.953c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1h10.953c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1zM13.646 15.661c0.407 0.371 0.437 1.003 0.067 1.412l-5.975 6.6c-0.099 0.11-0.222 0.19-0.355 0.246-0.115 0.052-0.243 0.081-0.382 0.081-0.141 0-0.274-0.031-0.395-0.084-0.029-0.012-0.051-0.038-0.079-0.053-0.089-0.050-0.175-0.103-0.244-0.177-0.005-0.006-0.013-0.008-0.018-0.013l-5.975-6.6c-0.37-0.409-0.34-1.041 0.067-1.412 0.408-0.372 1.037-0.342 1.406 0.066l4.242 4.687v-19.414c0-0.552 0.446-1 0.996-1s0.937 0.448 0.937 1v19.479l4.302-4.752c0.37-0.407 0.999-0.437 1.406-0.066zM14.967 20h7.966c0.55 0 0.996 0.448 0.996 1s-0.446 1-0.996 1h-7.966c-0.55 0-0.996-0.448-0.996-1s0.446-1 0.996-1z"
        }));
      },
      "list-bullets": function listBullets(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M25.091 13.091h-15.273c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091h15.273c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091zM25.091 4.364h-15.273c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091h15.273c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091zM3.273 24c-1.804 0-3.273-1.468-3.273-3.273s1.468-3.273 3.273-3.273c1.804 0 3.273 1.468 3.273 3.273s-1.468 3.273-3.273 3.273zM3.273 19.636c-0.601 0-1.091 0.49-1.091 1.091s0.49 1.091 1.091 1.091c0.601 0 1.091-0.49 1.091-1.091s-0.49-1.091-1.091-1.091zM3.273 15.273c-1.804 0-3.273-1.468-3.273-3.273s1.468-3.273 3.273-3.273c1.804 0 3.273 1.468 3.273 3.273s-1.468 3.273-3.273 3.273zM3.273 10.909c-0.601 0-1.091 0.49-1.091 1.091s0.49 1.091 1.091 1.091c0.601 0 1.091-0.49 1.091-1.091s-0.49-1.091-1.091-1.091zM3.273 6.545c-1.804 0-3.273-1.467-3.273-3.273 0-1.804 1.468-3.273 3.273-3.273s3.273 1.468 3.273 3.273c0 1.805-1.468 3.273-3.273 3.273zM3.273 2.182c-0.601 0-1.091 0.49-1.091 1.091s0.49 1.091 1.091 1.091c0.601 0 1.091-0.49 1.091-1.091s-0.49-1.091-1.091-1.091zM9.818 19.636h15.273c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091h-15.273c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091z"
        }));
      },
      "list-numbers": function listNumbers(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "25" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 25 24"
        }, i.a.createElement("path", {
          d: "M23.996 13.087h-15.266c-0.602 0-1.091-0.488-1.091-1.090s0.443-0.993 1.045-0.993h15.314c0.602 0 1.088 0.392 1.088 0.993s-0.488 1.090-1.091 1.090zM23.996 4.374h-15.266c-0.602 0-1.091-0.488-1.091-1.088 0-0.603 0.443-1.033 1.045-1.033h15.314c0.602 0 1.088 0.43 1.088 1.033 0 0.601-0.488 1.088-1.091 1.088zM3.683 23.348c-0.628 0.55-1.523 0.657-2.127 0.657-0.288 0-0.509-0.025-0.604-0.037-0.597-0.080-1.016-0.627-0.937-1.224 0.080-0.594 0.624-1.015 1.22-0.936 0.188 0.023 0.41 0.022 0.603 0.003-0.042-0.004-0.082-0.009-0.119-0.010-0.057 0.002-0.104 0.001-0.133 0.001-0.589-0.012-1.062-0.489-1.068-1.077-0.007-0.59 0.457-1.075 1.046-1.099 0.030-0.001 0.079 0.001 0.13-0.002 0.025-0.001 0.050-0.003 0.075-0.005-0.179-0.018-0.381-0.021-0.559-0.002-0.59 0.060-1.133-0.374-1.196-0.969-0.062-0.597 0.366-1.132 0.964-1.197 0.295-0.034 1.814-0.152 2.727 0.667 0.434 0.387 0.663 0.909 0.663 1.507 0 0.399-0.106 0.767-0.311 1.083 0.205 0.318 0.311 0.69 0.311 1.095 0 0.619-0.237 1.154-0.685 1.546zM4.368 14.179c0 0.602-0.489 1.090-1.091 1.090h-2.181c-0.441 0-0.838-0.266-1.006-0.673-0.17-0.407-0.077-0.875 0.235-1.186 0.908-0.909 1.781-2.081 1.86-2.494-0.196-0.009-0.462-0.008-0.692-0.005l-0.396 0.001c-0.602 0-1.091-0.488-1.091-1.088 0-0.602 0.489-1.090 1.091-1.090l0.382-0.001c0.981-0.004 1.759-0.011 2.338 0.563 0.496 0.491 0.552 1.157 0.552 1.616 0 0.675-0.411 1.467-0.921 2.192 0.522 0.081 0.921 0.532 0.921 1.075zM2.187 6.552c-0.602 0-1.091-0.488-1.091-1.090v-2.178c-0.258-0.010-0.513-0.11-0.714-0.304-0.434-0.417-0.447-1.106-0.030-1.54l1.049-1.088c0.308-0.321 0.78-0.422 1.192-0.256 0.413 0.166 0.684 0.567 0.684 1.011v4.356c0 0.602-0.488 1.090-1.091 1.090zM8.683 19.756h15.314c0.602 0 1.088 0.353 1.088 0.955 0 0.601-0.487 1.233-1.088 1.233h-15.314c-0.602 0-1.045-0.632-1.045-1.233 0-0.602 0.443-0.955 1.045-0.955z"
        }));
      },
      "book-4": function book4(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "18" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 18"
        }, i.a.createElement("g", {
          id: "Final"
        }, i.a.createElement("g", {
          id: "Upgrade---Short-Screen"
        }, i.a.createElement("g", {
          id: "Group-13"
        }, i.a.createElement("g", {
          id: "Side-Nav"
        }, i.a.createElement("path", {
          id: "Shape",
          d: "M16.75,17.16,9.21,18.67H8.92L1.38,17.16A1.72,1.72,0,0,1,0,15.51V2.06A1.38,1.38,0,0,1,.53,1,1.37,1.37,0,0,1,1.67.72L8.92,2.17l.14,0,.14,0L16.46.72a1.35,1.35,0,0,1,1.64,1.35V15.51A1.72,1.72,0,0,1,16.75,17.16ZM8.31,3.59,1.54,2.23V15.51a.22.22,0,0,0,.13.16L8.31,17Zm6-.91-2.26.45V6l.55-.66a.75.75,0,0,1,1-.11l.66.53Zm2.26-.45-.75.15v5a.75.75,0,0,1-1.22.59l-1.3-1L11.9,8.59a.75.75,0,0,1-.58.27.74.74,0,0,1-.26,0,.76.76,0,0,1-.5-.71V3.44l-.75.15V17l6.64-1.33a.22.22,0,0,0,.13-.16Z",
          transform: "translate(-0.03 -0.69)"
        }))))));
      },
      "knowledgebase-book": function knowledgebaseBook(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "18" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 20 20"
        }, i.a.createElement("defs", null), i.a.createElement("g", {
          id: "general",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "Artboard-3",
          fill: "#394F5A"
        }, i.a.createElement("path", {
          d: "M19.375,17.5 L12.5,17.5 C11.46625,17.5 10.625,18.34125 10.625,19.375 C10.625,19.720625 10.345,20 10,20 C9.655,20 9.375,19.720625 9.375,19.375 C9.375,18.34125 8.53375,17.5 7.5,17.5 L0.625,17.5 C0.28,17.5 0,17.22 0,16.875 L0,0.625 C0,0.279375 0.28,0 0.625,0 L7.5,0 C8.525625,0 9.43,0.50375 10,1.269375 C10.57,0.50375 11.474375,0 12.5,0 L19.375,0 C19.72,0 20,0.279375 20,0.625 L20,16.875 C20,17.22 19.72,17.5 19.375,17.5 Z M7.5,1.25 L1.25,1.25 L1.25,16.25 L7.5,16.25 C8.20625,16.25 8.85125,16.494375 9.375,16.89125 L9.375,3.125 C9.375,2.09125 8.53375,1.25 7.5,1.25 Z M18.75,1.25 L12.5,1.25 C11.46625,1.25 10.625,2.09125 10.625,3.125 L10.625,16.89125 C11.14875,16.494375 11.79375,16.25 12.5,16.25 L18.75,16.25 L18.75,1.25 Z M11.875,12.5 C11.875,12.155 12.155,11.875 12.5,11.875 L16.875,11.875 C17.22,11.875 17.5,12.155 17.5,12.5 C17.5,12.845 17.22,13.125 16.875,13.125 L12.5,13.125 C12.155,13.125 11.875,12.845 11.875,12.5 Z M16.875,9.375 L12.5,9.375 C12.155,9.375 11.875,9.095 11.875,8.75 C11.875,8.405 12.155,8.125 12.5,8.125 L16.875,8.125 C17.22,8.125 17.5,8.405 17.5,8.75 C17.5,9.095 17.22,9.375 16.875,9.375 Z M16.875,5.625 L12.5,5.625 C12.155,5.625 11.875,5.345625 11.875,5 C11.875,4.655 12.155,4.375 12.5,4.375 L16.875,4.375 C17.22,4.375 17.5,4.655 17.5,5 C17.5,5.345625 17.22,5.625 16.875,5.625 Z M7.5,13.125 L3.125,13.125 C2.78,13.125 2.5,12.845 2.5,12.5 C2.5,12.155 2.78,11.875 3.125,11.875 L7.5,11.875 C7.845,11.875 8.125,12.155 8.125,12.5 C8.125,12.845 7.845,13.125 7.5,13.125 Z M7.5,9.375 L3.125,9.375 C2.78,9.375 2.5,9.095 2.5,8.75 C2.5,8.405 2.78,8.125 3.125,8.125 L7.5,8.125 C7.845,8.125 8.125,8.405 8.125,8.75 C8.125,9.095 7.845,9.375 7.5,9.375 Z M7.5,5.625 L3.125,5.625 C2.78,5.625 2.5,5.345625 2.5,5 C2.5,4.655 2.78,4.375 3.125,4.375 L7.5,4.375 C7.845,4.375 8.125,4.655 8.125,5 C8.125,5.345625 7.845,5.625 7.5,5.625 Z",
          id: "book---6"
        }))));
      },
      article: function article(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 14 16"
        }, i.a.createElement("defs", null), i.a.createElement("g", {
          id: "create",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "add-menu",
          transform: "translate(-941.000000, -179.000000)",
          fill: "#394F5A"
        }, i.a.createElement("g", {
          id: "art-new",
          transform: "translate(941.000000, 179.000000)"
        }, i.a.createElement("path", {
          d: "M13.3,13.9666667 L11.9007,13.9666667 L11.9007,15.296 C11.9007,15.6626667 11.5871,15.9606667 11.2007,15.9606667 C10.8143,15.9606667 10.5007,15.6626667 10.5007,15.296 L10.5007,13.9666667 L9.1,13.9666667 C8.7136,13.9666667 8.4,13.6693333 8.4,13.302 C8.4,12.9346667 8.7136,12.6373333 9.1,12.6373333 L10.5007,12.6373333 L10.5007,11.3073333 C10.5007,10.94 10.8143,10.6426667 11.2007,10.6426667 C11.5871,10.6426667 11.9007,10.94 11.9007,11.3073333 L11.9007,12.6373333 L13.3,12.6373333 C13.6864,12.6373333 14,12.9346667 14,13.302 C14,13.6693333 13.6864,13.9666667 13.3,13.9666667 Z M12.6,7.98466667 C12.6,8.352 12.2864,8.64933333 11.9,8.64933333 C11.5136,8.64933333 11.2,8.352 11.2,7.98466667 L11.2,5.99066667 L7,5.99066667 C6.6136,5.99066667 6.3,5.69333333 6.3,5.326 L6.3,1.31333333 L1.4,1.31333333 L1.4,14.6313333 L6.3,14.6313333 C6.6864,14.6313333 7,14.9286667 7,15.296 C7,15.6626667 6.6864,15.9606667 6.3,15.9606667 L1.4,15.9606667 C0.6279,15.9606667 0,15.364 0,14.6313333 L0,1.338 C0,0.605333333 0.6279,0.00866666667 1.4,0.00866666667 L7,0.00866666667 C7.0147,0.00866666667 7.0273,0.016 7.0427,0.0173333333 C7.1064,0.0206666667 7.168,0.0326666667 7.2282,0.0526666667 C7.2506,0.06 7.273,0.0653333333 7.294,0.0746666667 C7.3647,0.106 7.4312,0.146 7.4893,0.2 C7.4914,0.202 7.4935,0.202666667 7.4956,0.204666667 L12.3186,4.784 C12.341,4.79866667 12.3515,4.824 12.3718,4.84133333 C12.3921,4.85933333 12.4082,4.88 12.4264,4.90066667 C12.5342,5.01733333 12.614,5.15866667 12.614,5.326 C12.614,5.34933333 12.6021,5.36933333 12.6,5.392 L12.6,7.98466667 Z M7.7,2.278 L7.7,4.66133333 L10.2102,4.66133333 L7.7,2.278 Z",
          id: "Shape"
        })))));
      },
      "article-create-1": function articleCreate1(e) {
        var t = e.width,
            n = e.height,
            r = e.className;
        return i.a.createElement("svg", {
          className: r,
          width: t,
          height: n
        }, i.a.createElement("path", {
          d: "M10.154 14H.846C.38 14 0 13.607 0 13.125V.875C0 .393.38 0 .846 0h9.308c.466 0 .846.393.846.875v12.25c0 .482-.38.875-.846.875zM1 1v12.25h9.306L10.308 1H1zm7.192 8.875H1.423A.43.43 0 0 1 1 9.437.43.43 0 0 1 1.423 9h6.77a.43.43 0 0 1 .422.438.43.43 0 0 1-.423.437zm0-2H1.423A.43.43 0 0 1 1 7.437.43.43 0 0 1 1.423 7h6.77a.43.43 0 0 1 .422.438.43.43 0 0 1-.423.437zm.77-2H6.423A.43.43 0 0 1 6 5.437.43.43 0 0 1 6.423 5h2.539a.43.43 0 0 1 .423.438.43.43 0 0 1-.423.437zm0-2H6.423A.43.43 0 0 1 6 3.437.43.43 0 0 1 6.423 3h2.539a.43.43 0 0 1 .423.438.43.43 0 0 1-.423.437zm-5 2.625H1.423A.43.43 0 0 1 1 6.062V3.438A.43.43 0 0 1 1.423 3h2.539a.43.43 0 0 1 .423.438v2.624a.43.43 0 0 1-.423.438zM3.692 3H2v1.75h1.692V3zm-2.269 7h4.23a.43.43 0 0 1 .424.438.43.43 0 0 1-.423.437h-4.23A.43.43 0 0 1 1 10.438.43.43 0 0 1 1.423 10z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      "article-create-2": function articleCreate2(e) {
        var t = e.width,
            n = void 0 === t ? "13" : t,
            r = e.height,
            a = void 0 === r ? "15" : r,
            o = e.className;
        return i.a.createElement("svg", {
          className: o,
          width: n,
          height: a
        }, i.a.createElement("path", {
          d: "M11.406 15H1.094A1.09 1.09 0 0 1 0 13.917V1.083C0 .486.49 0 1.094 0h10.312A1.09 1.09 0 0 1 12.5 1.083v12.834A1.09 1.09 0 0 1 11.406 15zM11.25 1.25h-10v12.5h10V1.25zM2.5 7.5H10a.625.625 0 0 1 0 1.25H2.5a.625.625 0 0 1 0-1.25zm0 1.875H10a.625.625 0 0 1 0 1.25H2.5a.625.625 0 0 1 0-1.25zm0 1.875h4.375a.625.625 0 0 1 0 1.25H2.5a.625.625 0 0 1 0-1.25zm7.5-5H7.5A.625.625 0 0 1 7.5 5H10a.625.625 0 0 1 0 1.25zm0-1.875H7.5a.625.625 0 0 1 0-1.25H10a.625.625 0 0 1 0 1.25zM5.625 6.25h-2.5a.625.625 0 0 1-.625-.625v-2.5c0-.345.28-.625.625-.625h2.5c.345 0 .625.28.625.625v2.5c0 .345-.28.625-.625.625zM5 3.75H3.75V5H5V3.75z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      "article-download": function articleDownload(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 12 16"
        }, i.a.createElement("g", {
          id: "personal->-Team-upgrade-flow",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "pro-copy-13",
          transform: "translate(-908.000000, -926.000000)",
          fill: "#394F5A"
        }, i.a.createElement("g", {
          id: "download-copy",
          transform: "translate(908.000000, 924.000000)"
        }, i.a.createElement("g", {
          id: "file-download",
          transform: "translate(0.500000, 2.500000)"
        }, i.a.createElement("path", {
          d: "M11.0954667,4.77813333 C11.1072889,4.80551111 11.1091556,4.83662222 11.1172444,4.86586667 C11.1359111,4.9256 11.1620444,4.98284444 11.1620444,5.0488 C11.1620444,5.07057778 11.1514667,5.08862222 11.1496,5.10977778 L11.1496,7.52026667 C11.1496,7.86373333 10.8720889,8.14124444 10.5304889,8.14124444 C10.1882667,8.14124444 9.97484444,7.85751111 9.97484444,7.51466667 L9.97484444,5.648 L6.24151111,5.648 C5.89928889,5.648 5.61928889,5.36862222 5.61928889,5.02577778 L5.61928889,1.30302222 L1.24257778,1.30302222 L1.24257778,13.7176 L4.95786667,13.7176 C5.29946667,13.7176 5.57697778,13.9957333 5.57697778,14.3385778 C5.57697778,14.6808 5.29946667,14.9589333 4.95786667,14.9589333 L1.24257778,14.9589333 C0.559377778,14.9589333 0.00435555556,14.4020444 0.00435555556,13.7176 L0.00435555556,1.30302222 C0.00435555556,0.618577778 0.559377778,0.0616888889 1.24257778,0.0616888889 L6.19608889,0.0616888889 C6.39457778,0.0616888889 6.5632,0.161244444 6.67644444,0.306844444 L10.9007111,4.54231111 C10.9654222,4.59333333 11.0158222,4.6512 11.0562667,4.71964444 C11.0693333,4.74017778 11.0848889,4.75635556 11.0954667,4.77813333 Z M6.8152,2.20151111 L6.8152,4.42782222 L9.03528889,4.42782222 L6.8152,2.20151111 Z M7.25324444,12.0475556 L8.10817778,12.9049778 L8.10817778,9.38133333 C8.10817778,9.03848889 8.33093333,8.76222222 8.67253333,8.76222222 C9.01475556,8.76222222 9.29226667,9.04035556 9.29226667,9.38257778 L9.29226667,12.8502222 L10.0924444,12.0475556 C10.3344889,11.8048889 10.7264889,11.8048889 10.9679111,12.0475556 C11.2099556,12.2902222 11.2099556,12.6828444 10.9679111,12.9248889 L9.1112,14.7865778 C9.05395556,14.8444444 8.98551111,14.8898667 8.90897778,14.9216 C8.83368889,14.9527111 8.75342222,14.9695111 8.67253333,14.9695111 C8.51448889,14.9695111 8.35582222,14.9085333 8.23511111,14.7872 L6.37715556,12.9248889 C6.13573333,12.6828444 6.13573333,12.2902222 6.37715556,12.0475556 C6.6192,11.8048889 7.0112,11.8048889 7.25324444,12.0475556 Z",
          id: "Shape"
        }))))));
      },
      section: function section(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "15" : n,
            a = e.height,
            o = void 0 === a ? "14" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 15 14",
          version: "1.1"
        }, i.a.createElement("defs", null), i.a.createElement("g", {
          id: "create",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "add-menu",
          transform: "translate(-942.000000, -219.000000)",
          fill: "#394F5A"
        }, i.a.createElement("g", {
          id: "sect-new",
          transform: "translate(942.000000, 219.000000)"
        }, i.a.createElement("path", {
          d: "M14.375,8.22818182 C14.029375,8.22818182 13.75,7.945 13.75,7.59563636 L13.75,2.534 L7.5,2.534 C7.5,2.534 7.5,2.534 7.499375,2.534 C7.499375,2.534 7.499375,2.534 7.499375,2.534 C7.42625,2.534 7.354375,2.51681818 7.28375,2.49009091 C7.26125,2.48181818 7.241875,2.471 7.220625,2.46018182 C7.198125,2.44872727 7.174375,2.44236364 7.153125,2.42772727 L5.435625,1.26890909 L1.25,1.26890909 L1.25,11.4545455 L8.125,11.4545455 C8.470625,11.4545455 8.75,11.6747273 8.75,12.0247273 C8.75,12.3740909 8.470625,12.7272727 8.125,12.7272727 L1.25,12.7272727 C0.560625,12.7272727 0,12.0896364 0,11.3915455 L0,1.26890909 C0,0.570818182 0.560625,0.00381818182 1.25,0.00381818182 L5.625,0.00381818182 C5.64375,0.00381818182 5.66,0.0127272727 5.678125,0.0146363636 C5.721875,0.0184545455 5.7625,0.0273636364 5.804375,0.0400909091 C5.845,0.0528181818 5.881875,0.0674545455 5.91875,0.0878181818 C5.935625,0.0967272727 5.955,0.0986363636 5.971875,0.109454545 L7.689375,1.26890909 L13.75,1.26890909 C14.43875,1.26890909 15,1.83654545 15,2.534 L15,7.59563636 C15,7.945 14.720625,8.22818182 14.375,8.22818182 Z M10.625,10.759 L11.875,10.759 L11.875,9.49327273 C11.875,9.14390909 12.154375,8.86072727 12.5,8.86072727 C12.845625,8.86072727 13.125,9.14390909 13.125,9.49327273 L13.125,10.759 L14.375,10.759 C14.720625,10.759 15,11.0421818 15,11.3915455 C15,11.7409091 14.720625,12.0247273 14.375,12.0247273 L13.125,12.0247273 L13.125,13.2898182 C13.125,13.6391818 12.845625,13.9223636 12.5,13.9223636 C12.154375,13.9223636 11.875,13.6391818 11.875,13.2898182 L11.875,12.0247273 L10.625,12.0247273 C10.279375,12.0247273 10,11.7409091 10,11.3915455 C10,11.0421818 10.279375,10.759 10.625,10.759 Z",
          id: "Shape"
        })))));
      },
      category: function category(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "17" : n,
            a = e.height,
            o = void 0 === a ? "15" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 17 15"
        }, i.a.createElement("defs", null), i.a.createElement("g", {
          id: "create",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "add-menu",
          transform: "translate(-941.000000, -254.000000)",
          fill: "#394F5A"
        }, i.a.createElement("path", {
          d: "M953.875,268.2391 C953.875,268.6234 953.557667,268.9356 953.166667,268.9356 L942.416667,268.9356 C941.635375,268.9356 941,268.3105 941,267.5419 L941,257.7874 C941,257.4024 941.317333,257.0902 941.708333,257.0902 C942.099333,257.0902 942.416667,257.4024 942.416667,257.7874 L942.416667,267.5916 L953.166667,267.5916 C953.557667,267.5916 953.875,267.8541 953.875,268.2391 Z M957.375,262.228182 C957.029375,262.228182 956.75,261.945 956.75,261.595636 L956.75,256.534 L950.5,256.534 C950.42625,256.534 950.354375,256.516818 950.28375,256.490091 C950.26125,256.481818 950.241875,256.471 950.220625,256.460182 C950.198125,256.448727 950.174375,256.442364 950.153125,256.427727 L948.435625,255.268909 L944.25,255.268909 L944.25,265.454545 L951.125,265.454545 C951.470625,265.454545 951.75,265.674727 951.75,266.024727 C951.75,266.374091 951.470625,266.727273 951.125,266.727273 L944.25,266.727273 C943.560625,266.727273 943,266.089636 943,265.391545 L943,255.268909 C943,254.570818 943.560625,254.003818 944.25,254.003818 L948.625,254.003818 C948.64375,254.003818 948.66,254.012727 948.678125,254.014636 C948.721875,254.018455 948.7625,254.027364 948.804375,254.040091 C948.845,254.052818 948.881875,254.067455 948.91875,254.087818 C948.935625,254.096727 948.955,254.098636 948.971875,254.109455 L950.689375,255.268909 L956.75,255.268909 C957.43875,255.268909 958,255.836545 958,256.534 L958,261.595636 C958,261.945 957.720625,262.228182 957.375,262.228182 Z M953.625,264.759 L954.875,264.759 L954.875,263.493273 C954.875,263.143909 955.154375,262.860727 955.5,262.860727 C955.845625,262.860727 956.125,263.143909 956.125,263.493273 L956.125,264.759 L957.375,264.759 C957.720625,264.759 958,265.042182 958,265.391545 C958,265.740909 957.720625,266.024727 957.375,266.024727 L956.125,266.024727 L956.125,267.289818 C956.125,267.639182 955.845625,267.922364 955.5,267.922364 C955.154375,267.922364 954.875,267.639182 954.875,267.289818 L954.875,266.024727 L953.625,266.024727 C953.279375,266.024727 953,265.740909 953,265.391545 C953,265.042182 953.279375,264.759 953.625,264.759 Z",
          id: "cat---new"
        }))));
      },
      "shopping-tag": function shoppingTag(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M22.999 12.414l-10.571 10.988c-0.391 0.39-0.893 0.598-1.428 0.598s-1.038-0.208-1.414-0.585l-9.001-9.001c-0.377-0.376-0.585-0.878-0.585-1.414s0.208-1.038 0.586-1.415l11.013-10.598c0.565-0.567 1.581-0.987 2.401-0.987h8c1.103 0 2 0.897 2 2v8c0 0.819-0.421 1.834-1.001 2.414zM22 2h-8c-0.285 0-0.799 0.213-1.001 0.414l-11.014 10.6 9.015 8.986c0.002 0 0.002 0 0.003-0.001l10.568-10.985c0.216-0.216 0.429-0.73 0.429-1.014v-8zM17.999 9c-1.653 0-2.999-1.345-2.999-3s1.346-3 2.999-3c1.654 0 3.001 1.346 3.001 3s-1.347 3-3.001 3zM17.999 5c-0.55 0-0.999 0.448-0.999 1 0 0.551 0.449 1 0.999 1 0.552 0 1.001-0.449 1.001-1s-0.449-1-1.001-1z"
        }));
      },
      "laptop-1": function laptop1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M25.843 23.637c-0.206 0.231-0.502 0.363-0.812 0.363h-23.953c-0.31 0-0.605-0.132-0.812-0.363s-0.304-0.54-0.271-0.848l1.082-9.758v-11.94c0-0.603 0.488-1.091 1.089-1.091h21.776c0.601 0 1.089 0.488 1.089 1.091v11.941l1.082 9.757c0.035 0.308-0.064 0.616-0.271 0.848zM22.853 2.182h-19.598v9.818h19.598v-9.818zM22.968 14.182h-19.827l-0.847 7.636h21.52l-0.847-7.636zM6.521 20.727h-2.177v-2.182h2.177v2.182zM5.433 15.273h2.177v2.182h-2.177v-2.182zM18.499 20.727h-10.888v-2.182h10.888v2.182zM21.765 20.727h-2.177v-2.182h2.177v2.182zM18.499 15.273h2.177v2.182h-2.177v-2.182zM15.232 15.273h2.177v2.182h-2.177v-2.182zM11.965 15.273h2.179v2.182h-2.179v-2.182zM8.699 15.273h2.177v2.182h-2.177v-2.182z"
        }));
      },
      "phone-message-1": function phoneMessage1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "23" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 23 24"
        }, i.a.createElement("path", {
          d: "M16 16.992c-0.205 0-0.494 0.002-0.736 0.004-0.896 0.885-2.167 1.024-2.874 1.024-0.296 0-0.493-0.025-0.521-0.028-0.386-0.051-0.707-0.321-0.823-0.692-0.116-0.372-0.007-0.777 0.28-1.039 0 0 0.218-0.227 0.357-0.56-1.733-1.081-2.683-2.552-2.683-4.205 0-3.031 3.141-5.496 7-5.496s7 2.465 7 5.496c0 3.031-3.141 5.496-7 5.496zM16 8c-2.71 0-5 1.601-5 3.496 0 1.436 1.412 2.372 2.254 2.802 0.044 0.022 0.072 0.061 0.111 0.088 0.059 0.042 0.118 0.079 0.166 0.132 0.043 0.048 0.072 0.102 0.105 0.156 0.034 0.055 0.070 0.107 0.093 0.169 0.025 0.066 0.031 0.134 0.041 0.204 0.007 0.048 0.029 0.091 0.029 0.141 0 0.021-0.004 0.039-0.004 0.059-0.001 0.009-0.002 0.018-0.002 0.027-0.004 0.13-0.010 0.259-0.027 0.38 0.080-0.063 0.152-0.138 0.212-0.224 0.192-0.276 0.499-0.409 0.812-0.412v-0.018c0 0 0.782-0.008 1.21-0.008 2.71 0 5-1.601 5-3.496s-2.29-3.496-5-3.496zM8 21h-2v-2.002h2v2.002zM5 4c0-0.552 0.447-1 1-1h2c0.553 0 1 0.448 1 1s-0.447 1-1 1h-2c-0.553 0-1-0.448-1-1zM13 5c-0.553 0-1-0.448-1-1v-1.533c0-0.253-0.214-0.467-0.467-0.467h-9.066c-0.253 0-0.467 0.214-0.467 0.467v19.066c0 0.253 0.214 0.467 0.467 0.467h9.066c0.253 0 0.467-0.214 0.467-0.467v-1.533c0-0.552 0.447-1 1-1s1 0.448 1 1v1.533c0 1.361-1.106 2.467-2.467 2.467h-9.066c-1.361 0-2.467-1.106-2.467-2.467v-19.066c0-1.36 1.106-2.467 2.467-2.467h9.066c1.361 0 2.467 1.107 2.467 2.467v1.533c0 0.552-0.447 1-1 1z"
        }));
      },
      "message-1": function message1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M4.364 24c-0.412 0-0.791-0.233-0.975-0.604-0.19-0.38-0.141-0.835 0.122-1.166 0.017-0.023 1.568-1.995 1.875-4.059-2.717-1.36-5.386-4.234-5.386-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406h-1.565c-2.135 3.104-6.919 3.267-7.133 3.273-0.009 0-0.019 0-0.028 0zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.212 4.751 6.154 0.415 0.166 0.686 0.567 0.686 1.013 0 1.448-0.515 2.864-1.069 3.967 1.26-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139z"
        }));
      },
      "message-1-write": function message1Write(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M13.091 20.727h-1.565c-2.135 3.104-6.919 3.267-7.133 3.273-0.009 0-0.019 0-0.028 0-0.412 0-0.791-0.233-0.975-0.604-0.19-0.38-0.141-0.835 0.122-1.167 0.017-0.022 1.568-1.993 1.874-4.058-2.716-1.359-5.385-4.234-5.385-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.213 4.751 6.155 0.415 0.165 0.686 0.567 0.686 1.013 0 1.448-0.515 2.863-1.069 3.965 1.261-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM16.364 9.818h2.182v2.182h-2.182v-2.182zM12 9.818h2.182v2.182h-2.182v-2.182zM7.636 9.818h2.182v2.182h-2.182v-2.182z"
        }));
      },
      "message-1-heart": function message1Heart(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M13.091 20.727h-1.567c-2.134 3.104-6.917 3.267-7.132 3.273-0.009 0-0.019 0-0.028 0-0.412 0-0.791-0.233-0.976-0.604-0.189-0.38-0.14-0.835 0.123-1.167 0.017-0.022 1.568-1.993 1.875-4.058-2.717-1.359-5.386-4.234-5.386-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.213 4.751 6.155 0.415 0.165 0.686 0.567 0.686 1.013 0 1.448-0.515 2.863-1.069 3.965 1.261-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM18.416 12c-0.007 0.007-0.010 0.015-0.016 0.022l-4.584 4.067c-0.059 0.052-0.129 0.080-0.194 0.117-0.041 0.023-0.076 0.055-0.12 0.072-0.132 0.055-0.269 0.086-0.409 0.086-0.001 0-0.001 0-0.001 0s0 0 0 0c-0.141 0-0.278-0.032-0.41-0.086-0.044-0.017-0.079-0.049-0.12-0.072-0.065-0.037-0.135-0.064-0.194-0.117l-4.584-4.067c-0.007-0.007-0.010-0.015-0.016-0.022-0.008-0.008-0.019-0.010-0.026-0.017-0.747-0.74-1.195-1.765-1.195-2.746 0-2.086 1.713-3.782 3.818-3.782 1.058 0 2.021 0.428 2.727 1.115 0.706-0.687 1.669-1.115 2.727-1.115 2.105 0 3.818 1.696 3.818 3.782 0 0.981-0.447 2.006-1.195 2.746-0.008 0.008-0.019 0.010-0.026 0.017zM15.818 7.636c-0.802 0-1.513 0.557-1.656 1.298-0.001 0.003-0.003 0.005-0.004 0.009-0.019 0.093-0.063 0.173-0.105 0.257-0.085 0.173-0.199 0.327-0.355 0.432-0.008 0.005-0.019 0.007-0.026 0.012-0.111 0.070-0.235 0.123-0.367 0.149-0.003 0.001-0.005 0.003-0.009 0.004-0.070 0.013-0.135-0.002-0.204-0.002-0.070 0-0.137 0.015-0.208 0.002-0.003-0.001-0.007-0.003-0.009-0.004-0.123-0.024-0.236-0.076-0.341-0.14-0.016-0.010-0.037-0.012-0.052-0.022-0.107-0.072-0.197-0.167-0.274-0.274-0.005-0.008-0.015-0.012-0.021-0.021-0.027-0.040-0.036-0.092-0.058-0.136-0.041-0.084-0.087-0.166-0.106-0.259-0.001-0.003-0.003-0.005-0.004-0.009-0.143-0.741-0.854-1.298-1.656-1.298-0.902 0-1.636 0.718-1.636 1.6 0 0.396 0.214 0.862 0.543 1.188l3.82 3.389 3.82-3.389c0.329-0.326 0.543-0.792 0.543-1.188 0-0.883-0.734-1.6-1.636-1.6z"
        }));
      },
      "message-1-ask": function message1Ask(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M13.091 20.727h-1.565c-2.135 3.104-6.919 3.267-7.133 3.273-0.009 0-0.019 0-0.028 0-0.412 0-0.791-0.233-0.975-0.604-0.19-0.38-0.141-0.835 0.122-1.167 0.017-0.022 1.568-1.994 1.874-4.058-2.716-1.36-5.385-4.234-5.385-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.212 4.751 6.154 0.415 0.166 0.686 0.567 0.686 1.013 0 1.448-0.515 2.864-1.069 3.967 1.261-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM14.182 11.799v0.201c0 0.122-0.028 0.235-0.070 0.341-0.053 0.159-0.131 0.311-0.247 0.433-0.053 0.050-0.123 0.080-0.185 0.12v0c-0.081 0.051-0.159 0.097-0.25 0.128-0.106 0.041-0.218 0.069-0.339 0.069s-0.233-0.027-0.339-0.069c-0.16-0.053-0.312-0.131-0.435-0.248-0.116-0.122-0.193-0.274-0.248-0.434-0.040-0.106-0.069-0.218-0.069-0.34v-1.091c0-0.602 0.489-1.091 1.091-1.091 0.601 0 1.091-0.49 1.091-1.091s-0.49-1.091-1.091-1.091c-0.601 0-1.091 0.49-1.091 1.091 0 0.602-0.489 1.091-1.091 1.091s-1.091-0.489-1.091-1.091c0-1.804 1.468-3.273 3.273-3.273s3.273 1.468 3.273 3.273c0 1.42-0.915 2.62-2.182 3.072zM13.865 14.498c0.196 0.207 0.316 0.491 0.316 0.775s-0.12 0.567-0.316 0.775c-0.207 0.196-0.491 0.316-0.775 0.316s-0.567-0.12-0.775-0.316c-0.196-0.207-0.316-0.491-0.316-0.775s0.12-0.567 0.316-0.775c0.415-0.404 1.145-0.404 1.549 0z"
        }));
      },
      "message-1-alert": function message1Alert(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M13.091 20.727h-1.567c-2.134 3.104-6.917 3.267-7.132 3.273-0.009 0-0.019 0-0.028 0-0.412 0-0.791-0.233-0.976-0.604-0.189-0.38-0.14-0.835 0.123-1.167 0.017-0.022 1.568-1.993 1.875-4.058-2.717-1.359-5.386-4.234-5.386-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.213 4.751 6.155 0.415 0.165 0.686 0.567 0.686 1.013 0 1.448-0.515 2.863-1.069 3.965 1.261-0.346 2.719-1.018 3.389-2.319 0.188-0.362 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM13.091 15.273c-0.284 0-0.567-0.12-0.775-0.316-0.196-0.207-0.316-0.491-0.316-0.775s0.12-0.567 0.316-0.775c0.404-0.404 1.135-0.404 1.549 0 0.196 0.207 0.316 0.491 0.316 0.775s-0.12 0.567-0.316 0.775c-0.207 0.196-0.491 0.316-0.775 0.316zM13.091 12c-0.602 0-1.091-0.489-1.091-1.091v-4.364c0-0.602 0.489-1.091 1.091-1.091s1.091 0.489 1.091 1.091v4.364c0 0.602-0.489 1.091-1.091 1.091z"
        }));
      },
      "comment-1": function comment1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M13.091 20.727h-1.567c-2.134 3.103-6.917 3.266-7.132 3.272-0.009 0.001-0.019 0.001-0.028 0.001-0.412 0-0.791-0.233-0.975-0.604-0.19-0.38-0.141-0.835 0.122-1.166 0.017-0.022 1.568-1.995 1.874-4.059-2.716-1.36-5.385-4.235-5.385-7.849 0-5.691 5.872-10.321 13.091-10.321s13.091 4.63 13.091 10.321c0 5.738-5.872 10.406-13.091 10.406zM13.091 2.182c-6.015 0-10.909 3.651-10.909 8.139 0 2.796 2.39 5.212 4.751 6.155 0.415 0.165 0.686 0.566 0.686 1.012 0 1.448-0.515 2.864-1.069 3.968 1.26-0.347 2.719-1.019 3.389-2.32 0.188-0.363 0.562-0.59 0.97-0.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139zM18.545 9.818h-10.909c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091h10.909c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091zM7.636 10.909h7.636c0.602 0 1.091 0.489 1.091 1.091s-0.489 1.091-1.091 1.091h-7.636c-0.602 0-1.091-0.489-1.091-1.091s0.489-1.091 1.091-1.091z"
        }));
      },
      "comments-1": function comments1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M22.365 19.653c0.274 1.62 1.152 2.324 1.193 2.355 0.35 0.268 0.513 0.728 0.397 1.154-0.115 0.425-0.469 0.746-0.908 0.802-0.037 0.005-0.276 0.034-0.648 0.034-1.121 0-3.452-0.278-5.21-2.205h-1.373c-1.975 0-3.842-0.418-5.401-1.208-0.537-0.272-0.752-0.928-0.479-1.465 0.272-0.536 0.929-0.751 1.467-0.479 1.253 0.636 2.781 0.972 4.415 0.972h1.853c0.025 0 0.047 0.013 0.071 0.015 0.075 0.004 0.145 0.023 0.217 0.044 0.067 0.019 0.131 0.034 0.192 0.064 0.060 0.029 0.11 0.071 0.165 0.111 0.061 0.046 0.119 0.091 0.169 0.148 0.016 0.017 0.038 0.026 0.053 0.047 0.616 0.805 1.39 1.252 2.105 1.496-0.255-0.609-0.448-1.357-0.515-2.24-0.002-0.014-0.004-0.026-0.005-0.040-0.002-0.024-0.009-0.043-0.011-0.068-0.002-0.052 0.017-0.098 0.021-0.148 0.007-0.079 0.010-0.155 0.033-0.229 0.020-0.068 0.053-0.124 0.086-0.185 0.032-0.063 0.061-0.124 0.106-0.18 0.048-0.060 0.108-0.106 0.168-0.154 0.040-0.033 0.067-0.076 0.112-0.104 1.255-0.757 3.361-2.427 3.361-5.116 0-1.317-0.721-2.774-1.714-3.465-0.494-0.345-0.616-1.023-0.273-1.517s1.023-0.616 1.519-0.272c1.585 1.102 2.65 3.214 2.65 5.254 0 2.54-1.391 4.898-3.817 6.578zM10.364 17.434h-1.371c-1.76 1.925-4.089 2.205-5.21 2.205-0.372 0-0.611-0.028-0.648-0.034-0.445-0.057-0.809-0.38-0.92-0.814-0.109-0.434 0.058-0.891 0.422-1.152 0.029-0.023 0.907-0.725 1.178-2.345-2.425-1.68-3.815-4.039-3.815-6.578 0-4.808 4.649-8.72 10.364-8.72s10.364 3.912 10.364 8.72c0 4.808-4.649 8.719-10.364 8.719zM10.364 2.175c-4.512 0-8.182 2.933-8.182 6.54 0 2.689 2.104 4.359 3.359 5.116 0.045 0.027 0.071 0.070 0.11 0.101 0.061 0.049 0.121 0.095 0.17 0.156 0.045 0.055 0.073 0.116 0.106 0.178 0.032 0.062 0.067 0.119 0.086 0.187 0.023 0.075 0.026 0.151 0.033 0.229 0.003 0.050 0.023 0.096 0.020 0.147-0.001 0.025-0.008 0.044-0.010 0.069-0.001 0.014-0.003 0.027-0.005 0.043-0.065 0.881-0.26 1.631-0.514 2.239 0.716-0.243 1.489-0.689 2.107-1.497 0.015-0.020 0.037-0.028 0.053-0.046 0.050-0.059 0.109-0.104 0.17-0.149 0.055-0.040 0.105-0.082 0.165-0.11 0.060-0.031 0.124-0.046 0.191-0.064 0.073-0.021 0.143-0.039 0.218-0.045 0.024-0.001 0.045-0.014 0.070-0.014h1.856c4.51 0 8.18-2.933 8.18-6.539 0-3.607-3.67-6.54-8.182-6.54zM14.042 8.727h-6.545c-0.602 0-1.091-0.489-1.091-1.090 0-0.602 0.489-1.090 1.091-1.090h6.545c0.602 0 1.091 0.488 1.091 1.090 0 0.601-0.489 1.090-1.091 1.090zM7.497 9.817h4.364c0.602 0 1.091 0.489 1.091 1.090 0 0.602-0.489 1.090-1.091 1.090h-4.364c-0.602 0-1.091-0.488-1.091-1.090 0-0.601 0.489-1.090 1.091-1.090z"
        }));
      },
      "chat-1": function chat1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "26" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 26 24"
        }, i.a.createElement("path", {
          d: "M22.365 19.653c0.274 1.62 1.152 2.324 1.193 2.354 0.351 0.269 0.512 0.729 0.397 1.155-0.116 0.425-0.469 0.746-0.908 0.802-0.037 0.005-0.275 0.034-0.648 0.034-1.121 0-3.452-0.278-5.21-2.205h-1.373c-1.975 0-3.842-0.418-5.401-1.208-0.537-0.272-0.752-0.928-0.479-1.465 0.273-0.536 0.929-0.751 1.467-0.479 1.253 0.636 2.78 0.972 4.415 0.972h1.853c0.025 0 0.046 0.013 0.071 0.014 0.075 0.005 0.145 0.024 0.219 0.045 0.065 0.019 0.129 0.034 0.189 0.063 0.060 0.031 0.112 0.072 0.167 0.112 0.060 0.046 0.118 0.091 0.168 0.147 0.016 0.019 0.038 0.027 0.053 0.048 0.616 0.805 1.389 1.252 2.105 1.495-0.255-0.608-0.448-1.356-0.515-2.237-0.002-0.014-0.004-0.028-0.005-0.043-0.002-0.024-0.009-0.043-0.010-0.068-0.003-0.051 0.016-0.098 0.020-0.148 0.007-0.077 0.010-0.154 0.033-0.228 0.020-0.068 0.053-0.125 0.086-0.188 0.033-0.061 0.061-0.122 0.106-0.178 0.048-0.061 0.109-0.107 0.17-0.156 0.039-0.032 0.065-0.074 0.11-0.101 1.255-0.757 3.361-2.427 3.361-5.116 0-1.317-0.721-2.774-1.714-3.465-0.494-0.345-0.616-1.023-0.273-1.517s1.024-0.615 1.519-0.272c1.585 1.102 2.65 3.214 2.65 5.254 0 2.54-1.391 4.898-3.817 6.578zM10.364 17.434h-1.372c-1.759 1.925-4.088 2.205-5.209 2.205-0.373 0-0.611-0.028-0.648-0.034-0.445-0.057-0.809-0.38-0.92-0.814-0.109-0.434 0.058-0.891 0.422-1.152 0.029-0.024 0.907-0.725 1.179-2.347-2.426-1.679-3.816-4.037-3.816-6.577 0-4.808 4.649-8.72 10.364-8.72s10.364 3.912 10.364 8.72c0 4.808-4.649 8.719-10.364 8.719zM10.364 2.175c-4.512 0-8.182 2.933-8.182 6.54 0 2.689 2.104 4.359 3.359 5.116 0.045 0.027 0.071 0.070 0.11 0.101 0.061 0.049 0.121 0.095 0.17 0.156 0.045 0.055 0.073 0.116 0.106 0.178 0.032 0.062 0.067 0.119 0.086 0.187 0.023 0.075 0.026 0.151 0.033 0.229 0.003 0.050 0.023 0.096 0.021 0.147-0.002 0.025-0.009 0.044-0.011 0.069-0.001 0.014-0.003 0.027-0.005 0.041-0.065 0.883-0.26 1.632-0.514 2.24 0.716-0.243 1.489-0.689 2.107-1.497 0.015-0.020 0.037-0.028 0.053-0.046 0.050-0.058 0.108-0.104 0.17-0.149 0.053-0.040 0.105-0.082 0.165-0.111s0.123-0.045 0.19-0.063c0.073-0.021 0.143-0.039 0.219-0.045 0.024-0.001 0.045-0.014 0.070-0.014h1.856c4.51 0 8.18-2.933 8.18-6.539 0-3.607-3.67-6.54-8.182-6.54z"
        }));
      },
      "megaphone-2": function megaphone2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "29" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 29 24"
        }, i.a.createElement("path", {
          d: "M28.887 10.776c0 2.649-2.159 4.804-4.814 4.804v4.806c0 0.427-0.229 0.823-0.599 1.038-0.187 0.11-0.396 0.162-0.604 0.162-0.206 0-0.412-0.053-0.597-0.158l-8.147-4.646h-6.903v6.005c0 0.664-0.539 1.201-1.204 1.201s-1.204-0.537-1.204-1.201v-6.005h-2.407c-1.328 0-2.407-1.077-2.407-2.402v-7.207c0-1.324 1.080-2.402 2.407-2.402h11.717l8.147-4.646c0.371-0.213 0.828-0.212 1.201 0.004 0.371 0.215 0.599 0.611 0.599 1.039v4.805c2.655 0.001 4.814 2.156 4.814 4.805zM4.814 7.172h-2.407v7.207h2.407v-7.207zM21.665 3.237l-6.625 3.777c-0.202 0.117-0.422 0.146-0.639 0.137-0.037 0.004-0.069 0.022-0.106 0.022-0.001 0-0.001 0-0.002 0h-7.071v7.207h7.222c0.024 0 0.045 0.012 0.069 0.013 0.081 0.005 0.156 0.026 0.235 0.048 0.079 0.020 0.156 0.040 0.227 0.075 0.022 0.011 0.046 0.010 0.066 0.022l6.625 3.778v-15.079zM24.072 8.374v4.805c1.328-0.001 2.407-1.078 2.407-2.402 0-1.325-1.080-2.401-2.407-2.402z"
        }));
      },
      email: function email(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "32" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 32 24"
        }, i.a.createElement("path", {
          d: "M28 24h-24c-2.205 0-4-1.795-4-4v-16c0-2.205 1.795-4 4-4h24c2.205 0 4 1.795 4 4v16c0 2.205-1.795 4-4 4zM4 21.333h24c0.735 0 1.333-0.599 1.333-1.333v-15.729l-12.496 10.1c-0.244 0.197-0.54 0.296-0.837 0.296s-0.593-0.099-0.837-0.296l-12.496-10.1v15.729c0 0.735 0.599 1.333 1.333 1.333zM27.076 2.667h-22.152l11.076 8.953 11.076-8.953z"
        }));
      },
      "inbox-empty": function inboxEmpty(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "29" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 29 24"
        }, i.a.createElement("path", {
          d: "M26.222 24h-23.824c-1.314 0-2.382-1.076-2.382-2.4v-9.6c0-0.046 0.020-0.085 0.025-0.13s-0.007-0.086 0.002-0.131l2.383-10.8c0.12-0.548 0.604-0.94 1.163-0.94h21.44c0.559 0 1.042 0.391 1.163 0.94l2.383 10.8c0.010 0.044-0.002 0.086 0.002 0.131s0.025 0.084 0.025 0.13v9.6c0 1.324-1.068 2.4-2.382 2.4zM24.076 2.4h-19.53l-1.853 8.4h6.853c0.658 0 1.19 0.538 1.19 1.2 0 1.985 1.603 3.6 3.574 3.6 1.972 0 3.574-1.615 3.574-3.6 0-0.662 0.534-1.2 1.192-1.2h6.853l-1.853-8.4zM26.363 13.2h-6.217c-0.553 2.735-2.959 4.8-5.836 4.8-2.875 0-5.281-2.065-5.834-4.8h-6.113v8.4h24v-8.4z"
        }));
      },
      "inbox-full": function inboxFull(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M21.799 24h-19.81c-1.093 0-1.981-0.897-1.981-2v-8c0-0.096 0.029-0.182 0.054-0.27-0.052-0.187-0.068-0.387-0.001-0.585l2.178-6.467c0.117-0.347 0.409-0.571 0.741-0.641v-2.037c0-0.552 0.443-1 0.99-1h15.848c0.547 0 0.991 0.448 0.991 1v2.038c0.33 0.070 0.621 0.293 0.738 0.64l2.181 6.467c0.041 0.121 0.052 0.245 0.047 0.366 0.111 0.147 0.194 0.308 0.194 0.489v8c0 1.103-1.077 2-2.17 2zM2.98 10.691l-0.778 2.309h0.778v-2.309zM18.828 5h-13.867v8h2.971c0.547 0 0.991 0.448 0.991 1 0 1.655 1.332 3 2.969 3 1.64 0 2.974-1.345 2.974-3 0-0.552 0.443-1 0.99-1h2.972v-8zM20.809 10.695v2.305h0.777l-0.777-2.305zM21.969 15h-5.222c-0.461 2.279-2.462 4-4.855 4-2.39 0-4.39-1.721-4.85-4h-5.053v7h19.98v-7zM17.837 2h-11.886c-0.547 0-0.99-0.448-0.99-1s0.443-1 0.99-1h11.886c0.547 0 0.991 0.448 0.991 1s-0.444 1-0.991 1z"
        }));
      },
      "email-send": function emailSend(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "36" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 36 24"
        }, i.a.createElement("path", {
          d: "M36.029 4.008l-2.007 16.342c-0.217 2.025-1.971 3.629-3.991 3.629h-19.521c-0.83 0-1.503-0.67-1.503-1.495 0-0.827 0.703-1.36 1.533-1.36h19.573c0.471 0 0.869-0.602 0.923-1.114l1.822-14.819-12.336 10.928c-0.276 0.245-0.631 0.379-0.998 0.379-0.030 0-0.059-0.002-0.089-0.005-0.398-0.023-0.769-0.202-1.034-0.498l-12.021-13.465c-0.051-0.057-0.071-0.129-0.111-0.193-0.059-0.089-0.122-0.172-0.16-0.274-0.039-0.102-0.048-0.206-0.065-0.313-0.011-0.074-0.044-0.139-0.044-0.215 0-0.015 0.009-0.027 0.009-0.042 0.003-0.111 0.038-0.214 0.065-0.321 0.023-0.084 0.029-0.17 0.065-0.247 0.035-0.077 0.095-0.14 0.143-0.212 0.062-0.090 0.116-0.185 0.196-0.26 0.012-0.011 0.017-0.026 0.027-0.035 0.057-0.051 0.129-0.071 0.191-0.111 0.090-0.059 0.175-0.122 0.277-0.16 0.102-0.039 0.208-0.048 0.316-0.065 0.072-0.011 0.139-0.042 0.214-0.042h24.78c1.083 0 2.121 0.464 2.852 1.272 0.684 0.756 1.001 1.713 0.894 2.695zM10.85 3.032l8.798 9.857 11.125-9.857h-19.923zM10.509 9.017c0 0.827-0.673 1.497-1.503 1.497h-4.506c-0.83 0-1.503-0.67-1.503-1.497s0.673-1.497 1.503-1.497h4.506c0.83 0 1.503 0.67 1.503 1.497zM12.012 13.506c0 0.827-0.673 1.497-1.503 1.497h-9.014c-0.83 0-1.503-0.67-1.503-1.497s0.673-1.497 1.503-1.497h9.014c0.83 0 1.503 0.67 1.503 1.497zM6.002 16.499h7.513c0.83 0 1.501 0.669 1.501 1.495s-0.672 1.497-1.501 1.497h-7.513c-0.83 0-1.501-0.67-1.501-1.497s0.672-1.495 1.501-1.495z"
        }));
      },
      "email-2-at": function email2At(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M20.806 24h-17.828c-1.639 0-2.972-1.345-2.972-3v-10c0-0.008 0.004-0.015 0.005-0.023 0.002-0.077 0.026-0.149 0.045-0.223 0.005-0.028 0.007-0.056 0.016-0.083 0.002-0.005 0.005-0.008 0.007-0.013 0.023-0.063 0.055-0.12 0.091-0.178 0.020-0.036 0.030-0.075 0.056-0.108 0.011-0.014 0.028-0.020 0.040-0.033 0.005-0.006 0.013-0.010 0.018-0.016 0.019-0.019 0.026-0.045 0.046-0.063l3.245-2.978c0.405-0.372 1.031-0.342 1.399 0.067 0.368 0.408 0.338 1.041-0.067 1.412l-2.389 2.193 5.675 4.622 2.685-2.22c0.582-0.472 1.447-0.471 2.020-0.008l2.693 2.228 5.674-4.621-2.368-2.174c-0.405-0.371-0.435-1.004-0.068-1.412 0.369-0.409 0.995-0.439 1.399-0.068l3.225 2.959c0.020 0.018 0.028 0.043 0.045 0.062 0.007 0.006 0.014 0.010 0.020 0.017 0.012 0.013 0.029 0.019 0.040 0.033 0.027 0.034 0.036 0.073 0.057 0.109 0.035 0.058 0.067 0.114 0.090 0.176 0.002 0.005 0.005 0.009 0.007 0.014 0.010 0.029 0.012 0.058 0.018 0.088 0.018 0.072 0.041 0.143 0.043 0.217 0.001 0.008 0.005 0.016 0.005 0.024v10c0 1.655-1.333 3-2.972 3zM1.938 13.051v7.697l4.69-3.878-4.69-3.819zM11.892 15.102l-8.342 6.898h16.684l-8.342-6.898zM21.938 12.977l-4.781 3.893 4.781 3.954v-7.847zM14.171 9.975c-0.586-0.235-0.994-0.664-1.177-1.194-0.341 0.138-0.712 0.219-1.102 0.219-1.638 0-2.971-1.346-2.971-3s1.333-3 2.971-3c0.9 0 1.697 0.414 2.243 1.053 0.417 0.118 0.728 0.488 0.728 0.947v3.144c0.071 0.031 0.442 0.043 0.548-0.047 0.467-0.501 0.451-1.194 0.438-1.805l-0.005-0.292c0-2.206-1.775-4-3.956-4-2.182 0-3.958 1.794-3.958 4 0 2.205 1.776 4 3.958 4 0.547 0 0.991 0.448 0.991 1s-0.444 1-0.991 1c-3.274 0-5.939-2.691-5.939-6 0-3.308 2.665-6 5.939-6s5.937 2.692 5.937 6l0.004 0.247c0.018 0.794 0.048 2.123-0.979 3.224-0.621 0.665-1.747 0.876-2.679 0.504zM11.892 5c-0.546 0-0.99 0.449-0.99 1s0.444 1 0.99 1c0.546 0 0.991-0.449 0.991-1s-0.445-1-0.991-1z"
        }));
      },
      answer: function answer(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M18.688 24c-2.537 0-7.166-2.973-11.518-7.398-2.515-2.554-4.599-5.249-5.868-7.587-1.495-2.753-1.709-4.701-0.638-5.789l3.273-2.961c0.197-0.177 0.456-0.266 0.717-0.25 0.263 0.018 0.508 0.141 0.68 0.343l4.263 4.997c0.261 0.305 0.315 0.74 0.137 1.101l-1.65 3.354 5.883 5.976 3.301-1.676c0.355-0.18 0.781-0.127 1.082 0.137l4.918 4.308c0.199 0.174 0.321 0.421 0.339 0.688 0.019 0.266-0.069 0.528-0.242 0.729l-2.851 3.295c-0.363 0.371-0.911 0.733-1.826 0.733zM2.084 4.612c-0.163 0.234-0.28 1.189 0.941 3.438 1.182 2.178 3.148 4.714 5.537 7.14 4.351 4.424 8.465 6.811 10.126 6.811 0.216 0 0.336-0.043 0.372-0.080l2.172-2.511-3.67-3.214-3.349 1.701c-0.38 0.192-0.837 0.116-1.136-0.188l-6.885-6.996c-0.3-0.303-0.374-0.768-0.185-1.153l1.673-3.4-3.181-3.728-2.415 2.18z"
        }));
      },
      "next-4": function next4(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "36" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 36 24"
        }, i.a.createElement("path", {
          d: "M35.77 17.073c-0.075 0.184-0.184 0.349-0.322 0.487l-5.977 6c-0.291 0.293-0.674 0.439-1.056 0.439s-0.765-0.147-1.056-0.439c-0.583-0.585-0.583-1.536 0-2.121l3.426-3.439h-21.797c-4.944 0-8.967-4.038-8.967-9v-7.5c0-0.828 0.669-1.5 1.495-1.5 0.825 0 1.494 0.672 1.494 1.5v7.5c0 3.309 2.681 6 5.978 6h21.797l-3.426-3.44c-0.583-0.585-0.583-1.536 0-2.121 0.584-0.587 1.529-0.587 2.112 0l5.977 6c0.138 0.138 0.248 0.303 0.322 0.487 0.151 0.366 0.151 0.78 0 1.146z"
        }));
      },
      "arrow-2-left": function arrow2Left(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "41" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 41 24"
        }, i.a.createElement("path", {
          d: "M39.513 13.703h-33.667l7.379 7.362c0.673 0.669 0.673 1.756 0 2.426-0.335 0.335-0.775 0.502-1.215 0.502s-0.88-0.167-1.215-0.502l-10.314-10.29c0 0 0-0.002-0.002-0.002-0.157-0.157-0.283-0.345-0.369-0.554-0.174-0.421-0.174-0.894 0-1.313 0.086-0.209 0.212-0.397 0.369-0.554 0.002-0.002 0.002-0.002 0.002-0.002l10.314-10.29c0.671-0.669 1.758-0.669 2.429 0 0.673 0.669 0.673 1.756 0 2.426l-7.379 7.362h33.667c0.949 0 1.718 0.766 1.718 1.713s-0.77 1.715-1.718 1.715z"
        }));
      },
      "arrow-2-right": function arrow2Right(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "41" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 41 24"
        }, i.a.createElement("path", {
          d: "M41.145 11.332c0.174 0.419 0.174 0.892 0 1.313-0.086 0.209-0.21 0.397-0.369 0.554 0 0 0 0.002 0 0.002l-10.314 10.29c-0.336 0.335-0.775 0.502-1.215 0.502s-0.88-0.167-1.216-0.502c-0.671-0.669-0.671-1.756 0-2.426l7.379-7.362h-33.666c-0.951 0-1.72-0.768-1.72-1.715s0.77-1.713 1.72-1.713h33.666l-7.379-7.362c-0.671-0.669-0.671-1.756 0-2.426s1.76-0.669 2.431 0l10.314 10.29c0 0 0 0 0 0.002 0.159 0.157 0.283 0.345 0.369 0.554z"
        }));
      },
      "arrow-1-square-left": function arrow1SquareLeft(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23 24h-22c-0.552 0-1-0.448-1-1v-22c0-0.552 0.448-1 1-1h22c0.552 0 1 0.448 1 1v22c0 0.552-0.448 1-1 1zM22 2h-20v20h20v-20zM13.293 7.293c0.391-0.391 1.023-0.391 1.414 0s0.391 1.024 0 1.414l-3.293 3.293 3.293 3.293c0.391 0.39 0.391 1.024 0 1.414-0.195 0.195-0.451 0.293-0.707 0.293s-0.512-0.098-0.707-0.293l-4-4c-0.391-0.39-0.391-1.024 0-1.414l4-4z"
        }));
      },
      "arrow-1-square-right": function arrow1SquareRight(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 24"
        }, i.a.createElement("path", {
          d: "M23 24h-22c-0.553 0-1-0.448-1-1v-22c0-0.552 0.447-1 1-1h22c0.553 0 1 0.448 1 1v22c0 0.552-0.447 1-1 1zM22 2h-20v20h20v-20zM9.293 7.293c0.391-0.391 1.023-0.391 1.414 0l4 4c0.391 0.39 0.391 1.024 0 1.414l-4 4c-0.195 0.195-0.451 0.293-0.707 0.293s-0.512-0.098-0.707-0.293c-0.391-0.39-0.391-1.024 0-1.414l3.293-3.293-3.293-3.293c-0.391-0.39-0.391-1.023 0-1.414z"
        }));
      },
      "arrow-1-left": function arrow1Left(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 14 24"
        }, i.a.createElement("path", {
          d: "M12.967 24c-0.241 0-0.482-0.086-0.674-0.263l-11.962-10.994c-0.206-0.189-0.324-0.457-0.324-0.737s0.118-0.547 0.324-0.737l11.962-10.994c0.407-0.373 1.038-0.345 1.409 0.061s0.344 1.039-0.061 1.412l-11.161 10.257 11.161 10.258c0.406 0.372 0.433 1.005 0.061 1.412-0.197 0.215-0.466 0.323-0.736 0.323z"
        }));
      },
      "arrow-1-right": function arrow1Right(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 14 24"
        }, i.a.createElement("path", {
          d: "M1.021 24c-0.27 0-0.539-0.108-0.736-0.323-0.371-0.407-0.344-1.040 0.061-1.412l11.162-10.258-11.162-10.257c-0.406-0.373-0.433-1.006-0.061-1.412s1.004-0.435 1.409-0.061l11.963 10.994c0.206 0.19 0.323 0.458 0.323 0.737 0 0.28-0.117 0.548-0.323 0.737l-11.963 10.995c-0.192 0.176-0.433 0.262-0.674 0.262z"
        }));
      },
      "chevron-down": function chevronDown(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "20" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 20 20"
        }, i.a.createElement("path", {
          d: "M0 6c0-0.128 0.049-0.256 0.146-0.354 0.195-0.195 0.512-0.195 0.707 0l8.646 8.646 8.646-8.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-9 9c-0.195 0.195-0.512 0.195-0.707 0l-9-9c-0.098-0.098-0.146-0.226-0.146-0.354z"
        }));
      },
      "chevron-up": function chevronUp(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "20" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          style: {
            transform: "rotate(180deg)"
          },
          viewBox: "0 0 20 20"
        }, i.a.createElement("path", {
          d: "M0 6c0-0.128 0.049-0.256 0.146-0.354 0.195-0.195 0.512-0.195 0.707 0l8.646 8.646 8.646-8.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-9 9c-0.195 0.195-0.512 0.195-0.707 0l-9-9c-0.098-0.098-0.146-0.226-0.146-0.354z"
        }));
      },
      "drift-logo-round": function driftLogoRound(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "25" : n,
            a = e.height,
            o = void 0 === a ? "25" : a;
        return i.a.createElement("svg", {
          className: t,
          xmlns: "http://www.w3.org/2000/svg",
          width: r,
          height: o,
          viewBox: "0 0 338.6 402.31"
        }, i.a.createElement("path", {
          d: "M175.6.1a169.34,169.34,0,0,0-32,336.6,4,4,0,0,1,3.1,5.7l-25.2,51.9s-.6,1.3-1.1,2.3a4.1,4.1,0,0,0,5,5.5c52.7-16.3,213.2-99.8,213.2-234.9C338.6,77.6,265.1,3.3,175.6.1Zm66.1,84.1a10.59,10.59,0,0,1-1,1.2l-47.3,53.8a11,11,0,0,0-1.2,1.4c-1.7,2.4,0,5.4,3.3,5.5h19.3c3.2.3,4.8,3.2,3.1,5.6l-1.3,1.6-34.9,39.3c-.4.5-.8.9-1.2,1.5-1.5,2.4.2,5.1,3.4,5.3h12.6a4.36,4.36,0,0,1,4.1,2.3,3.25,3.25,0,0,1-1,4,11,11,0,0,1-1,.8l-80.7,60.9a15,15,0,0,1-1.5,1.2,2.44,2.44,0,0,1-2.6,0,1.76,1.76,0,0,1-.8-2c.2-.5.7-1.5.7-1.5l22.2-45.8.6-1.3c1.5-3,0-5.6-3.3-6H116.4a12.1,12.1,0,0,1-1.9-.1c-2.7-.4-4.2-2.7-3.2-5a15.48,15.48,0,0,1,.8-1.5l27.6-46.3s.3-.5.5-.8c1.5-2.7-.3-5.4-3.8-5.5H118.3c-2.3,0-4-1.2-4.4-3.1a4.23,4.23,0,0,1,.7-2.7l8.4-14.8,27.6-48.6.7-1.1a7.49,7.49,0,0,1,7-3.8h78.6a16.35,16.35,0,0,1,2.2.2C241.9,79.5,243.1,82.1,241.7,84.2Z"
        }));
      },
      "drift-logo-full": function driftLogoFull(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? 69 : n,
            a = e.height,
            o = void 0 === a ? 16 : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 720 168"
        }, i.a.createElement("path", {
          d: "M263.62,166.43,242,115.67H223.44v50.76H174.26V0h86.68c38,0,58.44,26,58.44,57.14,0,28.7-16.31,43.92-29.22,50.41l29.47,58.88Zm5.84-106.16c0-11.32-7.79-16.35-16.07-16.35H223.44v33h29.95C261.67,76.94,269.46,71.91,269.46,60.27Z"
        }), i.a.createElement("path", {
          d: "M447.17,166.43V0H570.84V43.92h-74.3V66.21h72.59v43.92H496.54v56.3Z"
        }), i.a.createElement("path", {
          d: "M0,166.43V0H73c51.47,0,89.7,29.94,89.7,83.09s-38.23,83.34-89.45,83.34ZM112.49,83.09c0-22.46-12.75-39.17-39.21-39.17H49.5v78.6H73C97.78,122.52,112.49,104.05,112.49,83.09Z"
        }), i.a.createElement("path", {
          d: "M627.08,166.43V43.92H583.31V0H720V43.92H676.47V166.43Z"
        }), i.a.createElement("path", {
          d: "M436.28.48a13.44,13.44,0,0,1,1.94.16c2.44.57,3.49,2.79,2.25,4.67a13.55,13.55,0,0,1-.88,1.06L398,53.64s-.77.82-1.08,1.26c-1.52,2.13,0,4.71,2.94,4.87.45,0,1.36,0,1.36,0H415.5s.91,0,1.36,0c2.79.29,4.23,2.85,2.76,4.9-.34.48-1.17,1.37-1.17,1.37l-30.66,34.56a12.74,12.74,0,0,0-1.05,1.28c-1.34,2.07.21,4.51,3,4.67.75,0,1.52,0,2.27,0a3.77,3.77,0,0,1,3.57,2,2.82,2.82,0,0,1-.88,3.49c-.27.25-.85.74-.85.74l-62.09,53.47s-.84.76-1.31,1.08a2.06,2.06,0,0,1-2.25,0,1.42,1.42,0,0,1-.67-1.74c.16-.45.61-1.33.61-1.33l19.54-40.27.57-1.17c1.31-2.63,0-4.88-2.91-5.24-.35,0-1.12,0-1.12,0l-13.64,0a14.29,14.29,0,0,1-1.66-.09c-2.41-.39-3.68-2.41-2.77-4.37.21-.44.73-1.29.73-1.29l24.25-40.65s.28-.46.41-.7c1.32-2.4-.28-4.7-3.34-4.79-1.26,0-3.79,0-3.79,0s-6.54,0-10.8,0h-1.33c-2.05,0-3.51-1.09-3.83-2.74a3.46,3.46,0,0,1,.64-2.37l7.38-13L360.7,4.85l.6-1c1.24-2.24,3.33-3.32,6.17-3.32h68.81Z"
        }));
      },
      contacts: function contacts(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "12" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 12"
        }, i.a.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("path", {
          stroke: "#B5D2E1",
          strokeWidth: ".15",
          d: "M14.97 8.866c-.154-1.48-1.566-2.673-3.205-2.673-.746 0-1.45.235-2.034.682-.24.182-.58.136-.764-.103-.183-.24-.136-.583.104-.765.375-.286.808-.51 1.282-.664-.906-.51-1.486-1.462-1.486-2.52 0-1.598 1.3-2.898 2.9-2.898 1.597 0 2.897 1.3 2.897 2.9 0 1.052-.575 2.002-1.476 2.512 1.693.572 2.888 2.103 2.888 3.796v.28c0 .3-.244.544-.546.544h-4.706c-.302 0-.546-.244-.546-.545 0-.3.244-.546.546-.546h4.146zm-1.398-6.042c0 .996-.81 1.807-1.807 1.807-.997 0-1.808-.81-1.808-1.806 0-.997.81-1.808 1.808-1.808.996 0 1.807.81 1.807 1.808zM6.24 6.29c1.9.624 3.247 2.33 3.247 4.22v.314c0 .3-.245.545-.546.545H.47c-.3 0-.545-.245-.545-.546v-.314c0-1.89 1.346-3.596 3.246-4.22-1.11-.57-1.833-1.718-1.833-2.996 0-1.858 1.51-3.37 3.37-3.37 1.857 0 3.368 1.512 3.368 3.37 0 1.278-.722 2.426-1.835 2.997zm2.146 3.988l.005.08.076-.08h-.08zm-7.36 0h-.08l.074.08.005-.08zm0 0c.135-1.73 1.77-3.144 3.68-3.144 1.91 0 3.545 1.413 3.68 3.144h-7.36zm3.68-9.262c-1.256 0-2.278 1.022-2.278 2.278S3.45 5.572 4.706 5.572 6.984 4.55 6.984 3.294 5.962 1.016 4.706 1.016z"
        })));
      },
      conversations: function conversations(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 16"
        }, i.a.createElement("path", {
          d: "M2.07 15.597c-.115-.253-.085-.556.075-.777.01-.016.958-1.33 1.146-2.707C1.63 11.207 0 9.29 0 6.88 0 3.088 3.59 0 8 0s8 3.087 8 6.88c0 3.826-3.59 6.938-8 6.938h-.957C5.74 15.888 2.815 15.996 2.683 16c-.268 0-.5-.156-.612-.403zM1.334 6.88c0 1.865 1.46 3.476 2.904 4.103.253.11.42.378.42.676 0 .964-.316 1.908-.654 2.643.77-.23 1.66-.678 2.07-1.546.116-.24.344-.393.594-.393H8c3.676 0 6.667-2.46 6.667-5.483 0-2.99-2.99-5.425-6.667-5.425-3.676 0-6.667 2.434-6.667 5.426z",
          fill: "#B5D2E1",
          fillRule: "evenodd"
        }));
      },
      dashboard: function dashboard(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "17" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 17"
        }, i.a.createElement("path", {
          d: "M15.334 9.912c-.18 0-.36-.077-.493-.23l-.173-.203v6.103c0 .78-.6 1.417-1.334 1.417h-2.667c-.367 0-.666-.318-.666-.71 0-.09.02-.175.048-.254v-4.72L6 11.33v4.96c0 .392-.3.71-.667.71H2.666c-.735 0-1.333-.636-1.333-1.417V9.48l-.175.202c-.25.29-.67.308-.942.043-.27-.263-.29-.712-.04-1L7.507.218c.253-.293.73-.293.983 0l7.334 8.504c.25.29.23.738-.04 1-.128.127-.29.188-.45.188zM8 1.748L2.666 7.933v7.65h2V11.33c0-.782.6-1.418 1.334-1.418h4c.735 0 1.333.636 1.333 1.418v4.253h2.077v-7.56L8 1.747z",
          fill: "#B5D2E1",
          fillRule: "evenodd"
        }));
      },
      liveView: function liveView(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 16"
        }, i.a.createElement("path", {
          d: "M14.987 11.9c-.135.24-.44.327-.68.192-.24-.134-.326-.438-.192-.68.58-1.036.887-2.216.887-3.412 0-3.86-3.14-7.002-7.002-7.002C4.14.998.998 4.138.998 8c0 3.86 3.14 7.002 7.002 7.002 1.25 0 2.474-.333 3.545-.962.238-.14.543-.06.682.176.14.238.06.544-.177.684C10.827 15.62 9.426 16 8 16c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8c0 1.366-.35 2.715-1.013 3.9zM8 12.046c.458 0 .907-.076 1.334-.225.264-.09.55.047.642.31.09.262-.047.55-.31.64-.534.188-1.095.283-1.666.283-2.786 0-5.053-2.267-5.053-5.053S5.214 2.947 8 2.947 13.053 5.214 13.053 8c0 .512-.078 1.02-.23 1.508-.083.266-.363.413-.63.33-.266-.082-.415-.365-.332-.63.123-.39.185-.797.185-1.208 0-2.23-1.814-4.045-4.045-4.045C5.77 3.955 3.955 5.77 3.955 8S5.77 12.045 8 12.045zm-.07-2.077c-1.122 0-2.035-.913-2.035-2.036 0-1.124.913-2.037 2.036-2.037 1.124 0 2.038.913 2.038 2.037 0 .378-.11.728-.29 1.03l4.51 4.512h1.307c.28 0 .505.226.505.505 0 .278-.226.504-.505.504h-1.01v1.01c0 .28-.227.506-.506.506-.28 0-.506-.226-.506-.505v-1.307l-4.51-4.51c-.305.18-.655.29-1.033.29zM9.264 8.21c0-.58-.472-1.052-1.053-1.052-.58 0-1.052.472-1.052 1.053 0 .58.472 1.053 1.052 1.053.097 0 .19-.017.278-.042l-.4-.4c-.203-.203-.203-.53 0-.733.2-.202.53-.202.732 0l.4.402c.026-.09.043-.183.043-.28z",
          fill: "#B5D2E1",
          fillRule: "evenodd"
        }));
      },
      overview: function overview(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "15" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 15"
        }, i.a.createElement("path", {
          d: "M15.334 8.182H6c-.368 0-.667-.305-.667-.682 0-.376.3-.682.667-.682h9.334c.367 0 .666.306.666.682 0 .377-.3.682-.666.682zm.006-5.5H5.962c-.368 0-.63-.26-.63-.636 0-.377.3-.683.668-.683h9.334c.367 0 .666.306.666.683 0 .376-.292.637-.66.637zM2 15c-1.102 0-2-.918-2-2.045 0-1.13.898-2.046 2-2.046 1.103 0 2 .916 2 2.045C4 14.082 3.103 15 2 15zm0-2.727c-.368 0-.666.305-.666.682 0 .376.298.68.666.68.368 0 .667-.304.667-.68 0-.377-.3-.682-.667-.682zm0-2.728c-1.102 0-2-.917-2-2.045s.898-2.046 2-2.046c1.103 0 2 .918 2 2.046 0 1.128-.897 2.045-2 2.045zm0-2.727c-.368 0-.666.306-.666.682 0 .376.298.682.666.682.368 0 .667-.306.667-.682 0-.376-.3-.682-.667-.682zm.398-3.686c-.11.15-.273.248-.455.272-.027.004-.055.005-.082.005-.153 0-.302-.055-.422-.156L.244 2.252c-.285-.24-.326-.67-.093-.96.236-.29.655-.333.94-.094l.65.546L2.798.277c.218-.302.636-.368.932-.144.295.223.36.65.14.953L2.398 3.132zM6 12.272h9.334c.367 0 .666.306.666.683 0 .376-.3.68-.666.68H6c-.368 0-.667-.304-.667-.68 0-.377.3-.682.667-.682z",
          fill: "#B5D2E1",
          fillRule: "evenodd"
        }));
      },
      sync: function sync(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "14" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 14"
        }, ">", i.a.createElement("defs", null), i.a.createElement("g", {
          id: "admin",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "salesforce-sync",
          fill: "#394F5A"
        }, i.a.createElement("path", {
          d: "M12.064,11.961 C11.788,11.9885 11.54,11.801 11.506,11.5265 C11.4715,11.253 11.666,11.003 11.9395,10.969 C13.6845,10.75 15,9.259 15,7.5 C15,5.5705 13.43,4 11.5,4 C11.434,4 11.368,4.004 11.3025,4.011 C11.072,4.044 10.851,3.9005 10.773,3.6805 C10.211,2.077 8.695,1 7,1 C4.7945,1 3,2.7945 3,5 C3,5.184 3.016,5.372 3.049,5.5745 C3.089,5.8175 2.946,6.053 2.7125,6.13 C1.688,6.468 1,7.42 1,8.5 C1,9.8785 2.1215,11 3.5,11 L4.002,11 C4.278,11 4.502,11.2235 4.502,11.5 C4.502,11.7765 4.278,12 4.002,12 L3.5,12 C1.57,12 0,10.4295 0,8.5 C0,7.128 0.794,5.9025 2.013,5.3335 C2.0045,5.2215 2,5.1105 2,5 C2,2.243 4.243,0 7,0 C8.9935,0 10.7895,1.1915 11.58,3.0005 C14.0245,3.0435 16,5.0455 16,7.5 C16,9.762 14.308,11.68 12.064,11.961 Z M5.85358232,11.1465 L7.000025,12.293 L7.000025,7.5 C7.000025,7.2235 7.2240138,7 7.5,7 C7.7759862,7 7.999975,7.2235 7.999975,7.5 L7.999975,12.293 L9.14641768,11.1465 C9.3419079,10.951 9.65789211,10.951 9.85338233,11.1465 C10.0488726,11.342 10.0488726,11.658 9.85338233,11.8535 L7.85348233,13.8535 C7.8519824,13.855 7.8499825,13.8555 7.84848258,13.857 C7.80348483,13.901 7.75048748,13.937 7.69099045,13.9615 C7.6299935,13.9865 7.56499675,14 7.5,14 C7.43500325,14 7.3700065,13.9865 7.30900955,13.9615 C7.24901255,13.9365 7.19501525,13.9005 7.14951752,13.8555 C7.14851757,13.8545 7.14751762,13.8545 7.14651767,13.8535 L5.14661767,11.8535 C4.95112744,11.658 4.95112744,11.342 5.14661767,11.1465 C5.34210789,10.951 5.6580921,10.951 5.85358232,11.1465 Z",
          id: "Shape"
        }))));
      },
      "notification-active": function notificationActive(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 16"
        }, i.a.createElement("g", {
          id: "flow",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "admin-copy-2",
          transform: "translate(-983.000000, -638.000000)",
          fill: "#0075FF"
        }, i.a.createElement("g", {
          id: "Group-Copy-4",
          transform: "translate(782.000000, 618.000000)"
        }, i.a.createElement("g", {
          id: "notification-copy-7",
          transform: "translate(201.000000, 20.000000)"
        }, i.a.createElement("path", {
          d: "M12.3160361,11.23675 C12.1472125,11.50975 11.8430949,11.6666667 11.4830949,11.6666667 L8.94015373,11.6666667 C8.94015373,12.9529167 7.8913302,14 6.60250667,14 C5.31368314,14 4.26544784,12.9529167 4.26544784,11.6666667 L1.72368314,11.6666667 C1.36368314,11.6666667 1.05956549,11.50975 0.890741961,11.23675 C0.721918432,10.96375 0.717212549,10.6219167 0.877800785,10.3005 L2.51368314,7.42875 L2.51368314,4.08333333 C2.51368314,1.83166667 4.34780078,0 6.60250667,0 C8.85780078,0 10.6930949,1.83166667 10.6930949,4.08333333 L10.6930949,7.42875 L12.3142714,10.2730833 C12.4895655,10.6219167 12.4854478,10.96375 12.3160361,11.23675 Z M6.60250667,12.8333333 C7.24721255,12.8333333 7.77191843,12.3100833 7.77191843,11.6666667 L5.43368314,11.6666667 C5.43368314,12.3100833 5.95780078,12.8333333 6.60250667,12.8333333 Z M9.6013302,7.8715 C9.51780078,7.72566667 9.50780078,7.56 9.55427137,7.41125 L9.55427137,4.22975 C9.5413302,4.18191667 9.52485961,4.13525 9.52485961,4.08333333 C9.52485961,2.47508333 8.21368314,1.16666667 6.60250667,1.16666667 C4.99250667,1.16666667 3.68250667,2.47508333 3.68250667,4.08333333 L3.68250667,7.58333333 C3.68250667,7.595 3.67603608,7.60433333 3.67544784,7.616 C3.67368314,7.65508333 3.66250667,7.69125 3.65250667,7.72975 C3.64250667,7.76825 3.63368314,7.80558333 3.61603608,7.84 C3.6113302,7.8505 3.6113302,7.86158333 3.60603608,7.8715 L2.10780078,10.5 L11.0995655,10.5 L9.6013302,7.8715 Z",
          id: "Shape"
        }))))));
      },
      "notification-snooze": function notificationSnooze(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 16"
        }, i.a.createElement("g", {
          id: "flow",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "admin-copy-2",
          transform: "translate(-1396.000000, -637.000000)",
          fill: "#0075FF"
        }, i.a.createElement("g", {
          id: "notificatio-off-copy-3",
          transform: "translate(1396.000000, 637.000000)"
        }, i.a.createElement("path", {
          d: "M15.696,1.7216 L1.72096,15.74848 C1.59744,15.87264 1.43488,15.93536 1.27232,15.93536 C1.10976,15.93536 0.9472,15.87264 0.82304,15.74848 C0.57472,15.49952 0.57472,15.09568 0.82304,14.84672 L2.41088,13.25312 C2.2624,13.17312 2.1376,13.05984 2.04864,12.9152 C1.86432,12.61632 1.8592,12.24384 2.03456,11.89184 L3.81312,8.75328 L3.81312,5.09568 C3.81312,2.63488 5.80736,0.63296 8.25856,0.63296 C10.04224,0.63296 11.62752,1.70176 12.32768,3.2992 L14.79808,0.81984 C15.04576,0.57024 15.44832,0.57024 15.696,0.81984 C15.94432,1.0688 15.94432,1.472 15.696,1.7216 Z M11.3312,4.28224 L11.3312,4.2816 C10.96512,2.88448 9.70112,1.90848 8.25856,1.90848 C6.50752,1.90848 5.08352,3.33824 5.08352,5.09568 L5.08352,8.9216 C5.08352,8.9344 5.07712,8.94528 5.07648,8.95744 C5.07392,8.99968 5.0624,9.04 5.05152,9.0816 C5.04,9.12384 5.0304,9.16416 5.01184,9.20256 C5.00608,9.21344 5.00672,9.22624 5.00032,9.23712 L3.3568,12.13568 C3.39776,12.14784 3.43296,12.17024 3.47008,12.19008 L11.3344,4.29632 C11.33312,4.2912 11.33248,4.28672 11.3312,4.28224 Z M6.50496,12.33408 C6.62592,12.19136 6.80256,12.10944 6.9888,12.10944 L13.14816,12.10944 L11.51872,9.23712 C11.51296,9.22624 11.51296,9.21344 11.50784,9.20256 C11.48864,9.16416 11.47904,9.12384 11.46816,9.0816 C11.45728,9.04 11.44512,8.99968 11.4432,8.95744 C11.44192,8.94528 11.43552,8.9344 11.43552,8.9216 L11.43552,7.64608 C11.43552,7.29472 11.72032,7.00864 12.07104,7.00864 C12.42176,7.00864 12.70592,7.29472 12.70592,7.64608 L12.70592,8.75328 L14.46848,11.86176 C14.65984,12.24384 14.65472,12.61632 14.4704,12.9152 C14.28736,13.21344 13.95712,13.38496 13.56544,13.38496 L10.80064,13.38496 C10.80064,14.79104 9.66016,15.93536 8.25856,15.93536 C6.912,15.93536 5.7984,14.87936 5.7216,13.53088 C5.712,13.36768 5.7664,13.2064 5.872,13.0816 L6.50496,12.33408 Z M8.25856,14.65984 C8.96,14.65984 9.53024,14.08768 9.53024,13.38496 L7.28256,13.38496 L7.02464,13.69024 C7.16096,14.24896 7.66464,14.65984 8.25856,14.65984 Z",
          id: "Shape"
        })))));
      },
      info: function info(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "22" : n,
            a = e.height,
            o = void 0 === a ? "22" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 22 22"
        }, i.a.createElement("g", {
          fill: "#CCC",
          fillRule: "evenodd"
        }, i.a.createElement("path", {
          d: "M10.92 21.065c-5.597 0-10.15-4.553-10.15-10.15S5.322.765 10.92.765s10.15 4.553 10.15 10.15-4.553 10.15-10.15 10.15zm0-19c-4.88 0-8.85 3.97-8.85 8.85 0 4.88 3.97 8.85 8.85 8.85 4.88 0 8.85-3.97 8.85-8.85 0-4.88-3.97-8.85-8.85-8.85z"
        }), i.a.createElement("path", {
          d: "M12.497 15.205a1.884 1.884 0 0 1-.19.218c-.1.102-.277.226-.532.373-.254.146-.517.23-.786.254-.69.058-1.19-.226-1.498-.854-.274-.59-.293-1.283-.058-2.082l.387-1.617c.137-.468.12-.768-.05-.9-.037-.037-.106-.052-.21-.043a1.01 1.01 0 0 0-.228.05c-.08.028-.15.055-.203.08l-.07.037c-.114.063-.215.025-.302-.113a.34.34 0 0 1 .007-.406c.035-.054.1-.13.19-.225.092-.096.265-.22.52-.372a1.84 1.84 0 0 1 .785-.26c.705-.06 1.208.223 1.51.85.273.59.292 1.284.057 2.083l-.387 1.617c-.135.48-.117.784.054.914.026.03.095.04.206.03.07-.007.147-.024.23-.05.08-.03.148-.055.202-.08l.068-.038c.115-.062.216-.022.304.12.088.144.086.282-.007.415M11.67 8.722a1.475 1.475 0 1 1 0-2.95 1.475 1.475 0 0 1 0 2.95"
        })));
      },
      "check-circle": function checkCircle(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "32" : n,
            a = e.height,
            o = void 0 === a ? "32" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 32 32"
        }, i.a.createElement("path", {
          d: "M16 31.999c-8.822 0-16-7.177-16-15.999s7.178-16 16-16 16 7.177 16 16c0 8.822-7.178 15.999-16 15.999zM16 1.333c-8.087 0-14.667 6.579-14.667 14.667s6.579 14.666 14.667 14.666 14.667-6.579 14.667-14.666c0-8.088-6.579-14.667-14.667-14.667zM14.574 21.787c-0.123 0.133-0.293 0.209-0.473 0.213-0.005 0-0.010 0-0.015 0-0.175 0-0.343-0.069-0.468-0.192l-6.086-6.001c-0.262-0.258-0.265-0.68-0.007-0.943s0.681-0.265 0.943-0.006l5.597 5.518 9.447-10.164c0.25-0.271 0.673-0.285 0.942-0.035s0.285 0.673 0.034 0.943l-9.914 10.666z"
        }));
      },
      slack: function slack(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "22" : n,
            a = e.height,
            o = void 0 === a ? "22" : a;
        return i.a.createElement("svg", {
          className: "slack-icon ".concat(t),
          width: r,
          height: o,
          viewBox: "0 0 22 22"
        }, i.a.createElement("rect", {
          id: "Rectangle-path",
          x: "9.52",
          y: "9.48",
          width: "3.07",
          height: "2.97",
          transform: "translate(-3.04 4.05) rotate(-18.52)",
          fill: "rgb(181,210,225)"
        }), i.a.createElement("path", {
          id: "Shape",
          d: "M21.06,7.94C18.8.44,15.56-1.31,8,.94S-1.2,6.44,1,14s5.5,9.25,13,7S23.31,15.45,21.06,7.94Zm-3.79,4.87-1.41.47.49,1.47a1.13,1.13,0,0,1-.72,1.43,1,1,0,0,1-.38.05,1.17,1.17,0,0,1-1-.77L13.71,14l-2.92,1,.49,1.47a1.13,1.13,0,0,1-.72,1.43,1,1,0,0,1-.38.05,1.17,1.17,0,0,1-1-.77L8.64,15.7l-1.41.47a1,1,0,0,1-.38.05,1.17,1.17,0,0,1-1-.77A1.13,1.13,0,0,1,6.51,14l1.41-.47L7,10.74l-1.41.47a1,1,0,0,1-.38.05,1.17,1.17,0,0,1-1-.77,1.13,1.13,0,0,1,.72-1.43l1.41-.47L5.78,7.12a1.13,1.13,0,1,1,2.15-.72l.49,1.47,2.92-1-.49-1.47A1.13,1.13,0,1,1,13,4.71l.49,1.47,1.41-.47a1.13,1.13,0,1,1,.72,2.15l-1.41.47.94,2.81,1.41-.47a1.13,1.13,0,1,1,.72,2.15Z",
          transform: "translate(-0.13 -0.03)",
          fill: "rgb(181,210,225)"
        }));
      },
      "clone-1": function clone1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "20" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 30 30"
        }, i.a.createElement("path", {
          d: "M24.4,4H11.7c-1.5,0-2.6,1.2-2.6,2.6v2.4H6.6C5.2,9.1,4,10.2,4,11.7v12.7C4,25.8,5.2,27,6.6,27 h12.7c1.5,0,2.6-1.2,2.6-2.6v-2.4h2.4c1.5,0,2.6-1.2,2.6-2.6V6.6C27,5.2,25.8,4,24.4,4z M20.4,24.3c0,0.6-0.5,1.1-1.1,1.1H6.7 c-0.6,0-1.1-0.5-1.1-1.1V11.7c0-0.6,0.5-1.1,1.1-1.1h12.7c0.6,0,1.1,0.5,1.1,1.1L20.4,24.3L20.4,24.3z M25.5,19.3 c0,0.6-0.5,1.1-1.1,1.1h-2.4v-8.8c0-1.5-1.2-2.6-2.6-2.6h-8.8V6.6c0-0.6,0.5-1.1,1.1-1.1h12.7c0.6,0,1.1,0.5,1.1,1.1V19.3z"
        }));
      },
      lightbulb: function lightbulb(e) {
        var t = e.className,
            n = e.height,
            r = void 0 === n ? "24" : n,
            a = e.width,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: o,
          height: r,
          viewBox: "0 0 24 24"
        }, i.a.createElement("g", {
          id: "Group"
        }, i.a.createElement("path", {
          className: "st0",
          d: "M12,6.2c-1.1,0-2.1,0.5-2.8,1.2C8.9,7.9,8.6,8.3,8.4,8.8C8.3,9.2,8.2,9.6,8.2,10c0,0.8,0.2,1.5,0.7,2.1 c0.3,0.5,0.7,0.8,1.2,1.1l0.2,1.7h3.3l0.2-1.7c0.5-0.3,0.9-0.7,1.2-1.1c0.4-0.6,0.7-1.3,0.7-2.1c0-0.4-0.1-0.8-0.2-1.2 c-0.2-0.5-0.4-0.9-0.8-1.3C14.1,6.7,13.1,6.2,12,6.2z M12,12c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S13.1,12,12,12z"
        }), i.a.createElement("path", {
          className: "st0",
          d: "M10.8,17.5h0.6c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6h0.6v-1.2h-2.5V17.5z"
        }), i.a.createElement("path", {
          className: "st0",
          d: "M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M14.8,14.1l-0.3,2.1v1.5c0,0.6-0.4,1-1,1h-0.4 c-0.2,0.4-0.6,0.6-1.1,0.6s-0.9-0.3-1.1-0.6h-0.4c-0.6,0-1-0.4-1-1v-1.5l-0.3-2.1C7.9,13.2,7,11.7,7,10c0-2.8,2.2-5,5-5s5,2.2,5,5 C17,11.7,16.1,13.2,14.8,14.1z"
        })));
      },
      briefcase: function briefcase(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "11" : n,
            a = e.height,
            o = void 0 === a ? "10" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 11 10",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          d: "M9.927 9.356H1.593c-.46 0-.833-.351-.833-.783v-5.87c0-.43.374-.782.833-.782h2.084V1.53c0-.647.56-1.174 1.25-1.174h1.666c.69 0 1.25.527 1.25 1.174v.391h2.084c.459 0 .833.351.833.783v5.87c0 .431-.374.782-.833.782zm-8.334-.783h8.332l.001-3.13H7.01c0 .647-.56 1.174-1.25 1.174-.33 0-.643-.123-.881-.344a1.131 1.131 0 0 1-.369-.83H1.593v3.13zm3.75-3.13c0 .102.044.2.124.275a.435.435 0 0 0 .293.116c.23 0 .417-.175.417-.391V4.66c0-.102-.045-.2-.124-.275a.437.437 0 0 0-.293-.116c-.23 0-.417.176-.417.391v.783zM7.01 1.53c0-.216-.187-.391-.417-.391H4.927c-.23 0-.417.175-.417.39v.392h2.5V1.53zM1.593 2.704V4.66H4.51c0-.647.56-1.174 1.25-1.174.33 0 .643.123.881.345.239.224.369.518.369.83h2.916V2.703H1.594z",
          fill: "#000",
          fillRule: "evenodd"
        }));
      },
      ban: function ban(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          width: r,
          height: o,
          viewBox: "0 0 14 14",
          className: t
        }, i.a.createElement("g", {
          id: "Layer_1"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#394F5A",
          d: "M7,1.167c-1.398,0-2.683,0.495-3.689,1.318l8.203,8.204\r c0.824-1.007,1.32-2.291,1.32-3.689C12.834,3.783,10.217,1.167,7,1.167z M1.166,7c0,3.217,2.617,5.833,5.834,5.833\r c1.398,0,2.684-0.495,3.689-1.319L2.486,3.311C1.662,4.316,1.166,5.602,1.166,7z M7,14c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7\r S10.859,14,7,14z"
        })));
      },
      pencil: function pencil(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          width: r,
          height: o,
          className: t,
          viewBox: "0 0 47.986 47.985"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0.558,47.293c1.088,1.091,2.839,0.565,2.839,0.565l14.162-4.746 c0.354-0.121,0.676-0.318,0.938-0.583l23.966-24.006l0.003-0.003l0.004-0.003l2.45-2.46c1.841-1.837,2.892-3.936,3.046-6.062 c0.127-1.713-0.281-4.311-2.932-6.962c-2.675-2.685-5.275-3.13-7-3.016c-2.152,0.127-4.261,1.168-6.102,3.016h-0.007L5.502,29.509 c-0.265,0.265-0.462,0.589-0.583,0.94L0.046,45.117C0.046,45.117-0.229,46.503,0.558,47.293z M35.32,6.439 c0-0.003,0-0.003,0.007-0.007c0.689-0.696,1.78-1.546,2.999-1.62c1.07-0.061,2.179,0.482,3.313,1.62 c1.091,1.098,1.613,2.176,1.54,3.21c-0.087,1.215-0.948,2.306-1.654,3.009v0.006l-0.756,0.76l-6.206-6.219L35.32,6.439z M9.298,32.511L31.168,10.6l6.206,6.219L15.503,38.73l-9.312,3.106L9.298,32.511z"
        }));
      },
      bot: function bot(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 16"
        }, i.a.createElement("g", {
          id: "Layer_3",
          "data-name": "Layer 3"
        }, i.a.createElement("g", {
          id: "mask-2"
        }, i.a.createElement("path", {
          id: "path-1",
          d: "M18,12a.57.57,0,0,1-.57-.58V7.92a.57.57,0,1,1,1.13,0V11.4A.57.57,0,0,1,18,12Zm-2.78,4.63H3.78a1.67,1.67,0,0,1-1.65-1.68V5.55A1.67,1.67,0,0,1,3.78,3.87H5V2.71a.57.57,0,0,1,0-.15,1.13,1.13,0,1,1,1.08,0,.57.57,0,0,1,0,.15V3.87h6.8V2.71a.57.57,0,0,1,0-.15,1.13,1.13,0,1,1,1.08,0,.57.57,0,0,1,0,.15V3.87h1.18a1.67,1.67,0,0,1,1.65,1.68v9.37A1.67,1.67,0,0,1,15.22,16.61Zm.52-11.06A.52.52,0,0,0,15.22,5H3.78a.52.52,0,0,0-.52.53v9.37a.52.52,0,0,0,.52.53H15.22a.52.52,0,0,0,.52-.53ZM5.54,12a.57.57,0,1,1,1.13,0h5.66a.57.57,0,1,1,1.13,0v1.16H5.54ZM12,10.24a1.45,1.45,0,1,1,1.42-1.45A1.43,1.43,0,0,1,12,10.24ZM12,8.5a.29.29,0,1,0,.28.29A.29.29,0,0,0,12,8.5ZM7,10.24A1.45,1.45,0,1,1,8.37,8.79,1.43,1.43,0,0,1,7,10.24ZM7,8.5a.29.29,0,1,0,.28.29A.29.29,0,0,0,7,8.5ZM1,12a.57.57,0,0,1-.57-.58V7.92A.57.57,0,0,1,1,7.34a.57.57,0,0,1,.57.58V11.4A.57.57,0,0,1,1,12Z",
          transform: "translate(-0.44 -0.39)",
          fill: "#fff"
        }))));
      },
      "bot-2": function Bot2Svg(e) {
        var t = e.className,
            n = void 0 === t ? "" : t,
            r = e.height,
            a = void 0 === r ? 22 : r,
            o = e.width,
            s = void 0 === o ? 22 : o;
        return i.a.createElement("svg", {
          className: n,
          width: s,
          height: a,
          viewBox: "0 0 22 22",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.75 2C12.75 2.83934 12.233 3.55793 11.5 3.85462V7H13.75V8.25H18.75C20.2688 8.25 21.5 9.48122 21.5 11V19C21.5 20.5188 20.2688 21.75 18.75 21.75H2.75C1.23122 21.75 0 20.5188 0 19V11C0 9.48122 1.23122 8.25 2.75 8.25H7.75V7H10V3.85462C9.26704 3.55793 8.75 2.83934 8.75 2C8.75 0.89543 9.64543 0 10.75 0C11.8546 0 12.75 0.89543 12.75 2ZM1.5 11C1.5 10.3096 2.05964 9.75 2.75 9.75H18.75C19.4404 9.75 20 10.3096 20 11V19C20 19.6904 19.4404 20.25 18.75 20.25H2.75C2.05964 20.25 1.5 19.6904 1.5 19V11ZM7.75 14.5C7.75 15.3284 7.07843 16 6.25 16C5.42157 16 4.75 15.3284 4.75 14.5C4.75 13.6716 5.42157 13 6.25 13C7.07843 13 7.75 13.6716 7.75 14.5ZM15.25 16C16.0784 16 16.75 15.3284 16.75 14.5C16.75 13.6716 16.0784 13 15.25 13C14.4216 13 13.75 13.6716 13.75 14.5C13.75 15.3284 14.4216 16 15.25 16Z",
          fill: "white"
        }));
      },
      "pb-attribute": function pbAttribute(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#3A4F5A",
          d: "M45.443,16.937c-1.331,0-2.412-1.08-2.412-2.412c0-1.333,1.077-2.414,2.412-2.414\r c1.331,0,2.411,1.081,2.411,2.414C47.856,15.856,46.774,16.937,45.443,16.937z M45.443,8.56c-3.29,0-5.967,2.675-5.967,5.967\r c0,3.291,2.673,5.965,5.967,5.965c3.292,0,5.965-2.672,5.965-5.965C51.408,11.234,48.735,8.56,45.443,8.56z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#3A4F5A",
          d: "M38.763,25.514c-0.979,0-1.772,0.793-1.772,1.773v27.355c0,0.98,0.793,1.773,1.772,1.773\r c0.979,0,1.771-0.793,1.771-1.773V27.285C40.531,26.307,39.741,25.514,38.763,25.514z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#3A4F5A",
          d: "M52.113,25.514c-0.979,0-1.772,0.793-1.772,1.773v27.355c0,0.98,0.793,1.773,1.772,1.773\r c0.979,0,1.771-0.793,1.771-1.773V27.285C53.896,26.307,53.092,25.514,52.113,25.514z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#3A4F5A",
          d: "M60.866,59.074c0,0.979-0.794,1.769-1.774,1.769H31.793c-0.979,0-1.771-0.79-1.771-1.769V22.699\r c0-1.937,0.602-3.793,1.758-5.348l7.46-10.096c1.442-1.959,3.768-3.126,6.207-3.126s4.76,1.167,6.204,3.126l7.465,10.096\r c1.151,1.555,1.757,3.404,1.757,5.348v36.375H60.866z M26.48,34.872v11.619c-0.69,0.264-1.42,0.4-2.163,0.4\r c-3.426,0-6.203-2.791-6.203-6.206c0-3.431,2.789-6.204,6.203-6.204C25.061,34.472,25.791,34.605,26.48,34.872z M21.256,60.843\r v-3.04c0-0.79-0.526-1.494-1.294-1.705c-1.228-0.353-2.4-0.831-3.478-1.435c-0.691-0.39-1.556-0.264-2.123,0.289l-2.148,2.135\r l-4.318-4.318l2.136-2.147c0.565-0.566,0.677-1.435,0.288-2.124c-0.602-1.079-1.094-2.246-1.431-3.478\r c-0.213-0.768-0.917-1.294-1.706-1.294H4.153v-6.117h3.039c0.792,0,1.496-0.526,1.708-1.296c0.351-1.229,0.83-2.398,1.431-3.48\r c0.389-0.688,0.264-1.555-0.289-2.12l-2.135-2.136l4.32-4.318l2.147,2.136c0.565,0.567,1.431,0.676,2.122,0.286\r c1.081-0.602,2.248-1.092,3.479-1.431c0.768-0.214,1.295-0.915,1.295-1.707v-3.041l5.414-0.016\r c-0.123,0.72-0.199,1.46-0.199,2.199v8.464c-0.705-0.163-1.431-0.237-2.161-0.237c-5.375,0-9.76,4.371-9.76,9.747\r c0,5.375,4.372,9.76,9.76,9.76c0.729,0,1.458-0.089,2.161-0.241v8.879c0,0.631,0.116,1.231,0.315,1.798L21.256,60.843z\r M61.96,15.255L54.497,5.158c-2.11-2.864-5.498-4.571-9.058-4.571c-3.552,0-6.942,1.707-9.056,4.571l-7.461,10.097\r c-0.4,0.552-0.765,1.117-1.066,1.72h-8.378c-0.98,0-1.771,0.792-1.771,1.774v3.518c-0.602,0.213-1.192,0.452-1.758,0.729\r l-2.487-2.489c-0.69-0.689-1.809-0.689-2.513,0l-6.83,6.834c-0.692,0.752-0.692,1.82,0,2.511l2.487,2.486\r c-0.266,0.567-0.515,1.159-0.729,1.764h-3.52C1.392,34.073,0.6,34.878,0.6,35.858v9.658c0,0.982,0.792,1.772,1.773,1.772H5.89\r c0.212,0.601,0.45,1.193,0.727,1.757L4.13,51.533c-0.69,0.69-0.69,1.81,0,2.511l6.832,6.834c0.691,0.691,1.81,0.691,2.512,0\r l2.487-2.485c0.577,0.265,1.154,0.513,1.759,0.727v3.52c0,0.981,0.79,1.774,1.77,1.774h39.597c2.93,0,5.313-2.388,5.313-5.312\r V22.699C64.406,20,63.554,17.426,61.96,15.255z"
        }))));
      },
      "pb-branch": function pbBranch(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M48.176,50.67c-1.683-0.005-3.199,1.012-3.843,2.566c-0.643,1.552-0.284,3.339,0.914,4.526\r c1.195,1.186,2.985,1.531,4.537,0.871c1.554-0.656,2.548-2.182,2.533-3.864C52.292,52.496,50.449,50.67,48.176,50.67z\r M36.64,10.228c0.017-1.677-0.983-3.198-2.529-3.853c-1.547-0.653-3.334-0.309-4.526,0.873c-1.193,1.183-1.554,2.967-0.912,4.513\r c0.637,1.553,2.149,2.564,3.825,2.564C34.769,14.323,36.618,12.495,36.64,10.228z M12.688,54.77c0,2.285,1.854,4.137,4.139,4.137\r c2.287,0,4.137-1.852,4.137-4.137s-1.854-4.136-4.137-4.136C14.544,50.63,12.688,52.484,12.688,54.77z M57.88,54.77\r c0.012,5.002-3.777,9.188-8.754,9.679c-4.975,0.489-9.508-2.88-10.475-7.781c-0.966-4.906,1.95-9.739,6.737-11.174V39.67\r l-12.888-9.782l-12.887,9.806v5.8c4.617,1.377,7.516,5.937,6.816,10.705c-0.696,4.771-4.783,8.304-9.604,8.304\r c-4.816,0-8.903-3.533-9.604-8.304c-0.698-4.762,2.208-9.32,6.82-10.705v-8.585l15.674-11.895v-5.504\r c-4.614-1.38-7.516-5.939-6.82-10.707c0.7-4.768,4.787-8.305,9.604-8.305c4.819,0,8.907,3.532,9.606,8.305\r c0.696,4.763-2.208,9.321-6.818,10.707v5.501l15.674,11.916v8.568C55.057,46.727,57.867,50.494,57.88,54.77z"
        })));
      },
      "pb-button": function pbButton(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M61.612,29.395c0,1.459-1.184,2.647-2.648,2.647h-15.5L29.852,20.13v11.912H6.034\r c-1.462,0-2.65-1.188-2.65-2.647V10.867c0-1.457,1.188-2.646,2.65-2.646h52.93c1.465,0,2.648,1.189,2.648,2.646V29.395z\r M49.991,41.271l-6.131,3.104l4.275,9.327l-4.81,2.213l-4.174-9.108l-6.654,3.21v-24.05L49.991,41.271z M58.964,5.576H6.034\r c-2.913,0-5.296,2.38-5.296,5.293v18.53c0,2.909,2.382,5.296,5.296,5.296h23.818v19.612l7.997-3.999l4.172,9.115l9.627-4.408\r l-4.327-9.443l7.389-3.692l-8.222-7.188h12.479c2.909,0,5.296-2.38,5.296-5.292V10.871C64.259,7.956,61.875,5.576,58.964,5.576z"
        })));
      },
      "pb-calendar": function pbCalendar(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M16.26,16.262c1.494,0,2.706-1.214,2.706-2.707V2.727c0-1.494-1.212-2.707-2.706-2.707\r s-2.706,1.213-2.706,2.707v10.828C13.554,15.051,14.766,16.262,16.26,16.262z M13.554,29.798h5.412\r c1.494,0,2.707-1.215,2.707-2.709c0-1.493-1.213-2.708-2.707-2.708h-5.412c-1.494,0-2.709,1.215-2.709,2.708\r C10.845,28.583,12.06,29.798,13.554,29.798z M35.203,46.034h-5.412c-1.493,0-2.706,1.215-2.706,2.709\r c0,1.499,1.213,2.703,2.706,2.703h5.412c1.495,0,2.709-1.209,2.709-2.703C37.912,47.244,36.703,46.034,35.203,46.034z\r M27.085,5.437h-5.412v5.413h5.414L27.085,5.437L27.085,5.437z M18.966,35.204h-5.417c-1.494,0-2.707,1.22-2.707,2.708\r c0,1.495,1.213,2.709,2.707,2.709h5.417c1.494,0,2.704-1.214,2.704-2.709C21.675,36.414,20.46,35.204,18.966,35.204z M59.568,5.437\r h-5.419v5.413h5.419v48.719H5.433V10.847h5.414v-5.41H5.433c-2.99,0-5.413,2.423-5.413,5.413v48.719\r c0,2.987,2.426,5.412,5.413,5.412h54.13c2.993,0,5.418-2.425,5.418-5.412V10.847C64.98,7.859,62.556,5.437,59.568,5.437z\r M18.966,46.034h-5.417c-1.494,0-2.707,1.215-2.707,2.709c0,1.499,1.213,2.703,2.707,2.703h5.417c1.494,0,2.704-1.209,2.704-2.703\r C21.675,47.244,20.46,46.034,18.966,46.034z M29.796,29.798h5.413c1.494,0,2.706-1.215,2.706-2.709\r c0-1.493-1.212-2.708-2.706-2.708h-5.413c-1.493,0-2.709,1.215-2.709,2.708C27.085,28.583,28.298,29.798,29.796,29.798z\r M46.034,29.798h5.412c1.494,0,2.708-1.215,2.708-2.709c0-1.493-1.214-2.708-2.708-2.708h-5.412c-1.494,0-2.706,1.215-2.706,2.708\r C43.328,28.583,44.54,29.798,46.034,29.798z M48.737,16.262c1.494,0,2.709-1.214,2.709-2.707V2.727\r c0-1.494-1.215-2.707-2.709-2.707s-2.708,1.213-2.708,2.707v10.828C46.034,15.051,47.243,16.262,48.737,16.262z M51.446,35.204\r h-5.417c-1.494,0-2.704,1.22-2.704,2.708c0,1.495,1.21,2.709,2.704,2.709h5.417c1.494,0,2.706-1.214,2.706-2.709\r C54.149,36.414,52.94,35.204,51.446,35.204z M51.446,46.034h-5.417c-1.494,0-2.704,1.215-2.704,2.709\r c0,1.499,1.21,2.703,2.704,2.703h5.417c1.494,0,2.706-1.209,2.706-2.703C54.149,47.244,52.94,46.034,51.446,46.034z M32.5,16.262\r c1.494,0,2.703-1.214,2.703-2.707V2.727c0-1.494-1.209-2.707-2.703-2.707s-2.704,1.213-2.704,2.707v10.828\r C29.796,15.051,31.006,16.262,32.5,16.262z M35.203,35.204h-5.412c-1.493,0-2.706,1.22-2.706,2.708\r c0,1.495,1.213,2.709,2.706,2.709h5.412c1.495,0,2.709-1.214,2.709-2.709C37.912,36.414,36.703,35.204,35.203,35.204z\r M43.325,5.437h-5.418v5.413h5.418V5.437z"
        })));
      },
      "pb-close": function pbClose(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("polygon", {
          fill: "#394F5A",
          points: "64.268,10.581 54.415,0.732 32.497,22.651 10.581,0.732 0.732,10.578 22.651,32.497 0.732,54.418 \r 10.578,64.268 32.497,42.35 54.415,64.268 64.268,54.418 42.35,32.497   "
        })));
      },
      "pb-domain-exclusion": function pbDomainExclusion(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "none",
          d: "M46.371,27.723h6.958c-0.274-2.842-1.037-5.526-2.192-7.98h-5.849C45.864,22.261,46.233,24.939,46.371,27.723\r z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M48.163,14.956c-1.994-2.492-4.465-4.579-7.264-6.11c1.159,1.788,2.146,3.849,2.979,6.11H48.163z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M31.928,7.772v7.183h7.283C37.327,11.293,34.784,8.712,31.928,7.772z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M41.102,19.743h-9.174v7.98h10.535C42.295,24.855,41.818,22.173,41.102,19.743z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M18.112,8.846c-2.799,1.531-5.269,3.618-7.261,6.11h4.285C15.966,12.695,16.954,10.634,18.112,8.846z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M19.801,14.956h7.285V7.772C24.23,8.712,21.687,11.293,19.801,14.956z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M16.549,27.723h10.537v-7.98H17.91C17.196,22.173,16.719,24.855,16.549,27.723z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M17.91,40.492h9.176v-7.98H16.549C16.719,35.381,17.196,38.063,17.91,40.492z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M12.642,32.512H5.684c0.275,2.844,1.037,5.526,2.193,7.98h5.849C13.152,37.981,12.778,35.287,12.642,32.512z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M10.852,45.28c1.995,2.498,4.456,4.577,7.261,6.11c-1.158-1.788-2.146-3.849-2.976-6.11H10.852z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M27.086,52.462V45.28h-7.285C21.687,48.942,24.23,51.524,27.086,52.462z"
        }), i.a.createElement("path", {
          fill: "none",
          d: "M13.726,19.743H7.877c-1.156,2.454-1.918,5.138-2.193,7.98h6.958C12.778,24.939,13.149,22.261,13.726,19.743z\r "
        }), i.a.createElement("path", {
          fill: "#394F5A",
          d: "M35.039,50.704c0-0.002,0-0.004,0-0.008c-0.979,0.807-2.021,1.407-3.111,1.766V45.28h4.038\r c0.606-1.748,1.491-3.36,2.608-4.788h-6.646v-7.98h10.535c-0.099,1.676-0.312,3.279-0.606,4.813\r c1.293-0.945,2.73-1.704,4.278-2.246c0.088-0.852,0.194-1.696,0.236-2.567h6.958c-0.057,0.574-0.145,1.136-0.24,1.694\r c1.743,0.151,3.401,0.561,4.945,1.203c0.324-1.72,0.515-3.485,0.515-5.292c0-15.703-12.856-28.729-29.042-28.729\r c-16.187,0-29.042,13.025-29.042,28.729S13.32,58.847,29.507,58.847c2.493,0,4.893-0.344,7.195-0.923\r c-0.122-0.25-0.271-0.48-0.378-0.738C35.485,55.217,35.039,53.013,35.039,50.704z M51.137,19.743\r c1.155,2.454,1.918,5.138,2.192,7.98h-6.958c-0.138-2.783-0.507-5.462-1.083-7.98H51.137z M48.163,14.956h-4.285\r c-0.832-2.261-1.819-4.322-2.979-6.11C43.698,10.376,46.169,12.464,48.163,14.956z M31.928,7.772\r c2.856,0.94,5.399,3.521,7.283,7.183h-7.283V7.772z M31.928,19.743h9.174c0.717,2.431,1.193,5.113,1.361,7.98H31.928V19.743z\r M18.112,8.846c-1.158,1.788-2.146,3.849-2.976,6.11h-4.285C12.844,12.464,15.313,10.376,18.112,8.846z M7.877,19.743h5.849\r c-0.576,2.518-0.947,5.197-1.084,7.98H5.684C5.959,24.88,6.721,22.196,7.877,19.743z M7.877,40.492\r c-1.156-2.454-1.918-5.137-2.193-7.98h6.958c0.137,2.775,0.511,5.47,1.084,7.98H7.877z M10.852,45.28h4.285\r c0.829,2.262,1.817,4.322,2.976,6.11C15.308,49.857,12.847,47.778,10.852,45.28z M27.086,52.462\r c-2.855-0.938-5.399-3.52-7.285-7.182h7.285V52.462z M27.086,40.492H17.91c-0.714-2.429-1.191-5.111-1.361-7.98h10.537V40.492z\r M27.086,27.723H16.549c0.17-2.867,0.647-5.549,1.361-7.98h9.176V27.723z M27.086,14.956h-7.285\r c1.886-3.662,4.43-6.243,7.285-7.183V14.956z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M63.518,45.67c-1.271-2.984-3.596-5.323-6.44-6.651c-0.435-0.202-0.885-0.372-1.342-0.524\r c-0.248-0.082-0.5-0.152-0.751-0.22c-0.218-0.059-0.442-0.108-0.664-0.154c-0.857-0.183-1.734-0.314-2.634-0.318\r c-2.807-0.01-5.388,0.877-7.508,2.374c-0.11,0.078-0.217,0.163-0.328,0.245c-0.324,0.244-0.633,0.502-0.93,0.774\r c-0.096,0.084-0.191,0.164-0.278,0.252c-0.366,0.354-0.713,0.726-1.037,1.122c-0.054,0.069-0.104,0.142-0.16,0.212\r c-0.26,0.336-0.508,0.687-0.736,1.047c-0.08,0.128-0.156,0.255-0.232,0.385c-0.214,0.366-0.412,0.742-0.587,1.129\r c-0.042,0.088-0.088,0.17-0.126,0.259c-0.206,0.471-0.378,0.957-0.526,1.455c-0.034,0.126-0.064,0.255-0.099,0.383\r c-0.104,0.393-0.188,0.791-0.252,1.197c-0.023,0.15-0.05,0.302-0.068,0.452c-0.069,0.531-0.115,1.067-0.115,1.616\r c0,1.8,0.37,3.491,1.022,5.037c1.986,4.722,6.646,7.856,11.827,7.869c5.25,0.026,9.933-3.096,11.965-7.869\r c0.651-1.546,1.018-3.239,1.018-5.037C64.535,48.948,64.169,47.229,63.518,45.67z M61.035,51.917\r c-0.336,0.28-0.797,0.467-1.312,0.467c-6.783,0-7.442,0-8.106,0c-0.633,0-1.296,0-8.091,0c-0.499,0-0.979-0.187-1.322-0.467\r c-0.316-0.334-0.526-0.732-0.526-1.203c0-0.448,0.21-0.858,0.526-1.165c0.343-0.295,0.819-0.482,1.322-0.482\r c6.799,0,7.458,0,8.091,0c0.664,0,1.323,0,8.106,0c0.519,0,0.976,0.188,1.312,0.482c0.343,0.307,0.553,0.719,0.553,1.165\r C61.588,51.185,61.374,51.587,61.035,51.917z"
        }))));
      },
      "pb-email": function pbEmail(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M36.746,0.753C26.257-0.585,16.164,3.036,9.031,10.72c-7.13,7.684-10.002,18.089-7.856,28.531\r c2.488,12.104,11.845,21.682,23.851,24.41c2.51,0.58,5.021,0.858,7.504,0.858c4.917,0,9.713-1.115,14.17-3.308\r c1.586-0.788,2.233-2.712,1.455-4.292c-0.783-1.597-2.726-2.236-4.292-1.455c-5.359,2.652-11.393,3.332-17.413,1.959\r C17.037,55.28,9.407,47.462,7.452,37.971c-1.729-8.396,0.557-16.745,6.275-22.898c5.704-6.148,13.781-9.051,22.195-7.966\r c12.652,1.635,22.196,13.122,22.196,26.728v1.863c0,3.534-2.871,6.402-6.407,6.402c-3.531,0-6.401-2.868-6.401-6.402V22.892\r c0-1.768-1.434-3.203-3.201-3.203c-1.31,0-2.43,0.795-2.93,1.925c-1.906-1.21-4.146-1.928-6.681-1.928\r c-7.541,0-12.806,5.927-12.806,14.409c0,8.488,5.262,14.409,12.806,14.409c3.98,0,7.292-1.678,9.567-4.48\r c2.348,2.721,5.776,4.48,9.646,4.48c7.069,0,12.81-5.741,12.81-12.803v-1.865C64.521,17.02,52.582,2.798,36.746,0.753z\r M32.498,42.104c-3.95,0-6.404-3.066-6.404-8.003c0-4.942,2.455-8.01,6.404-8.01c3.952,0,6.405,3.067,6.405,8.01\r C38.902,39.037,36.449,42.104,32.498,42.104z"
        }));
      },
      "pb-filter": function pbFilter(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M35.69,36.975v14.593L29.31,54.74V36.975L12.731,7.789H52.27L35.69,36.975z M61.413,0.375H3.587\r c-1.928,0-3.212,1.285-3.212,3.212c0,1.928,1.284,3.213,3.212,3.213h1.607l17.667,31.161v26.664l19.277-9.639V37.961L59.806,6.8\r h1.607c1.928,0,3.212-1.285,3.212-3.213C64.625,1.66,63.341,0.375,61.413,0.375z"
        })));
      },
      "pb-greeting": function pbGreeting(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M46.433,39.434L31.282,54.705l-1.157,1.159c-2.981,2.989-6.955,4.563-10.93,4.563\r c-3.972,0-7.947-1.495-10.926-4.563C4.042,51.63,2.638,45.492,4.541,39.846l7.698-18.59c0.251-0.58,0.665-0.995,1.159-1.16\r c0.251-0.083,0.581-0.166,0.83-0.166c0.248,0,0.578,0.083,0.829,0.166c0.248,0.082,0.497,0.249,0.744,0.496\r c0.663,0.664,0.829,1.578,0.497,2.407c0,0-3.974,9.876-4.389,10.868c-0.248,0.664,0,1.245,0.496,1.245\r c0.25,0,0.499-0.166,0.829-0.498c0.995-0.993,4.553-4.561,4.553-4.561l2.814-2.821l11.507-11.536\r c0.416-0.415,0.993-0.664,1.573-0.664c0.578,0,1.159,0.249,1.574,0.664c0.827,0.83,0.827,2.24,0,3.152L21.76,32.38l-0.495,0.495\r c-0.58,0.58-0.58,1.576,0,2.158c0.332,0.332,0.663,0.415,1.076,0.415c0.248,0,0.578-0.083,0.829-0.253\r c0.083-0.083,0.167-0.166,0.248-0.249l16.475-16.349c0.413-0.415,0.996-0.665,1.574-0.665c0.494,0,0.994,0.167,1.409,0.498\r c0.41,0.333,0.576,0.748,0.744,1.079c0.249,0.745,0,1.577-0.578,2.157L26.568,38.182c-0.334,0.332-0.499,0.83-0.416,1.245\r c0,0.332,0.168,0.664,0.416,0.913c0.33,0.332,0.659,0.415,1.074,0.415c0.083,0,0.083,0,0.166,0c0.332,0,0.661-0.169,0.995-0.415\r l13.909-13.941c0.412-0.414,0.995-0.664,1.574-0.664c0.578,0,1.159,0.25,1.572,0.664c0.829,0.83,0.829,2.242,0,3.153\r L32.614,42.745l-0.497,0.498l-2.152,2.158c-0.58,0.578-0.58,1.578,0,2.159c0.333,0.332,0.663,0.412,1.074,0.412\r c0.413,0,0.827-0.166,1.074-0.412l0,0l10.594-10.625l0.661-0.664c0.414-0.412,0.996-0.661,1.576-0.661\r c0.576,0,1.157,0.249,1.574,0.661c0.33,0.332,0.495,0.747,0.578,1.162C47.177,38.188,47.011,38.936,46.433,39.434z M50.157,37.025\r c-0.164-1.072-0.66-2.072-1.489-2.819c-0.579-0.581-1.157-0.916-1.904-1.244l1.24-1.246c2.07-2.074,2.07-5.477,0-7.553\r c-0.576-0.581-1.24-0.995-2.069-1.244c0.746-1.244,0.912-2.739,0.498-4.149v-0.083v-0.084c-0.167-0.333-0.581-1.495-1.658-2.405\r c-0.912-0.748-2.069-1.162-3.312-1.162c-0.995,0-1.901,0.25-2.729,0.747c-0.253-0.747-0.664-1.495-1.242-2.073\r c-0.993-0.998-2.318-1.579-3.723-1.579c-1.408,0-2.732,0.581-3.726,1.579l-10.93,10.704c0-0.083,0.083-0.167,0.083-0.25\r c0.829-1.991,0.416-4.232-1.159-5.808c-0.495-0.499-1.076-0.915-1.737-1.163c-0.665-0.248-1.323-0.412-2.069-0.412\r c-0.665,0-1.408,0.166-1.99,0.412c-1.321,0.581-2.318,1.579-2.896,2.907l-7.7,18.59v0.083v0.083\r c-2.32,6.806-0.662,14.106,4.389,19.171c3.474,3.484,8.192,5.474,13.159,5.474c4.968,0,9.604-1.906,13.166-5.477l1.157-1.163\r l15.235-15.268C49.827,40.43,50.405,38.687,50.157,37.025z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M63.469,31.615c-0.552,0-0.918,0.336-0.918,0.845c0,7.167-3.021,13.918-8.521,18.979\r c-0.367,0.335-0.367,0.848,0,1.18c0.187,0.169,0.462,0.252,0.644,0.252c0.183,0,0.458-0.083,0.638-0.252\r c5.866-5.401,9.072-12.573,9.072-20.159C64.386,31.951,63.928,31.615,63.469,31.615z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M58.178,31.615c-0.538,0-0.895,0.329-0.895,0.82c0,5.821-2.415,11.315-6.801,15.499\r c-0.357,0.328-0.357,0.819,0,1.148c0.179,0.166,0.356,0.246,0.626,0.246c0.272,0,0.45-0.08,0.629-0.246\r c4.741-4.512,7.336-10.417,7.336-16.647C59.071,31.944,58.625,31.615,58.178,31.615z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M15.629,10.358c0.254,0,0.422-0.076,0.592-0.229c5.058-4.582,11.808-7.102,18.976-7.102l0,0\r c0.509,0,0.846-0.307,0.846-0.765S35.623,1.5,35.197,1.5c-7.588,0-14.759,2.673-20.159,7.561c-0.336,0.304-0.336,0.764,0,1.069\r C15.209,10.282,15.463,10.358,15.629,10.358z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M35.197,6.826C28.934,7,23.006,9.662,18.581,14.213c-0.334,0.344-0.334,0.858,0,1.203\r c0.168,0.17,0.417,0.257,0.585,0.257c0.169,0,0.417-0.087,0.584-0.259c4.093-4.209,9.604-6.697,15.447-6.871\r c0.502,0,0.837-0.429,0.837-0.857C36.116,7.17,35.699,6.741,35.197,6.826z"
        }))));
      },
      "pb-keywordmatching": function pbKeywordmatching(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M11.019,23.391h12.37c0.736,0,1.303-0.572,1.303-1.314c0-0.743-0.563-1.314-1.303-1.314h-12.37\r c-0.738,0-1.301,0.571-1.301,1.314C9.716,22.818,10.324,23.391,11.019,23.391z"
        }), i.a.createElement("path", {
          fill: "#394F5A",
          d: "M63.342,46.193l-8.95-6.816c-1.379-1.052-3.328-0.805-4.428,0.518l-2.827-2.081\r c2.308-4.299,1.234-9.78-2.744-12.819c-0.591-0.452-1.216-0.819-1.861-1.119v-8.542c-0.042-2.408-1.996-4.38-4.384-4.38H4.724\r c-2.387,0-4.342,1.973-4.342,4.38v20.144c0,2.407,1.955,4.381,4.342,4.381h11.2l10.891,8.8c0.218,0.174,0.521,0.31,0.824,0.31\r c0.172,0,0.391-0.039,0.563-0.131c0.437-0.221,0.739-0.703,0.739-1.182v-7.797h2.094c0.394,0.43,0.817,0.837,1.296,1.201\r c4.015,3.071,9.601,2.593,13.069-0.901l2.813,2.071c-0.907,1.416-0.6,3.315,0.752,4.345l8.947,6.813\r c1.42,1.081,3.449,0.799,4.528-0.629l1.517-2.013C65.04,49.317,64.76,47.275,63.342,46.193z M30.401,26.94\r c-0.094,0.127-0.172,0.259-0.262,0.386h-19.12c-0.738,0-1.301,0.571-1.301,1.315c0,0.743,0.563,1.313,1.301,1.313H28.86\r c-0.759,2.405-0.58,5.002,0.448,7.271H27.6c-0.738,0-1.303,0.57-1.303,1.316v6.349l-9.116-7.354\r c-0.215-0.175-0.52-0.312-0.824-0.312H4.725c-0.956,0-1.736-0.789-1.736-1.752V15.33c0-0.964,0.78-1.753,1.736-1.753h33.419\r c0.954,0,1.736,0.789,1.736,1.753v7.735C36.373,22.528,32.687,23.892,30.401,26.94z M43.945,37.293\r c-1.763,2.345-4.7,3.263-7.359,2.562c-0.432-0.11-0.858-0.267-1.269-0.466c-0.41-0.198-0.81-0.442-1.188-0.729\r c-0.273-0.208-0.515-0.449-0.746-0.684c-0.221-0.237-0.422-0.488-0.614-0.749h-0.01c-1.537-2.091-1.843-4.898-0.71-7.27\r c0.199-0.417,0.44-0.817,0.727-1.202c0.154-0.205,0.338-0.37,0.511-0.554c1.741-1.863,4.305-2.584,6.683-2.032\r c0.381,0.091,0.759,0.22,1.132,0.378c0.06,0.026,0.122,0.041,0.184,0.071c0.43,0.194,0.847,0.437,1.241,0.729v-0.001\r c0.022,0.016,0.042,0.026,0.063,0.041C45.668,29.743,46.28,34.186,43.945,37.293z M61.622,48.962l-1.517,2.013\r c-0.099,0.131-0.279,0.156-0.41,0.059l-8.95-6.816c-0.125-0.104-0.156-0.283-0.054-0.414l1.517-2.016\r c0.1-0.127,0.28-0.153,0.41-0.056l8.946,6.817C61.693,48.646,61.718,48.828,61.622,48.962z"
        })));
      },
      "pb-list": function pbList(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M6.398,4.391c-1.107,0-2.008,0.9-2.008,2.008v52.203c0,1.107,0.901,2.008,2.008,2.008h52.203\r c1.107,0,2.008-0.9,2.008-2.008V6.398c0-1.108-0.9-2.008-2.008-2.008H6.398z M58.602,64.625H6.398\r c-3.328,0-6.023-2.695-6.023-6.023V6.398c0-3.328,2.696-6.023,6.023-6.023h52.203c3.325,0,6.023,2.696,6.023,6.023v52.203\r C64.625,61.93,61.927,64.625,58.602,64.625z"
        })), i.a.createElement("g", null, i.a.createElement("circle", {
          fill: "#394F5A",
          cx: "14.143",
          cy: "32.5",
          r: "4.589"
        })), i.a.createElement("g", null, i.a.createElement("circle", {
          fill: "#394F5A",
          cx: "14.143",
          cy: "18.732",
          r: "4.589"
        })), i.a.createElement("g", null, i.a.createElement("circle", {
          fill: "#394F5A",
          cx: "14.143",
          cy: "46.268",
          r: "4.589"
        })), i.a.createElement("g", null, i.a.createElement("rect", {
          x: "23.321",
          y: "16.438",
          fill: "#394F5A",
          width: "32.125",
          height: "4.589"
        })), i.a.createElement("g", null, i.a.createElement("rect", {
          x: "23.321",
          y: "30.206",
          fill: "#394F5A",
          width: "32.125",
          height: "4.589"
        })), i.a.createElement("g", null, i.a.createElement("rect", {
          x: "23.321",
          y: "43.974",
          fill: "#394F5A",
          width: "32.125",
          height: "4.589"
        }))));
      },
      "pb-message": function pbMessage(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M32.5,56.105c-5.755,0-11.314-1.393-16.077-4.026l-0.854-0.477l-7.457,4.454\r c-0.207,0.129-0.386,0.033-0.487-0.142c-0.058-0.104-0.052-0.194,0.021-0.317l4.063-6.74l-0.98-0.927\r c-4.528-4.291-7.022-9.769-7.022-15.435c0-13.021,12.918-23.612,28.795-23.612s28.797,10.593,28.797,23.612\r C61.297,45.514,48.377,56.105,32.5,56.105z M32.5,5.508c-17.745,0-32.184,12.107-32.184,26.986c0,6.174,2.512,12.132,7.107,16.914\r l-2.683,4.454c-0.701,1.166-0.726,2.554-0.065,3.717c0.671,1.181,1.918,1.914,3.254,1.914c0.663,0,1.333-0.187,1.922-0.541\r l5.793-3.462c5.066,2.614,10.87,3.99,16.854,3.99c17.746,0,32.184-12.106,32.184-26.986C64.684,17.615,50.246,5.508,32.5,5.508z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M33.538,35.062c-1.415,0-2.563-1.151-2.563-2.562s1.148-2.563,2.563-2.563\r c1.416,0,2.563,1.152,2.563,2.563S34.954,35.062,33.538,35.062z M33.538,26.271c-3.436,0-6.229,2.794-6.229,6.229\r c0,3.436,2.794,6.229,6.229,6.229c3.435,0,6.229-2.794,6.229-6.229C39.767,29.065,36.973,26.271,33.538,26.271z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M19.004,35.062c-1.416,0-2.563-1.151-2.563-2.562s1.147-2.563,2.563-2.563\r c1.415,0,2.562,1.152,2.562,2.563S20.419,35.062,19.004,35.062z M19.004,26.271c-3.436,0-6.229,2.794-6.229,6.229\r c0,3.436,2.793,6.229,6.229,6.229c3.434,0,6.229-2.794,6.229-6.229C25.233,29.065,22.438,26.271,19.004,26.271z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M48.073,35.062c-1.416,0-2.563-1.151-2.563-2.562s1.147-2.563,2.563-2.563\r c1.414,0,2.562,1.152,2.562,2.563C50.636,33.915,49.487,35.062,48.073,35.062z M48.073,26.271c-3.436,0-6.229,2.794-6.229,6.229\r c0,3.436,2.794,6.229,6.229,6.229c3.434,0,6.228-2.794,6.228-6.229C54.301,29.065,51.507,26.271,48.073,26.271z"
        }))));
      },
      "pb-spam": function pbSpam(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M10.566,10.092v29.112c0,8.198,7.176,15.047,21.934,20.922c14.758-5.881,21.934-12.724,21.934-20.922\r V10.092c-2.69,0.263-5.779,0.175-8.885-0.259C40.242,9.091,35.47,7.425,32.504,5.332c-2.974,2.091-7.746,3.76-13.047,4.5\r C16.346,10.268,13.258,10.355,10.566,10.092z M32.498,64.625c-0.283,0-0.563-0.054-0.831-0.165\r c-0.015-0.006-0.03-0.014-0.045-0.016C14.528,57.776,6.216,49.521,6.216,39.204V7.584c0-0.65,0.293-1.265,0.8-1.679\r c0.506-0.411,1.173-0.574,1.812-0.444c2.727,0.557,6.377,0.59,10.02,0.082c6.065-0.849,10.414-2.865,12.062-4.501\r c0.635-0.652,1.441-0.825,2.426-0.523c0.308,0.125,0.574,0.317,0.787,0.554c1.677,1.631,6.006,3.628,12.027,4.47\r c3.644,0.511,7.298,0.477,10.021-0.082c0.635-0.13,1.306,0.033,1.812,0.444c0.508,0.414,0.801,1.028,0.801,1.679v31.62\r c0,10.32-8.32,18.576-25.425,25.246c-0.008,0.002-0.016,0.006-0.019,0.008c-0.168,0.07-0.345,0.117-0.518,0.141\r C32.713,64.615,32.606,64.625,32.498,64.625C32.219,64.625,32.606,64.625,32.498,64.625C32.219,64.625,32.606,64.625,32.498,64.625\r z"
        })), i.a.createElement("g", null, i.a.createElement("polygon", {
          fill: "#394F5A",
          points: "45.155,23.77 41.231,19.844 32.5,28.576 23.769,19.844 19.845,23.768 28.576,32.5 19.845,41.23 \r 23.769,45.155 32.5,36.424 41.231,45.155 45.155,41.23 36.425,32.5  "
        })));
      },
      "pb-sync": function pbSync(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          width: n,
          height: r,
          className: t,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M55.53,55.007c-6.031,6.193-14.124,9.58-22.714,9.745c-0.165,0-0.248,0-0.411,0\r c-8.26,0-16.105-3.138-22.134-8.754v2.724c0,0.828-0.659,1.569-1.569,1.569l0,0c-0.826,0-1.569-0.658-1.569-1.569l-0.083-6.44\r c0-0.828,0.66-1.567,1.568-1.567l6.443-0.084c0.826,0,1.569,0.662,1.569,1.569c0,0.909-0.661,1.567-1.569,1.567h-2.644\r c5.451,5.117,12.47,7.845,19.902,7.845c0.083,0,0.246,0,0.33,0c7.764-0.084,15.114-3.222,20.563-8.755\r c7.846-8.095,10.406-19.655,6.61-30.226c-0.248-0.827,0.165-1.652,0.908-1.98c0.829-0.249,1.648,0.164,1.981,0.909\r C67.09,33.288,64.284,46.088,55.53,55.007z M5.068,42.373c0.25,0.827-0.165,1.65-0.908,1.981c-0.166,0.082-0.331,0.082-0.494,0.082\r c-0.661,0-1.24-0.413-1.488-0.991c-4.212-11.729-1.403-24.527,7.269-33.45l0,0c6.028-6.193,14.122-9.58,22.711-9.746\r C40.58,0.167,48.511,3.308,54.62,9.004V6.28c0-0.826,0.662-1.569,1.567-1.569c0.828,0,1.567,0.662,1.567,1.569l0.081,6.441\r c0,0.826-0.659,1.567-1.564,1.567l-6.446,0.083c-0.824,0-1.564-0.66-1.564-1.567c0-0.825,0.66-1.569,1.564-1.569h2.644\r C46.937,6.117,39.834,3.31,32.236,3.391c-7.763,0.083-15.113,3.22-20.563,8.754l0,0C3.748,20.158,1.187,31.719,5.068,42.373z\r M32.734,33.122C32.734,33.122,32.651,33.122,32.734,33.122c-1.569,0-2.726-0.497-3.55-1.486c-2.229-2.559-1.735-7.515-1.735-7.515\r v-0.083c0.247-5.119,3.965-5.531,5.039-5.531c0.081,0,0.081,0,0.164,0h0.083c0.828,0,5.04,0.081,5.285,5.531v0.083\r c0,0.083,0.494,5.039-1.73,7.515C35.378,32.625,34.221,33.04,32.734,33.122z M47.434,46.584h0.083c0.827,0,1.487-0.662,1.57-1.404\r c0.246-3.8-1.156-6.358-3.883-7.019c-4.789-1.237-6.774-2.725-7.43-3.633c0.329-0.248,0.659-0.496,0.905-0.829\r c3.057-3.468,2.561-9.25,2.561-9.909c-0.331-6.856-5.45-8.588-8.424-8.425c-2.972-0.083-8.092,1.569-8.422,8.425\r c-0.083,0.661-0.497,6.442,2.561,9.909c0.329,0.333,0.661,0.664,1.074,0.994c-0.743,0.909-2.806,2.309-7.35,3.468\r c-2.726,0.662-4.212,3.221-3.881,7.019c0.081,0.825,0.743,1.404,1.569,1.404h0.081c0.827-0.083,1.487-0.828,1.404-1.652\r c-0.083-1.239,0-3.387,1.569-3.798c6.11-1.487,8.505-3.635,9.498-5.205c0.577,0.166,1.157,0.166,1.817,0.248h0.082H32.9\r c0,0,0,0,0.082,0h0.084c0.744,0,1.403-0.082,2.064-0.248c0.909,1.57,3.383,3.718,9.498,5.205c1.568,0.411,1.65,2.559,1.568,3.798\r C45.948,45.756,46.527,46.501,47.434,46.584z"
        })));
      },
      "pb-webhook": function pbWebhook(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M50.533,48.523H18.784v3.349c-0.616,3.436-3.674,6.044-7.352,6.044c-4.121,0-7.464-3.277-7.464-7.323\r c0-2.495,1.272-4.697,3.214-6.021l-2.141-2.997c-2.905,1.982-4.808,5.285-4.808,9.018c0,6.066,5.012,10.986,11.196,10.986\r c5.546,0,10.15-3.955,11.04-9.148h27.908c0.644,1.091,1.848,1.823,3.228,1.823c2.058,0,3.729-1.637,3.729-3.661\r c0-2.021-1.672-3.659-3.729-3.659C52.332,46.934,51.203,47.562,50.533,48.523z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M8.094,49.072c0.065-0.159,0.141-0.311,0.229-0.467c0.687-1.173,1.928-1.827,3.207-1.831l13.997-23.886\r c-4.124-3.354-5.309-9.248-2.544-13.967c3.08-5.259,9.902-7.061,15.235-4.029c3.275,1.863,5.224,5.116,5.534,8.567l-3.706,0.317\r c-0.206-2.3-1.504-4.47-3.688-5.711c-3.556-2.022-8.105-0.822-10.16,2.683c-2.013,3.434-0.885,7.803,2.5,9.88l2.045,1.165\r L14.89,48.848c0.449,0.926,0.498,2.028,0.07,3.022c-0.524,1.398-1.888,2.395-3.491,2.395c-2.054,0-3.72-1.639-3.72-3.659\r C7.753,50.055,7.875,49.536,8.094,49.072z"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M32.311,18.039l15.693,26.784l1.87-1.064l0.031,0.054c0.016-0.008,0.032-0.021,0.049-0.029\r c3.557-2.024,8.088-0.85,10.123,2.621c2.034,3.469,0.797,7.927-2.759,9.945c-2.193,1.248-4.761,1.278-6.879,0.306l-1.582,3.302\r c3.179,1.449,7.015,1.398,10.301-0.471c5.335-3.035,7.188-9.717,4.139-14.922c-2.756-4.701-8.562-6.594-13.593-4.682\r L35.776,16.122c0.601-1.077,0.636-2.421-0.028-3.555c-1.018-1.734-3.286-2.32-5.064-1.309c-1.778,1.011-2.398,3.237-1.38,4.972\r C29.953,17.34,31.103,17.98,32.311,18.039z"
        }))));
      },
      "pb-phone": function pbPhone(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          x: "0px",
          y: "0px",
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 65 65",
          enableBackground: "new 0 0 65 65"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M22.44,36.38c-2.295-2.155-4.105-4.921-4.418-8.082c-0.312-3.169,1.055-6.603,4.495-9.583 c0.837-0.726,1.295-1.229,1.421-1.595c0.126-0.358,0.162-0.884-0.549-2.181l-7.623-9.636c-0.983-0.95-1.376-0.922-2.124-0.696 c-0.748,0.228-1.774,0.971-2.731,1.87c-6.143,5.936-8.074,10.962-7.13,16.233c0.944,5.269,5.055,11.077,11.985,17.771 c2.844,2.749,5.97,5.77,8.494,8.209c6.93,6.694,12.938,10.666,18.394,11.581c5.451,0.912,10.654-0.954,16.797-6.888 c0.933-0.925,1.703-1.919,1.936-2.643c0.231-0.719,0.262-1.099-0.721-2.051l-9.973-7.365c-1.345-0.685-1.884-0.652-2.259-0.532 c-0.382,0.127-0.897,0.566-1.647,1.376c-3.083,3.323-6.639,4.646-9.919,4.34c-3.269-0.301-6.131-2.049-8.36-4.269 M30.935,39.896 c1.87,1.896,4.127,3.065,6.255,3.299c2.187,0.203,4.486-0.495,7.036-3.241c0.789-0.853,1.652-1.836,3.108-2.307 c1.458-0.471,3.207-0.179,5.064,0.786c3.549,2.604,7.208,5.238,10.693,7.915c1.665,1.607,2.095,3.727,1.554,5.387 c-0.533,1.664-1.687,2.921-2.748,3.975c-5.923,5.968-12.943,8.852-19.831,7.842c-6.656-1.111-13.094-5.615-20.231-12.512 c-3.069-2.965-5.458-5.275-8.497-8.209C6.202,35.934,1.54,29.711,0.387,23.28C-0.98,15.33,3.391,8.856,8.504,4.118 c1.09-1.029,2.396-2.138,4.113-2.656c1.722-0.518,3.913-0.105,5.576,1.502c2.77,3.372,5.499,6.906,8.189,10.333 c1,1.799,1.304,3.486,0.817,4.893c-0.488,1.407-1.508,2.241-2.392,3.005c-2.842,2.462-3.563,4.69-3.354,6.795 c0.244,2.062,1.454,4.24,3.414,6.047"
        })));
      },
      "targeting-came-from-playbooks": function targetingCameFromPlaybooks(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "21" : n,
            a = e.height,
            o = void 0 === a ? "21" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 21 21"
        }, i.a.createElement("path", {
          d: "M18.219 20H2.782C1.799 20 1 19.2 1 18.219V9.313c0-.008.004-.014.004-.021.002-.043.015-.082.025-.124.01-.035.013-.07.028-.101.014-.031.037-.056.056-.084.025-.036.047-.073.08-.103l.012-.016L3.816 6.6c.046-.04.1-.063.153-.086V3.97c0-.328.266-.594.594-.594h2.976l2.572-2.23a.594.594 0 0 1 .778 0l2.57 2.228.001.002h2.977c.329 0 .594.266.594.594v2.517c.02.013.04.017.059.033l2.705 2.345c.005.005.008.011.012.016.033.03.055.067.08.103.02.028.042.053.057.084.014.031.018.066.027.1.01.042.024.082.025.125 0 .007.004.013.004.02v8.907C20 19.2 19.201 20 18.219 20zM2.429 9.374c.026.011.054.016.08.033l1.46.938V8.04l-1.54 1.334zM10.5 2.379l-1.148.996h2.297L10.5 2.379zM15.9 4.533H7.877c-.035.007-.069.019-.104.019-.03 0-.057-.014-.087-.019H5.138v6.547c0 .005-.003.01-.003.014l5.365 3.45 5.399-3.47v-6.54zM17.03 8.04v2.305l1.46-.938c.026-.017.054-.021.08-.033l-1.54-1.334zm1.857 2.524l-8.067 5.185a.59.59 0 0 1-.642 0l-8.03-5.162v7.635c0 .328.305.59.633.59h15.437c.327 0 .669-.262.669-.59v-7.658z"
        }));
      },
      "targeting-drift-behavior": function targetingDriftBehavior(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "21" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 21"
        }, i.a.createElement("path", {
          d: "M22.633 14.623a.363.363 0 0 1-.366-.36v-4.66c0-.197.164-.358.366-.358.203 0 .367.16.367.358v4.66a.363.363 0 0 1-.367.36zM20.048 20H3.952c-.617 0-1.119-.49-1.119-1.09V6.391c0-.6.502-1.09 1.119-1.09H6.5V3.817c-.631-.16-1.1-.717-1.1-1.383C5.4 1.643 6.058 1 6.867 1s1.466.643 1.466 1.434c0 .666-.469 1.223-1.1 1.383v1.485h9.9V3.817c-.63-.16-1.1-.717-1.1-1.383 0-.791.658-1.434 1.467-1.434s1.467.643 1.467 1.434c0 .666-.47 1.222-1.1 1.383v1.485h2.181c.617 0 1.119.49 1.119 1.09V18.91c0 .602-.502 1.09-1.119 1.09zM7.6 2.434a.726.726 0 0 0-.733-.717.726.726 0 0 0-.734.717c0 .395.33.717.734.717a.726.726 0 0 0 .733-.717zm10.633 0a.726.726 0 0 0-.733-.717.726.726 0 0 0-.733.717c0 .395.329.717.733.717a.726.726 0 0 0 .733-.717zm2.2 3.958a.38.38 0 0 0-.385-.373H3.952a.38.38 0 0 0-.385.373V18.91a.38.38 0 0 0 .385.374h16.096a.38.38 0 0 0 .385-.374V6.392zm-4.583 6.08c-.91 0-1.65-.724-1.65-1.614 0-.89.74-1.613 1.65-1.613.91 0 1.65.724 1.65 1.613 0 .89-.74 1.614-1.65 1.614zm0-2.51a.908.908 0 0 0-.917.896c0 .494.411.896.917.896a.907.907 0 0 0 .917-.896.908.908 0 0 0-.917-.896zm-7.333 2.51c-.91 0-1.65-.724-1.65-1.614 0-.89.74-1.613 1.65-1.613.91 0 1.65.724 1.65 1.613 0 .89-.74 1.614-1.65 1.614zm0-2.51a.908.908 0 0 0-.917.896c0 .494.411.896.917.896a.907.907 0 0 0 .916-.896.908.908 0 0 0-.916-.896zM7.6 14.264c.203 0 .367.16.367.359v.716H16.4v-.716c0-.199.164-.36.367-.36.202 0 .366.161.366.36v1.075a.362.362 0 0 1-.366.358H7.6a.362.362 0 0 1-.367-.358v-1.075c0-.199.164-.36.367-.36zm-6.233.359a.363.363 0 0 1-.367-.36v-4.66c0-.197.164-.358.367-.358.202 0 .366.16.366.358v4.66a.363.363 0 0 1-.366.36z"
        }));
      },
      "targeting-firmographics": function targetingFirmographics(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "21" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 24 21"
        }, i.a.createElement("path", {
          d: "M22.542 9.143h-2.758v7.238h1.344c.254 0 .458.202.458.452s-.204.452-.458.452H2.863a.455.455 0 0 1-.458-.452c0-.25.205-.452.458-.452h1.344V9.143H1.458a.458.458 0 0 1-.437-.317.449.449 0 0 1 .176-.507l10.537-7.238a.462.462 0 0 1 .523 0l10.487 7.203a.452.452 0 0 1-.202.859zM16.12 16.38h2.749V9.143h-2.75v7.238zm-3.665 0h2.749V9.143h-2.75v7.238zm-.917 0V9.143H8.79v7.238h2.748zm-6.414 0h2.75V9.143h-2.75v7.238zm6.873-14.378L2.919 8.238h18.153l-9.076-6.235zM1.458 19.095h21.075c.254 0 .458.202.458.452s-.204.453-.458.453H1.458A.455.455 0 0 1 1 19.547c0-.25.205-.452.458-.452z"
        }));
      },
      "targeting-geolocation": function targetingGeolocation(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "19" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 20 19"
        }, i.a.createElement("path", {
          d: "M19.892 18.722a.622.622 0 0 1-.517.278H.625a.623.623 0 0 1-.518-.278.643.643 0 0 1-.062-.59l2.5-6.334a.626.626 0 0 1 .58-.398H5a.63.63 0 0 1 .625.633.63.63 0 0 1-.625.634H3.548l-2 5.066h16.904l-2-5.066H15a.63.63 0 0 1-.625-.634c0-.35.28-.633.625-.633h1.875c.256 0 .485.158.58.398l2.5 6.333a.645.645 0 0 1-.063.591zm-9.485-3.675a.622.622 0 0 1-.814 0c-.213-.185-5.218-4.594-5.218-9.32C4.375 2.57 6.898 0 10 0s5.625 2.57 5.625 5.727c0 4.726-5.005 9.135-5.218 9.32zM10 1.267c-2.412 0-4.375 2.001-4.375 4.46 0 3.421 3.218 6.855 4.374 7.978 1.157-1.124 4.376-4.563 4.376-7.978 0-2.459-1.963-4.46-4.375-4.46zm-2.5 4.48C7.5 4.35 8.62 3.214 10 3.214c1.38 0 2.5 1.136 2.5 2.533 0 1.398-1.12 2.534-2.5 2.534-1.379 0-2.5-1.136-2.5-2.534zM10 7.014a1.26 1.26 0 0 0 1.25-1.267A1.26 1.26 0 0 0 10 4.481a1.26 1.26 0 0 0-1.25 1.266A1.26 1.26 0 0 0 10 7.014z"
        }));
      },
      "targeting-target-account": function targetingTargetAccount(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "22" : n,
            a = e.height,
            o = void 0 === a ? "22" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 22 22"
        }, i.a.createElement("path", {
          d: "M11 21C5.486 21 1 16.514 1 11S5.486 1 11 1s10 4.486 10 10-4.486 10-10 10zm.333-19.317V3a.333.333 0 1 1-.666 0V1.683c-4.88.174-8.81 4.104-8.984 8.983H3a.333.333 0 1 1 0 .667H1.683c.174 4.88 4.104 8.81 8.984 8.983V19a.333.333 0 1 1 .666 0v1.316c4.88-.173 8.81-4.103 8.984-8.983H19a.334.334 0 0 1 0-.667h1.317c-.174-4.879-4.104-8.809-8.984-8.983zm3 13.338H7.667A.667.667 0 0 1 7 14.355v-.833c0-.017.007-.031.01-.048.003-.025.005-.05.014-.073.009-.021.022-.038.034-.057.012-.017.02-.036.035-.05.018-.02.04-.032.062-.046.013-.009.023-.022.038-.029l2.208-1.026a3.44 3.44 0 0 1-.398-1.724c0-.004-.003-.007-.003-.011l.001-1.875c0-.009.004-.016.005-.025 0-.01-.003-.02-.001-.03.152-.904 1.133-1.513 1.966-1.527L11 7c.84 0 1.842.613 1.995 1.528.002.01-.002.02-.001.03 0 .009.005.016.005.025v1.875l-.002.011c.008.153.025.959-.398 1.724l2.208 1.026c.016.008.026.02.04.03.021.014.043.026.06.044.015.016.024.034.035.052.012.018.025.035.033.056.01.023.012.049.015.074.003.016.01.03.01.047v.833a.667.667 0 0 1-.667.666zm0-1.286l-2.363-1.1c-.009-.004-.014-.011-.023-.016-.013-.008-.027-.012-.04-.022-.008-.006-.012-.015-.02-.022a.337.337 0 0 1-.076-.104.335.335 0 0 1-.019-.06.332.332 0 0 1-.01-.062.342.342 0 0 1 .02-.127c.003-.01.002-.02.007-.03.005-.011.015-.018.022-.03.006-.01.008-.022.016-.032.542-.703.485-1.639.484-1.648 0-.007.003-.014.003-.02l-.001-.004V8.621c-.104-.54-.766-.944-1.31-.954H11c-.549 0-1.228.407-1.332.954l-.001 1.837v.003c0 .008.003.014.002.022-.002.024-.054.95.484 1.647.008.01.01.022.017.033.007.011.016.018.022.03.004.009.003.019.007.028a.3.3 0 0 1 .015.066.298.298 0 0 1-.005.124.352.352 0 0 1-.02.06.325.325 0 0 1-.032.053.31.31 0 0 1-.045.051c-.007.007-.01.016-.019.022-.012.01-.026.014-.04.021-.008.005-.014.013-.023.018l-2.363 1.099v.62h6.666v-.62z"
        }));
      },
      "targeting-url": function targetingUrl(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "17" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 17"
        }, i.a.createElement("path", {
          d: "M14.938 6.543l-2.34 2.475a.643.643 0 0 1-.945 0 .737.737 0 0 1 0-1.001l2.339-2.474c.432-.457.67-1.065.67-1.71 0-.646-.238-1.253-.67-1.71-.865-.913-2.37-.914-3.233 0l-3.424 3.62c-.891.943-.891 2.477 0 3.42.117.124.247.234.388.33.31.21.402.648.202.977a.658.658 0 0 1-.564.326.635.635 0 0 1-.36-.112 3.667 3.667 0 0 1-.613-.522c-1.412-1.493-1.412-3.924 0-5.42l3.425-3.62A3.504 3.504 0 0 1 12.375 0c.969 0 1.878.399 2.563 1.123A3.918 3.918 0 0 1 16 3.833a3.919 3.919 0 0 1-1.062 2.71zM5.24 14.879l3.424-3.621c.432-.457.67-1.064.67-1.71 0-.646-.238-1.253-.67-1.71a2.362 2.362 0 0 0-.37-.317.733.733 0 0 1-.194-.98.649.649 0 0 1 .925-.205c.209.144.405.313.584.502a3.92 3.92 0 0 1 1.063 2.71 3.918 3.918 0 0 1-1.063 2.71L6.185 15.88A3.518 3.518 0 0 1 3.623 17a3.514 3.514 0 0 1-2.563-1.12c-1.413-1.495-1.413-3.928 0-5.422l2.332-2.466a.643.643 0 0 1 .945 0 .737.737 0 0 1 0 1.001l-2.33 2.465a2.473 2.473 0 0 0-.67 1.71c0 .647.237 1.254.67 1.71a2.202 2.202 0 0 0 3.233 0z"
        }));
      },
      "targeting-website-behavior": function targetingWebsiteBehavior(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "22" : n,
            a = e.height,
            o = void 0 === a ? "20" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 22 20"
        }, i.a.createElement("path", {
          d: "M19.75 19H2.25C1.56 19 1 18.395 1 17.65V2.35C1 1.606 1.56 1 2.25 1h17.5c.69 0 1.25.606 1.25 1.35v15.3c0 .745-.56 1.35-1.25 1.35zm.417-16.65c0-.248-.187-.45-.417-.45H2.25c-.23 0-.417.202-.417.45V4.6h18.334V2.35zm0 3.15H1.833v12.15c0 .248.187.45.417.45h17.5c.23 0 .417-.202.417-.45V5.5zM13.17 16.168a.4.4 0 0 1-.295.132.4.4 0 0 1-.295-.132l-2.977-3.215-1.209 1.395c-.013.015-.03.021-.043.034-.023.02-.044.039-.07.054a.364.364 0 0 1-.08.03c-.018.006-.033.017-.052.02-.014.003-.028.003-.041.004H8.1l-.012.001a.374.374 0 0 1-.126-.025c-.006-.002-.012-.001-.018-.004a.412.412 0 0 1-.133-.088l-.007-.005c-.01-.01-.015-.025-.025-.037a.439.439 0 0 1-.06-.093c-.01-.022-.016-.046-.022-.07-.007-.021-.018-.04-.02-.064l-.84-6.29a.472.472 0 0 1 .117-.383.394.394 0 0 1 .354-.128l5.83.902c.018.003.034.015.052.02.027.009.053.016.079.03.025.015.047.034.07.054.014.013.03.02.043.034.006.006.007.014.012.02.02.025.032.052.046.08.012.025.025.048.032.073.008.026.01.053.012.08.004.032.008.063.005.095 0 .008.003.015.002.023-.003.02-.013.035-.018.054-.008.03-.015.06-.029.088a.439.439 0 0 1-.052.078c-.01.015-.016.032-.029.045l-1.296 1.312 2.977 3.215a.475.475 0 0 1 0 .636l-1.875 2.025zM11.173 10.6a.472.472 0 0 1 .01-.646l.978-.988-4.42-.684.637 4.768L9.29 12a.394.394 0 0 1 .614.006l2.972 3.209 1.286-1.389-2.988-3.226zM3.092 2.8h.004c.23 0 .416.202.416.45 0 .249-.186.45-.416.45-.23 0-.419-.201-.419-.45 0-.248.185-.45.415-.45zm1.25 0h.004c.23 0 .416.202.416.45 0 .249-.186.45-.416.45-.23 0-.419-.201-.419-.45 0-.248.185-.45.415-.45zm1.25 0h.004c.23 0 .416.202.416.45 0 .249-.186.45-.416.45-.23 0-.419-.201-.419-.45 0-.248.185-.45.415-.45z"
        }));
      },
      redo: function redo(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "9" : n,
            a = e.height,
            o = void 0 === a ? "11" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0.405 -0.009 8.58 10.968"
        }, i.a.createElement("g", null, i.a.createElement("g", {
          transform: "translate(-1444.000000, -116.000000)"
        }, i.a.createElement("g", {
          transform: "translate(1391.000000, 103.000000)"
        }, i.a.createElement("g", {
          transform: "translate(56.517678, 18.492678) scale(-1, 1) rotate(45.000000) translate(-56.517678, -18.492678) translate(51.017678, 15.992678)"
        }, i.a.createElement("path", {
          fill: "#394F5A",
          d: "M10.976,4.428C10.124,2.03,7.922,0.418,5.5,0.418c-1.916,0-3.689,1.01-4.771,2.617l0-2.649 c0-0.213-0.163-0.386-0.364-0.386C0.163,0,0,0.173,0,0.386L0,4.564c0,0.002,0,0.004,0,0.007 c0.001,0.015,0.002,0.029,0.005,0.043c0.001,0.012,0.002,0.022,0.003,0.034c0.003,0.011,0.007,0.023,0.01,0.035 C0.023,4.696,0.027,4.708,0.031,4.72c0.004,0.011,0.01,0.02,0.015,0.03c0.006,0.011,0.012,0.023,0.019,0.034 c0.006,0.01,0.015,0.019,0.022,0.029C0.095,4.822,0.102,4.832,0.11,4.841c0.008,0.008,0.018,0.015,0.028,0.022 c0.009,0.009,0.017,0.017,0.028,0.023c0.008,0.007,0.018,0.011,0.029,0.016C0.205,4.91,0.217,4.916,0.23,4.922 c0.002,0.001,0.005,0.002,0.006,0.003C0.244,4.929,0.253,4.93,0.262,4.932C0.274,4.936,0.287,4.94,0.3,4.943 c0.012,0.003,0.026,0.003,0.038,0.005C0.347,4.948,0.356,4.95,0.365,4.95l3.95,0c0.202,0,0.365-0.172,0.365-0.385 C4.68,4.351,4.516,4.179,4.315,4.179H0.926C1.786,2.371,3.56,1.189,5.5,1.189c2.121,0,4.048,1.411,4.794,3.511 c0.055,0.154,0.194,0.25,0.341,0.25c0.042,0,0.086-0.007,0.128-0.025C10.952,4.85,11.048,4.628,10.976,4.428"
        }))))));
      },
      undo: function undo(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "9" : n,
            a = e.height,
            o = void 0 === a ? "11" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0.404 -0.009 8.58 10.968"
        }, i.a.createElement("g", null, i.a.createElement("g", {
          transform: "translate(-1444.000000, -116.000000)"
        }, i.a.createElement("g", {
          transform: "translate(1391.000000, 103.000000)"
        }, i.a.createElement("g", {
          id: "Page-1",
          transform: "translate(56.517678, 18.492678) scale(-1, 1) rotate(45.000000) translate(-56.517678, -18.492678) translate(51.017678, 15.992678)"
        }, i.a.createElement("path", {
          id: "Fill-1",
          fill: "#394F5A",
          d: "M5.764,9.64c0.2,0.071,0.422-0.024,0.497-0.213c0.017-0.042,0.025-0.086,0.025-0.128 C6.286,9.152,6.19,9.013,6.036,8.958c-2.1-0.746-3.511-2.674-3.511-4.794c0-1.94,1.182-3.714,2.99-4.574v3.389 c0,0.201,0.172,0.365,0.385,0.365C6.114,3.344,6.286,3.18,6.286,2.979v-3.95c0-0.009-0.001-0.018-0.002-0.027 C6.282-1.01,6.281-1.024,6.279-1.036c-0.002-0.013-0.006-0.026-0.01-0.038C6.266-1.083,6.264-1.092,6.262-1.1 C6.26-1.102,6.259-1.104,6.258-1.106C6.252-1.119,6.246-1.131,6.239-1.142c-0.005-0.01-0.009-0.02-0.016-0.029 C6.216-1.181,6.208-1.19,6.199-1.198c-0.007-0.01-0.014-0.02-0.022-0.028C6.168-1.234,6.158-1.241,6.149-1.249 C6.139-1.256,6.13-1.264,6.12-1.271C6.109-1.278,6.097-1.284,6.086-1.289c-0.01-0.005-0.02-0.011-0.03-0.015 C6.044-1.309,6.032-1.313,6.02-1.317C6.008-1.32,5.996-1.324,5.984-1.327C5.973-1.329,5.962-1.33,5.951-1.331 C5.937-1.334,5.922-1.335,5.907-1.335c-0.003,0-0.005-0.001-0.007,0L1.722-1.336c-0.213,0-0.386,0.164-0.386,0.365 c0,0.201,0.173,0.364,0.386,0.364l2.649,0C2.764,0.475,1.754,2.248,1.754,4.164C1.754,6.587,3.366,8.788,5.764,9.64"
        }))))));
      },
      rocket: function rocket(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? 24 : n,
            a = e.height,
            o = void 0 === a ? 24 : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o
        }, i.a.createElement("g", {
          fill: "#B5D2E1"
        }, i.a.createElement("path", {
          d: "M15.56.88a.98.98 0 0 0-.18-.26h-.04l-.2-.14C13.88-.32 9.44.36 6.4 3.4c-.385.386-.739.8-1.06 1.24l-2.12.52a3.92 3.92 0 0 0-1.98 1.18l-.82.9a1 1 0 0 0 1.1 1.6l.56-.22a1.14 1.14 0 0 1 1.1.16l.46.34 3.16 3.22.36.48c.24.314.301.73.16 1.1l-.22.56a.98.98 0 0 0 .38 1.18.98.98 0 0 0 1.24-.08l.9-.82a3.92 3.92 0 0 0 1.2-1.96l.54-2.14c.44-.321.854-.676 1.24-1.06a11.52 11.52 0 0 0 2.86-4.98c.46-1.58.48-3.04.1-3.74zm-13.7 6.6l.28-.32a2.72 2.72 0 0 1 1.36-.82l.92-.24a12.14 12.14 0 0 0-.7 1.64 2.34 2.34 0 0 0-1.86-.28v.02zm7.8 5.04a2.72 2.72 0 0 1-.82 1.36l-.32.28a2.34 2.34 0 0 0-.26-1.88c.564-.2 1.112-.44 1.64-.72l-.24.96zm2.08-3.78a10.38 10.38 0 0 1-4.3 2.54L4.72 8.54a10.38 10.38 0 0 1 2.52-4.3c2.8-2.8 6.64-3.12 7.26-2.76.36.66.02 4.48-2.76 7.26z"
        }), i.a.createElement("path", {
          d: "M1.46 14.56l.12.1c.294.16.626.236.96.22a3.64 3.64 0 0 0 2.5-1c.261-.265.49-.56.68-.88a.6.6 0 0 0-.1-.7l-1.88-1.92a.6.6 0 0 0-.72-.12 4.64 4.64 0 0 0-.92.7c-1.06 1.06-1.2 2.76-.8 3.42l.12.16.04.02zm1.52-2.76l.28-.24 1.18 1.2-.24.26a2.42 2.42 0 0 1-1.86.64 2.42 2.42 0 0 1 .64-1.86zM10.3 3.14a1.81 1.81 0 1 0 2.56 2.56 1.81 1.81 0 0 0-2.56-2.56zm1.7 1.7a.6.6 0 1 1-.837-.86.6.6 0 0 1 .837.86z"
        })));
      },
      eye: function eye(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o
        }, i.a.createElement("path", {
          d: "M8 12c-5.197 0-8-4.259-8-6 0-1.741 2.803-6 8-6s8 4.259 8 6c0 1.741-2.803 6-8 6zM8 1.333C3.477 1.333 1.333 5.077 1.333 6c0 .923 2.144 4.667 6.667 4.667S14.667 6.923 14.667 6c0-.923-2.144-4.667-6.667-4.667zm0 8A3.337 3.337 0 0 1 4.667 6 3.337 3.337 0 0 1 8 2.667 3.337 3.337 0 0 1 11.333 6 3.337 3.337 0 0 1 8 9.333zM8 4c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z",
          fill: "#7695A5",
          fillRule: "evenodd"
        }));
      },
      "eye-off": function eyeOff(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o
        }, i.a.createElement("path", {
          fill: "#94C8FF",
          fillRule: "evenodd",
          d: "M12.09 3.623l-.002.001-9.861 9.839a.47.47 0 0 1-.665-.664l1.944-1.939C1.606 9.576.64 8.05.512 7.223a.466.466 0 0 1-.042-.19c0-1.497 2.636-5.16 7.523-5.16 1.821 0 2.85.465 3.674.845l2.12-2.115a.469.469 0 1 1 .665.664l-2.363 2.356zM6.39 7.983L8.96 5.42a1.864 1.864 0 0 0-.951-.264 1.88 1.88 0 0 0-1.881 1.876c0 .34.094.663.264.95zM7.993 2.81c-4.404 0-6.52 3.289-6.577 4.181.001.015.008.026.008.04 0 .307.712 1.82 2.76 3.15L5.713 8.66a2.783 2.783 0 0 1-.526-1.628 2.82 2.82 0 0 1 2.822-2.814 2.8 2.8 0 0 1 1.63.524l1.319-1.315c-.71-.314-1.562-.616-2.964-.616zm-.456 6.567c0-.259.21-.469.47-.469a1.88 1.88 0 0 0 1.88-1.876.47.47 0 0 1 .941 0 2.821 2.821 0 0 1-2.82 2.815.47.47 0 0 1-.471-.47zm-1.302 1.683a7.91 7.91 0 0 0 1.772.193c4.465 0 6.583-3.386 6.583-4.221 0-.399-.546-1.456-1.717-2.458a.469.469 0 1 1 .612-.712c1.204 1.03 2.045 2.334 2.045 3.17 0 1.497-2.636 5.16-7.523 5.16a8.85 8.85 0 0 1-1.98-.217.47.47 0 1 1 .208-.915z"
        }));
      },
      "categories-1": function categories1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "12" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o
        }, i.a.createElement("path", {
          d: "M13.887 11.555a.447.447 0 0 1-.3.144l-3.906.28a.429.429 0 0 1-.47-.378l-.458-5.287v5.254a.426.426 0 0 1-.438.413H.437A.426.426 0 0 1 0 11.568V.826C0 .598.196.413.438.413H8.315c.193 0 .351.119.41.281l3.889-.28c.24-.02.45.152.47.378l.906 10.461a.398.398 0 0 1-.103.302zM3.94 1.24H.875v1.653H3.94V1.239zm0 2.479H.875v7.437H3.94V3.718zm3.939-2.48H4.814v1.654h3.064V1.239zm0 2.48H4.814v7.437h3.064V3.718zm4.368-2.449l-3.034.219.143 1.64 3.034-.219-.143-1.64zm.214 2.463l-3.034.22.623 7.173 3.033-.219-.622-7.174zm-1.134 5.772l.45-.039a.43.43 0 0 1 .476.374.421.421 0 0 1-.396.45l-.45.038a.429.429 0 0 1-.476-.374.42.42 0 0 1 .396-.45zm-5.199-.002h.438c.242 0 .437.185.437.413a.425.425 0 0 1-.437.413h-.438c-.242 0-.438-.184-.438-.413 0-.228.196-.413.438-.413zm-3.939 0h.438c.242 0 .438.185.438.413 0 .229-.196.413-.438.413h-.438c-.241 0-.437-.184-.437-.413 0-.228.196-.413.437-.413z",
          fill: "#7695A5",
          fillRule: "evenodd"
        }));
      },
      "categories-2": function categories2(e) {
        var t = e.width,
            n = void 0 === t ? "18" : t,
            r = e.height,
            a = void 0 === r ? "16" : r,
            o = e.className;
        return i.a.createElement("svg", {
          className: o,
          width: n,
          height: a
        }, i.a.createElement("path", {
          d: "M17.855 14.857a.567.567 0 0 1-.385.192l-5.023.374a.558.558 0 0 1-.604-.504l-.59-7.05v7.005a.557.557 0 0 1-.562.551H.563A.557.557 0 0 1 0 14.874V.552C0 .247.252 0 .563 0h10.128c.247 0 .451.158.526.375l5.001-.374a.557.557 0 0 1 .604.504l1.166 13.949a.543.543 0 0 1-.133.402zM4.939 1H1v2.204h3.939V1zm0 3H1v9.916h3.939V4zm5-3H6v2.204h3.939V1zm0 3H6v9.916h3.939V4zM15.9 1L12 1.292l.183 2.186 3.901-.292L15.901 1zm0 3L12 4.292l.8 9.565 3.9-.292L15.9 4zm-1.39 8.054l.58-.051c.31-.03.583.194.611.498a.555.555 0 0 1-.509.599l-.58.051a.558.558 0 0 1-.611-.499.555.555 0 0 1 .51-.598zM7.563 12h.563c.31 0 .562.246.562.55 0 .305-.251.551-.562.551h-.563a.557.557 0 0 1-.563-.55c0-.305.252-.551.563-.551zm-5 0h.562c.311 0 .563.246.563.55 0 .305-.252.551-.563.551h-.563a.556.556 0 0 1-.562-.55c0-.305.252-.551.563-.551z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      "section-1": function section1(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "9" : n,
            a = e.height,
            o = void 0 === a ? "12" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o
        }, i.a.createElement("path", {
          d: "M8.625 2.25c.207 0 .375.168.375.375v9a.375.375 0 0 1-.375.375H1.5C.673 12 0 11.327 0 10.5v-9C0 .672.673 0 1.5 0h7.125a.375.375 0 1 1 0 .75.75.75 0 0 0 0 1.5zM1.5.75a.75.75 0 0 0 0 1.5h5.83a1.476 1.476 0 0 1-.205-.75c0-.274.08-.528.208-.75H1.5zM1.5 3c-.274 0-.528-.08-.75-.209V10.5c0 .413.336.75.75.75h6.75V3H1.5z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      "section-2": function section2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "11" : n,
            a = e.height,
            o = void 0 === a ? "14 " : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o
        }, i.a.createElement("path", {
          d: "M10.542 2.625c.253 0 .458.196.458.438v10.5a.448.448 0 0 1-.458.437H1.833C.823 14 0 13.215 0 12.25V1.75C0 .784.822 0 1.833 0h8.709c.253 0 .458.196.458.438a.448.448 0 0 1-.458.437c-.506 0-.917.392-.917.875 0 .482.411.875.917.875zM1.917 1C1.41 1 1 1.392 1 1.875c0 .482.411.875.917.875h7.126a1.663 1.663 0 0 1-.251-.875c0-.32.097-.616.255-.875h-7.13zm0 2.243A1.88 1.88 0 0 1 1 3v8.993c0 .482.411.875.917.875h8.25V3.243h-8.25z",
          fill: "#394F5A",
          fillRule: "evenodd"
        }));
      },
      "chevron-right-bold": function chevronRightBold(e) {
        var t = e.width,
            n = void 0 === t ? "7" : t,
            r = e.height,
            a = void 0 === r ? "12" : r,
            o = e.className;
        return i.a.createElement("svg", {
          className: o,
          width: n,
          height: a
        }, i.a.createElement("path", {
          d: "M6.674 6.843A1.135 1.135 0 0 0 6.68 5.26L1.904.337A1.102 1.102 0 0 0 .333.322a1.135 1.135 0 0 0-.014 1.591L4.32 6.056.326 10.08a1.135 1.135 0 0 0-.001 1.59c.434.44 1.137.441 1.572.002l4.777-4.828z",
          fill: "#394F5A",
          fillRule: "nonzero"
        }));
      },
      "chevron-down-bold": function chevronDownBold(e) {
        var t = e.className,
            n = e.height,
            r = void 0 === n ? "7" : n,
            a = e.width,
            o = void 0 === a ? "12" : a;
        return i.a.createElement("svg", {
          className: t,
          width: o,
          height: r
        }, i.a.createElement("path", {
          d: "M5.157 6.674a1.135 1.135 0 0 0 1.584.007l4.922-4.777c.444-.43.45-1.133.015-1.571a1.135 1.135 0 0 0-1.591-.014L5.944 4.32 1.92.326A1.135 1.135 0 0 0 .331.325a1.102 1.102 0 0 0-.002 1.572l4.828 4.777z",
          fill: "#394F5A",
          fillRule: "nonzero"
        }));
      },
      "chevron-up-bold": function chevronUpBold(e) {
        var t = e.className,
            n = e.height,
            r = void 0 === n ? "7" : n,
            a = e.width,
            o = void 0 === a ? "12" : a;
        return i.a.createElement("svg", {
          className: t,
          width: o,
          height: r,
          style: {
            transform: "rotate(180deg)"
          }
        }, i.a.createElement("path", {
          d: "M5.157 6.674a1.135 1.135 0 0 0 1.584.007l4.922-4.777c.444-.43.45-1.133.015-1.571a1.135 1.135 0 0 0-1.591-.014L5.944 4.32 1.92.326A1.135 1.135 0 0 0 .331.325a1.102 1.102 0 0 0-.002 1.572l4.828 4.777z",
          fill: "#394F5A",
          fillRule: "nonzero"
        }));
      },
      hamburger: function hamburger(e) {
        var t = e.width,
            n = void 0 === t ? "14" : t,
            r = e.height,
            a = void 0 === r ? "10" : r;
        return i.a.createElement("svg", {
          width: n,
          height: a
        }, i.a.createElement("g", {
          stroke: "#7695A5",
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "square"
        }, i.a.createElement("path", {
          d: "M1.441.5h12M1.441 5h12M1.441 9.5h12"
        })));
      },
      meatballs: function meatballs(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 30 30",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.5 18C7.88071 18 9 16.8807 9 15.5C9 14.1193 7.88071 13 6.5 13C5.11929 13 4 14.1193 4 15.5C4 16.8807 5.11929 18 6.5 18ZM14.5 18C15.8807 18 17 16.8807 17 15.5C17 14.1193 15.8807 13 14.5 13C13.1193 13 12 14.1193 12 15.5C12 16.8807 13.1193 18 14.5 18ZM25 15.5C25 16.8807 23.8807 18 22.5 18C21.1193 18 20 16.8807 20 15.5C20 14.1193 21.1193 13 22.5 13C23.8807 13 25 14.1193 25 15.5Z",
          fill: "#353F45"
        }));
      },
      "circle-line": function circleLine(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "14" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 12 12"
        }, i.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          transform: "translate(-398.000000, -326.000000)",
          stroke: "#7695A5"
        }, i.a.createElement("g", {
          transform: "translate(399.000000, 284.000000)"
        }, i.a.createElement("g", {
          transform: "translate(0.000000, 43.000000)"
        }, i.a.createElement("g", null, i.a.createElement("circle", {
          strokeWidth: "0.5",
          cx: "5",
          cy: "5",
          r: "5"
        }), i.a.createElement("path", {
          d: "M2.85874548,5.07565111 L7.28264633,5.07565111",
          fill: "#D8D8D8",
          strokeLinecap: "round"
        })))))));
      },
      "circle-check-2": function circleCheck2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "14" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 12 12"
        }, i.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          transform: "translate(-398.000000, -408.000000)",
          stroke: "#7695A5"
        }, i.a.createElement("g", {
          transform: "translate(399.000000, 284.000000)"
        }, i.a.createElement("g", {
          transform: "translate(0.000000, 125.000000)"
        }, i.a.createElement("g", null, i.a.createElement("circle", {
          strokeWidth: "0.5",
          cx: "5",
          cy: "5",
          r: "5"
        }), i.a.createElement("polyline", {
          strokeLinecap: "round",
          points: "2.85874548 5.07565111 4.30973174 6.54263831 7.11187993 3.4083043"
        })))))));
      },
      "circle-empty": function circleEmpty(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "14" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 12 12"
        }, i.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          transform: "translate(-398.000000, -283.000000)",
          stroke: "#7695A5",
          strokeWidth: "0.5"
        }, i.a.createElement("g", {
          transform: "translate(399.000000, 284.000000)"
        }, i.a.createElement("g", null, i.a.createElement("circle", {
          cx: "5",
          cy: "5",
          r: "5"
        }))))));
      },
      ticket: function ticket(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "32" : n,
            a = e.height,
            o = void 0 === a ? "22" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 32 22"
        }, i.a.createElement("path", {
          d: "M29 22H3c-1.654 0-3-1.345-3-2.999V3c0-1.654 1.346-3 3-3h26c1.654 0 3 1.346 3 3v16.001A3.003 3.003 0 0 1 29 22zm1-19c0-.551-.449-1-1-1H3c-.551 0-1 .449-1 1v16.001c0 .55.449.999 1 .999h26c.551 0 1-.449 1-.999V3zm-3 9h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-1-6h-4v4h4V6zM16 17H6a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2zm0-4H6a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2zm-6-5H6a1 1 0 0 1 0-2h4a1 1 0 1 1 0 2z",
          fillRule: "evenodd"
        }));
      },
      "support-bot": function supportBot(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "30" : n,
            a = e.height,
            o = void 0 === a ? "30" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 30 30"
        }, i.a.createElement("defs", null, i.a.createElement("path", {
          d: "M17.564 21.764H2.558A2.19 2.19 0 0 1 .393 19.56V7.23a2.19 2.19 0 0 1 2.165-2.204h1.6V3.505a.748.748 0 0 1 0-.197 1.482 1.482 0 1 1 1.417 0 .748.748 0 0 1 0 .197v1.521h8.92V3.505a.748.748 0 0 1 0-.197 1.482 1.482 0 1 1 1.416 0 .748.748 0 0 1 0 .197v1.521h1.548a2.19 2.19 0 0 1 2.164 2.204v12.29a2.19 2.19 0 0 1-2.06 2.217v.027zm.682-14.508a.682.682 0 0 0-.682-.747H2.558a.682.682 0 0 0-.682.695v12.29a.682.682 0 0 0 .682.696h15.006a.682.682 0 0 0 .682-.696V7.256zM4.866 15.69a.748.748 0 1 1 1.483 0h7.424a.748.748 0 1 1 1.482 0v1.522H4.866V15.69zm8.474-2.308a1.902 1.902 0 1 1 1.863-1.902 1.876 1.876 0 0 1-1.863 1.902zm0-2.283a.38.38 0 1 0-.026.76.38.38 0 0 0 .026-.76zm-6.558 2.283a1.902 1.902 0 1 1 1.797-1.902 1.876 1.876 0 0 1-1.797 1.902zm0-2.283a.38.38 0 1 0-.027.76.38.38 0 0 0 .027-.76z",
          id: "a"
        })), i.a.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          transform: "translate(5 6)"
        }, i.a.createElement("mask", {
          id: "b",
          fill: "#fff"
        }, i.a.createElement("use", {
          xlinkHref: "#a"
        })), i.a.createElement("use", {
          fill: "#000",
          fillRule: "nonzero",
          xlinkHref: "#a"
        }), i.a.createElement("g", {
          mask: "url(#b)",
          fill: "#394F5A"
        }, i.a.createElement("path", {
          d: "M-5-5h30v30H-5z"
        }))), i.a.createElement("path", {
          d: "M18.3 24.5c1.958-.444 3.4-.84 4.326-1.19.926-.35 2.134-.953 3.624-1.81",
          stroke: "#394F5A",
          strokeWidth: "1.5",
          strokeLinecap: "square"
        }), i.a.createElement("g", {
          fill: "#394F5A",
          fillRule: "nonzero"
        }, i.a.createElement("path", {
          d: "M26.938 15.375h-1.375a.689.689 0 0 0-.688.688v5.5c0 .378.309.687.688.687h1.375a.689.689 0 0 0 .687-.688v-5.5a.689.689 0 0 0-.688-.687zM2.375 21.563c0 .378.309.687.688.687h1.374a.689.689 0 0 0 .688-.688v-5.5a.689.689 0 0 0-.688-.687H3.063a.689.689 0 0 0-.687.688v5.5zM25.5 14.382v-.13c0-5.429-4.71-9.845-10.5-9.845S4.5 8.823 4.5 14.253v.13c.015-.006.031.314.048.958L3 15.358v-1.105C3 8.048 8.383 3 15 3c6.616 0 12 5.048 12 11.253v1.1l-1.518.015c-.001-.662.005-.99.018-.986z"
        })), i.a.createElement("circle", {
          fill: "#394F5A",
          fillRule: "nonzero",
          cx: "18",
          cy: "24.5",
          r: "1"
        })));
      },
      outreach: function outreach(e) {
        var t = e.className,
            n = e.width,
            r = e.height;
        return i.a.createElement("svg", {
          className: t,
          width: n,
          height: r,
          viewBox: "0 0 27 25",
          version: "1.1"
        }, i.a.createElement("g", {
          id: "enroll-in-outreach",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "Artboard-Copy-2",
          transform: "translate(-125.000000, -141.000000)",
          fill: "#FFFFFF"
        }, i.a.createElement("g", {
          id: "Group-7",
          transform: "translate(125.000000, 141.000000)"
        }, i.a.createElement("path", {
          d: "M11.7399564,0 C15.7828962,0 21.8918356,1.25115191 24.7355609,4.12029489 C25.4559714,4.84777061 26.3985892,6.27259517 26.3985892,8.35932516 C26.3985892,12.0693627 23.4358241,17.7615723 20.1644377,21.0631247 C18.4731927,22.7697243 15.7828962,25 12.1640904,25 C8.62640783,25 5.92464829,22.5756717 5.14251359,21.78617 C2.1462411,18.7628482 2.55795385e-13,14.1738144 2.55795385e-13,9.89491033 C2.55795385e-13,7.19500957 0.762735641,4.83359325 2.70881375,2.87091515 C4.51116247,1.05266889 7.61677511,1.57400301e-15 11.7399564,0 Z M16.7440313,14.795846 C18.1090195,13.417984 18.4767198,11.7211314 18.4767198,10.7871978 C18.4767198,10.110229 18.3003647,9.11692777 17.4609146,8.27071667 C16.1735227,6.97171617 14.747692,6.60487701 13.1966493,6.60487701 C11.2320539,6.60487701 9.91203623,7.23133905 9.03290625,8.11919614 C8.34335796,8.81477281 7.74727785,9.88427731 7.74727785,11.403913 C7.74727785,12.9226625 8.54969338,14.3900191 9.42441449,15.2716736 C10.2321207,16.0868718 11.5018771,16.6902956 12.7804513,16.6902956 C14.0590255,16.6902956 15.3790431,16.1737081 16.7440313,14.795846 Z",
          id: "Combined-Shape"
        })))));
      },
      "emoji-face": function emojiFace(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 15"
        }, i.a.createElement("path", {
          d: "M8 15c-4.411 0-8-3.364-8-7.5S3.589 0 8 0s8 3.364 8 7.5S12.411 15 8 15zM8 1.25c-3.676 0-6.667 2.804-6.667 6.25S4.324 13.75 8 13.75c3.676 0 6.667-2.804 6.667-6.25S11.676 1.25 8 1.25zM8 12.5c-1.942 0-3.705-1.094-4.601-2.856-.16-.312-.018-.685.314-.833.33-.15.73-.017.888.295C5.275 10.428 6.577 11.25 8 11.25c1.431 0 2.733-.82 3.397-2.142.156-.312.554-.447.888-.299.332.148.475.52.318.833C11.717 11.404 9.953 12.5 8 12.5zm2.667-5c-.735 0-1.334-.56-1.334-1.25S9.932 5 10.667 5C11.402 5 12 5.56 12 6.25s-.598 1.25-1.333 1.25zm-5.334 0C4.6 7.5 4 6.94 4 6.25S4.599 5 5.333 5c.736 0 1.334.56 1.334 1.25S6.069 7.5 5.333 7.5z"
        }));
      },
      expand: function expand(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o
        }, i.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          transform: "translate(-681.000000, -475.000000)",
          fill: "#FFFFFF"
        }, i.a.createElement("g", {
          transform: "translate(681.000000, 475.000000)"
        }, i.a.createElement("path", {
          d: "M14.343,14 L5.9742,14 C5.6442,14 5.3766,13.7386667 5.3766,13.4166667 C5.3766,13.0946667 5.6442,12.8333333 5.9742,12.8333333 L13.7454,12.8333333 L13.7454,1.16666667 L1.7436,1.16666667 L1.7436,8.75 C1.7436,9.072 1.5228,9.33333333 1.1922,9.33333333 C0.8622,9.33333333 0.5946,9.072 0.5946,8.75 L0.5946,0.583333333 C0.5946,0.261333333 0.8622,0 1.1922,0 L14.343,0 C14.673,0 14.9406,0.261333333 14.9406,0.583333333 L14.9406,13.4166667 C14.9406,13.7386667 14.673,14 14.343,14 Z M8.7162,5.25 L5.376,5.25 C5.046,5.25 4.7784,4.98866667 4.7784,4.66666667 C4.7784,4.34466667 5.046,4.08333333 5.376,4.08333333 L10.1592,4.08333333 C10.4892,4.08333333 10.7568,4.34466667 10.7568,4.66666667 L10.7568,9.33333333 C10.7568,9.65533333 10.4892,9.91666667 10.1592,9.91666667 C9.8292,9.91666667 9.5616,9.65533333 9.5616,9.33333333 L9.5616,6.07483333 L1.6152,13.8290833 C1.4982,13.9428333 1.3452,14 1.1922,14 C1.0392,14 0.8868,13.9428333 0.7698,13.8290833 C0.5364,13.6015833 0.5364,13.2323333 0.7698,13.00425 L8.7162,5.25 Z",
          id: "Shape"
        })))));
      },
      "lightning-bolt": function lightningBolt(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 14 24"
        }, i.a.createElement("path", {
          fill: "#394F5A",
          fillRule: "nonzero",
          d: "M8.61 2L2 12.148h4.848L3.91 20.623l7.492-10.482h-5.29L8.61 2zm2.792 6.14c1.627 0 2.573 1.84 1.627 3.164L5.537 21.786c-1.343 1.879-4.273.364-3.517-1.818l2.018-5.82H2c-1.588 0-2.542-1.761-1.676-3.092L6.934.908C8.2-1.034 11.204.371 10.524 2.587L8.817 8.141h2.585z"
        }));
      },
      "lightning-bolt-filled": function lightningBoltFilled(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "11" : n,
            a = e.height,
            o = void 0 === a ? "17" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 11 17"
        }, i.a.createElement("path", {
          fill: "#7A8A94",
          fillRule: "evenodd",
          d: "M.132 10.16l5.278-.67-3.424 7.213 8.749-10.181-5.475.695L7.502.797z"
        }));
      },
      "support-ticket": function supportTicket(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "28" : n,
            a = e.height,
            o = void 0 === a ? "28" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 28 28"
        }, i.a.createElement("g", {
          fill: "#394F5A",
          fillRule: "nonzero"
        }, i.a.createElement("path", {
          d: "M23.307 23.307c-5.14 5.14-13.474 5.14-18.614 0-5.14-5.14-5.14-13.474 0-18.614 5.14-5.14 13.474-5.14 18.614 0 5.14 5.14 5.14 13.474 0 18.614zm-1.414-1.414c4.359-4.36 4.359-11.427 0-15.786-4.36-4.359-11.427-4.359-15.786 0-4.359 4.36-4.359 11.427 0 15.786 4.36 4.359 11.427 4.359 15.786 0z"
        }), i.a.createElement("path", {
          d: "M17.803 17.803a5.378 5.378 0 1 1-7.606-7.606 5.378 5.378 0 0 1 7.606 7.606zM16.39 16.39a3.378 3.378 0 1 0-4.778-4.778 3.378 3.378 0 0 0 4.778 4.778z"
        }), i.a.createElement("path", {
          d: "M3.317 7.483L4.731 6.07l5.504 5.504-1.414 1.414zM15.013 19.18l1.414-1.415 5.504 5.504-1.414 1.414zM6.069 4.731l1.414-1.414 5.504 5.504-1.414 1.414zM17.765 16.427l1.414-1.414 5.504 5.504-1.414 1.414zM8.82 15.013l1.415 1.414-5.504 5.504-1.414-1.414zM20.173 3.661l1.414 1.414-5.504 5.504-1.414-1.414zM11.573 17.765l1.414 1.414-5.504 5.504-1.414-1.414zM22.925 6.413l1.414 1.414-5.504 5.504-1.414-1.414z"
        }), i.a.createElement("path", {
          d: "M6.717 2.55a4 4 0 0 0-4.342 4.243c.237 3.656.356 6.042.356 7.21 0 1.168-.119 3.555-.356 7.212a4 4 0 0 0 4.338 4.244c3.593-.312 6.004-.468 7.287-.468 1.272 0 3.651.153 7.191.46a4 4 0 0 0 4.333-4.297c-.339-4.337-.508-7.16-.508-8.53 0-1.167.121-3.059.362-5.713a4 4 0 0 0-4.33-4.346c-3.499.304-5.845.456-7.095.456-1.27 0-3.664-.158-7.236-.472zm7.236-1.53c1.173 0 3.48-.149 6.922-.448a6 6 0 0 1 6.495 6.52c-.236 2.598-.354 4.442-.354 5.532 0 1.3.168 4.09.502 8.374a6 6 0 0 1-6.5 6.445c-3.483-.301-5.822-.452-7.018-.452-1.207 0-3.578.153-7.114.46a6 6 0 0 1-6.507-6.365c.234-3.613.352-5.974.352-7.084 0-1.109-.117-3.469-.351-7.08A6 6 0 0 1 6.893.557c3.514.309 5.867.464 7.06.464z"
        })));
      },
      "question-bubble": function questionBubble(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "27" : n,
            a = e.height,
            o = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 27 24"
        }, i.a.createElement("defs", null, i.a.createElement("path", {
          id: "a",
          d: "M13.091 20.727h-1.565C9.391 23.831 4.607 23.994 4.393 24h-.028a1.093 1.093 0 0 1-.853-1.771c.017-.022 1.568-1.994 1.874-4.058C2.67 16.811.001 13.937.001 10.322.001 4.631 5.873.001 13.092.001c7.219 0 13.091 4.63 13.091 10.321 0 5.738-5.872 10.406-13.091 10.406l-.001-.001zm0-18.545c-6.015 0-10.909 3.651-10.909 8.139 0 2.797 2.39 5.212 4.751 6.154.415.166.686.567.686 1.013 0 1.448-.515 2.864-1.069 3.967 1.261-.346 2.719-1.018 3.389-2.319.188-.362.562-.59.97-.59h2.182c6.015 0 10.909-3.689 10.909-8.224 0-4.488-4.894-8.139-10.909-8.139v-.001zm1.091 9.617V12a.919.919 0 0 1-.07.341 1.148 1.148 0 0 1-.247.433c-.053.05-.123.08-.185.12a1.18 1.18 0 0 1-.589.197.912.912 0 0 1-.339-.069 1.144 1.144 0 0 1-.435-.248 1.173 1.173 0 0 1-.248-.434A.954.954 0 0 1 12 12v-1.091c0-.602.489-1.091 1.091-1.091.601 0 1.091-.49 1.091-1.091s-.49-1.091-1.091-1.091S12 8.126 12 8.727a1.092 1.092 0 0 1-2.182 0 3.277 3.277 0 0 1 3.273-3.273 3.276 3.276 0 0 1 3.273 3.273c0 1.42-.915 2.62-2.182 3.072zm-.317 2.699c.196.207.316.491.316.775 0 .284-.12.567-.316.775a1.148 1.148 0 0 1-.775.316 1.15 1.15 0 0 1-.775-.316 1.148 1.148 0 0 1-.316-.775c0-.284.12-.567.316-.775.415-.404 1.145-.404 1.549 0h.001z"
        })), i.a.createElement("g", {
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("mask", {
          id: "b",
          fill: "#fff"
        }, i.a.createElement("use", {
          xlinkHref: "#a"
        })), i.a.createElement("use", {
          fill: "#000",
          fillRule: "nonzero",
          xlinkHref: "#a"
        }), i.a.createElement("g", {
          fill: "#394F5A",
          mask: "url(#b)"
        }, i.a.createElement("path", {
          d: "M-2-3h30v30H-2z"
        }))));
      },
      linkedin: function linkedin(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "30" : n,
            a = e.height,
            o = void 0 === a ? "30" : a;
        return i.a.createElement("svg", {
          width: r,
          height: o,
          viewBox: "0 0 30 30",
          className: t
        }, i.a.createElement("defs", null, i.a.createElement("path", {
          d: "M0.740055504,6.12765957 L4.56984274,6.12765957 L4.56984274,18 L0.740055504,18 L0.740055504,6.12765957 Z M10.6975023,11.106383 L10.6975023,18 L6.86771508,18 L6.86771508,8.80851064 C6.86771508,8.80851064 6.80388529,6.53191489 6.80388529,6.12765957 L10.5698427,6.12765957 L10.6975023,7.76595745 C11.4634598,6.61702128 12.6123959,5.74468085 14.1443108,5.74468085 C16.8251619,5.74468085 18.7400555,7.65957447 18.7400555,11.106383 L18.7400555,18 L14.9102683,18 L14.9102683,11.4893617 C14.9102683,9.57446809 13.9740981,8.80851064 12.8251619,8.80851064 C11.6762257,8.80851064 10.6975023,9.57446809 10.6975023,11.106383 Z M2.63367253,4.21276596 L2.61239593,4.21276596 C1.2506938,4.21276596 0.357076781,3.27659574 0.357076781,2.10638298 C0.357076781,0.914893617 1.2719704,0 2.67622572,0 C4.05920444,0 4.93154487,0.914893617 4.95282146,2.10638298 C4.95282146,3.27659574 4.05920444,4.21276596 2.63367253,4.21276596 Z",
          id: "path-linkedin"
        })), i.a.createElement("g", {
          id: "icon/linkedin",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "color/navy-extra-dark",
          transform: "translate(6.000000, 6.000000)"
        }, i.a.createElement("mask", {
          id: "mask-2",
          fill: "white"
        }, i.a.createElement("use", {
          xlinkHref: "#path-linkedin"
        })), i.a.createElement("use", {
          id: "Mask",
          fill: "#394F5A",
          xlinkHref: "#path-linkedin"
        }))));
      },
      twitter: function twitter(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "30" : n,
            a = e.height,
            o = void 0 === a ? "30" : a;
        return i.a.createElement("svg", {
          width: r,
          height: o,
          viewBox: "0 0 30 30",
          className: t
        }, i.a.createElement("defs", null, i.a.createElement("path", {
          d: "M18.6667153,1.79321455 C18.1481954,2.57099435 17.5000456,3.24074918 16.7654758,3.78087405 C16.7654758,3.95371401 16.7654758,4.10494897 16.7654758,4.27778892 C16.7654758,9.33335765 12.9197867,15.1667062 5.87655852,15.1667062 C3.71605907,15.1667062 1.68518958,14.6913963 0,13.6111466 C0.302469924,13.6543566 0.604939848,13.6759616 0.907409772,13.6759616 C2.70062432,13.6759616 4.3642089,12.8981818 5.66050858,11.861142 C3.99692399,11.839537 2.57099435,10.7160773 2.09568447,9.20372768 C2.33333941,9.24693767 2.57099435,9.26854267 2.80864929,9.26854267 C3.15432921,9.26854267 3.50000912,9.22533268 3.82408404,9.1389127 C2.07407948,8.79323279 0.75617481,7.23767318 0.75617481,5.37964365 C0.75617481,5.35803865 0.75617481,5.35803865 0.75617481,5.33643366 C1.27469468,5.61729859 1.85802953,5.79013854 2.48457437,5.81174354 C1.44753464,5.12038371 0.777779804,3.95371401 0.777779804,2.63580934 C0.777779804,1.92284452 0.972224755,1.33950966 1.29629967,0.777779804 C3.1975392,3.08951422 6.00618849,4.53704886 9.18212269,4.70988882 C9.11730771,4.42902389 9.09570271,4.12655396 9.09570271,3.82408404 C9.09570271,1.70679457 10.8024973,0 12.9197867,0 C14.0216415,0 15.0154712,0.47530988 15.728436,1.2098797 C16.5926358,1.03703974 17.4136256,0.712964821 18.1481954,0.280864929 C17.8673305,1.16666971 17.2623907,1.92284452 16.4630059,2.3981544 C17.2407857,2.31173442 17.9753555,2.09568447 18.6667153,1.79321455 Z",
          id: "path-twitter"
        })), i.a.createElement("g", {
          id: "icon/twitter",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "color/navy-extra-dark",
          transform: "translate(6.000000, 9.000000)"
        }, i.a.createElement("mask", {
          id: "mask-2",
          fill: "white"
        }, i.a.createElement("use", {
          xlinkHref: "#path-twitter"
        })), i.a.createElement("use", {
          id: "Mask",
          fill: "#394F5A",
          xlinkHref: "#path-twitter"
        }))));
      },
      facebook: function facebook(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "30" : n,
            a = e.height,
            o = void 0 === a ? "30" : a;
        return i.a.createElement("svg", {
          width: r,
          height: o,
          viewBox: "0 0 30 30",
          className: t
        }, i.a.createElement("defs", null, i.a.createElement("path", {
          d: "M2.33333941,18.6667153 L2.33333941,10.1111375 L0,10.1111375 L0,7.00001824 L2.33333941,7.00001824 L2.33333941,4.27778892 C2.33333941,2.07407948 3.71605907,0 7.00001824,0 C8.31792291,0 9.33335765,0.172839957 9.33335765,0.172839957 L9.20372768,3.11111922 L7.19446319,3.11111922 C6.00618849,3.11111922 5.83334853,3.75926905 5.83334853,4.66667883 L5.83334853,7.00001824 L9.33335765,7.00001824 L9.09570271,10.1111375 L5.83334853,10.1111375 L5.83334853,18.6667153 L2.33333941,18.6667153 Z",
          id: "path-facebook"
        })), i.a.createElement("g", {
          id: "icon/facebook",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "color/navy-extra-dark",
          transform: "translate(10.000000, 6.000000)"
        }, i.a.createElement("mask", {
          id: "mask-2",
          fill: "white"
        }, i.a.createElement("use", {
          xlinkHref: "#path-facebook"
        })), i.a.createElement("use", {
          id: "Mask",
          fill: "#394F5A",
          xlinkHref: "#path-facebook"
        }))));
      },
      lock: function lock(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "30" : n,
            a = e.height,
            o = void 0 === a ? "30" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 16"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.4074 13.7777H4.66667C3.8703 13.7777 3.22223 13.1301 3.22223 12.3333V7.51846C3.22223 6.72209 3.8703 6.07402 4.66667 6.07402H5.14815V5.11106C5.14815 3.51832 6.44382 2.22217 8.03704 2.22217C9.63027 2.22217 10.9259 3.51832 10.9259 5.11106V6.07402H11.4074C12.2038 6.07402 12.8519 6.72209 12.8519 7.51846V12.3333C12.8519 13.1301 12.2038 13.7777 11.4074 13.7777ZM8.03704 3.18513C6.9749 3.18513 6.11112 4.04891 6.11112 5.11106V6.07402H9.96297V5.11106C9.96297 4.04891 9.09919 3.18513 8.03704 3.18513ZM11.8889 7.51846C11.8889 7.25269 11.6727 7.03698 11.4074 7.03698H4.66667C4.40138 7.03698 4.18519 7.25269 4.18519 7.51846V12.3333C4.18519 12.5986 4.40138 12.8148 4.66667 12.8148H11.4074C11.6727 12.8148 11.8889 12.5986 11.8889 12.3333V7.51846Z"
        }), i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.03704 2.44444C6.56657 2.44444 5.37037 3.64108 5.37037 5.11111V6.2963H4.66667C3.99303 6.2963 3.44444 6.84488 3.44444 7.51852V12.3333C3.44444 13.0074 3.99298 13.5556 4.66667 13.5556H11.4074C12.0811 13.5556 12.6296 13.0074 12.6296 12.3333V7.51852C12.6296 6.84488 12.081 6.2963 11.4074 6.2963H10.7037V5.11111C10.7037 3.64108 9.50751 2.44444 8.03704 2.44444ZM4.92593 5.11111C4.92593 3.39566 6.32106 2 8.03704 2C9.75301 2 11.1481 3.39566 11.1481 5.11111V5.85185H11.4074C12.3265 5.85185 13.0741 6.59942 13.0741 7.51852V12.3333C13.0741 13.253 12.3265 14 11.4074 14H4.66667C3.74761 14 3 13.253 3 12.3333V7.51852C3 6.59942 3.74757 5.85185 4.66667 5.85185H4.92593V5.11111ZM5.88889 5.11111C5.88889 3.92623 6.85216 2.96296 8.03704 2.96296C9.22192 2.96296 10.1852 3.92623 10.1852 5.11111V6.2963H5.88889V5.11111ZM8.03704 3.40741C7.09762 3.40741 6.33333 4.17169 6.33333 5.11111V5.85185H9.74074V5.11111C9.74074 4.17169 8.97646 3.40741 8.03704 3.40741ZM3.96296 7.51852C3.96296 7.12987 4.27879 6.81481 4.66667 6.81481H11.4074C11.7953 6.81481 12.1111 7.12987 12.1111 7.51852V12.3333C12.1111 12.7214 11.7954 13.037 11.4074 13.037H4.66667C4.27864 13.037 3.96296 12.7214 3.96296 12.3333V7.51852ZM4.66667 7.25926C4.52396 7.25926 4.40741 7.37562 4.40741 7.51852V12.3333C4.40741 12.4759 4.5241 12.5926 4.66667 12.5926H11.4074C11.55 12.5926 11.6667 12.4759 11.6667 12.3333V7.51852C11.6667 7.37562 11.5501 7.25926 11.4074 7.25926H4.66667Z"
        }));
      },
      "fork-arrows": function forkArrows(e) {
        var t = e.width,
            n = e.height,
            r = e.className;
        return i.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: t,
          height: n,
          className: r,
          viewBox: "0 0 25 24"
        }, i.a.createElement("path", {
          fill: "#394F5A",
          fillRule: "evenodd",
          d: "M24.808 1v4.981c0 .55-.444.997-.992.997a.996.996 0 0 1-.993-.997V3.404l-5.836 5.858a10.572 10.572 0 0 0-3.097 7.507v6.148c0 .55-.444.997-.993.997-.548 0-.959-.424-.959-.974v-5.701c-.01-.056-.033-.107-.033-.165v-.305c0-.084.011-.167.012-.251-.106-2.693-1.211-5.35-3.109-7.256L2.973 3.405v2.576c0 .55-.445.997-.993.997a.996.996 0 0 1-.993-.997V1.002a1 1 0 0 1 .282-.693c.004-.004.005-.01.009-.013a.982.982 0 0 1 .323-.215.983.983 0 0 1 .373-.076L1.98.004h4.963c.548 0 .992.445.992.996 0 .55-.444.996-.992.996H4.375l5.836 5.858a12.573 12.573 0 0 1 2.686 3.997 12.592 12.592 0 0 1 2.687-3.997l5.836-5.858h-2.567A.994.994 0 0 1 17.861 1c0-.551.444-.996.992-.996h4.963c.012 0 .021.006.033.006a.997.997 0 0 1 .345.07.996.996 0 0 1 .538.54c.042.102.057.21.064.318.001.021.012.04.012.062z"
        }));
      },
      "chat-solid-1": function chatSolid1(e) {
        e.className;
        var t = e.width,
            n = void 0 === t ? "20" : t,
            r = e.height,
            a = void 0 === r ? "20" : r;
        return i.a.createElement("svg", {
          width: n,
          height: a,
          viewBox: "0 0 25 23",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          d: "M4.583 14.894l-3.256 3.78c-.7.813-1.26.598-1.25-.46a10689.413 10689.413 0 0 1 .035-4.775V4.816a3.89 3.89 0 0 1 3.88-3.89h12.064a3.885 3.885 0 0 1 3.882 3.89v6.185a3.89 3.89 0 0 1-3.882 3.89H4.583z",
          fill: "#7695a5",
          fillRule: "evenodd"
        }));
      },
      "chat-solid-2": function chatSolid2(e) {
        e.className;
        var t = e.width,
            n = void 0 === t ? "20" : t,
            r = e.height,
            a = void 0 === r ? "20" : r;
        return i.a.createElement("svg", {
          width: n,
          height: a,
          viewBox: "0 0 25 23",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          d: "M24.516 9.953C24.516 4.453 19.04 0 12.258 0 5.476 0 0 4.452 0 9.953c0 3.318 1.986 6.24 5.05 8.053-.34 2.552-1.815 4.055-1.844 4.084-.14.14-.17.368-.113.567a.524.524 0 0 0 .482.312c2.95 0 5.335-1.93 6.612-3.206.652.086 1.362.142 2.07.142 6.783 0 12.26-4.452 12.26-9.953z",
          fill: "#7695a5",
          fillRule: "evenodd"
        }));
      },
      "chat-outline-1": function chatOutline1(e) {
        e.className;
        var t = e.width,
            n = void 0 === t ? "20" : t,
            r = e.height,
            a = void 0 === r ? "20" : r;
        return i.a.createElement("svg", {
          width: n,
          height: a,
          viewBox: "0 0 25 23",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          d: "M22.814 12.25h-1.362v3.063a1.02 1.02 0 0 1-1.744.72L15.92 12.25H11.92c-.94 0-1.703-.785-1.703-1.75V1.75c0-.965.764-1.75 1.703-1.75h10.896c.938 0 1.702.785 1.702 1.75v8.75c0 .965-.764 1.75-1.702 1.75zm-.34-10.208H12.257v8.166h4.086a1.032 1.032 0 0 1 .723.3l2.342 2.34v-1.62c0-.562.456-1.02 1.02-1.02h2.043V2.042zM8.17 10.208h-6.13v8.167h2.044c.564 0 1.022.457 1.022 1.02v1.62l2.34-2.34a1.022 1.022 0 0 1 .724-.3h4.086V14.29a1.02 1.02 0 0 1 2.043 0v4.377c0 .965-.763 1.75-1.702 1.75H8.595L4.808 24.2a1.022 1.022 0 0 1-1.743-.72v-3.063H1.702c-.938 0-1.702-.785-1.702-1.75v-8.75c0-.965.764-1.75 1.702-1.75h6.47a1.022 1.022 0 0 1 0 2.04z",
          fill: "#7695a5",
          fillRule: "evenodd"
        }));
      },
      "chat-outline-2": function chatOutline2(e) {
        e.className;
        var t = e.width,
            n = void 0 === t ? "20" : t,
            r = e.height,
            a = void 0 === r ? "20" : r;
        return i.a.createElement("svg", {
          width: n,
          height: a,
          viewBox: "0 0 25 23",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          d: "M23.295 24.412a.987.987 0 0 1-1.123-.43L19.9 20.358H9.527c-1.392 0-2.523-1.153-2.523-2.57V16.3c0-.563.448-1.02 1-1.02.553 0 1 .457 1 1.02v1.485c0 .295.235.533.523.533h10.92c.036 0 .067.018.103.022a.96.96 0 0 1 .527.224.984.984 0 0 1 .14.15c.023.026.054.043.073.075l.725 1.154V9.7a.528.528 0 0 0-.523-.532h-1.48c-.55 0-1-.457-1-1.02 0-.56.45-1.018 1-1.018h1.48c1.392 0 2.524 1.152 2.524 2.57V23.433c0 .452-.293.85-.72.978zM14.49 13.226H4.116L1.844 16.85a.997.997 0 0 1-1.124.43 1.017 1.017 0 0 1-.72-.978V2.57C0 1.152 1.132 0 2.523 0H14.49c1.39 0 2.52 1.152 2.52 2.57v8.085c0 1.418-1.13 2.57-2.52 2.57zm.52-10.656a.528.528 0 0 0-.52-.532H2.522c-.288 0-.522.24-.522.532v10.242l.726-1.153c.02-.032.05-.05.07-.076a.897.897 0 0 1 .296-.256.92.92 0 0 1 .372-.118c.037-.004.068-.022.104-.022h10.92c.288 0 .522-.238.522-.533V2.57z",
          fill: "#7695a5",
          fillRule: "evenodd"
        }));
      },
      "available-blue": function availableBlue(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n;
        e.height;
        return i.a.createElement("svg", {
          className: t,
          xmlns: "http://www.w3.org/2000/svg",
          width: r,
          height: r,
          viewBox: "0 0 8 8"
        }, i.a.createElement("g", {
          fill: "none"
        }, i.a.createElement("circle", {
          cx: "4",
          cy: "4",
          r: "4",
          fill: "#0071EB"
        }), i.a.createElement("path", {
          fill: "#FFFFFF",
          d: "M2.49 4l-.53.68 1.753 1.4 2.403-2.988-.673-.543-1.869 2.338z"
        })));
      },
      "available-white": function availableWhite(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          xmlns: "http://www.w3.org/2000/svg",
          width: r,
          height: o,
          viewBox: "0 0 12 12"
        }, i.a.createElement("g", {
          fill: "none"
        }, i.a.createElement("circle", {
          cx: "6",
          cy: "6",
          r: "6",
          fill: "#F4F9FF"
        }), i.a.createElement("path", {
          fill: "#0071EB",
          d: "M3.735 6L2.94 7.02l2.63 2.101 3.603-4.484-1.01-.813L5.362 7.33z"
        })));
      },
      "away-grey": function awayGrey(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          xmlns: "http://www.w3.org/2000/svg",
          width: r,
          height: o,
          viewBox: "0 0 12 12"
        }, i.a.createElement("g", {
          fill: "none"
        }, i.a.createElement("circle", {
          cx: "6",
          cy: "6",
          r: "6",
          fill: "#687882"
        }), i.a.createElement("path", {
          stroke: "#D6DDE1",
          d: "M3 6h6"
        })));
      },
      "away-white": function awayWhite(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          xmlns: "http://www.w3.org/2000/svg",
          width: r,
          height: o,
          viewBox: "0 0 8 8"
        }, i.a.createElement("g", {
          fill: "none"
        }, i.a.createElement("circle", {
          cx: "4",
          cy: "4",
          r: "4",
          fill: "#687882"
        }), i.a.createElement("path", {
          stroke: "#FFF",
          d: "M2 4h4"
        })));
      },
      "chat-limit-white": function chatLimitWhite(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          xmlns: "http://www.w3.org/2000/svg",
          width: r,
          height: o,
          viewBox: "0 0 12 12"
        }, i.a.createElement("g", {
          fill: "none",
          transform: "translate(-.617 -.559)"
        }, i.a.createElement("circle", {
          cx: "6.617",
          cy: "6.559",
          r: "6",
          fill: "#FFFBF0"
        }), i.a.createElement("path", {
          fill: "#F4B806",
          d: "M7.179 7.717H5.9l-.224-4.05h1.717l-.214 4.05zm-.635 2.278a.889.889 0 0 1-.877-.878c0-.466.401-.868.877-.868s.868.402.868.868a.88.88 0 0 1-.868.878z"
        })));
      },
      "chat-limit-yellow": function chatLimitYellow(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "14" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          xmlns: "http://www.w3.org/2000/svg",
          width: r,
          height: o,
          viewBox: "0 0 8 8"
        }, i.a.createElement("g", {
          fill: "none"
        }, i.a.createElement("circle", {
          cx: "4",
          cy: "4",
          r: "4",
          fill: "#F4B806"
        }), i.a.createElement("path", {
          fill: "#FFFFFF",
          d: "M4.374 4.772h-.852l-.15-2.7h1.145l-.143 2.7zm-.423 1.519a.592.592 0 0 1-.585-.585c0-.311.268-.579.585-.579.317 0 .579.268.579.579a.587.587 0 0 1-.579.585z"
        })));
      },
      move: function move(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "20" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 30 30"
        }, i.a.createElement("path", {
          d: "M23.578,11.579c-0.489-0.49-1.327-0.143-1.327,0.55v1.976h-6.355V7.749h1.976 c0.693,0,1.04-0.838,0.551-1.328L15,3l-3.421,3.421c-0.49,0.49-0.143,1.328,0.55,1.328h1.976v6.355H7.749v-1.976 c0-0.693-0.838-1.04-1.328-0.55L3,15l3.421,3.422c0.49,0.489,1.328,0.143,1.328-0.551v-1.976h6.355v6.355h-1.976 c-0.693,0-1.04,0.838-0.55,1.327L15,27l3.422-3.422c0.489-0.489,0.143-1.327-0.551-1.327h-1.976v-6.355h6.355v1.976 c0,0.693,0.838,1.04,1.327,0.551L27,15L23.578,11.579z"
        }));
      },
      "video-play": function videoPlay(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "17" : n,
            a = e.height,
            o = void 0 === a ? "17" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 17 17"
        }, i.a.createElement("g", {
          id: "Symbols",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("path", {
          d: "M8.5,16.625 C4.01268641,16.625 0.375,12.9873136 0.375,8.5 C0.375,4.01268641 4.01268641,0.375 8.5,0.375 C12.9873136,0.375 16.625,4.01268641 16.625,8.5 C16.625,12.9873136 12.9873136,16.625 8.5,16.625 Z M8.5,15.375 C12.2969577,15.375 15.375,12.2969577 15.375,8.5 C15.375,4.70304235 12.2969577,1.625 8.5,1.625 C4.70304235,1.625 1.625,4.70304235 1.625,8.5 C1.625,12.2969577 4.70304235,15.375 8.5,15.375 Z M6.375,6.87780195 C6.375,6.67587414 6.42934923,6.47766852 6.53234483,6.30398276 C6.84925642,5.76956156 7.539398,5.59323519 8.07381919,5.91014678 L11.3136913,7.83138983 C11.4759053,7.92758273 11.6113343,8.06301172 11.7075272,8.22522581 C12.0244388,8.759647 11.8481125,9.44978858 11.3136913,9.76670017 L8.07381919,11.6879432 C7.90013343,11.7909388 7.70192781,11.8452881 7.5,11.8452881 C6.87867966,11.8452881 6.375,11.3416084 6.375,10.7202881 L6.375,6.87780195 Z M7.625,10.5008376 L10.4948036,8.799045 L7.625,7.09725244 L7.625,10.5008376 Z",
          id: "Combined-Shape",
          fill: "#353F45",
          fillRule: "nonzero"
        })));
      },
      "warning-triangle-filled": function warningTriangleFilled(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 16 16"
        }, i.a.createElement("g", {
          id: "Symbols",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          id: "Modal/Icons/Warning",
          fill: "#353F45"
        }, i.a.createElement("path", {
          d: "M15.8184672,13.5925926 C16.0777998,14.1111111 16.059276,14.7222222 15.762896,15.2037037 C15.4479922,15.7037037 14.9108034,16 14.3365671,16 L1.66632076,16 C1.09208445,16 0.554895646,15.7037037 0.239991863,15.2037037 C-0.0563881676,14.7222222 -0.0749119195,14.1111111 0.165896856,13.5925926 L6.50102001,0.925925926 C6.79740004,0.351851852 7.37163635,0 8.00144392,0 C8.63125148,0 9.20548779,0.351851852 9.48334407,0.925925926 L15.8184672,13.5925926 Z M7.00116132,4.33333333 L7.00116132,10 L9.00172652,10 L9.00172652,4.33333333 L7.00116132,4.33333333 Z M8.00144392,14.3333333 C8.742394,14.3333333 9.33515406,13.7407407 9.33515406,13 C9.33515406,12.2592593 8.742394,11.6666667 8.00144392,11.6666667 C7.26049384,11.6666667 6.66773378,12.2592593 6.66773378,13 C6.66773378,13.7407407 7.26049384,14.3333333 8.00144392,14.3333333 Z",
          id: "Icon"
        }))));
      },
      "app-switch": function appSwitch(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "18" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 18"
        }, i.a.createElement("g", {
          fill: "#C1CCD2",
          fillRule: "evenodd"
        }, i.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          rx: 1
        }), i.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 7,
          rx: 1
        }), i.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 14,
          rx: 1
        }), i.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          y: 7,
          rx: 1
        }), i.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 7,
          y: 7,
          rx: 1
        }), i.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 14,
          y: 7,
          rx: 1
        }), i.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          y: 14,
          rx: 1
        }), i.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 7,
          y: 14,
          rx: 1
        }), i.a.createElement("rect", {
          width: 4.5,
          height: 4.5,
          x: 14,
          y: 14,
          rx: 1
        })));
      },
      "graduation-cap": function graduationCap(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 16"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          d: "M16.839 13.32c-.64 0-1.162-.52-1.162-1.159 0-.427.236-.797.581-.999v-4.38l-2.334 1.332c.002.02.011.036.011.055V13.9c0 .022-.01.041-.012.063a.603.603 0 0 1-.024.115.57.57 0 0 1-.192.27c-.017.014-.027.033-.046.044-.082.052-2.046 1.247-4.951 1.247s-4.87-1.195-4.951-1.247c-.02-.011-.03-.03-.047-.043a.546.546 0 0 1-.215-.386c-.003-.021-.013-.04-.013-.063V8.17c0-.02.01-.037.01-.056l-3.2-1.827a.578.578 0 0 1 0-1.007L8.422.642a.582.582 0 0 1 .576 0l8.129 4.638a.578.578 0 0 1 .292.504c0 .01-.007.018-.007.028 0 .014.007.025.007.039v5.311c.346.202.581.572.581.999 0 .639-.52 1.16-1.161 1.16zm-4.065.235V8.77l-3.776 2.155a.578.578 0 0 1-.576 0L4.645 8.77v4.783c.583.291 2.078.927 4.065.927 1.998 0 3.484-.634 4.064-.925zM8.71 1.813l-6.96 3.97 6.959 3.97 6.958-3.97-6.958-3.97z"
        }));
      },
      library: function library(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 16"
        }, i.a.createElement("path", {
          d: "M.75 2.941h16.5c.414 0 .75.33.75.735v10.295a.743.743 0 0 1-.75.735H.75A.743.743 0 0 1 0 13.97V3.676c0-.406.336-.735.75-.735zm0 .735v10.295h16.5V3.676H.75zm6 2.665a.427.427 0 0 1 .64-.371l4.353 2.482a.427.427 0 0 1 0 .743l-4.354 2.483a.427.427 0 0 1-.639-.372V6.341zM1.125 2.47c-.207 0-.375-.224-.375-.5 0-.277.168-.5.375-.5h15.738c.207 0 .375.223.375.5 0 .276-.168.5-.375.5H1.125zM2.625 1C2.418 1 2.25.776 2.25.5s.168-.5.375-.5h13.5c.207 0 .375.224.375.5s-.168.5-.375.5h-13.5z"
        }));
      },
      siftrock: function siftrock(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "18" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 18"
        }, i.a.createElement("g", {
          fill: "#644A9E",
          fillRule: "evenodd"
        }, i.a.createElement("circle", {
          cx: 8.9,
          cy: 15.9,
          r: 1.9
        }), i.a.createElement("circle", {
          cx: 8.9,
          cy: 8.9,
          r: 1.9
        }), i.a.createElement("circle", {
          cx: 15.9,
          cy: 8.9,
          r: 1.9
        }), i.a.createElement("circle", {
          cx: 1.9,
          cy: 8.9,
          r: 1.9
        }), i.a.createElement("circle", {
          cx: 8.9,
          cy: 1.9,
          r: 1.9
        }), i.a.createElement("circle", {
          cx: 12.4,
          cy: 12.4,
          r: 1.9
        }), i.a.createElement("circle", {
          cx: 12.4,
          cy: 5.4,
          r: 1.9
        }), i.a.createElement("circle", {
          cx: 5.4,
          cy: 12.4,
          r: 1.9
        }), i.a.createElement("circle", {
          cx: 5.4,
          cy: 5.4,
          r: 1.9
        })));
      },
      "dev-platform": function devPlatform(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "18" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 18 16"
        }, i.a.createElement("path", {
          d: "M16.5 16h-15C.673 16 0 15.347 0 14.545V1.455C0 .653.673 0 1.5 0h15c.827 0 1.5.653 1.5 1.455v13.09c0 .802-.673 1.455-1.5 1.455zm-15-1.455h14.998l.001-10.182H1.5v10.182zm0-13.09v1.454h15V1.455h-15zm9.53 10.696a.76.76 0 0 1-.53.214.759.759 0 0 1-.53-.214.71.71 0 0 1 0-1.028l1.72-1.668-1.72-1.667a.71.71 0 0 1 0-1.029.768.768 0 0 1 1.06 0l2.251 2.182a.71.71 0 0 1 0 1.029l-2.25 2.182zm-3 0a.76.76 0 0 1-.53.213.759.759 0 0 1-.53-.213L4.72 9.969a.71.71 0 0 1 0-1.029l2.25-2.182a.766.766 0 0 1 1.06 0 .71.71 0 0 1 0 1.029L6.312 9.454l1.72 1.667a.71.71 0 0 1 0 1.029H8.03z"
        }));
      },
      star: function star(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "20" : n,
            a = e.height,
            o = void 0 === a ? "19" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 14 13"
        }, i.a.createElement("g", {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          transform: "translate(-124.000000, -107.000000)",
          fill: "#353F45"
        }, i.a.createElement("path", {
          d: "M127.128699,119.68155 C126.746655,119.922451 126.266308,119.573459 126.377361,119.13567 L127.410415,115.063202 L124.18092,112.37572 C123.833751,112.086817 124.017227,111.522136 124.467906,111.492469 L128.660285,111.2165 L130.218263,107.31459 C130.385745,106.895137 130.979486,106.895137 131.146968,107.31459 L132.704946,111.2165 L136.897325,111.492469 C137.348004,111.522136 137.53148,112.086817 137.184311,112.37572 L133.954816,115.063202 L134.98787,119.13567 C135.098923,119.573459 134.618576,119.922451 134.236531,119.68155 L130.682615,117.440595 L127.128699,119.68155 Z",
          id: "Star"
        }))));
      },
      "lightbulb-2": function lightbulb2(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "16" : n,
            a = e.height,
            o = void 0 === a ? "16" : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 30 30",
          version: "1.1"
        }, i.a.createElement("g", {
          id: "icon/insights",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd"
        }, i.a.createElement("g", {
          transform: "translate(6.000000, 2.000000)",
          fill: "#353F45"
        }, i.a.createElement("path", {
          d: "M6.02996594,17.0006278 L12.0299659,17.0006278 C12.5822507,17.0006278 13.0299659,17.448343 13.0299659,18.0006278 C13.0299659,18.5529125 12.5822507,19.0006278 12.0299659,19.0006278 L6.02996594,19.0006278 C5.47768119,19.0006278 5.02996594,18.5529125 5.02996594,18.0006278 C5.02996594,17.448343 5.47768119,17.0006278 6.02996594,17.0006278 Z M6.02996594,20.0006278 L12.0299659,20.0006278 C12.5822507,20.0006278 13.0299659,20.448343 13.0299659,21.0006278 C13.0299659,21.5529125 12.5822507,22.0006278 12.0299659,22.0006278 L6.02996594,22.0006278 C5.47768119,22.0006278 5.02996594,21.5529125 5.02996594,21.0006278 C5.02996594,20.448343 5.47768119,20.0006278 6.02996594,20.0006278 Z M7.02996594,23.0006278 L11.0299659,23.0006278 C11.5822507,23.0006278 12.0299659,23.448343 12.0299659,24.0006278 C12.0299659,24.5529125 11.5822507,25.0006278 11.0299659,25.0006278 L7.02996594,25.0006278 C6.47768119,25.0006278 6.02996594,24.5529125 6.02996594,24.0006278 C6.02996594,23.448343 6.47768119,23.0006278 7.02996594,23.0006278 Z M14.7061934,15.9601317 C14.2792169,16.3104309 13.6491105,16.2482716 13.2988113,15.8212951 C12.9485121,15.3943186 13.0106714,14.7642122 13.4376479,14.413913 C14.9837931,13.1454278 15.9246494,11.282054 15.9958058,9.2444024 C16.130727,5.38076421 13.1080047,2.13929135 9.2443665,2.00437013 C5.38072831,1.86944891 2.13925545,4.89217125 2.00433423,8.75580944 C1.92847797,10.9280485 2.85359934,12.969018 4.48171082,14.3469849 C4.90327476,14.7037794 4.9557808,15.3347635 4.59898633,15.7563275 C4.24219187,16.1778914 3.61120771,16.2303975 3.18964377,15.873603 C1.09874504,14.1039519 -0.0919164183,11.4771573 0.0055525792,8.68601045 C0.179022717,3.71847563 4.34663068,-0.167881663 9.31416549,0.0055884753 C14.2817003,0.179058614 18.1680576,4.34666657 17.9945875,9.31420139 C17.9031664,11.9321569 16.6919496,14.3309817 14.7061934,15.9601317 Z M8.75060956,14.1795466 C8.6975643,14.3398046 8.55198024,14.4532058 8.38084153,14.4532058 C8.36457948,14.4532058 8.34831743,14.4524183 8.33166819,14.4500558 C8.14813935,14.4280055 8.01649419,14.2819227 7.99481145,14.1078833 C7.9924883,14.097252 7.99364988,14.0862269 7.99210111,14.0755955 C7.99132673,14.0543328 7.98474447,14.0342513 7.98745481,14.0125948 L7.99093954,13.9814882 C7.99287549,13.9669193 7.99326269,13.9527442 7.99636022,13.9377815 L8.37000016,10.9165054 L6.54710187,10.9161116 C6.25980566,10.9161116 6.13358118,10.7593974 6.08363346,10.6660777 C5.94308289,10.4030499 6.11654475,10.1482909 6.17346192,10.0644212 L10.0322139,5.15194356 C10.1673438,4.98066047 10.416308,4.9503414 10.5878339,5.08382408 C10.6842447,5.15863738 10.7310949,5.26849481 10.7349668,5.38110852 C10.7411618,5.42835902 10.7411618,5.47718455 10.7287717,5.52640382 L9.9822662,8.55752382 L11.5647185,8.55752382 C11.8504659,8.55752382 11.9743672,8.70833169 12.0231534,8.79810765 C12.1555729,9.04420404 12.0065042,9.26588767 11.9267427,9.3851952 L8.75060956,14.1795466 Z"
        }))));
      },
      calendar: function CalendarSvg(e) {
        var t = e.className,
            n = e.height,
            r = void 0 === n ? "104" : n,
            a = e.width,
            o = void 0 === a ? "102" : a;
        return i.a.createElement("svg", {
          className: t,
          width: o,
          height: r,
          viewBox: "0 0 102 104",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", {
          filter: "url(#filter0_dd)"
        }, i.a.createElement("rect", {
          x: "19",
          y: "30.9056",
          width: "54.4151",
          height: "38.0377",
          rx: "1.0566",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), i.a.createElement("rect", {
          x: "22.1698",
          y: "15.0565",
          width: "48.0755",
          height: "49.1321",
          rx: "1.58491",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2.11321"
        }), i.a.createElement("path", {
          d: "M19 33.0189V68.9434H73.4151L19 33.0189Z",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), i.a.createElement("path", {
          d: "M73.4151 68.9434V33.0189L19 68.9434H73.4151Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), i.a.createElement("line", {
          x1: "40.9434",
          y1: "13",
          x2: "40.9434",
          y2: "17",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round"
        }), i.a.createElement("line", {
          x1: "45.9434",
          y1: "13",
          x2: "45.9434",
          y2: "17",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round"
        }), i.a.createElement("line", {
          x1: "50.9434",
          y1: "13",
          x2: "50.9434",
          y2: "17",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round"
        }), i.a.createElement("circle", {
          cx: "70",
          cy: "64",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          "stroke-width": "2"
        }), i.a.createElement("path", {
          d: "M64.9999 63.9997L68.7499 67.7497L75.2499 60.2497",
          stroke: "white",
          "stroke-width": "2.75",
          "stroke-linecap": "square"
        })), i.a.createElement("defs", null, i.a.createElement("filter", {
          id: "filter0_dd",
          x: "-11.2688",
          y: "-8.63441",
          width: "114.538",
          height: "114.538",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB"
        }, i.a.createElement("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }), i.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), i.a.createElement("feOffset", {
          dy: "2.59032"
        }), i.a.createElement("feGaussianBlur", {
          stdDeviation: "2.59032"
        }), i.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.1 0"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), i.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), i.a.createElement("feOffset", {
          dy: "8.63441"
        }), i.a.createElement("feGaussianBlur", {
          stdDeviation: "8.63441"
        }), i.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow",
          result: "effect2_dropShadow"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow",
          result: "shape"
        }))));
      },
      "notification-2": function NotificationSvg(e) {
        var t = e.className,
            n = e.height,
            r = void 0 === n ? "106" : n,
            a = e.width,
            o = void 0 === a ? "105" : a;
        return i.a.createElement("svg", {
          className: t,
          width: o,
          height: r,
          viewBox: "0 0 105 106",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", {
          filter: "url(#filter0_dd)"
        }, i.a.createElement("rect", {
          x: "20",
          y: "20",
          width: "56",
          height: "56",
          rx: "2.53807",
          fill: "#353F45"
        }), i.a.createElement("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M48.9981 33.1251C48.9981 32.7232 49.2091 32.3517 49.5523 32.1507C49.8941 31.9498 50.3162 31.9498 50.6587 32.1507L62.8135 39.2852C63.1034 39.4551 63.1085 39.8738 62.818 40.0438C61.1009 41.0465 56.4391 43.7783 54.7073 44.7934C54.4135 44.9659 54.0479 44.7501 54.0479 44.4077V41.1577C54.0479 41.1305 54.0338 41.1053 54.0101 41.0911L49.5523 38.4743C49.2091 38.2727 48.9981 37.9019 48.9981 37.4993V33.1251ZM46.8269 38.6023C47.3048 38.3218 47.5985 37.8062 47.5985 37.2493V33.1251C47.5985 32.7232 47.3875 32.3517 47.045 32.1507C46.7025 31.9498 46.2804 31.9498 45.9379 32.1507L33.7767 39.2891C33.49 39.4571 33.4842 39.8719 33.7716 40.0392C35.4874 41.042 40.1787 43.7906 41.9021 44.8012C42.1908 44.9704 42.5487 44.7579 42.5487 44.4219V41.1137L46.8269 38.6023ZM46.8057 55.7563C47.1482 55.5548 47.3592 55.1832 47.3592 54.7813V50.4039C47.3592 50.002 47.1482 49.6304 46.8057 49.4289L32.66 41.1268C32.3175 40.9259 31.8961 40.9259 31.5529 41.1268C31.2104 41.3278 31 41.6986 31 42.1012V46.4754C31 46.8773 31.2104 47.2488 31.5529 47.4504L36.0492 50.0892V61.5385C36.0492 61.9397 36.2602 62.3113 36.6027 62.5122L39.3845 64.1456C39.5564 64.2458 39.7476 64.2962 39.9381 64.2962C40.1292 64.2962 40.3204 64.2458 40.4916 64.1456C40.8341 63.9447 41.0445 63.5731 41.0445 63.1706V53.0226L45.6986 55.7557C45.7007 55.757 45.7031 55.758 45.7054 55.7588L45.7089 55.7602C46.0495 55.956 46.4657 55.9547 46.8057 55.7563ZM64.8044 47.4504C65.1476 47.2488 65.3579 46.8773 65.3579 46.4754V42.1012C65.3579 41.6986 65.1476 41.3278 64.8044 41.1268C64.4619 40.9259 64.0398 40.9259 63.6973 41.1268L49.5523 49.4289C49.2091 49.6304 48.9981 50.002 48.9981 50.4039V54.7813C48.9981 55.1832 49.2091 55.5548 49.5523 55.7563C49.8916 55.9547 50.3078 55.956 50.6491 55.7602C50.6508 55.7595 50.6525 55.7588 50.6542 55.7581C50.6557 55.7574 50.6572 55.7566 50.6587 55.7557L55.3128 53.0226V63.1706C55.3128 63.5731 55.5232 63.9447 55.8663 64.1456C56.0376 64.2458 56.2281 64.2962 56.4192 64.2962C56.6104 64.2962 56.8015 64.2458 56.9728 64.1456L59.7552 62.5122C60.0977 62.3113 60.3081 61.9397 60.3081 61.5385V50.0892L64.8044 47.4504Z",
          fill: "white"
        }), i.a.createElement("circle", {
          cx: "72.1523",
          cy: "23.1523",
          r: "11.376",
          fill: "#353F45",
          stroke: "white",
          "stroke-width": "2.44743"
        }), i.a.createElement("path", {
          d: "M72.1494 27.7703C74.0445 27.7703 75.7771 26.9446 75.7771 25.2661C75.7771 24.1697 74.9108 23.3304 73.8414 22.9514C74.8296 22.5995 75.6282 21.9497 75.6282 20.8262C75.6282 19.1206 73.8144 18.4438 72.1494 18.4438C70.4709 18.4438 68.6705 19.1206 68.6705 20.8262C68.6705 21.9497 69.4556 22.5995 70.4573 22.9514C69.3744 23.3304 68.5216 24.1697 68.5216 25.2661C68.5216 26.9446 70.2543 27.7703 72.1494 27.7703ZM72.1494 22.1934C71.5944 22.0986 70.6198 21.8143 70.6198 21.1511C70.6198 20.5148 71.256 20.1494 72.1494 20.1494C73.0293 20.1494 73.6655 20.5148 73.6655 21.1511C73.6655 21.8143 72.7044 22.0986 72.1494 22.1934ZM72.1494 26.0648C71.2018 26.0648 70.4709 25.6451 70.4709 24.9954C70.4709 24.2509 71.5809 23.8989 72.1494 23.8177C72.7044 23.8989 73.8279 24.2509 73.8279 24.9954C73.8279 25.6451 73.0699 26.0648 72.1494 26.0648Z",
          fill: "white"
        })), i.a.createElement("defs", null, i.a.createElement("filter", {
          id: "filter0_dd",
          x: "-12",
          y: "-2",
          width: "120",
          height: "120",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB"
        }, i.a.createElement("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }), i.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), i.a.createElement("feOffset", {
          dy: "3"
        }), i.a.createElement("feGaussianBlur", {
          stdDeviation: "3"
        }), i.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.1 0"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), i.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), i.a.createElement("feOffset", {
          dy: "10"
        }), i.a.createElement("feGaussianBlur", {
          stdDeviation: "10"
        }), i.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow",
          result: "effect2_dropShadow"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow",
          result: "shape"
        }))));
      },
      "routing-circle": function RoutingCircleSvg(e) {
        var t = e.className,
            n = e.height,
            r = void 0 === n ? "94" : n,
            a = e.width,
            o = void 0 === a ? "88" : a;
        return i.a.createElement("svg", {
          className: t,
          width: o,
          height: r,
          viewBox: "0 0 88 89",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", {
          filter: "url(#filter0_dd)"
        }, i.a.createElement("path", {
          d: "M24.2525 51.8463C20.6581 51.8463 17.7443 54.0056 17.7443 57.6036H30.7607C30.7607 54.0056 27.8469 51.8463 24.2525 51.8463Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), i.a.createElement("circle", {
          cx: "24.3777",
          cy: "47.9663",
          r: "3.8799",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), i.a.createElement("path", {
          d: "M44.746 37.8931C41.1516 37.8931 38.2378 40.0524 38.2378 43.6504H51.2542C51.2542 40.0524 48.3404 37.8931 44.746 37.8931Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), i.a.createElement("circle", {
          cx: "44.8712",
          cy: "34.0131",
          r: "3.8799",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), i.a.createElement("path", {
          d: "M65.6757 23.9401C62.0813 23.9401 59.1674 26.0994 59.1674 29.6974H72.1839C72.1839 26.0994 69.27 23.9401 65.6757 23.9401Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), i.a.createElement("circle", {
          cx: "65.8009",
          cy: "20.0602",
          r: "3.8799",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), i.a.createElement("path", {
          d: "M53.4989 14.984C33.4414 10.6237 20.4382 21.2405 19.2703 37.2218M19.2703 37.2218L23.6306 34.3875M19.2703 37.2218L16 33.2975",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }), i.a.createElement("path", {
          d: "M34.7495 65.016C54.807 69.3764 67.8102 58.7596 68.9781 42.7783M68.9781 42.7783L64.6178 45.6125M68.9781 42.7783L72.2484 46.7026",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })), i.a.createElement("defs", null, i.a.createElement("filter", {
          id: "filter0_dd",
          x: "-10.2528",
          y: "-7.12641",
          width: "108.506",
          height: "108.506",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB"
        }, i.a.createElement("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }), i.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), i.a.createElement("feOffset", {
          dy: "2.13792"
        }), i.a.createElement("feGaussianBlur", {
          stdDeviation: "2.13792"
        }), i.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.1 0"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), i.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), i.a.createElement("feOffset", {
          dy: "7.12641"
        }), i.a.createElement("feGaussianBlur", {
          stdDeviation: "7.12641"
        }), i.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow",
          result: "effect2_dropShadow"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow",
          result: "shape"
        }))));
      },
      "sequence-envelope": function SequenceEnvelopeSvg(e) {
        var t = e.className,
            n = e.height,
            r = void 0 === n ? "94" : n,
            a = e.width,
            o = void 0 === a ? "92" : a;
        return i.a.createElement("svg", {
          className: t,
          width: o,
          height: r,
          viewBox: "0 0 92 94",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", {
          filter: "url(#filter0_dd)"
        }, i.a.createElement("rect", {
          x: "19",
          y: "28.8491",
          width: "54.4151",
          height: "38.0377",
          rx: "1.0566",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), i.a.createElement("rect", {
          x: "22.1698",
          y: "13",
          width: "48.0755",
          height: "49.1321",
          rx: "1.58491",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2"
        }), i.a.createElement("path", {
          d: "M19 30.9624V66.8869H73.4151L19 30.9624Z",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), i.a.createElement("path", {
          d: "M73.4151 66.8869V30.9624L19 66.8869H73.4151Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2",
          "stroke-linejoin": "round"
        }), i.a.createElement("path", {
          d: "M54.9873 30.4913C53.9379 31.5362 52.5278 32.0594 51.1229 32.0594C49.7319 32.0594 48.3466 31.5487 47.3171 30.5223C46.9746 30.1816 46.9657 29.6216 47.298 29.2702C47.6304 28.9187 48.1766 28.9103 48.5183 29.2511C49.9138 30.6413 52.3742 30.6248 53.7853 29.22C54.4531 28.554 54.8209 27.671 54.8209 26.7329C54.82 25.7967 54.4526 24.9155 53.7853 24.2525C52.3933 22.8632 50.1303 22.8623 48.7326 24.2432C48.0231 25.0104 47.5607 25.964 47.0722 26.9739C46.5042 28.1475 45.9185 29.3611 44.8855 30.4691C44.8811 30.4735 44.8753 30.4744 44.8709 30.4784C44.8673 30.4828 44.8664 30.4877 44.8625 30.4913C43.8339 31.5167 42.4823 32.0292 41.129 32.0292C39.7774 32.0292 38.4263 31.5167 37.3964 30.4913C36.3909 29.4885 35.8362 28.1533 35.8371 26.7321C35.838 25.3135 36.3922 23.981 37.3964 22.9808C39.4832 20.9011 42.9953 20.8856 45.0666 22.948C45.4091 23.2888 45.418 23.8487 45.0856 24.2002C44.7524 24.5525 44.2062 24.5591 43.8654 24.2193C42.4699 22.83 40.0095 22.8446 38.5993 24.2521C37.9306 24.9159 37.5637 25.7967 37.5628 26.7334C37.5628 27.6714 37.9297 28.5544 38.5984 29.2213C39.9913 30.6066 42.2534 30.608 43.6489 29.2298C44.4937 28.321 44.996 27.2845 45.5267 26.1867C46.0538 25.0961 46.5996 23.969 47.4977 23.0039C47.5013 22.9995 47.507 22.9986 47.5115 22.9946C47.515 22.9901 47.5168 22.9853 47.5199 22.9817C49.5783 20.9286 52.9293 20.9286 54.9873 22.9817C55.9928 23.981 56.5457 25.3135 56.5466 26.7325C56.5474 28.1537 55.9932 29.4889 54.9873 30.4917V30.4913Z",
          fill: "#353F45"
        })), i.a.createElement("defs", null, i.a.createElement("filter", {
          id: "filter0_dd",
          x: "-11.2688",
          y: "-8.63441",
          width: "114.538",
          height: "114.538",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB"
        }, i.a.createElement("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }), i.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), i.a.createElement("feOffset", {
          dy: "2.59032"
        }), i.a.createElement("feGaussianBlur", {
          stdDeviation: "2.59032"
        }), i.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.1 0"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow"
        }), i.a.createElement("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), i.a.createElement("feOffset", {
          dy: "8.63441"
        }), i.a.createElement("feGaussianBlur", {
          stdDeviation: "8.63441"
        }), i.a.createElement("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.207843 0 0 0 0 0.247059 0 0 0 0 0.270588 0 0 0 0.15 0"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in2: "effect1_dropShadow",
          result: "effect2_dropShadow"
        }), i.a.createElement("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect2_dropShadow",
          result: "shape"
        }))));
      },
      "cw-abandoned-scheduling": function CWAbandonedSchedulingSVG(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", null, i.a.createElement("rect", {
          x: "13",
          y: "30.9056",
          width: "54.4151",
          height: "38.0377",
          rx: "1.0566",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2.11321",
          strokeLinejoin: "round"
        }), i.a.createElement("rect", {
          x: "16.1698",
          y: "15.0565",
          width: "48.0755",
          height: "49.1321",
          rx: "1.58491",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2.11321"
        }), i.a.createElement("rect", {
          x: "20",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "31",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "42",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "53",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "20",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "31",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "42",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "53",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("path", {
          d: "M13 33.0189V68.9434H67.4151L13 33.0189Z",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2.11321",
          strokeLinejoin: "round"
        }), i.a.createElement("path", {
          d: "M67.4151 68.9434V33.0189L13 68.9434H67.4151Z",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2.11321",
          strokeLinejoin: "round"
        }), i.a.createElement("line", {
          x1: "23",
          y1: "12",
          x2: "23",
          y2: "18",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), i.a.createElement("line", {
          x1: "40",
          y1: "12",
          x2: "40",
          y2: "18",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), i.a.createElement("line", {
          x1: "57",
          y1: "12",
          x2: "57",
          y2: "18",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        })), i.a.createElement("circle", {
          cx: "64",
          cy: "64",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M58.9999 63.9997L62.7499 67.7497L69.2499 60.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-clp": function CWClpSvg(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", null, i.a.createElement("rect", {
          x: "10",
          y: "15",
          width: "60",
          height: "50",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("rect", {
          x: "15",
          y: "54",
          width: "50",
          height: "5",
          rx: "2.5",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "30",
          y: "28",
          width: "35",
          height: "7",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "44",
          y: "38",
          width: "21",
          height: "7",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "15",
          y: "20",
          width: "17",
          height: "3",
          rx: "1.5",
          fill: "#353F45"
        })));
      },
      "cw-help-article-lookup": function CWHelpArticleLookupSvg(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", {
          clipPath: "url(#clip0)"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.3514 20.7326C35.926 20.1692 37.0542 18.6488 37.0542 16.8615C37.0542 14.5946 35.2391 12.757 33.0001 12.757C30.7612 12.757 28.9461 14.5946 28.9461 16.8615C28.9461 18.6487 30.0741 20.169 31.6487 20.7325V27.109H27.5946V29.8433H10.0523C8.91884 29.8433 8 30.7622 8 31.8956V59.2595C8 60.393 8.91884 61.3118 10.0523 61.3118H31.0769V64.6923H34.9231V61.3118H55.9477C57.0812 61.3118 58 60.393 58 59.2595V31.8956C58 30.7622 57.0812 29.8433 55.9477 29.8433H38.4054V27.109H34.3514V20.7326ZM31.0769 64.6923C24.7044 64.6923 19.5385 69.8582 19.5385 76.2308V78.1538C19.5385 79.2159 20.3995 80.0769 21.4615 80.0769H44.5385C45.6005 80.0769 46.4615 79.2159 46.4615 78.1538V76.2308C46.4615 69.8582 41.2956 64.6923 34.9231 64.6923H31.0769Z",
          fill: "#353F45"
        }), i.a.createElement("rect", {
          x: "14.7568",
          y: "38.7273",
          width: "37.1622",
          height: "11.6185",
          rx: "5.80924",
          fill: "white"
        }), i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.5134 44.5387C46.5134 46.6167 44.8496 48.3012 42.7972 48.3012C40.7448 48.3012 39.081 46.6167 39.081 44.5387C39.081 42.4607 40.7448 40.7761 42.7972 40.7761C44.8496 40.7761 46.5134 42.4607 46.5134 44.5387ZM27.5945 44.5391C27.5945 46.6171 25.9307 48.3016 23.8783 48.3016C21.8259 48.3016 20.1621 46.6171 20.1621 44.5391C20.1621 42.4611 21.8259 40.7766 23.8783 40.7766C25.9307 40.7766 27.5945 42.4611 27.5945 44.5391Z",
          fill: "#353F45"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          d: "M60.5 13C53.0564 13 47 17.5182 47 23.0721C47 26.5334 49.9576 29.5232 52.8794 30.689C53.393 30.8932 53.7283 31.3906 53.7283 31.9426C53.7283 33.7345 53.091 35.4856 52.4054 36.8493C53.9659 36.4211 55.7702 35.5895 56.5994 33.9795C56.832 33.5315 57.2948 33.2494 57.7998 33.2494H60.5C67.9436 33.2494 74 28.6842 74 23.0721C74 17.5182 67.9436 13 60.5 13Z",
          fill: "white"
        }), i.a.createElement("path", {
          d: "M52.5088 31.6178L52.51 31.6182C52.6406 31.6701 52.7283 31.7978 52.7283 31.9426C52.7283 33.5136 52.1641 35.103 51.512 36.4001C51.3345 36.7531 51.3815 37.1774 51.6319 37.483C51.8823 37.7886 52.2891 37.9182 52.6701 37.8137C54.2932 37.3683 56.4566 36.4385 57.4873 34.4395C57.5486 34.3221 57.6697 34.2494 57.7998 34.2494H60.5C64.4192 34.2494 68.0101 33.0488 70.6433 31.0638C73.2766 29.0787 75 26.2622 75 23.0721C75 19.9065 73.2721 17.116 70.6393 15.1518C68.0063 13.1874 64.4168 12 60.5 12C56.5832 12 52.9937 13.1874 50.3607 15.1518C47.7279 17.116 46 19.9065 46 23.0721C46 25.0938 46.8626 26.9254 48.0758 28.3815C49.2879 29.8364 50.8949 30.9738 52.5088 31.6178Z",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        })), i.a.createElement("circle", {
          cx: "54.5",
          cy: "23.5",
          r: "1.5",
          fill: "#353F45"
        }), i.a.createElement("circle", {
          cx: "60.5",
          cy: "23.5",
          r: "1.5",
          fill: "#353F45"
        }), i.a.createElement("circle", {
          cx: "66.5",
          cy: "23.5",
          r: "1.5",
          fill: "#353F45"
        })), i.a.createElement("defs", null, i.a.createElement("clipPath", {
          id: "clip0"
        }, i.a.createElement("rect", {
          width: "80",
          height: "80",
          fill: "white"
        }))));
      },
      "cw-saved-keyword-group": function CWSavedKeywordGroupSvg(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", {
          clipPath: "url(#clip0)"
        }, i.a.createElement("g", null, i.a.createElement("circle", {
          cx: "40",
          cy: "40",
          r: "32",
          fill: "white"
        }), i.a.createElement("circle", {
          cx: "40",
          cy: "40",
          r: "31",
          stroke: "#353F45",
          strokeWidth: "2"
        })), i.a.createElement("mask", {
          id: "path-3-inside-1",
          fill: "white"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70.0775 29.0527L41.8653 39.3001C41.814 39.1671 41.7479 39.0344 41.6679 38.9082C41.5786 38.7673 41.4874 38.6587 41.4143 38.5857C41.3413 38.5126 41.2328 38.4214 41.0918 38.3321C40.9656 38.2522 40.833 38.186 40.6999 38.1348L50.9473 9.92252C55.2098 11.4708 59.2092 13.9541 62.6276 17.3725C66.0459 20.7909 68.5293 24.7902 70.0775 29.0527ZM29.053 9.92252L39.3004 38.1348C39.1673 38.186 39.0346 38.2522 38.9085 38.3321C38.7675 38.4214 38.659 38.5126 38.5859 38.5857C38.5129 38.6587 38.4216 38.7673 38.3323 38.9082C38.2524 39.0344 38.1863 39.1671 38.135 39.3001L9.92276 29.0527C11.471 24.7902 13.9543 20.7909 17.3727 17.3725C20.7911 13.9541 24.7905 11.4708 29.053 9.92252ZM9.92276 50.947L38.135 40.6997C38.1863 40.8327 38.2524 40.9654 38.3323 41.0915C38.4216 41.2325 38.5129 41.341 38.5859 41.4141C38.659 41.4872 38.7675 41.5784 38.9085 41.6677C39.0346 41.7476 39.1673 41.8137 39.3004 41.865L29.053 70.0773C24.7905 68.529 20.7911 66.0457 17.3727 62.6273C13.9543 59.2089 11.471 55.2096 9.92276 50.947ZM50.9473 70.0773L40.6999 41.865C40.833 41.8137 40.9656 41.7476 41.0918 41.6677C41.2328 41.5784 41.3413 41.4872 41.4143 41.4141C41.4874 41.341 41.5786 41.2325 41.6679 41.0915C41.7479 40.9654 41.814 40.8327 41.8653 40.6997L70.0775 50.947C68.5293 55.2095 66.0459 59.2089 62.6276 62.6273C59.2092 66.0457 55.2098 68.529 50.9473 70.0773ZM40.0352 40.0349L41.8653 40.6997C41.8703 40.6866 41.8752 40.6735 41.88 40.6604L40.0616 39.9999L41.88 39.3394C41.8752 39.3263 41.8703 39.3132 41.8653 39.3001L40.0352 39.9648L40.6999 38.1348C40.6868 38.1297 40.6737 38.1248 40.6606 38.1201L40.0001 39.9384L39.3397 38.1201C39.3266 38.1248 39.3135 38.1297 39.3004 38.1348L39.9651 39.9648L38.135 39.3001C38.13 39.3132 38.1251 39.3263 38.1203 39.3394L39.9387 39.9999L38.1203 40.6604C38.1251 40.6735 38.13 40.6866 38.135 40.6997L39.9651 40.0349L39.3004 41.865C39.3135 41.8701 39.3266 41.875 39.3397 41.8797L40.0001 40.0613L40.6606 41.8797C40.6737 41.875 40.6868 41.8701 40.6999 41.865L40.0352 40.0349Z"
        })), i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M70.0775 29.0527L41.8653 39.3001C41.814 39.1671 41.7479 39.0344 41.6679 38.9082C41.5786 38.7673 41.4874 38.6587 41.4143 38.5857C41.3413 38.5126 41.2328 38.4214 41.0918 38.3321C40.9656 38.2522 40.833 38.186 40.6999 38.1348L50.9473 9.92252C55.2098 11.4708 59.2092 13.9541 62.6276 17.3725C66.0459 20.7909 68.5293 24.7902 70.0775 29.0527ZM29.053 9.92252L39.3004 38.1348C39.1673 38.186 39.0346 38.2522 38.9085 38.3321C38.7675 38.4214 38.659 38.5126 38.5859 38.5857C38.5129 38.6587 38.4216 38.7673 38.3323 38.9082C38.2524 39.0344 38.1863 39.1671 38.135 39.3001L9.92276 29.0527C11.471 24.7902 13.9543 20.7909 17.3727 17.3725C20.7911 13.9541 24.7905 11.4708 29.053 9.92252ZM9.92276 50.947L38.135 40.6997C38.1863 40.8327 38.2524 40.9654 38.3323 41.0915C38.4216 41.2325 38.5129 41.341 38.5859 41.4141C38.659 41.4872 38.7675 41.5784 38.9085 41.6677C39.0346 41.7476 39.1673 41.8137 39.3004 41.865L29.053 70.0773C24.7905 68.529 20.7911 66.0457 17.3727 62.6273C13.9543 59.2089 11.471 55.2096 9.92276 50.947ZM50.9473 70.0773L40.6999 41.865C40.833 41.8137 40.9656 41.7476 41.0918 41.6677C41.2328 41.5784 41.3413 41.4872 41.4143 41.4141C41.4874 41.341 41.5786 41.2325 41.6679 41.0915C41.7479 40.9654 41.814 40.8327 41.8653 40.6997L70.0775 50.947C68.5293 55.2095 66.0459 59.2089 62.6276 62.6273C59.2092 66.0457 55.2098 68.529 50.9473 70.0773ZM40.0352 40.0349L41.8653 40.6997C41.8703 40.6866 41.8752 40.6735 41.88 40.6604L40.0616 39.9999L41.88 39.3394C41.8752 39.3263 41.8703 39.3132 41.8653 39.3001L40.0352 39.9648L40.6999 38.1348C40.6868 38.1297 40.6737 38.1248 40.6606 38.1201L40.0001 39.9384L39.3397 38.1201C39.3266 38.1248 39.3135 38.1297 39.3004 38.1348L39.9651 39.9648L38.135 39.3001C38.13 39.3132 38.1251 39.3263 38.1203 39.3394L39.9387 39.9999L38.1203 40.6604C38.1251 40.6735 38.13 40.6866 38.135 40.6997L39.9651 40.0349L39.3004 41.865C39.3135 41.8701 39.3266 41.875 39.3397 41.8797L40.0001 40.0613L40.6606 41.8797C40.6737 41.875 40.6868 41.8701 40.6999 41.865L40.0352 40.0349Z",
          fill: "white"
        }), i.a.createElement("path", {
          d: "M70.0775 29.0527L75.8813 45.0313L91.8599 39.2275L86.0561 23.2489L70.0775 29.0527ZM41.6679 38.9082L27.3072 48.006L27.3072 48.006L41.6679 38.9082ZM41.0918 38.3321L31.994 52.6928L31.9941 52.6929L41.0918 38.3321ZM50.9473 9.92252L56.7511 -6.05608L40.7725 -11.8599L34.9687 4.11871L50.9473 9.92252ZM29.053 9.92252L45.0316 4.11871L39.2278 -11.8599L23.2492 -6.05608L29.053 9.92252ZM38.9085 38.3321L48.0062 52.6929L48.0063 52.6928L38.9085 38.3321ZM38.3323 38.9082L52.693 48.0061L52.6931 48.0059L38.3323 38.9082ZM9.92276 29.0527L-6.05584 23.2489L-11.8597 39.2275L4.11895 45.0313L9.92276 29.0527ZM9.92276 50.947L4.11895 34.9684L-11.8597 40.7723L-6.05584 56.7509L9.92276 50.947ZM38.3323 41.0915L52.6931 31.9939L52.693 31.9937L38.3323 41.0915ZM38.9085 41.6677L48.0063 27.307L48.0062 27.3069L38.9085 41.6677ZM29.053 70.0773L23.2492 86.0559L39.2278 91.8597L45.0316 75.8811L29.053 70.0773ZM50.9473 70.0773L34.9687 75.8811L40.7725 91.8597L56.7511 86.0559L50.9473 70.0773ZM41.0918 41.6677L31.9941 27.3069L31.994 27.307L41.0918 41.6677ZM41.6679 41.0915L27.3072 31.9938L27.3072 31.9938L41.6679 41.0915ZM70.0775 50.947L86.0561 56.7509L91.8599 40.7723L75.8813 34.9684L70.0775 50.947ZM40.0352 40.0349L45.839 24.0563L11.6317 11.6314L24.0566 45.8388L40.0352 40.0349ZM41.88 40.6604L57.8584 46.4647L63.6629 30.4858L47.6838 24.6818L41.88 40.6604ZM40.0616 39.9999L34.2578 24.0213L-9.73327 39.9999L34.2578 55.9785L40.0616 39.9999ZM41.88 39.3394L47.6838 55.318L63.6629 49.514L57.8584 33.5351L41.88 39.3394ZM40.0352 39.9648L24.0566 34.161L11.6316 68.3684L45.839 55.9434L40.0352 39.9648ZM40.6606 38.1201L46.465 22.1417L30.486 16.3371L24.682 32.3162L40.6606 38.1201ZM40.0001 39.9384L24.0215 45.7423L40.0001 89.7333L55.9787 45.7423L40.0001 39.9384ZM39.3397 38.1201L55.3183 32.3162L49.5142 16.3371L33.5353 22.1416L39.3397 38.1201ZM39.9651 39.9648L34.1612 55.9434L68.3687 68.3684L55.9437 34.161L39.9651 39.9648ZM38.1203 39.3394L22.1412 33.537L16.3393 49.5147L32.3165 55.318L38.1203 39.3394ZM39.9387 39.9999L45.7425 55.9785L89.7335 39.9999L45.7425 24.0213L39.9387 39.9999ZM38.1203 40.6604L32.3165 24.6818L16.3374 30.4858L22.1419 46.4647L38.1203 40.6604ZM39.9651 40.0349L55.9437 45.8388L68.3686 11.6314L34.1613 24.0563L39.9651 40.0349ZM39.3397 41.8797L33.5353 57.8581L49.5142 63.6627L55.3183 47.6835L39.3397 41.8797ZM40.0001 40.0613L55.9787 34.2575L40.0001 -9.73348L24.0215 34.2575L40.0001 40.0613ZM40.6606 41.8797L24.682 47.6835L30.486 63.6627L46.465 57.8581L40.6606 41.8797ZM34.5871 53.9977C34.3315 53.8992 34.0801 53.7942 33.8332 53.683L47.7919 22.6806C47.4701 22.5357 47.1436 22.3993 46.8127 22.2718L34.5871 53.9977ZM32.6885 53.1066C32.4564 52.9768 32.2247 52.839 31.994 52.6928L50.1896 23.9714C49.8899 23.7815 49.5882 23.602 49.2854 23.4327L32.6885 53.1066ZM31.9941 52.6929C31.7695 52.5506 31.5521 52.4044 31.3415 52.2548L51.0317 24.5366C50.7617 24.3448 50.4809 24.156 50.1895 23.9713L31.9941 52.6929ZM30.2317 51.3851C29.9595 51.1504 29.6787 50.8917 29.3935 50.6065L53.4352 26.5649C53.1018 26.2315 52.7651 25.9206 52.4294 25.6312L30.2317 51.3851ZM29.3935 50.6065C29.1084 50.3213 28.8496 50.0406 28.6149 49.7683L54.3688 27.5706C54.0795 27.2349 53.7685 26.8982 53.4352 26.5649L29.3935 50.6065ZM27.7452 48.6585C27.5957 48.448 27.4494 48.2305 27.3072 48.006L56.0287 29.8105C55.8441 29.5191 55.6552 29.2383 55.4634 28.9683L27.7452 48.6585ZM27.3072 48.006C27.1611 47.7753 27.0232 47.5436 26.8934 47.3115L56.5674 30.7147C56.398 30.4119 56.2185 30.1102 56.0287 29.8105L27.3072 48.006ZM26.317 46.1669C26.2058 45.9199 26.1008 45.6686 26.0023 45.413L57.7282 33.1873C57.6007 32.8564 57.4643 32.5299 57.3195 32.2081L26.317 46.1669ZM57.7274 46.8146C57.74 46.7819 57.7525 46.7492 57.7648 46.7167L25.974 34.6608C25.9836 34.6356 25.9933 34.6102 26.0031 34.5848L57.7274 46.8146ZM57.823 46.5612C57.8349 46.529 57.8467 46.4968 57.8584 46.4647L25.9016 34.856C25.9106 34.8313 25.9197 34.8064 25.9289 34.7814L57.823 46.5612ZM47.6838 24.6818L47.1787 24.4983L35.5711 56.4555L36.0762 56.639L47.6838 24.6818ZM46.3705 24.2048L45.8654 24.0213L34.2578 55.9785L34.7629 56.162L46.3705 24.2048ZM45.8654 55.9785L46.3705 55.795L34.7629 23.8378L34.2578 24.0213L45.8654 55.9785ZM47.1787 55.5015L47.6838 55.318L36.0762 23.3608L35.5711 23.5443L47.1787 55.5015ZM57.8584 33.5351C57.8466 33.5027 57.8347 33.4703 57.8228 33.4379L25.9291 45.219C25.9199 45.1939 25.9107 45.1689 25.9016 45.1438L57.8584 33.5351ZM57.7649 33.2833C57.7527 33.2512 57.7405 33.219 57.7281 33.187L26.0024 45.4133C25.9929 45.3884 25.9834 45.3636 25.9739 45.3387L57.7649 33.2833ZM24.7213 32.3309L24.5367 32.8393L56.4939 44.4469L56.6785 43.9386L24.7213 32.3309ZM24.2412 33.6527L24.0566 34.161L56.0138 45.7687L56.1984 45.2603L24.2412 33.6527ZM45.839 55.9434L46.3473 55.7588L34.7397 23.8016L34.2314 23.9862L45.839 55.9434ZM47.1607 55.4634L47.6691 55.2787L36.0614 23.3215L35.5531 23.5062L47.1607 55.4634ZM56.6785 43.9386L59.525 36.1019L27.5678 24.4942L24.7213 32.331L56.6785 43.9386ZM64.0794 23.5631L66.9259 15.7263L34.9687 4.11871L32.1222 11.9554L64.0794 23.5631ZM45.1435 25.9011C45.707 26.1058 46.2594 26.3451 46.7978 26.6189L62.2096 -3.68748C60.4291 -4.59293 58.6057 -5.38243 56.7511 -6.05608L45.1435 25.9011ZM49.2315 28.1728C49.703 28.5429 50.1625 28.949 50.6067 29.3933L74.6484 5.35166C73.2402 3.94346 71.7619 2.63443 70.2229 1.4266L49.2315 28.1728ZM50.6067 29.3933C51.051 29.8376 51.4572 30.2971 51.8272 30.7685L78.5734 9.77714C77.3656 8.23817 76.0566 6.75986 74.6484 5.35166L50.6067 29.3933ZM53.3811 33.2022C53.6549 33.7407 53.8942 34.2931 54.0989 34.8566L86.0561 23.2489C85.3825 21.3943 84.593 19.5709 83.6875 17.7904L53.3811 33.2022ZM64.2737 13.0741L56.437 15.9206L68.0446 47.8778L75.8813 45.0313L64.2737 13.0741ZM43.8982 20.475L36.0614 23.3215L47.6691 55.2787L55.5058 52.4322L43.8982 20.475ZM45.4135 53.9976C45.3887 54.0072 45.3638 54.0167 45.339 54.0261L33.2835 22.2351C33.2514 22.2473 33.2193 22.2596 33.1872 22.2719L45.4135 53.9976ZM45.2192 54.0709C45.1942 54.0802 45.1691 54.0893 45.144 54.0985L33.5353 22.1416C33.5029 22.1534 33.4705 22.1653 33.4382 22.1772L45.2192 54.0709ZM23.3611 43.9239L23.5445 44.429L55.5017 32.8213L55.3183 32.3162L23.3611 43.9239ZM23.8381 45.2372L24.0215 45.7423L55.9787 34.1346L55.7953 33.6295L23.8381 45.2372ZM55.9787 45.7423L56.1622 45.2371L24.205 33.6295L24.0215 34.1346L55.9787 45.7423ZM56.4558 44.429L56.6392 43.9239L24.682 32.3162L24.4985 32.8214L56.4558 44.429ZM34.8563 54.0985C34.8312 54.0893 34.8061 54.0802 34.781 54.0709L46.5622 22.1773C46.5298 22.1653 46.4974 22.1534 46.465 22.1417L34.8563 54.0985ZM34.6608 54.0259C34.6358 54.0164 34.6109 54.0069 34.5859 53.9973L46.8139 22.2723C46.7817 22.2599 46.7495 22.2475 46.7172 22.2353L34.6608 54.0259ZM53.9981 45.4127C53.8995 45.6685 53.7944 45.92 53.6832 46.167L22.6809 32.208C22.5359 32.5299 22.3995 32.8565 22.272 33.1875L53.9981 45.4127ZM53.1067 47.3118C52.9769 47.5438 52.8391 47.7754 52.693 48.0061L23.9716 29.8104C23.7818 30.1101 23.6024 30.4117 23.433 30.7144L53.1067 47.3118ZM52.6931 48.0059C52.5509 48.2305 52.4046 48.4479 52.2551 48.6584L24.5368 28.9684C24.345 29.2384 24.1562 29.5191 23.9715 29.8106L52.6931 48.0059ZM51.3854 49.7682C51.1507 50.0405 50.8919 50.3213 50.6067 50.6065L26.5651 26.5649C26.2317 26.8983 25.9207 27.235 25.6314 27.5707L51.3854 49.7682ZM50.6067 50.6065C50.3215 50.8917 50.0407 51.1505 49.7684 51.3852L27.571 25.6311C27.2353 25.9205 26.8985 26.2314 26.5651 26.5649L50.6067 50.6065ZM48.6587 52.2548C48.4482 52.4044 48.2307 52.5506 48.0062 52.6929L29.8108 23.9713C29.5193 24.156 29.2386 24.3448 28.9686 24.5366L48.6587 52.2548ZM48.0063 52.6928C47.7756 52.8389 47.544 52.9767 47.3119 53.1065L30.7148 23.4327C30.412 23.6021 30.1104 23.7815 29.8107 23.9714L48.0063 52.6928ZM46.1673 53.683C45.9203 53.7942 45.6689 53.8992 45.4132 53.9977L33.1875 22.2718C32.8566 22.3994 32.53 22.5357 32.2082 22.6806L46.1673 53.683ZM32.3312 55.2787L32.8395 55.4634L44.4472 23.5062L43.9388 23.3215L32.3312 55.2787ZM33.6529 55.7588L34.1612 55.9434L45.7689 23.9862L45.2606 23.8016L33.6529 55.7588ZM55.9437 34.161L55.759 33.6527L23.8018 45.2603L23.9865 45.7687L55.9437 34.161ZM55.4636 32.8393L55.279 32.3309L23.3218 43.9386L23.5064 44.4469L55.4636 32.8393ZM43.9388 23.3215L36.1021 20.475L24.4945 52.4322L32.3312 55.2787L43.9388 23.3215ZM23.5633 15.9206L15.7266 13.0741L4.11895 45.0313L11.9557 47.8778L23.5633 15.9206ZM25.9014 34.8566C26.106 34.2931 26.3453 33.7407 26.6191 33.2022L-3.68724 17.7904C-4.59269 19.5709 -5.38219 21.3943 -6.05584 23.2489L25.9014 34.8566ZM28.1731 30.7685C28.5431 30.2971 28.9493 29.8376 29.3935 29.3933L5.3519 5.35166C3.9437 6.75986 2.63467 8.23816 1.42683 9.77714L28.1731 30.7685ZM29.3935 29.3933C29.8378 28.949 30.2973 28.5429 30.7688 28.1728L9.77738 1.42659C8.23841 2.63443 6.7601 3.94346 5.3519 5.35166L29.3935 29.3933ZM33.2025 26.6189C33.7409 26.3451 34.2933 26.1058 34.8568 25.9011L23.2492 -6.05608C21.3945 -5.38243 19.5712 -4.59293 17.7907 -3.68748L33.2025 26.6189ZM13.0744 15.7263L15.9209 23.5631L47.8781 11.9554L45.0316 4.11871L13.0744 15.7263ZM20.4753 36.1018L23.3218 43.9386L55.279 32.3309L52.4325 24.4942L20.4753 36.1018ZM53.9983 34.5876C54.0077 34.6122 54.0171 34.6368 54.0265 34.6615L22.2352 46.716C22.2473 46.748 22.2595 46.7799 22.2718 46.8117L53.9983 34.5876ZM54.0712 34.7808C54.0804 34.8058 54.0896 34.8309 54.0987 34.856L22.1419 46.4647C22.1537 46.4971 22.1655 46.5295 22.1775 46.5618L54.0712 34.7808ZM43.9241 56.639L44.4292 56.4555L32.8216 24.4983L32.3165 24.6818L43.9241 56.639ZM45.2374 56.162L45.7425 55.9785L34.1349 24.0213L33.6298 24.2048L45.2374 56.162ZM45.7425 24.0213L45.2374 23.8378L33.6298 55.795L34.1349 55.9785L45.7425 24.0213ZM44.4292 23.5443L43.9241 23.3608L32.3165 55.318L32.8216 55.5015L44.4292 23.5443ZM54.0994 45.1418C54.09 45.1676 54.0807 45.1933 54.0713 45.2187L22.1774 33.4383C22.1653 33.471 22.1532 33.5039 22.1412 33.537L54.0994 45.1418ZM54.0263 45.3388C54.017 45.3635 54.0076 45.3879 53.9983 45.4122L22.2718 33.1881C22.2596 33.2196 22.2475 33.2513 22.2354 33.2832L54.0263 45.3388ZM22.272 46.8124C22.3996 47.1434 22.536 47.47 22.6809 47.7919L53.6832 33.8328C53.7944 34.0798 53.8995 34.3312 53.998 34.587L22.272 46.8124ZM23.433 49.2853C23.6024 49.5881 23.7818 49.8897 23.9716 50.1894L52.693 31.9937C52.8391 32.2244 52.9769 32.456 53.1067 32.688L23.433 49.2853ZM23.9715 50.1892C24.1562 50.4807 24.345 50.7614 24.5368 51.0314L52.2551 31.3413C52.4046 31.5519 52.5509 31.7693 52.6931 31.9939L23.9715 50.1892ZM25.6314 52.4291C25.9207 52.7648 26.2317 53.1015 26.5651 53.4349L50.6067 29.3933C50.8919 29.6785 51.1507 29.9593 51.3854 30.2316L25.6314 52.4291ZM26.5651 53.4349C26.8985 53.7683 27.2353 54.0793 27.571 54.3687L49.7684 28.6146C50.0407 28.8493 50.3215 29.1081 50.6067 29.3933L26.5651 53.4349ZM28.9686 55.4632C29.2386 55.655 29.5193 55.8438 29.8108 56.0285L48.0062 27.3069C48.2307 27.4492 48.4482 27.5954 48.6587 27.745L28.9686 55.4632ZM29.8107 56.0284C30.1103 56.2182 30.4119 56.3977 30.7147 56.567L47.312 26.8933C47.544 27.0231 47.7756 27.1609 48.0063 27.307L29.8107 56.0284ZM32.2082 57.3192C32.5301 57.4641 32.8567 57.6005 33.1877 57.728L45.413 26.002C45.6688 26.1006 45.9202 26.2056 46.1672 26.3168L32.2082 57.3192ZM43.9388 56.6783L44.4472 56.4936L32.8396 24.5364L32.3312 24.7211L43.9388 56.6783ZM45.2605 56.1982L45.7689 56.0136L34.1613 24.0563L33.6529 24.241L45.2605 56.1982ZM23.9865 34.2311L23.8018 34.7395L55.759 46.3471L55.9437 45.8388L23.9865 34.2311ZM23.5064 35.5529L23.3217 36.0612L55.279 47.6688L55.4636 47.1605L23.5064 35.5529ZM32.3312 24.7211L24.4945 27.5676L36.1021 59.5248L43.9388 56.6783L32.3312 24.7211ZM11.9557 32.122L4.11895 34.9684L15.7266 66.9256L23.5633 64.0792L11.9557 32.122ZM-6.05584 56.7509C-5.38219 58.6055 -4.59269 60.4288 -3.68724 62.2094L26.6191 46.7975C26.3453 46.2591 26.106 45.7067 25.9014 45.1432L-6.05584 56.7509ZM1.42683 70.2226C2.63467 71.7616 3.9437 73.2399 5.3519 74.6481L29.3935 50.6065C28.9493 50.1622 28.5431 49.7027 28.1731 49.2312L1.42683 70.2226ZM5.3519 74.6481C6.7601 76.0563 8.23841 77.3654 9.77738 78.5732L30.7688 51.827C30.2973 51.4569 29.8378 51.0508 29.3935 50.6065L5.3519 74.6481ZM17.7907 83.6873C19.5712 84.5927 21.3945 85.3822 23.2492 86.0559L34.8568 54.0987C34.2933 53.894 33.7409 53.6547 33.2025 53.3809L17.7907 83.6873ZM45.0316 75.8811L47.8781 68.0443L15.9209 56.4367L13.0744 64.2734L45.0316 75.8811ZM52.4325 55.5056L55.279 47.6688L23.3218 36.0612L20.4753 43.8979L52.4325 55.5056ZM33.1874 57.7279C33.2198 57.7404 33.2521 57.7527 33.2843 57.765L45.3382 25.9734C45.3631 25.9829 45.3882 25.9924 45.4133 26.0021L33.1874 57.7279ZM33.4389 57.8228C33.4711 57.8347 33.5032 57.8465 33.5353 57.8581L45.144 25.9013C45.1688 25.9103 45.1936 25.9194 45.2185 25.9286L33.4389 57.8228ZM55.3183 47.6835L55.5017 47.1784L23.5445 35.5708L23.3611 36.0759L55.3183 47.6835ZM55.7953 46.3703L55.9787 45.8652L24.0215 34.2575L23.8381 34.7626L55.7953 46.3703ZM24.0215 45.8652L24.205 46.3703L56.1622 34.7626L55.9787 34.2575L24.0215 45.8652ZM24.4985 47.1784L24.682 47.6835L56.6392 36.0759L56.4558 35.5708L24.4985 47.1784ZM46.465 57.8581C46.497 57.8465 46.5292 57.8347 46.5614 57.8228L34.7817 25.9286C34.8066 25.9194 34.8315 25.9103 34.8563 25.9013L46.465 57.8581ZM46.7165 57.7648C46.7489 57.7525 46.7814 57.7401 46.8139 57.7275L34.5859 26.0025C34.6112 25.9928 34.6364 25.9831 34.6615 25.9736L46.7165 57.7648ZM46.8126 57.728C47.1435 57.6005 47.4701 57.4641 47.7919 57.3192L33.8331 26.3168C34.0801 26.2056 34.3315 26.1005 34.5872 26.002L46.8126 57.728ZM49.2854 56.5671C49.5882 56.3977 49.8899 56.2183 50.1896 56.0284L31.994 27.307C32.2247 27.1608 32.4563 27.023 32.6884 26.8932L49.2854 56.5671ZM50.1895 56.0285C50.4809 55.8438 50.7617 55.655 51.0317 55.4631L31.3415 27.745C31.5521 27.5954 31.7695 27.4492 31.9941 27.3069L50.1895 56.0285ZM52.4294 54.3686C52.7651 54.0792 53.1018 53.7683 53.4352 53.4349L29.3935 29.3933C29.6787 29.1081 29.9595 28.8494 30.2317 28.6147L52.4294 54.3686ZM53.4352 53.4349C53.7685 53.1015 54.0795 52.7649 54.3688 52.4291L28.6149 30.2315C28.8496 29.9592 29.1084 29.6785 29.3935 29.3933L53.4352 53.4349ZM55.4634 51.0315C55.6552 50.7615 55.8441 50.4807 56.0287 50.1893L27.3072 31.9938C27.4494 31.7693 27.5957 31.5518 27.7452 31.3413L55.4634 51.0315ZM56.0287 50.1893C56.2185 49.8896 56.398 49.5879 56.5674 49.2851L26.8934 32.6882C27.0232 32.4562 27.1611 32.2245 27.3072 31.9938L56.0287 50.1893ZM57.3195 47.7917C57.4643 47.4699 57.6007 47.1434 57.7282 46.8125L26.0023 34.5868C26.1008 34.3312 26.2058 34.0799 26.317 33.8329L57.3195 47.7917ZM56.6785 36.0612L56.4939 35.5529L24.5367 47.1605L24.7213 47.6688L56.6785 36.0612ZM56.1984 34.7395L56.0138 34.2311L24.0566 45.8388L24.2412 46.3471L56.1984 34.7395ZM34.2314 56.0136L34.7397 56.1982L46.3473 24.241L45.839 24.0563L34.2314 56.0136ZM35.5531 56.4936L36.0614 56.6783L47.6691 24.7211L47.1607 24.5364L35.5531 56.4936ZM24.7213 47.6688L27.5678 55.5056L59.525 43.8979L56.6785 36.0612L24.7213 47.6688ZM32.1222 68.0443L34.9687 75.8811L66.9259 64.2734L64.0794 56.4367L32.1222 68.0443ZM56.7511 86.0559C58.6057 85.3822 60.4291 84.5927 62.2096 83.6873L46.7978 53.3809C46.2594 53.6547 45.707 53.894 45.1435 54.0987L56.7511 86.0559ZM70.2229 78.5732C71.7619 77.3654 73.2402 76.0563 74.6484 74.6481L50.6067 50.6065C50.1625 51.0508 49.703 51.4569 49.2315 51.827L70.2229 78.5732ZM74.6484 74.6481C76.0566 73.2399 77.3656 71.7616 78.5734 70.2226L51.8272 49.2312C51.4572 49.7027 51.051 50.1622 50.6067 50.6065L74.6484 74.6481ZM83.6875 62.2094C84.593 60.4288 85.3825 58.6055 86.0561 56.7509L54.0989 45.1432C53.8942 45.7067 53.6549 46.2591 53.3811 46.7975L83.6875 62.2094ZM75.8813 34.9684L68.0446 32.1219L56.437 64.0792L64.2737 66.9256L75.8813 34.9684ZM55.5058 27.5676L47.6691 24.7211L36.0614 56.6783L43.8982 59.5248L55.5058 27.5676ZM70.0775 29.0527L81.6851 61.0099L113.642 49.4023L102.035 17.4451L70.0775 29.0527ZM41.6679 38.9082L12.9464 57.1037L12.9465 57.1038L41.6679 38.9082ZM41.0918 38.3321L22.8961 67.0535L22.8964 67.0537L41.0918 38.3321ZM50.9473 9.92252L62.5549 -22.0347L30.5977 -33.6423L18.9901 -1.68511L50.9473 9.92252ZM29.053 9.92252L61.0102 -1.68511L49.4026 -33.6423L17.4453 -22.0347L29.053 9.92252ZM38.9085 38.3321L57.1039 67.0536L57.104 67.0535L38.9085 38.3321ZM38.3323 38.9082L67.0537 57.1039L67.0539 57.1036L38.3323 38.9082ZM9.92276 29.0527L-22.0344 17.4451L-33.6421 49.4023L-1.68487 61.0099L9.92276 29.0527ZM9.92276 50.947L-1.68487 18.9898L-33.6421 30.5975L-22.0344 62.5547L9.92276 50.947ZM38.3323 41.0915L67.0539 22.8962L67.0537 22.8959L38.3323 41.0915ZM38.9085 41.6677L57.104 12.9462L57.1039 12.9462L38.9085 41.6677ZM29.053 70.0773L17.4454 102.034L49.4026 113.642L61.0102 81.6849L29.053 70.0773ZM50.9473 70.0773L18.9901 81.6849L30.5977 113.642L62.5549 102.034L50.9473 70.0773ZM41.0918 41.6677L22.8964 12.9461L22.8961 12.9463L41.0918 41.6677ZM41.6679 41.0915L12.9465 22.896L12.9464 22.8961L41.6679 41.0915ZM70.0775 50.947L102.035 62.5547L113.642 30.5975L81.6851 18.9898L70.0775 50.947ZM40.0352 40.0349L51.6428 8.07773L-16.7718 -16.7721L8.07798 51.6426L40.0352 40.0349ZM41.88 40.6604L73.8368 52.2691L85.4459 20.3112L53.4876 8.70317L41.88 40.6604ZM40.0616 39.9999L28.454 8.04269L-59.5281 39.9999L28.454 71.9571L40.0616 39.9999ZM41.88 39.3394L53.4876 71.2966L85.4459 59.6886L73.8368 27.7307L41.88 39.3394ZM40.0352 39.9648L8.07799 28.3572L-16.7719 96.7719L51.6428 71.9221L40.0352 39.9648ZM40.6606 38.1201L52.2693 6.16324L20.3114 -5.44584L8.70341 26.5124L40.6606 38.1201ZM40.0001 39.9384L8.04293 51.5461L40.0002 139.528L71.9573 51.5461L40.0001 39.9384ZM39.3397 38.1201L71.2969 26.5124L59.6888 -5.44584L27.731 6.16324L39.3397 38.1201ZM39.9651 39.9648L28.3574 71.922L96.7722 96.772L71.9223 28.3572L39.9651 39.9648ZM38.1203 39.3394L6.16204 27.7347L-5.44163 59.69L26.5127 71.2966L38.1203 39.3394ZM39.9387 39.9999L51.5463 71.9571L139.528 39.9999L51.5463 8.04269L39.9387 39.9999ZM38.1203 40.6604L26.5127 8.70317L-5.4456 20.3112L6.16348 52.2691L38.1203 40.6604ZM39.9651 40.0349L71.9223 51.6426L96.7721 -16.7721L28.3575 8.07774L39.9651 40.0349ZM39.3397 41.8797L27.731 73.8365L59.6888 85.4456L71.2969 53.4874L39.3397 41.8797ZM40.0001 40.0613L71.9573 28.4537L40.0002 -59.5283L8.04293 28.4537L40.0001 40.0613ZM40.6606 41.8797L8.70341 53.4873L20.3114 85.4456L52.2693 73.8365L40.6606 41.8797ZM28.4744 69.8607C27.9255 69.6492 27.3852 69.4235 26.8538 69.1843L54.7713 7.17932C54.1651 6.90639 53.5496 6.64933 52.9255 6.40882L28.4744 69.8607ZM24.39 67.9435C23.8904 67.6641 23.3921 67.3677 22.8961 67.0535L59.2874 9.61069C58.7225 9.25278 58.1541 8.91465 57.5839 8.5957L24.39 67.9435ZM22.8964 67.0537C22.4138 66.7479 21.9472 66.4341 21.4964 66.1139L60.8768 10.6776C60.3665 10.315 59.8366 9.95862 59.2871 9.61051L22.8964 67.0537ZM19.1329 64.2621C18.5566 63.7654 17.9671 63.2217 17.3727 62.6273L65.456 14.544C64.8133 13.9014 64.1679 13.3056 63.5282 12.7543L19.1329 64.2621ZM17.3727 62.6273C16.7783 62.0329 16.2346 61.4434 15.738 60.8671L67.2458 16.4718C66.6944 15.8321 66.0986 15.1867 65.456 14.544L17.3727 62.6273ZM13.8862 58.5036C13.5659 58.0528 13.2521 57.5862 12.9464 57.1037L70.3895 20.7128C70.0414 20.1633 69.685 19.6335 69.3224 19.1232L13.8862 58.5036ZM12.9465 57.1038C12.6323 56.6079 12.3358 56.1095 12.0564 55.61L71.4044 22.4162C71.0854 21.846 70.7473 21.2776 70.3894 20.7127L12.9465 57.1038ZM10.8158 53.1463C10.5766 52.615 10.3509 52.0747 10.1394 51.5258L73.5911 27.0744C73.3506 26.4503 73.0936 25.8348 72.8207 25.2287L10.8158 53.1463ZM73.5896 52.9295C73.6134 52.8677 73.6369 52.8061 73.6602 52.7447L10.0786 28.6329C10.0991 28.5788 10.1199 28.5244 10.1409 28.4699L73.5896 52.9295ZM73.7701 52.4512C73.7926 52.3902 73.8148 52.3295 73.8368 52.2691L9.92315 29.0517C9.94246 28.9985 9.96203 28.9451 9.98184 28.8915L73.7701 52.4512ZM53.4876 8.70317L52.9825 8.5197L29.7672 72.4341L30.2723 72.6176L53.4876 8.70317ZM52.1743 8.22615L51.6692 8.04269L28.454 71.9571L28.9591 72.1406L52.1743 8.22615ZM51.6692 71.9571L52.1743 71.7736L28.9591 7.85922L28.454 8.04269L51.6692 71.9571ZM52.9825 71.4801L53.4876 71.2966L30.2723 7.38221L29.7672 7.56567L52.9825 71.4801ZM73.8368 27.7307C73.8146 27.6696 73.7922 27.6085 73.7696 27.5474L9.98227 51.1095C9.96242 51.0558 9.94271 51.002 9.92315 50.9481L73.8368 27.7307ZM73.6604 27.2555C73.6374 27.1949 73.6143 27.1344 73.5909 27.0738L10.1396 51.5264C10.1191 51.4731 10.0987 51.4198 10.0785 51.3665L73.6604 27.2555ZM8.74271 26.5271L8.55807 27.0355L72.4725 50.2508L72.6571 49.7424L8.74271 26.5271ZM8.26263 27.8488L8.07799 28.3572L71.9924 51.5725L72.177 51.0641L8.26263 27.8488ZM51.6428 71.9221L52.1512 71.7374L28.9359 7.82299L28.4276 8.00763L51.6428 71.9221ZM52.9645 71.442L53.4729 71.2573L30.2576 7.34291L29.7493 7.52755L52.9645 71.442ZM72.6571 49.7424L75.5036 41.9057L11.5892 18.6904L8.74271 26.5271L72.6571 49.7424ZM80.058 29.3669L82.9045 21.5302L18.9901 -1.68511L16.1436 6.15163L80.058 29.3669ZM39.3397 41.8797C39.2576 41.8499 39.1745 41.8141 39.0919 41.7721L69.9155 -18.8407C67.5139 -20.0619 65.0551 -21.1265 62.5549 -22.0347L39.3397 41.8797ZM38.7358 41.5459C38.6735 41.4971 38.6236 41.4518 38.5859 41.4141L86.6692 -6.66915C84.779 -8.55931 82.7913 -10.3198 80.7186 -11.9465L38.7358 41.5459ZM38.5859 41.4141C38.5482 41.3764 38.5029 41.3265 38.4541 41.2642L91.9466 -0.718553C90.3198 -2.79127 88.5593 -4.77899 86.6692 -6.66915L38.5859 41.4141ZM38.228 40.9081C38.1859 40.8255 38.1501 40.7425 38.1203 40.6604L102.035 17.4451C101.127 14.9449 100.062 12.4861 98.8407 10.0845L38.228 40.9081ZM58.4699 -2.90446L50.6331 -0.0579707L73.8484 63.8564L81.6851 61.0099L58.4699 -2.90446ZM38.0944 4.49642L30.2576 7.34291L53.4729 71.2573L61.3096 68.4108L38.0944 4.49642ZM51.5267 69.8604C51.4734 69.881 51.4201 69.9013 51.3667 69.9216L27.2558 6.33964C27.1952 6.36262 27.1346 6.38578 27.0741 6.40911L51.5267 69.8604ZM51.1097 70.0178C51.056 70.0376 51.0022 70.0573 50.9483 70.0769L27.731 6.16324C27.6698 6.18545 27.6087 6.20784 27.5477 6.23038L51.1097 70.0178ZM7.38245 49.7277L7.56592 50.2328L71.4803 27.0175L71.2969 26.5124L7.38245 49.7277ZM7.85947 51.041L8.04293 51.5461L71.9573 28.3308L71.7739 27.8257L7.85947 51.041ZM71.9573 51.5461L72.1408 51.041L8.22639 27.8257L8.04293 28.3308L71.9573 51.5461ZM72.4344 50.2328L72.6178 49.7277L8.70341 26.5124L8.51994 27.0175L72.4344 50.2328ZM29.0519 70.0769C28.9981 70.0573 28.9442 70.0376 28.8904 70.0177L52.4527 6.23044C52.3916 6.20785 52.3305 6.18546 52.2693 6.16324L29.0519 70.0769ZM28.6326 69.9212C28.579 69.9009 28.5255 69.8804 28.4719 69.8598L52.928 6.40979C52.8671 6.38633 52.8063 6.36306 52.7454 6.34L28.6326 69.9212ZM69.8611 51.5253C69.6495 52.0745 69.4237 52.615 69.1844 53.1465L7.17968 25.2285C6.90668 25.8348 6.64953 26.4505 6.40891 27.075L69.8611 51.5253ZM67.9436 55.6104C67.6642 56.1099 67.3678 56.6081 67.0537 57.1039L9.61093 20.7126C9.25315 21.2774 8.91509 21.8456 8.59617 22.4158L67.9436 55.6104ZM67.0539 57.1036C66.7482 57.5861 66.4344 58.0527 66.1142 58.5035L10.6777 19.1233C10.3152 19.6336 9.95883 20.1634 9.61075 20.7129L67.0539 57.1036ZM64.2624 60.867C63.7657 61.4432 63.2221 62.0328 62.6276 62.6273L14.5443 14.544C13.9016 15.1868 13.3057 15.8323 12.7543 16.472L64.2624 60.867ZM62.6276 62.6273C62.033 63.2218 61.4435 63.7655 60.8672 64.2622L16.4722 12.7541C15.8325 13.3055 15.187 13.9013 14.5443 14.544L62.6276 62.6273ZM58.5038 66.1139C58.053 66.4342 57.5864 66.7479 57.1039 67.0536L20.7131 9.61055C20.1636 9.95863 19.6338 10.315 19.1235 10.6775L58.5038 66.1139ZM57.104 67.0535C56.6082 67.3676 56.11 67.6641 55.6105 67.9434L22.4162 8.59583C21.846 8.91475 21.2777 9.25282 20.7129 9.61064L57.104 67.0535ZM53.1468 69.1841C52.6154 69.4234 52.0751 69.6491 51.5261 69.8607L27.0746 6.40888C26.4504 6.64944 25.8348 6.90653 25.2286 7.17948L53.1468 69.1841ZM26.5273 71.2573L27.0357 71.4419L50.251 7.52757L49.7427 7.34292L26.5273 71.2573ZM27.8491 71.7374L28.3574 71.922L51.5728 8.00765L51.0644 7.823L27.8491 71.7374ZM71.9223 28.3572L71.7376 27.8488L7.82324 51.0641L8.00788 51.5725L71.9223 28.3572ZM71.4422 27.0355L71.2576 26.5271L7.34315 49.7424L7.5278 50.2508L71.4422 27.0355ZM49.7426 7.34291L41.9059 4.49642L18.6906 68.4108L26.5274 71.2573L49.7426 7.34291ZM29.3671 -0.057969L21.5304 -2.90446L-1.68487 61.0099L6.15187 63.8564L29.3671 -0.057969ZM41.88 40.6604C41.8502 40.7425 41.8143 40.8255 41.7723 40.9081L-18.8404 10.0845C-20.0617 12.4861 -21.1263 14.9449 -22.0344 17.4451L41.88 40.6604ZM41.5462 41.2642C41.4973 41.3265 41.452 41.3764 41.4143 41.4141L-6.66891 -6.66915C-8.55907 -4.779 -10.3195 -2.79128 -11.9463 -0.718564L41.5462 41.2642ZM41.4143 41.4141C41.3767 41.4518 41.3267 41.4971 41.2645 41.5459L-0.718321 -11.9465C-2.79104 -10.3198 -4.77876 -8.55931 -6.66891 -6.66915L41.4143 41.4141ZM40.9084 41.7721C40.8257 41.8141 40.7427 41.8499 40.6606 41.8797L17.4453 -22.0347C14.9451 -21.1265 12.4863 -20.0619 10.0848 -18.8407L40.9084 41.7721ZM-2.90422 21.5302L-0.0577289 29.3669L63.8567 6.15162L61.0102 -1.68511L-2.90422 21.5302ZM4.49666 41.9057L7.34315 49.7424L71.2576 26.5271L68.4111 18.6904L4.49666 41.9057ZM69.8615 28.4756C69.8819 28.5283 69.9021 28.5813 69.9222 28.6343L6.33952 52.7433C6.36237 52.8036 6.38537 52.8637 6.4085 52.9238L69.8615 28.4756ZM70.018 28.8903C70.0378 28.944 70.0575 28.9978 70.0771 29.0517L6.16348 52.2691C6.18572 52.3303 6.20809 52.3914 6.23061 52.4523L70.018 28.8903ZM49.7279 72.6176L50.233 72.4341L27.0178 8.51971L26.5127 8.70317L49.7279 72.6176ZM51.0412 72.1406L51.5463 71.9571L28.331 8.04269L27.8259 8.22616L51.0412 72.1406ZM51.5463 8.04269L51.0412 7.85923L27.8259 71.7736L28.331 71.9571L51.5463 8.04269ZM50.233 7.56568L49.7279 7.38221L26.5127 71.2966L27.0178 71.4801L50.233 7.56568ZM70.0786 50.9441C70.0585 50.9995 70.0384 51.0544 70.0182 51.1089L6.23039 27.5481C6.20757 27.6098 6.18478 27.6721 6.16204 27.7347L70.0786 50.9441ZM69.9218 51.3666C69.9017 51.4195 69.8816 51.4721 69.8615 51.5242L6.40851 27.076C6.38562 27.1354 6.36276 27.1952 6.33994 27.2554L69.9218 51.3666ZM6.40899 52.925C6.6496 53.5494 6.90674 54.1651 7.17972 54.7714L69.1844 26.8532C69.4236 27.3846 69.6494 27.9251 69.861 28.4743L6.40899 52.925ZM8.59615 57.584C8.91506 58.1542 9.25312 58.7224 9.61093 59.2872L67.0537 22.8959C67.3678 23.3917 67.6642 23.8899 67.9436 24.3894L8.59615 57.584ZM9.61075 59.2869C9.95883 59.8363 10.3152 60.3661 10.6777 60.8765L66.1142 21.4963C66.4344 21.9471 66.7482 22.4137 67.0539 22.8962L9.61075 59.2869ZM12.7543 63.5278C13.3057 64.1675 13.9016 64.813 14.5443 65.4557L62.6276 17.3725C63.2221 17.967 63.7657 18.5565 64.2624 19.1328L12.7543 63.5278ZM14.5443 65.4557C15.187 66.0985 15.8325 66.6943 16.4722 67.2457L60.8672 15.7376C61.4435 16.2343 62.033 16.7779 62.6276 17.3725L14.5443 65.4557ZM19.1235 69.3223C19.6338 69.6848 20.1636 70.0412 20.7131 70.3892L57.1039 12.9462C57.5864 13.2519 58.053 13.5656 58.5038 13.8859L19.1235 69.3223ZM20.7129 70.3891C21.2777 70.7469 21.8459 71.085 22.4161 71.4039L55.6106 12.0564C56.1101 12.3358 56.6083 12.6322 57.104 12.9462L20.7129 70.3891ZM25.2287 72.8203C25.835 73.0933 26.4506 73.3505 27.075 73.5911L51.5257 10.139C52.0748 10.3506 52.6153 10.5764 53.1468 10.8157L25.2287 72.8203ZM49.7426 72.6569L50.251 72.4722L27.0357 8.55782L26.5274 8.74246L49.7426 72.6569ZM51.0643 72.1768L51.5727 71.9922L28.3575 8.07774L27.8491 8.26238L51.0643 72.1768ZM8.00787 28.4273L7.82322 28.9357L71.7376 52.1509L71.9223 51.6426L8.00787 28.4273ZM7.52779 29.7491L7.34314 30.2574L71.2576 53.4726L71.4422 52.9643L7.52779 29.7491ZM26.5274 8.74247L18.6906 11.589L41.9059 75.5034L49.7426 72.6569L26.5274 8.74247ZM6.15187 16.1433L-1.68487 18.9898L21.5304 82.9042L29.3671 80.0578L6.15187 16.1433ZM-22.0344 62.5547C-21.1263 65.0549 -20.0617 67.5137 -18.8404 69.9153L41.7723 39.0916C41.8143 39.1743 41.8501 39.2573 41.88 39.3394L-22.0344 62.5547ZM-11.9463 80.7183C-10.3195 82.7911 -8.55907 84.7788 -6.66891 86.6689L41.4143 38.5857C41.452 38.6234 41.4973 38.6733 41.5462 38.7355L-11.9463 80.7183ZM-6.66891 86.6689C-4.77876 88.5591 -2.79104 90.3196 -0.718321 91.9463L41.2645 38.4538C41.3267 38.5027 41.3767 38.548 41.4143 38.5857L-6.66891 86.6689ZM10.0848 98.8405C12.4863 100.062 14.9451 101.126 17.4454 102.034L40.6606 38.1201C40.7427 38.1499 40.8257 38.1857 40.9084 38.2277L10.0848 98.8405ZM61.0102 81.6849L63.8567 73.8482L-0.0577289 50.6329L-2.90422 58.4696L61.0102 81.6849ZM68.4111 61.3094L71.2576 53.4727L7.34315 30.2574L4.49666 38.0941L68.4111 61.3094ZM27.0745 73.5908C27.1356 73.6144 27.1965 73.6377 27.2574 73.6608L51.3651 10.0776C51.4187 10.0979 51.4724 10.1184 51.5262 10.1392L27.0745 73.5908ZM27.5491 73.7699C27.6099 73.7924 27.6705 73.8146 27.731 73.8365L50.9483 9.92291C51.0015 9.94222 51.0548 9.96175 51.1083 9.98149L27.5491 73.7699ZM71.2969 53.4874L71.4803 52.9823L7.56592 29.767L7.38245 30.2721L71.2969 53.4874ZM71.7739 52.1741L71.9573 51.669L8.04293 28.4537L7.85947 28.9588L71.7739 52.1741ZM8.04293 51.669L8.2264 52.1741L72.1408 28.9588L71.9573 28.4537L8.04293 51.669ZM8.51994 52.9822L8.70341 53.4873L72.6178 30.2721L72.4344 29.767L8.51994 52.9822ZM52.2693 73.8365C52.3298 73.8146 52.3904 73.7924 52.4513 73.7699L28.8918 9.98154C28.9454 9.96177 28.9988 9.94222 29.0519 9.92291L52.2693 73.8365ZM52.744 73.6603C52.8051 73.6372 52.8665 73.6137 52.928 73.59L28.4719 10.14C28.5261 10.1191 28.5802 10.0985 28.634 10.078L52.744 73.6603ZM52.9253 73.591C53.5495 73.3505 54.1651 73.0934 54.7713 72.8204L26.8537 10.8155C27.3851 10.5763 27.9255 10.3506 28.4745 10.139L52.9253 73.591ZM57.5839 71.404C58.1542 71.0851 58.7225 70.747 59.2874 70.3891L22.8961 12.9463C23.3921 12.6321 23.8904 12.3357 24.3899 12.0563L57.5839 71.404ZM59.2871 70.3893C59.8366 70.0412 60.3665 69.6847 60.8768 69.3222L21.4964 13.8859C21.9472 13.5657 22.4138 13.2518 22.8964 12.9461L59.2871 70.3893ZM63.5282 67.2455C64.1679 66.6942 64.8133 66.0984 65.456 65.4557L17.3727 17.3725C17.9671 16.7781 18.5566 16.2344 19.1329 15.7377L63.5282 67.2455ZM65.456 65.4557C66.0986 64.8131 66.6944 64.1677 67.2458 63.528L15.738 19.1327C16.2346 18.5564 16.7783 17.9669 17.3727 17.3725L65.456 65.4557ZM69.3224 60.8766C69.685 60.3663 70.0414 59.8365 70.3895 59.287L12.9464 22.8961C13.2521 22.4135 13.5659 21.9469 13.8862 21.4961L69.3224 60.8766ZM70.3894 59.2871C70.7473 58.7221 71.0854 58.1538 71.4044 57.5836L12.0564 24.3898C12.3358 23.8903 12.6323 23.3919 12.9465 22.896L70.3894 59.2871ZM72.8207 54.7711C73.0936 54.1649 73.3506 53.5495 73.5911 52.9254L10.1394 28.474C10.3509 27.9251 10.5766 27.3848 10.8158 26.8535L72.8207 54.7711ZM72.6571 30.2574L72.4725 29.749L8.55806 52.9643L8.7427 53.4726L72.6571 30.2574ZM72.177 28.9357L71.9924 28.4273L8.07798 51.6426L8.26262 52.1509L72.177 28.9357ZM28.4276 71.9922L28.9359 72.1768L52.1512 8.26238L51.6428 8.07773L28.4276 71.9922ZM29.7493 72.4722L30.2576 72.6569L53.4729 8.74246L52.9645 8.55782L29.7493 72.4722ZM8.74271 53.4727L11.5892 61.3094L75.5036 38.0941L72.6571 30.2574L8.74271 53.4727ZM16.1436 73.8482L18.9901 81.6849L82.9045 58.4696L80.058 50.6329L16.1436 73.8482ZM62.5549 102.034C65.0551 101.126 67.5139 100.062 69.9155 98.8405L39.0919 38.2277C39.1745 38.1857 39.2576 38.1499 39.3396 38.1201L62.5549 102.034ZM80.7186 91.9463C82.7913 90.3196 84.779 88.5591 86.6692 86.6689L38.5859 38.5857C38.6236 38.548 38.6735 38.5027 38.7358 38.4538L80.7186 91.9463ZM86.6692 86.6689C88.5593 84.7788 90.3198 82.7911 91.9466 80.7183L38.4541 38.7355C38.503 38.6733 38.5482 38.6234 38.5859 38.5857L86.6692 86.6689ZM98.8407 69.9153C100.062 67.5137 101.127 65.0549 102.035 62.5547L38.1203 39.3394C38.1501 39.2573 38.1859 39.1743 38.228 39.0916L98.8407 69.9153ZM81.6851 18.9898L73.8484 16.1433L50.6331 80.0578L58.4699 82.9042L81.6851 18.9898ZM61.3096 11.589L53.4729 8.74247L30.2576 72.6569L38.0944 75.5034L61.3096 11.589Z",
          fill: "#353F45",
          mask: "url(#path-3-inside-1)"
        }), i.a.createElement("g", null, i.a.createElement("path", {
          d: "M40.5 29C33.0564 29 27 33.5182 27 39.0721C27 42.5334 29.9576 45.5233 32.8794 46.689C33.393 46.8932 33.7283 47.3907 33.7283 47.9426C33.7283 49.7345 33.091 51.4856 32.4054 52.8493C33.9659 52.4211 35.7702 51.5895 36.5994 49.9795C36.832 49.5315 37.2948 49.2494 37.7998 49.2494H40.5C47.9436 49.2494 54 44.6842 54 39.0721C54 33.5182 47.9436 29 40.5 29Z",
          fill: "white"
        }), i.a.createElement("path", {
          d: "M32.5088 47.6178L32.51 47.6182C32.6406 47.6702 32.7283 47.7979 32.7283 47.9426C32.7283 49.5136 32.1641 51.103 31.512 52.4002C31.3345 52.7531 31.3815 53.1775 31.6319 53.4831C31.8823 53.7886 32.2891 53.9182 32.6701 53.8137C34.2932 53.3683 36.4566 52.4385 37.4873 50.4396C37.5486 50.3222 37.6697 50.2494 37.7998 50.2494H40.5C44.4192 50.2494 48.0101 49.0488 50.6433 47.0638C53.2766 45.0787 55 42.2623 55 39.0721C55 35.9066 53.2721 33.116 50.6393 31.1518C48.0063 29.1874 44.4168 28 40.5 28C36.5832 28 32.9937 29.1874 30.3607 31.1518C27.7279 33.116 26 35.9066 26 39.0721C26 41.0938 26.8626 42.9254 28.0758 44.3815C29.2879 45.8364 30.8949 46.9739 32.5088 47.6178Z",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        })), i.a.createElement("circle", {
          cx: "34.5",
          cy: "39.5",
          r: "1.5",
          fill: "#353F45"
        }), i.a.createElement("circle", {
          cx: "40.5",
          cy: "39.5",
          r: "1.5",
          fill: "#353F45"
        }), i.a.createElement("circle", {
          cx: "46.5",
          cy: "39.5",
          r: "1.5",
          fill: "#353F45"
        })), i.a.createElement("defs", null, i.a.createElement("clipPath", {
          id: "clip0"
        }, i.a.createElement("rect", {
          width: "80",
          height: "80",
          fill: "white"
        }))));
      },
      "cw-team-availability": function CWTeamAvailabilitySvg(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", null, i.a.createElement("rect", {
          x: "10",
          y: "16",
          width: "60",
          height: "52",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("line", {
          x1: "20",
          y1: "13",
          x2: "20",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), i.a.createElement("line", {
          x1: "41",
          y1: "13",
          x2: "41",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), i.a.createElement("line", {
          x1: "62",
          y1: "13",
          x2: "62",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), i.a.createElement("rect", {
          x: "14",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "25",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "36",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "47",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "58",
          y: "33",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "14",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "25",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "36",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "47",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "58",
          y: "44",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "14",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "25",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "36",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "47",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "58",
          y: "55",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "14",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "25",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "36",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "47",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "58",
          y: "22",
          width: "8",
          height: "8",
          rx: "1",
          fill: "#EFF3F5"
        })), i.a.createElement("circle", {
          cx: "65",
          cy: "61",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M59.9999 60.9997L63.7499 64.7497L70.2499 57.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-conversation-ratings": function CWConversationRatingsSVG(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("g", {
          clipPath: "url(#clip0)"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M34.3514 20.725C35.926 20.1621 37.0542 18.6431 37.0542 16.8576C37.0542 14.5929 35.2391 12.757 33.0001 12.757C30.7612 12.757 28.9461 14.5929 28.9461 16.8576C28.9461 18.643 30.0741 20.1619 31.6487 20.7249V27.109H27.5946V29.8433H10.0523C8.91884 29.8433 8 30.7622 8 31.8956V59.2293C8 60.3627 8.91884 61.2816 10.0523 61.2816H31.0769V64.6923H34.9231V61.2816H55.9477C57.0812 61.2816 58 60.3627 58 59.2293V31.8956C58 30.7622 57.0812 29.8433 55.9477 29.8433H38.4054V27.109H34.3514V20.725ZM31.0769 64.6923C24.7044 64.6923 19.5385 69.8582 19.5385 76.2308V78.1538C19.5385 79.2159 20.3995 80.0769 21.4615 80.0769H44.5385C45.6005 80.0769 46.4615 79.2159 46.4615 78.1538V76.2308C46.4615 69.8582 41.2956 64.6923 34.9231 64.6923H31.0769Z",
          fill: "#353F45"
        }), i.a.createElement("rect", {
          x: "14.7568",
          y: "38.7273",
          width: "37.1622",
          height: "11.6185",
          rx: "5.80924",
          fill: "white"
        }), i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.5134 44.5351C46.5134 46.6111 44.8496 48.294 42.7972 48.294C40.7448 48.294 39.081 46.6111 39.081 44.5351C39.081 42.4591 40.7448 40.7761 42.7972 40.7761C44.8496 40.7761 46.5134 42.4591 46.5134 44.5351ZM27.5945 44.5355C27.5945 46.6115 25.9307 48.2944 23.8783 48.2944C21.8259 48.2944 20.1621 46.6115 20.1621 44.5355C20.1621 42.4595 21.8259 40.7766 23.8783 40.7766C25.9307 40.7766 27.5945 42.4595 27.5945 44.5355Z",
          fill: "#353F45"
        })), i.a.createElement("g", null, i.a.createElement("path", {
          d: "M60.5 13C53.0564 13 47 17.5182 47 23.0721C47 26.5334 49.9576 29.5232 52.8794 30.689C53.393 30.8932 53.7283 31.3906 53.7283 31.9426C53.7283 33.7345 53.091 35.4856 52.4054 36.8493C53.9659 36.4211 55.7702 35.5895 56.5994 33.9795C56.832 33.5315 57.2948 33.2494 57.7998 33.2494H60.5C67.9436 33.2494 74 28.6842 74 23.0721C74 17.5182 67.9436 13 60.5 13Z",
          fill: "white"
        }), i.a.createElement("path", {
          d: "M52.5088 31.6178L52.51 31.6182C52.6406 31.6701 52.7283 31.7978 52.7283 31.9426C52.7283 33.5136 52.1641 35.103 51.512 36.4001C51.3345 36.7531 51.3815 37.1774 51.6319 37.483C51.8823 37.7886 52.2891 37.9182 52.6701 37.8137C54.2932 37.3683 56.4566 36.4385 57.4873 34.4395C57.5486 34.3221 57.6697 34.2494 57.7998 34.2494H60.5C64.4192 34.2494 68.0101 33.0488 70.6433 31.0638C73.2766 29.0787 75 26.2622 75 23.0721C75 19.9065 73.2721 17.116 70.6393 15.1518C68.0063 13.1874 64.4168 12 60.5 12C56.5832 12 52.9937 13.1874 50.3607 15.1518C47.7279 17.116 46 19.9065 46 23.0721C46 25.0938 46.8626 26.9254 48.0758 28.3815C49.2879 29.8364 50.8949 30.9738 52.5088 31.6178Z",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        })), i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M64.8401 21.9647L63.0699 23.777L63.4885 26.3468C63.5235 26.56 63.4333 26.7733 63.2576 26.8973C63.1607 26.9656 63.0474 27 62.9336 27C62.8401 27 62.7466 26.9769 62.6609 26.9301L60.5003 25.7337L58.3396 26.9301C58.1515 27.0338 57.9199 27.0214 57.7436 26.8973C57.5672 26.7733 57.4776 26.56 57.512 26.3468L57.9306 23.777L56.1604 21.9647C56.0128 21.8141 55.9621 21.593 56.0291 21.3933C56.0962 21.1931 56.2691 21.0476 56.4776 21.016L58.9013 20.6454L59.991 18.3232C60.0834 18.1263 60.2822 18 60.5003 18C60.7183 18 60.9166 18.1263 61.0096 18.3232L62.0986 20.6454L64.5224 21.016C64.7308 21.0476 64.9044 21.1931 64.9709 21.3933C65.0379 21.593 64.9872 21.8141 64.8401 21.9647Z",
          fill: "#353F45"
        })), i.a.createElement("defs", null, i.a.createElement("clipPath", {
          id: "clip0"
        }, i.a.createElement("rect", {
          width: "80",
          height: "80",
          fill: "white"
        }))));
      },
      "cw-document-success": function CWDocumentSuccessSVG(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "16",
          y: "11",
          width: "48",
          height: "58",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("rect", {
          x: "20",
          y: "19",
          width: "31",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "20",
          y: "25",
          width: "39",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "20",
          y: "31",
          width: "23",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("circle", {
          cx: "59",
          cy: "65",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M53.9999 64.9997L57.7499 68.7497L64.2499 61.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-document": function CWDocumentSVG(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "16",
          y: "11",
          width: "48",
          height: "58",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("rect", {
          x: "20",
          y: "19",
          width: "31",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "20",
          y: "25",
          width: "39",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "20",
          y: "31",
          width: "23",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }));
      },
      "cw-empty-search": function CWEmptySearchSVG(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "6",
          y: "24.3211",
          width: "46.4211",
          height: "5.52632",
          rx: "1",
          fill: "#353F45"
        }), i.a.createElement("rect", {
          x: "6",
          y: "35.3737",
          width: "37.5789",
          height: "5.52632",
          rx: "1",
          fill: "#353F45"
        }), i.a.createElement("rect", {
          x: "6",
          y: "46.4263",
          width: "42",
          height: "5.52632",
          rx: "1",
          fill: "#353F45"
        }), i.a.createElement("circle", {
          cx: "45.7894",
          cy: "32.0579",
          r: "22",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("mask", {
          id: "mask0",
          "mask-type": "alpha",
          maskUnits: "userSpaceOnUse",
          x: "24",
          y: "11",
          width: "43",
          height: "43"
        }, i.a.createElement("circle", {
          cx: "45.7894",
          cy: "32.0579",
          r: "21",
          fill: "white"
        })), i.a.createElement("g", {
          mask: "url(#mask0)"
        }, i.a.createElement("rect", {
          x: "-1.73694",
          y: "17.6895",
          width: "55.7053",
          height: "6.63158",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "-1.73694",
          y: "28.7421",
          width: "45.0947",
          height: "6.63158",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "-1.73694",
          y: "39.7948",
          width: "50.4",
          height: "6.63158",
          rx: "1",
          fill: "#EFF3F5"
        })), i.a.createElement("path", {
          d: "M51.3157 54.0834L58.4291 50.8474L65.0674 65.4399C65.7535 66.948 65.087 68.7268 63.5789 69.4128L61.927 70.1643C60.4188 70.8504 58.6401 70.184 57.954 68.6759L51.3157 54.0834Z",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2"
        }));
      },
      "cw-image-success": function CWImageSuccessSVG(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M35.1415 36.4374C35.5295 35.7878 36.4705 35.7878 36.8585 36.4374L48.0869 55.2372C48.485 55.9038 48.0047 56.75 47.2283 56.75H24.7717C23.9953 56.75 23.515 55.9038 23.9131 55.2372L35.1415 36.4374Z",
          fill: "#EFF3F5"
        }), i.a.createElement("path", {
          d: "M33.5719 56.7417L33.1143 57.5H34H67.2286C68.3962 57.5 69.1161 56.2247 68.5129 55.225L52.7843 29.1605C52.2009 28.1938 50.7991 28.1938 50.2157 29.1605L33.5719 56.7417Z",
          fill: "#EFF3F5",
          stroke: "white"
        }), i.a.createElement("circle", {
          cx: "21",
          cy: "31",
          r: "7",
          fill: "#EFF3F5"
        }), i.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M60.9999 57.9997L64.7499 61.7497L71.2499 54.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-image": function CWImageSVG(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M35.1415 36.4374C35.5295 35.7878 36.4705 35.7878 36.8585 36.4374L48.0869 55.2372C48.485 55.9038 48.0047 56.75 47.2283 56.75H24.7717C23.9953 56.75 23.515 55.9038 23.9131 55.2372L35.1415 36.4374Z",
          fill: "#EFF3F5"
        }), i.a.createElement("path", {
          d: "M33.5719 56.7417L33.1143 57.5H34H67.2286C68.3962 57.5 69.1161 56.2247 68.5129 55.225L52.7843 29.1605C52.2009 28.1938 50.7991 28.1938 50.2157 29.1605L33.5719 56.7417Z",
          fill: "#EFF3F5",
          stroke: "white"
        }), i.a.createElement("circle", {
          cx: "21",
          cy: "31",
          r: "7",
          fill: "#EFF3F5"
        }));
      },
      "cw-video-success": function CWVideoSuccessSVG(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M50.5 39.134C51.1667 39.5189 51.1667 40.4811 50.5 40.866L34 50.3923C33.3333 50.7772 32.5 50.2961 32.5 49.5263L32.5 30.4737C32.5 29.7039 33.3333 29.2228 34 29.6077L50.5 39.134Z",
          fill: "#EFF3F5"
        }), i.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M60.9999 57.9997L64.7499 61.7497L71.2499 54.2497",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-video": function CWVideoSVG(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M50.5 39.134C51.1667 39.5189 51.1667 40.4811 50.5 40.866L34 50.3923C33.3333 50.7772 32.5 50.2961 32.5 49.5263L32.5 30.4737C32.5 29.7039 33.3333 29.2228 34 29.6077L50.5 39.134Z",
          fill: "#EFF3F5"
        }));
      },
      "cw-announcement": function CWAnnouncementSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("circle", {
          cx: "31.5",
          cy: "16.5",
          r: "4.5",
          fill: "#353F45"
        }), i.a.createElement("path", {
          d: "M26.9218 27.1368C27.3054 29.3124 25.8527 31.387 23.6772 31.7706C21.5016 32.1542 19.4269 30.7015 19.0433 28.526",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M25.8648 8.4744L5.75626 24.1683C5.39419 24.4509 5.27116 24.9438 5.45797 25.3634L7.4395 29.814C7.62878 30.2391 8.08628 30.4774 8.54315 30.389L33.4252 25.5709C33.828 25.493 34.1397 25.1783 34.1782 24.7699C34.3167 23.3008 34.4086 19.5969 32.5433 15.4075C30.6871 11.2383 28.034 9.1518 26.9056 8.40948C26.5823 8.19677 26.1699 8.23629 25.8648 8.4744Z",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M10 21.2018L6 24.7018L8.5 30.2018L13.5 29.2018L10 21.2018Z",
          fill: "#353F45"
        }));
      },
      "cw-bots": function CWBotsSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.8772 6.50283C21.7662 6.18473 22.4032 5.32634 22.4032 4.31733C22.4032 3.0375 21.3784 2 20.1144 2C18.8503 2 17.8256 3.0375 17.8256 4.31733C17.8256 5.32628 18.4624 6.18463 19.3514 6.50277V10.1105H17.0625V11.6558H7.15867C6.51875 11.6558 6 12.1745 6 12.8144V28.2633C6 28.9032 6.51875 29.4219 7.15866 29.4219H19.0286V31.3143C15.4308 31.3143 12.5143 34.2308 12.5143 37.8286V38.9143C12.5143 39.5139 13.0004 40 13.6 40H26.6286C27.2282 40 27.7143 39.5139 27.7143 38.9143V37.8286C27.7143 34.2308 24.7977 31.3143 21.2 31.3143V29.4219H33.0699C33.7098 29.4219 34.2286 28.9032 34.2286 28.2633V12.8144C34.2286 12.1745 33.7098 11.6558 33.0699 11.6558H23.166V10.1105H20.8772V6.50283Z",
          fill: "#353F45"
        }), i.a.createElement("rect", {
          x: "9.81476",
          y: "16.6762",
          width: "20.9807",
          height: "6.56577",
          rx: "3.28288",
          fill: "white"
        }), i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.7436 19.9583C27.7436 21.1314 26.8043 22.0825 25.6456 22.0825C24.4868 22.0825 23.5475 21.1314 23.5475 19.9583C23.5475 18.7851 24.4868 17.834 25.6456 17.834C26.8043 17.834 27.7436 18.7851 27.7436 19.9583ZM17.0626 19.9587C17.0626 21.1319 16.1233 22.0829 14.9645 22.0829C13.8058 22.0829 12.8665 21.1319 12.8665 19.9587C12.8665 18.7855 13.8058 17.8345 14.9645 17.8345C16.1233 17.8345 17.0626 18.7855 17.0626 19.9587Z",
          fill: "#353F45"
        }));
      },
      "cw-clp-marketplace": function CWCLPSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "5.5",
          y: "8",
          width: "29",
          height: "24",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("rect", {
          x: "7.5",
          y: "27",
          width: "25",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "14",
          y: "15",
          width: "17.5",
          height: "3.5",
          rx: "0.5",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "21",
          y: "20",
          width: "10.5",
          height: "3.5",
          rx: "0.5",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "8",
          y: "11",
          width: "9",
          height: "2",
          rx: "1",
          fill: "#353F45"
        }));
      },
      "cw-email": function CWEmailSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "7",
          y: "15.0333",
          width: "26",
          height: "18.1748",
          rx: "0.504854",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), i.a.createElement("rect", {
          x: "8.51459",
          y: "7.46045",
          width: "22.9709",
          height: "23.4757",
          rx: "0.757282",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("rect", {
          x: "11",
          y: "11",
          width: "10",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "11",
          y: "14",
          width: "17",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), i.a.createElement("path", {
          d: "M7 16.043V33.208H33L7 16.043Z",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), i.a.createElement("path", {
          d: "M33 33.208V16.043L7 33.208H33Z",
          fill: "#353F45",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }));
      },
      "cw-live-chat": function CWLiveChatSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          d: "M11.5068 26.7287L11.5079 26.7292C11.6369 26.7808 11.7283 26.9103 11.7283 27.0623C11.7283 28.646 11.1632 30.2473 10.5109 31.5531C10.3344 31.9064 10.3823 32.3304 10.6332 32.6353C10.8841 32.9403 11.291 33.069 11.6716 32.9639C13.2964 32.5153 15.459 31.5791 16.4885 29.5698C16.5514 29.4487 16.673 29.3773 16.7998 29.3773H19.5C23.4207 29.3773 27.0125 28.1687 29.6457 26.1711C32.2793 24.1732 34 21.3409 34 18.1357C34 14.9554 32.2748 12.1491 29.6418 10.1723C27.0086 8.19538 23.4182 7 19.5 7C15.5818 7 11.9914 8.19538 9.35824 10.1723C6.72518 12.1491 5 14.9554 5 18.1357C5 20.1664 5.861 22.0074 7.07378 23.4723C8.28541 24.9357 9.89228 26.0805 11.5068 26.7287Z",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), i.a.createElement("path", {
          d: "M22.0988 14.1216C21.2462 14.1216 20.3662 14.5135 19.7475 15.1622C19.6512 15.2567 19.5687 15.3378 19.5 15.4189C19.4313 15.3378 19.3487 15.2567 19.2525 15.1622C18.6337 14.5135 17.7537 14.1216 16.9013 14.1216C15.2513 14.1216 14 15.3378 14 16.973C14 18.5811 14.7425 19.3919 15.9662 20.5946C17.4787 22.0811 19.17 23.5946 19.1837 23.6081C19.356 23.762 19.6165 23.762 19.7887 23.6081C19.8025 23.5946 21.4937 22.0811 23.0062 20.5946C24.2575 19.3919 25 18.5811 25 16.973C25 15.3378 23.7487 14.1216 22.0988 14.1216Z",
          fill: "#D6DDE1"
        }));
      },
      "dizzybot-error": function DizzybotErrorSVG(e) {
        var t = e.height,
            n = void 0 === t ? "80" : t,
            r = e.width,
            a = void 0 === r ? "80" : r;
        return i.a.createElement("svg", {
          fill: "none",
          height: n,
          width: a,
          viewBox: "0 0 80 80"
        }, i.a.createElement("g", null, i.a.createElement("path", {
          clipRule: "evenodd",
          d: "M38.459 13.411h3.024v7.647h4.536v3.059h19.627a2.296 2.296 0 012.296 2.296v30.582a2.296 2.296 0 01-2.296 2.296H42.123v3.816h-4.304v-3.816H14.296A2.296 2.296 0 0112 56.995V26.413a2.296 2.296 0 012.296-2.296h19.627v-3.06h4.536zm-.64 49.696c-7.13 0-12.91 5.78-12.91 12.91v2.151c0 1.189.964 2.152 2.152 2.152h25.82a2.152 2.152 0 002.151-2.152v-2.151c0-7.13-5.78-12.91-12.91-12.91z",
          fill: "#353f45",
          fillRule: "evenodd"
        }), i.a.createElement("rect", {
          fill: "#fff",
          height: 12.999,
          rx: 6.5,
          transform: "rotate(-5 19.073 35.893)",
          width: 41.578,
          x: 19.073,
          y: 35.893
        }), i.a.createElement("path", {
          clipRule: "evenodd",
          d: "M55.088 40.812c-.04 2.322-1.935 4.172-4.23 4.132-2.297-.04-4.125-1.955-4.085-4.277.041-2.323 1.935-4.173 4.231-4.133 2.296.04 4.125 1.955 4.084 4.278zm-21.164-.37c-.04 2.323-1.935 4.173-4.23 4.133-2.297-.04-4.125-1.955-4.084-4.278.04-2.322 1.934-4.172 4.23-4.132 2.296.04 4.125 1.955 4.084 4.278z",
          fill: "#353f45",
          fillRule: "evenodd"
        }), i.a.createElement("path", {
          d: "M39.234 17.94c5.99 1.084 11.489 1.738 15.544 1.912 2.02.088 3.724.058 4.963-.11.612-.082 1.173-.206 1.617-.4.393-.173.995-.534 1.119-1.257s-.32-1.273-.633-1.573c-.353-.339-.838-.652-1.386-.945-1.109-.592-2.7-1.218-4.627-1.846-3.869-1.26-9.254-2.577-15.244-3.661S29.098 8.322 25.043 8.148c-2.02-.088-3.724-.058-4.963.11-.612.082-1.173.206-1.617.4-.393.173-.995.534-1.119 1.257-.124.722.32 1.273.633 1.573.353.339.838.652 1.386.945 1.109.592 2.7 1.218 4.627 1.846 3.869 1.26 9.254 2.577 15.244 3.661z",
          stroke: "#eff3f5",
          strokeWidth: 2
        }), i.a.createElement("path", {
          d: "M40.587 17.94c5.99-1.084 11.375-2.402 15.244-3.661 1.927-.628 3.518-1.254 4.627-1.846.548-.293 1.033-.606 1.386-.945.312-.3.757-.85.633-1.573s-.726-1.084-1.12-1.257c-.443-.194-1.004-.318-1.616-.4-1.24-.168-2.943-.198-4.963-.11-4.055.174-9.554.828-15.544 1.912s-11.375 2.402-15.244 3.661c-1.928.628-3.518 1.254-4.627 1.846-.548.293-1.033.606-1.386.945-.312.3-.757.85-.633 1.573s.726 1.084 1.12 1.257c.443.194 1.004.318 1.616.4 1.24.168 2.943.197 4.963.11 4.055-.175 9.554-.828 15.544-1.912z",
          stroke: "#eff3f5",
          strokeWidth: 2
        }), i.a.createElement("path", {
          clipRule: "evenodd",
          d: "M39.971 14.176c2.505 0 4.536-2.054 4.536-4.588C44.507 7.054 42.477 5 39.97 5c-2.505 0-4.536 2.054-4.536 4.588 0 2.534 2.031 4.588 4.536 4.588z",
          fill: "#353f45",
          fillRule: "evenodd"
        })));
      },
      "cw-upgrade-announcement": function CWUpgradeAnnouncementSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("circle", {
          cx: "31.5",
          cy: "16.5",
          r: "4.5",
          fill: "#687882"
        }), i.a.createElement("path", {
          d: "M26.9218 27.1368C27.3054 29.3124 25.8527 31.387 23.6772 31.7706C21.5016 32.1542 19.4269 30.7015 19.0433 28.526",
          stroke: "#687882",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M25.8648 8.4744L5.75626 24.1683C5.39419 24.4509 5.27116 24.9438 5.45797 25.3634L7.4395 29.814C7.62878 30.2391 8.08628 30.4774 8.54315 30.389L33.4252 25.5709C33.828 25.493 34.1397 25.1783 34.1782 24.7699C34.3167 23.3008 34.4086 19.5969 32.5433 15.4075C30.6871 11.2383 28.034 9.1518 26.9056 8.40948C26.5823 8.19677 26.1699 8.23629 25.8648 8.4744Z",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M10 21.2018L6 24.7018L8.5 30.2018L13.5 29.2018L10 21.2018Z",
          fill: "#687882"
        }));
      },
      "cw-upgrade-bots": function CWUpgradeBotsSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.8772 6.50283C21.7662 6.18473 22.4032 5.32634 22.4032 4.31733C22.4032 3.0375 21.3784 2 20.1144 2C18.8503 2 17.8256 3.0375 17.8256 4.31733C17.8256 5.32628 18.4624 6.18463 19.3514 6.50277V10.1105H17.0625V11.6558H7.15867C6.51875 11.6558 6 12.1745 6 12.8144V28.2633C6 28.9032 6.51875 29.4219 7.15866 29.4219H19.0286V31.3143C15.4308 31.3143 12.5143 34.2308 12.5143 37.8286V38.9143C12.5143 39.5139 13.0004 40 13.6 40H26.6286C27.2282 40 27.7143 39.5139 27.7143 38.9143V37.8286C27.7143 34.2308 24.7977 31.3143 21.2 31.3143V29.4219H33.0699C33.7098 29.4219 34.2286 28.9032 34.2286 28.2633V12.8144C34.2286 12.1745 33.7098 11.6558 33.0699 11.6558H23.166V10.1105H20.8772V6.50283Z",
          fill: "#687882"
        }), i.a.createElement("rect", {
          x: "9.81476",
          y: "16.6762",
          width: "20.9807",
          height: "6.56577",
          rx: "3.28288",
          fill: "white"
        }), i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.7436 19.9583C27.7436 21.1314 26.8043 22.0825 25.6456 22.0825C24.4868 22.0825 23.5475 21.1314 23.5475 19.9583C23.5475 18.7851 24.4868 17.834 25.6456 17.834C26.8043 17.834 27.7436 18.7851 27.7436 19.9583ZM17.0626 19.9587C17.0626 21.1319 16.1233 22.0829 14.9645 22.0829C13.8058 22.0829 12.8665 21.1319 12.8665 19.9587C12.8665 18.7855 13.8058 17.8345 14.9645 17.8345C16.1233 17.8345 17.0626 18.7855 17.0626 19.9587Z",
          fill: "#687882"
        }));
      },
      "cw-upgrade-clp": function CWUpgradeCLPSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "5.5",
          y: "8",
          width: "29",
          height: "24",
          rx: "2",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2"
        }), i.a.createElement("rect", {
          x: "7.5",
          y: "27",
          width: "25",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "14",
          y: "15",
          width: "17.5",
          height: "3.5",
          rx: "0.5",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "21",
          y: "20",
          width: "10.5",
          height: "3.5",
          rx: "0.5",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "8",
          y: "11",
          width: "9",
          height: "2",
          rx: "1",
          fill: "#687882"
        }));
      },
      "cw-upgrade-email": function CWUpgradeEmailSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "7",
          y: "15.0333",
          width: "26",
          height: "18.1748",
          rx: "0.504854",
          fill: "#687882",
          stroke: "#687882",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), i.a.createElement("rect", {
          x: "8.51459",
          y: "7.46045",
          width: "22.9709",
          height: "23.4757",
          rx: "0.757282",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2"
        }), i.a.createElement("rect", {
          x: "11",
          y: "11",
          width: "10",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "11",
          y: "14",
          width: "17",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), i.a.createElement("path", {
          d: "M7 16.043V33.208H33L7 16.043Z",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), i.a.createElement("path", {
          d: "M33 33.208V16.043L7 33.208H33Z",
          fill: "#687882",
          stroke: "#687882",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }));
      },
      "cw-upgrade-live-chat": function CWUpgradeLiveChatSVG(e) {
        var t = e.height,
            n = void 0 === t ? 40 : t,
            r = e.width,
            a = void 0 === r ? 40 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 40 40",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("path", {
          d: "M11.5068 26.7287L11.5079 26.7292C11.6369 26.7808 11.7283 26.9103 11.7283 27.0623C11.7283 28.646 11.1632 30.2473 10.5109 31.5531C10.3344 31.9064 10.3823 32.3304 10.6332 32.6353C10.8841 32.9403 11.291 33.069 11.6716 32.9639C13.2964 32.5153 15.459 31.5791 16.4885 29.5698C16.5514 29.4487 16.673 29.3773 16.7998 29.3773H19.5C23.4207 29.3773 27.0125 28.1687 29.6457 26.1711C32.2793 24.1732 34 21.3409 34 18.1357C34 14.9554 32.2748 12.1491 29.6418 10.1723C27.0086 8.19538 23.4182 7 19.5 7C15.5818 7 11.9914 8.19538 9.35824 10.1723C6.72518 12.1491 5 14.9554 5 18.1357C5 20.1664 5.861 22.0074 7.07378 23.4723C8.28541 24.9357 9.89228 26.0805 11.5068 26.7287Z",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2",
          strokeLinejoin: "round"
        }), i.a.createElement("path", {
          d: "M22.0988 14.1216C21.2462 14.1216 20.3662 14.5135 19.7475 15.1622C19.6512 15.2567 19.5687 15.3378 19.5 15.4189C19.4313 15.3378 19.3487 15.2567 19.2525 15.1622C18.6337 14.5135 17.7537 14.1216 16.9013 14.1216C15.2513 14.1216 14 15.3378 14 16.973C14 18.5811 14.7425 19.3919 15.9662 20.5946C17.4787 22.0811 19.17 23.5946 19.1837 23.6081C19.356 23.762 19.6165 23.762 19.7887 23.6081C19.8025 23.5946 21.4937 22.0811 23.0062 20.5946C24.2575 19.3919 25 18.5811 25 16.973C25 15.3378 23.7487 14.1216 22.0988 14.1216Z",
          fill: "#D6DDE1"
        }));
      },
      "cw-invite-success": function CWInviteSuccessSvg(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "12",
          y: "30.9056",
          width: "54.4151",
          height: "38.0377",
          rx: "1.0566",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), i.a.createElement("rect", {
          x: "15.1698",
          y: "15.0565",
          width: "48.0755",
          height: "49.1321",
          rx: "1.58491",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2.11321"
        }), i.a.createElement("path", {
          d: "M12 33.0189V68.9434H66.4151L12 33.0189Z",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), i.a.createElement("path", {
          d: "M66.4151 68.9434V33.0189L12 68.9434H66.4151Z",
          fill: "#353F45",
          stroke: "#353F45",
          "stroke-width": "2.11321",
          "stroke-linejoin": "round"
        }), i.a.createElement("path", {
          d: "M32.8636 29.7954L37.6136 34.5454L45.847 25.0454",
          stroke: "#353F45",
          "stroke-width": "3.48333",
          "stroke-linecap": "square"
        }));
      },
      "cw-image-failure": function CWImageFailureSvg(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "#F5F8FA",
          stroke: "#687882",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M33.1415 36.4374C33.5295 35.7878 34.4705 35.7878 34.8585 36.4374L46.0869 55.2372C46.485 55.9038 46.0047 56.75 45.2283 56.75H22.7717C21.9953 56.75 21.515 55.9038 21.9131 55.2372L33.1415 36.4374Z",
          fill: "#D6DDE1"
        }), i.a.createElement("path", {
          d: "M33.5719 56.7417L33.1143 57.5H34H67.2286C68.3962 57.5 69.1161 56.2247 68.5129 55.225L52.7843 29.1605C52.2009 28.1938 50.7991 28.1938 50.2157 29.1605L33.5719 56.7417Z",
          fill: "#D6DDE1",
          stroke: "#F5F8FA"
        }), i.a.createElement("circle", {
          cx: "21",
          cy: "31",
          r: "7",
          fill: "#D6DDE1"
        }), i.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M67.3065 60.7609L67.7413 51H64.4152L64.8717 60.7609H67.3065ZM66.0891 65.7174C67.0456 65.7174 67.85 64.913 67.85 63.9783C67.85 63.0217 67.0456 62.2174 66.0891 62.2174C65.1326 62.2174 64.35 63.0217 64.35 63.9783C64.35 64.913 65.1326 65.7174 66.0891 65.7174Z",
          fill: "white"
        }));
      },
      "cw-be-prepared": function CWBePreparedSvg(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "16",
          y: "11",
          width: "48",
          height: "58",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M44.4999 24.4998L48.2499 28.2498L54.7499 20.7498",
          stroke: "#EFF3F5",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }), i.a.createElement("path", {
          d: "M44.4999 39.4998L48.2499 43.2498L54.7499 35.7498",
          stroke: "#353F45",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }), i.a.createElement("path", {
          d: "M44.4999 54.4998L48.2499 58.2498L54.7499 50.7498",
          stroke: "#EFF3F5",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "cw-group": function CWGroup(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "3",
          y: "11",
          width: "34",
          height: "26",
          rx: "2.22876",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("circle", {
          cx: "20",
          cy: "22.671",
          r: "6",
          fill: "#353F45"
        }), i.a.createElement("path", {
          d: "M20 30C15.7036 30 8 30 8 36H32C32 30 24.2964 30 20 30Z",
          fill: "#353F45"
        }), i.a.createElement("rect", {
          x: "43",
          y: "11",
          width: "34",
          height: "26",
          rx: "2.22876",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("circle", {
          cx: "60",
          cy: "22.671",
          r: "6",
          fill: "#D6DDE1"
        }), i.a.createElement("path", {
          d: "M60 30C55.7036 30 48 30 48 36H72C72 30 64.2964 30 60 30Z",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "43",
          y: "43",
          width: "34",
          height: "26",
          rx: "2.22876",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("circle", {
          cx: "60",
          cy: "54.671",
          r: "6",
          fill: "#D6DDE1"
        }), i.a.createElement("path", {
          d: "M60 62C55.7036 62 48 62 48 68H72C72 62 64.2964 62 60 62Z",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "3",
          y: "43",
          width: "34",
          height: "26",
          rx: "2.22876",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("circle", {
          cx: "20",
          cy: "54.671",
          r: "6",
          fill: "#D6DDE1"
        }), i.a.createElement("path", {
          d: "M20 62C15.7036 62 8 62 8 68H32C32 62 24.2964 62 20 62Z",
          fill: "#D6DDE1"
        }));
      },
      "cw-one-on-one": function CWOneOnOneSvg(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "3",
          y: "11",
          width: "50",
          height: "36.2353",
          rx: "3.58824",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("circle", {
          cx: "27.3671",
          cy: "26.1907",
          r: "8.54357",
          fill: "#D6DDE1"
        }), i.a.createElement("path", {
          d: "M28 36C21.7343 36 10 37.2548 10 46.25H45C45 37.2548 34.2656 36 28 36Z",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "27",
          y: "27.7058",
          width: "50",
          height: "36.2353",
          rx: "3.58824",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("circle", {
          cx: "51.3671",
          cy: "42.8965",
          r: "8.54357",
          fill: "#353F45"
        }), i.a.createElement("path", {
          d: "M52 53C45.7343 53 34 54.2242 34 63H69C69 54.2242 58.2656 53 52 53Z",
          fill: "#353F45"
        }));
      },
      "cw-reminder": function CWReminderSvg(e) {
        var t = e.height,
            n = void 0 === t ? 80 : t,
            r = e.width,
            a = void 0 === r ? 80 : r;
        return i.a.createElement("svg", {
          className: "colorway-icon",
          width: a,
          height: n,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "10",
          y: "16",
          width: "60",
          height: "52",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("line", {
          x1: "20",
          y1: "13",
          x2: "20",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), i.a.createElement("line", {
          x1: "41",
          y1: "13",
          x2: "41",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), i.a.createElement("line", {
          x1: "62",
          y1: "13",
          x2: "62",
          y2: "19",
          stroke: "#353F45",
          strokeWidth: "2",
          strokeLinecap: "round"
        }), i.a.createElement("path", {
          d: "M42.0654 30.1844C42.1574 29.8769 42.0085 29.5486 41.7165 29.4152C41.4246 29.2819 41.079 29.3844 40.9069 29.6553L32.6002 42.7332C32.4744 42.9311 32.4665 43.1819 32.5794 43.3874C32.6924 43.593 32.9083 43.7207 33.1428 43.7207H38.3385L34.9335 53.7941C34.831 54.0973 34.9672 54.4298 35.2529 54.5739C35.5387 54.7181 35.887 54.6301 36.07 54.3675L45.4842 40.8586C45.6211 40.6621 45.6375 40.4058 45.5267 40.1935C45.4159 39.9813 45.1962 39.8482 44.9568 39.8482H39.1724L42.0654 30.1844Z",
          fill: "#EFF3F5",
          stroke: "#EFF3F5",
          strokeWidth: "1.28571",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), i.a.createElement("circle", {
          cx: "65",
          cy: "61",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M59.9999 60.9998L63.7499 64.7498L70.2499 57.2498",
          stroke: "white",
          strokeWidth: "2.75",
          strokeLinecap: "square"
        }));
      },
      "open-new-tab": function openNewTab(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "24" : n,
            a = e.height,
            s = void 0 === a ? "24" : a;
        return i.a.createElement("svg", {
          className: o()("tide--open-new-tab", t),
          width: r,
          height: s,
          viewBox: "0 0 16 16",
          fill: "none"
        }, i.a.createElement("path", {
          d: "M7.74359 3H5C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H11C12.1046 13 13 12.1046 13 11V8.41667M8.16026 8L13 3M13 3H10.0833M13 3V5.91667",
          stroke: "#687882",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }));
      },
      "csv-error": function csvError(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? 80 : n,
            a = e.height,
            o = void 0 === a ? 80 : a;
        return i.a.createElement("svg", {
          classname: t,
          width: r,
          height: o,
          viewBox: "0 0 80 80",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "8",
          y: "18",
          width: "64",
          height: "44",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          "stroke-width": "2"
        }), i.a.createElement("rect", {
          x: "13",
          y: "26",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "13",
          y: "32",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "13",
          y: "38",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "13",
          y: "44",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "13",
          y: "50",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "33",
          y: "26",
          width: "14",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "33",
          y: "32",
          width: "12",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "33",
          y: "38",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "33",
          y: "44",
          width: "14",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "33",
          y: "50",
          width: "18",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "53",
          y: "26",
          width: "8",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "53",
          y: "32",
          width: "12",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "53",
          y: "38",
          width: "10",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "53",
          y: "44",
          width: "12",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("rect", {
          x: "53",
          y: "50",
          width: "10",
          height: "4",
          rx: "1",
          fill: "#EFF3F5"
        }), i.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          "stroke-width": "2"
        }), i.a.createElement("circle", {
          cx: "66",
          cy: "58",
          r: "13",
          fill: "#353F45",
          stroke: "white",
          "stroke-width": "2"
        }), i.a.createElement("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M66 65C65.74 65 65.48 64.89 65.29 64.71C65.109 64.52 65 64.26 65 64C65 63.73 65.109 63.48 65.29 63.29C65.66 62.92 66.33 62.92 66.71 63.29C66.89 63.48 67 63.73 67 64C67 64.26 66.89 64.52 66.71 64.71C66.52 64.89 66.26 65 66 65ZM66 61C65.447 61 65 60.552 65 60V52C65 51.448 65.447 51 66 51C66.553 51 67 51.448 67 52V60C67 60.552 66.553 61 66 61Z",
          fill: "white",
          stroke: "white",
          "stroke-width": "0.5"
        }));
      },
      "email-reply-mgmt": function emailReplyMgmt(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? 32 : n,
            a = e.height,
            o = void 0 === a ? 23 : a;
        return i.a.createElement("svg", {
          className: t,
          width: r,
          height: o,
          viewBox: "0 0 33 25",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, i.a.createElement("rect", {
          x: "1",
          y: "1",
          width: "29",
          height: "20",
          rx: "2",
          fill: "white",
          stroke: "#353F45",
          strokeWidth: "2"
        }), i.a.createElement("rect", {
          x: "3",
          y: "4",
          width: "25",
          height: "2",
          rx: "1",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "15.5",
          y: "8",
          width: "10",
          height: "2",
          rx: "0.5",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "15.5",
          y: "11",
          width: "11",
          height: "2",
          rx: "0.5",
          fill: "#D6DDE1"
        }), i.a.createElement("rect", {
          x: "15.5",
          y: "14",
          width: "8",
          height: "2",
          rx: "0.5",
          fill: "#D6DDE1"
        }), i.a.createElement("circle", {
          cx: "9.46666",
          cy: "10.4833",
          r: "2.48332",
          fill: "#353F45"
        }), i.a.createElement("path", {
          d: "M9.46664 13.5167C7.6884 13.5167 4.5 13.5167 4.5 16H14.4333C14.4333 13.5167 11.2449 13.5167 9.46664 13.5167Z",
          fill: "#353F45"
        }), i.a.createElement("circle", {
          cx: "25.5",
          cy: "18",
          r: "6",
          fill: "#353F45",
          stroke: "white",
          strokeWidth: "2"
        }), i.a.createElement("path", {
          d: "M26.5 18.7071L28.2733 17.8897L29.397 19.4865",
          stroke: "white"
        }), i.a.createElement("path", {
          d: "M21.8261 16.5L22.9481 18.098L24.7222 17.2826",
          stroke: "white"
        }), i.a.createElement("path", {
          d: "M22.8173 18.1342C22.8173 16.6793 23.9966 15.5 25.4514 15.5C26.4264 15.5 27.2777 16.0297 27.7332 16.8171",
          stroke: "white"
        }), i.a.createElement("path", {
          d: "M28.0856 18.1342C28.0856 19.589 26.9062 20.7683 25.4514 20.7683C24.4764 20.7683 23.6251 20.2386 23.1697 19.4512",
          stroke: "white"
        }));
      },
      "phone-hangup": function phoneHangup(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "34" : n,
            a = e.height,
            o = void 0 === a ? "34" : a;
        return i.a.createElement("svg", {
          width: r,
          height: o,
          className: t,
          viewBox: "0 0 34 34",
          fill: "none"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.1959 10.344C10.9896 10.2923 5.61419 11.4633 3.82026 13.2572C3.17325 13.9042 3.04173 14.5477 3.04739 15.0667L3.36134 19.4126C3.38114 19.6771 3.50418 19.9245 3.7057 20.0992C3.90723 20.2753 4.16815 20.3637 4.4319 20.346L10.9557 19.9146C11.3552 19.8885 11.6939 19.6247 11.8176 19.2464L12.9667 15.7272L21.3523 15.7929L22.5572 19.3313C22.6866 19.7124 23.0323 19.9818 23.4326 20.0129L29.9804 20.532C30.2448 20.5532 30.5051 20.4669 30.7037 20.2937C30.8996 20.1204 31.0198 19.8743 31.034 19.6099L31.2546 15.2018C31.2426 13.6751 29.7138 12.449 26.71 11.5595C24.1595 10.8036 20.7802 10.3715 17.1959 10.344ZM26.174 13.4602C28.6277 14.1871 29.2202 14.9451 29.2704 15.2258L29.1043 18.475L24.2189 18.0882L22.9977 14.501C22.8591 14.0952 22.478 13.8187 22.0516 13.8166L12.2362 13.7381C11.8099 13.7345 11.433 14.0039 11.3 14.4084L10.1347 17.9793L5.267 18.3017L5.02729 14.9904C5.02658 14.9387 5.08103 14.8235 5.23376 14.6707C6.40826 13.4962 11.0052 12.2751 17.21 12.3267C20.6147 12.3528 23.7981 12.7559 26.174 13.4602Z",
          fill: "#353F45"
        }));
      },
      "microphone-off": function microphoneOff(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "30" : n,
            a = e.height,
            o = void 0 === a ? "30" : a;
        return i.a.createElement("svg", {
          width: r,
          height: o,
          className: t,
          viewBox: "0 0 30 30",
          fill: "none"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.707 4.7074L4.70674 26.7069C4.51128 26.9026 4.25537 27 3.99946 27C3.74355 27 3.48764 26.9026 3.29319 26.7069C2.90227 26.3164 2.90227 25.6841 3.29319 25.2936L8.71769 19.8683C7.64468 18.476 7.04218 16.7626 7.04218 15V12.8138C7.04218 12.2617 7.48952 11.8141 8.04164 11.8141C8.59377 11.8141 9.04211 12.2617 9.04211 12.8138V15C9.04211 16.2336 9.44512 17.4311 10.1514 18.4349L11.0088 17.5777C11.0078 17.5616 10.9997 17.5476 10.9997 17.5315V6.83438C10.9997 6.77415 11.0239 6.72296 11.034 6.66575C11.2083 4.61807 12.91 3 14.9996 3C17.0902 3 18.7919 4.61807 18.9662 6.66575C18.9763 6.72296 18.9995 6.77415 18.9995 6.83438V9.5867L25.2924 3.2931C25.6834 2.90263 26.3161 2.90263 26.707 3.2931C27.0979 3.68356 27.0979 4.31694 26.707 4.7074ZM17.0411 7.21497C17.025 7.14471 16.9978 7.07846 16.9978 7.00217C16.9978 5.89803 16.1011 5.00067 14.9978 5.00067C13.8946 5.00067 12.9979 5.89803 12.9979 7.00217V15.5864L17.0411 11.5432V7.21497ZM15.5413 19.9629C15.495 19.9699 15.4507 19.972 15.4053 19.972C14.9126 19.972 14.4844 19.6076 14.4159 19.1067C14.3414 18.5587 14.7252 18.0558 15.2723 17.9815C16.0854 17.8711 16.7584 17.2608 16.9458 16.4618C17.0728 15.9248 17.6128 15.5925 18.1488 15.718C18.6858 15.8435 19.0193 16.3825 18.8934 16.9205C18.5165 18.5205 17.1695 19.7431 15.5413 19.9629ZM9.9998 25.0003H14.0007V22.9296C13.5805 22.8774 13.1654 22.8001 12.7614 22.6816C12.2315 22.5271 11.9272 21.972 12.0823 21.441C12.2385 20.911 12.7927 20.6079 13.3236 20.7614C13.8636 20.92 14.4279 21.0003 15.0001 21.0003C18.3088 21.0003 20.9999 18.3092 20.9999 14.9998C20.9999 14.8713 21.0291 14.7509 21.0735 14.6385V13.0214C21.0735 12.4693 21.4483 11.8139 22.0004 11.8139C22.5525 11.8139 23.0009 12.2616 23.0009 12.8136V14.9998C23.0009 19.0721 19.94 22.4357 16.0006 22.9306V25.0003H20.0005C20.5526 25.0003 20.9999 25.448 20.9999 26.0001C20.9999 26.5521 20.5526 26.9998 20.0005 26.9998H9.9998C9.44768 26.9998 9.00034 26.5521 9.00034 26.0001C9.00034 25.448 9.44768 25.0003 9.9998 25.0003Z",
          fill: "#353F45"
        }));
      },
      "microphone-on": function microphoneOn(e) {
        var t = e.className,
            n = e.width,
            r = void 0 === n ? "30" : n,
            a = e.height,
            o = void 0 === a ? "30" : a;
        return i.a.createElement("svg", {
          width: r,
          height: o,
          className: t,
          viewBox: "0 0 30 30",
          fill: "none"
        }, i.a.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16 22.93V25H20C20.552 25 21 25.448 21 26C21 26.552 20.552 27 20 27H10C9.448 27 9 26.552 9 26C9 25.448 9.448 25 10 25H14V22.93C10.06 22.436 7 19.072 7 15V13C7 12.448 7.448 12 8 12C8.552 12 9 12.448 9 13V15C9 18.309 11.691 21 15 21C18.309 21 21 18.309 21 15V13C21 12.448 21.448 12 22 12C22.552 12 23 12.448 23 13V15C23 19.072 19.94 22.436 16 22.93ZM15 20C12.794 20 11 18.205 11 16C11 15.97 11.014 15.946 11.017 15.917C11.014 15.888 11 15.863 11 15.834V6.834C11 6.774 11.024 6.723 11.034 6.666C11.208 4.619 12.909 3 15 3C17.091 3 18.792 4.619 18.966 6.666C18.976 6.723 19 6.774 19 6.834V15.834C19 15.863 18.986 15.888 18.983 15.917C18.986 15.946 19 15.97 19 16C19 18.205 17.206 20 15 20ZM17 15.834V7.002C17 5.898 16.103 5 15 5C13.897 5 13 5.898 13 7.002V15.834C13 15.863 12.986 15.888 12.983 15.917C12.986 15.946 13 15.97 13 16C13 17.103 13.897 18 15 18C16.103 18 17 17.103 17 16C17 15.97 17.014 15.946 17.017 15.917C17.014 15.888 17 15.863 17 15.834Z",
          fill: "#353F45"
        }));
      }
    },
        c = (n(146), function getClassNames(e) {
      return "tide-icon ".concat(e);
    }),
        p = function Icon(e) {
      var t = e.name,
          n = e.className,
          r = void 0 === n ? "" : n,
          i = e.width,
          a = e.height,
          o = {
        className: c(r),
        width: i,
        height: a
      };
      return function getIconPath(e) {
        var t = l[e];
        if (!t) throw new Error("the icon ".concat(e, " does not exist."));
        return t;
      }(t)(o);
    },
        d = (n(148), {
      small: "small",
      medium: "medium",
      large: "large"
    }),
        h = {
      dark: "dark",
      light: "light"
    },
        u = "dark",
        f = "light",
        m = function CircleLoader(e) {
      var t = e.size,
          n = void 0 === t ? "medium" : t,
          r = e.colorMode,
          a = void 0 === r ? u : r,
          s = e.className,
          l = void 0 === s ? "" : s;
      return i.a.createElement(li, {
        className: o()("tide-circle-loader", d[n], h[a], l)
      }, i.a.createElement("svg", {
        className: "tide-circle-loader--spinner",
        viewBox: "25 25 50 50"
      }, i.a.createElement("circle", {
        className: "tide-circle-loader---loading-circle",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none"
      })));
    },
        g = (n(150), {
      primary: "tide-button--primary",
      secondary: "tide-button--secondary",
      tertiary: "tide-button--tertiary",
      danger: "tide-button--danger",
      subtle: "tide-button--subtle",
      utility: "tide-button--utility",
      inlineUtility: "tide-button--inline-utility"
    }),
        v = {
      small: "small",
      medium: "medium",
      large: "large"
    },
        b = {
      primary: f,
      secondary: f,
      tertiary: u,
      danger: f,
      subtle: u,
      utility: u
    },
        y = function getClassNames(e) {
      var t = e.type,
          n = e.size,
          r = e.className,
          i = e.iconAlignment,
          a = e.selected;
      return "tide-button ".concat(function selectedClass(e) {
        return e ? "selected" : "";
      }(a), " ").concat(g[t], " ").concat(v[n], " icon-").concat(i, " ").concat(r);
    },
        x = function LinkorButton(e) {
      return !!e.href ? i.a.createElement(Qr, e, e.children) : i.a.createElement("button", e, e.children);
    },
        w = function Button(e) {
      var t = e.type,
          n = void 0 === t ? "primary" : t,
          r = e.size,
          a = void 0 === r ? "medium" : r,
          s = e.loading,
          l = void 0 !== s && s,
          c = e.submit,
          d = void 0 !== c && c,
          h = e.disabled,
          u = void 0 !== h && h,
          f = e.className,
          g = void 0 === f ? "" : f,
          v = e.icon,
          w = e.iconAlignment,
          E = void 0 === w ? "left" : w,
          C = e.onClick,
          k = e.selected,
          S = e.children,
          _ = e.href,
          M = e.target,
          L = e.style,
          P = e.educationHover;
      return i.a.createElement(x, Object.assign({}, function getProps(e, t, n, r, i, a) {
        var o = {};
        return o.type = e ? "submit" : "button", r && (o.href = r), i && (o.target = i), t && (o.onClick = t), n && (o.disabled = n), a && (o.style = a), o;
      }(d, function onNonLoadingClick(e) {
        if (!l && C) return e && e.stopPropagation && e.stopPropagation(), C(e);
      }, u, _, M, L), {
        className: o()(y({
          type: n,
          size: a,
          className: g,
          iconAlignment: E,
          selected: k
        }), {
          "tide-button--education-hover": P
        })
      }), !!l && i.a.createElement(m, {
        className: "tide-button-loader",
        size: "small",
        colorMode: b[n]
      }), function FormattedChildren(e) {
        var t = e.children,
            n = e.icon,
            r = e.iconAlignment,
            a = e.hideContent,
            s = !!n,
            l = o()({
          "tide-text-hidden": a
        }),
            c = {
          left: i.a.createElement(oi, {
            className: l
          }, i.a.createElement(p, {
            name: n,
            width: 12,
            height: 12
          }), " ", t),
          right: i.a.createElement(oi, {
            className: l
          }, t, " ", i.a.createElement(p, {
            name: n
          }))
        };
        return s ? c[r] : i.a.createElement(oi, {
          className: l
        }, t);
      }({
        children: S,
        icon: v,
        iconAlignment: E,
        hideContent: !!l
      }));
    },
        E = function (e) {
      function AsyncButton(e) {
        var t;
        return _classCallCheck(this, AsyncButton), (t = _possibleConstructorReturn(this, _getPrototypeOf(AsyncButton).call(this, e))).delayLoad = function () {
          var e = t.props.delay || 1e3;
          setTimeout(function () {
            t.setState({
              loading: !1
            });
          }, e);
        }, t.handlePromise = function () {
          (0, t.props.promise)().then(t.delayLoad);
        }, t.handleClick = function () {
          t.setState({
            loading: !0
          }, t.handlePromise);
        }, t.state = {
          loading: !1
        }, t;
      }

      return _inherits(AsyncButton, r["Component"]), _createClass(AsyncButton, [{
        key: "render",
        value: function render() {
          var e = this.state.loading;
          return i.a.createElement(w, Object.assign({
            onClick: this.handleClick,
            loading: e
          }, this.props));
        }
      }]), AsyncButton;
    }(),
        C = w;

    function _toConsumableArray(e) {
      return function _arrayWithoutHoles(e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }
      }(e) || function _iterableToArray(e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    var k = n(9),
        S = function getAlignment(e) {
      return "right" === e ? {
        right: 0
      } : {};
    },
        _ = function (e) {
      function Dropdown() {
        var e, t;

        _classCallCheck(this, Dropdown);

        for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++) {
          r[a] = arguments[a];
        }

        return (t = _possibleConstructorReturn(this, (e = _getPrototypeOf(Dropdown)).call.apply(e, [this].concat(r)))).renderSimpleDropdown = function () {
          var e = t.props,
              n = e.align,
              r = e.actions,
              a = e.handleClickOutside,
              s = e.flowUp;
          return i.a.createElement(li, {
            className: o()("tide-action-dropdown-actions", {
              flowUp: s
            }),
            style: S(n)
          }, Object(k.map)(function Action(e) {
            var t,
                n = e.icon,
                r = e.label,
                s = e.action,
                l = void 0 === s ? function () {} : s,
                c = e.actionClass,
                d = e.disabled,
                h = void 0 !== d && d;
            return i.a.createElement(li, {
              key: "action-".concat(r),
              className: o()("tide-action-dropdown-action", (t = {}, _defineProperty(t, c, !!c), _defineProperty(t, "tide-action-dropdown-action--disabled", h), t)),
              onClick: function onClick() {
                return !h && l(a);
              }
            }, !!n && i.a.createElement(p, {
              name: n,
              width: 16
            }), i.a.createElement(oi, {
              className: "tide-action-dropdown--simple-label"
            }, r));
          }, r));
        }, t.renderRichDropdown = function (e) {
          var n = t.props,
              r = n.align,
              a = n.actions,
              s = n.handleClickOutside,
              l = n.flowUp;
          return i.a.createElement(li, {
            className: o()("tide-action-dropdown-actions", {
              flowUp: l
            }),
            style: S(r)
          }, t.renderBuckets(e, function Action(e) {
            var t,
                n = e.icon,
                r = e.label,
                a = e.description,
                l = e.action,
                c = void 0 === l ? function () {} : l,
                d = e.actionClass,
                h = e.disabled,
                u = void 0 !== h && h;
            return i.a.createElement(li, {
              key: "action-".concat(r),
              className: o()("tide-action-dropdown-action", (t = {}, _defineProperty(t, d, !!d), _defineProperty(t, "tide-action-dropdown-action--disabled", u), t)),
              onClick: function onClick() {
                return !u && c(s);
              }
            }, !!n && i.a.createElement(li, {
              className: "tide-action-dropdown-icon"
            }, i.a.createElement(p, {
              name: n,
              width: 16,
              height: 16
            })), i.a.createElement(li, {
              className: "tide-action-dropdown-entry"
            }, i.a.createElement(oi, {
              className: "tide-action-dropdown-entry-label"
            }, r), i.a.createElement(oi, {
              className: "tide-action-dropdown-entry-description"
            }, a)));
          }, a));
        }, t.renderBuckets = function (e, t, n) {
          return e.map(function (e) {
            return i.a.createElement(li, null, i.a.createElement(li, {
              className: "tide-action-dropdown-heading"
            }, e), Object(k.map)(t, n.filter(function (t) {
              return t.heading === e;
            })));
          });
        }, t;
      }

      return _inherits(Dropdown, r["Component"]), _createClass(Dropdown, [{
        key: "render",
        value: function render() {
          var e = this.props.actions,
              t = _toConsumableArray(new Set(e.map(function (e) {
            return e.heading;
          }).filter(Boolean)));

          return t.length >= 1 ? this.renderRichDropdown(t) : this.renderSimpleDropdown();
        }
      }]), Dropdown;
    }(),
        M = n(19);

    function isNodeFound(e, t, n) {
      return e === t || (e.correspondingElement ? e.correspondingElement.classList.contains(n) : e.classList.contains(n));
    }

    var L = function testPassiveEventSupport() {
      if ("undefined" !== typeof window && "function" === typeof window.addEventListener) {
        var e = !1,
            t = Object.defineProperty({}, "passive", {
          get: function get() {
            e = !0;
          }
        }),
            n = function noop() {};

        return window.addEventListener("testPassiveEventSupport", n, t), window.removeEventListener("testPassiveEventSupport", n, t), e;
      }
    };

    var F,
        D = function autoInc(e) {
      return void 0 === e && (e = 0), function () {
        return ++e;
      };
    }(),
        N = {},
        O = {},
        z = ["touchstart", "touchmove"],
        T = "ignore-react-onclickoutside";

    function getEventHandlerOptions(e, t) {
      var n = null;
      return -1 !== z.indexOf(t) && F && (n = {
        passive: !e.props.preventDefault
      }), n;
    }

    var I = function onClickOutsideHOC(e, t) {
      var n,
          i,
          a = e.displayName || e.name || "Component";
      return i = n = function (n) {
        function onClickOutside(e) {
          var t;
          return (t = n.call(this, e) || this).__outsideClickHandler = function (e) {
            if ("function" !== typeof t.__clickOutsideHandlerProp) {
              var n = t.getInstance();

              if ("function" !== typeof n.props.handleClickOutside) {
                if ("function" !== typeof n.handleClickOutside) throw new Error("WrappedComponent: " + a + " lacks a handleClickOutside(event) function for processing outside click events.");
                n.handleClickOutside(e);
              } else n.props.handleClickOutside(e);
            } else t.__clickOutsideHandlerProp(e);
          }, t.enableOnClickOutside = function () {
            if ("undefined" !== typeof document && !O[t._uid]) {
              "undefined" === typeof F && (F = L()), O[t._uid] = !0;
              var e = t.props.eventTypes;
              e.forEach || (e = [e]), N[t._uid] = function (e) {
                null !== t.componentNode && (t.props.preventDefault && e.preventDefault(), t.props.stopPropagation && e.stopPropagation(), t.props.excludeScrollbar && function clickedScrollbar(e) {
                  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
                }(e) || function findHighest(e, t, n) {
                  if (e === t) return !0;

                  for (; e.parentNode;) {
                    if (isNodeFound(e, t, n)) return !0;
                    e = e.parentNode;
                  }

                  return e;
                }(e.target, t.componentNode, t.props.outsideClickIgnoreClass) === document && t.__outsideClickHandler(e));
              }, e.forEach(function (e) {
                document.addEventListener(e, N[t._uid], getEventHandlerOptions(t, e));
              });
            }
          }, t.disableOnClickOutside = function () {
            delete O[t._uid];
            var e = N[t._uid];

            if (e && "undefined" !== typeof document) {
              var n = t.props.eventTypes;
              n.forEach || (n = [n]), n.forEach(function (n) {
                return document.removeEventListener(n, e, getEventHandlerOptions(t, n));
              }), delete N[t._uid];
            }
          }, t.getRef = function (e) {
            return t.instanceRef = e;
          }, t._uid = D(), t;
        }

        !function _inheritsLoose(e, t) {
          e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
        }(onClickOutside, n);
        var i = onClickOutside.prototype;
        return i.getInstance = function getInstance() {
          if (!e.prototype.isReactComponent) return this;
          var t = this.instanceRef;
          return t.getInstance ? t.getInstance() : t;
        }, i.componentDidMount = function componentDidMount() {
          if ("undefined" !== typeof document && document.createElement) {
            var e = this.getInstance();
            if (t && "function" === typeof t.handleClickOutside && (this.__clickOutsideHandlerProp = t.handleClickOutside(e), "function" !== typeof this.__clickOutsideHandlerProp)) throw new Error("WrappedComponent: " + a + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            this.componentNode = Object(M.findDOMNode)(this.getInstance()), this.props.disableOnClickOutside || this.enableOnClickOutside();
          }
        }, i.componentDidUpdate = function componentDidUpdate() {
          this.componentNode = Object(M.findDOMNode)(this.getInstance());
        }, i.componentWillUnmount = function componentWillUnmount() {
          this.disableOnClickOutside();
        }, i.render = function render() {
          var t = this.props,
              n = (t.excludeScrollbar, function _objectWithoutProperties(e, t) {
            if (null == e) return {};
            var n,
                r,
                i = {},
                a = Object.keys(e);

            for (r = 0; r < a.length; r++) {
              n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            }

            if (Object.getOwnPropertySymbols) {
              var o = Object.getOwnPropertySymbols(e);

              for (r = 0; r < o.length; r++) {
                n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
              }
            }

            return i;
          }(t, ["excludeScrollbar"]));
          return e.prototype.isReactComponent ? n.ref = this.getRef : n.wrappedRef = this.getRef, n.disableOnClickOutside = this.disableOnClickOutside, n.enableOnClickOutside = this.enableOnClickOutside, Object(r.createElement)(e, n);
        }, onClickOutside;
      }(r.Component), n.displayName = "OnClickOutside(" + a + ")", n.defaultProps = {
        eventTypes: ["mousedown", "touchstart"],
        excludeScrollbar: t && t.excludeScrollbar || !1,
        outsideClickIgnoreClass: T,
        preventDefault: !1,
        stopPropagation: !1
      }, n.getClass = function () {
        return e.getClass ? e.getClass() : e;
      }, i;
    },
        R = n(135),
        j = n.n(R),
        B = n(20),
        V = n.n(B),
        H = n(31),
        W = n.n(H),
        G = n(6),
        Z = n.n(G),
        q = n(8),
        U = n.n(q),
        K = n(81),
        X = n(136),
        Y = n.n(X)()({
      setReferenceNode: void 0,
      referenceNode: void 0
    }),
        $ = function (e) {
      function Manager() {
        var t;
        return t = e.call(this) || this, U()(Z()(Z()(t)), "setReferenceNode", function (e) {
          e && t.state.context.referenceNode !== e && t.setState(function (t) {
            var n = t.context;
            return {
              context: V()({}, n, {
                referenceNode: e
              })
            };
          });
        }), t.state = {
          context: {
            setReferenceNode: t.setReferenceNode,
            referenceNode: void 0
          }
        }, t;
      }

      return W()(Manager, e), Manager.prototype.render = function render() {
        return r.createElement(Y.Provider, {
          value: this.state.context
        }, this.props.children);
      }, Manager;
    }(r.Component),
        J = function unwrapArray(e) {
      return Array.isArray(e) ? e[0] : e;
    },
        Q = function safeInvoke(e) {
      if ("function" === typeof e) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
          n[r - 1] = arguments[r];
        }

        return e.apply(void 0, n);
      }
    },
        ee = {
      position: "absolute",
      top: 0,
      left: 0,
      opacity: 0,
      pointerEvents: "none"
    },
        te = {},
        ne = function (e) {
      function InnerPopper() {
        for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return t = e.call.apply(e, [this].concat(r)) || this, U()(Z()(Z()(t)), "state", {
          data: void 0,
          placement: void 0
        }), U()(Z()(Z()(t)), "popperInstance", void 0), U()(Z()(Z()(t)), "popperNode", null), U()(Z()(Z()(t)), "arrowNode", null), U()(Z()(Z()(t)), "setPopperNode", function (e) {
          e && t.popperNode !== e && (Q(t.props.innerRef, e), t.popperNode = e, t.updatePopperInstance());
        }), U()(Z()(Z()(t)), "setArrowNode", function (e) {
          t.arrowNode = e;
        }), U()(Z()(Z()(t)), "updateStateModifier", {
          enabled: !0,
          order: 900,
          fn: function fn(e) {
            var n = e.placement;
            return t.setState({
              data: e,
              placement: n
            }), e;
          }
        }), U()(Z()(Z()(t)), "getOptions", function () {
          return {
            placement: t.props.placement,
            eventsEnabled: t.props.eventsEnabled,
            positionFixed: t.props.positionFixed,
            modifiers: V()({}, t.props.modifiers, {
              arrow: V()({}, t.props.modifiers && t.props.modifiers.arrow, {
                enabled: !!t.arrowNode,
                element: t.arrowNode
              }),
              applyStyle: {
                enabled: !1
              },
              updateStateModifier: t.updateStateModifier
            })
          };
        }), U()(Z()(Z()(t)), "getPopperStyle", function () {
          return t.popperNode && t.state.data ? V()({
            position: t.state.data.offsets.popper.position
          }, t.state.data.styles) : ee;
        }), U()(Z()(Z()(t)), "getPopperPlacement", function () {
          return t.state.data ? t.state.placement : void 0;
        }), U()(Z()(Z()(t)), "getArrowStyle", function () {
          return t.arrowNode && t.state.data ? t.state.data.arrowStyles : te;
        }), U()(Z()(Z()(t)), "getOutOfBoundariesState", function () {
          return t.state.data ? t.state.data.hide : void 0;
        }), U()(Z()(Z()(t)), "destroyPopperInstance", function () {
          t.popperInstance && (t.popperInstance.destroy(), t.popperInstance = null);
        }), U()(Z()(Z()(t)), "updatePopperInstance", function () {
          t.destroyPopperInstance();
          var e = Z()(Z()(t)).popperNode,
              n = t.props.referenceElement;
          n && e && (t.popperInstance = new K.a(n, e, t.getOptions()));
        }), U()(Z()(Z()(t)), "scheduleUpdate", function () {
          t.popperInstance && t.popperInstance.scheduleUpdate();
        }), t;
      }

      W()(InnerPopper, e);
      var t = InnerPopper.prototype;
      return t.componentDidUpdate = function componentDidUpdate(e, t) {
        this.props.placement !== e.placement || this.props.referenceElement !== e.referenceElement || this.props.positionFixed !== e.positionFixed ? this.updatePopperInstance() : this.props.eventsEnabled !== e.eventsEnabled && this.popperInstance && (this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners()), t.placement !== this.state.placement && this.scheduleUpdate();
      }, t.componentWillUnmount = function componentWillUnmount() {
        Q(this.props.innerRef, null), this.destroyPopperInstance();
      }, t.render = function render() {
        return J(this.props.children)({
          ref: this.setPopperNode,
          style: this.getPopperStyle(),
          placement: this.getPopperPlacement(),
          outOfBoundaries: this.getOutOfBoundariesState(),
          scheduleUpdate: this.scheduleUpdate,
          arrowProps: {
            ref: this.setArrowNode,
            style: this.getArrowStyle()
          }
        });
      }, InnerPopper;
    }(r.Component);

    U()(ne, "defaultProps", {
      placement: "bottom",
      eventsEnabled: !0,
      referenceElement: void 0,
      positionFixed: !1
    });
    K.a.placements;

    function Popper(e) {
      var t = e.referenceElement,
          n = j()(e, ["referenceElement"]);
      return r.createElement(Y.Consumer, null, function (e) {
        var i = e.referenceNode;
        return r.createElement(ne, V()({
          referenceElement: void 0 !== t ? t : i
        }, n));
      });
    }

    var re = n(137),
        ie = n.n(re),
        ae = function (e) {
      function InnerReference() {
        for (var t, n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return t = e.call.apply(e, [this].concat(r)) || this, U()(Z()(Z()(t)), "refHandler", function (e) {
          Q(t.props.innerRef, e), Q(t.props.setReferenceNode, e);
        }), t;
      }

      return W()(InnerReference, e), InnerReference.prototype.render = function render() {
        return ie()(Boolean(this.props.setReferenceNode), "`Reference` should not be used outside of a `Manager` component."), J(this.props.children)({
          ref: this.refHandler
        });
      }, InnerReference;
    }(r.Component);

    function Reference(e) {
      return r.createElement(Y.Consumer, null, function (t) {
        var n = t.setReferenceNode;
        return r.createElement(ae, V()({
          setReferenceNode: n
        }, e));
      });
    }

    n(83);

    var oe = I(function (e) {
      function ActionDropdown(e) {
        var t;
        return _classCallCheck(this, ActionDropdown), (t = _possibleConstructorReturn(this, _getPrototypeOf(ActionDropdown).call(this, e))).handleClickOutside = function () {
          t.setState({
            isOpen: !1
          });
        }, t.toggleDropdown = function () {
          t.setState(function (e) {
            return {
              isOpen: !e.isOpen
            };
          });
        }, t.state = {
          isOpen: !1
        }, t;
      }

      return _inherits(ActionDropdown, r["Component"]), _createClass(ActionDropdown, [{
        key: "render",
        value: function render() {
          var e,
              t = this,
              n = this.props,
              r = n.actions,
              a = n.title,
              s = n.className,
              l = n.tetherPlacement,
              c = void 0 === l ? "bottom-start" : l,
              p = n.openTriggerClassName,
              d = n.align,
              h = n.buttonType,
              u = void 0 === h ? "tertiary" : h,
              f = n.buttonSize,
              m = void 0 === f ? "medium" : f,
              g = n.flowUp,
              v = void 0 !== g && g,
              b = n.trigger,
              y = void 0 === b ? null : b,
              x = this.state.isOpen;
          return i.a.createElement($, null, i.a.createElement(li, {
            className: o()("tide-action-dropdown", (e = {}, _defineProperty(e, s, !!s), _defineProperty(e, "tide-action-dropdown--with-icon", !a), e))
          }, y && i.a.createElement(Reference, null, function (e) {
            var n = e.ref;
            return i.a.createElement("div", {
              ref: n,
              className: o()(_defineProperty({}, p, !!p && x)),
              onClick: t.toggleDropdown
            }, y);
          }), !y && i.a.createElement(Reference, null, function (e) {
            var n = e.ref;
            return i.a.createElement("div", {
              ref: n
            }, i.a.createElement(C, {
              type: u,
              size: m,
              onClick: t.toggleDropdown,
              ref: n
            }, a, " \u2026"));
          }), !!x && i.a.createElement(Popper, {
            placement: c,
            positionFixed: !0,
            modifiers: {
              preventOverflow: {
                boundariesElement: "viewport"
              }
            }
          }, function (e) {
            var n = e.ref,
                a = e.style,
                o = e.placement;
            return i.a.createElement("div", {
              ref: n,
              style: a,
              "data-placement": o
            }, i.a.createElement(_, {
              align: d,
              actions: r,
              toggle: t.toggleDropdown,
              flowUp: v
            }));
          })));
        }
      }]), ActionDropdown;
    }()),
        se = I(_),
        le = function (e) {
      function ActionDropdown(e) {
        var t;
        return _classCallCheck(this, ActionDropdown), (t = _possibleConstructorReturn(this, _getPrototypeOf(ActionDropdown).call(this, e))).handleClickOutside = function () {
          t.setState({
            isOpen: !1
          });
        }, t.toggleDropdown = function () {
          t.setState(function (e) {
            return {
              isOpen: !e.isOpen
            };
          });
        }, t.state = {
          isOpen: !1
        }, t;
      }

      return _inherits(ActionDropdown, r["Component"]), _createClass(ActionDropdown, [{
        key: "render",
        value: function render() {
          var e,
              t = this.props,
              n = t.actions,
              r = t.title,
              a = t.className,
              s = t.tethered,
              l = void 0 !== s && s,
              c = t.openTriggerClassName,
              p = t.align,
              d = t.buttonType,
              h = void 0 === d ? "tertiary" : d,
              u = t.buttonSize,
              f = void 0 === u ? "medium" : u,
              m = t.flowUp,
              g = void 0 !== m && m,
              v = t.trigger,
              b = void 0 === v ? null : v,
              y = this.state.isOpen;
          return l ? i.a.createElement(oe, this.props) : i.a.createElement(li, {
            className: o()("tide-action-dropdown", (e = {}, _defineProperty(e, a, !!a), _defineProperty(e, "tide-action-dropdown--with-icon", !r), e))
          }, b && i.a.createElement(oi, {
            className: o()(_defineProperty({}, c, !!c && y)),
            onClick: this.toggleDropdown
          }, b), !b && i.a.createElement(C, {
            type: h,
            size: f,
            onClick: this.toggleDropdown
          }, r, " \u2026"), !!y && i.a.createElement(se, {
            align: p,
            actions: n,
            handleClickOutside: this.toggleDropdown,
            flowUp: g
          }));
        }
      }]), ActionDropdown;
    }(),
        ce = (n(160), Object.freeze({
      small: "small",
      medium: "medium",
      large: "large"
    })),
        pe = Object.freeze({
      available: "tide-agent-status-toggle-available",
      away: "tide-agent-status-toggle-away",
      "chat-limit": "tide-agent-status-toggle-chat-limit"
    }),
        de = Object.freeze({
      available: !0,
      away: !1,
      "chat-limit": !0
    }),
        he = function AgentStatusToggle(e) {
      var t = e.onChange,
          n = e.className,
          r = void 0 === n ? "" : n,
          a = e.size,
          o = void 0 === a ? "" : a,
          s = e.agentStatus,
          l = void 0 === s ? "available" : s;
      return i.a.createElement(li, {
        className: "tide-agent-status-toggle ".concat(r, " ").concat(pe[l])
      }, i.a.createElement(li, {
        className: "tide-agent-status-toggle-outer ".concat(ce[o] || "medium")
      }, i.a.createElement("input", {
        type: "checkbox",
        checked: de[l],
        onChange: t,
        className: "tide-agent-status-toggle-checkbox"
      }), i.a.createElement("b", {
        className: "tide-agent-status-toggle--switch"
      }), i.a.createElement("b", {
        className: "tide-agent-status-toggle--track"
      })));
    },
        ue = (n(162), [{
      background: "var(--color-s5-8)",
      fontColor: "var(--color-s5-6)"
    }, {
      background: "var(--color-p3-8)",
      fontColor: "var(--color-p3-5)"
    }, {
      background: "var(--color-s3-9)",
      fontColor: "var(--color-s3-5)"
    }, {
      background: "var(--color-s4-7)",
      fontColor: "var(--color-s4-4)"
    }, {
      background: "var(--color-s2-8)",
      fontColor: "var(--color-s2-5)"
    }, {
      background: "var(--color-s1-9)",
      fontColor: "var(--color-s1-7)"
    }]),
        fe = {
      withBorder: {
        available: "available-white",
        away: "away-grey",
        chat_limit: "chat-limit-white"
      },
      withoutBorder: {
        available: "available-blue",
        away: "away-white",
        chat_limit: "chat-limit-yellow"
      }
    },
        me = function getBackgroundAndFontColor(e) {
      var t = e ? function BKDRHash(e) {
        var t = 0;
        e += "x";

        for (var n = parseInt(65745979961613.07, 10), r = 0; r < e.length; r++) {
          t > n && (t = parseInt(t / 137, 10)), t = t + 131 + e.charCodeAt(r);
        }

        return t;
      }(e) : Math.floor(Math.random() * ue.length);
      return {
        background: ue[t % ue.length].background,
        fontColor: ue[t % ue.length].fontColor
      };
    },
        ge = function generateDefaultInitials(e) {
      var t = e.value;
      return t ? t.split(" ").map(function (e) {
        return e[0];
      }).slice(0, 2).join("") : null;
    },
        ve = function PlaceholderAvatar() {
      return i.a.createElement(li, {
        className: "avatar-initials avatar-placeholder"
      });
    },
        be = function InitialsAvatar(e) {
      var t = e.initials,
          n = e.background,
          r = e.fontColor;
      return i.a.createElement(li, {
        className: "avatar-initials",
        style: {
          background: n,
          color: r
        }
      }, t ? i.a.createElement("span", {
        className: "avatar-initials-text"
      }, t) : i.a.createElement(p, {
        className: "avatar-initials-icon",
        name: "user"
      }));
    },
        ye = function (e) {
      function AvatarWithInitialsFallback(e) {
        var t;
        return _classCallCheck(this, AvatarWithInitialsFallback), (t = _possibleConstructorReturn(this, _getPrototypeOf(AvatarWithInitialsFallback).call(this, e))).setImageCallbacks = function (e) {
          var n = new Image();
          n.onload = function () {
            t.setState({
              imageLoaded: !0
            });
          }, n.onerror = function () {
            t.setState({
              imageError: !0
            });
          }, n.src = e;
        }, t.state = {
          imageLoaded: !1,
          imageError: !1
        }, t;
      }

      return _inherits(AvatarWithInitialsFallback, r["PureComponent"]), _createClass(AvatarWithInitialsFallback, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var e = this.props.avatarUrl;
          e && this.setImageCallbacks(e);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          e.avatarUrl !== this.props.avatarUrl && this.setImageCallbacks(this.props.avatarUrl);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.avatarUrl,
              n = e.initials,
              r = e.background,
              a = e.fontColor,
              o = this.state,
              s = o.imageLoaded,
              l = o.imageError;
          return !t || l ? i.a.createElement(be, {
            initials: n,
            background: r,
            fontColor: a
          }) : s ? i.a.createElement(li, {
            className: "avatar-image",
            style: {
              backgroundImage: "url('".concat(t, "')")
            }
          }) : i.a.createElement(ve, null);
        }
      }]), AvatarWithInitialsFallback;
    }(),
        xe = function TeamAvatar(e) {
      var t = e.className,
          n = e.size,
          r = e.team;
      return i.a.createElement(li, {
        className: o()("user-avatar", n, t)
      }, i.a.createElement(be, Object.assign({
        initials: ge({
          value: r.name
        })
      }, me(r.name))));
    },
        we = function CompanyAvatar(e) {
      var t = e.className,
          n = e.size,
          r = e.company,
          a = function getCompanyAvatarURL(e) {
        e.name;
        return e.logo || null;
      }(r);

      return i.a.createElement(li, {
        className: o()("user-avatar", n, t)
      }, i.a.createElement(ye, Object.assign({
        avatarUrl: a,
        initials: ge({
          value: r.name
        })
      }, me(r.name))));
    },
        Ee = function UserAvatar(e) {
      var t,
          n,
          r = e.className,
          a = e.size,
          s = e.user,
          l = e.forcePlaceholder,
          c = function getUserAvatarURL(e) {
        var t = e.attributes,
            n = e.socialProfile,
            r = e.avatars,
            i = e.avatarUrl,
            a = t ? t.avatar_url : null,
            o = n ? n.avatar : null;
        return (r ? r.image200 : null) || i || a || o || null;
      }(s);

      t = s.name || s.alias || s.email, !["END_USER", "LEAD"].includes(s.type) || c || t ? n = t ? me(String(s.id)) : me() : (t = "Site Visitor", n = me(String(s.id)));
      var p = l ? i.a.createElement(ve, null) : i.a.createElement(ye, Object.assign({
        avatarUrl: c,
        initials: ge({
          value: t
        })
      }, n));
      return i.a.createElement(li, {
        className: o()("user-avatar", a, r)
      }, p);
    },
        Ce = function PresenceDot(e) {
      var t = e.presenceState,
          n = e.withBorder,
          r = e.isDot;
      return i.a.createElement(li, {
        className: o()("presence-dot-outer", {
          withBorder: n
        })
      }, r ? i.a.createElement(li, {
        className: o()("presence-dot-inner", "away" === t || "chat_limit" === t ? "grey" : "green")
      }) : i.a.createElement(p, {
        name: fe[n ? "withBorder" : "withoutBorder"][t],
        className: o()("presence-dot-inner")
      }));
    },
        ke = function AvatarBase(e) {
      var t = e.user,
          n = void 0 === t ? {} : t,
          r = e.company,
          a = void 0 === r ? {} : r,
          o = e.team,
          s = void 0 === o ? {} : o,
          l = e.type,
          c = void 0 === l ? "user" : l,
          p = e.className,
          d = void 0 === p ? "" : p,
          h = e.size,
          u = void 0 === h ? "icon" : h,
          f = e.forcePlaceholder,
          m = void 0 !== f && f;

      switch (c) {
        case "user":
          return i.a.createElement(Ee, {
            className: d,
            user: n,
            size: u,
            forcePlaceholder: m
          });

        case "company":
          return i.a.createElement(we, {
            className: d,
            company: a,
            size: u
          });

        case "team":
          return i.a.createElement(xe, {
            className: d,
            team: s,
            size: u
          });

        default:
          return null;
      }
    },
        Se = function Avatar(e) {
      var t = e.user,
          n = void 0 === t ? {} : t,
          r = e.company,
          a = void 0 === r ? {} : r,
          s = e.team,
          l = void 0 === s ? {} : s,
          c = e.type,
          p = void 0 === c ? "user" : c,
          d = e.className,
          h = void 0 === d ? "" : d,
          u = e.size,
          f = void 0 === u ? "icon" : u,
          m = e.forcePlaceholder,
          g = void 0 !== m && m,
          v = e.withPresence,
          b = void 0 !== v && v,
          y = e.isDot,
          x = void 0 !== y && y,
          w = e.presenceState,
          E = void 0 === w ? "away" : w,
          C = e.withBorder,
          k = void 0 !== C && C;
      return b ? i.a.createElement(li, {
        className: o()("user-avatar-container", k && E, f, {
          withBorder: k
        })
      }, i.a.createElement(ke, {
        user: n,
        company: a,
        team: l,
        type: p,
        className: h,
        size: f,
        forcePlaceholder: g
      }), i.a.createElement(Ce, {
        presenceState: E,
        withBorder: k,
        isDot: x
      })) : i.a.createElement(ke, {
        user: n,
        company: a,
        team: l,
        type: p,
        className: h,
        size: f,
        forcePlaceholder: g
      });
    },
        _e = n(138),
        Me = n.n(_e),
        Le = function (e) {
      function BodyMovin() {
        return _classCallCheck(this, BodyMovin), _possibleConstructorReturn(this, _getPrototypeOf(BodyMovin).apply(this, arguments));
      }

      return _inherits(BodyMovin, i.a.Component), _createClass(BodyMovin, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.options = {
            container: this.lavContainer,
            renderer: this.props.options.renderer,
            loop: !1 !== this.props.options.loop,
            autoplay: !1 !== this.props.options.autoplay,
            animationData: this.props.options.animationData,
            rendererSettings: this.props.options.rendererSettings
          }, this.anim = Me.a.loadAnimation(this.options);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          this.props.isStopped ? this.stop() : this.play(), this.pause(), this.setSpeed(), this.setDirection();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.anim.destroy();
        }
      }, {
        key: "pause",
        value: function pause() {
          this.props.isPaused && !this.anim.isPaused ? this.anim.pause() : !this.props.isPaused && this.anim.isPaused && this.anim.pause();
        }
      }, {
        key: "stop",
        value: function stop() {
          this.anim.stop();
        }
      }, {
        key: "play",
        value: function play() {
          this.anim.play();
        }
      }, {
        key: "setSpeed",
        value: function setSpeed() {
          this.anim.setSpeed(this.props.speed);
        }
      }, {
        key: "setDirection",
        value: function setDirection() {
          this.anim.setDirection(this.props.direction);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props,
              n = {
            height: t.height || "100%",
            margin: "0 auto",
            overflow: "hidden",
            width: t.width || "100%"
          };
          return i.a.createElement("div", {
            ref: function ref(t) {
              e.lavContainer = t;
            },
            style: n
          });
        }
      }]), BodyMovin;
    }();

    Le.defaultProps = {
      isStopped: !1,
      isPaused: !1,
      speed: 1
    };

    var Pe = Le,
        Fe = (n(164), function Breadcrumbs(e) {
      var t = e.className,
          n = e.headings,
          r = e.onHeadingClick,
          a = e.arrowSize,
          s = void 0 === a ? 8 : a;
      return n ? n.reduce(function (e, t) {
        return t.title && t.link && e;
      }) ? i.a.createElement(li, {
        className: o()("tide-breadcrumbs-main", t)
      }, n.map(function (e, t) {
        return i.a.createElement(li, {
          className: "tide-breadcrumbs-page",
          key: t * e.title.length * e.link.length
        }, i.a.createElement(Qr, {
          className: o()("tide-breadcrumbs-link", {
            active: e.isActive
          }),
          href: e.link,
          onClick: r ? function (t) {
            return r(e, t);
          } : function () {}
        }, e.title), i.a.createElement(p, {
          className: "tide-breadcrumbs-icon",
          width: s,
          height: s,
          name: "arrow-1-right"
        }));
      })) : i.a.createElement(li, null, console.log("Breadcrumbs: your heading props have missing titles or links")) : i.a.createElement(li, null, console.log("Breadcrumbs: headings prop is missing, make sure you pass it to the component"));
    }),
        Ae = (n(166), Object.freeze({
      small: "small",
      medium: "medium",
      large: "large"
    })),
        De = Object.freeze({
      default: "default",
      subtle: "subtle"
    }),
        Ne = function getClassNames(e) {
      var t = e.size,
          n = e.className,
          r = e.inline,
          i = e.inlineStyle;
      return o()("tide-icon-button", Ae[t], r ? "inline inline-".concat(De[i]) : "", n);
    },
        Oe = function IconButton(e) {
      var t = e.className,
          n = e.size,
          r = void 0 === n ? "medium" : n,
          a = e.disabled,
          o = void 0 !== a && a,
          s = e.inline,
          l = void 0 !== s && s,
          c = e.inlineStyle,
          d = void 0 === c ? "default" : c,
          h = e.onClick,
          u = e.icon,
          f = e.buttonProps;
      return u ? i.a.createElement("button", Object.assign({}, f, {
        className: Ne({
          size: r,
          className: t,
          inline: l,
          inlineStyle: d
        }),
        disabled: o,
        onClick: h
      }), i.a.createElement(oi, null, i.a.createElement(p, {
        name: u
      }))) : null;
    },
        ze = (n(168), function getClassNames(e, t) {
      return "tide-card ".concat(function selectedClass(e) {
        return e ? "selected" : "unselected";
      }(e), " ").concat(t);
    }),
        Te = function (e) {
      function Card() {
        return _classCallCheck(this, Card), _possibleConstructorReturn(this, _getPrototypeOf(Card).apply(this, arguments));
      }

      return _inherits(Card, r["Component"]), _createClass(Card, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.selected,
              n = e.header,
              r = e.imgSrc,
              a = e.description,
              s = e.className,
              l = void 0 === s ? "" : s,
              c = e.href,
              p = e.target,
              d = e.onClick,
              h = e.disabled,
              u = e.upgrade,
              f = e.upgradeText,
              m = e.align,
              g = void 0 === m ? "center" : m,
              v = e.boxShadow,
              b = c && !h ? Qr : li,
              y = r;
          return i.a.createElement(b, {
            className: o()(ze(t, l), {
              "tide-card--disabled": h
            }, {
              "tide-card--left": "left" === g
            }),
            style: {
              boxShadow: h ? "none" : "var(".concat(v, ")")
            },
            href: c,
            target: p,
            onClick: h ? function () {} : d
          }, u && i.a.createElement(li, {
            className: "tide-card--upgrade-callout"
          }, i.a.createElement(bn, {
            isUpgrade: !0,
            text: f
          })), y && "function" === typeof y ? i.a.createElement(y, null) : y ? i.a.createElement("img", {
            className: "tide-card--image",
            src: r,
            alt: "card-icon"
          }) : null, i.a.createElement(ni, {
            className: "tide-card--header"
          }, n), a && i.a.createElement(si, {
            className: "tide-card--description"
          }, a));
        }
      }]), Card;
    }();

    Te.defaultProps = {
      boxShadow: "--box-shadow-1"
    };
    var Ie = Te;

    function objectWithoutProperties_objectWithoutProperties(e, t) {
      if (null == e) return {};

      var n,
          r,
          i = function _objectWithoutPropertiesLoose(e, t) {
        if (null == e) return {};
        var n,
            r,
            i = {},
            a = Object.keys(e);

        for (r = 0; r < a.length; r++) {
          n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        }

        return i;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (r = 0; r < a.length; r++) {
          n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
      }

      return i;
    }

    n(170);

    var Re = function getClassNames(e, t) {
      return "tide-card-container ".concat(function getInsetPaddingClass(e) {
        return "tide-card-container-padding-".concat(e);
      }(e), " ").concat(t);
    },
        je = function CardContainer(e) {
      var t = e.padding,
          n = void 0 === t ? "medium" : t,
          r = e.className,
          a = e.children,
          s = e.header,
          l = e.boxShadow,
          c = void 0 === l ? "--box-shadow-1" : l,
          p = objectWithoutProperties_objectWithoutProperties(e, ["padding", "className", "children", "header", "boxShadow"]);
      return i.a.createElement(li, Object.assign({
        className: o()(Re(n, r)),
        style: {
          boxShadow: "var(".concat(c, ")")
        }
      }, p), function renderHeader() {
        switch (typeof s) {
          case "function":
            return s();

          case "string":
            return i.a.createElement(ri, {
              className: "tide-card-container--header"
            }, s);

          default:
            return null;
        }
      }(), a);
    },
        Be = function Be(e) {
      var t = e.width,
          n = void 0 === t ? 35 : t,
          r = e.height,
          a = void 0 === r ? 38 : r,
          o = e.className,
          s = e.scale;
      return i.a.createElement("svg", {
        width: "".concat(n, "px"),
        className: o,
        height: "".concat(a, "px"),
        viewBox: "0 0 ".concat(n, " ").concat(a)
      }, i.a.createElement("defs", null, i.a.createElement("linearGradient", {
        id: "a",
        x1: "47.971%",
        x2: "40.33%",
        y1: "100%",
        y2: "-82.78%"
      }, i.a.createElement("stop", {
        offset: "0%",
        stopColor: "#ED1886"
      }), i.a.createElement("stop", {
        offset: "100%",
        stopColor: "#8711FF"
      }))), i.a.createElement("path", {
        fill: "url(#a)",
        fillRule: "nonzero",
        d: "M11.993 41.814c-.068-.315-.13-.63-.183-.944-.36-2.12-.314-3.89.322-5.2a1 1 0 1 1 1.8.872c-.41.844-.447 2.249-.15 3.993.164.965.417 1.968.722 2.944a25.027 25.027 0 0 0 .434 1.271 1 1 0 0 1-1.112 1.347l-.336-.06a103.281 103.281 0 0 0-4.417-.677c-1.937-.244-3.387-.315-3.686-.205a1 1 0 1 1-.69-1.878c.747-.274 2.254-.2 4.625.099a68.992 68.992 0 0 1 1.56.213C4.454 36.191 1.156 28.82.508 21.613c-.527-5.848.708-11.19 3.089-15.876a28.005 28.005 0 0 1 2.21-3.654A16.03 16.03 0 0 1 6.845.759a1 1 0 1 1 1.481 1.344 7.86 7.86 0 0 0-.232.274c-.199.245-.423.536-.665.873a26.014 26.014 0 0 0-2.05 3.392c-2.22 4.372-3.37 9.346-2.88 14.792.596 6.626 3.597 13.45 9.493 20.38z",
        transform: "".concat(s, " rotate(46 65.16 13.672)")
      }));
    },
        Ve = (n(172), Object.freeze({
      small: {
        width: 32,
        height: 47
      },
      medium: {
        width: 48,
        height: 70
      },
      large: {
        width: 72,
        height: 105
      }
    })),
        He = Object.freeze({
      small: "scale(0.5 -0.5)",
      medium: "scale(1.1 -1)",
      large: "scale(2 -2)"
    }),
        We = function CalloutArrow(e) {
      var t = e.text,
          n = e.linkUrl,
          r = e.linkText,
          a = e.linkProps,
          s = void 0 === a ? {} : a,
          l = e.size,
          c = void 0 === l ? "medium" : l,
          p = e.position,
          d = void 0 === p ? "left" : p,
          h = e.orientation,
          u = void 0 === h ? "vertical" : h,
          f = e.rotate,
          m = void 0 === f ? 0 : f;
      return i.a.createElement(li, {
        className: "tide-callout-arrow--container"
      }, i.a.createElement(li, {
        className: o()("tide-callout-arrow--image", {
          "tide-callout-arrow--image--small": "small" === c,
          "tide-callout-arrow--image--medium": "medium" === c,
          "tide-callout-arrow--image--large": "large" === c,
          "tide-callout-arrow--image--left": "left" === d,
          "tide-callout-arrow--image--right": "right" === d,
          "tide-callout-arrow--image--top": "top" === d,
          "tide-callout-arrow--image--bottom": "bottom" === d,
          "tide-callout-arrow--image--horizontal": "horizontal" === u,
          "tide-callout-arrow--image--vertical": "vertical" === u,
          "tide-callout-arrow--image--90": 90 === m,
          "tide-callout-arrow--image--neg90": -90 === m,
          "tide-callout-arrow--image--180": 180 === m,
          "tide-callout-arrow--image--neg180": -180 === m,
          "tide-callout-arrow--image--270": 270 === m,
          "tide-callout-arrow--image--neg270": -270 === m,
          "tide-callout-arrow--image--360": 360 === m,
          "tide-callout-arrow--image--neg360": -360 === m
        })
      }, i.a.createElement(Be, {
        width: Ve[c].width,
        height: Ve[c].height,
        scale: He[c]
      })), i.a.createElement(li, {
        className: "tide-callout-arrow--text"
      }, t, !!n && i.a.createElement(Qr, Object.assign({
        href: n
      }, s), r)));
    },
        Ge = n(82),
        Ze = n.n(Ge),
        qe = (n(174), n(175), function CodeBlock(e) {
      var t = e.children,
          n = e.language,
          r = void 0 === n ? "jsx" : n,
          a = Ze.a.highlight(t, Ze.a.languages[r]);
      return i.a.createElement(li, {
        className: "code-block--monokai"
      }, i.a.createElement("pre", null, i.a.createElement("code", {
        dangerouslySetInnerHTML: {
          __html: a
        }
      })));
    }),
        Ue = (n(177), function FingerGunToolTip(e) {
      var t = e.size,
          n = void 0 === t ? "medium" : t,
          r = e.className,
          a = e.value,
          s = objectWithoutProperties_objectWithoutProperties(e, ["size", "className", "value"]);
      return i.a.createElement(li, Object.assign({
        className: o()("tide-fingerguntooltip", n, r)
      }, s), i.a.createElement(oi, {
        className: "tide-fingerguntooltip-emoji"
      }, "\uD83D\uDC49"), a);
    });

    function _objectSpread(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
            r = Object.keys(n);
        "function" === typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), r.forEach(function (t) {
          _defineProperty(e, t, n[t]);
        });
      }

      return e;
    }

    n(179);

    var Ke = function (e) {
      function Checkbox(e) {
        var t;
        return _classCallCheck(this, Checkbox), (t = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, e))).componentWillReceiveProps = function (e) {
          t.setState({
            checked: !!e.checked
          });
        }, t.toggleCheckbox = function () {
          var e = t.props,
              n = e.locked,
              r = e.onChange;

          if (!(n | e.disabled)) {
            var i = !t.state.checked;
            t.setState({
              checked: i
            }, function onStateSet() {
              return r && r(i);
            });
          }
        }, t.resolveClassNames = function () {
          var e = t.state.checked,
              n = t.props.disabled;
          return o()({
            "tide-checkbox-input": !0,
            "tide-checkbox-input--checked": e,
            "tide-checkbox-input--disabled": n
          });
        }, t.state = {
          checked: !!e.checked
        }, t;
      }

      return _inherits(Checkbox, r["Component"]), _createClass(Checkbox, [{
        key: "render",
        value: function render() {
          var e = this.resolveClassNames(),
              t = this.props,
              n = t.label,
              r = t.className;
          return i.a.createElement(li, {
            className: o()("tide-checkbox", r),
            onClick: this.toggleCheckbox
          }, i.a.createElement(li, {
            className: e
          }), n && i.a.createElement(si, {
            className: "tide-checkbox--label"
          }, n));
        }
      }]), Checkbox;
    }();

    Ke.defaultProps = {
      locked: !1,
      disabled: !1
    };

    var Xe = Ke,
        Ye = {
      small: "small",
      medium: "medium",
      large: "large"
    },
        $e = {
      search: "magnifier-1"
    },
        Je = function getClassNames(e, t) {
      return "tide-input ".concat(Ye[e], " ").concat(function loadingClass(e) {
        return e ? "inline-loading" : "";
      }(t));
    },
        Qe = function typeToIcon(e) {
      return $e[e] || null;
    },
        et = function PlainInput(e) {
      var t = e.type,
          n = void 0 === t ? "text" : t,
          r = e.size,
          a = void 0 === r ? "medium" : r,
          s = e.loading,
          l = void 0 !== s && s,
          c = e.className,
          p = void 0 === c ? "" : c,
          d = (e.description, e.prefixText),
          h = void 0 === d ? "" : d,
          u = e.postfixText,
          f = void 0 === u ? "" : u,
          m = e.validate,
          g = void 0 === m ? function () {
        return !1;
      } : m,
          v = e.value,
          b = void 0 === v ? void 0 : v,
          y = e.inline,
          x = void 0 !== y && y,
          w = objectWithoutProperties_objectWithoutProperties(e, ["type", "size", "loading", "className", "description", "prefixText", "postfixText", "validate", "value", "inline"]),
          E = Object(k.omit)(["iconName", "labelType"], _objectSpread({}, w));
      if ("checkbox" === n) return i.a.createElement(Xe, Object.assign({
        className: p
      }, E));

      var C = !!b && g(b),
          S = i.a.createElement(li, null, i.a.createElement("input", Object.assign({
        className: o()(Je(a, l), {
          "tide-input--invalid": C
        }, {
          "tide-input--inline": x
        }),
        type: n,
        value: b
      }, E)), C ? i.a.createElement("span", {
        className: "tide-input--error"
      }, g(b)) : null),
          _ = !!h || !!f,
          M = i.a.createElement(li, {
        className: o()("tide-input-wrapper ".concat(Ye[a]), {
          "prefix-text-wrapper": !!h
        }, {
          "postfix-text-wrapper": !!f
        })
      }, !!h && i.a.createElement(li, {
        className: "input-prefix"
      }, h), S, !!f && i.a.createElement(li, {
        className: "input-postfix"
      }, f));

      return _ ? M : S;
    },
        tt = function IconInput(e) {
      var t = Object(k.omit)(["className"], _objectSpread({}, e));
      return i.a.createElement(oi, {
        className: "".concat(e.size || "medium", " icon-input ").concat(e.className || "")
      }, i.a.createElement(p, {
        name: e.iconName,
        width: 14
      }), i.a.createElement(et, t));
    },
        nt = function buildInput(e) {
      var t = e.icon ? e.icon : Qe(e.type);
      return t ? i.a.createElement(tt, Object.assign({}, e, {
        iconName: t
      })) : i.a.createElement(et, e);
    },
        rt = function buildWithoutLabel(e) {
      return !e.icon && e.description || "inline" === e.type ? i.a.createElement(oi, {
        className: "".concat(e.size || "medium", " ").concat(e.className || "", " tide-input--no-label")
      }, nt(e), i.a.createElement(si, {
        className: "tide-input--description",
        type: "subtle"
      }, e.description)) : function buildRawInput(e) {
        var t = e.icon ? e.icon : Qe(e.type);
        return t ? i.a.createElement(tt, Object.assign({}, e, {
          iconName: t
        })) : i.a.createElement(oi, {
          className: "raw-input ".concat(e.className || "")
        }, i.a.createElement(et, e));
      }(e);
    },
        it = function Input(e) {
      return e.label && "checkbox" !== e.type ? function buildWithLabel(e) {
        var t = nt(e);
        return i.a.createElement(bi, {
          className: e.className || ""
        }, e.label, t, i.a.createElement(si, {
          className: "tide-input--description",
          type: "subtle"
        }, e.description));
      }(e) : rt(e);
    },
        at = function Form(e) {
      var t = e.onSubmit,
          n = void 0 === t ? function () {} : t,
          r = e.className,
          a = void 0 === r ? "" : r,
          o = e.children;
      return i.a.createElement("form", {
        className: "tide-form ".concat(a),
        onSubmit: function onSubmit(e) {
          return function submitForm(e, t) {
            e.preventDefault(), t(e);
          }(e, n);
        }
      }, o);
    };

    n(181);

    function ControlledInput(e) {
      var t = e.className,
          n = void 0 === t ? "" : t,
          r = e.inputSize,
          a = void 0 === r ? "small" : r,
          s = e.inputValue,
          l = e.isFocused,
          c = e.onBlur,
          d = e.onCancel,
          h = e.onChange,
          u = e.onFocus,
          f = e.onKeyDown,
          m = e.onSave,
          g = e.shouldValidate,
          v = void 0 !== g && g,
          b = e.toolTipPlacement,
          y = void 0 === b ? "up" : b,
          x = !!v && !s;
      return i.a.createElement(li, {
        className: o()("tide-controlled-inline-input--editing-wrapper", _defineProperty({}, n, !!n))
      }, i.a.createElement(li, {
        className: o()("tide-controlled-inline-input--input-field", {
          active: l
        })
      }, i.a.createElement("input", {
        autoFocus: !0,
        className: o()("tide-input", _defineProperty({}, a, !!a)),
        onBlur: c,
        onChange: h,
        onFocus: u,
        onKeyDown: f,
        placeholder: "Enter text",
        type: "text",
        value: s
      }), i.a.createElement(li, {
        className: "tide-controlled-inline-input--controlled-actions"
      }, i.a.createElement(Mr, {
        flow: y,
        component: "Enter value",
        hover: x
      }, i.a.createElement(oi, {
        className: o()("controlled-action controlled-action--save", _defineProperty({
          disable: x
        }, a, a)),
        onClick: m
      }, i.a.createElement(p, {
        name: "check"
      }))), i.a.createElement(oi, {
        className: o()("controlled-action controlled-action--cancel", _defineProperty({}, a, !!a)),
        onClick: d
      }, i.a.createElement(p, {
        name: "close"
      })))));
    }

    n(183);

    var ot = function InlineLinkInput(e) {
      var t = e.inputSize,
          n = void 0 === t ? "small" : t,
          r = e.inputValue,
          a = e.isActiveLink,
          s = e.isEditing,
          l = e.isFocused,
          c = e.leadingText,
          d = void 0 === c ? "" : c,
          h = e.onClick;
      return s ? function renderControlledInput() {
        return i.a.createElement(li, {
          className: o()("tide-controlled-inline-input--link", {
            active: l
          })
        }, i.a.createElement(li, {
          className: o()("tide-controlled-inline-input--link__leading-text", _defineProperty({}, n, !!n))
        }, d), i.a.createElement(ControlledInput, Object.assign({
          className: "tide-controlled-inline-input--editing-link"
        }, e)));
      }() : function renderInlineDisplay() {
        var e = a ? h : null,
            t = a ? null : h;
        return i.a.createElement(li, {
          className: "tide-controlled-inline-input"
        }, i.a.createElement(oi, {
          className: "tide-controlled-inline-input--row",
          onClick: t
        }, function buildAnchorTag() {
          var e = "".concat(d).concat(r),
              t = a ? null : function (e) {
            e.preventDefault();
          };
          return i.a.createElement(Qr, {
            href: e,
            onClick: t,
            rel: "noopener noreferrer",
            target: "_blank"
          }, e);
        }(), i.a.createElement(oi, {
          className: "tide-controlled-inline-input--icon-wrapper",
          onClick: e
        }, i.a.createElement(p, {
          width: 12,
          name: "edit-1"
        }))));
      }();
    },
        st = (n(185), Object.freeze({
      h1: function h1(e) {
        var t = e.children;
        return i.a.createElement(ei, null, t);
      },
      h2: function h2(e) {
        var t = e.children;
        return i.a.createElement(ti, null, t);
      },
      h3: function h3(e) {
        var t = e.children;
        return i.a.createElement(ni, null, t);
      },
      h4: function h4(e) {
        var t = e.children;
        return i.a.createElement(ri, null, t);
      },
      h5: function h5(e) {
        var t = e.children;
        return i.a.createElement(ii, null, t);
      },
      h6: function h6(e) {
        var t = e.children;
        return i.a.createElement(ai, null, t);
      }
    })),
        lt = Object.freeze({
      h1: 16,
      h2: 16,
      h3: 13,
      h4: 13,
      h5: 11,
      h6: 11
    }),
        ct = Object.freeze({
      h1: "large",
      h2: "large",
      h3: "medium",
      h4: "medium",
      h5: "small",
      h6: "small"
    });

    n(187);

    var pt = {
      link: ot,
      heading: function InlineHeadingInput(e) {
        var t = e.onClick,
            n = e.headingSize,
            r = void 0 === n ? "h2" : n,
            a = e.inputValue;
        return e.isEditing ? function renderControlledInput() {
          var t = ct[r];
          return i.a.createElement(ControlledInput, Object.assign({
            className: "tide-controlled-inline-input--editing-heading editing-heading--".concat(r),
            inputSize: t
          }, e));
        }() : function renderInlineDisplay() {
          var e = st[r] || null,
              n = lt[r] || 12;
          return i.a.createElement(li, {
            className: "tide-controlled-inline-input"
          }, i.a.createElement(oi, {
            className: "tide-controlled-inline-input--row",
            onClick: t
          }, i.a.createElement(e, null, a), i.a.createElement(oi, {
            className: "tide-controlled-inline-input--icon-wrapper"
          }, i.a.createElement(p, {
            height: n,
            width: n,
            name: "edit-1"
          }))));
        }();
      },
      text: function DefaultInlineInput(e) {
        var t = e.onClick,
            n = e.inputValue;
        return e.isEditing ? i.a.createElement(ControlledInput, e) : function renderInlineDisplay() {
          return i.a.createElement(li, {
            className: "tide-controlled-inline-input"
          }, i.a.createElement(oi, {
            className: "tide-controlled-inline-input--row",
            onClick: t
          }, n, i.a.createElement(oi, {
            className: "tide-controlled-inline-input--icon-wrapper"
          }, i.a.createElement(p, {
            width: 12,
            name: "edit-1"
          }))));
        }();
      }
    },
        dt = 27,
        ht = 13,
        ut = 32,
        ft = function (e) {
      function InlineInputWithSave(e) {
        var t;
        return _classCallCheck(this, InlineInputWithSave), (t = _possibleConstructorReturn(this, _getPrototypeOf(InlineInputWithSave).call(this, e))).handleOnBlur = function () {
          t.setState(function () {
            return {
              isFocused: !1
            };
          });
        }, t.handleOnFocus = function () {
          t.state.isFocused || t.setState(function () {
            return {
              isFocused: !0
            };
          });
        }, t.handleOnClick = function () {
          t.setState(function (e) {
            return {
              isEditing: !e.isEditing
            };
          });
        }, t.handleOnChange = function (e) {
          var n = e.target.value || "";
          t.setState(function () {
            return {
              inputValue: n
            };
          });
        }, t.handleOnKeyDown = function (e) {
          var n,
              r = t.props.type,
              i = (_defineProperty(n = {}, dt, t.handleOnCancel), _defineProperty(n, ut, function () {
            "link" === r && e.preventDefault();
          }), _defineProperty(n, ht, t.handleOnSave), n);
          return i[e.keyCode] ? i[e.keyCode]() : function () {};
        }, t.handleOnCancel = function () {
          var e = t.props.value;
          t.setState(function () {
            return {
              isEditing: !1,
              inputValue: e
            };
          });
        }, t.handleOnSave = function () {
          t.setState(function () {
            return {
              isEditing: !1
            };
          }, t.propagateChange);
        }, t.propagateChange = function () {
          var e = t.state.inputValue,
              n = t.props.onSubmit;
          (void 0 === n ? function () {} : n)(e);
        }, t.state = {
          inputValue: e.value || "",
          isEditing: !1,
          isFocused: !0
        }, t;
      }

      return _inherits(InlineInputWithSave, r["PureComponent"]), _createClass(InlineInputWithSave, [{
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.inputValue,
              n = e.isEditing,
              r = e.isFocused,
              a = this.props.type,
              o = pt[void 0 === a ? "text" : a] || null;
          return i.a.createElement(o, Object.assign({
            inputValue: t,
            isEditing: n,
            isFocused: r,
            onBlur: this.handleOnBlur,
            onCancel: this.handleOnCancel,
            onClick: this.handleOnClick,
            onChange: this.handleOnChange,
            onFocus: this.handleOnFocus,
            onKeyDown: this.handleOnKeyDown,
            onSave: this.handleOnSave
          }, this.props));
        }
      }]), InlineInputWithSave;
    }(),
        mt = (n(189), Object.freeze({
      h1: function h1(e) {
        var t = e.children;
        return i.a.createElement(ei, null, t);
      },
      h2: function h2(e) {
        var t = e.children;
        return i.a.createElement(ti, null, t);
      },
      h3: function h3(e) {
        var t = e.children;
        return i.a.createElement(ni, null, t);
      },
      h4: function h4(e) {
        var t = e.children;
        return i.a.createElement(ri, null, t);
      },
      h5: function h5(e) {
        var t = e.children;
        return i.a.createElement(ii, null, t);
      },
      h6: function h6(e) {
        var t = e.children;
        return i.a.createElement(ai, null, t);
      }
    })),
        gt = Object.freeze({
      h1: 16,
      h2: 16,
      h3: 13,
      h4: 13,
      h5: 11,
      h6: 11
    }),
        vt = Object.freeze({
      text: function InlineText(e) {
        var t = e.isEditing,
            n = e.isInvalid,
            r = e.onSelectEdit,
            a = objectWithoutProperties_objectWithoutProperties(e, ["isEditing", "isInvalid", "onSelectEdit"]);
        return t ? i.a.createElement(li, {
          className: o()("tide-inline-editor--link-editing tide-inline-editor--editing-wrapper", {
            invalid: n
          })
        }, i.a.createElement(it, Object.assign({
          autoFocus: !0,
          type: "text"
        }, bt(a)))) : i.a.createElement(oi, {
          onClick: r,
          className: "tide-inline-editor--row"
        }, a.value, i.a.createElement(oi, {
          className: "tide-inline-editor--icon-wrapper"
        }, i.a.createElement(p, {
          width: 12,
          height: 12,
          name: "edit-1",
          className: "tide-inline-editor--icon"
        })));
      },
      link: function InlineLink(e) {
        var t = e.isEditing,
            n = e.isInvalid,
            r = e.onSelectEdit,
            a = e.leadingText,
            s = e.isActiveLink,
            l = e.customParams,
            c = void 0 === l ? "" : l,
            d = objectWithoutProperties_objectWithoutProperties(e, ["isEditing", "isInvalid", "onSelectEdit", "leadingText", "isActiveLink", "customParams"]),
            h = "" !== c ? "?".concat(c) : "",
            u = "".concat(a).concat(d.value).concat(h);
        if (t) return i.a.createElement(li, {
          className: o()("tide-inline-editor--link-editing tide-inline-editor--editing-wrapper", {
            invalid: n
          })
        }, i.a.createElement(li, {
          className: o()("tide-inline-editor--input-prompt", d.size || "small")
        }, i.a.createElement(oi, null, a)), i.a.createElement(li, {
          className: "tide-inline-editor--input-container"
        }, i.a.createElement(it, Object.assign({
          autoFocus: !0,
          type: "text",
          size: "small",
          className: "tide-inline-editor--link-input"
        }, bt(d)))));
        var f = s ? null : r,
            m = s ? null : function (e) {
          return e.preventDefault();
        },
            g = s ? r : null,
            v = o()("tide-inline-editor--link--anchor", {
          "tide-inline-editor--link--inactive": !s
        });
        return i.a.createElement(oi, {
          className: "tide-inline-editor--row",
          onClick: f
        }, i.a.createElement(Qr, {
          className: v,
          href: u,
          rel: "noopener noreferrer",
          onClick: m,
          target: "_blank"
        }, u), i.a.createElement(oi, {
          className: "tide-inline-editor--icon-wrapper",
          onClick: g
        }, i.a.createElement(p, {
          width: 12,
          height: 12,
          name: "edit-1",
          className: "tide-inline-editor--icon"
        })));
      },
      heading: function InlineHeading(e) {
        var t = e.isEditing,
            n = e.isInvalid,
            r = e.onSelectEdit,
            a = e.headingSize,
            s = (e.leadingText, objectWithoutProperties_objectWithoutProperties(e, ["isEditing", "isInvalid", "onSelectEdit", "headingSize", "leadingText"])),
            l = mt[a],
            c = gt[a];
        return t ? i.a.createElement(li, {
          className: o()("tide-inline-editor--editing-wrapper", {
            invalid: n
          })
        }, i.a.createElement(it, Object.assign({
          autoFocus: !0,
          type: "text",
          className: "tide-inline-editor--heading-input tide-inline-editor--heading-input-".concat(a)
        }, bt(s)))) : i.a.createElement(li, {
          onClick: r,
          className: "tide-inline-editor--row"
        }, i.a.createElement(l, null, s.value), i.a.createElement(oi, {
          className: "tide-inline-editor--icon-wrapper"
        }, i.a.createElement(p, {
          width: c,
          height: c,
          name: "edit-1",
          className: "tide-inline-editor--icon"
        })));
      }
    }),
        bt = Object(k.pick)(["value", "size", "onChange", "onBlur", "onKeyPress"]),
        yt = I(function (e) {
      function InlineEditInput(e) {
        var t;
        return _classCallCheck(this, InlineEditInput), (t = _possibleConstructorReturn(this, _getPrototypeOf(InlineEditInput).call(this, e))).handleClickOutside = function () {
          t.state.isEditing && t.onFinishEditing();
        }, t.onFinishEditing = function () {
          var e = t.props,
              n = e.onFinishEditing,
              r = e.value;
          t.setState({
            isEditing: !1,
            hasEverFinishedEditing: !0
          }), n && n({
            target: {
              value: r
            }
          });
        }, t.onKeyPress = function (e) {
          "Enter" === e.key && t.commitChanges();
        }, t.onEdit = function () {
          t.setState(function (e) {
            return {
              isEditing: !e.isEditing
            };
          });
        }, t.commitChanges = function () {
          var e = t.props,
              n = e.value,
              r = e.onChange;
          r && r({
            target: {
              value: n
            }
          }), t.onFinishEditing();
        }, t.state = {
          isEditing: !1,
          hasEverFinishedEditing: !1
        }, t;
      }

      return _inherits(InlineEditInput, r["Component"]), _createClass(InlineEditInput, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.type,
              n = e.leadingText,
              r = e.headingSize,
              a = e.loading,
              s = void 0 !== a && a,
              l = e.className,
              c = e.withSave,
              p = void 0 !== c && c,
              d = objectWithoutProperties_objectWithoutProperties(e, ["type", "leadingText", "headingSize", "loading", "className", "withSave"]),
              h = this.state,
              u = h.hasEverFinishedEditing,
              f = h.isEditing;
          if (p) return i.a.createElement(ft, this.props);
          var m = d.shouldValidate && !d.value,
              g = vt[t];
          return i.a.createElement(li, {
            className: o()("tide-inline-editor tide-inline-editor--".concat(t), _defineProperty({
              "tide-inline-editor--is-editing": f,
              "tide-inline-editor--loading": s,
              "tide-inline-editor--has-ever-finished-editing": u
            }, l, !!l))
          }, s ? null : i.a.createElement(g, Object.assign({
            onSelectEdit: this.onEdit,
            leadingText: n,
            headingSize: r,
            onBlur: this.onFinishEditing,
            onKeyPress: this.onKeyPress,
            isEditing: f,
            isInvalid: m
          }, d)));
        }
      }]), InlineEditInput;
    }()),
        xt = (n(191), n(193), {
      info: "info",
      warning: "warning-triangle",
      danger: "warning-triangle"
    }),
        wt = function (e) {
      function InlineWarning() {
        return _classCallCheck(this, InlineWarning), _possibleConstructorReturn(this, _getPrototypeOf(InlineWarning).apply(this, arguments));
      }

      return _inherits(InlineWarning, r["Component"]), _createClass(InlineWarning, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.title,
              n = e.type,
              r = e.onClick,
              a = e.className,
              s = e.icon,
              l = void 0 === s ? xt[n] : s,
              c = e.buttonText,
              d = e.buttonType,
              h = void 0 === d ? "secondary" : d,
              u = e.copy,
              f = e.children;
          return i.a.createElement(li, {
            className: o()("tide-inline-warning", a, {
              "tide-inline-warning--title-box": !!t,
              "tide-inline-warning--no-title-box": !t,
              "tide-inline-warning--info": "info" === n,
              "tide-inline-warning--warning": "warning" === n,
              "tide-inline-warning--danger": "danger" === n
            })
          }, i.a.createElement(li, {
            className: "tide-inline-warning-copy-block"
          }, i.a.createElement(li, {
            className: "tide-inline-warning-title"
          }, i.a.createElement(p, {
            className: "tide-inline-warning-icon",
            name: l,
            width: 12,
            height: 12
          }), i.a.createElement(ri, null, t)), i.a.createElement(li, {
            className: "tide-inline-warning-body"
          }, u ? i.a.createElement(si, {
            className: "tide-inline-warning-text"
          }, u) : i.a.createElement(li, null, f))), r && !!t && i.a.createElement(C, {
            className: "tide-inline-warning-button",
            type: h,
            onClick: r
          }, c));
        }
      }]), InlineWarning;
    }();

    wt.defaultProps = {
      buttonType: "secondary"
    };

    var Et = wt,
        Ct = (n(195), function P(e) {
      var t,
          n = e.className,
          r = e.children,
          a = e.type,
          s = void 0 === a ? "standard" : a,
          l = objectWithoutProperties_objectWithoutProperties(e, ["className", "children", "type"]);
      return i.a.createElement("p", Object.assign({
        className: o()("tide-paragraph", (t = {}, _defineProperty(t, n, !!n), _defineProperty(t, "tide-paragraph-1", "standard" === s || "inverse" === s || "subtle" === s), _defineProperty(t, "tide-paragraph-2", "small" === s), _defineProperty(t, "tide-paragraph-1--inverse", "inverse" === s), _defineProperty(t, "tide-paragraph-1--subtle", "subtle" === s), t))
      }, l), r);
    }),
        kt = function A(e) {
      var t,
          n = e.className,
          r = e.children,
          a = e.type,
          s = void 0 === a ? "standard" : a,
          l = objectWithoutProperties_objectWithoutProperties(e, ["className", "children", "type"]);
      return i.a.createElement("a", Object.assign({
        className: o()("tide-anchor-link", (t = {}, _defineProperty(t, n, !!n), _defineProperty(t, "tide-anchor-link-2", "small" === s), _defineProperty(t, "secondary-link", "secondary" === s), t))
      }, l), r);
    },
        St = function H1(e) {
      var t = e.className,
          n = e.children,
          r = objectWithoutProperties_objectWithoutProperties(e, ["className", "children"]);
      return i.a.createElement("h1", Object.assign({
        className: o()("tide-heading tide-heading-1", _defineProperty({}, t, !!t))
      }, r), n);
    },
        _t = function H2(e) {
      var t = e.className,
          n = e.children,
          r = objectWithoutProperties_objectWithoutProperties(e, ["className", "children"]);
      return i.a.createElement("h2", Object.assign({
        className: o()("tide-heading tide-heading-2", _defineProperty({}, t, !!t))
      }, r), n);
    },
        Mt = function H3(e) {
      var t,
          n = e.className,
          r = e.children,
          a = e.type,
          s = void 0 === a ? "standard" : a,
          l = objectWithoutProperties_objectWithoutProperties(e, ["className", "children", "type"]);
      return i.a.createElement("h3", Object.assign({
        className: o()("tide-heading tide-heading-3", (t = {}, _defineProperty(t, n, !!n), _defineProperty(t, "tide-heading-3--inverse", "inverse" === s), t))
      }, l), r);
    },
        Lt = function H4(e) {
      var t = e.className,
          n = e.children,
          r = objectWithoutProperties_objectWithoutProperties(e, ["className", "children"]);
      return i.a.createElement("h4", Object.assign({
        className: o()("tide-heading tide-heading-4", _defineProperty({}, t, !!t))
      }, r), n);
    },
        Pt = function H5(e) {
      var t = e.className,
          n = e.children,
          r = objectWithoutProperties_objectWithoutProperties(e, ["className", "children"]);
      return i.a.createElement("h5", Object.assign({
        className: o()("tide-heading tide-heading-5", _defineProperty({}, t, !!t))
      }, r), n);
    },
        Ft = function H6(e) {
      var t = e.className,
          n = e.children,
          r = objectWithoutProperties_objectWithoutProperties(e, ["className", "children"]);
      return i.a.createElement("h6", Object.assign({
        className: o()("tide-heading tide-heading-6", _defineProperty({}, t, !!t))
      }, r), n);
    },
        At = Ct,
        Dt = function Span(e) {
      var t,
          n = e.className,
          r = e.children,
          a = e.type,
          s = void 0 === a ? null : a,
          l = objectWithoutProperties_objectWithoutProperties(e, ["className", "children", "type"]);
      return i.a.createElement("span", Object.assign({
        className: o()("tide-text-span", (t = {}, _defineProperty(t, n, !!n), _defineProperty(t, "tide-text-span--error", "error" === s), t))
      }, l), r);
    },
        Nt = function Div(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("div", Object.assign({
        className: o()("tide-div", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Ot = function Article(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("article", Object.assign({
        className: o()("tide-article", _defineProperty({}, n, !!n))
      }, r), t);
    },
        zt = function Header(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("header", Object.assign({
        className: o()("tide-header", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Tt = function Footer(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("footer", Object.assign({
        className: o()("tide-footer", _defineProperty({}, n, !!n))
      }, r), t);
    },
        It = function Nav(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("nav", Object.assign({
        className: o()("tide-nav", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Rt = function Ol(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("ol", Object.assign({
        className: o()("tide-ol", _defineProperty({}, n, !!n))
      }, r), t);
    },
        jt = function Ul(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("ul", Object.assign({
        className: o()("tide-ul", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Bt = function Li(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("li", Object.assign({
        className: o()("tide-li", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Vt = function Main(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("main", Object.assign({
        className: o()("tide-main", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Ht = function Section(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement("section", Object.assign({
        className: o()("tide-section", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Wt = function Label(e) {
      var t = e.className,
          n = e.children,
          r = objectWithoutProperties_objectWithoutProperties(e, ["className", "children"]);
      return i.a.createElement("label", Object.assign({
        className: o()("tide-label", _defineProperty({}, t, !!t))
      }, r), n);
    },
        Gt = function Small(e) {
      var t = e.className,
          n = e.children,
          r = e.type,
          a = objectWithoutProperties_objectWithoutProperties(e, ["className", "children", "type"]);
      return i.a.createElement("small", Object.assign({
        className: o()("tide-small", _defineProperty({
          "tide-small--error": "error" === r
        }, t, !!t))
      }, a), n);
    },
        Zt = function Strong(e) {
      var t = e.className,
          n = e.children,
          r = objectWithoutProperties_objectWithoutProperties(e, ["className", "children"]);
      return i.a.createElement("strong", Object.assign({
        className: o()("tide-strong", _defineProperty({}, t, !!t))
      }, r), n);
    },
        qt = function Em(e) {
      var t = e.className,
          n = e.children;
      objectWithoutProperties_objectWithoutProperties(e, ["className", "children"]);
      return i.a.createElement("em", {
        className: o()("tide-em", _defineProperty({}, t, !!t))
      }, n);
    },
        Ut = (n(197), Vt),
        Kt = function Layout(e) {
      var t,
          n = e.children,
          r = e.className,
          a = e.type,
          s = void 0 === a ? null : a,
          l = objectWithoutProperties_objectWithoutProperties(e, ["children", "className", "type"]);
      return i.a.createElement(Ut, Object.assign({
        className: o()("tide-layout", (t = {}, _defineProperty(t, r, !!r), _defineProperty(t, "tide-layout--subtle", "subtle" === s), t))
      }, l), n);
    },
        Xt = (n(199), n(201), n(203), n(205), n(207), n(209), n(211), n(213), function LoadStyles() {}),
        Yt = {
      v: "4.6.0",
      fr: 29.9700012207031,
      ip: 0,
      op: 61.0000024845809,
      w: 400,
      h: 400,
      nm: "Comp 1",
      ddd: 0,
      assets: [{
        id: "comp_0",
        layers: [{
          ddd: 0,
          ind: 1,
          ty: 0,
          nm: "Pre-comp 2",
          refId: "comp_1",
          ks: {
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 1,
              k: [{
                i: {
                  x: .372,
                  y: .995
                },
                o: {
                  x: .333,
                  y: 0
                },
                n: "0p372_0p995_0p333_0",
                t: -1,
                s: [-63.707, 132, 0],
                e: [508.793, 132, 0],
                to: [95.4166641235352, 0, 0],
                ti: [-95.4166641235352, 0, 0]
              }, {
                t: 65.0000026475043
              }]
            },
            a: {
              a: 0,
              k: [200, 200, 0]
            },
            s: {
              a: 0,
              k: [100, 100, 100]
            }
          },
          ao: 0,
          w: 400,
          h: 400,
          ip: -1.00000004073083,
          op: 899.000036617021,
          st: -1.00000004073083,
          bm: 0,
          sr: 1
        }, {
          ddd: 0,
          ind: 2,
          ty: 0,
          nm: "Pre-comp 2",
          refId: "comp_1",
          ks: {
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 1,
              k: [{
                i: {
                  x: .663,
                  y: .994
                },
                o: {
                  x: .333,
                  y: 0
                },
                n: "0p663_0p994_0p333_0",
                t: 47,
                s: [-120.707, 132, 0],
                e: [480.293, 132, 0],
                to: [100.166664123535, 0, 0],
                ti: [-100.166664123535, 0, 0]
              }, {
                t: 120.0000048877
              }]
            },
            a: {
              a: 0,
              k: [200, 200, 0]
            },
            s: {
              a: 0,
              k: [100, 100, 100]
            }
          },
          ao: 0,
          w: 400,
          h: 400,
          ip: 47.0000019143492,
          op: 947.000038572101,
          st: 47.0000019143492,
          bm: 0,
          sr: 1
        }, {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Master",
          ks: {
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [198, 192, 0]
            },
            a: {
              a: 0,
              k: [146.5, 5.5, 0]
            },
            s: {
              a: 0,
              k: [100, 100, 100]
            }
          },
          ao: 0,
          shapes: [{
            ty: "gr",
            it: [{
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [[-2.858, 0], [0, 0], [0, -2.858], [2.859, 0], [0, 0], [0, 2.858]],
                  o: [[0, 0], [2.859, 0], [0, 2.858], [0, 0], [-2.858, 0], [0, -2.858]],
                  v: [[-140.825, -5.175], [140.825, -5.175], [146, .001], [140.825, 5.175], [-140.825, 5.175], [-146, .001]],
                  c: !0
                }
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group"
            }, {
              ty: "fl",
              c: {
                a: 0,
                k: [.847, .847, .847, 1]
              },
              o: {
                a: 0,
                k: 100
              },
              r: 1,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill"
            }, {
              ty: "tr",
              p: {
                a: 0,
                k: [146.25, 5.425],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: "Transform"
            }],
            nm: "Group 1",
            np: 2,
            mn: "ADBE Vector Group"
          }],
          ip: 0,
          op: 900.000036657751,
          st: 0,
          bm: 0,
          sr: 1
        }]
      }, {
        id: "comp_1",
        layers: [{
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Layer 5/progressbar-final Outlines",
          ks: {
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [296, 260, 0]
            },
            a: {
              a: 0,
              k: [76.5, 5.5, 0]
            },
            s: {
              a: 0,
              k: [100, 100, 100]
            }
          },
          ao: 0,
          shapes: [{
            ty: "gr",
            it: [{
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [[-2.858, 0], [0, 0], [0, -2.859], [2.859, 0], [0, 0], [0, 2.857]],
                  o: [[0, 0], [2.859, 0], [0, 2.857], [0, 0], [-2.858, 0], [0, -2.859]],
                  v: [[-70.825, -5.175], [70.825, -5.175], [76, 0], [70.825, 5.175], [-70.825, 5.175], [-76, 0]],
                  c: !0
                }
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group"
            }, {
              ty: "fl",
              c: {
                a: 0,
                k: [0, .455, 1, 1]
              },
              o: {
                a: 0,
                k: 100
              },
              r: 1,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill"
            }, {
              ty: "tr",
              p: {
                a: 0,
                k: [76.25, 5.425],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: "Transform"
            }],
            nm: "Group 1",
            np: 2,
            mn: "ADBE Vector Group"
          }],
          ip: 0,
          op: 900.000036657751,
          st: 0,
          bm: 0,
          sr: 1
        }, {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "Layer 4/progressbar-final Outlines",
          ks: {
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [86, 260, 0]
            },
            a: {
              a: 0,
              k: [22.5, 5.5, 0]
            },
            s: {
              a: 0,
              k: [100, 100, 100]
            }
          },
          ao: 0,
          shapes: [{
            ty: "gr",
            it: [{
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [[-2.858, 0], [0, 0], [0, -2.859], [2.858, 0], [0, 0], [0, 2.857]],
                  o: [[0, 0], [2.858, 0], [0, 2.857], [0, 0], [-2.858, 0], [0, -2.859]],
                  v: [[-16.825, -5.175], [16.825, -5.175], [22, 0], [16.825, 5.175], [-16.825, 5.175], [-22, 0]],
                  c: !0
                }
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group"
            }, {
              ty: "fl",
              c: {
                a: 0,
                k: [0, .455, 1, 1]
              },
              o: {
                a: 0,
                k: 100
              },
              r: 1,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill"
            }, {
              ty: "tr",
              p: {
                a: 0,
                k: [22.25, 5.425],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: "Transform"
            }],
            nm: "Group 1",
            np: 2,
            mn: "ADBE Vector Group"
          }],
          ip: 0,
          op: 900.000036657751,
          st: 0,
          bm: 0,
          sr: 1
        }, {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Layer 3/progressbar-final Outlines",
          ks: {
            o: {
              a: 0,
              k: 100
            },
            r: {
              a: 0,
              k: 0
            },
            p: {
              a: 0,
              k: [164, 260, 0]
            },
            a: {
              a: 0,
              k: [40, 5.5, 0]
            },
            s: {
              a: 0,
              k: [100, 100, 100]
            }
          },
          ao: 0,
          shapes: [{
            ty: "gr",
            it: [{
              ind: 0,
              ty: "sh",
              ks: {
                a: 0,
                k: {
                  i: [[-2.858, 0], [0, 0], [0, -2.859], [2.858, 0], [0, 0], [0, 2.857]],
                  o: [[0, 0], [2.858, 0], [0, 2.857], [0, 0], [-2.858, 0], [0, -2.859]],
                  v: [[-34.325, -5.175], [34.325, -5.175], [39.5, 0], [34.325, 5.175], [-34.325, 5.175], [-39.5, 0]],
                  c: !0
                }
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group"
            }, {
              ty: "fl",
              c: {
                a: 0,
                k: [0, .455, 1, 1]
              },
              o: {
                a: 0,
                k: 100
              },
              r: 1,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill"
            }, {
              ty: "tr",
              p: {
                a: 0,
                k: [39.75, 5.425],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: "Transform"
            }],
            nm: "Group 1",
            np: 2,
            mn: "ADBE Vector Group"
          }],
          ip: 0,
          op: 900.000036657751,
          st: 0,
          bm: 0,
          sr: 1
        }]
      }],
      layers: [{
        ddd: 0,
        ind: 1,
        ty: 0,
        nm: "Pre-comp 1",
        refId: "comp_0",
        ks: {
          o: {
            a: 0,
            k: 100
          },
          r: {
            a: 0,
            k: 0
          },
          p: {
            a: 0,
            k: [202.032, 208.014, 0]
          },
          a: {
            a: 0,
            k: [200, 200, 0]
          },
          s: {
            a: 0,
            k: [99.979, 100, 100]
          }
        },
        ao: 0,
        hasMask: !0,
        masksProperties: [{
          inv: !1,
          mode: "a",
          pt: {
            a: 0,
            k: {
              i: [[4.821, 0], [0, 0], [0, -4.821], [-4.821, 0], [0, 0], [0, 2.771]],
              o: [[0, 0], [-4.821, 0], [0, 4.821], [0, 0], [4.821, 0], [0, -2.417]],
              v: [[337.122, 186.522], [59.625, 186.49], [52.02, 192.229], [59.708, 197.449], [337.205, 197.481], [343.914, 191.917]],
              c: !0
            }
          },
          o: {
            a: 0,
            k: 100
          },
          x: {
            a: 0,
            k: 0
          },
          nm: "Mask 2"
        }],
        w: 400,
        h: 400,
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0,
        sr: 1
      }]
    },
        $t = {
      v: "4.10.1",
      fr: 29.9700012207031,
      ip: 0,
      op: 60.0000024438501,
      w: 900,
      h: 12,
      nm: "Loader 1 JSON",
      ddd: 0,
      assets: [{
        id: "comp_1",
        layers: [{
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Shape Layer 4",
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 1,
              k: [{
                i: {
                  x: 0,
                  y: 1
                },
                o: {
                  x: .167,
                  y: .167
                },
                n: "0_1_0p167_0p167",
                t: 243,
                s: [200, 5, 0],
                e: [200, -5, 0],
                to: [0, -1.66666662693024, 0],
                ti: [0, 1.66666662693024, 0]
              }, {
                t: 253.000010304901
              }],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 38.5, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: "gr",
            it: [{
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [[0, 0], [0, 0]],
                  o: [[0, 0], [0, 0]],
                  v: [[-200, 38.5], [200.25, 38.5]],
                  c: !1
                },
                ix: 2
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: !1
            }, {
              ty: "st",
              c: {
                a: 0,
                k: [.709803938866, .823529422283, .882352948189, 1],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 10,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 4,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: !1
            }, {
              ty: "tr",
              p: {
                a: 0,
                k: [0, 0],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: "Transform"
            }],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }, {
            ty: "tm",
            s: {
              a: 1,
              k: [{
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0_1_0p333_0"],
                t: 110,
                s: [48.75],
                e: [97.5]
              }, {
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0_1_0p333_0"],
                t: 130,
                s: [97.5],
                e: [0]
              }, {
                i: {
                  x: [.667],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0p667_1_0p333_0"],
                t: 150,
                s: [0],
                e: [0]
              }, {
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0_1_0p333_0"],
                t: 170,
                s: [0],
                e: [97.5]
              }, {
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0_1_0p333_0"],
                t: 190,
                s: [97.5],
                e: [0]
              }, {
                t: 210.000008553475
              }],
              ix: 1
            },
            e: {
              a: 1,
              k: [{
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0_1_0p333_0"],
                t: 100,
                s: [48.75],
                e: [100]
              }, {
                i: {
                  x: [.667],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0p667_1_0p333_0"],
                t: 120,
                s: [100],
                e: [100]
              }, {
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0_1_0p333_0"],
                t: 140,
                s: [100],
                e: [2.5]
              }, {
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0_1_0p333_0"],
                t: 160,
                s: [2.5],
                e: [100]
              }, {
                i: {
                  x: [.667],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0p667_1_0p333_0"],
                t: 180,
                s: [100],
                e: [100]
              }, {
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0_1_0p333_0"],
                t: 200,
                s: [100],
                e: [2.5]
              }, {
                i: {
                  x: [0],
                  y: [1]
                },
                o: {
                  x: [.333],
                  y: [0]
                },
                n: ["0_1_0p333_0"],
                t: 220,
                s: [2.5],
                e: [100]
              }, {
                t: 240.0000097754
              }],
              ix: 2
            },
            o: {
              a: 0,
              k: 0,
              ix: 3
            },
            m: 1,
            ix: 2,
            nm: "Trim Paths 1",
            mn: "ADBE Vector Filter - Trim",
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }, {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "Shape Layer 1",
          sr: 1,
          ks: {
            o: {
              a: 0,
              k: 100,
              ix: 11
            },
            r: {
              a: 0,
              k: 0,
              ix: 10
            },
            p: {
              a: 1,
              k: [{
                i: {
                  x: 0,
                  y: 1
                },
                o: {
                  x: .167,
                  y: .167
                },
                n: "0_1_0p167_0p167",
                t: 30,
                s: [201.074, 44.223, 0],
                e: [201.074, 147.289, 0],
                to: [0, 17.177734375, 0],
                ti: [0, -17.177734375, 0]
              }, {
                i: {
                  x: .833,
                  y: .833
                },
                o: {
                  x: .167,
                  y: .167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 45,
                s: [201.074, 147.289, 0],
                e: [201.074, 147.289, 0],
                to: [0, 0, 0],
                ti: [0, 0, 0]
              }, {
                i: {
                  x: 0,
                  y: 1
                },
                o: {
                  x: .167,
                  y: .167
                },
                n: "0_1_0p167_0p167",
                t: 90,
                s: [201.074, 147.289, 0],
                e: [201.074, 57.289, 0],
                to: [0, -15, 0],
                ti: [0, 15, 0]
              }, {
                i: {
                  x: .833,
                  y: .833
                },
                o: {
                  x: .167,
                  y: .167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 100,
                s: [201.074, 57.289, 0],
                e: [201.074, 57.289, 0],
                to: [0, 0, 0],
                ti: [0, 0, 0]
              }, {
                i: {
                  x: 0,
                  y: 1
                },
                o: {
                  x: .167,
                  y: .167
                },
                n: "0_1_0p167_0p167",
                t: 243,
                s: [201.074, 57.289, 0],
                e: [201.074, 45.289, 0],
                to: [0, -1.99999380111694, 0],
                ti: [0, 1.99999380111694, 0]
              }, {
                t: 253.000010304901
              }],
              ix: 2
            },
            a: {
              a: 0,
              k: [0, 0, 0],
              ix: 1
            },
            s: {
              a: 0,
              k: [100, 100, 100],
              ix: 6
            }
          },
          ao: 0,
          shapes: [{
            ty: "gr",
            it: [{
              ty: "rc",
              d: 1,
              s: {
                a: 0,
                k: [400, 100],
                ix: 2
              },
              p: {
                a: 0,
                k: [0, 0],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 4
              },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: !1
            }, {
              ty: "fl",
              c: {
                a: 0,
                k: [.943504929543, .943504929543, .943504929543, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 0,
                ix: 5
              },
              r: 1,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: !1
            }, {
              ty: "tr",
              p: {
                a: 0,
                k: [-.082, -96.781],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: "Transform"
            }],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          }],
          ip: 0,
          op: 300.00001221925,
          st: 0,
          bm: 0
        }]
      }],
      layers: [{
        ddd: 0,
        ind: 1,
        ty: 0,
        nm: "Loader 1",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [450, 51, 0],
            ix: 2
          },
          a: {
            a: 0,
            k: [200, 50, 0],
            ix: 1
          },
          s: {
            a: 0,
            k: [224.5, 100, 100],
            ix: 6
          }
        },
        ao: 0,
        w: 400,
        h: 100,
        ip: 0,
        op: 60.0000024438501,
        st: -130.000005295009,
        bm: 0
      }]
    },
        Jt = (n(215), {
      default: Yt,
      table: $t
    }),
        Qt = function Loader(e) {
      var t = e.type,
          n = void 0 === t ? "default" : t,
          r = e.size,
          a = void 0 === r ? 150 : r,
          s = e.width,
          l = e.height,
          c = e.className,
          p = void 0 === c ? "" : c,
          d = {
        loop: !0,
        autoplay: !0,
        prerender: !0,
        renderer: "svg",
        animationData: Jt[n],
        rendererSettings: {
          preserveAspectRatio: "xMinYMid slice"
        }
      };
      return i.a.createElement(li, {
        className: o()("tide-loading-icon", p)
      }, i.a.createElement(Pe, {
        height: l,
        options: d,
        width: s || a
      }));
    },
        en = (n(217), function (e) {
      function BaseModal(e) {
        var t;
        return _classCallCheck(this, BaseModal), (t = _possibleConstructorReturn(this, _getPrototypeOf(BaseModal).call(this, e))).open = function () {
          t.setState({
            hidden: !1
          }, t.delayOpen);
        }, t.close = function () {
          t.setState({
            open: !1,
            hidden: !0
          }, t.delayHidden);
        }, t.delayOpen = function () {
          setTimeout(function () {
            t.setState({
              open: !0
            });
          }, 0);
        }, t.closeOutside = function () {
          t.props.onClose();
        }, t.state = {
          hidden: !e.open,
          open: e.open
        }, t;
      }

      return _inherits(BaseModal, r["Component"]), _createClass(BaseModal, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.handleParentUpdate(this.props);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          this.handleParentUpdate(e);
        }
      }, {
        key: "handleParentUpdate",
        value: function handleParentUpdate(e) {
          e.open ? this.open() : this.close();
        }
      }, {
        key: "isErrorOrWarning",
        value: function isErrorOrWarning() {
          var e = this.props.type;
          return "error" === e || "warning" === e;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.children,
              n = e.className,
              r = e.footerCopy,
              a = e.onClose,
              s = e.size,
              l = e.title,
              c = e.type,
              d = this.state,
              h = d.hidden,
              u = d.open,
              f = s || "medium";
          return h ? null : i.a.createElement(li, {
            className: o()("tide-base-modal", {
              "tide-base-modal--open": u
            })
          }, i.a.createElement(li, {
            className: "tide-base-modal--overlay",
            onClick: this.closeOutside
          }), i.a.createElement(li, {
            className: o()("tide-base-modal-content", n, {
              "tide-base-modal--small": "small" === f,
              "tide-base-modal--medium": "medium" === f,
              "tide-base-modal--large": "large" === f,
              "tide-base-modal--warning": "warning" === c,
              "tide-base-modal--error": "error" === c
            })
          }, i.a.createElement(pi, {
            className: "tide-base-modal-header"
          }, i.a.createElement(li, {
            className: "tide-base-modal-header-title"
          }, this.isErrorOrWarning() && i.a.createElement(p, {
            name: "warning-triangle-filled",
            height: 16,
            width: 16
          }), i.a.createElement(ri, null, l)), i.a.createElement(li, {
            className: "tide-base-modal-close",
            onClick: a
          }, i.a.createElement(p, {
            name: "close",
            width: 15
          }))), i.a.createElement(li, {
            className: o()("tide-base-modal-content--body", {
              "tide-base-modal-content--body__flow": r
            })
          }, t), r && i.a.createElement(di, {
            className: "tide-base-modal-footer"
          }, r)));
        }
      }]), BaseModal;
    }()),
        tn = (n(219), function (e) {
      function Tabs(e) {
        var t;
        return _classCallCheck(this, Tabs), (t = _possibleConstructorReturn(this, _getPrototypeOf(Tabs).call(this, e))).handleKeyPress = function (e) {
          return function (n) {
            ["Enter", " "].includes(n.key) && (n.preventDefault(), t.activateTab(e));
          };
        }, t.activateTab = function (e, n) {
          t.props.controlled ? t.props.onActivateTab && t.props.onActivateTab(e) : n || t.setState({
            activeTab: e
          });
        }, t.getActiveTab = function () {
          return t.props.controlled ? window.isFinite(t.props.activeTab) ? t.props.activeTab : 0 : t.state.activeTab;
        }, t.isActiveTab = function (e) {
          return e === t.getActiveTab();
        }, e.controlled || (t.state = {
          activeTab: window.isFinite(e.activeTab) ? e.activeTab : 0
        }), t;
      }

      return _inherits(Tabs, r["Component"]), _createClass(Tabs, [{
        key: "render",
        value: function render() {
          var e,
              t = this,
              n = this.props,
              r = n.activeTabClass,
              a = n.className,
              s = n.data,
              l = n.listClass,
              c = n.tabClass,
              p = n.tabBgColor,
              d = n.tabsBgColor,
              h = n.tabHover,
              u = n.tabTitleBgColor,
              f = n.type,
              m = n.wrapperClass,
              g = s[this.getActiveTab()];
          return i.a.createElement(li, {
            className: o()("tabby-tabs tabby-tabs--".concat(f), (e = {}, _defineProperty(e, a, !!a), _defineProperty(e, m, !!m), e)),
            style: {
              "--tabs-bg": "var(".concat(d, ")"),
              "--tab-bg": "var(".concat(p, ")"),
              "--tab-hover": "var(".concat(h, ")"),
              "--tab-title-color": "var(".concat(u, ")")
            }
          }, i.a.createElement(fi, {
            className: o()("tabby-tabs-tabs", _defineProperty({}, l, !!l)),
            role: "tablist"
          }, s.map(function (e, n) {
            var a;
            return e.hidden ? null : i.a.createElement(mi, {
              key: "tab-".concat(e.title, "-").concat(n),
              className: o()("tabby-tabs-tab", (a = {
                "tabby-tabs-tab--active": t.isActiveTab(n),
                "tabby-tabs-tab--external": e.external
              }, _defineProperty(a, r, !!r && t.isActiveTab(n)), _defineProperty(a, c, !!c), a)),
              tabIndex: 0,
              role: "tab",
              "aria-selected": t.isActiveTab(n),
              onKeyPress: t.handleKeyPress(n),
              onClick: function onClick() {
                return t.activateTab(n, e.external);
              }
            }, e.title);
          })), g && g.component && i.a.createElement(li, {
            className: "tabby-tabs-content"
          }, g.component()));
        }
      }]), Tabs;
    }());

    tn.defaultProps = {
      controlled: !1,
      tabBgColor: "--color-p1-2",
      tabsBgColor: "--color-p1-4",
      tabHover: "--color-p1-3",
      tabTitleBgColor: "--color-p1",
      type: "default"
    };

    var nn = tn,
        rn = (n(221), function splitPath(e) {
      return e.split("/").filter(function (e) {
        return "" !== e;
      });
    }),
        an = function navToTabsProps(e, t) {
      var n = Object(k.indexOf)(!0, e.map(function (e) {
        return function checkIfActive(e, t) {
          if (t && e) {
            var n = rn(e),
                r = rn(t.location.pathname);

            if (!Object(k.isEmpty)(r) && r.length >= 2) {
              if (Object(k.last)(r) === Object(k.last)(n)) return !0;
            } else if (t.location.pathname === e) return !0;
          }

          return !1;
        }(e.route, t.history);
      })),
          r = e.map(function (e) {
        return e.onClick;
      });
      return {
        activeTab: n,
        onActivateTab: function onActivateTab(e) {
          var n = r[e];
          n && n(t);
        },
        data: e.map(function (e) {
          return {
            title: e.label,
            hidden: e.isHidden && e.isHidden(),
            external: e.external
          };
        }),
        controlled: !0
      };
    },
        on = function renderProp(e) {
      return e && "function" === typeof e ? e() : e;
    },
        sn = function (e) {
      function NavigationHeader(e) {
        var t;
        return _classCallCheck(this, NavigationHeader), (t = _possibleConstructorReturn(this, _getPrototypeOf(NavigationHeader).call(this, e))).state = {
          activeSection: null
        }, t;
      }

      return _inherits(NavigationHeader, r["Component"]), _createClass(NavigationHeader, [{
        key: "checkIfActive",
        value: function checkIfActive(e) {
          var t = this.props.history;

          if (t) {
            var n = e.split("/"),
                r = t.location.pathname.split("/");

            if (!Object(k.isEmpty)(r) && r.length >= 2) {
              if (r[1] === n[1]) return !0;
            } else if (t.location.pathname === e) return !0;
          }

          return !1;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.nav,
              n = e.title,
              r = e.children,
              a = e.secondary,
              s = "function" === typeof n;
          return i.a.createElement(pi, {
            className: o()("tide-header-nav--container", {
              "tide-header-nav--container--with-nav": !!t
            })
          }, !!a && i.a.createElement(li, {
            className: "tide-header-nav--secondary"
          }, on(a)), i.a.createElement(li, {
            className: "tide-header-nav--title-container"
          }, i.a.createElement(li, {
            className: "tide-header-nav--title-block"
          }, s ? on(n) : i.a.createElement(ni, {
            className: "tide-header-nav--title"
          }, n)), !!r && i.a.createElement(li, {
            className: "tide-header-nav--title-actions"
          }, r)), !!t && i.a.createElement(nn, Object.assign({
            className: "tide-header-nav"
          }, an(t, this.props))));
        }
      }]), NavigationHeader;
    }(),
        ln = (n(223), function sizeToSizeOptions(e) {
      return {
        label: e,
        value: e
      };
    }),
        cn = function NoMaxPagesPaginator(e) {
      var t = e.goBackward,
          n = e.goForward,
          r = e.index,
          a = e.size,
          s = Math.floor(r / a) + 1,
          l = r > 0,
          c = o()({
        "paginator-button--hidden": !l
      }),
          d = o()({
        "paginator-button--hidden": !1
      });
      return i.a.createElement(li, {
        className: "tide-table--paginator"
      }, i.a.createElement(li, {
        className: "tide-table--paginator-navigation"
      }, i.a.createElement("button", {
        onClick: t,
        className: c
      }, i.a.createElement(p, {
        width: 12,
        height: 12,
        name: "arrow-1-left"
      })), "Page ", s, i.a.createElement("button", {
        onClick: n,
        className: d
      }, i.a.createElement(p, {
        width: 12,
        height: 12,
        name: "arrow-1-right"
      }))));
    },
        pn = function Paginator(e) {
      var t,
          n = e.totalPages,
          r = e.index,
          a = e.size,
          s = e.goForward,
          l = e.goBackward,
          c = e.changeSize,
          d = e.sizes,
          h = void 0 === d ? [25, 50, 75, 100] : d,
          u = e.className,
          f = e.position,
          m = void 0 === f ? "fixed" : f,
          g = !r,
          v = r + 1 >= n,
          b = function sizesToSizeOptions(e) {
        return e.map(ln);
      }(h),
          y = "fixed" === m,
          x = o()("tide-table--paginator", (_defineProperty(t = {}, u, !!u), _defineProperty(t, "tide-table--paginator--fixed", y), t));

      return i.a.createElement(li, {
        className: x
      }, i.a.createElement(cr, {
        options: b,
        clearable: !1,
        value: a,
        onChange: c,
        className: "tide-table--paginator-size-select"
      }), i.a.createElement(li, {
        className: "tide-table--paginator-navigation"
      }, n > 1 && i.a.createElement("button", {
        onClick: l,
        disabled: g
      }, i.a.createElement(p, {
        width: 12,
        height: 12,
        name: "arrow-1-left"
      })), i.a.createElement(oi, null, "page ", isNaN(r) ? 1 : r + 1, " of ", isNaN(n) ? 1 : n), n > 1 && i.a.createElement("button", {
        disabled: v,
        onClick: s
      }, i.a.createElement(p, {
        width: 12,
        height: 12,
        name: "arrow-1-right"
      }))));
    },
        dn = n(21),
        hn = n.n(dn);

    function asyncGeneratorStep(e, t, n, r, i, a, o) {
      try {
        var s = e[a](o),
            l = s.value;
      } catch (c) {
        return void n(c);
      }

      s.done ? t(l) : Promise.resolve(l).then(r, i);
    }

    function _asyncToGenerator(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, i) {
          var a = e.apply(t, n);

          function _next(e) {
            asyncGeneratorStep(a, r, i, _next, _throw, "next", e);
          }

          function _throw(e) {
            asyncGeneratorStep(a, r, i, _next, _throw, "throw", e);
          }

          _next(void 0);
        });
      };
    }

    var un = function () {
      var e = _asyncToGenerator(hn.a.mark(function _callee(e) {
        return hn.a.wrap(function _callee$(t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", new Promise(function (t) {
                  return setTimeout(t, e);
                }));

              case 1:
              case "end":
                return t.stop();
            }
          }
        }, _callee);
      }));

      return function pause(t) {
        return e.apply(this, arguments);
      };
    }(),
        fn = function uid() {
      return Math.random().toString(36).substring(2);
    },
        mn = {
      animate: !0,
      speed: 2,
      width: 400,
      height: 130,
      preserveAspectRatio: "xMidYMid meet",
      primaryColor: "#f2f6f8",
      secondaryColor: "#ffffff",
      primaryOpacity: .5,
      secondaryOpacity: .005,
      delaySpeed: 50
    },
        gn = function Wrap() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = _objectSpread({}, mn, e),
          n = t.uniquekey ? "".concat(t.uniquekey, "-idClip") : fn(),
          r = t.uniquekey ? "".concat(t.uniquekey, "-idGradient") : fn(),
          a = t.delayKey ? t.delayKey * t.delaySpeed : 0;

      return i.a.createElement("svg", {
        viewBox: "0 0 ".concat(t.width, " ").concat(t.height),
        version: "1.1",
        style: t.style,
        preserveAspectRatio: t.preserveAspectRatio,
        className: t.className
      }, i.a.createElement("rect", {
        style: {
          fill: "url(#".concat(r, ")")
        },
        clipPath: "url(#".concat(n, ")"),
        x: "0",
        y: "0",
        width: t.width,
        height: t.height
      }), i.a.createElement("defs", null, i.a.createElement("clipPath", {
        id: n
      }, t.children), i.a.createElement("linearGradient", {
        id: r,
        gradientTransform: "rotate(5)"
      }, i.a.createElement("stop", {
        offset: "0%",
        stopColor: t.primaryColor,
        stopOpacity: t.primaryOpacity
      }, t.animate ? i.a.createElement("animate", {
        attributeName: "offset",
        values: "-2; 1",
        dur: "".concat(t.speed, "s"),
        repeatCount: "indefinite",
        begin: "".concat(a, "ms")
      }) : null), i.a.createElement("stop", {
        offset: "50%",
        stopColor: t.secondaryColor,
        stopOpacity: t.secondaryOpacity
      }, t.animate ? i.a.createElement("animate", {
        attributeName: "offset",
        values: "-1.5; 1.5",
        dur: "".concat(t.speed, "s"),
        repeatCount: "indefinite",
        begin: "".concat(a, "ms")
      }) : null), i.a.createElement("stop", {
        offset: "100%",
        stopColor: t.primaryColor,
        stopOpacity: t.primaryOpacity
      }, t.animate ? i.a.createElement("animate", {
        attributeName: "offset",
        values: "-1; 2",
        dur: "".concat(t.speed, "s"),
        repeatCount: "indefinite",
        begin: "".concat(a, "ms")
      }) : null))));
    },
        vn = (n(227), function (e) {
      function ProgressiveLoader(e) {
        var t;
        return _classCallCheck(this, ProgressiveLoader), (t = _possibleConstructorReturn(this, _getPrototypeOf(ProgressiveLoader).call(this, e))).state = {
          fadeOut: !1
        }, t;
      }

      return _inherits(ProgressiveLoader, r["Component"]), _createClass(ProgressiveLoader, [{
        key: "componentDidUpdate",
        value: function () {
          var e = _asyncToGenerator(hn.a.mark(function _callee(e, t) {
            var n;
            return hn.a.wrap(function _callee$(t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (n = this.props.transitionWaitTime, e.isLoaded === this.props.isLoaded) {
                      t.next = 5;
                      break;
                    }

                    return t.next = 4, un(n || 1e3);

                  case 4:
                    this.setState({
                      fadeOut: !0
                    });

                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, _callee, this);
          }));

          return function componentDidUpdate(t, n) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.className,
              n = e.placeholderShape,
              r = e.numPlaceholders,
              a = e.options,
              s = e.children,
              l = this.state.fadeOut;
          return i.a.createElement(li, {
            className: o()("tide-placeholder-shimmer", t, {
              "tide-placeholder-shimmer--loaded": l
            })
          }, !s && Array.apply("", {
            length: r
          }).map(function (e, t) {
            return i.a.createElement(gn, Object.assign({}, a, {
              key: "placeholder-".concat(t)
            }), n);
          }), !!s && i.a.createElement(oi, null, s));
        }
      }]), ProgressiveLoader;
    }()),
        bn = (n(229), function Ribbon(e) {
      var t = e.text,
          n = e.className,
          r = void 0 === n ? "" : n,
          a = e.isUpgrade,
          s = void 0 !== a && a;
      return i.a.createElement(li, {
        className: "tide-ribbon--container"
      }, i.a.createElement(li, {
        className: o()("tide-ribbon", {
          "tide-upgrade-ribbon": s
        }, r)
      }, t), i.a.createElement(p, {
        className: "tide-ribbon--lightning-icon",
        width: 16,
        height: 24,
        name: "lightning-bolt-filled"
      }));
    }),
        yn = n(139),
        xn = n.n(yn),
        wn = n(2),
        En = n.n(wn),
        Cn = function arrowRenderer(e) {
      var t = e.onMouseDown;
      return i.a.createElement("span", {
        className: "Select-arrow",
        onMouseDown: t
      });
    };

    Cn.propTypes = {
      onMouseDown: En.a.func
    };

    var kn = [{
      base: "A",
      letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
    }, {
      base: "AA",
      letters: /[\uA732]/g
    }, {
      base: "AE",
      letters: /[\u00C6\u01FC\u01E2]/g
    }, {
      base: "AO",
      letters: /[\uA734]/g
    }, {
      base: "AU",
      letters: /[\uA736]/g
    }, {
      base: "AV",
      letters: /[\uA738\uA73A]/g
    }, {
      base: "AY",
      letters: /[\uA73C]/g
    }, {
      base: "B",
      letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
    }, {
      base: "C",
      letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
    }, {
      base: "D",
      letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
    }, {
      base: "DZ",
      letters: /[\u01F1\u01C4]/g
    }, {
      base: "Dz",
      letters: /[\u01F2\u01C5]/g
    }, {
      base: "E",
      letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
    }, {
      base: "F",
      letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
    }, {
      base: "G",
      letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
    }, {
      base: "H",
      letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
    }, {
      base: "I",
      letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
    }, {
      base: "J",
      letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
    }, {
      base: "K",
      letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
    }, {
      base: "L",
      letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
    }, {
      base: "LJ",
      letters: /[\u01C7]/g
    }, {
      base: "Lj",
      letters: /[\u01C8]/g
    }, {
      base: "M",
      letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
    }, {
      base: "N",
      letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
    }, {
      base: "NJ",
      letters: /[\u01CA]/g
    }, {
      base: "Nj",
      letters: /[\u01CB]/g
    }, {
      base: "O",
      letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
    }, {
      base: "OI",
      letters: /[\u01A2]/g
    }, {
      base: "OO",
      letters: /[\uA74E]/g
    }, {
      base: "OU",
      letters: /[\u0222]/g
    }, {
      base: "P",
      letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
    }, {
      base: "Q",
      letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
    }, {
      base: "R",
      letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
    }, {
      base: "S",
      letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
    }, {
      base: "T",
      letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
    }, {
      base: "TZ",
      letters: /[\uA728]/g
    }, {
      base: "U",
      letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
    }, {
      base: "V",
      letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
    }, {
      base: "VY",
      letters: /[\uA760]/g
    }, {
      base: "W",
      letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
    }, {
      base: "X",
      letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
    }, {
      base: "Y",
      letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
    }, {
      base: "Z",
      letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
    }, {
      base: "a",
      letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
    }, {
      base: "aa",
      letters: /[\uA733]/g
    }, {
      base: "ae",
      letters: /[\u00E6\u01FD\u01E3]/g
    }, {
      base: "ao",
      letters: /[\uA735]/g
    }, {
      base: "au",
      letters: /[\uA737]/g
    }, {
      base: "av",
      letters: /[\uA739\uA73B]/g
    }, {
      base: "ay",
      letters: /[\uA73D]/g
    }, {
      base: "b",
      letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
    }, {
      base: "c",
      letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
    }, {
      base: "d",
      letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
    }, {
      base: "dz",
      letters: /[\u01F3\u01C6]/g
    }, {
      base: "e",
      letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
    }, {
      base: "f",
      letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
    }, {
      base: "g",
      letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
    }, {
      base: "h",
      letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
    }, {
      base: "hv",
      letters: /[\u0195]/g
    }, {
      base: "i",
      letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
    }, {
      base: "j",
      letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
    }, {
      base: "k",
      letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
    }, {
      base: "l",
      letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
    }, {
      base: "lj",
      letters: /[\u01C9]/g
    }, {
      base: "m",
      letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
    }, {
      base: "n",
      letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
    }, {
      base: "nj",
      letters: /[\u01CC]/g
    }, {
      base: "o",
      letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
    }, {
      base: "oi",
      letters: /[\u01A3]/g
    }, {
      base: "ou",
      letters: /[\u0223]/g
    }, {
      base: "oo",
      letters: /[\uA74F]/g
    }, {
      base: "p",
      letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
    }, {
      base: "q",
      letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
    }, {
      base: "r",
      letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
    }, {
      base: "s",
      letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
    }, {
      base: "t",
      letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
    }, {
      base: "tz",
      letters: /[\uA729]/g
    }, {
      base: "u",
      letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
    }, {
      base: "v",
      letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
    }, {
      base: "vy",
      letters: /[\uA761]/g
    }, {
      base: "w",
      letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
    }, {
      base: "x",
      letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
    }, {
      base: "y",
      letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
    }, {
      base: "z",
      letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
    }],
        Sn = function stripDiacritics(e) {
      for (var t = 0; t < kn.length; t++) {
        e = e.replace(kn[t].letters, kn[t].base);
      }

      return e;
    },
        _n = function isValid(e) {
      return "undefined" !== typeof e && null !== e && "" !== e;
    },
        Mn = function filterOptions(e, t, n, r) {
      return r.ignoreAccents && (t = Sn(t)), r.ignoreCase && (t = t.toLowerCase()), r.trimFilter && (t = function trim(e) {
        return e.replace(/^\s+|\s+$/g, "");
      }(t)), n && (n = n.map(function (e) {
        return e[r.valueKey];
      })), e.filter(function (e) {
        if (n && n.indexOf(e[r.valueKey]) > -1) return !1;
        if (r.filterOption) return r.filterOption.call(void 0, e, t);
        if (!t) return !0;

        var i = e[r.valueKey],
            a = e[r.labelKey],
            o = _n(i),
            s = _n(a);

        if (!o && !s) return !1;
        var l = o ? String(i) : null,
            c = s ? String(a) : null;
        return r.ignoreAccents && (l && "label" !== r.matchProp && (l = Sn(l)), c && "value" !== r.matchProp && (c = Sn(c))), r.ignoreCase && (l && "label" !== r.matchProp && (l = l.toLowerCase()), c && "value" !== r.matchProp && (c = c.toLowerCase())), "start" === r.matchPos ? l && "label" !== r.matchProp && l.substr(0, t.length) === t || c && "value" !== r.matchProp && c.substr(0, t.length) === t : l && "label" !== r.matchProp && l.indexOf(t) >= 0 || c && "value" !== r.matchProp && c.indexOf(t) >= 0;
      });
    },
        Ln = function menuRenderer(e) {
      var t = e.focusedOption,
          n = e.focusOption,
          r = e.inputValue,
          a = e.instancePrefix,
          s = e.onFocus,
          l = e.onOptionRef,
          c = e.onSelect,
          p = e.optionClassName,
          d = e.optionComponent,
          h = e.optionRenderer,
          u = e.options,
          f = e.removeValue,
          m = e.selectValue,
          g = e.valueArray,
          v = e.valueKey,
          b = d;
      return u.map(function (e, d) {
        var u = g && g.some(function (t) {
          return t[v] === e[v];
        }),
            y = e === t,
            x = o()(p, {
          "Select-option": !0,
          "is-selected": u,
          "is-focused": y,
          "is-disabled": e.disabled
        });
        return i.a.createElement(b, {
          className: x,
          focusOption: n,
          inputValue: r,
          instancePrefix: a,
          isDisabled: e.disabled,
          isFocused: y,
          isSelected: u,
          key: "option-" + d + "-" + e[v],
          onFocus: s,
          onSelect: c,
          option: e,
          optionIndex: d,
          ref: function ref(e) {
            l(e, y);
          },
          removeValue: f,
          selectValue: m
        }, h(e, d, r));
      });
    };

    Ln.propTypes = {
      focusOption: En.a.func,
      focusedOption: En.a.object,
      inputValue: En.a.string,
      instancePrefix: En.a.string,
      onFocus: En.a.func,
      onOptionRef: En.a.func,
      onSelect: En.a.func,
      optionClassName: En.a.string,
      optionComponent: En.a.func,
      optionRenderer: En.a.func,
      options: En.a.array,
      removeValue: En.a.func,
      selectValue: En.a.func,
      valueArray: En.a.array,
      valueKey: En.a.string
    };

    var Pn = function blockEvent(e) {
      e.preventDefault(), e.stopPropagation(), "A" === e.target.tagName && "href" in e.target && (e.target.target ? window.open(e.target.href, e.target.target) : window.location.href = e.target.href);
    },
        Fn = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
        An = (function () {
      function AwaitValue(e) {
        this.value = e;
      }

      function AsyncGenerator(e) {
        var t, n;

        function resume(t, n) {
          try {
            var r = e[t](n),
                i = r.value;
            i instanceof AwaitValue ? Promise.resolve(i.value).then(function (e) {
              resume("next", e);
            }, function (e) {
              resume("throw", e);
            }) : settle(r.done ? "return" : "normal", r.value);
          } catch (a) {
            settle("throw", a);
          }
        }

        function settle(e, r) {
          switch (e) {
            case "return":
              t.resolve({
                value: r,
                done: !0
              });
              break;

            case "throw":
              t.reject(r);
              break;

            default:
              t.resolve({
                value: r,
                done: !1
              });
          }

          (t = t.next) ? resume(t.key, t.arg) : n = null;
        }

        this._invoke = function send(e, r) {
          return new Promise(function (i, a) {
            var o = {
              key: e,
              arg: r,
              resolve: i,
              reject: a,
              next: null
            };
            n ? n = n.next = o : (t = n = o, resume(e, r));
          });
        }, "function" !== typeof e.return && (this.return = void 0);
      }

      "function" === typeof Symbol && Symbol.asyncIterator && (AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
        return this;
      }), AsyncGenerator.prototype.next = function (e) {
        return this._invoke("next", e);
      }, AsyncGenerator.prototype.throw = function (e) {
        return this._invoke("throw", e);
      }, AsyncGenerator.prototype.return = function (e) {
        return this._invoke("return", e);
      };
    }(), function classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }),
        Dn = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        Nn = function defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    },
        On = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        zn = function inherits(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    },
        Tn = function objectWithoutProperties(e, t) {
      var n = {};

      for (var r in e) {
        t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      }

      return n;
    },
        In = function possibleConstructorReturn(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    },
        Rn = function (e) {
      function Option(e) {
        An(this, Option);
        var t = In(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, e));
        return t.handleMouseDown = t.handleMouseDown.bind(t), t.handleMouseEnter = t.handleMouseEnter.bind(t), t.handleMouseMove = t.handleMouseMove.bind(t), t.handleTouchStart = t.handleTouchStart.bind(t), t.handleTouchEnd = t.handleTouchEnd.bind(t), t.handleTouchMove = t.handleTouchMove.bind(t), t.onFocus = t.onFocus.bind(t), t;
      }

      return zn(Option, e), Dn(Option, [{
        key: "handleMouseDown",
        value: function handleMouseDown(e) {
          e.preventDefault(), e.stopPropagation(), this.props.onSelect(this.props.option, e);
        }
      }, {
        key: "handleMouseEnter",
        value: function handleMouseEnter(e) {
          this.onFocus(e);
        }
      }, {
        key: "handleMouseMove",
        value: function handleMouseMove(e) {
          this.onFocus(e);
        }
      }, {
        key: "handleTouchEnd",
        value: function handleTouchEnd(e) {
          this.dragging || this.handleMouseDown(e);
        }
      }, {
        key: "handleTouchMove",
        value: function handleTouchMove() {
          this.dragging = !0;
        }
      }, {
        key: "handleTouchStart",
        value: function handleTouchStart() {
          this.dragging = !1;
        }
      }, {
        key: "onFocus",
        value: function onFocus(e) {
          this.props.isFocused || this.props.onFocus(this.props.option, e);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.option,
              n = e.instancePrefix,
              r = e.optionIndex,
              a = o()(this.props.className, t.className);
          return t.disabled ? i.a.createElement("div", {
            className: a,
            onMouseDown: Pn,
            onClick: Pn
          }, this.props.children) : i.a.createElement("div", {
            className: a,
            style: t.style,
            role: "option",
            "aria-label": t.label,
            onMouseDown: this.handleMouseDown,
            onMouseEnter: this.handleMouseEnter,
            onMouseMove: this.handleMouseMove,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            id: n + "-option-" + r,
            title: t.title
          }, this.props.children);
        }
      }]), Option;
    }(i.a.Component);

    Rn.propTypes = {
      children: En.a.node,
      className: En.a.string,
      instancePrefix: En.a.string.isRequired,
      isDisabled: En.a.bool,
      isFocused: En.a.bool,
      isSelected: En.a.bool,
      onFocus: En.a.func,
      onSelect: En.a.func,
      onUnfocus: En.a.func,
      option: En.a.object.isRequired,
      optionIndex: En.a.number
    };

    var jn = function (e) {
      function Value(e) {
        An(this, Value);
        var t = In(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, e));
        return t.handleMouseDown = t.handleMouseDown.bind(t), t.onRemove = t.onRemove.bind(t), t.handleTouchEndRemove = t.handleTouchEndRemove.bind(t), t.handleTouchMove = t.handleTouchMove.bind(t), t.handleTouchStart = t.handleTouchStart.bind(t), t;
      }

      return zn(Value, e), Dn(Value, [{
        key: "handleMouseDown",
        value: function handleMouseDown(e) {
          if ("mousedown" !== e.type || 0 === e.button) return this.props.onClick ? (e.stopPropagation(), void this.props.onClick(this.props.value, e)) : void (this.props.value.href && e.stopPropagation());
        }
      }, {
        key: "onRemove",
        value: function onRemove(e) {
          e.preventDefault(), e.stopPropagation(), this.props.onRemove(this.props.value);
        }
      }, {
        key: "handleTouchEndRemove",
        value: function handleTouchEndRemove(e) {
          this.dragging || this.onRemove(e);
        }
      }, {
        key: "handleTouchMove",
        value: function handleTouchMove() {
          this.dragging = !0;
        }
      }, {
        key: "handleTouchStart",
        value: function handleTouchStart() {
          this.dragging = !1;
        }
      }, {
        key: "renderRemoveIcon",
        value: function renderRemoveIcon() {
          if (!this.props.disabled && this.props.onRemove) return i.a.createElement("span", {
            className: "Select-value-icon",
            "aria-hidden": "true",
            onMouseDown: this.onRemove,
            onTouchEnd: this.handleTouchEndRemove,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove
          }, "\xd7");
        }
      }, {
        key: "renderLabel",
        value: function renderLabel() {
          return this.props.onClick || this.props.value.href ? i.a.createElement("a", {
            className: "Select-value-label",
            href: this.props.value.href,
            target: this.props.value.target,
            onMouseDown: this.handleMouseDown,
            onTouchEnd: this.handleMouseDown
          }, this.props.children) : i.a.createElement("span", {
            className: "Select-value-label",
            role: "option",
            "aria-selected": "true",
            id: this.props.id
          }, this.props.children);
        }
      }, {
        key: "render",
        value: function render() {
          return i.a.createElement("div", {
            className: o()("Select-value", this.props.value.className),
            style: this.props.value.style,
            title: this.props.value.title
          }, this.renderRemoveIcon(), this.renderLabel());
        }
      }]), Value;
    }(i.a.Component);

    jn.propTypes = {
      children: En.a.node,
      disabled: En.a.bool,
      id: En.a.string,
      onClick: En.a.func,
      onRemove: En.a.func,
      value: En.a.object.isRequired
    };

    var Bn = function stringifyValue(e) {
      return "string" === typeof e ? e : null !== e && JSON.stringify(e) || "";
    },
        Vn = En.a.oneOfType([En.a.string, En.a.node]),
        Hn = En.a.oneOfType([En.a.string, En.a.number]),
        Wn = 1,
        Gn = function expandValue(e, t) {
      var n = "undefined" === typeof e ? "undefined" : Fn(e);
      if ("string" !== n && "number" !== n && "boolean" !== n) return e;
      var r = t.options,
          i = t.valueKey;
      if (r) for (var a = 0; a < r.length; a++) {
        if (String(r[a][i]) === String(e)) return r[a];
      }
    },
        Zn = function handleRequired(e, t) {
      return !e || (t ? 0 === e.length : 0 === Object.keys(e).length);
    },
        qn = function (e) {
      function Select(e) {
        An(this, Select);
        var t = In(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, e));
        return ["clearValue", "focusOption", "getOptionLabel", "handleInputBlur", "handleInputChange", "handleInputFocus", "handleInputValueChange", "handleKeyDown", "handleMenuScroll", "handleMouseDown", "handleMouseDownOnArrow", "handleMouseDownOnMenu", "handleTouchEnd", "handleTouchEndClearValue", "handleTouchMove", "handleTouchOutside", "handleTouchStart", "handleValueClick", "onOptionRef", "removeValue", "selectValue"].forEach(function (e) {
          return t[e] = t[e].bind(t);
        }), t.state = {
          inputValue: "",
          isFocused: !1,
          isOpen: !1,
          isPseudoFocused: !1,
          required: !1
        }, t;
      }

      return zn(Select, e), Dn(Select, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          this._instancePrefix = "react-select-" + (this.props.instanceId || ++Wn) + "-";
          var e = this.getValueArray(this.props.value);
          this.props.required && this.setState({
            required: Zn(e[0], this.props.multi)
          });
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          "undefined" !== typeof this.props.autofocus && "undefined" !== typeof console && console.warn("Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0"), (this.props.autoFocus || this.props.autofocus) && this.focus();
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          var t = this.getValueArray(e.value, e);
          e.required ? this.setState({
            required: Zn(t[0], e.multi)
          }) : this.props.required && this.setState({
            required: !1
          }), this.state.inputValue && this.props.value !== e.value && e.onSelectResetsInput && this.setState({
            inputValue: this.handleInputValueChange("")
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e, t) {
          if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
            var n = Object(M.findDOMNode)(this.focused),
                r = Object(M.findDOMNode)(this.menu),
                i = r.scrollTop,
                a = i + r.offsetHeight,
                o = n.offsetTop,
                s = o + n.offsetHeight;
            (i > o || a < s) && (r.scrollTop = n.offsetTop), this.hasScrolledToOption = !0;
          } else this.state.isOpen || (this.hasScrolledToOption = !1);

          if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
            this._scrollToFocusedOptionOnUpdate = !1;
            var l = Object(M.findDOMNode)(this.focused),
                c = Object(M.findDOMNode)(this.menu),
                p = l.getBoundingClientRect(),
                d = c.getBoundingClientRect();
            p.bottom > d.bottom ? c.scrollTop = l.offsetTop + l.clientHeight - c.offsetHeight : p.top < d.top && (c.scrollTop = l.offsetTop);
          }

          if (this.props.scrollMenuIntoView && this.menuContainer) {
            var h = this.menuContainer.getBoundingClientRect();
            window.innerHeight < h.bottom + this.props.menuBuffer && window.scrollBy(0, h.bottom + this.props.menuBuffer - window.innerHeight);
          }

          if (e.disabled !== this.props.disabled && (this.setState({
            isFocused: !1
          }), this.closeMenu()), t.isOpen !== this.state.isOpen) {
            this.toggleTouchOutsideEvent(this.state.isOpen);
            var u = this.state.isOpen ? this.props.onOpen : this.props.onClose;
            u && u();
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.toggleTouchOutsideEvent(!1);
        }
      }, {
        key: "toggleTouchOutsideEvent",
        value: function toggleTouchOutsideEvent(e) {
          e ? !document.addEventListener && document.attachEvent ? document.attachEvent("ontouchstart", this.handleTouchOutside) : document.addEventListener("touchstart", this.handleTouchOutside) : !document.removeEventListener && document.detachEvent ? document.detachEvent("ontouchstart", this.handleTouchOutside) : document.removeEventListener("touchstart", this.handleTouchOutside);
        }
      }, {
        key: "handleTouchOutside",
        value: function handleTouchOutside(e) {
          this.wrapper && !this.wrapper.contains(e.target) && this.closeMenu();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.input && this.input.focus();
        }
      }, {
        key: "blurInput",
        value: function blurInput() {
          this.input && this.input.blur();
        }
      }, {
        key: "handleTouchMove",
        value: function handleTouchMove() {
          this.dragging = !0;
        }
      }, {
        key: "handleTouchStart",
        value: function handleTouchStart() {
          this.dragging = !1;
        }
      }, {
        key: "handleTouchEnd",
        value: function handleTouchEnd(e) {
          this.dragging || this.handleMouseDown(e);
        }
      }, {
        key: "handleTouchEndClearValue",
        value: function handleTouchEndClearValue(e) {
          this.dragging || this.clearValue(e);
        }
      }, {
        key: "handleMouseDown",
        value: function handleMouseDown(e) {
          if (!(this.props.disabled || "mousedown" === e.type && 0 !== e.button)) if ("INPUT" !== e.target.tagName) {
            if (e.preventDefault(), !this.props.searchable) return this.focus(), this.setState({
              isOpen: !this.state.isOpen
            });

            if (this.state.isFocused) {
              this.focus();
              var t = this.input,
                  n = !0;
              "function" === typeof t.getInput && (t = t.getInput()), t.value = "", this._focusAfterClear && (n = !1, this._focusAfterClear = !1), this.setState({
                isOpen: n,
                isPseudoFocused: !1,
                focusedOption: null
              });
            } else this._openAfterFocus = this.props.openOnClick, this.focus(), this.setState({
              focusedOption: null
            });
          } else this.state.isFocused ? this.state.isOpen || this.setState({
            isOpen: !0,
            isPseudoFocused: !1
          }) : (this._openAfterFocus = this.props.openOnClick, this.focus());
        }
      }, {
        key: "handleMouseDownOnArrow",
        value: function handleMouseDownOnArrow(e) {
          this.props.disabled || "mousedown" === e.type && 0 !== e.button || (this.state.isOpen ? (e.stopPropagation(), e.preventDefault(), this.closeMenu()) : this.setState({
            isOpen: !0
          }));
        }
      }, {
        key: "handleMouseDownOnMenu",
        value: function handleMouseDownOnMenu(e) {
          this.props.disabled || "mousedown" === e.type && 0 !== e.button || (e.stopPropagation(), e.preventDefault(), this._openAfterFocus = !0, this.focus());
        }
      }, {
        key: "closeMenu",
        value: function closeMenu() {
          this.props.onCloseResetsInput ? this.setState({
            inputValue: this.handleInputValueChange(""),
            isOpen: !1,
            isPseudoFocused: this.state.isFocused && !this.props.multi
          }) : this.setState({
            isOpen: !1,
            isPseudoFocused: this.state.isFocused && !this.props.multi
          }), this.hasScrolledToOption = !1;
        }
      }, {
        key: "handleInputFocus",
        value: function handleInputFocus(e) {
          if (!this.props.disabled) {
            var t = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
            t = !this._focusAfterClear && t, this.props.onFocus && this.props.onFocus(e), this.setState({
              isFocused: !0,
              isOpen: !!t
            }), this._focusAfterClear = !1, this._openAfterFocus = !1;
          }
        }
      }, {
        key: "handleInputBlur",
        value: function handleInputBlur(e) {
          if (!this.menu || this.menu !== document.activeElement && !this.menu.contains(document.activeElement)) {
            this.props.onBlur && this.props.onBlur(e);
            var t = {
              isFocused: !1,
              isOpen: !1,
              isPseudoFocused: !1
            };
            this.props.onBlurResetsInput && (t.inputValue = this.handleInputValueChange("")), this.setState(t);
          } else this.focus();
        }
      }, {
        key: "handleInputChange",
        value: function handleInputChange(e) {
          var t = e.target.value;
          this.state.inputValue !== e.target.value && (t = this.handleInputValueChange(t)), this.setState({
            inputValue: t,
            isOpen: !0,
            isPseudoFocused: !1
          });
        }
      }, {
        key: "setInputValue",
        value: function setInputValue(e) {
          if (this.props.onInputChange) {
            var t = this.props.onInputChange(e);
            null != t && "object" !== ("undefined" === typeof t ? "undefined" : Fn(t)) && (e = "" + t);
          }

          this.setState({
            inputValue: e
          });
        }
      }, {
        key: "handleInputValueChange",
        value: function handleInputValueChange(e) {
          if (this.props.onInputChange) {
            var t = this.props.onInputChange(e);
            null != t && "object" !== ("undefined" === typeof t ? "undefined" : Fn(t)) && (e = "" + t);
          }

          return e;
        }
      }, {
        key: "handleKeyDown",
        value: function handleKeyDown(e) {
          if (!this.props.disabled && ("function" !== typeof this.props.onInputKeyDown || (this.props.onInputKeyDown(e), !e.defaultPrevented))) switch (e.keyCode) {
            case 8:
              !this.state.inputValue && this.props.backspaceRemoves && (e.preventDefault(), this.popValue());
              break;

            case 9:
              if (e.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) break;
              e.preventDefault(), this.selectFocusedOption();
              break;

            case 13:
              e.preventDefault(), e.stopPropagation(), this.state.isOpen ? this.selectFocusedOption() : this.focusNextOption();
              break;

            case 27:
              e.preventDefault(), this.state.isOpen ? (this.closeMenu(), e.stopPropagation()) : this.props.clearable && this.props.escapeClearsValue && (this.clearValue(e), e.stopPropagation());
              break;

            case 32:
              if (this.props.searchable) break;

              if (e.preventDefault(), !this.state.isOpen) {
                this.focusNextOption();
                break;
              }

              e.stopPropagation(), this.selectFocusedOption();
              break;

            case 38:
              e.preventDefault(), this.focusPreviousOption();
              break;

            case 40:
              e.preventDefault(), this.focusNextOption();
              break;

            case 33:
              e.preventDefault(), this.focusPageUpOption();
              break;

            case 34:
              e.preventDefault(), this.focusPageDownOption();
              break;

            case 35:
              if (e.shiftKey) break;
              e.preventDefault(), this.focusEndOption();
              break;

            case 36:
              if (e.shiftKey) break;
              e.preventDefault(), this.focusStartOption();
              break;

            case 46:
              !this.state.inputValue && this.props.deleteRemoves && (e.preventDefault(), this.popValue());
          }
        }
      }, {
        key: "handleValueClick",
        value: function handleValueClick(e, t) {
          this.props.onValueClick && this.props.onValueClick(e, t);
        }
      }, {
        key: "handleMenuScroll",
        value: function handleMenuScroll(e) {
          if (this.props.onMenuScrollToBottom) {
            var t = e.target;
            t.scrollHeight > t.offsetHeight && t.scrollHeight - t.offsetHeight - t.scrollTop <= 0 && this.props.onMenuScrollToBottom();
          }
        }
      }, {
        key: "getOptionLabel",
        value: function getOptionLabel(e) {
          return e[this.props.labelKey];
        }
      }, {
        key: "getValueArray",
        value: function getValueArray(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
              n = "object" === ("undefined" === typeof t ? "undefined" : Fn(t)) ? t : this.props;

          if (n.multi) {
            if ("string" === typeof e && (e = e.split(n.delimiter)), !Array.isArray(e)) {
              if (null === e || void 0 === e) return [];
              e = [e];
            }

            return e.map(function (e) {
              return Gn(e, n);
            }).filter(function (e) {
              return e;
            });
          }

          var r = Gn(e, n);
          return r ? [r] : [];
        }
      }, {
        key: "setValue",
        value: function setValue(e) {
          var t = this;

          if (this.props.autoBlur && this.blurInput(), this.props.required) {
            var n = Zn(e, this.props.multi);
            this.setState({
              required: n
            });
          }

          this.props.simpleValue && e && (e = this.props.multi ? e.map(function (e) {
            return e[t.props.valueKey];
          }).join(this.props.delimiter) : e[this.props.valueKey]), this.props.onChange && this.props.onChange(e);
        }
      }, {
        key: "selectValue",
        value: function selectValue(e) {
          var t = this;
          this.props.closeOnSelect && (this.hasScrolledToOption = !1);
          var n = this.props.onSelectResetsInput ? "" : this.state.inputValue;
          this.props.multi ? this.setState({
            focusedIndex: null,
            inputValue: this.handleInputValueChange(n),
            isOpen: !this.props.closeOnSelect
          }, function () {
            t.getValueArray(t.props.value).some(function (n) {
              return n[t.props.valueKey] === e[t.props.valueKey];
            }) ? t.removeValue(e) : t.addValue(e);
          }) : this.setState({
            inputValue: this.handleInputValueChange(n),
            isOpen: !this.props.closeOnSelect,
            isPseudoFocused: this.state.isFocused
          }, function () {
            t.setValue(e);
          });
        }
      }, {
        key: "addValue",
        value: function addValue(e) {
          var t = this.getValueArray(this.props.value),
              n = this._visibleOptions.filter(function (e) {
            return !e.disabled;
          }),
              r = n.indexOf(e);

          this.setValue(t.concat(e)), n.length - 1 === r ? this.focusOption(n[r - 1]) : n.length > r && this.focusOption(n[r + 1]);
        }
      }, {
        key: "popValue",
        value: function popValue() {
          var e = this.getValueArray(this.props.value);
          e.length && !1 !== e[e.length - 1].clearableValue && this.setValue(this.props.multi ? e.slice(0, e.length - 1) : null);
        }
      }, {
        key: "removeValue",
        value: function removeValue(e) {
          var t = this,
              n = this.getValueArray(this.props.value);
          this.setValue(n.filter(function (n) {
            return n[t.props.valueKey] !== e[t.props.valueKey];
          })), this.focus();
        }
      }, {
        key: "clearValue",
        value: function clearValue(e) {
          e && "mousedown" === e.type && 0 !== e.button || (e.preventDefault(), this.setValue(this.getResetValue()), this.setState({
            inputValue: this.handleInputValueChange(""),
            isOpen: !1
          }, this.focus), this._focusAfterClear = !0);
        }
      }, {
        key: "getResetValue",
        value: function getResetValue() {
          return void 0 !== this.props.resetValue ? this.props.resetValue : this.props.multi ? [] : null;
        }
      }, {
        key: "focusOption",
        value: function focusOption(e) {
          this.setState({
            focusedOption: e
          });
        }
      }, {
        key: "focusNextOption",
        value: function focusNextOption() {
          this.focusAdjacentOption("next");
        }
      }, {
        key: "focusPreviousOption",
        value: function focusPreviousOption() {
          this.focusAdjacentOption("previous");
        }
      }, {
        key: "focusPageUpOption",
        value: function focusPageUpOption() {
          this.focusAdjacentOption("page_up");
        }
      }, {
        key: "focusPageDownOption",
        value: function focusPageDownOption() {
          this.focusAdjacentOption("page_down");
        }
      }, {
        key: "focusStartOption",
        value: function focusStartOption() {
          this.focusAdjacentOption("start");
        }
      }, {
        key: "focusEndOption",
        value: function focusEndOption() {
          this.focusAdjacentOption("end");
        }
      }, {
        key: "focusAdjacentOption",
        value: function focusAdjacentOption(e) {
          var t = this._visibleOptions.map(function (e, t) {
            return {
              option: e,
              index: t
            };
          }).filter(function (e) {
            return !e.option.disabled;
          });

          if (this._scrollToFocusedOptionOnUpdate = !0, !this.state.isOpen) {
            var n = {
              focusedOption: this._focusedOption || (t.length ? t["next" === e ? 0 : t.length - 1].option : null),
              isOpen: !0
            };
            return this.props.onSelectResetsInput && (n.inputValue = ""), void this.setState(n);
          }

          if (t.length) {
            for (var r = -1, i = 0; i < t.length; i++) {
              if (this._focusedOption === t[i].option) {
                r = i;
                break;
              }
            }

            if ("next" === e && -1 !== r) r = (r + 1) % t.length;else if ("previous" === e) r > 0 ? r -= 1 : r = t.length - 1;else if ("start" === e) r = 0;else if ("end" === e) r = t.length - 1;else if ("page_up" === e) {
              var a = r - this.props.pageSize;
              r = a < 0 ? 0 : a;
            } else if ("page_down" === e) {
              var o = r + this.props.pageSize;
              r = o > t.length - 1 ? t.length - 1 : o;
            }
            -1 === r && (r = 0), this.setState({
              focusedIndex: t[r].index,
              focusedOption: t[r].option
            });
          }
        }
      }, {
        key: "getFocusedOption",
        value: function getFocusedOption() {
          return this._focusedOption;
        }
      }, {
        key: "selectFocusedOption",
        value: function selectFocusedOption() {
          if (this._focusedOption) return this.selectValue(this._focusedOption);
        }
      }, {
        key: "renderLoading",
        value: function renderLoading() {
          if (this.props.isLoading) return i.a.createElement("span", {
            className: "Select-loading-zone",
            "aria-hidden": "true"
          }, i.a.createElement("span", {
            className: "Select-loading"
          }));
        }
      }, {
        key: "renderValue",
        value: function renderValue(e, t) {
          var n = this,
              r = this.props.valueRenderer || this.getOptionLabel,
              a = this.props.valueComponent;
          if (!e.length) return function shouldShowPlaceholder(e, t, n) {
            var r = e.inputValue,
                i = e.isPseudoFocused,
                a = e.isFocused,
                o = t.onSelectResetsInput;
            return !r || !o && !n && !i && !a;
          }(this.state, this.props, t) ? i.a.createElement("div", {
            className: "Select-placeholder"
          }, this.props.placeholder) : null;
          var o = this.props.onValueClick ? this.handleValueClick : null;
          return this.props.multi ? e.map(function (e, t) {
            return i.a.createElement(a, {
              disabled: n.props.disabled || !1 === e.clearableValue,
              id: n._instancePrefix + "-value-" + t,
              instancePrefix: n._instancePrefix,
              key: "value-" + t + "-" + e[n.props.valueKey],
              onClick: o,
              onRemove: n.removeValue,
              placeholder: n.props.placeholder,
              value: e
            }, r(e, t), i.a.createElement("span", {
              className: "Select-aria-only"
            }, "\xa0"));
          }) : function shouldShowValue(e, t) {
            var n = e.inputValue,
                r = e.isPseudoFocused,
                i = e.isFocused,
                a = t.onSelectResetsInput;
            return !n || !a && !(!i && r || i && !r);
          }(this.state, this.props) ? (t && (o = null), i.a.createElement(a, {
            disabled: this.props.disabled,
            id: this._instancePrefix + "-value-item",
            instancePrefix: this._instancePrefix,
            onClick: o,
            placeholder: this.props.placeholder,
            value: e[0]
          }, r(e[0]))) : void 0;
        }
      }, {
        key: "renderInput",
        value: function renderInput(e, t) {
          var n,
              r = this,
              a = o()("Select-input", this.props.inputProps.className),
              s = this.state.isOpen,
              l = o()((Nn(n = {}, this._instancePrefix + "-list", s), Nn(n, this._instancePrefix + "-backspace-remove-message", this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), n)),
              c = this.state.inputValue;
          !c || this.props.onSelectResetsInput || this.state.isFocused || (c = "");
          var p = On({}, this.props.inputProps, {
            "aria-activedescendant": s ? this._instancePrefix + "-option-" + t : this._instancePrefix + "-value",
            "aria-describedby": this.props["aria-describedby"],
            "aria-expanded": "" + s,
            "aria-haspopup": "" + s,
            "aria-label": this.props["aria-label"],
            "aria-labelledby": this.props["aria-labelledby"],
            "aria-owns": l,
            className: a,
            onBlur: this.handleInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.handleInputFocus,
            ref: function ref(e) {
              return r.input = e;
            },
            role: "combobox",
            required: this.state.required,
            tabIndex: this.props.tabIndex,
            value: c
          });
          if (this.props.inputRenderer) return this.props.inputRenderer(p);

          if (this.props.disabled || !this.props.searchable) {
            var d = Tn(this.props.inputProps, []),
                h = o()(Nn({}, this._instancePrefix + "-list", s));
            return i.a.createElement("div", On({}, d, {
              "aria-expanded": s,
              "aria-owns": h,
              "aria-activedescendant": s ? this._instancePrefix + "-option-" + t : this._instancePrefix + "-value",
              "aria-disabled": "" + this.props.disabled,
              "aria-label": this.props["aria-label"],
              "aria-labelledby": this.props["aria-labelledby"],
              className: a,
              onBlur: this.handleInputBlur,
              onFocus: this.handleInputFocus,
              ref: function ref(e) {
                return r.input = e;
              },
              role: "combobox",
              style: {
                border: 0,
                width: 1,
                display: "inline-block"
              },
              tabIndex: this.props.tabIndex || 0
            }));
          }

          return this.props.autosize ? i.a.createElement(xn.a, On({
            id: this.props.id
          }, p, {
            minWidth: "5"
          })) : i.a.createElement("div", {
            className: a,
            key: "input-wrap",
            style: {
              display: "inline-block"
            }
          }, i.a.createElement("input", On({
            id: this.props.id
          }, p)));
        }
      }, {
        key: "renderClear",
        value: function renderClear() {
          var e = this.getValueArray(this.props.value);

          if (this.props.clearable && e.length && !this.props.disabled && !this.props.isLoading) {
            var t = this.props.multi ? this.props.clearAllText : this.props.clearValueText,
                n = this.props.clearRenderer();
            return i.a.createElement("span", {
              "aria-label": t,
              className: "Select-clear-zone",
              onMouseDown: this.clearValue,
              onTouchEnd: this.handleTouchEndClearValue,
              onTouchMove: this.handleTouchMove,
              onTouchStart: this.handleTouchStart,
              title: t
            }, n);
          }
        }
      }, {
        key: "renderArrow",
        value: function renderArrow() {
          if (this.props.arrowRenderer) {
            var e = this.handleMouseDownOnArrow,
                t = this.state.isOpen,
                n = this.props.arrowRenderer({
              onMouseDown: e,
              isOpen: t
            });
            return n ? i.a.createElement("span", {
              className: "Select-arrow-zone",
              onMouseDown: e
            }, n) : null;
          }
        }
      }, {
        key: "filterOptions",
        value: function filterOptions$$1(e) {
          var t = this.state.inputValue,
              n = this.props.options || [];

          if (this.props.filterOptions) {
            var filterOptions$$1 = "function" === typeof this.props.filterOptions ? this.props.filterOptions : Mn;
            return filterOptions$$1(n, t, e, {
              filterOption: this.props.filterOption,
              ignoreAccents: this.props.ignoreAccents,
              ignoreCase: this.props.ignoreCase,
              labelKey: this.props.labelKey,
              matchPos: this.props.matchPos,
              matchProp: this.props.matchProp,
              trimFilter: this.props.trimFilter,
              valueKey: this.props.valueKey
            });
          }

          return n;
        }
      }, {
        key: "onOptionRef",
        value: function onOptionRef(e, t) {
          t && (this.focused = e);
        }
      }, {
        key: "renderMenu",
        value: function renderMenu(e, t, n) {
          return e && e.length ? this.props.menuRenderer({
            focusedOption: n,
            focusOption: this.focusOption,
            inputValue: this.state.inputValue,
            instancePrefix: this._instancePrefix,
            labelKey: this.props.labelKey,
            onFocus: this.focusOption,
            onOptionRef: this.onOptionRef,
            onSelect: this.selectValue,
            optionClassName: this.props.optionClassName,
            optionComponent: this.props.optionComponent,
            optionRenderer: this.props.optionRenderer || this.getOptionLabel,
            options: e,
            removeValue: this.removeValue,
            selectValue: this.selectValue,
            valueArray: t,
            valueKey: this.props.valueKey
          }) : this.props.noResultsText ? i.a.createElement("div", {
            className: "Select-noresults"
          }, this.props.noResultsText) : null;
        }
      }, {
        key: "renderHiddenField",
        value: function renderHiddenField(e) {
          var t = this;

          if (this.props.name) {
            if (this.props.joinValues) {
              var n = e.map(function (e) {
                return Bn(e[t.props.valueKey]);
              }).join(this.props.delimiter);
              return i.a.createElement("input", {
                disabled: this.props.disabled,
                name: this.props.name,
                ref: function ref(e) {
                  return t.value = e;
                },
                type: "hidden",
                value: n
              });
            }

            return e.map(function (e, n) {
              return i.a.createElement("input", {
                disabled: t.props.disabled,
                key: "hidden." + n,
                name: t.props.name,
                ref: "value" + n,
                type: "hidden",
                value: Bn(e[t.props.valueKey])
              });
            });
          }
        }
      }, {
        key: "getFocusableOptionIndex",
        value: function getFocusableOptionIndex(e) {
          var t = this._visibleOptions;
          if (!t.length) return null;
          var n = this.props.valueKey,
              r = this.state.focusedOption || e;

          if (r && !r.disabled) {
            var i = -1;
            if (t.some(function (e, t) {
              var a = e[n] === r[n];
              return a && (i = t), a;
            }), -1 !== i) return i;
          }

          for (var a = 0; a < t.length; a++) {
            if (!t[a].disabled) return a;
          }

          return null;
        }
      }, {
        key: "renderOuter",
        value: function renderOuter(e, t, n) {
          var r = this,
              a = this.renderMenu(e, t, n);
          return a ? i.a.createElement("div", {
            ref: function ref(e) {
              return r.menuContainer = e;
            },
            className: "Select-menu-outer",
            style: this.props.menuContainerStyle
          }, i.a.createElement("div", {
            className: "Select-menu",
            id: this._instancePrefix + "-list",
            onMouseDown: this.handleMouseDownOnMenu,
            onScroll: this.handleMenuScroll,
            ref: function ref(e) {
              return r.menu = e;
            },
            role: "listbox",
            style: this.props.menuStyle,
            tabIndex: -1
          }, a)) : null;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.getValueArray(this.props.value),
              n = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? t : null),
              r = this.state.isOpen;
          this.props.multi && !n.length && t.length && !this.state.inputValue && (r = !1);
          var a = this.getFocusableOptionIndex(t[0]),
              s = null;
          s = this._focusedOption = null !== a ? n[a] : null;
          var l = o()("Select", this.props.className, {
            "has-value": t.length,
            "is-clearable": this.props.clearable,
            "is-disabled": this.props.disabled,
            "is-focused": this.state.isFocused,
            "is-loading": this.props.isLoading,
            "is-open": r,
            "is-pseudo-focused": this.state.isPseudoFocused,
            "is-searchable": this.props.searchable,
            "Select--multi": this.props.multi,
            "Select--rtl": this.props.rtl,
            "Select--single": !this.props.multi
          }),
              c = null;
          return this.props.multi && !this.props.disabled && t.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves && (c = i.a.createElement("span", {
            id: this._instancePrefix + "-backspace-remove-message",
            className: "Select-aria-only",
            "aria-live": "assertive"
          }, this.props.backspaceToRemoveMessage.replace("{label}", t[t.length - 1][this.props.labelKey]))), i.a.createElement("div", {
            ref: function ref(t) {
              return e.wrapper = t;
            },
            className: l,
            style: this.props.wrapperStyle
          }, this.renderHiddenField(t), i.a.createElement("div", {
            ref: function ref(t) {
              return e.control = t;
            },
            className: "Select-control",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleMouseDown,
            onTouchEnd: this.handleTouchEnd,
            onTouchMove: this.handleTouchMove,
            onTouchStart: this.handleTouchStart,
            style: this.props.style
          }, i.a.createElement("span", {
            className: "Select-multi-value-wrapper",
            id: this._instancePrefix + "-value"
          }, this.renderValue(t, r), this.renderInput(t, a)), c, this.renderLoading(), this.renderClear(), this.renderArrow()), r ? this.renderOuter(n, t, s) : null);
        }
      }]), Select;
    }(i.a.Component);

    qn.propTypes = {
      "aria-describedby": En.a.string,
      "aria-label": En.a.string,
      "aria-labelledby": En.a.string,
      arrowRenderer: En.a.func,
      autoBlur: En.a.bool,
      autoFocus: En.a.bool,
      autofocus: En.a.bool,
      autosize: En.a.bool,
      backspaceRemoves: En.a.bool,
      backspaceToRemoveMessage: En.a.string,
      className: En.a.string,
      clearAllText: Vn,
      clearRenderer: En.a.func,
      clearValueText: Vn,
      clearable: En.a.bool,
      closeOnSelect: En.a.bool,
      deleteRemoves: En.a.bool,
      delimiter: En.a.string,
      disabled: En.a.bool,
      escapeClearsValue: En.a.bool,
      filterOption: En.a.func,
      filterOptions: En.a.any,
      id: En.a.string,
      ignoreAccents: En.a.bool,
      ignoreCase: En.a.bool,
      inputProps: En.a.object,
      inputRenderer: En.a.func,
      instanceId: En.a.string,
      isLoading: En.a.bool,
      joinValues: En.a.bool,
      labelKey: En.a.string,
      matchPos: En.a.string,
      matchProp: En.a.string,
      menuBuffer: En.a.number,
      menuContainerStyle: En.a.object,
      menuRenderer: En.a.func,
      menuStyle: En.a.object,
      multi: En.a.bool,
      name: En.a.string,
      noResultsText: Vn,
      onBlur: En.a.func,
      onBlurResetsInput: En.a.bool,
      onChange: En.a.func,
      onClose: En.a.func,
      onCloseResetsInput: En.a.bool,
      onFocus: En.a.func,
      onInputChange: En.a.func,
      onInputKeyDown: En.a.func,
      onMenuScrollToBottom: En.a.func,
      onOpen: En.a.func,
      onSelectResetsInput: En.a.bool,
      onValueClick: En.a.func,
      openOnClick: En.a.bool,
      openOnFocus: En.a.bool,
      optionClassName: En.a.string,
      optionComponent: En.a.func,
      optionRenderer: En.a.func,
      options: En.a.array,
      pageSize: En.a.number,
      placeholder: Vn,
      removeSelected: En.a.bool,
      required: En.a.bool,
      resetValue: En.a.any,
      rtl: En.a.bool,
      scrollMenuIntoView: En.a.bool,
      searchable: En.a.bool,
      simpleValue: En.a.bool,
      style: En.a.object,
      tabIndex: Hn,
      tabSelectsValue: En.a.bool,
      trimFilter: En.a.bool,
      value: En.a.any,
      valueComponent: En.a.func,
      valueKey: En.a.string,
      valueRenderer: En.a.func,
      wrapperStyle: En.a.object
    }, qn.defaultProps = {
      arrowRenderer: Cn,
      autosize: !0,
      backspaceRemoves: !0,
      backspaceToRemoveMessage: "Press backspace to remove {label}",
      clearable: !0,
      clearAllText: "Clear all",
      clearRenderer: function clearRenderer() {
        return i.a.createElement("span", {
          className: "Select-clear",
          dangerouslySetInnerHTML: {
            __html: "&times;"
          }
        });
      },
      clearValueText: "Clear value",
      closeOnSelect: !0,
      deleteRemoves: !0,
      delimiter: ",",
      disabled: !1,
      escapeClearsValue: !0,
      filterOptions: Mn,
      ignoreAccents: !0,
      ignoreCase: !0,
      inputProps: {},
      isLoading: !1,
      joinValues: !1,
      labelKey: "label",
      matchPos: "any",
      matchProp: "any",
      menuBuffer: 0,
      menuRenderer: Ln,
      multi: !1,
      noResultsText: "No results found",
      onBlurResetsInput: !0,
      onCloseResetsInput: !0,
      onSelectResetsInput: !0,
      openOnClick: !0,
      optionComponent: Rn,
      pageSize: 5,
      placeholder: "Select...",
      removeSelected: !0,
      required: !1,
      rtl: !1,
      scrollMenuIntoView: !0,
      searchable: !0,
      simpleValue: !1,
      tabSelectsValue: !0,
      trimFilter: !0,
      valueComponent: jn,
      valueKey: "value"
    };

    var Un = {
      autoload: En.a.bool.isRequired,
      cache: En.a.any,
      children: En.a.func.isRequired,
      ignoreAccents: En.a.bool,
      ignoreCase: En.a.bool,
      loadOptions: En.a.func.isRequired,
      loadingPlaceholder: En.a.oneOfType([En.a.string, En.a.node]),
      multi: En.a.bool,
      noResultsText: En.a.oneOfType([En.a.string, En.a.node]),
      onChange: En.a.func,
      onInputChange: En.a.func,
      options: En.a.array.isRequired,
      placeholder: En.a.oneOfType([En.a.string, En.a.node]),
      searchPromptText: En.a.oneOfType([En.a.string, En.a.node]),
      value: En.a.any
    },
        Kn = {},
        Xn = {
      autoload: !0,
      cache: Kn,
      children: function defaultChildren(e) {
        return i.a.createElement(qn, e);
      },
      ignoreAccents: !0,
      ignoreCase: !0,
      loadingPlaceholder: "Loading...",
      options: [],
      searchPromptText: "Type to search"
    },
        Yn = function (e) {
      function Async(e, t) {
        An(this, Async);
        var n = In(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, e, t));
        return n._cache = e.cache === Kn ? {} : e.cache, n.state = {
          inputValue: "",
          isLoading: !1,
          options: e.options
        }, n.onInputChange = n.onInputChange.bind(n), n;
      }

      return zn(Async, e), Dn(Async, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.props.autoload && this.loadOptions("");
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          e.options !== this.props.options && this.setState({
            options: e.options
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this._callback = null;
        }
      }, {
        key: "loadOptions",
        value: function loadOptions(e) {
          var t = this,
              loadOptions = this.props.loadOptions,
              n = this._cache;
          if (n && Object.prototype.hasOwnProperty.call(n, e)) return this._callback = null, void this.setState({
            isLoading: !1,
            options: n[e]
          });

          var r = function callback(r, i) {
            var a = i && i.options || [];
            n && (n[e] = a), callback === t._callback && (t._callback = null, t.setState({
              isLoading: !1,
              options: a
            }));
          };

          this._callback = r;
          var i = loadOptions(e, r);
          i && i.then(function (e) {
            return r(0, e);
          }, function (e) {
            return r();
          }), this._callback && !this.state.isLoading && this.setState({
            isLoading: !0
          });
        }
      }, {
        key: "onInputChange",
        value: function onInputChange(e) {
          var t = this.props,
              n = t.ignoreAccents,
              r = t.ignoreCase,
              onInputChange = t.onInputChange,
              i = e;

          if (onInputChange) {
            var a = onInputChange(i);
            null != a && "object" !== ("undefined" === typeof a ? "undefined" : Fn(a)) && (i = "" + a);
          }

          var o = i;
          return n && (o = Sn(o)), r && (o = o.toLowerCase()), this.setState({
            inputValue: i
          }), this.loadOptions(o), i;
        }
      }, {
        key: "noResultsText",
        value: function noResultsText() {
          var e = this.props,
              t = e.loadingPlaceholder,
              noResultsText = e.noResultsText,
              n = e.searchPromptText,
              r = this.state,
              i = r.inputValue;
          return r.isLoading ? t : i && noResultsText ? noResultsText : n;
        }
      }, {
        key: "focus",
        value: function focus() {
          this.select.focus();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props,
              n = t.children,
              r = t.loadingPlaceholder,
              i = t.placeholder,
              a = this.state,
              o = a.isLoading,
              s = a.options,
              l = {
            noResultsText: this.noResultsText(),
            placeholder: o ? r : i,
            options: o && r ? [] : s,
            ref: function ref(t) {
              return e.select = t;
            }
          };
          return n(On({}, this.props, l, {
            isLoading: o,
            onInputChange: this.onInputChange
          }));
        }
      }]), Async;
    }(r.Component);

    Yn.propTypes = Un, Yn.defaultProps = Xn;

    var $n = function (e) {
      function CreatableSelect(e, t) {
        An(this, CreatableSelect);
        var n = In(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, e, t));
        return n.filterOptions = n.filterOptions.bind(n), n.menuRenderer = n.menuRenderer.bind(n), n.onInputKeyDown = n.onInputKeyDown.bind(n), n.onInputChange = n.onInputChange.bind(n), n.onOptionSelect = n.onOptionSelect.bind(n), n;
      }

      return zn(CreatableSelect, e), Dn(CreatableSelect, [{
        key: "createNewOption",
        value: function createNewOption() {
          var e = this.props,
              t = e.isValidNewOption,
              n = e.newOptionCreator,
              r = e.onNewOptionClick,
              i = e.options,
              a = void 0 === i ? [] : i;

          if (t({
            label: this.inputValue
          })) {
            var o = n({
              label: this.inputValue,
              labelKey: this.labelKey,
              valueKey: this.valueKey
            });
            this.isOptionUnique({
              option: o,
              options: a
            }) && (r ? r(o) : (a.unshift(o), this.select.selectValue(o)));
          }
        }
      }, {
        key: "filterOptions",
        value: function filterOptions$$1() {
          var e = this.props,
              filterOptions$$1 = e.filterOptions,
              t = e.isValidNewOption,
              n = e.promptTextCreator,
              r = (arguments.length <= 2 ? void 0 : arguments[2]) || [],
              i = filterOptions$$1.apply(void 0, arguments) || [];

          if (t({
            label: this.inputValue
          })) {
            var a = this.props.newOptionCreator,
                o = a({
              label: this.inputValue,
              labelKey: this.labelKey,
              valueKey: this.valueKey
            });

            if (this.isOptionUnique({
              option: o,
              options: r.concat(i)
            })) {
              var s = n(this.inputValue);
              this._createPlaceholderOption = a({
                label: s,
                labelKey: this.labelKey,
                valueKey: this.valueKey
              }), i.unshift(this._createPlaceholderOption);
            }
          }

          return i;
        }
      }, {
        key: "isOptionUnique",
        value: function isOptionUnique(e) {
          var t = e.option,
              n = e.options,
              isOptionUnique = this.props.isOptionUnique;
          return n = n || this.props.options, isOptionUnique({
            labelKey: this.labelKey,
            option: t,
            options: n,
            valueKey: this.valueKey
          });
        }
      }, {
        key: "menuRenderer",
        value: function menuRenderer$$1(e) {
          var menuRenderer$$1 = this.props.menuRenderer;
          return menuRenderer$$1(On({}, e, {
            onSelect: this.onOptionSelect,
            selectValue: this.onOptionSelect
          }));
        }
      }, {
        key: "onInputChange",
        value: function onInputChange(e) {
          var onInputChange = this.props.onInputChange;
          return this.inputValue = e, onInputChange && (this.inputValue = onInputChange(e)), this.inputValue;
        }
      }, {
        key: "onInputKeyDown",
        value: function onInputKeyDown(e) {
          var t = this.props,
              n = t.shouldKeyDownEventCreateNewOption,
              onInputKeyDown = t.onInputKeyDown,
              r = this.select.getFocusedOption();
          r && r === this._createPlaceholderOption && n({
            keyCode: e.keyCode
          }) ? (this.createNewOption(), e.preventDefault()) : onInputKeyDown && onInputKeyDown(e);
        }
      }, {
        key: "onOptionSelect",
        value: function onOptionSelect(e) {
          e === this._createPlaceholderOption ? this.createNewOption() : this.select.selectValue(e);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.select.focus();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props,
              n = t.ref,
              r = Tn(t, ["ref"]),
              i = this.props.children;
          return i || (i = Jn), i(On({}, r, {
            allowCreate: !0,
            filterOptions: this.filterOptions,
            menuRenderer: this.menuRenderer,
            onInputChange: this.onInputChange,
            onInputKeyDown: this.onInputKeyDown,
            ref: function ref(t) {
              e.select = t, t && (e.labelKey = t.props.labelKey, e.valueKey = t.props.valueKey), n && n(t);
            }
          }));
        }
      }]), CreatableSelect;
    }(i.a.Component),
        Jn = function defaultChildren(e) {
      return i.a.createElement(qn, e);
    },
        Qn = function isOptionUnique(e) {
      var t = e.option,
          n = e.options,
          r = e.labelKey,
          i = e.valueKey;
      return !n || !n.length || 0 === n.filter(function (e) {
        return e[r] === t[r] || e[i] === t[i];
      }).length;
    },
        er = function isValidNewOption(e) {
      return !!e.label;
    },
        tr = function newOptionCreator(e) {
      var t = e.label,
          n = e.labelKey,
          r = {};
      return r[e.valueKey] = t, r[n] = t, r.className = "Select-create-option-placeholder", r;
    },
        nr = function promptTextCreator(e) {
      return 'Create option "' + e + '"';
    },
        rr = function shouldKeyDownEventCreateNewOption(e) {
      switch (e.keyCode) {
        case 9:
        case 13:
        case 188:
          return !0;

        default:
          return !1;
      }
    };

    $n.isOptionUnique = Qn, $n.isValidNewOption = er, $n.newOptionCreator = tr, $n.promptTextCreator = nr, $n.shouldKeyDownEventCreateNewOption = rr, $n.defaultProps = {
      filterOptions: Mn,
      isOptionUnique: Qn,
      isValidNewOption: er,
      menuRenderer: Ln,
      newOptionCreator: tr,
      promptTextCreator: nr,
      shouldKeyDownEventCreateNewOption: rr
    }, $n.propTypes = {
      children: En.a.func,
      filterOptions: En.a.any,
      isOptionUnique: En.a.func,
      isValidNewOption: En.a.func,
      menuRenderer: En.a.any,
      newOptionCreator: En.a.func,
      onInputChange: En.a.func,
      onInputKeyDown: En.a.func,
      onNewOptionClick: En.a.func,
      options: En.a.array,
      promptTextCreator: En.a.func,
      ref: En.a.func,
      shouldKeyDownEventCreateNewOption: En.a.func
    };

    var ir = function (e) {
      function AsyncCreatableSelect() {
        return An(this, AsyncCreatableSelect), In(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
      }

      return zn(AsyncCreatableSelect, e), Dn(AsyncCreatableSelect, [{
        key: "focus",
        value: function focus() {
          this.select.focus();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this;
          return i.a.createElement(Yn, this.props, function (t) {
            var n = t.ref,
                r = Tn(t, ["ref"]),
                a = n;
            return i.a.createElement($n, r, function (t) {
              var n = t.ref,
                  r = Tn(t, ["ref"]),
                  i = n;
              return e.props.children(On({}, r, {
                ref: function ref(t) {
                  i(t), a(t), e.select = t;
                }
              }));
            });
          });
        }
      }]), AsyncCreatableSelect;
    }(i.a.Component);

    ir.propTypes = {
      children: En.a.func.isRequired
    }, ir.defaultProps = {
      children: function defaultChildren(e) {
        return i.a.createElement(qn, e);
      }
    }, qn.Async = Yn, qn.AsyncCreatable = ir, qn.Creatable = $n, qn.Value = jn, qn.Option = Rn;

    var ar = qn,
        or = (n(84), n(234), {
      small: "small",
      medium: "medium",
      large: "large"
    }),
        sr = function getClassNames(e, t) {
      return "tide-select ".concat(or[t], " ").concat(e);
    },
        lr = function arrowRenderer() {
      return i.a.createElement(p, {
        name: "chevron-down",
        width: 8,
        height: 8
      });
    },
        cr = function Select(e) {
      var t = e.label,
          n = e.className,
          r = e.description,
          a = function PlainSelect(e) {
        var t = e.className,
            n = void 0 === t ? "" : t,
            r = e.size,
            a = void 0 === r ? "medium" : r,
            o = e.creatable,
            s = void 0 !== o && o,
            l = objectWithoutProperties_objectWithoutProperties(e, ["className", "size", "creatable"]);
        return s ? i.a.createElement(ar.Creatable, Object.assign({
          className: sr(n, a),
          arrowRenderer: lr
        }, l)) : i.a.createElement(ar, Object.assign({
          className: sr(n, a),
          arrowRenderer: lr
        }, l));
      }(e);

      return t ? function buildLabel(e, t, n, r) {
        return i.a.createElement("label", {
          className: n
        }, i.a.createElement("span", {
          className: "tide-select--label"
        }, e), t, r && i.a.createElement("p", {
          className: "tide-select--description"
        }, r));
      }(t, a, n, r) : a;
    },
        pr = (n(236), function (e) {
      function Sidebar(e) {
        var t;
        return _classCallCheck(this, Sidebar), (t = _possibleConstructorReturn(this, _getPrototypeOf(Sidebar).call(this, e))).delayRemove = function () {
          setTimeout(function () {
            t.setState({
              shouldHide: !0
            });
          }, 300);
        }, t.delayShow = function () {
          setTimeout(function () {
            t.setState({
              isOpen: !0
            });
          }, 100);
        }, t.state = {
          shouldHide: !e.isOpen,
          isOpen: e.isOpen
        }, t;
      }

      return _inherits(Sidebar, r["Component"]), _createClass(Sidebar, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.toggleWidget(this.props);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          e.isOpen !== this.props.isOpen && (!e.isOpen && this.setState({
            isOpen: !1
          }, this.delayRemove), e.isOpen && this.setState({
            shouldHide: !1
          }, this.delayShow), this.toggleWidget(e));
        }
      }, {
        key: "toggleWidget",
        value: function toggleWidget(e) {
          var t = e.isOpen;
          e.toggleWidget && (t ? (window.drift && window.drift.hide(), window.HelpLauncher && window.HelpLauncher.hide()) : (window.drift && window.drift.show(), window.HelpLauncher && window.HelpLauncher.show()));
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.close,
              n = e.showClose,
              r = e.children,
              a = e.className,
              s = e.hideOverlay,
              l = e.title,
              c = this.state,
              d = c.shouldHide,
              h = c.isOpen;
          return d ? null : i.a.createElement(li, {
            className: o()("tide-sidebar-wrapper", {
              "tide-sidebar-wrapper--open": h,
              "tide-sidebar-wrapper--no-overlay": s
            })
          }, !s && i.a.createElement(li, {
            className: "tide-sidebar-bg",
            onClick: t
          }), i.a.createElement(li, {
            className: o()(a, "tide-sidebar")
          }, !Object(k.isEmpty)(l) && i.a.createElement(pi, {
            className: "tide-sidebar--header"
          }, i.a.createElement(ni, null, l)), n && i.a.createElement(oi, {
            onClick: t
          }, i.a.createElement(p, {
            name: "close",
            width: 16,
            className: "close-button"
          })), r));
        }
      }]), Sidebar;
    }());

    pr.defaultProps = {
      isOpen: !1,
      showClose: !0,
      toggleWidget: !0,
      hideOverlay: !1
    };

    var dr = pr,
        hr = (n(238), Object.freeze({
      subtle: "subtle",
      copy: "copy",
      small: "small",
      medium: "medium",
      large: "large"
    })),
        ur = Object.freeze({
      status: "status",
      default: "default"
    }),
        fr = function (e) {
      function Tag() {
        return _classCallCheck(this, Tag), _possibleConstructorReturn(this, _getPrototypeOf(Tag).apply(this, arguments));
      }

      return _inherits(Tag, r["Component"]), _createClass(Tag, [{
        key: "render",
        value: function render() {
          var e,
              t = this.props,
              n = t.wrapperClass,
              r = t.textClass,
              a = t.text,
              s = t.onClick,
              l = t.icon,
              c = t.backgroundColor,
              d = t.textColor,
              h = t.size,
              u = void 0 === h ? hr.copy : h,
              f = t.type,
              m = t.statusIsOn,
              g = f === ur.status ? m ? "ON" : "OFF" : a;
          return i.a.createElement(li, {
            className: o()("tide-tag", (e = {}, _defineProperty(e, n, !!n), _defineProperty(e, "tide-tag-type-".concat(f), f), _defineProperty(e, "tide-tag-type-status-on", f === ur.status && m), _defineProperty(e, "tide-tag-type-status-off", f === ur.status && !m), _defineProperty(e, "tide-tag-type-status-default", f === ur.default), e)),
            style: {
              background: c && c
            },
            onClick: s
          }, i.a.createElement(li, {
            className: "tide-tag-contents"
          }, l && i.a.createElement(p, {
            name: l
          }), i.a.createElement(oi, {
            className: o()("tide-tag-text", "tide-tag-text-size--".concat(u), _defineProperty({}, r, !!r)),
            style: {
              color: d && d
            }
          }, g)));
        }
      }]), Tag;
    }(),
        mr = (n(240), function (e) {
      function Skill(e) {
        var t;
        return _classCallCheck(this, Skill), (t = _possibleConstructorReturn(this, _getPrototypeOf(Skill).call(this, e))).isUngated = function () {
          var e = t.props,
              n = e.accessGate,
              r = e.canOpen,
              i = e.ACCESS;
          return !n && !!r || !!n && i.hasGates(n);
        }, t.toggleOpen = function () {
          (t.props.canOpen || t.isUngated()) && t.setState(function (e) {
            return {
              isOpen: !e.isOpen
            };
          });
        }, t.state = {
          isOpen: !1
        }, t;
      }

      return _inherits(Skill, r["Component"]), _createClass(Skill, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.skillName,
              n = e.subHead,
              r = e.canOpen,
              a = e.component,
              s = e.hasBanner,
              l = e.headerIcon,
              c = e.editAbandonedSchedulingIsUngated,
              d = e.hasStatusBadge,
              h = e.isOn,
              u = this.state.isOpen,
              f = u ? "chevron-down" : "arrow-1-right",
              m = o()("tide-bot-skills--skills-item-header", {
            ribbon: s,
            "ribbon-coming": s && !r && !this.isUngated()
          }),
              g = o()("tide-bot-skills--skills-item", {
            "selected-row": u,
            interactive: r,
            "tide-bot-skills--skills-item-coming-soon": s && !r && !this.isUngated()
          }),
              v = o()("tide-bot-skills--skills-item-drawer", {
            "routing-drawer-container": "Team Availability" === t,
            "old-routing-drawer-container": "Add Participant (Old Version)" === t,
            "abandoned-drawer-container": "Abandoned Scheduling" === t && c
          }),
              b = l,
              y = a;
          return i.a.createElement(li, {
            className: g
          }, i.a.createElement(li, {
            className: m,
            onClick: this.toggleOpen
          }, i.a.createElement(li, {
            className: "tide-bot-skills--skills-item-icon-container"
          }, i.a.createElement(li, {
            className: "tide-bot-skills--skills-item-icon"
          }, i.a.createElement(b, null))), i.a.createElement(li, {
            className: "tide-bot-skills--skills-item-text"
          }, i.a.createElement(li, {
            className: "tide-bot-skills--skills-item-title-container"
          }, i.a.createElement(ni, null, t), d && i.a.createElement(fr, {
            wrapperClass: "tide-bot-skills--status",
            type: "status",
            statusIsOn: h
          })), i.a.createElement(si, {
            dangerouslySetInnerHTML: {
              __html: n
            }
          })), i.a.createElement(li, {
            className: "tide-bot-skills--skills-item-toggle"
          }, (r || this.isUngated()) && i.a.createElement(p, {
            name: f,
            width: 18,
            height: 18
          }))), u && i.a.createElement(li, {
            className: v
          }, !!a && i.a.createElement(y, this.props)));
        }
      }]), Skill;
    }()),
        gr = n(140),
        vr = n.n(gr),
        br = (n(254), function getSizeStyle(e) {
      return {
        width: e
      };
    }),
        yr = function TableBody(e, t, n) {
      return i.a.createElement("tbody", null, e.map(function (e, r) {
        var a = e.rowClickEventData,
            s = e.data,
            l = e.customKey,
            c = e.className,
            p = e.style,
            d = objectWithoutProperties_objectWithoutProperties(e, ["rowClickEventData", "data", "customKey", "className", "style"]);
        return i.a.createElement("tr", Object.assign({
          key: "row-".concat(l || r),
          className: o()("tide-table-row", {
            "tide-table-row--clickable": !!n
          }, c),
          style: p,
          onClick: n ? function (e) {
            return n(a, e);
          } : null
        }, d), function TableRow(e, t) {
          return e.map(function (e, n) {
            var r = e.content,
                a = e.customKey,
                o = e.className,
                s = e.style;
            return i.a.createElement("td", {
              key: "cell-".concat(a || n),
              className: o,
              style: s
            }, i.a.createElement(li, {
              style: br(t[n])
            }, r));
          });
        }(s, t));
      }));
    },
        xr = function Table(e) {
      var t = e.columns,
          n = e.data,
          r = e.className,
          a = e.width,
          s = void 0 === a ? "100%" : a,
          l = e.scrollX,
          c = void 0 !== l && l,
          p = e.isWorking,
          d = void 0 !== p && p,
          h = e.onRowClick;
      return i.a.createElement(li, {
        className: o()("tide-table-wrapper", _defineProperty({}, r, !!r))
      }, d && i.a.createElement(vr.a, null, function (e) {
        var t = e.width;
        return i.a.createElement(oi, {
          className: "tide-table-fetcher"
        }, i.a.createElement(Qt, {
          type: "table",
          width: t
        }));
      }), i.a.createElement("table", {
        style: br(s),
        className: o()("tide-table", {
          "tide-table-scroll-x": c,
          "tide-table--clickable-rows": !!h
        })
      }, function TableHeader(e) {
        return i.a.createElement("thead", null, i.a.createElement("tr", null, e.map(function (e, t) {
          var n = e.label,
              r = e.value,
              a = void 0 === r ? "" : r,
              s = e.width,
              l = void 0 === s ? "auto" : s,
              c = e.onClick,
              p = e.sortable,
              d = void 0 !== p && p,
              h = e.sorting,
              u = void 0 !== h && h,
              f = e.direction,
              m = void 0 === f ? "desc" : f,
              g = e.className;
          return i.a.createElement("th", {
            className: o()("tide-table-column-header--sorting-".concat(m), {
              "tide-table-column-header--sortable": d,
              "tide-table-column-header--sorting": u,
              className: g
            }),
            key: "header-cell-".concat(t),
            style: br(l),
            onClick: function onClick() {
              return function onUpdateSort(e, t, n) {
                e && e(t, n);
              }(c, a, m);
            }
          }, i.a.createElement(oi, null, n));
        })));
      }(t), yr(n, t, h)));
    },
        wr = (n(256), function (e) {
      function TextArea(e) {
        var t;
        return _classCallCheck(this, TextArea), (t = _possibleConstructorReturn(this, _getPrototypeOf(TextArea).call(this, e))).handleChange = function (e) {
          var n = e.target,
              r = t.props.onChange;
          t.setState({
            text: n.value
          }, function onStateSet() {
            return r && r(n.value);
          });
        }, t.state = {
          text: e.text
        }, t;
      }

      return _inherits(TextArea, r["Component"]), _createClass(TextArea, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          this.setState({
            text: e.text
          });
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.label,
              n = e.placeholder,
              r = e.className,
              a = e.defaultValue,
              s = e.isErrored,
              l = void 0 !== s && s,
              c = e.errorMessage,
              p = objectWithoutProperties_objectWithoutProperties(e, ["label", "placeholder", "className", "defaultValue", "isErrored", "errorMessage"]),
              d = this.state.text;
          return i.a.createElement(li, {
            className: o()("tide-textarea--wrapper", r)
          }, t && i.a.createElement(bi, {
            className: "tide-textarea--label"
          }, t), i.a.createElement("textarea", Object.assign({
            className: o()("tide-textarea", {
              "tide-textarea--error": l
            }),
            placeholder: n,
            value: d,
            onChange: this.handleChange,
            defaultValue: a
          }, p)), !!l && i.a.createElement(oi, {
            type: "error"
          }, c));
        }
      }]), TextArea;
    }()),
        Er = (n(258), function TextLoader(e) {
      var t,
          n = e.className,
          a = e.hasFinished,
          s = e.height,
          l = e.size,
          c = void 0 === l ? 150 : l,
          p = e.text,
          d = e.textPlacement,
          h = void 0 === d ? "above" : d,
          u = e.type,
          f = void 0 === u ? "default" : u,
          m = e.width,
          g = {
        height: p ? function loaderTypesDefaultHeightStyles(e) {
          var t = {
            default: 16
          };
          return t[e] ? t[e] : null;
        }(f) : s,
        type: f,
        width: m || c
      };
      return i.a.createElement(li, {
        className: o()("tide-text-loader", (t = {}, _defineProperty(t, n, !!n), _defineProperty(t, "tide-text-loader--loaded", a), t))
      }, "above" === h ? i.a.createElement(r.Fragment, null, i.a.createElement(si, {
        type: "small"
      }, p), i.a.createElement(Qt, g)) : i.a.createElement(r.Fragment, null, i.a.createElement(Qt, g), i.a.createElement(si, {
        type: "small"
      }, p)));
    }),
        Cr = (n(260), Object.freeze({
      small: "small",
      medium: "medium",
      large: "large"
    })),
        kr = function Toggle(e) {
      var t = e.onChange,
          n = e.checked,
          r = e.defaultChecked,
          a = e.className,
          o = e.size,
          s = void 0 === o ? "medium" : o,
          l = e.disabled,
          c = void 0 !== l && l;
      return i.a.createElement(li, {
        className: "tide-toggle ".concat(a || "", " ").concat(c && "disabled")
      }, i.a.createElement(li, {
        className: "tide-toggle-outer tide-toggle-".concat(Cr[s])
      }, i.a.createElement("input", {
        type: "checkbox",
        defaultChecked: r,
        checked: n,
        onChange: t,
        disabled: c,
        className: "tide-toggle-checkbox"
      }), i.a.createElement("b", {
        className: "tide-toggle--track"
      }), i.a.createElement("b", {
        className: "tide-toggle--switch"
      })));
    },
        Sr = (n(262), n(264), {
      auto: "auto",
      up: "top",
      down: "bottom",
      left: "left",
      right: "right"
    }),
        _r = function (e) {
      function ToolTipTethered(e) {
        var t;
        return _classCallCheck(this, ToolTipTethered), (t = _possibleConstructorReturn(this, _getPrototypeOf(ToolTipTethered).call(this, e))).handleMouseEnter = function () {
          t.setState({
            isHovering: !0
          });
        }, t.handleMouseLeave = function () {
          t.setState({
            isHovering: !1
          });
        }, t.state = {
          isHovering: !1
        }, t;
      }

      return _inherits(ToolTipTethered, i.a.Component), _createClass(ToolTipTethered, [{
        key: "render",
        value: function render() {
          var e = this,
              t = this.state.isHovering,
              n = this.props,
              r = n.children,
              a = n.open,
              s = n.hover,
              l = void 0 === s || s,
              c = n.flow,
              p = void 0 === c ? "auto" : c,
              d = n.component,
              render = n.render,
              h = n.className,
              u = a || l && t;
          return i.a.createElement($, null, i.a.createElement("div", {
            className: o()("tide-tooltip-tethered--wrapper", h)
          }, i.a.createElement(Reference, null, function (t) {
            var n = t.ref;
            return i.a.createElement("div", {
              ref: n,
              className: "tide-tooltip-tethered--target",
              onMouseEnter: e.handleMouseEnter,
              onMouseLeave: e.handleMouseLeave
            }, r);
          }), i.a.createElement(Popper, {
            placement: Sr[p] || "auto",
            modifiers: {
              flip: {
                padding: 20
              },
              offset: {
                offset: "0, 16px"
              },
              preventOverflow: {
                boundariesElement: "viewport"
              }
            },
            key: u
          }, function (e) {
            var t = e.ref,
                n = e.style,
                r = e.placement,
                a = e.outOfBoundaries;
            return i.a.createElement("div", {
              ref: t,
              style: n,
              "data-placement": r,
              "data-out-of-bounds": a,
              className: o()("tide-tooltip-tethered", {
                "tide-tooltip-tethered--open": u
              })
            }, render ? render() : d);
          })));
        }
      }]), ToolTipTethered;
    }(),
        Mr = function ToolTip(e) {
      var t = e.className,
          n = e.children,
          r = e.open,
          a = e.delay,
          s = void 0 === a ? 0 : a,
          l = e.hover,
          c = void 0 === l || l,
          p = e.flow,
          d = void 0 === p ? "right" : p,
          h = e.component,
          u = e.render,
          f = e.tethered;
      return void 0 !== f && f ? i.a.createElement(_r, e) : i.a.createElement(oi, {
        className: o()("tide-tooltip--wrapper", {
          "tide-tooltip--hover": c
        }, t)
      }, n, i.a.createElement(li, {
        className: o()("tide-tooltip", "tide-tooltip--".concat(d), {
          "tide-tooltip--open": r
        }),
        style: {
          animationDelay: "".concat(s, "ms")
        }
      }, u ? u() : h));
    },
        Lr = (n(266), 8),
        Pr = [13, 9, 188],
        Fr = function (e) {
      function MultiStringCompact(e) {
        var t;
        return _classCallCheck(this, MultiStringCompact), (t = _possibleConstructorReturn(this, _getPrototypeOf(MultiStringCompact).call(this, e))).countDisplay = function () {
          var e = t.props,
              n = e.values,
              r = e.valueType,
              i = void 0 === r ? "value" : r,
              a = n.length;
          return 1 === a ? "1 ".concat(i) : "".concat(a, " ").concat(i, "s");
        }, t.removeValue = function (e) {
          t.props.onChange({
            values: Object(k.remove)(e, 1, t.props.values)
          });
        }, t.insertValues = function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              n = e.map(function (e) {
            return e.replace(/^\s*$/g, "");
          }).filter(function (e) {
            return e.length;
          }),
              r = e.length < 2,
              i = t.props.getValidity(t.props.values.concat(n)),
              a = i.errorMsg,
              o = i.validValues;
          n.length && t.setState({
            errorMsg: r && a
          }, function () {
            return t.props.onChange({
              values: o
            });
          });
        }, t.handleOnBlur = function (e) {
          e.persist(), t.insertValues([e.target.value]), e.target.value = "";
        }, t.handleKeyDown = function (e) {
          e.persist(), t.props.keyCodeSplitters.includes(e.keyCode) ? (e.preventDefault(), t.insertValues([e.target.value]), e.target.value = "") : e.keyCode === Lr && "" === e.target.value ? t.removeValue(-1) : t.setState({
            errorMsg: !1
          });
        }, t.handlePaste = function (e) {
          e.persist();
          var n = e.clipboardData.getData("Text").split(t.props.pasteRegexSplitter);
          n.length > 1 && (e.preventDefault(), t.insertValues(n));
        }, t.onChipIconHover = function () {
          t.setState(function (e) {
            return {
              chipIconHover: !e.chipIconHover
            };
          });
        }, t.state = {
          errorMsg: !1,
          chipIconHover: !1
        }, t;
      }

      return _inherits(MultiStringCompact, r["Component"]), _createClass(MultiStringCompact, [{
        key: "render",
        value: function render() {
          var e = this,
              t = this.state,
              n = t.errorMsg,
              r = t.chipIconHover,
              a = this.props,
              s = a.values,
              l = a.disabled,
              c = a.placeholder,
              d = a.className,
              h = a.hideCount;
          return i.a.createElement("div", {
            className: o()("multi-string-compact", d)
          }, i.a.createElement("label", {
            className: o()("multi-string-compact-container", {
              disabled: l
            })
          }, s.map(function (t, n) {
            return i.a.createElement("div", {
              className: o()("multi-string-compact-chip", {
                disabled: l,
                "icon-hover": r
              }),
              key: "".concat(t, "-").concat(n)
            }, i.a.createElement(Ct, {
              type: "small"
            }, t), !l && i.a.createElement("div", {
              className: "multi-string-compact-chip-icon-container",
              onMouseEnter: e.onChipIconHover,
              onMouseLeave: e.onChipIconHover,
              onClick: function onClick() {
                return e.removeValue(n);
              }
            }, i.a.createElement(p, {
              width: 6,
              height: 6,
              className: "multi-string-compact-chip-icon",
              name: "close"
            })));
          }), i.a.createElement("input", {
            disabled: l,
            className: "multi-string-compact-input",
            onBlur: this.handleOnBlur,
            onKeyDown: this.handleKeyDown,
            onPaste: this.handlePaste,
            placeholder: s.length ? "" : c,
            type: "text"
          })), i.a.createElement("div", {
            className: "multi-string-compact-bottom-bar"
          }, i.a.createElement("span", {
            className: "multi-string-compact-error"
          }, n ? i.a.createElement(Et, {
            type: "warning",
            copy: n
          }) : this.props.info && i.a.createElement(Et, {
            type: "info",
            copy: this.props.info
          })), !h && i.a.createElement("span", {
            className: "multi-string-compact-count"
          }, this.countDisplay())));
        }
      }]), MultiStringCompact;
    }();

    Fr.defaultProps = {
      getValidity: function getValidity(e) {
        return {
          errorMsg: null,
          validValues: e
        };
      },
      keyCodeSplitters: Pr,
      pasteRegexSplitter: /\r?\n|\t|,/,
      disabled: !1,
      placeholder: "",
      hideCount: !1
    };

    var Ar = Fr,
        Dr = (n(268), Nt),
        Nr = function DefaultContainer(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement(Dr, Object.assign({
        className: o()("tide-content-container", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Or = function FixedWidthContainer(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement(Nr, Object.assign({
        className: o()("tide-content-container--fixed-width", _defineProperty({}, n, !!n))
      }, r), t);
    },
        zr = function SplitWidthContainer(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement(Nr, Object.assign({
        className: o()("tide-content-container--split-width", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Tr = function LeftAlignedSplitContainer(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement(Nr, Object.assign({
        className: o()("tide-content-container--left-aligned", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Ir = function RightAlignedSplitContainer(e) {
      var t = e.children,
          n = e.className,
          r = objectWithoutProperties_objectWithoutProperties(e, ["children", "className"]);
      return i.a.createElement(Nr, Object.assign({
        className: o()("tide-content-container--right-aligned", _defineProperty({}, n, !!n))
      }, r), t);
    },
        Rr = (n(270), function ToggleBlock(e) {
      var t = e.title,
          n = e.description,
          r = e.isChecked,
          a = e.onToggled,
          o = e.children;
      return i.a.createElement(li, {
        className: "tide-toggle-block"
      }, i.a.createElement(li, {
        className: "tide-toggle-block-content"
      }, t && i.a.createElement(ii, {
        className: "tide-toggle-block-title"
      }, t), n && i.a.createElement("p", {
        className: "tide-toggle-block-description"
      }, n), i.a.createElement(li, {
        className: "tide-toggle-block-content"
      }, o)), i.a.createElement("div", {
        className: "tide-toggle-block-toggle-wrapper"
      }, i.a.createElement(kr, {
        checked: r,
        onChange: a,
        className: "tide-toggle-block-toggle",
        size: "small"
      })));
    }),
        jr = (n(272), Object.freeze({
      h1: function h1(e) {
        var t = e.children;
        return i.a.createElement(ei, null, t);
      },
      h2: function h2(e) {
        var t = e.children;
        return i.a.createElement(ti, null, t);
      },
      h3: function h3(e) {
        var t = e.children;
        return i.a.createElement(ni, null, t);
      },
      h4: function h4(e) {
        var t = e.children;
        return i.a.createElement(ri, null, t);
      },
      h5: function h5(e) {
        var t = e.children;
        return i.a.createElement(ii, null, t);
      },
      h6: function h6(e) {
        var t = e.children;
        return i.a.createElement(ai, null, t);
      }
    })),
        Br = function (e) {
      function HeaderWithRule() {
        return _classCallCheck(this, HeaderWithRule), _possibleConstructorReturn(this, _getPrototypeOf(HeaderWithRule).apply(this, arguments));
      }

      return _inherits(HeaderWithRule, r["Component"]), _createClass(HeaderWithRule, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.title,
              n = e.description,
              r = e.buttonText,
              a = e.buttonType,
              o = e.onClick,
              s = e.linkText,
              l = e.href,
              c = e.headingSize,
              p = e.classname,
              d = jr[c];
          return i.a.createElement(li, {
            className: "tide-header-container ".concat(p)
          }, i.a.createElement(li, {
            className: "tide-header-title"
          }, i.a.createElement(d, null, t)), (n || r) && i.a.createElement(li, {
            className: "tide-header-content-container"
          }, i.a.createElement(li, {
            className: "tide-header-content-container-text"
          }, n && i.a.createElement(si, {
            className: "tide-header-content-description"
          }, n, s && i.a.createElement(Qr, {
            className: "tide-header-content-link",
            href: l
          }, s))), r && i.a.createElement(li, {
            className: "tide-header-content-button-container"
          }, i.a.createElement(C, {
            className: "tide-header-button",
            type: a,
            onClick: o
          }, r))));
        }
      }]), HeaderWithRule;
    }(),
        Vr = (n(274), function Option(e) {
      var t = e.option,
          n = void 0 === t ? {} : t,
          r = e.type,
          a = e.isSelected,
          s = e.onSelect,
          l = n.value,
          c = n.title,
          p = n.description,
          d = n.descriptionElement,
          h = n.expandedContent;
      return i.a.createElement(li, {
        className: o()("tide-selection-blocks-option", {
          "tide-selection-blocks-option--selected": a
        })
      }, i.a.createElement(li, {
        className: "tide-selection-blocks-option-selectable",
        onClick: function onClick() {
          return s(l);
        }
      }, i.a.createElement(it, {
        type: r,
        checked: a,
        onChange: function onChange(e) {
          return e.stopPropagation();
        }
      }), i.a.createElement("label", {
        className: "tide-selection-blocks-option--label"
      }, i.a.createElement(si, {
        className: "tide-selection-blocks-option--title"
      }, c), p && i.a.createElement(si, {
        type: "small"
      }, p), d)), a && h && i.a.createElement(li, {
        className: "tide-selection-blocks-option-content"
      }, h));
    }),
        Hr = function (e) {
      function SelectionBlocks(e) {
        var t;
        return _classCallCheck(this, SelectionBlocks), (t = _possibleConstructorReturn(this, _getPrototypeOf(SelectionBlocks).call(this, e))).onChangeRadio = function (e) {
          var n = t.props.onChange;
          t.setState({
            selected: [e]
          }, function () {
            n && n(t.state.selected);
          });
        }, t.onChangeCheckbox = function (e) {
          var n = t.props.onChange,
              r = t.state.selected,
              i = r.includes(e) ? Object(k.without)([e], r) : [e].concat(_toConsumableArray(r));
          t.setState({
            selected: i
          }, function () {
            n && n(t.state.selected);
          });
        }, t.state = {
          selected: e.selected
        }, t;
      }

      return _inherits(SelectionBlocks, r["Component"]), _createClass(SelectionBlocks, [{
        key: "render",
        value: function render() {
          var e = this,
              t = this.props,
              n = t.header,
              r = t.helpText,
              a = t.helpLink,
              s = t.type,
              l = t.options,
              c = t.classname,
              p = void 0 === c ? "" : c,
              d = this.state.selected,
              h = void 0 === d ? [] : d;
          return i.a.createElement(li, {
            className: o()("tide-selection-blocks", p)
          }, i.a.createElement(pi, {
            className: "tide-selection-blocks--header"
          }, i.a.createElement(ri, null, n), r && i.a.createElement(Qr, {
            href: a,
            target: "__blank"
          }, r)), l.map(function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                n = arguments.length > 1 ? arguments[1] : void 0;
            return i.a.createElement(Vr, {
              key: "tide-selection-blocks-".concat(n),
              option: t,
              type: s,
              isSelected: h.includes(t.value),
              onSelect: "radio" === s ? e.onChangeRadio : e.onChangeCheckbox
            });
          }));
        }
      }]), SelectionBlocks;
    }(),
        Wr = (n(276), function QuickActionButton(e) {
      var t = e.className,
          n = void 0 === t ? "" : t,
          r = e.iconName,
          a = void 0 === r ? "plus" : r,
          s = e.height,
          l = void 0 === s ? 12 : s,
          c = e.iconClassName,
          d = void 0 === c ? "" : c,
          h = e.onClick,
          u = e.text,
          f = void 0 === u ? "" : u,
          m = e.textPosition,
          g = void 0 === m ? "right" : m,
          v = e.width,
          b = void 0 === v ? 12 : v,
          y = e.disabled,
          x = void 0 !== y && y,
          w = e.builderStyle,
          E = void 0 !== w && w;
      return i.a.createElement(li, {
        className: o()("tide-quick-item", n, _defineProperty({}, "position-".concat(g), !!f.length), {
          disabled: x
        }, {
          "builder-style": E
        }),
        "data-content-copy": f,
        onClick: x ? function () {} : h
      }, i.a.createElement(oi, {
        className: "tide-quick-item__icon ".concat(d)
      }, i.a.createElement(p, {
        name: a,
        height: l,
        width: b
      })));
    }),
        Gr = n(141),
        Zr = (n(544), function ColorPreview(e) {
      var t = e.color,
          n = e.onChange,
          r = void 0 === n ? function () {} : n,
          a = e.handleFocus,
          s = void 0 === a ? function () {} : a,
          l = e.onClick,
          c = void 0 === l ? function () {} : l,
          p = e.isOpen,
          d = void 0 !== p && p;
      return i.a.createElement(li, {
        className: o()("color-preview-container", {
          "color-preview-container--active": d
        })
      }, i.a.createElement(li, {
        className: "color-preview-square",
        onClick: c,
        style: {
          background: t
        }
      }), i.a.createElement(it, {
        value: t,
        onChange: function onChange(e) {
          return r(e.target.value);
        },
        onFocus: function onFocus() {
          return s(!0);
        },
        onBlur: function onBlur() {
          return s(!1);
        },
        validate: function validate(e) {
          return e.match(/[^a-fA-F0-9#]/) && "Please use a valid hex color";
        },
        spellCheck: "false",
        className: o()("color-preview-input", {
          "color-preview-input--active": d
        })
      }));
    }),
        qr = I(function (e) {
      function ColorPicker(e) {
        var t;
        return _classCallCheck(this, ColorPicker), (t = _possibleConstructorReturn(this, _getPrototypeOf(ColorPicker).call(this, e))).handleClickOutside = function () {
          t.setState({
            isOpen: !1
          });
        }, t.handleFocus = function (e) {
          return t.setState({
            isFocused: e
          });
        }, t.onChange = function (e) {
          var n = e.hex || e;
          t.setState({
            color: n
          }, function () {
            /^#[a-fA-F0-9]{6}$/.test(n) && t.props.onColorChange({
              hex: n
            });
          });
        }, t.state = {
          color: e.color,
          isFocused: !1,
          isOpen: !1
        }, t;
      }

      return _inherits(ColorPicker, r["Component"]), _createClass(ColorPicker, [{
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          var t = this.props.color;
          e.color !== t && this.setState({
            color: t
          });
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props,
              n = t.label,
              r = t.infoTooltipText,
              a = t.errorMessage,
              o = t.focusTooltipText,
              s = t.focusTooltipFlow,
              l = void 0 === s ? "left" : s,
              c = this.state,
              d = c.color,
              h = c.isOpen,
              u = c.isFocused;
          return i.a.createElement(li, {
            className: "tide-color-picker"
          }, i.a.createElement(li, {
            className: "tide-color-picker-color-option tide-color-picker--solid-option"
          }, i.a.createElement(li, null, i.a.createElement("label", {
            className: "tide-color-picker-label"
          }, n), r && i.a.createElement(Mr, {
            className: "tide-color-picker-tooltip tide-color-picker-tooltip--info",
            flow: "up",
            render: function render() {
              return i.a.createElement(li, null, r);
            }
          }, i.a.createElement(p, {
            name: "info",
            width: 12,
            height: 12
          }))), i.a.createElement(Mr, {
            className: "tide-color-picker-tooltip tide-color-picker-tooltip--focus",
            flow: l,
            open: (h || u) && o,
            hover: !1,
            render: function render() {
              return i.a.createElement(li, null, o);
            }
          }, i.a.createElement(Zr, {
            color: d,
            onClick: function onClick() {
              return e.setState({
                isOpen: !0
              });
            },
            handleFocus: this.handleFocus,
            onChange: this.onChange,
            isOpen: h
          })), h && i.a.createElement(Gr.ChromePicker, {
            color: d,
            onChangeComplete: this.onChange,
            disableAlpha: !0
          })), a && i.a.createElement(si, {
            type: "small",
            className: "tide-color-picker-error"
          }, a));
        }
      }]), ColorPicker;
    }()),
        Ur = (n(546), function Colorway(e) {
      var t,
          n = e.size,
          r = void 0 === n ? "medium" : n,
          a = e.type,
          s = void 0 === a ? 1 : a,
          l = e.className,
          c = void 0 === l ? null : l,
          p = e.children,
          d = e.theme,
          h = void 0 === d ? "AUTO" : d,
          u = objectWithoutProperties_objectWithoutProperties(e, ["size", "type", "className", "children", "theme"]),
          f = o()("tide-colorway", (_defineProperty(t = {}, c, !!c), _defineProperty(t, "tide-colorway-type--".concat(s), !!s), _defineProperty(t, "tide-colorway-size--".concat(r), !0), _defineProperty(t, "tide-colorway-theme--".concat(h), !0), t));
      return i.a.createElement("div", Object.assign({}, u, {
        className: f
      }), i.a.createElement("div", {
        className: "tide-colorway--content"
      }, p));
    }),
        Kr = (n(548), function OptIn(e) {
      var t = e.optInText,
          n = e.onOptIn;
      return i.a.createElement(li, {
        className: "tide-opt-banner--in"
      }, i.a.createElement(bn, {
        text: "New!"
      }), i.a.createElement(C, {
        type: "utility",
        educationHover: !0,
        onClick: n
      }, t));
    }),
        Xr = function OptOut(e) {
      var t = e.firstActionIcon,
          n = void 0 === t ? "undo" : t,
          r = e.firstActionText,
          a = void 0 === r ? "Switch back to the old view" : r,
          o = e.onFirstAction,
          s = e.secondActionText,
          l = void 0 === s ? "Give us feedback" : s,
          c = e.secondActionIcon,
          p = void 0 === c ? "message-1-write" : c,
          d = e.onSecondAction;
      return i.a.createElement(li, {
        className: "tide-opt-banner--actions"
      }, i.a.createElement(C, {
        className: "tide-opt-banner--first-button",
        type: "utility",
        onClick: o,
        icon: n
      }, a), i.a.createElement(oi, {
        className: "tide-opt-banner--divide"
      }), i.a.createElement(C, {
        className: "tide-opt-banner--second-button",
        type: "utility",
        onClick: d,
        icon: p
      }, l));
    },
        Yr = function OptInBanner(e) {
      var t = e.showOptOut,
          n = void 0 !== t && t,
          r = e.optInText,
          a = e.onOptIn;
      return i.a.createElement(li, {
        className: "tide-opt-banner"
      }, n ? i.a.createElement(Xr, e) : i.a.createElement(Kr, {
        optInText: r,
        onOptIn: a
      }));
    },
        $r = (n(550), function InlineSelect(e) {
      var t = e.className,
          n = void 0 === t ? "" : t,
          r = objectWithoutProperties_objectWithoutProperties(e, ["className"]);
      return i.a.createElement(ar, Object.assign({
        className: o()("tide-inline-select", n)
      }, r, {
        searchable: !1,
        clearable: !1
      }));
    });

    n.d(t, "A", function () {
      return Qr;
    }), n.d(t, "Article", function () {
      return ci;
    }), n.d(t, "Div", function () {
      return li;
    }), n.d(t, "Footer", function () {
      return di;
    }), n.d(t, "H1", function () {
      return ei;
    }), n.d(t, "H2", function () {
      return ti;
    }), n.d(t, "H3", function () {
      return ni;
    }), n.d(t, "H4", function () {
      return ri;
    }), n.d(t, "H5", function () {
      return ii;
    }), n.d(t, "H6", function () {
      return ai;
    }), n.d(t, "Header", function () {
      return pi;
    }), n.d(t, "Li", function () {
      return mi;
    }), n.d(t, "Main", function () {
      return gi;
    }), n.d(t, "Nav", function () {
      return hi;
    }), n.d(t, "Ol", function () {
      return ui;
    }), n.d(t, "P", function () {
      return si;
    }), n.d(t, "Section", function () {
      return vi;
    }), n.d(t, "Span", function () {
      return oi;
    }), n.d(t, "Ul", function () {
      return fi;
    }), n.d(t, "Label", function () {
      return bi;
    }), n.d(t, "Small", function () {
      return yi;
    }), n.d(t, "Strong", function () {
      return xi;
    }), n.d(t, "Em", function () {
      return wi;
    }), n.d(t, "ColorWay", function () {
      return Jr;
    }), n.d(t, "ActionDropdown", function () {
      return le;
    }), n.d(t, "AccordionRow", function () {
      return s;
    }), n.d(t, "AgentStatusToggle", function () {
      return he;
    }), n.d(t, "AsyncButton", function () {
      return E;
    }), n.d(t, "Avatar", function () {
      return Se;
    }), n.d(t, "BodyMovin", function () {
      return Pe;
    }), n.d(t, "Breadcrumbs", function () {
      return Fe;
    }), n.d(t, "Button", function () {
      return C;
    }), n.d(t, "Card", function () {
      return Ie;
    }), n.d(t, "CardContainer", function () {
      return je;
    }), n.d(t, "CalloutArrow", function () {
      return We;
    }), n.d(t, "CircleLoader", function () {
      return m;
    }), n.d(t, "CodeBlock", function () {
      return qe;
    }), n.d(t, "DefaultContainer", function () {
      return Nr;
    }), n.d(t, "FingerGunToolTip", function () {
      return Ue;
    }), n.d(t, "FixedWidthContainer", function () {
      return Or;
    }), n.d(t, "Form", function () {
      return at;
    }), n.d(t, "Icon", function () {
      return p;
    }), n.d(t, "IconButton", function () {
      return Oe;
    }), n.d(t, "Input", function () {
      return it;
    }), n.d(t, "InlineSelect", function () {
      return $r;
    }), n.d(t, "InlineWarning", function () {
      return Et;
    }), n.d(t, "Layout", function () {
      return Kt;
    }), n.d(t, "LeftAlignedSplitContainer", function () {
      return Tr;
    }), n.d(t, "LoadStyles", function () {
      return Xt;
    }), n.d(t, "Loader", function () {
      return Qt;
    }), n.d(t, "Modal", function () {
      return en;
    }), n.d(t, "NavigationHeader", function () {
      return sn;
    }), n.d(t, "NoMaxPagesPaginator", function () {
      return cn;
    }), n.d(t, "Paginator", function () {
      return pn;
    }), n.d(t, "ProgressiveLoader", function () {
      return vn;
    }), n.d(t, "Ribbon", function () {
      return bn;
    }), n.d(t, "RightAlignedSplitContainer", function () {
      return Ir;
    }), n.d(t, "Select", function () {
      return cr;
    }), n.d(t, "Sidebar", function () {
      return dr;
    }), n.d(t, "SplitWidthContainer", function () {
      return zr;
    }), n.d(t, "Skill", function () {
      return mr;
    }), n.d(t, "Table", function () {
      return xr;
    }), n.d(t, "Tabs", function () {
      return nn;
    }), n.d(t, "Tag", function () {
      return fr;
    }), n.d(t, "TextArea", function () {
      return wr;
    }), n.d(t, "TextLoader", function () {
      return Er;
    }), n.d(t, "Toggle", function () {
      return kr;
    }), n.d(t, "ToolTip", function () {
      return Mr;
    }), n.d(t, "InlineEditInput", function () {
      return yt;
    }), n.d(t, "MultiStringCompact", function () {
      return Ar;
    }), n.d(t, "ToggleBlock", function () {
      return Rr;
    }), n.d(t, "HeaderWithRule", function () {
      return Br;
    }), n.d(t, "SelectionBlocks", function () {
      return Hr;
    }), n.d(t, "QuickActionButton", function () {
      return Wr;
    }), n.d(t, "ColorPicker", function () {
      return qr;
    }), n.d(t, "Colorway", function () {
      return Ur;
    }), n.d(t, "OptInBanner", function () {
      return Yr;
    });
    var Jr = Ur,
        Qr = kt,
        ei = St,
        ti = _t,
        ni = Mt,
        ri = Lt,
        ii = Pt,
        ai = Ft,
        oi = Dt,
        si = At,
        li = Nt,
        ci = Ot,
        pi = zt,
        di = Tt,
        hi = It,
        ui = Rt,
        fi = jt,
        mi = Bt,
        gi = Vt,
        vi = Ht,
        bi = Wt,
        yi = Gt,
        xi = Zt,
        wi = qt;
  }]);
});